import PropTypes, { shape } from 'prop-types';
import React, { Component } from 'react';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
import { withTheme } from 'emotion-theming';
import moment from 'moment';
import styled$1 from 'react-emotion';
import 'react-modal';
import classnames from 'classnames';
import 'react-datepicker';
import 'react-autocomplete';

var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
	nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
	__proto__: null,
	caches: caches,
	css: css,
	cx: cx,
	flush: flush,
	getRegisteredStyles: getRegisteredStyles,
	hydrate: hydrate,
	injectGlobal: injectGlobal,
	keyframes: keyframes,
	merge: merge,
	sheet: sheet
});

var styled = createEmotionStyled(emotion, React);

var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};

var breakpoint = function breakpoint(_breakpoint) {
  return breakpoints[_breakpoint];
};

var getMediaQuery = function getMediaQuery(css, breakpoint) {
  return '@media (min-width: ' + breakpoint + ') { ' + css + ' }';
};

var breakpointAndUp = {};

var _loop = function _loop(_breakpoint2) {
  if (breakpoints[_breakpoint2] !== '0') {
    breakpointAndUp[_breakpoint2] = function (css) {
      return getMediaQuery(css, breakpoints[_breakpoint2]);
    };
  }
};

for (var _breakpoint2 in breakpoints) {
  _loop(_breakpoint2);
}

var theme = { baseFontSize: 16 }; //DEBTxCYBG pull this from theme component or global?
var baseSpacing = 8;

var spacingHelper = function spacingHelper(value) {
    var fontMultiple = value * baseSpacing;
    var rems = fontMultiple / theme.baseFontSize;
    return rems + 'rem';
};

var spacing = {
    EIGHTH: spacingHelper(0.125),
    QUARTER: spacingHelper(0.25),
    HALF: spacingHelper(0.5),
    THREE_QUARTERS: spacingHelper(0.75),
    SINGLE: spacingHelper(1),
    ONE_AND_QUARTER: spacingHelper(1.25),
    ONE_AND_HALF: spacingHelper(1.5),
    ONE_AND_THREE_QUARTERS: spacingHelper(1.75),
    DOUBLE: spacingHelper(2),
    TWO_AND_HALF: spacingHelper(2.5),
    TRIPLE: spacingHelper(3),
    THREE_AND_HALF: spacingHelper(3.5),
    QUADRUPLE: spacingHelper(4),
    QUINTUPLE: spacingHelper(5),
    SEXTUPLE: spacingHelper(6),
    SEPTUPLE: spacingHelper(7),
    OCTUPLE: spacingHelper(8),
    NONUPLE: spacingHelper(9),
    DECUPLE: spacingHelper(10)
};

var externalMarginRegular = '\n    margin-right: ' + spacing.DOUBLE + ';\n    margin-bottom: ' + spacing.DOUBLE + ';\n';

var internalPaddingShell = '\n    overflow: auto;\n    padding-bottom: ' + spacing.SINGLE + '; \n    padding-left: ' + spacing.DOUBLE + '; \n    padding-right: 0; \n    padding-top: ' + spacing.DOUBLE + ';\n    ' + breakpointAndUp.md1('\n        padding-left: ' + spacing.TRIPLE + ';\n        padding-right: ' + spacing.SINGLE + ';\n    ') + '\n';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var HSL_SLICE_START = 4;
var DEFAULT_AMOUNT = 5;

var hslAdjust = function hslAdjust(hslText) {
	var splitHSL = hslText.slice(HSL_SLICE_START, hslText.length - 1).split(',');

	var _splitHSL = slicedToArray(splitHSL, 3),
	    hueLabel = _splitHSL[0],
	    saturationLabel = _splitHSL[1],
	    lightnessLabel = _splitHSL[2];

	var hue = parseInt(hueLabel, 10);
	var saturation = parseInt(saturationLabel.slice(0, saturationLabel.length - 1), 10);
	var lightness = parseInt(lightnessLabel.slice(0, lightnessLabel.length - 1), 10);

	return {
		darken: function darken() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness - amount) + '%)';
		},
		lighten: function lighten() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness + amount) + '%)';
		},
		saturate: function saturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation + amount) + '%, ' + lightness + '%)';
		},
		desaturate: function desaturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation - amount) + '%, ' + lightness + '%)';
		}
	};
};

var _templateObject = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n']),
    _templateObject2 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n']),
    _templateObject3 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n']),
    _templateObject4 = taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n'], ['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n']),
    _templateObject5 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n'], ['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n']),
    _templateObject6 = taggedTemplateLiteral(['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n'], ['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n']),
    _templateObject7 = taggedTemplateLiteral(['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n'], ['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n']),
    _templateObject8 = taggedTemplateLiteral(['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n']);

var circularPulseB = keyframes(_templateObject, spacing.QUADRUPLE);

var circularPulseCB = keyframes(_templateObject2, spacing.QUADRUPLE);

var circularPulseYB = keyframes(_templateObject3, spacing.QUADRUPLE);

var fadeIn = keyframes(_templateObject4);

var fadeOut = keyframes(_templateObject5);

var iconPulse = function iconPulse(colour) {
  return keyframes(_templateObject6, colour, hslAdjust(colour).lighten(0.2));
};

var rotate = keyframes(_templateObject7);

var scaleFadeIn = keyframes(_templateObject8);

var animations = {
  circularPulseB: circularPulseB,
  circularPulseCB: circularPulseCB,
  circularPulseYB: circularPulseYB,
  fadeIn: fadeIn,
  fadeOut: fadeOut,
  iconPulse: iconPulse,
  rotate: rotate,
  scaleFadeIn: scaleFadeIn
};

var generalPalette = {
  black: 'hsl(0, 0%, 0%)',
  blue: 'hsl(217,33%,38%)',
  blueLighter: 'hsl(210, 97%, 87%)',
  blueLightest: 'hsl(210, 100%, 95%)',
  green: 'hsl(135, 41%, 48%)',
  greenUpdated: 'hsl(67, 100%, 35%)',
  greenLighter: 'hsl(90, 53%, 70%)',
  greenLightest: 'hsl(90, 61%, 88%)',
  greenLightestUpdated: 'hsl(66, 75%, 75%)',
  greenFaint: 'hsl(135, 41%, 70%)',
  greyDarkest: 'hsl(0, 0%, 28%)',
  greyDarker: 'hsl(0, 0%, 45%)',
  grey: 'hsl(0, 0%, 60%)',
  greyUpdated: 'hsl(0, 0%, 55%)',
  greyLighter: 'hsl(0, 0%, 75%)',
  greyLightest: 'hsl(0, 0%, 85%)',
  greyLightestUpdated: 'hsl(0, 0%, 91%)',
  orange: 'hsl(29, 77%, 56%)',
  orangeUpdated: 'hsl(28, 100%, 54%)',
  orangeLighter: 'hsl(30, 45%, 89%)',
  orangeLightestUpdated: 'hsl(31, 100%, 63%)',
  red: 'hsl(360, 93%, 41%)',
  redUpdated: 'hsl(360, 91%, 46%)',
  redLighter: 'hsl(360, 97%, 77%)',
  redLightest: 'hsl(360, 60%, 96%)',
  redLightestUpdated: 'hsl(10, 94%, 80%)',
  yellowLighter: 'hsl(55, 92%, 69%)',
  yellowLightest: 'hsl(55, 100%, 88%)',
  white: 'hsl(0, 0%, 100%)',
  whiteOff: 'hsl(0, 0%, 95%)',
  pebble: 'hsl(210, 46%, 91%)'
};

var black = generalPalette.black,
    blue = generalPalette.blue,
    blueLighter = generalPalette.blueLighter,
    blueLightest = generalPalette.blueLightest,
    green = generalPalette.green,
    greenUpdated = generalPalette.greenUpdated,
    greenLighter = generalPalette.greenLighter,
    greenFaint = generalPalette.greenFaint,
    greenLightest = generalPalette.greenLightest,
    greenLightestUpdated = generalPalette.greenLightestUpdated,
    greyUpdated = generalPalette.greyUpdated,
    greyDarker = generalPalette.greyDarker,
    greyDarkest = generalPalette.greyDarkest,
    greyLightest = generalPalette.greyLightest,
    greyLightestUpdated = generalPalette.greyLightestUpdated,
    orange = generalPalette.orange,
    orangeLighter = generalPalette.orangeLighter,
    red = generalPalette.red,
    redUpdated = generalPalette.redUpdated,
    redLighter = generalPalette.redLighter,
    redLightest = generalPalette.redLightest,
    redLightestUpdated = generalPalette.redLightestUpdated,
    grey = generalPalette.grey,
    greyLighter = generalPalette.greyLighter,
    yellowLighter = generalPalette.yellowLighter,
    yellowLightest = generalPalette.yellowLightest,
    white = generalPalette.white,
    whiteOff = generalPalette.whiteOff,
    pebble = generalPalette.pebble;


var colours = {
  generalPalette: {
    black: black,
    blue: blue,
    blueLighter: blueLighter,
    blueLightest: blueLightest,
    green: green,
    greenUpdated: greenUpdated,
    greenLighter: greenLighter,
    greenLightest: greenLightest,
    greenLightestUpdated: greenLightestUpdated,
    greenFaint: greenFaint,
    greyDarkest: greyDarkest,
    greyDarker: greyDarker,
    grey: grey,
    greyUpdated: greyUpdated,
    greyLighter: greyLighter,
    greyLightest: greyLightest,
    greyLightestUpdated: greyLightestUpdated,
    orange: orange,
    orangeLighter: orangeLighter,
    pebble: pebble,
    red: red,
    redUpdated: redUpdated,
    redLighter: yellowLightest,
    redLightest: redLightest,
    redLightestUpdated: redLightestUpdated,
    yellowLighter: yellowLighter,
    yellowLightest: yellowLightest,
    white: white,
    whiteOff: whiteOff
  },
  component: {
    background: white,
    backgroundDisabled: greyLightest,
    border: greyLightest,
    borderDisabled: greyDarkest,
    focusOutline: 'hsl(208, 59%, 60%)',
    hover: greyLightest,
    locked: greyDarker,
    modalBackdrop: black,
    shell: whiteOff,
    tableCell: 'hsl(0, 0%, 97%)',
    tableHeader: 'hsl(0, 0%, 94%)',
    navigationButtonDisabled: 'hsl(215, 8%, 58%)',
    frame: {
      active: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 0%, 85%),' + 'hsl(45, 0%, 85%) 28px, hsl(46, 0%, 95%) 28px, hsl(46, 0%, 95%) 56px)',
        content: 'hsl(45, 0%, 85%)',
        contentAlternate: 'hsl(46, 0%, 95%)'
      },
      bespoke: {
        background: 'repeating-linear-gradient(45deg, hsl(302, 44%, 70%), ' + 'hsl(302, 44%, 70%) 28px, hsl(302, 44%, 90%) 28px, hsl(302, 44%, 90%) 56px)',
        content: 'hsl(302, 44%, 70%)',
        contentAlternate: 'hsl(302, 44%, 90%)'
      },
      deprecated: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 100%, 46%), ' + 'hsl(45, 100%, 46%) 28px, hsl(46, 100%, 64%) 28px, hsl(46, 100%, 64%) 56px)',
        content: 'hsl(45, 100%, 46%)',
        contentAlternate: 'hsl(46, 100%, 64%)'
      },
      draft: {
        background: 'repeating-linear-gradient(45deg, ' + blue + ', ' + (blue + ' 28px, hsl(205, 52%, 58%) 28px, hsl(205, 52%, 58%) 56px)'),
        content: blue,
        contentAlternate: 'hsl(205, 52%, 58%)'
      },
      outdated: {
        background: 'repeating-linear-gradient(45deg, hsl(269, 69%, 69%), ' + 'hsl(269, 69%, 69%) 28px, hsl(270, 69%, 79%) 28px, hsl(270, 69%, 79%) 56px)',
        content: 'hsl(269, 69%, 69%)',
        contentAlternate: 'hsl(270, 69%, 79%)'
      }
    }
  },
  telephony: {
    answerCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    calledGradient: 'linear-gradient(hsl(159, 52%, 67%), hsl(153, 41%, 49%));',
    conferenceCallGradient: 'linear-gradient(hsl(193, 100%, 91%), hsl(196, 96%, 80%));',
    conferenceMaskGradient: 'linear-gradient(hsl(248, 86%, 83%), hsl(260, 94%, 72%));',
    dialingCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    holdCallGradient: 'linear-gradient(hsl(45, 95%, 75%), hsl(37, 91%, 65%));',
    makeCallGradient: 'linear-gradient(hsl(33, 15%, 86%), hsl(180, 3%, 69%));',
    onCallGradient: 'linear-gradient(hsl(129, 80%, 82%), hsl(127, 67%, 63%));',
    answerCall: 'hsl(89, 91%, 40%)',
    closeCall: 'hsl(353, 98%, 41%)',
    dialCall: 'hsl(89, 91%, 40%)',
    endCall: 'hsl(353, 98%, 41%)',
    holdCall: 'hsl(37, 94%, 49%)',
    resumeCall: 'hsl(89, 91%, 40%)'
  },
  typography: {
    body: greyDarkest,
    secondaryBody: greyDarker,
    supplementaryBody: grey
  },
  utility: {
    error: red,
    errorUpdated: redUpdated,
    errorLighter: redLighter,
    errorLightest: redLightest,
    errorLightestUpdated: redLightestUpdated,
    guidance: blue,
    guidanceLighter: blueLighter,
    guidanceLightest: blueLightest,
    important: red,
    importantLighter: redLighter,
    importantLightest: redLightest,
    indicative: orange,
    information: blue,
    informationUpdated: greyUpdated,
    informationLightest: blueLightest,
    informationLightestUpdated: greyLightestUpdated,
    negative: red,
    positive: green,
    rememberLighter: yellowLighter,
    rememberLightest: yellowLightest,
    success: green,
    successUpdated: greenUpdated,
    successLighter: greenLighter,
    successLightest: greenLightest,
    successLightestUpdated: greenLightestUpdated,
    successDisabled: greenFaint,
    tip: green,
    tipLighter: greenLighter,
    tipLightest: greenLightest,
    warning: orange
  },
  state: {
    active: green,
    archived: greyLightest,
    inactive: red,
    notStarted: greyDarker,
    paused: blue,
    pending: orange
  }
};

/* Font size config: usage example ${fontSize('arran')} */

var fontConfig = {
	lewis: {
		xs1: { fontSize: 37, lineHeight: 1.189 },
		sm1: { fontSize: 37, lineHeight: 1.189 },
		md1: { fontSize: 45, lineHeight: 1.067 },
		lg1: { fontSize: 52, lineHeight: 1.154 },
		xl1: { fontSize: 52, lineHeight: 1.154 }
	},
	skye: {
		xs1: { fontSize: 32, lineHeight: 1.125 },
		sm1: { fontSize: 32, lineHeight: 1.125 },
		md1: { fontSize: 40, lineHeight: 1.1 },
		lg1: { fontSize: 45, lineHeight: 1.156 },
		xl1: { fontSize: 45, lineHeight: 1.156 }
	},
	shetland: {
		xs1: { fontSize: 29, lineHeight: 1.241 },
		sm1: { fontSize: 29, lineHeight: 1.241 },
		md1: { fontSize: 34, lineHeight: 1.176 },
		lg1: { fontSize: 39, lineHeight: 1.128 },
		xl1: { fontSize: 39, lineHeight: 1.128 }
	},
	mull: {
		xs1: { fontSize: 26, lineHeight: 1.231 },
		sm1: { fontSize: 26, lineHeight: 1.231 },
		md1: { fontSize: 29, lineHeight: 1.241 },
		lg1: { fontSize: 33, lineHeight: 1.212 },
		xl1: { fontSize: 33, lineHeight: 1.212 }
	},
	islay: {
		xs1: { fontSize: 23, lineHeight: 1.217 },
		sm1: { fontSize: 23, lineHeight: 1.217 },
		md1: { fontSize: 25, lineHeight: 1.28 },
		lg1: { fontSize: 28, lineHeight: 1.286 },
		xl1: { fontSize: 28, lineHeight: 1.286 }
	},
	orkney: {
		xs1: { fontSize: 20, lineHeight: 1.4 },
		sm1: { fontSize: 20, lineHeight: 1.4 },
		md1: { fontSize: 22, lineHeight: 1.273 },
		lg1: { fontSize: 25, lineHeight: 1.28 },
		xl1: { fontSize: 25, lineHeight: 1.28 }
	},
	arran: {
		xs1: { fontSize: 18, lineHeight: 1.333 },
		sm1: { fontSize: 18, lineHeight: 1.333 },
		md1: { fontSize: 19, lineHeight: 1.474 },
		lg1: { fontSize: 21, lineHeight: 1.333 },
		xl1: { fontSize: 21, lineHeight: 1.333 }
	},
	jura: {
		xs1: { fontSize: 16, lineHeight: 1.5 },
		sm1: { fontSize: 16, lineHeight: 1.5 },
		md1: { fontSize: 16, lineHeight: 1.5 },
		lg1: { fontSize: 18, lineHeight: 1.556 },
		xl1: { fontSize: 18, lineHeight: 1.556 }
	},
	uist: {
		xs1: { fontSize: 14, lineHeight: 1.429 },
		sm1: { fontSize: 14, lineHeight: 1.429 },
		md1: { fontSize: 14, lineHeight: 1.429 },
		lg1: { fontSize: 16, lineHeight: 1.5 },
		xl1: { fontSize: 16, lineHeight: 1.5 }
	},
	bute: {
		xs1: { fontSize: 12, lineHeight: 1.333 },
		sm1: { fontSize: 12, lineHeight: 1.333 },
		md1: { fontSize: 13, lineHeight: 1.538 },
		lg1: { fontSize: 13, lineHeight: 1.538 },
		xl1: { fontSize: 13, lineHeight: 1.538 }
	},
	cumbrae: {
		xs1: { fontSize: 11, lineHeight: 1.455 },
		sm1: { fontSize: 11, lineHeight: 1.455 },
		md1: { fontSize: 12, lineHeight: 1.333 },
		lg1: { fontSize: 12, lineHeight: 1.333 },
		xl1: { fontSize: 12, lineHeight: 1.333 }
	}
};

var generateSASS = function generateSASS(mqBreakpoint, size, lineHeight) {
	var styles = '';
	if (parseInt(mqBreakpoint) === 0) {
		styles = 'font-size: ' + size + 'px; line-height: ' + lineHeight + ';';
	} else {
		styles = '\n      @media (min-width: ' + mqBreakpoint + ') {\n        font-size: ' + size + 'px;\n        line-height: ' + lineHeight + ';\n      }\n    ';
	}
	return styles;
};

var fontSizes = {};

for (var fontSize in fontConfig) {
	if (fontConfig.hasOwnProperty(fontSize)) {
		var style = '';
		for (var breakpoint$1 in fontConfig[fontSize]) {
			if (fontConfig[fontSize].hasOwnProperty(breakpoint$1)) {
				var _fontConfig$fontSize$ = fontConfig[fontSize][breakpoint$1],
				    size = _fontConfig$fontSize$.fontSize,
				    lineHeight = _fontConfig$fontSize$.lineHeight;

				style += generateSASS(breakpoints[breakpoint$1], size, lineHeight);
			}
		}
		fontSizes[fontSize] = style;
	}
}

var useFontSize = {

	of: {
		lewis: function lewis() {
			return fontSizes['lewis'];
		},
		skye: function skye() {
			return fontSizes['skye'];
		},
		shetland: function shetland() {
			return fontSizes['shetland'];
		},
		mull: function mull() {
			return fontSizes['mull'];
		},
		islay: function islay() {
			return fontSizes['islay'];
		},
		orkney: function orkney() {
			return fontSizes['orkney'];
		},
		arran: function arran() {
			return fontSizes['arran'];
		},
		jura: function jura() {
			return fontSizes['jura'];
		},
		uist: function uist() {
			return fontSizes['uist'];
		},
		bute: function bute() {
			return fontSizes['bute'];
		},
		cumbrae: function cumbrae() {
			return fontSizes['cumbrae'];
		}
	},

	biggerThan: {
		lewis: function lewis() {
			throw new Error("lewis is the biggest font");
		},
		skye: function skye() {
			return fontSizes['lewis'];
		},
		shetland: function shetland() {
			return fontSizes['skye'];
		},
		mull: function mull() {
			return fontSizes['shetland'];
		},
		islay: function islay() {
			return fontSizes['mull'];
		},
		orkney: function orkney() {
			return fontSizes['islay'];
		},
		arran: function arran() {
			return fontSizes['orkney'];
		},
		jura: function jura() {
			return fontSizes['arran'];
		},
		uist: function uist() {
			return fontSizes['jura'];
		},
		bute: function bute() {
			return fontSizes['uist'];
		},
		cumbrae: function cumbrae() {
			return fontSizes['bute'];
		}
	},

	smallerThan: {
		lewis: function lewis() {
			return fontSizes['skye'];
		},
		skye: function skye() {
			return fontSizes['shetland'];
		},
		shetland: function shetland() {
			return fontSizes['mull'];
		},
		mull: function mull() {
			return fontSizes['islay'];
		},
		islay: function islay() {
			return fontSizes['orkney'];
		},
		orkney: function orkney() {
			return fontSizes['arran'];
		},
		arran: function arran() {
			return fontSizes['jura'];
		},
		jura: function jura() {
			return fontSizes['uist'];
		},
		uist: function uist() {
			return fontSizes['bute'];
		},
		bute: function bute() {
			return fontSizes['cumbrae'];
		},
		cumbrae: function cumbrae() {
			throw new Error("cumbrae is the smallest font");
		}
	}
};

var layers = {
  datepicker1: 2147483647,
  globalTakeoverContent: 1053,
  globalTakeoverTransparency: 1052,
  globalTakeover: 1051,
  loader: 1051,
  modal1: 1050,
  modal2: 1040,
  localTakeover: 1020,
  popper: 110,
  webchat: 110,
  multiButtonModal: 104,
  wideModal: 104,
  accountLegacyPanelDropdown: 100,
  modal3: 100,
  paymentAccountSelector1: 16,
  paymentAccountSelector2: 15,
  checkboxToggleOffIcon: 10,
  comparisonTable: 10,
  accountSelectDropdown: 10,
  currencySelectDropdown: 10,
  header: 10,
  listPayment: 10,
  payeeFooterBar: 9,
  payeeList: 9,
  datepicker2: 5,
  searchAndSelect2: 5,
  searchAndSelect1: 3,
  datepicker: 2,
  datepicker3: 2,
  fauxBlockLink: 2,
  sortCardGroup: 2,
  submittedTransactionTable: 2,
  tileButtonOverlay: 2,
  root: 1,
  sub: -1
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CheckboxIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends$1({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M36.136 59.588L73.4 21l8.1 7.823-44.935 46.532-.157-.15-.15.155L14.5 54.35l7.823-8.1 13.813 13.338z" }));
});

var LIFE_CYCLE_STATUSES = {
	ACTIVE: 'active',
	BESPOKE: 'bespoke',
	DEPRECATED: 'deprecated',
	DRAFT: 'draft',
	OUTDATED: 'outdated'
};

var checkIsVariantDeprecatedFromPackageJson = function checkIsVariantDeprecatedFromPackageJson(packageJson, variant) {
	var deprecations = packageJson.deprecations;


	if (!deprecations) {
		return false;
	}

	var isDeprecated = false;
	deprecations.forEach(function (deprecationObj) {
		return deprecationObj.variants && deprecationObj.variants.forEach(function (deprecatedVariant) {
			if (deprecatedVariant === variant) {
				isDeprecated = true;
			}
		});
	});
	return isDeprecated;
};

var getComponentProminentStatusFromPackage = function getComponentProminentStatusFromPackage(packageJson, variant) {
	var isComponentDeprecated = packageJson['component-life-cycle'] === LIFE_CYCLE_STATUSES.DEPRECATED;
	var isVariantDeprecated = variant && checkIsVariantDeprecatedFromPackageJson(packageJson, variant);

	if (isComponentDeprecated || isVariantDeprecated) {
		return LIFE_CYCLE_STATUSES.DEPRECATED;
	}

	if (packageJson['is-bespoke']) {
		return LIFE_CYCLE_STATUSES.BESPOKE;
	}

	return packageJson['component-life-cycle'];
};

var addFullStop = function addFullStop(value) {
	return value.charAt(value.length - 1) === '.' ? value : value.replace(/([^.])$/, '$1.');
};

var capitaliseFirstLetter = function capitaliseFirstLetter(value) {
	return value.trim().charAt(0).toUpperCase() + value.trim().slice(1);
};

var WEE_WORDS = ['an', 'is', 'of', 'to'];

var capitaliseFirstLetterExceptWeeOnes = function capitaliseFirstLetterExceptWeeOnes(value) {
	if (WEE_WORDS.includes(value)) {
		return value;
	}

	return capitaliseFirstLetter(value);
};

var lowercaseFirstLetter = function lowercaseFirstLetter(value) {
	return value.charAt(0).toLowerCase() + value.slice(1);
};

var slugifyString = function slugifyString(name) {
	return ('' + name.toLowerCase()).replace(' ', '-');
};

var StringUtils = {
	addFullStop: addFullStop,
	capitaliseFirstLetter: capitaliseFirstLetter,
	capitaliseFirstLetterExceptWeeOnes: capitaliseFirstLetterExceptWeeOnes,
	lowercaseFirstLetter: lowercaseFirstLetter,
	slugifyString: slugifyString
};

var _templateObject$1 = taggedTemplateLiteral(['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n'], ['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n']);

var StyledInternalStandardBody = styled('div')(_templateObject$1, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var InternalStandardBody = function InternalStandardBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		StyledInternalStandardBody,
		{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
		children
	);
};

InternalStandardBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalStandardBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'internal-standardbody'
};

var _templateObject$2 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n'], ['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n'], ['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n']);

var StyledUL = styled('ul')(_templateObject$2, function (props) {
	return props.theme.colours.bodyText;
}, spacing.DOUBLE, spacing.TRIPLE, spacing.DOUBLE);

var BORDER_RADIUS_DIVIDER = 4;
var BORDER_RADIUS_REMAINDER = 3;

var StyledListItem = styled('li')(_templateObject2$1, spacing.SINGLE, colours.generalPalette.black, function (props) {
	return props.level % 2 > 0 ? colours.generalPalette.black : 'transparent';
}, function (props) {
	return props.level % BORDER_RADIUS_DIVIDER === BORDER_RADIUS_REMAINDER || props.level % BORDER_RADIUS_DIVIDER === 0 ? '0' : '100%';
});

var processItems = function processItems(items, level) {
	return items.map(function (item, index) {
		return Array.isArray(item) ? React.createElement(
			StyledUL,
			{ key: level + '.' + [index] },
			processItems(item, level + 1)
		) : React.createElement(
			StyledListItem,
			{ key: level + '.' + [index], level: level },
			React.createElement(
				InternalStandardBody,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					item
				)
			)
		);
	});
};

var InternalBulletList = function InternalBulletList(_ref) {
	var items = _ref.items;
	return items !== ( undefined) && React.createElement(
		StyledUL,
		null,
		processItems(items, 1)
	);
};

InternalBulletList.propTypes = {
	/** An array of strings for each item. Can include other arrays for sub items. */
	items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.string])).isRequired
};

var getThemeIcon = function getThemeIcon(vmIcon, generalIcon) {
  return function (themeName) {
    return themeName === 'vm' ? vmIcon : generalIcon;
  };
};

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1(_ref, ["styles"]);

  return React.createElement("svg", _extends$2({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "icon-triangleright-large"), React.createElement("path", { d: "M16 8L0 16V0" }));
});

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2(_ref, ["styles"]);

  return React.createElement("svg", _extends$3({ height: "16", viewBox: "0 0 96 96", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13.75 1.849l68.847 45.515-67.217 47.89" }));
});

var getTriangleRightLarge = getThemeIcon(VMIcon, GenericIcon);

var _templateObject$3 = taggedTemplateLiteral(['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n'], ['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n']),
    _templateObject2$2 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\tcursor: pointer;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n'], ['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\tcursor: pointer;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']);

var StyledBodyContent = styled('div')(_templateObject$3, spacing.DOUBLE, function (props) {
	return props.isOpen ? '\n\t\t\t\tanimation: ' + animations.fadeIn + ' 0.7s linear;\n\t\t\t  ' : '\n\t\t\t\tanimation: ' + animations.fadeOut + ' 0.5s linear;\n\t\t\t  ';
}, function (props) {
	return props.isOpen && '\n\t\tmax-height: 4000px;\n\t\toverflow: visible;\n\t\tpadding-bottom: ' + spacing.SINGLE + ';\n\t\tpadding-left: ' + spacing.DOUBLE + ';\n\n\t';
}, function (props) {
	return props.panelColour;
});

var StyledButton = styled('button')(_templateObject2$2, function (props) {
	return props.panelColour;
}, useFontSize.of.jura, function (props) {
	return props.panelColour;
}, function (props) {
	return props.isOpen && !props.hasIconOverride && '\n\t\tmargin-bottom: ' + spacing.DOUBLE + ';\n\n\t\t> svg {\n\t\t\ttransform: rotate(90deg) !important;\n\t\t}\n\t';
}, function (props) {
	return props.isHeadingString ? '6' : '8';
}, function (props) {
	return props.isHeadingString && 'padding: 0 2px;';
}, breakpoints.md1, function (props) {
	return props.theme.borderRadius;
}, colours.component.focusOutline);

var StyledWrapper = styled('div')(_templateObject3$1, function (props) {
	return props.hasAdditionalMarginBottom && 'margin-bottom: ' + spacing.TRIPLE;
});

var InternalContentRevealPanel = function InternalContentRevealPanel(_ref) {
	var children = _ref.children,
	    hasAdditionalMarginBottom = _ref.hasAdditionalMarginBottom,
	    titleText = _ref.titleText,
	    icon = _ref.icon,
	    isOpen = _ref.isOpen,
	    onClick = _ref.onClick,
	    panelColour = _ref.panelColour,
	    theme = _ref.theme,
	    dataTestId = _ref['data-test-id'];

	var isHeadingString = typeof titleText === 'string';
	var ariaLabel = isHeadingString ? titleText.toLowerCase().replace(/\s+/g, '-') : 'content-reveal-panel';
	var TriangleRightLargeIcon = getTriangleRightLarge(theme.name);
	var hasIconOverride = icon !== undefined;
	var contentId = isHeadingString ? titleText.toLowerCase().replace(/\s+/g, '-') + '-content-id' : 'content-reveal-panel-id';
	return React.createElement(
		StyledWrapper,
		{ hasAdditionalMarginBottom: hasAdditionalMarginBottom },
		React.createElement(
			StyledButton,
			{
				'aria-labelledby': ariaLabel,
				isOpen: isOpen,
				hasIconOverride: hasIconOverride,
				onClick: onClick,
				panelColour: panelColour,
				type: 'button',
				'data-test-id': dataTestId + '-button',
				'aria-expanded': isOpen,
				'aria-controls': contentId
			},
			icon ? icon : React.createElement(TriangleRightLargeIcon, null),
			React.createElement(
				'div',
				{ className: 'buttonLabel' },
				isHeadingString ? React.createElement(
					InternalStandardBody,
					{ isFlush: true },
					React.createElement(
						'span',
						{ id: ariaLabel },
						titleText
					)
				) : titleText
			)
		),
		React.createElement(
			StyledBodyContent,
			{
				isOpen: isOpen,
				panelColour: panelColour,
				id: contentId,
				'data-test-id': dataTestId + '-content'
			},
			children
		)
	);
};

InternalContentRevealPanel.propTypes = {
	/** Content of the panel. */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	/** Adds additional margin bottom. */
	hasAdditionalMarginBottom: PropTypes.bool,
	/** Set to true to open panel. */
	isOpen: PropTypes.bool,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Sets panel colour. */
	panelColour: PropTypes.string.isRequired,
	/** Title text. */
	titleText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	/** Optional icon  */
	icon: PropTypes.node,
	/** Data attribute targeting inner html button for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalContentRevealPanel.defaultProps = {
	hasAdditionalMarginBottom: false,
	isOpen: false,
	'data-test-id': 'content-reveal-panel'
};

var WrappedInternalContentRevealPanel = withTheme(InternalContentRevealPanel);

var _templateObject$4 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']),
    _templateObject2$3 = taggedTemplateLiteral(['\n\t', ';\n\tdisplay: ', ';\n'], ['\n\t', ';\n\tdisplay: ', ';\n']),
    _templateObject3$2 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n'], ['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n']),
    _templateObject4$1 = taggedTemplateLiteral(['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n'], ['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n']),
    _templateObject5$1 = taggedTemplateLiteral(['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n'], ['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n']),
    _templateObject6$1 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n'], ['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n']);

var BasicBlockWrapper = styled('div')(_templateObject$4, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
});

var BasicInlineWrapper = styled('span')(_templateObject2$3, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
}, function (props) {
	return props.isInlineBlock ? 'inline-block' : 'inline';
});

var BasicDetails = styled('span')(_templateObject3$2, function (props) {
	return props.content;
}, spacing.HALF, colours.generalPalette.black, spacing.QUARTER);

var InfoContainer = styled('div')(_templateObject4$1, function (props) {
	return props.content;
}, spacing.SINGLE, spacing.SINGLE, spacing.DOUBLE, spacing.DOUBLE, spacing.SINGLE, colours.generalPalette.black);

var InfoContentWrapper = styled('div')(_templateObject5$1, spacing.SINGLE, colours.generalPalette.black, spacing.SINGLE);

var InnerComponentWrapper = styled('div')(_templateObject$4, function (props) {
	return props.isContainer && '\n\t\tbackground-color: hsla(0, 100%, 100%, 60%);\n\t\tpadding: ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE + ';\n\t';
});

var XRayComponentWrapper = styled('div')(_templateObject6$1, function (props) {
	return props.background;
}, function (props) {
	return props.isContainer ? '0' : spacing.SINGLE + ' ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE;
});

var revealContent = {
	active: React.createElement(
		'span',
		null,
		'Details on this component can be found in the Web UI Components the style guide.'
	),
	bespoke: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component was built for a certainuse case and should not be used outside of that.'
		),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		)
	),
	deprecated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Deprecated components are no longer tested via:'
		),
		React.createElement(InternalBulletList, {
			items: ['Visual regression & brand testing.', 'Integration testing.', 'Manual input testing.', 'Accessibility testing.']
		}),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		),
		React.createElement(
			'p',
			null,
			React.createElement(
				'b',
				null,
				React.createElement(
					'u',
					null,
					'Upgrade as soon as possible.'
				)
			)
		)
	),
	draft: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Do not log defects for:'
		),
		React.createElement(InternalBulletList, {
			items: ['Appearance or styles.', 'Keyboard or mouse behaviours.', 'Missing input validations.'],
			isFlush: true
		}),
		React.createElement(
			'p',
			null,
			'Upgrade before using in production.'
		)
	),
	outdated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component is outdated. Therefore, should not be used in newer project work.'
		),
		React.createElement(
			'p',
			null,
			'It may have issues with:'
		),
		React.createElement(InternalBulletList, { items: ['Accessibility.', 'Consistency.', 'Optimisation.'], isFlush: true }),
		React.createElement(
			'p',
			null,
			'Before adding to a new codebase, contact the UI team about seeking a replacement.'
		)
	)
};

var getComponentName = function getComponentName(packageJson) {
	return packageJson.main.split('.')[0];
};

var InternalComponentFrame = function (_Component) {
	inherits(InternalComponentFrame, _Component);

	function InternalComponentFrame(props) {
		classCallCheck(this, InternalComponentFrame);

		var _this = possibleConstructorReturn(this, (InternalComponentFrame.__proto__ || Object.getPrototypeOf(InternalComponentFrame)).call(this, props));

		_this.state = {
			isOpen: false
		};
		return _this;
	}

	createClass(InternalComponentFrame, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    children = _props.children,
			    hasCustomMargins = _props.hasCustomMargins,
			    layout = _props.layout,
			    isFlush = _props.isFlush,
			    packageJson = _props.packageJson,
			    variant = _props.variant,
			    xraySuppressed = _props.xraySuppressed;
			var isOpen = this.state.isOpen;
			var _window = window,
			    XrayHelper = _window.XrayHelper;


			var componentName = getComponentName(packageJson);
			var status = getComponentProminentStatusFromPackage(packageJson, variant);
			var formattedStatus = StringUtils.capitaliseFirstLetter(status);
			var variantSuffix = variant ? '.' + variant : '';

			var isContainer = layout === 'container';
			var isInline = layout === 'inline-block' || layout === 'inline';
			var isTypography = layout === 'typography';
			var isCompactLayout = isInline || isTypography;
			var _colours$component$fr = colours.component.frame[status],
			    background = _colours$component$fr.background,
			    content = _colours$component$fr.content;


			if (xraySuppressed || XrayHelper && XrayHelper.checkIsXrayMode() === false) {
				return isInline ? React.createElement(
					BasicInlineWrapper,
					{ isInlineBlock: layout === 'inline-block', removeFrameMargins: hasCustomMargins || isFlush },
					children
				) : React.createElement(
					BasicBlockWrapper,
					{ removeFrameMargins: hasCustomMargins || isFlush },
					children
				);
			}

			return isCompactLayout ? React.createElement(
				'div',
				null,
				children,
				React.createElement(
					BasicDetails,
					{ content: content },
					React.createElement(
						'b',
						null,
						formattedStatus,
						' component:'
					),
					' ',
					componentName,
					variantSuffix
				)
			) : React.createElement(
				'div',
				null,
				React.createElement(
					XRayComponentWrapper,
					{ background: background, isContainer: isContainer },
					React.createElement(
						InnerComponentWrapper,
						{ isContainer: isContainer },
						children
					)
				),
				React.createElement(
					InfoContainer,
					{ content: content },
					React.createElement(
						WrappedInternalContentRevealPanel,
						{
							panelColour: 'black',
							titleText: formattedStatus + ' component: ' + getComponentName(packageJson) + variantSuffix,
							isOpen: isOpen,
							onClick: function onClick() {
								return _this2.setState(function (prevState) {
									return { isOpen: !prevState.isOpen };
								});
							}
						},
						React.createElement(
							InfoContentWrapper,
							null,
							revealContent[status]
						)
					)
				)
			);
		}
	}]);
	return InternalComponentFrame;
}(Component);

InternalComponentFrame.propTypes = {
	children: PropTypes.node.isRequired,
	hasCustomMargins: PropTypes.bool,
	isFlush: PropTypes.bool,
	layout: PropTypes.oneOf(['block', 'container', 'inline', 'inline-block', 'typography']),
	packageJson: PropTypes.object.isRequired,
	variant: PropTypes.string,
	xraySuppressed: PropTypes.bool
};

InternalComponentFrame.defaultProps = {
	hasCustomMargins: false,
	isFlush: false,
	layout: 'block',
	xraySuppressed: false
};

var _templateObject$5 = taggedTemplateLiteral(['\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: center;\n\n\t', ';\n'], ['\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: center;\n\n\t', ';\n']),
    _templateObject2$4 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\talign-self: stretch;\n\talign-items: ', ';\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\talign-self: stretch;\n\talign-items: ', ';\n\n\t', ';\n']),
    _templateObject3$3 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: space-between;\n\twidth: 100%;\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: space-between;\n\twidth: 100%;\n\n\t', ';\n']),
    _templateObject4$2 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\twidth: 100%;\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\twidth: 100%;\n\n\t', ';\n']),
    _templateObject5$2 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: flex-end;\n\twidth: 100%;\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: flex-end;\n\twidth: 100%;\n\n\t', ';\n']),
    _templateObject6$2 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: flex-start;\n\twidth: 100%;\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: flex-start;\n\twidth: 100%;\n\n\t', ';\n']),
    _templateObject7$1 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\twidth: 100%;\n\n\t> div {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t}\n\n\t@media (min-width: ', ') {\n\t\tflex-basis: 33.33%;\n\t}\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\twidth: 100%;\n\n\t> div {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t}\n\n\t@media (min-width: ', ') {\n\t\tflex-basis: 33.33%;\n\t}\n\n\t', ';\n']);

var baseProps = {
	nodes: PropTypes.arrayOf(PropTypes.node).isRequired,
	isNonWrapping: PropTypes.bool,
	verticalAlignment: PropTypes.string,
	isNonFlexForPrint: PropTypes.bool,
	breakpointForNonStacked: PropTypes.oneOf(['480', '540', '640', '960', '1280'])
};

var defaultProps = {
	isNonWrapping: false,
	isNonFlexForPrint: false,
	verticalAlignment: 'stretch'
};

var CenteredWrapper = styled('div')(_templateObject$5, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var verticalAlignmentToAlignItems = function verticalAlignmentToAlignItems(verticalAlignment) {
	switch (verticalAlignment) {
		case 'top':
			return 'flex-start';
		case 'bottom':
			return 'flex-end';
		case 'center':
			return 'center';
		case 'baseline':
			return 'baseline';
		case 'stretch':
		default:
			return 'stretch';
	}
};

var Centered = function Centered(_ref) {
	var nodes = _ref.nodes,
	    isNonWrapping = _ref.isNonWrapping,
	    verticalAlignment = _ref.verticalAlignment,
	    breakpointForNonStacked = _ref.breakpointForNonStacked;
	return React.createElement(
		CenteredWrapper,
		{
			alignItems: verticalAlignmentToAlignItems(verticalAlignment),
			isNonWrapping: isNonWrapping,
			breakpointForNonStacked: breakpointForNonStacked
		},
		nodes.map(function (x, index) {
			return React.createElement(
				'div',
				{ key: index },
				x
			);
		})
	);
};

Centered.propTypes = _extends({}, baseProps);

Centered.defaultProps = _extends({}, defaultProps);

var JustifiedNodeWrapper = styled('div')(_templateObject2$4, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var JustifiedWrapper = styled('div')(_templateObject3$3, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var Justified = function Justified(_ref2) {
	var nodes = _ref2.nodes,
	    isNonWrapping = _ref2.isNonWrapping,
	    verticalAlignment = _ref2.verticalAlignment,
	    breakpointForNonStacked = _ref2.breakpointForNonStacked;
	return React.createElement(
		JustifiedWrapper,
		{ isNonWrapping: isNonWrapping, breakpointForNonStacked: breakpointForNonStacked },
		nodes.map(function (x, index) {
			return React.createElement(
				JustifiedNodeWrapper,
				{
					alignItems: verticalAlignmentToAlignItems(verticalAlignment),
					breakpointForNonStacked: breakpointForNonStacked,
					key: index
				},
				x
			);
		})
	);
};

Justified.propTypes = _extends({}, baseProps);

Justified.defaultProps = _extends({}, defaultProps);

var LeftAlignedWrapper = styled('div')(_templateObject4$2, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var LeftAligned = function LeftAligned(_ref3) {
	var nodes = _ref3.nodes,
	    isNonWrapping = _ref3.isNonWrapping,
	    verticalAlignment = _ref3.verticalAlignment,
	    breakpointForNonStacked = _ref3.breakpointForNonStacked;
	return React.createElement(
		LeftAlignedWrapper,
		{
			alignItems: verticalAlignmentToAlignItems(verticalAlignment),
			isNonWrapping: isNonWrapping,
			breakpointForNonStacked: breakpointForNonStacked
		},
		nodes.map(function (x, index) {
			return React.createElement(
				'div',
				{ key: index },
				x
			);
		})
	);
};

LeftAligned.propTypes = _extends({}, baseProps);

LeftAligned.defaultProps = _extends({}, defaultProps);

var RightAlignedWrapper = styled('div')(_templateObject5$2, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var RightAligned = function RightAligned(_ref4) {
	var nodes = _ref4.nodes,
	    isNonWrapping = _ref4.isNonWrapping,
	    verticalAlignment = _ref4.verticalAlignment,
	    breakpointForNonStacked = _ref4.breakpointForNonStacked;
	return React.createElement(
		RightAlignedWrapper,
		{
			alignItems: verticalAlignmentToAlignItems(verticalAlignment),
			isNonWrapping: isNonWrapping,
			breakpointForNonStacked: breakpointForNonStacked
		},
		nodes.map(function (x, index) {
			return React.createElement(
				'div',
				{ key: index },
				x
			);
		})
	);
};

RightAligned.propTypes = _extends({}, baseProps);

RightAligned.defaultProps = _extends({}, defaultProps);

var ThirdsWrapper = styled('div')(_templateObject6$2, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var NodeWrapper = styled('div')(_templateObject7$1, breakpoints.sm2, function (props) {
	return !props.isNonFlexForPrint && '@media print { flex-basis: 100%; }';
});

var Thirds = function Thirds(_ref5) {
	var nodes = _ref5.nodes,
	    isNonWrapping = _ref5.isNonWrapping,
	    verticalAlignment = _ref5.verticalAlignment,
	    isNonFlexForPrint = _ref5.isNonFlexForPrint,
	    breakpointForNonStacked = _ref5.breakpointForNonStacked;
	return React.createElement(
		ThirdsWrapper,
		{
			alignItems: verticalAlignmentToAlignItems(verticalAlignment),
			isNonWrapping: isNonWrapping,
			isNonFlexForPrint: isNonFlexForPrint,
			breakpointForNonStacked: breakpointForNonStacked
		},
		nodes.map(function (x, index) {
			return React.createElement(
				NodeWrapper,
				{ key: index },
				x
			);
		})
	);
};

Thirds.propTypes = _extends({}, baseProps);

Thirds.defaultProps = _extends({}, defaultProps);

var Inline = {
	Centered: Centered,
	Justified: Justified,
	LeftAligned: LeftAligned,
	RightAligned: RightAligned,
	Thirds: Thirds
};

var _templateObject$6 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\t', ';\n\t', ';\n'], ['\n\tcolor: ', ';\n\t', ';\n\t', ';\n']);

var StyledInternalSecondaryBody = styled('div')(_templateObject$6, colours.typography.secondaryBody, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var InternalSecondaryBody = function InternalSecondaryBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		StyledInternalSecondaryBody,
		{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
		children
	);
};

InternalSecondaryBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalSecondaryBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'internal-secondarybody'
};

var main = "SecondaryBody.js";
var packageJson = {
	main: main,
	"component-id": 1070,
	"component-life-cycle": "active",
	"is-bespoke": false
};

/**
 * @example ./Design.md
 */
var SecondaryBody = function SecondaryBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			InternalSecondaryBody,
			{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
			children
		)
	);
};

SecondaryBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

SecondaryBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'secondarybody'
};

var main$1 = "StandardBody.js";
var packageJson$1 = {
	main: main$1,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

/**
 * @example ./Design.md
 */
var StandardBody = function StandardBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$1, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			InternalStandardBody,
			{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
			children
		)
	);
};

StandardBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

StandardBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'standardbody'
};

var main$2 = "SubBody.js";
var packageJson$2 = {
	main: main$2,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$7 = taggedTemplateLiteral(['\n\t', ';\n\t', ';\n'], ['\n\t', ';\n\t', ';\n']);

var StyledSubBody = styled('div')(_templateObject$7, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.uist();
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

/**
 * @example ./Design.md
 */
var SubBody = function SubBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$2, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledSubBody,
			{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
			children
		)
	);
};

SubBody.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

SubBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'subbody'
};

var _templateObject$8 = taggedTemplateLiteral(['\n\tclip: rect(1px, 1px, 1px, 1px) !important;\n\theight: 1px !important;\n\twidth: 1px !important;\n\toverflow: hidden !important;\n\tposition: absolute;\n'], ['\n\tclip: rect(1px, 1px, 1px, 1px) !important;\n\theight: 1px !important;\n\twidth: 1px !important;\n\toverflow: hidden !important;\n\tposition: absolute;\n']);

var StyledVisuallyHiddenText = styled('span')(_templateObject$8);

var VisuallyHiddenBody = function VisuallyHiddenBody(_ref) {
	var children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		StyledVisuallyHiddenText,
		{ id: id, 'data-test-id': dataTestId },
		children
	);
};

VisuallyHiddenBody.propTypes = {
	/** The id of the component. */
	id: PropTypes.string,
	/** Content of the visually hidden span. */
	children: PropTypes.node,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

var INTERNET_BANKING_CSS_OVERRIDE = '!important';

var main$3 = "SubHeading.js";
var packageJson$3 = {
	main: main$3,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$9 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\t', ';\n\tfont-family: ', ';\n\tmargin: 0;\n'], ['\n\tcolor: ', ';\n\t', ';\n\tfont-family: ', ';\n\tmargin: 0;\n']),
    _templateObject2$5 = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\t', ';\n\n\tdiv > svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\tmargin-right: ', ';\n\t\twidth: ', ';\n\t}\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\t', ';\n\n\tdiv > svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\tmargin-right: ', ';\n\t\twidth: ', ';\n\t}\n']);

var StyledSubHeading = styled('h2')(_templateObject$9, function (props) {
	return props.theme.colours.heading;
}, function (props) {
	return props.theme.isCompact ? useFontSize.of.arran() : useFontSize.of.islay();
}, function (props) {
	return props.theme.fonts.display.bold;
});

var StyledWrapper$1 = styled('div')(_templateObject2$5, function (props) {
	return props.isFlush && 'margin-bottom: 0;';
}, function (props) {
	return props.theme.colours.heading;
}, function (props) {
	return props.theme.isCompact ? '14px' : '28px';
}, function (props) {
	return props.theme.isCompact ? '8px' : '16px';
}, function (props) {
	return props.theme.isCompact ? '14px' : '28px';
});

/**
 * Uses `<h2>` tag internally.
 * @example ./Design.md
 */
var SubHeading = function SubHeading(_ref) {
	var children = _ref.children,
	    icon = _ref.icon,
	    isFlush = _ref.isFlush,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$3, isFlush: isFlush, layout: 'typography' },
		React.createElement(
			StyledWrapper$1,
			{ isFlush: isFlush },
			icon,
			React.createElement(
				StyledSubHeading,
				{ id: id, 'data-test-id': dataTestId },
				children
			)
		)
	);
};

SubHeading.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Optional Left aligned icon with SubHeading. */
	icon: PropTypes.node,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

SubHeading.defaultProps = {
	isFlush: false,
	'data-test-id': 'sub-heading'
};

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var ClockSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3(_ref, ["styles"]);

  return React.createElement("svg", _extends$4({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { fillRule: "evenodd", d: "M71.997 48.031H48V24.002a3 3 0 0 0-3-3c-1.659 0-3 1.341-3 3v26.93c0 .024-.015.042-.015.07 0 .641.252 1.205.603 1.691.543.774 1.395 1.308 2.412 1.308.048 0 .084-.024.132-.027h26.865c1.665 0 3.015-1.332 3.015-2.973 0-1.647-1.35-2.97-3.015-2.97M48 0C21.489 0 0 21.491 0 48.002 0 74.511 21.489 96 48 96c26.508 0 48-21.488 48-47.998C96 21.491 74.508 0 48 0" }));
});

var _extends$5 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4(_ref, ["styles"]);

  return React.createElement("svg", _extends$5({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M48 96.003c-26.51 0-48-21.49-48-48C0 21.49 21.49 0 48 0s48 21.49 48 48.003c0 26.51-21.49 48-48 48zm23.02-71.022a3.35 3.35 0 0 0-4.735 0L48 43.269 29.712 24.98a3.35 3.35 0 0 0-4.735 0 3.344 3.344 0 0 0 0 4.734l18.288 18.288-18.288 18.288a3.344 3.344 0 0 0 0 4.735 3.35 3.35 0 0 0 4.735 0L48 52.738l18.285 18.288a3.35 3.35 0 0 0 4.734 0 3.35 3.35 0 0 0 0-4.735L52.735 48.003l18.284-18.288a3.35 3.35 0 0 0 0-4.734z" }));
});

var _extends$6 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var MinusSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5(_ref, ["styles"]);

  return React.createElement("svg", _extends$6({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M48 0c26.508 0 48 21.489 48 48 0 26.508-21.492 48-48 48C21.489 96 0 74.508 0 48 0 21.489 21.489 0 48 0zm20.045 41H28.931C27.311 41 26 44.356 26 48.504 26 52.644 27.311 56 28.931 56h39.114c1.62 0 2.931-3.356 2.931-7.496 0-4.148-1.311-7.504-2.931-7.504" }));
});

var _extends$7 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6(_ref, ["styles"]);

  return React.createElement("svg", _extends$7({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("g", { fillRule: "evenodd" }, React.createElement("circle", { cx: "48", cy: "48", r: "48" }), React.createElement("path", { d: "M48 51c-.893 0-1.615.67-1.615 1.5v9c0 .828.722 1.5 1.615 1.5.892 0 1.615-.672 1.615-1.5v-9c0-.83-.723-1.5-1.615-1.5zm17.77 15c0 1.656-1.448 2.998-3.232 2.998H33.462c-1.785 0-3.231-1.342-3.231-2.998V48c0-1.657 1.446-3 3.23-3h29.077c1.784 0 3.231 1.343 3.231 3zM36.691 37.5C36.692 31.701 41.755 27 48 27s11.308 4.701 11.308 10.5V42H36.692zM62.538 42v-4.5C62.538 30.044 56.03 24 48 24s-14.538 6.044-14.538 13.5V42C29.893 42 27 44.685 27 48v18c0 3.313 2.893 6 6.462 6h29.076C66.107 72 69 69.313 69 66V48c0-3.314-2.893-6-6.462-6z", fill: "#fff" })));
});

var _extends$8 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7(_ref, ["styles"]);

  return React.createElement("svg", _extends$8({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("g", { fillRule: "evenodd" }, React.createElement("circle", { cx: "48", cy: "48", r: "48" }), React.createElement("path", { d: "M65.1 72H51.8c-.113 0-.226-.01-.337-.031a14.3 14.3 0 0 1-1.196-.28A8.297 8.297 0 0 1 48 70.662a8.634 8.634 0 0 1-3.504 1.315c-.08.01-.215.023-.296.023H30.9c-.504 0-.987-.21-1.344-.586A2.055 2.055 0 0 1 29 70V46c.052-2.186 1.723-3.945 3.8-4h3.8v-6c0-6.627 5.104-12 11.4-12s11.4 5.373 11.4 12v4h-3.8v-4c0-4.418-3.403-8-7.6-8-4.197 0-7.6 3.582-7.6 8v8c0 .53-.2 1.04-.556 1.414-.357.375-.84.586-1.344.586h-5.7v22h11.277c.349-.054.691-.146 1.022-.275a10.892 10.892 0 0 1-.392-.659l-3.248-5.943a8.31 8.31 0 0 1 .039-7.933c1.355-2.447 3.846-3.95 6.538-3.944h.001c2.694-.007 5.187 1.5 6.54 3.953a8.296 8.296 0 0 1 .012 7.938l-3.283 5.949c-.12.219-.246.43-.38.637.103.037.207.07.312.1.24.066.485.126.738.177H63.2V46H42.3v-4h20.9c2.077.055 3.748 1.814 3.8 4v24c0 .53-.2 1.04-.556 1.414-.357.375-.84.586-1.344.586zM48.035 53.246c-1.128-.001-2.197.529-2.914 1.445-.988 1.254-1.135 3.02-.368 4.436L48 65.07l.012.022.007-.014 3.282-5.95a4.08 4.08 0 0 0-.35-4.437c-.718-.916-1.788-1.446-2.917-1.445z", fill: "#fff" })));
});

var _extends$9 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$8(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$3 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$8(_ref, ["styles"]);

  return React.createElement("svg", _extends$9({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M4.143 10.39l1.362 1.254-2.001.63.64-1.885zm7.473-7.188l1.544 1.467-6.998 6.556-1.587-1.507 7.04-6.516zm1.67-1.703a.531.531 0 0 1 .365-.14c.139 0 .347.138.444.228l.798.773a.458.458 0 0 1 0 .68L13.756 4.1l-1.608-1.541 1.14-1.06zm-9.814 8.03l-.006.029-.97 3.06.712.593L6.32 12.19l.04.007h.152l7.534-7.008 1.545-1.47c.604-.562.509-1.653-.095-2.216l-.671-.596c-.583-.543-1.608-.543-2.19 0l-1.449 1.584-7.715 6.87v.169zm11.526-4.31v9.4H1V1.455h9.006v-.94H1c-.553 0-1 .42-1 .94v13.164c0 .519.447.94 1 .94h13.998c.552 0 1-.421 1-.94v-9.4h-1z" }));
});

var _extends$a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$9(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$9(_ref, ["styles"]);

  return React.createElement("svg", _extends$a({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M37.142 7.772v7.68H9.732v69.116h69.12v-30.72h7.68v38.4H2.052V7.772zM82.369 0c6.362 0 11.52 5.158 11.52 11.52 0 6.362-5.158 11.52-11.52 11.52H80.19c.185.23.381.45.59.66l2.391 2.43a3.838 3.838 0 0 1-.018 5.41L52.095 62.594l-5.43-5.43L75.03 28.802a15.22 15.22 0 0 1-3.607-6.355 15.486 15.486 0 0 1-6.342-3.592L26.258 57.679l-3.709 13.657 13.658-3.708 1.942-1.943-6.652-6.652 5.43-5.43 9.367 9.367a3.839 3.839 0 0 1 0 5.43l-5.381 5.381a3.84 3.84 0 0 1-1.71.99l-21.109 5.734a3.84 3.84 0 0 1-4.71-4.71l5.73-21.112a3.84 3.84 0 0 1 .99-1.71l42.24-42.24a3.837 3.837 0 0 1 5.408-.02l2.415 2.377c.215.214.443.415.682.603V11.52C70.85 5.158 76.007 0 82.37 0zm0 7.68a3.84 3.84 0 0 0-3.84 3.84v3.84h3.84a3.84 3.84 0 0 0 0-7.68z" }));
});

var _extends$b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$a(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$4 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$a(_ref, ["styles"]);

  return React.createElement("svg", _extends$b({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 95.999c-26.508 0-48-21.486-48-48 0-26.508 21.492-48 48-48s48 21.492 48 48c0 26.514-21.492 48-48 48zm-6.137-24c.078 0 .156 0 .228-.006 1.656-.078 3.162-.906 4.032-2.25l25.116-38.436c1.47-2.244.744-5.19-1.608-6.588-2.346-1.392-5.442-.702-6.9 1.53l-21.264 32.55-8.46-10.644c-1.668-2.106-4.806-2.532-7.02-.93-2.208 1.596-2.64 4.59-.966 6.69l12.846 16.194c.948 1.194 2.436 1.89 3.996 1.89z" }));
});

var _extends$c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$b(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$3 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$b(_ref, ["styles"]);

  return React.createElement("svg", _extends$c({ height: "96", viewBox: "0 0 40 40", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20C39.988 8.96 31.04.012 20 0z" }), React.createElement("g", { fill: "none", fillRule: "evenodd" }, React.createElement("path", { d: "M0 0h40v40H0z" }), React.createElement("path", { d: "M16.711 29.8a1.462 1.462 0 0 1-1.043.473h-.034c-.387 0-.757-.153-1.03-.424l-5.827-5.787 2.06-2.045 4.746 4.714 13.54-14.792 2.154 1.947z", fill: "#fff" })));
});

var main$4 = "ProminentLabel.js";
var packageJson$4 = {
	main: main$4,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$a = taggedTemplateLiteral(['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n'], ['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n']);

var StyledProminentLabel = styled('div')(_templateObject$a, function (props) {
	return props.theme.isCompact ? useFontSize.of.jura() : useFontSize.of.arran();
}, function (props) {
	return props.theme.fonts.display.bold;
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var ProminentLabel = function ProminentLabel(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$4, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledProminentLabel,
			{ isFlush: isFlush },
			children
		)
	);
};

ProminentLabel.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool
};

ProminentLabel.defaultProps = {
	isFlush: false
};

var main$5 = "StandardLabel.js";
var packageJson$5 = {
	main: main$5,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$b = taggedTemplateLiteral(['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n'], ['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n']);

var StyledStandardLabel = styled('div')(_templateObject$b, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
}, function (props) {
	return props.theme.fonts.standardLabel;
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var StandardLabel = function StandardLabel(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    dataTestId = _ref['data-test-id'],
	    id = _ref.id;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$5, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledStandardLabel,
			{ isFlush: isFlush, 'data-test-id': dataTestId, id: id },
			children
		)
	);
};

StandardLabel.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** Data attribute targeting modal container for automation test purposes. */
	'data-test-id': PropTypes.string,
	/** String id passed to underlying html element. */
	id: PropTypes.string
};

StandardLabel.defaultProps = {
	isFlush: false,
	'data-test-id': 'standard-label'
};

var main$6 = "SubLabel.js";
var packageJson$6 = {
	main: main$6,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$c = taggedTemplateLiteral(['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n'], ['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n']);

var StyledSubLabel = styled('div')(_templateObject$c, function (props) {
	return props.theme.isCompact ? useFontSize.of.cumbrae() : useFontSize.of.bute();
}, function (props) {
	return props.theme.fonts.subLabel;
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var SubLabel = function SubLabel(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$6, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledSubLabel,
			{ isFlush: isFlush },
			children
		)
	);
};

SubLabel.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool
};

SubLabel.defaultProps = {
	isFlush: false
};

var _extends$d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$c(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$5 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$c(_ref, ["styles"]);

  return React.createElement("svg", _extends$d({ width: "16", height: "16", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M6.63 6.631a9.378 9.378 0 0 0 0 13.263l28.1 28.102-28.103 28.12A9.377 9.377 0 0 0 19.89 89.371l28.102-28.105L76.106 89.37a9.38 9.38 0 0 0 13.263-.001 9.378 9.378 0 0 0 0-13.263L61.253 47.987l28.108-28.11a9.373 9.373 0 0 0 .004-13.25 9.359 9.359 0 0 0-13.24-.004l-28.108 28.11L19.894 6.63a9.38 9.38 0 0 0-13.263.002z" }));
});

var _extends$e = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$d(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$4 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$d(_ref, ["styles"]);

  return React.createElement("svg", _extends$e({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M84.562 2.58l9.696 9.697-36.295 36.295 36.295 36.295-9.696 9.696-36.295-36.294-36.295 36.294-9.696-9.696L38.57 48.572 2.276 12.277l9.696-9.696 36.295 36.295z" }));
});

var _extends$f = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$e(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$5 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$e(_ref, ["styles"]);

  return React.createElement("svg", _extends$f({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M11.429 37c6.311 0 11.428 5.117 11.428 11.429S17.74 59.857 11.43 59.857C5.117 59.857 0 54.74 0 48.43S5.117 37 11.429 37zM48 37c6.312 0 11.429 5.117 11.429 11.429S54.312 59.857 48 59.857 36.571 54.74 36.571 48.43 41.688 37 48 37zm36.571 0C90.883 37 96 42.117 96 48.429s-5.117 11.428-11.429 11.428S73.143 54.74 73.143 48.43 78.26 37 84.57 37z" }));
});

var _extends$g = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$f(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$6 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$f(_ref, ["styles"]);

  return React.createElement("svg", _extends$g({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M2 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" }));
});

var main$7 = "ProminentValue.js";
var packageJson$7 = {
	main: main$7,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$d = taggedTemplateLiteral(['\n\tfont-family: ', ';\n\t', ';\n'], ['\n\tfont-family: ', ';\n\t', ';\n']);

var StyledProminentValue = styled('span')(_templateObject$d, function (props) {
	return props.theme.fonts.text.bold;
}, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
});

/**
 * Uses `<span>` tag internally
 * @example ./Design.md
 */
var ProminentValue = function ProminentValue(_ref) {
	var children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$7, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(
			StyledProminentValue,
			null,
			children
		)
	);
};

ProminentValue.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired
};

ProminentValue.defaultProps = {};

var inputStyles = 'input {\n\t\tclip: rect(0, 0, 0, 0);\n\t\theight: 0;\n\t\twidth: 0;\n\t\toverflow: hidden;\n\t\tposition: absolute;\n\n\t\t:focus {\n\t\t\t~ label {\n\t\t\t\toutline-color: ' + colours.component.focusOutline + ';\n\t\t\t\toutline-offset: 2px;\n\t\t\t\toutline-style: auto;\n\t\t\t\toutline-width: 5px;\n\t\t\t}\n\t\t}\n\t}';

var _templateObject$e = taggedTemplateLiteral(['\n\tdisplay: inline-flex;\n\tposition: relative;\n\n\t@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n\t\ttable & {\n\t\t\tflex: 1;\n\t\t}\n\t}\n\n\t', ';\n\n\t', ';\n'], ['\n\tdisplay: inline-flex;\n\tposition: relative;\n\n\t@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n\t\ttable & {\n\t\t\tflex: 1;\n\t\t}\n\t}\n\n\t', ';\n\n\t', ';\n']),
    _templateObject2$6 = taggedTemplateLiteral(['\n\tmargin-right: ', ';\n'], ['\n\tmargin-right: ', ';\n']),
    _templateObject3$4 = taggedTemplateLiteral(['\n\tbox-sizing: border-box;\n\tcolor: ', ';\n\tcursor: ', ';\n\tdisplay: inline-flex;\n\tmin-width: 98px;\n\t', ';\n\n\t// IE11 Solution to content stress test\n\t&:after {\n\t\tdisplay: block;\n\t\tcontent: \'\';\n\t\tmin-height: inherit;\n\t\tfont-size: 0;\n\t}\n'], ['\n\tbox-sizing: border-box;\n\tcolor: ', ';\n\tcursor: ', ';\n\tdisplay: inline-flex;\n\tmin-width: 98px;\n\t', ';\n\n\t// IE11 Solution to content stress test\n\t&:after {\n\t\tdisplay: block;\n\t\tcontent: \'\';\n\t\tmin-height: inherit;\n\t\tfont-size: 0;\n\t}\n']),
    _templateObject4$3 = taggedTemplateLiteral(['\n\tflex-shrink: 0;\n\t', ';\n\t', ';\n\theight: ', ';\n\twidth: ', ';\n\n\tsvg {\n\t\tbackground-color: ', ';\n\t\tborder: 2px solid ', ';\n\t\tborder-radius: 2px;\n\t\tmargin-top: 1px;\n\t\theight: ', ';\n\t\twidth: ', ';\n\t\t', ';\n\t}\n'], ['\n\tflex-shrink: 0;\n\t', ';\n\t', ';\n\theight: ', ';\n\twidth: ', ';\n\n\tsvg {\n\t\tbackground-color: ', ';\n\t\tborder: 2px solid ', ';\n\t\tborder-radius: 2px;\n\t\tmargin-top: 1px;\n\t\theight: ', ';\n\t\twidth: ', ';\n\t\t', ';\n\t}\n']);

var getIconFillColour = function getIconFillColour(isChecked, isStacked, isDisabled, hasError, theme) {
	if (isChecked && isDisabled) {
		return colours.component.borderDisabled;
	}
	if (isDisabled) {
		return colours.component.backgroundDisabled;
	}
	if (isStacked && isChecked) {
		return colours.generalPalette.white;
	}
	if (isChecked) {
		return hasError ? colours.utility.error : theme.colours.interaction;
	}
	return 'transparent';
};

var getIconBackgroundColour = function getIconBackgroundColour(isChecked, isStacked, isDisabled, hasError, theme) {
	if (isDisabled) {
		return colours.component.backgroundDisabled;
	}
	if (isStacked && isChecked) {
		return hasError ? colours.utility.error : theme.colours.interaction;
	}
	return colours.component.background;
};

var StyledWrapper$2 = styled('div')(_templateObject$e, inputStyles, function (props) {
	return props.isStacked && '\n\t\twidth: 100%;\n        input {\n            :focus {\n                ~ label {\n                    z-index: 3000\n                }\n            }\n        }\n    ';
});

var StyledLabelContent = styled('div')(_templateObject2$6, spacing.SINGLE);

var StyledLabel = styled('label')(_templateObject3$4, function (props) {
	return props.theme.colours.bodyText;
}, function (props) {
	return props.isDisabled ? 'not-allowed' : 'pointer';
}, function (props) {
	return props.isStacked && '\n\t\twidth: 100%;\n\t\tpadding: ' + spacing.DOUBLE + ';\n\t\talign-items: center;\n\t\tflex-direction: row-reverse;\n\t\tbackground-color: ' + colours.generalPalette.white + ';\n\t';
});

var StyledIconWrapper = styled('div')(_templateObject4$3, function (props) {
	return props.isStacked && 'padding-left: ' + spacing.SINGLE;
}, function (props) {
	return props.isStacked ? 'margin-left: auto;' : 'margin-right: ' + spacing.SINGLE;
}, function (props) {
	return props.theme.isCompact ? '18px' : '24px';
}, function (props) {
	return props.theme.isCompact ? '18px' : '24px';
}, function (props) {
	return getIconBackgroundColour(props.isChecked, props.isStacked, props.isDisabled, props.hasError, props.theme);
}, function (props) {
	return props.hasError ? colours.utility.error : props.theme.colours.interaction;
}, function (props) {
	return props.theme.isCompact ? '18px' : '24px';
}, function (props) {
	return props.theme.isCompact ? '18px' : '24px';
}, function (props) {
	return props.isDisabled && 'border-color: ' + colours.component.borderDisabled + ';';
});

var UnwrappedBaseInternalCheckbox = function (_Component) {
	inherits(UnwrappedBaseInternalCheckbox, _Component);

	function UnwrappedBaseInternalCheckbox(props) {
		classCallCheck(this, UnwrappedBaseInternalCheckbox);

		var _this = possibleConstructorReturn(this, (UnwrappedBaseInternalCheckbox.__proto__ || Object.getPrototypeOf(UnwrappedBaseInternalCheckbox)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(UnwrappedBaseInternalCheckbox, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    hasError = _props.hasError,
			    id = _props.id,
			    isChecked = _props.isChecked,
			    isDisabled = _props.isDisabled,
			    innerRef = _props.innerRef,
			    label = _props.label,
			    name = _props.name,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    theme = _props.theme,
			    hasSubLabelStyling = _props.hasSubLabelStyling,
			    subLabelText = _props.subLabelText,
			    isStacked = _props.isStacked;


			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				StyledWrapper$2,
				{
					hasError: hasError,
					isChecked: isChecked,
					isStacked: isStacked,
					isDisabled: isDisabled,
					hasSubLabel: !!subLabelText
				},
				React.createElement('input', {
					checked: isChecked,
					disabled: isDisabled,
					id: id,
					name: name,
					onBlur: onBlur,
					onChange: onChange,
					onFocus: onFocus,
					ref: function ref(element) {
						_this2.refInput = element;
					},
					type: 'checkbox',
					value: label
				}),
				React.createElement(
					StyledLabel,
					{ htmlFor: id, isStacked: isStacked, isDisabled: isDisabled },
					React.createElement(
						StyledIconWrapper,
						{ hasError: hasError, isChecked: isChecked, isStacked: isStacked, isDisabled: isDisabled },
						React.createElement(CheckboxIcon, { fill: getIconFillColour(isChecked, isStacked, isDisabled, hasError, theme) })
					),
					React.createElement(
						InternalStandardBody,
						{ isFlush: true },
						hasSubLabelStyling && subLabelText ? React.createElement(Inline.LeftAligned, {
							nodes: [React.createElement(
								StyledLabelContent,
								null,
								React.createElement(
									ProminentValue,
									null,
									label
								)
							), React.createElement(
								SecondaryBody,
								{ isFlush: true },
								React.createElement(
									'span',
									null,
									' - ',
									subLabelText
								)
							)]
						}) : React.createElement(
							'span',
							null,
							label
						)
					)
				)
			);
		}
	}]);
	return UnwrappedBaseInternalCheckbox;
}(Component);

var baseProps$1 = {
	/** Changes radio colour when set to true. */
	hasError: PropTypes.bool,
	/** An ID HTML attribute for the checkbox element. Must be unique on any individual page. */
	id: PropTypes.string.isRequired,
	/** Boolean controlling whether checkbox input is checked. */
	isChecked: PropTypes.bool.isRequired,
	/** Boolean controlling whether checkbox input is disabled. */
	isDisabled: PropTypes.bool,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** The checkbox input label. */
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	/** HTML name attribute value that this checkbox option belongs to. */
	name: PropTypes.string,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Boolean determined from items passed whether sub level styling should be applied. */
	hasSubLabelStyling: PropTypes.bool
};

var baseDefaultProps = {
	hasError: false,
	isDisabled: false
};

UnwrappedBaseInternalCheckbox.propTypes = baseProps$1;
UnwrappedBaseInternalCheckbox.defaultProps = baseDefaultProps;

var BaseInternalCheckbox = withTheme(UnwrappedBaseInternalCheckbox);

var Default = function Default(_ref) {
	var hasError = _ref.hasError,
	    id = _ref.id,
	    isChecked = _ref.isChecked,
	    isDisabled = _ref.isDisabled,
	    innerRef = _ref.innerRef,
	    label = _ref.label,
	    name = _ref.name,
	    onBlur = _ref.onBlur,
	    onChange = _ref.onChange,
	    onFocus = _ref.onFocus;
	return React.createElement(BaseInternalCheckbox, {
		hasError: hasError,
		id: id,
		isChecked: isChecked,
		isDisabled: isDisabled,
		innerRef: innerRef,
		label: label,
		name: name,
		onBlur: onBlur,
		onChange: onChange,
		onFocus: onFocus
	});
};

Default.propTypes = _extends({}, baseProps$1);

var Stacked = function Stacked(_ref) {
	var hasError = _ref.hasError,
	    id = _ref.id,
	    isChecked = _ref.isChecked,
	    isDisabled = _ref.isDisabled,
	    innerRef = _ref.innerRef,
	    label = _ref.label,
	    name = _ref.name,
	    onBlur = _ref.onBlur,
	    onChange = _ref.onChange,
	    onFocus = _ref.onFocus,
	    hasSubLabelStyling = _ref.hasSubLabelStyling,
	    subLabelText = _ref.subLabelText,
	    isStacked = _ref.isStacked;
	return React.createElement(BaseInternalCheckbox, {
		hasError: hasError,
		id: id,
		isChecked: isChecked,
		isDisabled: isDisabled,
		innerRef: innerRef,
		label: label,
		name: name,
		onBlur: onBlur,
		onChange: onChange,
		onFocus: onFocus,
		hasSubLabelStyling: hasSubLabelStyling,
		subLabelText: subLabelText,
		isStacked: isStacked
	});
};

Stacked.propTypes = _extends({}, baseProps$1);

var InternalCheckbox = {
	Default: Default,
	Stacked: Stacked
};

var main$8 = "CheckboxContainer.js";
var variants = ["Standalone", "StackedSet"];
var packageJson$8 = {
	main: main$8,
	variants: variants,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$f = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tbackground-color: ', ';\n\tpadding: ', ' ', ' ', ' 0;\n\twidth: 100%;\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\tbackground-color: ', ';\n\tpadding: ', ' ', ' ', ' 0;\n\twidth: 100%;\n\n\t', ';\n']),
    _templateObject2$7 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\talign-items: center;\n\n\t> div > label {\n\t\tmin-width: 0;\n\t\tpadding-top: 100%;\n\t\tpadding-bottom: 100%;\n\t\tpadding-left: ', ';\n\t\tpadding-right: ', ';\n\t}\n\n\tlabel span {\n\t\tclip: rect(1px, 1px, 1px, 1px) !important;\n\t\theight: 1px !important;\n\t\twidth: 1px !important;\n\t\toverflow: hidden !important;\n\t\tposition: absolute;\n\t}\n'], ['\n\tdisplay: flex;\n\talign-items: center;\n\n\t> div > label {\n\t\tmin-width: 0;\n\t\tpadding-top: 100%;\n\t\tpadding-bottom: 100%;\n\t\tpadding-left: ', ';\n\t\tpadding-right: ', ';\n\t}\n\n\tlabel span {\n\t\tclip: rect(1px, 1px, 1px, 1px) !important;\n\t\theight: 1px !important;\n\t\twidth: 1px !important;\n\t\toverflow: hidden !important;\n\t\tposition: absolute;\n\t}\n']);

var getSelectedDarkenValue = 8;

var StyledInputWrapper = styled('div')(_templateObject$f, function (props) {
	return props.theme.colours.interactionAlternate;
}, spacing.TRIPLE, spacing.TRIPLE, spacing.TRIPLE, function (props) {
	return props.isSelected && 'background-color: ' + hslAdjust(props.theme.colours.interactionAlternate).darken(getSelectedDarkenValue);
});

var StyledCheckboxWrapper = styled('div')(_templateObject2$7, spacing.TRIPLE, spacing.DOUBLE);

var checkIsSelected = function checkIsSelected(selectedIds, id) {
	return selectedIds.some(function (item) {
		return item === id;
	});
};

var Base = function (_Component) {
	inherits(Base, _Component);

	function Base(props) {
		classCallCheck(this, Base);

		var _this = possibleConstructorReturn(this, (Base.__proto__ || Object.getPrototypeOf(Base)).call(this, props));

		_this.inputRef = null;

		_this.handleOnChange = _this.handleOnChange.bind(_this);
		return _this;
	}

	createClass(Base, [{
		key: 'handleOnChange',
		value: function handleOnChange(selectedIds, id) {
			var onChange = this.props.onChange;


			var isPreviouslySelected = checkIsSelected(selectedIds, id);

			var newIds = isPreviouslySelected ? selectedIds.filter(function (item) {
				return item !== id;
			}) : [].concat(toConsumableArray(selectedIds), [id]);

			onChange(newIds);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    hasError = _props.hasError,
			    groupName = _props.groupName,
			    innerRef = _props.innerRef,
			    isStacked = _props.isStacked,
			    items = _props.items,
			    onBlur = _props.onBlur,
			    onFocus = _props.onFocus,
			    selectedIds = _props.selectedIds;


			return React.createElement(
				'div',
				null,
				items.map(function (_ref, index) {
					var id = _ref.id,
					    visuallyHiddenLabel = _ref.visuallyHiddenLabel,
					    contentNode = _ref.contentNode;

					var blur = index === items.length - 1 ? onBlur : undefined;
					var focus = index === 0 ? onFocus : undefined;
					var ref = index === 0 ? innerRef : undefined;
					var getName = groupName !== '' ? groupName : undefined;
					var getGroupName = groupName ? groupName + id : id;

					return React.createElement(
						StyledInputWrapper,
						{ key: getGroupName, isStacked: isStacked, isSelected: checkIsSelected(selectedIds, id) },
						React.createElement(
							StyledCheckboxWrapper,
							null,
							React.createElement(InternalCheckbox.Default, {
								hasError: hasError,
								id: getGroupName,
								innerRef: ref,
								isChecked: checkIsSelected(selectedIds, id),
								label: visuallyHiddenLabel,
								name: getName,
								onBlur: blur,
								onChange: function onChange() {
									return _this2.handleOnChange(selectedIds, id);
								},
								onFocus: focus
							})
						),
						contentNode
					);
				})
			);
		}
	}]);
	return Base;
}(Component);

var Standalone = function Standalone(_ref2) {
	var hasError = _ref2.hasError,
	    innerRef = _ref2.innerRef,
	    items = _ref2.items,
	    onBlur = _ref2.onBlur,
	    onChange = _ref2.onChange,
	    onFocus = _ref2.onFocus,
	    selectedIds = _ref2.selectedIds;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Standalone', packageJson: packageJson$8 },
		React.createElement(Base, {
			hasError: hasError,
			innerRef: innerRef,
			items: items,
			onBlur: onBlur,
			onChange: onChange,
			onFocus: onFocus,
			selectedIds: selectedIds
		})
	);
};

var StackedSet = function StackedSet(_ref3) {
	var groupName = _ref3.groupName,
	    hasError = _ref3.hasError,
	    innerRef = _ref3.innerRef,
	    items = _ref3.items,
	    onBlur = _ref3.onBlur,
	    onChange = _ref3.onChange,
	    onFocus = _ref3.onFocus,
	    selectedIds = _ref3.selectedIds;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'StackedSet', packageJson: packageJson$8 },
		React.createElement(Base, {
			groupName: groupName,
			hasError: hasError,
			innerRef: innerRef,
			items: items,
			isStacked: true,
			onBlur: onBlur,
			onChange: onChange,
			onFocus: onFocus,
			selectedIds: selectedIds
		})
	);
};

var baseProps$2 = {
	/** Changes radio colour when set to true. */
	hasError: PropTypes.bool,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Array of checkbox objects data. */
	items: PropTypes.arrayOf(shape({
		id: PropTypes.string.isRequired,
		visuallyHiddenLabel: PropTypes.string.isRequired
	})),
	/** Callback function triggered on blur of the last checkbox. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus of the first checkbox. */
	onFocus: PropTypes.func,
	/** Array of ids to be highlighted. */
	selectedIds: PropTypes.arrayOf(PropTypes.string).isRequired
};

Base.propTypes = _extends({}, baseProps$2);
Standalone.propTypes = _extends({}, baseProps$2);
StackedSet.propTypes = _extends({}, baseProps$2, {
	groupName: PropTypes.string.isRequired,
	isStacked: PropTypes.bool
});

Base.defaultProps = {
	hasError: false
};

var CheckboxContainer = {
	Standalone: Standalone,
	StackedSet: StackedSet
};

var _templateObject$g = taggedTemplateLiteral(['\n\tdisplay: ', ';\n\t', ';\n\t', ';\n\n\t@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n\t\ttable & {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n'], ['\n\tdisplay: ', ';\n\t', ';\n\t', ';\n\n\t@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n\t\ttable & {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n']);

var StyledInputWrapper$1 = styled('div')(_templateObject$g, function (props) {
	return props.isStacked ? 'flex' : 'inline-flex';
}, function (props) {
	return !props.isStacked && externalMarginRegular;
}, function (props) {
	return props.isStacked && '\n        border: 1px solid ' + colours.generalPalette.greyLighter + ';\n        border-bottom: none;\n\n        :last-of-type {\n            border-bottom: 1px solid ' + colours.generalPalette.greyLighter + ';\n        }\n    ';
});

var checkIsSelected$1 = function checkIsSelected(selectedIds, id) {
	return selectedIds.some(function (item) {
		return item === id;
	});
};

var BaseGenericCheckbox = function (_Component) {
	inherits(BaseGenericCheckbox, _Component);

	function BaseGenericCheckbox(props) {
		classCallCheck(this, BaseGenericCheckbox);

		var _this = possibleConstructorReturn(this, (BaseGenericCheckbox.__proto__ || Object.getPrototypeOf(BaseGenericCheckbox)).call(this, props));

		_this.inputRef = null;

		_this.handleOnChange = _this.handleOnChange.bind(_this);
		return _this;
	}

	createClass(BaseGenericCheckbox, [{
		key: 'handleOnChange',
		value: function handleOnChange(selectedIds, id) {
			var onChange = this.props.onChange;


			var isPreviouslySelected = checkIsSelected$1(selectedIds, id);

			var newIds = isPreviouslySelected ? selectedIds.filter(function (item) {
				return item !== id;
			}) : [].concat(toConsumableArray(selectedIds), [id]);

			onChange(newIds);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    hasError = _props.hasError,
			    groupName = _props.groupName,
			    innerRef = _props.innerRef,
			    isStacked = _props.isStacked,
			    items = _props.items,
			    onBlur = _props.onBlur,
			    onFocus = _props.onFocus,
			    selectedIds = _props.selectedIds,
			    hasSubLabelStyling = _props.hasSubLabelStyling;


			return React.createElement(
				'div',
				null,
				items.map(function (_ref, index) {
					var id = _ref.id,
					    labelText = _ref.labelText,
					    subLabelText = _ref.subLabelText;

					var blur = index === items.length - 1 ? onBlur : undefined;
					var focus = index === 0 ? onFocus : undefined;
					var ref = index === 0 ? innerRef : undefined;
					var getName = groupName !== '' ? groupName : undefined;

					return React.createElement(
						StyledInputWrapper$1,
						{ key: groupName + id, isStacked: isStacked },
						isStacked ? React.createElement(InternalCheckbox.Stacked, {
							hasError: hasError,
							hasSubLabelStyling: hasSubLabelStyling,
							id: groupName + id,
							innerRef: ref,
							isChecked: checkIsSelected$1(selectedIds, id),
							label: labelText,
							name: getName,
							onBlur: blur,
							onChange: function onChange() {
								return _this2.handleOnChange(selectedIds, id);
							},
							onFocus: focus,
							subLabelText: subLabelText,
							isStacked: true
						}) : React.createElement(InternalCheckbox.Default, {
							hasError: hasError,
							hasSubLabelStyling: hasSubLabelStyling,
							id: groupName + id,
							innerRef: ref,
							isChecked: checkIsSelected$1(selectedIds, id),
							label: labelText,
							name: getName,
							onBlur: blur,
							onChange: function onChange() {
								return _this2.handleOnChange(selectedIds, id);
							},
							onFocus: focus
						})
					);
				})
			);
		}
	}]);
	return BaseGenericCheckbox;
}(Component);

var baseProps$3 = {
	/** String added to the html name attribute of each checkbox. */
	groupName: PropTypes.string.isRequired,
	/** Changes radio colour when set to true. */
	hasError: PropTypes.bool,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Array of checkbox objects data. */
	items: PropTypes.arrayOf(shape({
		id: PropTypes.string.isRequired,
		labelText: PropTypes.string.isRequired,
		subLabelText: PropTypes.string
	})),
	/** Callback function triggered on blur of the last checkbox. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus of the first checkbox. */
	onFocus: PropTypes.func,
	/** Array of ids to be highlighted. */
	selectedIds: PropTypes.arrayOf(PropTypes.string).isRequired,
	/** Boolean determined from items passed whether sub level styling should be applied. */
	hasSubLabelStyling: PropTypes.bool
};

BaseGenericCheckbox.propTypes = _extends({}, baseProps$3);

BaseGenericCheckbox.defaultProps = {
	hasError: false,
	hasSubLabelStyling: false
};

var main$9 = "GenericCheckbox.js";
var variants$1 = ["StackedSet", "InlineSet"];
var packageJson$9 = {
	main: main$9,
	variants: variants$1,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var InlineSet = function InlineSet(_ref) {
	var groupName = _ref.groupName,
	    hasError = _ref.hasError,
	    innerRef = _ref.innerRef,
	    items = _ref.items,
	    onBlur = _ref.onBlur,
	    onChange = _ref.onChange,
	    onFocus = _ref.onFocus,
	    selectedIds = _ref.selectedIds;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'InlineSet', packageJson: packageJson$9, hasCustomMargins: true },
		React.createElement(BaseGenericCheckbox, {
			hasError: hasError,
			innerRef: innerRef,
			groupName: groupName,
			onBlur: onBlur,
			onChange: onChange,
			onFocus: onFocus,
			selectedIds: selectedIds,
			items: items
		})
	);
};

InlineSet.propTypes = _extends({}, baseProps$3);

var StackedSet$1 = function StackedSet(_ref) {
	var groupName = _ref.groupName,
	    hasError = _ref.hasError,
	    innerRef = _ref.innerRef,
	    items = _ref.items,
	    onBlur = _ref.onBlur,
	    onChange = _ref.onChange,
	    onFocus = _ref.onFocus,
	    selectedIds = _ref.selectedIds;

	var hasSubLabelStyling = items.some(function (item) {
		return !!item.subLabelText;
	});

	return React.createElement(
		InternalComponentFrame,
		{ variant: 'StackedSet', packageJson: packageJson$9 },
		React.createElement(BaseGenericCheckbox, {
			groupName: groupName,
			hasError: hasError,
			innerRef: innerRef,
			items: items,
			isStacked: true,
			onBlur: onBlur,
			onChange: onChange,
			onFocus: onFocus,
			selectedIds: selectedIds,
			hasSubLabelStyling: hasSubLabelStyling
		})
	);
};

StackedSet$1.propTypes = _extends({}, baseProps$3, { isStacked: PropTypes.bool });

var GenericCheckbox = {
	StackedSet: StackedSet$1,
	InlineSet: InlineSet
};

var main$a = "StandaloneCheckbox.js";
var packageJson$a = {
	main: main$a,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var StandaloneCheckbox = function StandaloneCheckbox(_ref) {
	var hasError = _ref.hasError,
	    id = _ref.id,
	    isChecked = _ref.isChecked,
	    innerRef = _ref.innerRef,
	    labelText = _ref.labelText,
	    onBlur = _ref.onBlur,
	    onChange = _ref.onChange,
	    onFocus = _ref.onFocus;

	var onChangeHandler = function onChangeHandler(selectedIds) {
		var isChecked = selectedIds.length === 1;
		onChange({ isChecked: isChecked });
	};

	var items = [{ id: id, labelText: labelText }];
	var selectedIds = isChecked ? [id] : [];

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$a, hasCustomMargins: true },
		React.createElement(GenericCheckbox.InlineSet, {
			groupName: '',
			hasError: hasError,
			innerRef: innerRef,
			items: items,
			onBlur: onBlur,
			onChange: function onChange(selectedIds) {
				return onChangeHandler(selectedIds);
			},
			onFocus: onFocus,
			selectedIds: selectedIds
		})
	);
};

StandaloneCheckbox.propTypes = {
	/** Changes radio colour when set to true. */
	hasError: PropTypes.bool,
	/** String id passed to underlying html element. */
	id: PropTypes.string.isRequired,
	/** Boolean for native html checked attribute of checkbox element. */
	isChecked: PropTypes.bool.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** String label text. */
	labelText: PropTypes.string.isRequired,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func
};

StandaloneCheckbox.defaultProps = {
	hasError: false
};

var main$b = "AccountNumberInput.js";
var packageJson$b = {
	main: main$b,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$h = taggedTemplateLiteral(['\n\tinput[type=\'number\'] {\n\t\t-moz-appearance: textfield;\n\t}\n\tinput[type=\'number\']::-webkit-inner-spin-button,\n\tinput[type=\'number\']::-webkit-outer-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n'], ['\n\tinput[type=\'number\'] {\n\t\t-moz-appearance: textfield;\n\t}\n\tinput[type=\'number\']::-webkit-inner-spin-button,\n\tinput[type=\'number\']::-webkit-outer-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n']),
    _templateObject2$8 = taggedTemplateLiteral(['\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\twidth: 9rem;\n\ttext-align: left;\n\n\t', '};\n'], ['\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\twidth: 9rem;\n\ttext-align: left;\n\n\t', '};\n']);

var StyledAccountInput = styled('div')(_templateObject$h);

var StyledInput = styled('input')(_templateObject2$8, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.isCompact ? '12px' : '16px';
}, spacing.SEXTUPLE, spacing.SINGLE, function (props) {
	return props.hasError && 'border: ' + props.theme.borderWidth + ' solid ' + colours.utility.error;
});

var validationReasons = {
	INVALID: 'INVALID',
	BELOW_MIN: 'BELOW_MIN',
	ABOVE_MAX: 'ABOVE_MAX'
};

var AccountNumberInput = function (_Component) {
	inherits(AccountNumberInput, _Component);

	function AccountNumberInput(props) {
		classCallCheck(this, AccountNumberInput);

		var _this = possibleConstructorReturn(this, (AccountNumberInput.__proto__ || Object.getPrototypeOf(AccountNumberInput)).call(this, props));

		var value = _this.props.value;


		_this.state = {
			value: value,
			hasValidationError: false
		};

		_this.setAccountNumber = _this.setAccountNumber.bind(_this);
		_this.validateInputLength = _this.validateInputLength.bind(_this);
		return _this;
	}

	createClass(AccountNumberInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'setAccountNumber',
		value: function setAccountNumber(_ref) {
			var target = _ref.target;
			var value = target.value;
			var onChange = this.props.onChange;


			var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

			for (var i = 0; i < value.length; i += 1) {
				if (!numbers.includes(value.charAt(i))) {
					return;
				}
			}

			var _validateInputLength = this.validateInputLength(value),
			    hasValidationError = _validateInputLength.hasValidationError,
			    validationErrorReason = _validateInputLength.validationErrorReason;

			this.setState({
				value: value,
				hasValidationError: hasValidationError
			}, function () {
				onChange({
					value: value,
					validationErrorReason: validationErrorReason
				});
			});
		}
	}, {
		key: 'validateInputLength',
		value: function validateInputLength(inputValue) {
			var length = inputValue.length;
			var _props = this.props,
			    minLength = _props.minLength,
			    maxLength = _props.maxLength;


			if (length < minLength) {
				return {
					hasValidationError: true,
					validationErrorReason: validationReasons.BELOW_MIN
				};
			}

			if (length > maxLength) {
				return {
					hasValidationError: true,
					validationErrorReason: validationReasons.ABOVE_MAX
				};
			}

			return {
				hasValidationError: false,
				validationErrorReason: null
			};
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props2 = this.props,
			    hasValidationEnabled = _props2.hasValidationEnabled,
			    id = _props2.id,
			    innerRef = _props2.innerRef,
			    maxLength = _props2.maxLength,
			    onBlur = _props2.onBlur,
			    onFocus = _props2.onFocus;
			var _state = this.state,
			    value = _state.value,
			    hasValidationError = _state.hasValidationError;


			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$b },
				React.createElement(
					StyledAccountInput,
					null,
					React.createElement(StyledInput, {
						id: id,
						innerRef: function innerRef(element) {
							_this2.refInput = element;
						},
						inputMode: 'numeric',
						maxLength: maxLength,
						name: id,
						onBlur: onBlur,
						onChange: function onChange(event) {
							return _this2.setAccountNumber(event);
						},
						onFocus: onFocus,
						pattern: '[0-9]*',
						type: 'text',
						value: value,
						hasError: hasValidationError && hasValidationEnabled
					})
				)
			);
		}
	}]);
	return AccountNumberInput;
}(Component);

AccountNumberInput.propTypes = {
	/** The id of the component. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** Maximum account number length. */
	maxLength: PropTypes.number,
	/** Minimum account number length. */
	minLength: PropTypes.number,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Account number string value. */
	value: PropTypes.string
};

AccountNumberInput.defaultProps = {
	hasValidationEnabled: false,
	maxLength: 11,
	minLength: 6
};

var _templateObject$i = taggedTemplateLiteral(['\n\t', ';\n\tdisplay: inline-block;\n\tfont-family: ', ';\n\tmargin-bottom: ', ';\n'], ['\n\t', ';\n\tdisplay: inline-block;\n\tfont-family: ', ';\n\tmargin-bottom: ', ';\n']);

var StyledControlLabel = styled('label')(_templateObject$i, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.uist();
}, function (props) {
	return props.theme.fonts.subLabel;
}, spacing.HALF);

/**
 * @example ./Design.md
 */
var InternalControlLabel = function InternalControlLabel(_ref) {
	var children = _ref.children,
	    htmlFor = _ref.htmlFor;
	return React.createElement(
		StyledControlLabel,
		{ htmlFor: htmlFor },
		children
	);
};

InternalControlLabel.propTypes = {
	/** Child content. */
	children: PropTypes.node.isRequired,
	/** For attribute to connect with input. */
	htmlFor: PropTypes.string.isRequired
};

InternalControlLabel.defaultProps = {
	isFlush: false
};

var main$c = "DateOfBirthInput.js";
var packageJson$c = {
	main: main$c,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$j = taggedTemplateLiteral(['\n\tdisplay: flex;\n'], ['\n\tdisplay: flex;\n']),
    _templateObject2$9 = taggedTemplateLiteral(['\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\twidth: 100%;\n\ttext-align: center;\n\n\t&.error {\n\t\tborder: ', ';\n\t}\n'], ['\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\twidth: 100%;\n\ttext-align: center;\n\n\t&.error {\n\t\tborder: ', ';\n\t}\n']),
    _templateObject3$5 = taggedTemplateLiteral(['\n\twidth: 50px;\n\tmargin-right: 16px;\n'], ['\n\twidth: 50px;\n\tmargin-right: 16px;\n']),
    _templateObject4$4 = taggedTemplateLiteral(['\n\twidth: 80px;\n'], ['\n\twidth: 80px;\n']);

var StyledDOBInput = styled('div')(_templateObject$j);

var StyledInput$1 = styled('input')(_templateObject2$9, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.isCompact ? '12px' : '16px';
}, spacing.SEXTUPLE, spacing.SINGLE, function (props) {
	return props.theme.borderWidth + ' solid ' + colours.utility.error;
});

var StyledDayInput = styled('div')(_templateObject3$5);

var StyledMonthInput = styled('div')(_templateObject3$5);

var StyledYearInput = styled('div')(_templateObject4$4);

//TODOxVM: All the code below is utter trash. Will need to fix alongside introduction of proper behaviour testing.

var ZERO_TO_NINE = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
var ONE_TO_NINE = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
var ZERO_TO_ONE = ['0', '1'];
var ZERO_TO_TWO = ['0', '1', '2'];
var ONE_TO_TWO = ['1', '2'];
var NINE_ONLY = ['9'];

var validationReasons$1 = {
	INVALID_DATE: 'INVALID_DATE',
	BELOW_MIN: 'BELOW_MIN',
	ABOVE_MAX: 'ABOVE_MAX'
};

var checkIsValidDayValue = function checkIsValidDayValue(value) {
	var getValidDaySecondDigits = function getValidDaySecondDigits(number) {
		switch (number) {
			case '0':
				return ONE_TO_NINE;
			case '1':
			case '2':
				return ZERO_TO_NINE;
			case '3':
				return ZERO_TO_ONE;
			default:
				return [];
		}
	};

	if (value.length === 1) {
		return ZERO_TO_NINE.includes(value);
	} else if (value.length === 2) {
		var _value$split = value.split(''),
		    _value$split2 = slicedToArray(_value$split, 2),
		    firstDigit = _value$split2[0],
		    secondDigit = _value$split2[1];

		var validSecondDigits = getValidDaySecondDigits(firstDigit);
		return validSecondDigits.includes(secondDigit);
	}

	return false;
};

var checkIsValidMonthValue = function checkIsValidMonthValue(value) {
	var getValidMonthSecondDigits = function getValidMonthSecondDigits(number) {
		switch (number) {
			case '0':
				return ONE_TO_NINE;
			case '1':
				return ZERO_TO_TWO;
			default:
				return [];
		}
	};

	if (value.length === 1) {
		return ZERO_TO_NINE.includes(value);
	} else if (value.length === 2) {
		var _value$split3 = value.split(''),
		    _value$split4 = slicedToArray(_value$split3, 2),
		    firstDigit = _value$split4[0],
		    secondDigit = _value$split4[1];

		var validSecondDigits = getValidMonthSecondDigits(firstDigit);
		return validSecondDigits.includes(secondDigit);
	}

	return false;
};

var checkIsValidYearValue = function checkIsValidYearValue(value) {
	var THIRD_DIGIT = 3;
	var FOURTH_DIGIT = 4;

	var getValidYearSecondDigits = function getValidYearSecondDigits(number) {
		switch (number) {
			case '1':
				return NINE_ONLY;
			case '2':
				return ZERO_TO_NINE;
			default:
				return [];
		}
	};

	if (value.length === 1) {
		return ONE_TO_TWO.includes(value);
	} else if (value.length === 2) {
		var _value$split5 = value.split(''),
		    _value$split6 = slicedToArray(_value$split5, 2),
		    firstDigit = _value$split6[0],
		    secondDigit = _value$split6[1];

		var validSecondDigits = getValidYearSecondDigits(firstDigit);
		return validSecondDigits.includes(secondDigit);
	} else if (value.length === THIRD_DIGIT) {
		var _value$split7 = value.split(''),
		    _value$split8 = slicedToArray(_value$split7, 3),
		    _firstDigit = _value$split8[0],
		    _secondDigit = _value$split8[1],
		    thirdDigit = _value$split8[2];

		return ZERO_TO_NINE.includes(thirdDigit);
	} else if (value.length === FOURTH_DIGIT) {
		var _value$split9 = value.split(''),
		    _value$split10 = slicedToArray(_value$split9, 4),
		    _firstDigit2 = _value$split10[0],
		    _secondDigit2 = _value$split10[1],
		    _thirdDigit = _value$split10[2],
		    fourthDigit = _value$split10[3];

		return ZERO_TO_NINE.includes(fourthDigit);
	}

	return false;
};

var stripLastDigit = function stripLastDigit(value) {
	return value.slice(0, value.length - 1);
};

var limitInputForDay = function limitInputForDay(event) {
	var value = event.target.value;


	if (!checkIsValidDayValue(value)) {
		event.target.value = stripLastDigit(value);
	}
};

var limitInputForMonth = function limitInputForMonth(event) {
	var value = event.target.value;


	if (!checkIsValidMonthValue(value)) {
		event.target.value = stripLastDigit(value);
	}
};

var limitInputForYear = function limitInputForYear(event) {
	var value = event.target.value;


	if (!checkIsValidYearValue(value)) {
		event.target.value = stripLastDigit(value);
	}
};

var checkAgeRange = function checkAgeRange(dateObj, minAge, maxAge) {
	// Make moment date (accounting for 0 indexed month)
	var dob = moment({ year: dateObj.year, month: dateObj.month - 1, day: dateObj.day });
	// valid return object
	var returnObj = {
		validationErrorReason: null,
		value: dob.toDate()
	};

	// Calc min / max dates
	var minDate = moment().subtract(minAge, 'years');
	var maxDate = dob.clone().add(maxAge + 1, 'years');

	// Check if dob is below minimum
	if (dob.isAfter(minDate)) {
		returnObj = {
			validationErrorReason: validationReasons$1.BELOW_MIN,
			value: dob.toDate()
		};
	}

	// Check if todays date is after dob + maxAge (+ 1) -- takes into account next birthday
	if (moment().isAfter(maxDate)) {
		returnObj = {
			validationErrorReason: validationReasons$1.ABOVE_MAX,
			value: dob.toDate()
		};
	}

	return returnObj;
};

var checkDateIsInvalid = function checkDateIsInvalid(dateObj) {
	var MAX_YEAR_LENGTH = 4;
	if (dateObj.day === '' || dateObj.month === '' || dateObj.year.length < MAX_YEAR_LENGTH) {
		return true;
	}

	var checkDate = moment({ year: dateObj.year, month: dateObj.month - 1, day: dateObj.day });
	return moment(checkDate).isValid() === false;
};

var DateOfBirthInput = function (_Component) {
	inherits(DateOfBirthInput, _Component);

	function DateOfBirthInput(props) {
		classCallCheck(this, DateOfBirthInput);

		var _this = possibleConstructorReturn(this, (DateOfBirthInput.__proto__ || Object.getPrototypeOf(DateOfBirthInput)).call(this, props));

		if (_this.props.value === null) {
			_this.state = {
				day: '',
				month: '',
				year: '',
				hasError: false
			};
		} else {
			var date = _this.props.value;
			_this.state = {
				day: date.getDate(),
				month: date.getMonth() + 1,
				year: date.getFullYear(),
				hasError: false
			};
		}

		_this.setDay = _this.setDay.bind(_this);
		_this.setMonth = _this.setMonth.bind(_this);
		_this.setYear = _this.setYear.bind(_this);
		return _this;
	}

	createClass(DateOfBirthInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'setDay',
		value: function setDay(event) {
			var value = event.target.value;
			var _state = this.state,
			    month = _state.month,
			    year = _state.year;


			var dateObj = {
				day: value,
				month: month,
				year: year
			};

			this.updateDate(dateObj);
		}
	}, {
		key: 'setMonth',
		value: function setMonth(event) {
			var value = event.target.value;
			var _state2 = this.state,
			    day = _state2.day,
			    year = _state2.year;


			var dateObj = {
				day: day,
				month: value,
				year: year
			};

			this.updateDate(dateObj);
		}
	}, {
		key: 'setYear',
		value: function setYear(event) {
			var value = event.target.value;
			var _state3 = this.state,
			    day = _state3.day,
			    month = _state3.month;


			var dateObj = {
				day: day,
				month: month,
				year: value
			};

			this.updateDate(dateObj);
		}
	}, {
		key: 'updateDate',
		value: function updateDate(dateObj) {
			var returnObj = {};
			var dateIsValid = true;
			var hasError = this.state.hasError;


			if (checkDateIsInvalid(dateObj)) {
				dateIsValid = false;
				hasError = true;
			}

			if (dateIsValid) {
				returnObj = checkAgeRange(dateObj, this.props.minAge, this.props.maxAge);
				if (returnObj.validationErrorReason === null) {
					hasError = false;
				}
			} else {
				returnObj = {
					validationErrorReason: validationReasons$1.INVALID_DATE,
					value: null
				};
			}

			this.props.onChange(returnObj);
			this.setState(_extends({}, dateObj, { hasError: hasError }));
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    hasValidationEnabled = _props.hasValidationEnabled,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    onBlur = _props.onBlur,
			    onFocus = _props.onFocus;


			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$c },
				React.createElement(
					StyledDOBInput,
					null,
					React.createElement(
						StyledDayInput,
						null,
						React.createElement(
							InternalControlLabel,
							{ htmlFor: id + '-day' },
							'Day'
						),
						React.createElement(StyledInput$1, {
							autoComplete: 'bday-day',
							className: this.state.hasError && hasValidationEnabled ? 'error' : '',
							id: id + '-day',
							innerRef: function innerRef(element) {
								_this2.refInput = element;
							},
							inputMode: 'numeric',
							max: 31,
							maxLength: 2,
							min: 1,
							name: id + '-day',
							onChange: this.setDay,
							onFocus: onFocus,
							onInput: function onInput(e) {
								return limitInputForDay(e);
							},
							size: 2,
							pattern: '[0-9]*',
							type: 'text',
							value: this.state.day
						})
					),
					React.createElement(
						StyledMonthInput,
						null,
						React.createElement(
							InternalControlLabel,
							{ htmlFor: id + '-month' },
							'Month'
						),
						React.createElement(StyledInput$1, {
							autoComplete: 'bday-month',
							className: this.state.hasError && hasValidationEnabled ? 'error' : '',
							id: id + '-month',
							inputMode: 'numeric',
							max: 12,
							maxLength: 2,
							min: 1,
							name: id + '-month',
							onChange: this.setMonth,
							onInput: function onInput(e) {
								return limitInputForMonth(e);
							},
							pattern: '[0-9]*',
							size: 2,
							type: 'text',
							value: this.state.month
						})
					),
					React.createElement(
						StyledYearInput,
						null,
						React.createElement(
							InternalControlLabel,
							{ htmlFor: id + '-year' },
							'Year'
						),
						React.createElement(StyledInput$1, {
							autoComplete: 'bday-year',
							className: this.state.hasError && hasValidationEnabled ? 'error' : '',
							id: id + '-year',
							inputMode: 'numeric',
							maxLength: 4,
							min: 1900,
							name: id + '-year',
							onBlur: onBlur,
							onChange: this.setYear,
							onInput: function onInput(e) {
								return limitInputForYear(e);
							},
							pattern: '[0-9]*',
							size: 4,
							type: 'text',
							value: this.state.year
						})
					)
				)
			);
		}
	}]);
	return DateOfBirthInput;
}(Component);

DateOfBirthInput.propTypes = {
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** The id of the component. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Sets the maximum age used in validation. */
	maxAge: PropTypes.number,
	/** Sets the minimim age used in validation. */
	minAge: PropTypes.number,
	/** Callback function triggered on blur of the 'Year' input. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus of the 'Day' input. */
	onFocus: PropTypes.func,
	/** Sets the date (JS date object). */
	value: PropTypes.instanceOf(Date)
};

DateOfBirthInput.defaultProps = {
	hasValidationEnabled: false,
	maxAge: 120,
	minAge: 18
};

var main$d = "FileUploadInput.js";
var packageJson$d = {
	main: main$d,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$k = taggedTemplateLiteral(['\n\tbackground: ', ';\n\tdisplay: inline-flex;\n\tflex-basis: 100%;\n\n\tdiv {\n\t\twidth: 100%;\n\t}\n\n\t@media (min-width: ', ') {\n\t\tflex-wrap: nowrap;\n\t\theight: 48px;\n\t}\n\n\tlabel {\n\t\tposition: relative;\n\n\t\tspan {\n\t\t\talign-items: center;\n\t\t\tbackground: ', ';\n\t\t\t', '\n\t\t\tborder-radius: ', ';\n\t\t\tbox-sizing: border-box;\n\t\t\tcolor: ', ';\n\t\t\tcursor: pointer;\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\theight: 48px;\n\t\t\tpadding: ', ' ', ';;\n\t\t\tposition: relative;\n\t\t\ttext-align: center;\n\t\t\ttext-decoration: none;\n\t\t\ttransition: background 0.3s;\n\t\t\tuser-select: none;\n\t\t\twhite-space: nowrap;\n\t\t\tvertical-align: middle;\n\n\t\t\t:hover {\n\t\t\t\tbackground-color: ', ';\n\t\t\t\tborder-color: ', ';\n\t\t\t\tcolor: ', ';\n\t\t\t}\n\t\t}\n\t}\n\n\tinput[type="file"] {\n\t\tborder-radius: ', ';\n\t\theight: 100%;\n\t\tleft: 0;\n\t\topacity: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 100%;\n\n\t\t:focus {\n\t\t\t~ span {\n\t\t\t\toutline-color: ', ';\n\t\t\t\toutline-style: auto;\n\t\t\t\toutline-width: 5px;\n\t\t\t}\n\t\t}\n\t}\n\n\t> div {\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\tcolor: ', ';\n\t\tdirection: rtl;\n\t\tdisplay: flex;\n\t\tflex-basis: 100%;\n\t\theight: 48px;\n\t\tmax-width: 100%;\n\t\tpadding: 0 ', ';\n\n\t\t@media (min-width: ', ') {\n\t\t\tflex-basis: auto;\n\t\t\tmax-width: 300px;\n\t\t}\n\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\tmargin-right: auto;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\twhite-space: nowrap;\n\t\t}\n\t}\n'], ['\n\tbackground: ', ';\n\tdisplay: inline-flex;\n\tflex-basis: 100%;\n\n\tdiv {\n\t\twidth: 100%;\n\t}\n\n\t@media (min-width: ', ') {\n\t\tflex-wrap: nowrap;\n\t\theight: 48px;\n\t}\n\n\tlabel {\n\t\tposition: relative;\n\n\t\tspan {\n\t\t\talign-items: center;\n\t\t\tbackground: ', ';\n\t\t\t', '\n\t\t\tborder-radius: ', ';\n\t\t\tbox-sizing: border-box;\n\t\t\tcolor: ', ';\n\t\t\tcursor: pointer;\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\theight: 48px;\n\t\t\tpadding: ', ' ', ';;\n\t\t\tposition: relative;\n\t\t\ttext-align: center;\n\t\t\ttext-decoration: none;\n\t\t\ttransition: background 0.3s;\n\t\t\tuser-select: none;\n\t\t\twhite-space: nowrap;\n\t\t\tvertical-align: middle;\n\n\t\t\t:hover {\n\t\t\t\tbackground-color: ', ';\n\t\t\t\tborder-color: ', ';\n\t\t\t\tcolor: ', ';\n\t\t\t}\n\t\t}\n\t}\n\n\tinput[type="file"] {\n\t\tborder-radius: ', ';\n\t\theight: 100%;\n\t\tleft: 0;\n\t\topacity: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 100%;\n\n\t\t:focus {\n\t\t\t~ span {\n\t\t\t\toutline-color: ', ';\n\t\t\t\toutline-style: auto;\n\t\t\t\toutline-width: 5px;\n\t\t\t}\n\t\t}\n\t}\n\n\t> div {\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\tcolor: ', ';\n\t\tdirection: rtl;\n\t\tdisplay: flex;\n\t\tflex-basis: 100%;\n\t\theight: 48px;\n\t\tmax-width: 100%;\n\t\tpadding: 0 ', ';\n\n\t\t@media (min-width: ', ') {\n\t\t\tflex-basis: auto;\n\t\t\tmax-width: 300px;\n\t\t}\n\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\tmargin-right: auto;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\twhite-space: nowrap;\n\t\t}\n\t}\n']);

var StyledWrapper$3 = styled('div')(_templateObject$k, colours.component.background, breakpoints.sm1, function (props) {
	return props.hasFilename ? colours.generalPalette.white : props.theme.colours.interaction;
}, function (props) {
	return props.hasFilename && 'border: 2px solid ' + props.theme.colours.interaction + ';';
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.hasFilename ? props.theme.colours.interaction : colours.generalPalette.white;
}, spacing.HALF, spacing.DOUBLE, function (props) {
	return props.hasFilename ? props.theme.colours.interaction : props.theme.colours.interactionAccent;
}, function (props) {
	return props.hasFilename ? props.theme.colours.interaction : props.theme.colours.interactionAccent;
}, colours.generalPalette.white, function (props) {
	return props.theme.borderRadius;
}, colours.component.focusOutline, colours.generalPalette.black, spacing.DOUBLE, breakpoints.sm1);

var fileChangeHandler = function fileChangeHandler(event, onChange) {
	var _event$target = event.target,
	    files = _event$target.files,
	    value = _event$target.value;

	onChange(files, value);
	// eslint-disable-next-line no-param-reassign
	event.target.value = '';
};

var FileUploadInput = function FileUploadInput(_ref) {
	var acceptedFormats = _ref.acceptedFormats,
	    allowMultiple = _ref.allowMultiple,
	    filename = _ref.filename,
	    id = _ref.id,
	    labelText = _ref.labelText,
	    _onChange = _ref.onChange,
	    dataTestId = _ref['data-test-id'];

	var hasFilename = !!filename;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$d },
		React.createElement(
			StyledWrapper$3,
			{ hasFilename: hasFilename, 'data-test-id': dataTestId + '-wrapper' },
			React.createElement(
				'label',
				{ htmlFor: id },
				React.createElement('input', {
					accept: acceptedFormats,
					id: id,
					'data-test-id': dataTestId + '-input',
					multiple: allowMultiple,
					onChange: function onChange(event) {
						return fileChangeHandler(event, _onChange);
					},
					type: 'file'
				}),
				React.createElement(
					'span',
					null,
					labelText
				)
			),
			hasFilename ? React.createElement(
				StandardLabel,
				{ isFlush: true, 'data-test-id': dataTestId + '-filename' },
				React.createElement(
					'span',
					null,
					filename
				)
			) : React.createElement(
				StandardBody,
				{ isFlush: true, 'data-test-id': dataTestId + '-nofile' },
				React.createElement(
					'span',
					null,
					'No file chosen'
				)
			)
		)
	);
};

FileUploadInput.propTypes = {
	/** A comma-separated list of accepted file formats to permit for uploading (e.g. '.txt, .csv'). */
	acceptedFormats: PropTypes.string.isRequired,
	/** Set to true to allow the user to upload multiple files instad of a single file. */
	allowMultiple: PropTypes.bool,
	/** The displayed file name. Only shown when filename is not an empty string, null or undefined. */
	filename: PropTypes.string.isRequired,
	/** A unique ID used to identify the control within the DOM. */
	id: PropTypes.string.isRequired,
	/** File selection text displayed on the choose button. */
	labelText: PropTypes.string,
	/** Callback function triggered on change.
  * Called with two parameters: A file list of selected files and the filename of the first selected file.
  */
	onChange: PropTypes.func.isRequired,
	/** Partial Data attribute targeting accountCard for automation test purposes - appended by -wrapper, -input and -filename. */
	'data-test-id': PropTypes.string
};

FileUploadInput.defaultProps = {
	allowMultiple: false,
	labelText: 'Choose file',
	'data-test-id': 'file-upload-input'
};

var MAX_CHAR_WIDTH = 0.6725;
var INITIAL_PADDING = 2;
var ICON_WIDTH_IN_REM = 3;
var PADDING_WITH_ICON = INITIAL_PADDING + ICON_WIDTH_IN_REM;

var getInputWidth = function getInputWidth(characters, borderWidth, hasIcon) {
	var PADDING = hasIcon ? PADDING_WITH_ICON : INITIAL_PADDING;

	if (!characters) {
		return '375px';
	}

	return parseInt(characters) * MAX_CHAR_WIDTH + PADDING + parseFloat(borderWidth) + 'rem';
};

var _templateObject$l = taggedTemplateLiteral(['\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\theight: ', ';\n\tmax-width: 100%;\n\tpadding: ', ';\n\twidth: ', ';\n\t', '};\n'], ['\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\theight: ', ';\n\tmax-width: 100%;\n\tpadding: ', ';\n\twidth: ', ';\n\t', '};\n']);

var StyledInput$2 = styled('input')(_templateObject$l, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.isCompact ? '12px' : '16px';
}, spacing.SEXTUPLE, spacing.DOUBLE, function (props) {
	return getInputWidth(props.characterCount, props.theme.borderWidth);
}, function (props) {
	return props.hasValidationError && props.hasValidationEnabled && 'border: ' + props.theme.borderWidth + ' solid ' + colours.utility.error;
});

var validationErrorReasons = {
	BELOW_MIN: 'BELOW_MIN',
	ABOVE_MAX: 'ABOVE_MAX'
};

var validateMinMax = function validateMinMax(val, min, max) {
	var length = val.length;


	if (!!min && length < min) {
		return validationErrorReasons.BELOW_MIN;
	}

	if (!!max && length > max) {
		return validationErrorReasons.ABOVE_MAX;
	}

	return '';
};

var getNormalisedValue = function getNormalisedValue(value) {
	return value === null || value === undefined ? '' : value;
};

var onChangeHandler = function onChangeHandler(onChange, minLength, maxLength) {
	return function (_ref) {
		var target = _ref.target;

		var normaliseValue = getNormalisedValue(target.value);
		var validationErrorReason = validateMinMax(normaliseValue, minLength, maxLength);

		onChange({
			validationErrorReason: validationErrorReason,
			value: normaliseValue
		});
	};
};

var BaseTextInput = function (_Component) {
	inherits(BaseTextInput, _Component);

	function BaseTextInput(props) {
		classCallCheck(this, BaseTextInput);

		var _this = possibleConstructorReturn(this, (BaseTextInput.__proto__ || Object.getPrototypeOf(BaseTextInput)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(BaseTextInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    characterCount = _props.characterCount,
			    hasValidationEnabled = _props.hasValidationEnabled,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    inputMode = _props.inputMode,
			    maxLength = _props.maxLength,
			    minLength = _props.minLength,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    value = _props.value,
			    type = _props.type,
			    rest = objectWithoutProperties(_props, ['characterCount', 'hasValidationEnabled', 'id', 'innerRef', 'inputMode', 'maxLength', 'minLength', 'onBlur', 'onChange', 'onFocus', 'value', 'type']);


			var normaliseValue = getNormalisedValue(value);
			var validationErrorReason = validateMinMax(normaliseValue, minLength, maxLength);

			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(StyledInput$2, _extends({
				characterCount: characterCount,
				hasValidationEnabled: hasValidationEnabled,
				hasValidationError: !!validationErrorReason,
				id: id,
				innerRef: function innerRef(element) {
					_this2.refInput = element;
				},
				inputMode: inputMode,
				onBlur: onBlur,
				onChange: onChangeHandler(onChange, minLength, maxLength),
				onFocus: onFocus,
				type: type,
				value: normaliseValue
			}, rest));
		}
	}]);
	return BaseTextInput;
}(Component);

BaseTextInput.propTypes = {
	/** Character count to be used for display width of the input. */
	characterCount: PropTypes.number,
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** An is for the component. */
	id: PropTypes.string,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** The input mode - triggers a particular onscreen keyboard on mobile */
	inputMode: PropTypes.oneOf(['tel', 'url', 'email', 'search']),
	/** The maximum character length of the input. */
	maxLength: PropTypes.number,
	/** The minimum character length of the input. */
	minLength: PropTypes.number,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** The value of the input */
	value: PropTypes.string,
	/** The input type */
	type: PropTypes.oneOf(['text', 'tel', 'search', 'password']).isRequired
};

BaseTextInput.defaultProps = {};

BaseTextInput.validationLiterals = _extends({ WHEN_VALID: '' }, validationErrorReasons);

var InternalStandardTextInput = function InternalStandardTextInput(_ref) {
	var characterCount = _ref.characterCount,
	    dataTestId = _ref['data-test-id'],
	    hasValidationEnabled = _ref.hasValidationEnabled,
	    id = _ref.id,
	    innerRef = _ref.innerRef,
	    onBlur = _ref.onBlur,
	    onChange = _ref.onChange,
	    onFocus = _ref.onFocus,
	    maxLength = _ref.maxLength,
	    minLength = _ref.minLength,
	    value = _ref.value;

	return React.createElement(BaseTextInput, {
		characterCount: characterCount,
		'data-test-id': dataTestId,
		hasValidationEnabled: hasValidationEnabled,
		id: id,
		innerRef: innerRef,
		maxLength: maxLength,
		minLength: minLength,
		onBlur: onBlur,
		onChange: onChange,
		onFocus: onFocus,
		type: 'text',
		value: value
	});
};

InternalStandardTextInput.propTypes = {
	/** Character count to be used for display width of the input. */
	characterCount: PropTypes.number,
	/** Partial Data attribute targeting select for automation test purposes. */
	'data-test-id': PropTypes.string,
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool, // TODOxVMUI fix this to be required, because it is.
	/** An is for the component. */
	id: PropTypes.string,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** The maximum character length of the input. **/
	maxLength: PropTypes.number,
	/** The minimum character length of the input. */
	minLength: PropTypes.number,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** The value of the input */
	value: PropTypes.string
};

InternalStandardTextInput.defaultProps = {
	hasValidationEnabled: false,
	'data-test-id': 'internal-standard-text-input'
};

InternalStandardTextInput.validationLiterals = BaseTextInput.validationLiterals;

var main$e = "GenericAlphaNumericInput.js";
var packageJson$e = {
	main: main$e,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var GenericAlphaNumericInput = function GenericAlphaNumericInput(_ref) {
	var characterCount = _ref.characterCount,
	    hasValidationEnabled = _ref.hasValidationEnabled,
	    innerRef = _ref.innerRef,
	    maxLength = _ref.maxLength,
	    minLength = _ref.minLength,
	    onBlur = _ref.onBlur,
	    onChange = _ref.onChange,
	    onFocus = _ref.onFocus,
	    id = _ref.id,
	    value = _ref.value;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$e, layout: 'inline-block' },
		React.createElement(InternalStandardTextInput, {
			characterCount: characterCount,
			hasValidationEnabled: hasValidationEnabled,
			id: id,
			innerRef: innerRef,
			maxLength: maxLength,
			minLength: minLength,
			onBlur: onBlur,
			onChange: onChange,
			onFocus: onFocus,
			type: 'text',
			value: value
		})
	);
};

GenericAlphaNumericInput.propTypes = {
	/** Character count as number, controls the input width. */
	characterCount: PropTypes.number,
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** The maximum character length of the input. **/
	maxLength: PropTypes.number,
	/** The minimum character length of the input. */
	minLength: PropTypes.number,
	/** Sets the ID attribute on the component, needed to attach it to an associated label in the DOM. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** The value of the input. */
	value: PropTypes.string
};

GenericAlphaNumericInput.defaultProps = {
	hasValidationEnabled: false
};

GenericAlphaNumericInput.validationLiterals = InternalStandardTextInput.validationLiterals;

var _templateObject$m = taggedTemplateLiteral(['\n\tdisplay: flex;\n\talign-items: stretch;\n'], ['\n\tdisplay: flex;\n\talign-items: stretch;\n']),
    _templateObject2$a = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder: ', ';\n\tcolor: ', ';\n\t', ' text-align: center;\n\tjustify-content: center;\n\tmin-width: 48px;\n\tdisplay: flex;\n\n\tspan {\n\t\talign-self: center;\n\t}\n'], ['\n\tbackground-color: ', ';\n\tborder: ', ';\n\tcolor: ', ';\n\t', ' text-align: center;\n\tjustify-content: center;\n\tmin-width: 48px;\n\tdisplay: flex;\n\n\tspan {\n\t\talign-self: center;\n\t}\n']),
    _templateObject3$6 = taggedTemplateLiteral(['\n\tborder-radius: ', ' 0 0 ', ';\n\tborder-right-width: 0;\n'], ['\n\tborder-radius: ', ' 0 0 ', ';\n\tborder-right-width: 0;\n']),
    _templateObject4$5 = taggedTemplateLiteral(['\n\tborder-radius: 0 ', ' ', ' 0;\n\tborder-left-width: 0;\n'], ['\n\tborder-radius: 0 ', ' ', ' 0;\n\tborder-left-width: 0;\n']),
    _templateObject5$3 = taggedTemplateLiteral(['\n\tborder: ', ';\n\t', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\theight: ', ';\n\tpadding: ', ';\n\tposition: relative;\n\twidth: ', ';\n\n\t-moz-appearance: textfield;\n\n\t&::-webkit-outer-spin-button, &::-webkit-inner-spin-button {\n    \t-webkit-appearance: none;\n    \tmargin: 0;\n\t}\n}\n'], ['\n\tborder: ', ';\n\t', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\theight: ', ';\n\tpadding: ', ';\n\tposition: relative;\n\twidth: ', ';\n\n\t-moz-appearance: textfield;\n\n\t&::-webkit-outer-spin-button, &::-webkit-inner-spin-button {\n    \t-webkit-appearance: none;\n    \tmargin: 0;\n\t}\n}\n']);

var StyledWrapper$4 = styled('div')(_templateObject$m);

var StyledAnnotation = styled('div')(_templateObject2$a, colours.component.background, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, function (props) {
	return props.theme.colours.interaction;
}, function (props) {
	return props.theme.isCompact ? useFontSize.of.jura() : useFontSize.of.arran();
});

var StyledPrefix = styled(StyledAnnotation)(_templateObject3$6, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.borderRadius;
});

var StyledSuffix = styled(StyledAnnotation)(_templateObject4$5, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.borderRadius;
});

var getRadius = function getRadius(hasPrefix, hasSuffix, borderRadius) {
	if (!hasPrefix && !hasSuffix) {
		return 'border-radius: ' + borderRadius;
	}

	var leftCorners = hasPrefix ? 'border-top-left-radius: 0; border-bottom-left-radius: 0;' : 'border-top-left-radius: ' + borderRadius + '; border-bottom-left-radius: ' + borderRadius + ';';

	var rightCorners = hasSuffix ? 'border-top-right-radius: 0; border-bottom-right-radius: 0;' : 'border-top-right-radius: ' + borderRadius + '; border-bottom-right-radius: ' + borderRadius + ';';

	return leftCorners + rightCorners;
};

var StyledInput$3 = styled('input')(_templateObject5$3, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, function (_ref) {
	var hasPrefix = _ref.hasPrefix,
	    hasSuffix = _ref.hasSuffix,
	    theme = _ref.theme;
	return getRadius(hasPrefix, hasSuffix, theme.borderRadius);
}, function (props) {
	return props.theme.isCompact ? '12px' : '16px';
}, spacing.SEXTUPLE, spacing.DOUBLE, function (props) {
	return getInputWidth(props.characterCount, props.theme.borderWidth);
});

var E = 69;
var NUMPAD_PERIOD = 110;
var PERIOD = 190;
var NUMPAD_PLUS = 107;
var PLUS = 187;
// const NUMPAD_MINUS = 109, MINUS = 189;

var keyHandler = function keyHandler(allowDecimal) {
	return function (event) {
		var keyCode = event.keyCode;


		var isUndesiredNumericKey = [E, NUMPAD_PLUS, PLUS].some(function (x) {
			return x === keyCode;
		});

		if (isUndesiredNumericKey) {
			event.preventDefault();
			event.stopPropagation();
		}

		if (allowDecimal) {
			return;
		}

		var isPeriodKey = [NUMPAD_PERIOD, PERIOD].some(function (x) {
			return x === keyCode;
		});

		if (isPeriodKey) {
			event.preventDefault();
			event.stopPropagation();
		}
	};
};

var onChangeHandler$1 = function onChangeHandler(_ref2, onChange) {
	var target = _ref2.target;
	var value = target.value;

	onChange({
		value: value
	});
};

var BaseNumberInput = function (_Component) {
	inherits(BaseNumberInput, _Component);

	function BaseNumberInput(props) {
		classCallCheck(this, BaseNumberInput);

		var _this = possibleConstructorReturn(this, (BaseNumberInput.__proto__ || Object.getPrototypeOf(BaseNumberInput)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(BaseNumberInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    characterCount = _props.characterCount,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    inputMode = _props.inputMode,
			    onBlur = _props.onBlur,
			    _onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    symbolPrefix = _props.symbolPrefix,
			    symbolSuffix = _props.symbolSuffix,
			    value = _props.value,
			    dataTestId = _props['data-test-id'];


			var hasPrefix = !!symbolPrefix;
			var hasSuffix = !!symbolSuffix;

			var normalisedValue = value === null || undefined ? '' : value; //TODOxVM: Extract normaliser functions.
			var allowDecimal = inputMode === 'decimal';

			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				StyledWrapper$4,
				null,
				hasPrefix && React.createElement(
					StyledPrefix,
					null,
					React.createElement(
						'span',
						null,
						symbolPrefix
					)
				),
				React.createElement(StyledInput$3, {
					characterCount: characterCount,
					hasPrefix: hasPrefix,
					hasSuffix: hasSuffix,
					id: id,
					innerRef: function innerRef(element) {
						_this2.refInput = element;
					},
					inputMode: inputMode,
					onBlur: onBlur,
					onChange: function onChange(event) {
						return onChangeHandler$1(event, _onChange);
					},
					onFocus: onFocus,
					onKeyDown: keyHandler(allowDecimal),
					type: 'number',
					value: normalisedValue,
					'data-test-id': dataTestId
				}),
				hasSuffix && React.createElement(
					StyledSuffix,
					null,
					React.createElement(
						'span',
						null,
						symbolSuffix
					)
				)
			);
		}
	}]);
	return BaseNumberInput;
}(Component);

BaseNumberInput.propTypes = {
	/** Character count as number. */
	characterCount: PropTypes.number,
	/** The id of the component. */
	id: PropTypes.string,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** The input mode - triggers a particular onscreen keyboard on mobile. */
	inputMode: PropTypes.oneOf(['decimal', 'numeric']).isRequired,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Optional symbol appearing before input. */
	symbolPrefix: PropTypes.string,
	/** Optional symbol appearing after input. */
	symbolSuffix: PropTypes.string,
	/** The value of the input */
	value: PropTypes.number,
	/** Data attribute targeting input for automation test purposes. */
	'data-test-id': PropTypes.string
};

var onChangeHandler$2 = function onChangeHandler(onChange) {
	return function (_ref) {
		var validationMessage = _ref.validationMessage,
		    value = _ref.value;

		if (value === '') {
			onChange({ validationMessage: validationMessage, value: null });
			return;
		}

		var isNumber = /[0-9]/.test(value);

		if (isNumber === false) {
			return;
		}

		onChange({ validationMessage: validationMessage, value: value });
	};
};

var InternalIntegerInput = function InternalIntegerInput(_ref2) {
	var characterCount = _ref2.characterCount,
	    id = _ref2.id,
	    innerRef = _ref2.innerRef,
	    onBlur = _ref2.onBlur,
	    onChange = _ref2.onChange,
	    onFocus = _ref2.onFocus,
	    symbolPrefix = _ref2.symbolPrefix,
	    symbolSuffix = _ref2.symbolSuffix,
	    value = _ref2.value,
	    dataTestId = _ref2['data-test-id'];
	return React.createElement(BaseNumberInput, {
		characterCount: characterCount,
		id: id,
		innerRef: innerRef,
		inputMode: 'numeric',
		onBlur: onBlur,
		onChange: onChangeHandler$2(onChange),
		onFocus: onFocus,
		symbolPrefix: symbolPrefix,
		symbolSuffix: symbolSuffix,
		value: value,
		'data-test-id': dataTestId
	});
};

InternalIntegerInput.propTypes = {
	/** Character count as number. */
	characterCount: PropTypes.number,
	/** The id of the component. */
	id: PropTypes.string,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Optional symbol appearing before input. */
	symbolPrefix: PropTypes.string,
	/** Optional symbol appearing after input. */
	symbolSuffix: PropTypes.string,
	/** The value of the input. */
	value: PropTypes.number,
	/** Data attribute targeting input for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalIntegerInput.defaultProps = {
	'data-test-id': 'integer-input'
};

var main$f = "GenericIntegerInput.js";
var packageJson$f = {
	main: main$f,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var GenericIntegerInput = function GenericIntegerInput(_ref) {
	var value = _ref.value,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'],
	    innerRef = _ref.innerRef,
	    onBlur = _ref.onBlur,
	    onChange = _ref.onChange,
	    onFocus = _ref.onFocus,
	    characterCount = _ref.characterCount;

	var onChangeHandler = function onChangeHandler(onChange) {
		return function (containedValue) {
			var value = containedValue.value;

			onChange(value);
		};
	};

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$f },
		React.createElement(InternalIntegerInput, {
			id: id,
			innerRef: innerRef,
			onBlur: onBlur,
			onChange: onChangeHandler(onChange),
			onFocus: onFocus,
			value: value,
			'data-test-id': dataTestId,
			characterCount: characterCount
		})
	);
};

GenericIntegerInput.propTypes = {
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** The value of the input. */
	value: PropTypes.number,
	/** The id of the component. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Data attribute targeting input for automation test purposes. */
	'data-test-id': PropTypes.string,
	/** Character count as number. */
	characterCount: PropTypes.number
};

GenericIntegerInput.defaultProps = {
	'data-test-id': 'generic-integer-input'
};

var main$g = "GenericTextInput.js";
var deprecations = [{
	replacements: {
		name: "GenericAlphaNumericInput",
		path: "Data/Capture/Inputs"
	}
}];
var packageJson$g = {
	main: main$g,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations
};

var _templateObject$n = taggedTemplateLiteral(['\n\t> input {\n\t\twidth: 100% !important;\n\t}\n'], ['\n\t> input {\n\t\twidth: 100% !important;\n\t}\n']);

var StyledWrapper$5 = styled('div')(_templateObject$n);

var onChangeHandler$3 = function onChangeHandler(onChange) {
	return function (containedValue) {
		var value = containedValue.value;

		onChange(value);
	};
};

var GenericTextInput = function GenericTextInput(_ref) {
	var id = _ref.id,
	    onChange = _ref.onChange,
	    value = _ref.value;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$g },
		React.createElement(
			StyledWrapper$5,
			null,
			React.createElement(InternalStandardTextInput, { id: id, onChange: onChangeHandler$3(onChange), value: value })
		)
	);
};

GenericTextInput.propTypes = {
	/** Sets the ID attribute on the component, needed to attach it to an associated label in the DOM. */
	id: PropTypes.string.isRequired,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** The value of the input */
	value: PropTypes.string.isRequired
};

GenericTextInput.defaultProps = {};

var onChangeHandler$4 = function onChangeHandler(onChange) {
	return function (output) {
		var validationErrorReason = output.validationErrorReason,
		    value = output.value;


		var isNumberOrSpace = /^[0-9\s]*$/.test(value);

		if (isNumberOrSpace === false && value !== '') {
			return;
		}

		onChange({
			validationErrorReason: validationErrorReason,
			value: value
		});
	};
};

var InternalTelephoneInput = function InternalTelephoneInput(_ref) {
	var onChange = _ref.onChange,
	    value = _ref.value,
	    rest = objectWithoutProperties(_ref, ['onChange', 'value']);
	return React.createElement(BaseTextInput, _extends({
		autoComplete: 'tel',
		type: 'tel',
		inputMode: 'tel',
		onChange: onChangeHandler$4(onChange),
		value: value
	}, rest));
};

InternalTelephoneInput.propTypes = {
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** The value of the input */
	value: PropTypes.string.isRequired
};

InternalTelephoneInput.defaultProps = {};

var main$h = "LandlineNumberInput.js";
var packageJson$h = {
	main: main$h,
	"component-id": 1004,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$o = taggedTemplateLiteral(['\n\twidth: 12rem;\n'], ['\n\twidth: 12rem;\n']);

var StyledWrapper$6 = styled('div')(_templateObject$o);

var validationReasons$2 = {
	BELOW_MIN: 'BELOW_MIN',
	ABOVE_MAX: 'ABOVE_MAX'
};

var getValidationErrorReason = function getValidationErrorReason(maxLength, minLength, valueToCheck) {
	var valueLength = valueToCheck.replace(/\s+/g, '').length;

	if (valueLength > maxLength) {
		return validationReasons$2.ABOVE_MAX;
	}

	if (valueLength < minLength) {
		return validationReasons$2.BELOW_MIN;
	}

	return '';
};

var onChangeHandler$5 = function onChangeHandler(maxLength, minLength, onChange) {
	return function (output) {
		var value = output.value;


		onChange({
			value: value,
			validationErrorReason: getValidationErrorReason(maxLength, minLength, value)
		});
	};
};

/**
 * @example ./Design.md
 */

var LandlineNumberInput = function (_Component) {
	inherits(LandlineNumberInput, _Component);

	function LandlineNumberInput(props) {
		classCallCheck(this, LandlineNumberInput);

		var _this = possibleConstructorReturn(this, (LandlineNumberInput.__proto__ || Object.getPrototypeOf(LandlineNumberInput)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(LandlineNumberInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    hasValidationEnabled = _props.hasValidationEnabled,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    maxLength = _props.maxLength,
			    minLength = _props.minLength,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    value = _props.value;


			var hasValidationError = getValidationErrorReason(maxLength, minLength, value) !== '';

			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$h },
				React.createElement(
					StyledWrapper$6,
					null,
					React.createElement(InternalTelephoneInput, {
						characterCount: 16,
						hasValidationError: hasValidationError && hasValidationEnabled,
						id: id,
						innerRef: function innerRef(element) {
							_this2.refInput = element;
						},
						onBlur: onBlur,
						onChange: onChangeHandler$5(maxLength, minLength, onChange),
						onFocus: onFocus,
						value: value
					})
				)
			);
		}
	}]);
	return LandlineNumberInput;
}(Component);

LandlineNumberInput.propTypes = {
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** Sets the ID attribute on the component, needed to attach it to an associated label in the DOM. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** The maximum character length of the input after space removal. */
	maxLength: PropTypes.number,
	/** The minimum character length of the input after space removal. */
	minLength: PropTypes.number,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** The value of the input. */
	value: PropTypes.string.isRequired
};

LandlineNumberInput.defaultProps = {
	maxLength: 11,
	minLength: 6
};

var InternalDecimalInput = function (_Component) {
	inherits(InternalDecimalInput, _Component);

	function InternalDecimalInput(props) {
		classCallCheck(this, InternalDecimalInput);

		var _this = possibleConstructorReturn(this, (InternalDecimalInput.__proto__ || Object.getPrototypeOf(InternalDecimalInput)).call(this, props));

		var value = props.value;

		var decimalStore = value !== null && value !== undefined && value !== '' ? value.toString() : null;

		_this.state = {
			decimalStore: decimalStore
		};

		_this.onChangeHandler = _this.onChangeHandler.bind(_this);
		return _this;
	}

	createClass(InternalDecimalInput, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.value !== this.props.value) {
				var newValue = nextProps.value;


				if (newValue !== null && newValue !== undefined && newValue !== '') {
					var decimalStore = nextProps.value.toString();
					this.setState({ decimalStore: decimalStore });
				} else {
					this.setState({ decimalStore: null });
				}
			}
		}
	}, {
		key: 'onChangeHandler',
		value: function onChangeHandler(onChange, output) {
			var validationMessage = output.validationMessage,
			    value = output.value;


			if (value !== null && value !== undefined && value !== '') {
				var numericValue = parseInt(value, 10);
				this.setState({ decimalStore: value.toString() }, function () {
					onChange({ value: numericValue, validationMessage: validationMessage });
				});
			} else {
				this.setState({ decimalStore: null }, function () {
					onChange({ value: value, validationMessage: validationMessage });
				});
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    characterCount = _props.characterCount,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    onBlur = _props.onBlur,
			    _onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    symbolPrefix = _props.symbolPrefix,
			    symbolSuffix = _props.symbolSuffix,
			    dataTestId = _props['data-test-id'];
			var decimalStore = this.state.decimalStore;


			return React.createElement(BaseNumberInput, {
				characterCount: characterCount,
				id: id,
				innerRef: innerRef,
				inputMode: 'decimal',
				onBlur: onBlur,
				onChange: function onChange(output) {
					return _this2.onChangeHandler(_onChange, output);
				},
				onFocus: onFocus,
				symbolPrefix: symbolPrefix,
				symbolSuffix: symbolSuffix,
				value: decimalStore,
				'data-test-id': dataTestId
			});
		}
	}]);
	return InternalDecimalInput;
}(Component);

InternalDecimalInput.propTypes = {
	/** Character count as number. */
	characterCount: PropTypes.number,
	/** The id of the component. */
	id: PropTypes.string,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Optional symbol appearing before input. */
	symbolPrefix: PropTypes.string,
	/** Optional symbol appearing after input. */
	symbolSuffix: PropTypes.string,
	/** The value of the input. */
	value: PropTypes.number,
	/** Data attribute targeting input for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalDecimalInput.defaultProps = {};

var main$i = "MoneyInput.js";
var variants$2 = ["PoundsOnly", "WithPence"];
var packageJson$i = {
	main: main$i,
	variants: variants$2,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$p = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']);

var poundsOnChangeHandler = function poundsOnChangeHandler(onChange) {
	return function (_ref) {
		var validationMessage = _ref.validationMessage,
		    value = _ref.value;

		var newValue = value === null ? null : parseInt(value, 10);
		onChange({ value: newValue, validationMessage: validationMessage });
	};
};

var InputWrapper = styled('div')(_templateObject$p, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var PoundsOnly = function PoundsOnly(_ref2) {
	var amountInPounds = _ref2.amountInPounds,
	    hasSuffix = _ref2.hasSuffix,
	    id = _ref2.id,
	    innerRef = _ref2.innerRef,
	    onBlur = _ref2.onBlur,
	    onChange = _ref2.onChange,
	    onFocus = _ref2.onFocus,
	    isFlush = _ref2.isFlush,
	    dataTestId = _ref2['data-test-id'];

	var value = amountInPounds === null || amountInPounds === undefined || amountInPounds === '' ? null : amountInPounds;

	return React.createElement(
		InternalComponentFrame,
		{ variant: 'PoundsOnly', packageJson: packageJson$i, hasCustomMargins: true },
		React.createElement(
			InputWrapper,
			{ isFlush: isFlush },
			React.createElement(InternalIntegerInput, {
				characterCount: 7,
				id: id,
				innerRef: innerRef,
				onBlur: onBlur,
				onChange: poundsOnChangeHandler(onChange),
				onFocus: onFocus,
				symbolPrefix: '\xA3',
				symbolSuffix: hasSuffix ? '.00' : '',
				value: value,
				'data-test-id': dataTestId
			})
		)
	);
};

var baseProps$4 = {
	/** The amount in pounds. */
	amountInPounds: PropTypes.number,
	/** The id of the component. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal button inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Data attribute targeting input for automation test purposes. */
	'data-test-id': PropTypes.string,
	/** Boolean controlling margin display. */
	isFlush: PropTypes.bool
};

var baseDefaultProps$1 = {
	'data-test-id': 'money-input'
};

PoundsOnly.propTypes = _extends({}, baseProps$4, {
	/** Visibility of decimal point and fractional part of value. */
	hasSuffix: PropTypes.bool
});

PoundsOnly.defaultProps = _extends({}, baseDefaultProps$1, {
	hasSuffix: true
});

var PENCE_IN_POUND = 100;

var penceToPounds = function penceToPounds(amountInPence) {
	return amountInPence === null || amountInPence === undefined || amountInPence === '' ? null : amountInPence / PENCE_IN_POUND;
};

var poundsToPence = function poundsToPence(amountInPounds) {
	return amountInPounds === null || amountInPounds === undefined || amountInPounds === '' ? null : amountInPounds * PENCE_IN_POUND;
};

var penceOnChangeHandler = function penceOnChangeHandler(onChange) {
	return function (output) {
		var validationMessage = output.validationMessage,
		    value = output.value;


		var newValue = poundsToPence(value);
		onChange({ value: newValue, validationMessage: validationMessage });
	};
};

var WithPence = function (_Component) {
	inherits(WithPence, _Component);

	function WithPence(props) {
		classCallCheck(this, WithPence);
		return possibleConstructorReturn(this, (WithPence.__proto__ || Object.getPrototypeOf(WithPence)).call(this, props));
	}

	createClass(WithPence, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    amountInPence = _props.amountInPence,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    isFlush = _props.isFlush,
			    dataTestId = _props['data-test-id'];


			var value = penceToPounds(amountInPence);

			return React.createElement(
				InternalComponentFrame,
				{ variant: 'WithPence', packageJson: packageJson$i, hasCustomMargins: true },
				React.createElement(
					InputWrapper,
					{ isFlush: isFlush },
					React.createElement(InternalDecimalInput, {
						characterCount: 10,
						id: id,
						innerRef: innerRef,
						onBlur: onBlur,
						onChange: penceOnChangeHandler(onChange),
						onFocus: onFocus,
						symbolPrefix: '\xA3',
						value: value,
						'data-test-id': dataTestId
					})
				)
			);
		}
	}]);
	return WithPence;
}(Component);

WithPence.propTypes = _extends({}, baseProps$4);

WithPence.defaultProps = _extends({}, baseDefaultProps$1);

var MoneyInput = {
	PoundsOnly: PoundsOnly,
	WithPence: WithPence
};

var main$j = "MonthAndYearDateInput.js";
var packageJson$j = {
	main: main$j,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$q = taggedTemplateLiteral(['\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\ttext-align: center;\n\twidth: 100%;\n\n\t&.error {\n\t\tborder: ', ';\n\t}\n'], ['\n\tborder: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\ttext-align: center;\n\twidth: 100%;\n\n\t&.error {\n\t\tborder: ', ';\n\t}\n']),
    _templateObject2$b = taggedTemplateLiteral(['\n\twidth: 60px;\n\tmargin-right: ', ';\n'], ['\n\twidth: 60px;\n\tmargin-right: ', ';\n']),
    _templateObject3$7 = taggedTemplateLiteral(['\n\twidth: 100px;\n'], ['\n\twidth: 100px;\n']);

var StyledInput$4 = styled('input')(_templateObject$q, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.isCompact ? '12px' : '16px';
}, spacing.SEXTUPLE, spacing.SINGLE, function (props) {
	return props.theme.borderWidth + ' solid ' + colours.utility.error;
});

var StyledMonthInput$1 = styled('div')(_templateObject2$b, spacing.DOUBLE);

var StyledYearInput$1 = styled('div')(_templateObject3$7);

var MAX_MONTHS = 12;
var MAX_YEAR = 2100;
var MONTH_MAX_LENGTH = 2;
var YEAR_LENGTH = 4;

var checkIsMonthInvalid = function checkIsMonthInvalid(month) {
	return month !== null ? month > MAX_MONTHS || month < 1 : false;
};

var checkIsYearInvalid = function checkIsYearInvalid(year) {
	return year !== null ? year > MAX_YEAR || year.toString().length < YEAR_LENGTH : false;
};

var keyHandler$1 = function keyHandler(event) {
	var NUMPAD_PERIOD = 110;
	var NUMPAD_MINUS = 109;
	var NUMPAD_PLUS = 107;

	var MINUS = 189;
	var PERIOD = 190;
	var PLUS = 187;

	var keyCode = event.keyCode;


	var hasNonNumberKey = [NUMPAD_PERIOD, NUMPAD_MINUS, NUMPAD_PLUS, MINUS, PERIOD, PLUS].some(function (x) {
		return x === keyCode;
	});

	if (hasNonNumberKey) {
		event.preventDefault();
		event.stopPropagation();
	}
};

var onChangeHandler$6 = function onChangeHandler(maxLength, settingFunc) {
	return function (_ref) {
		var target = _ref.target;

		var newValue = target.value;

		var isNumber = /[0-9]/.test(newValue);

		if (isNumber === false && newValue !== '') {
			return;
		}

		if (newValue.length > maxLength) {
			return;
		}

		var valueAsNumber = newValue !== '' ? parseInt(newValue, 10) : null;

		settingFunc(valueAsNumber);
	};
};

var setValidationErrorReason = function setValidationErrorReason(newState) {
	var isMonthInvalid = checkIsMonthInvalid(newState.value.month);
	var isYearInvalid = checkIsYearInvalid(newState.value.year);

	if (isMonthInvalid && isYearInvalid) {
		return _extends({}, newState, { validationErrorReason: 'INVALID_MONTH_AND_YEAR' });
	}

	if (isMonthInvalid) {
		return _extends({}, newState, { validationErrorReason: 'INVALID_MONTH' });
	}

	if (isYearInvalid) {
		return _extends({}, newState, { validationErrorReason: 'INVALID_YEAR' });
	}

	return _extends({}, newState, { validationErrorReason: '' });
};

var MonthAndYearDateInput = function (_Component) {
	inherits(MonthAndYearDateInput, _Component);

	function MonthAndYearDateInput(props) {
		classCallCheck(this, MonthAndYearDateInput);

		var _this = possibleConstructorReturn(this, (MonthAndYearDateInput.__proto__ || Object.getPrototypeOf(MonthAndYearDateInput)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(MonthAndYearDateInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    hasValidationEnabled = _props.hasValidationEnabled,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    value = _props.value;


			var normalisedValue = function () {
				if (!value) {
					return {
						month: null,
						year: null
					};
				}

				if (!value.month && !value.year) {
					return { month: null, year: null };
				}

				if (!value.month) {
					return _extends({}, value, { month: null });
				}

				if (!value.year) {
					return _extends({}, value, { year: null });
				}

				return value;
			}();

			var month = normalisedValue.month,
			    year = normalisedValue.year;


			var monthAsString = month !== null ? month.toString() : '';
			var yearAsString = year !== null ? year.toString() : '';

			var setMonth = function setMonth(month) {
				var newState = {
					value: _extends({}, normalisedValue, { month: month })
				};

				onChange(setValidationErrorReason(newState));
			};

			var setYear = function setYear(year) {
				var newState = {
					value: _extends({}, normalisedValue, { year: year })
				};

				onChange(setValidationErrorReason(newState));
			};

			var monthHasError = checkIsMonthInvalid(month);
			var yearHasError = checkIsYearInvalid(year);

			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$j },
				React.createElement(Inline.LeftAligned, {
					nodes: [React.createElement(
						StyledMonthInput$1,
						{ key: 'month' },
						React.createElement(
							InternalControlLabel,
							{ htmlFor: id + '-month' },
							'Month'
						),
						React.createElement(StyledInput$4, {
							id: id + '-month',
							inputMode: 'numeric',
							innerRef: function innerRef(element) {
								_this2.refInput = element;
							},
							min: 0,
							name: id + '-month',
							onChange: onChangeHandler$6(MONTH_MAX_LENGTH, setMonth),
							onFocus: onFocus,
							onKeyDown: function onKeyDown(event) {
								return keyHandler$1(event);
							},
							size: MONTH_MAX_LENGTH,
							type: 'text',
							value: monthAsString,
							className: monthHasError && hasValidationEnabled ? 'error' : ''
						})
					), React.createElement(
						StyledYearInput$1,
						{ key: 'year' },
						React.createElement(
							InternalControlLabel,
							{ htmlFor: id + '-year' },
							'Year'
						),
						React.createElement(StyledInput$4, {
							id: id + '-year',
							inputMode: 'numeric',
							min: 0,
							name: id + '-year',
							onBlur: onBlur,
							onChange: onChangeHandler$6(YEAR_LENGTH, setYear),
							onKeyDown: function onKeyDown(event) {
								return keyHandler$1(event);
							},
							size: YEAR_LENGTH,
							type: 'text',
							value: yearAsString,
							className: yearHasError && hasValidationEnabled ? 'error' : ''
						})
					)]
				})
			);
		}
	}]);
	return MonthAndYearDateInput;
}(Component);

MonthAndYearDateInput.propTypes = {
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** The id of the component. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * returns: {
  *   value: {
  *     month: number,
  *     year: number
  *   },
  *   validationErrorReason: [INVALID_MONTH|INVALID_YEAR|INVALID_MONTH_AND_YEAR]
  * }
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Values passed into the input. */
	value: PropTypes.shape({
		month: PropTypes.number,
		year: PropTypes.number
	})
};

MonthAndYearDateInput.defaultProps = {};

var main$k = "PasscodeNumberInput.js";
var packageJson$k = {
	main: main$k,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$r = taggedTemplateLiteral(['\n\tinput[type=\'number\'] {\n\t\t-moz-appearance: textfield;\n\t}\n\tinput[type=\'number\']::-webkit-inner-spin-button,\n\tinput[type=\'number\']::-webkit-outer-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n'], ['\n\tinput[type=\'number\'] {\n\t\t-moz-appearance: textfield;\n\t}\n\tinput[type=\'number\']::-webkit-inner-spin-button,\n\tinput[type=\'number\']::-webkit-outer-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n']),
    _templateObject2$c = taggedTemplateLiteral(['\n\tborder: ', '\n\t\t', ';\n\tborder-radius: ', ' ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ' ', ';\n\tmin-height: ', ';\n\tpadding: ', ' ', ';\n\twidth: 9rem ', ';\n\ttext-align: left;\n\tbackground: ', ' ', ';\n\n\t', ';\n'], ['\n\tborder: ', '\n\t\t', ';\n\tborder-radius: ', ' ', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ' ', ';\n\tmin-height: ', ';\n\tpadding: ', ' ', ';\n\twidth: 9rem ', ';\n\ttext-align: left;\n\tbackground: ', ' ', ';\n\n\t', ';\n']);

var PASSCODE_LENGTH = 8;

var StyledPasscodeInput = styled('div')(_templateObject$r);

var StyledInput$5 = styled('input')(_templateObject2$c, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.theme.borderRadius;
}, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.theme.isCompact ? '12px' : '16px';
}, INTERNET_BANKING_CSS_OVERRIDE, spacing.SEXTUPLE, spacing.SINGLE, INTERNET_BANKING_CSS_OVERRIDE, INTERNET_BANKING_CSS_OVERRIDE, colours.generalPalette.white, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.hasError && 'border: ' + props.theme.borderWidth + ' solid ' + colours.utility.error;
});

var validationReasons$3 = {
	BELOW_MIN: 'BELOW_MIN'
};

var PasscodeNumberInput = function (_Component) {
	inherits(PasscodeNumberInput, _Component);

	function PasscodeNumberInput(props) {
		classCallCheck(this, PasscodeNumberInput);

		var _this = possibleConstructorReturn(this, (PasscodeNumberInput.__proto__ || Object.getPrototypeOf(PasscodeNumberInput)).call(this, props));

		var value = _this.props.value;


		_this.state = {
			value: value,
			hasValidationError: false
		};

		_this.setPasscodeNumber = _this.setPasscodeNumber.bind(_this);
		return _this;
	}

	createClass(PasscodeNumberInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'setPasscodeNumber',
		value: function setPasscodeNumber(value) {
			var onChange = this.props.onChange;


			var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

			for (var i = 0; i < value.length; i += 1) {
				if (!numbers.includes(value.charAt(i))) {
					return;
				}
			}

			var hasValidationError = value.length !== PASSCODE_LENGTH;
			var validationErrorReason = hasValidationError ? validationReasons$3.BELOW_MIN : null;

			this.setState({
				value: value,
				hasValidationError: hasValidationError
			}, function () {
				onChange({
					value: value,
					validationErrorReason: validationErrorReason
				});
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    dataTestId = _props['data-test-id'],
			    hasValidationEnabled = _props.hasValidationEnabled,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    onBlur = _props.onBlur,
			    onFocus = _props.onFocus;
			var _state = this.state,
			    value = _state.value,
			    hasValidationError = _state.hasValidationError;


			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$k },
				React.createElement(
					StyledPasscodeInput,
					null,
					React.createElement(StyledInput$5, {
						'data-test-id': dataTestId,
						id: id,
						innerRef: function innerRef(element) {
							_this2.refInput = element;
						},
						inputMode: 'numeric',
						maxLength: PASSCODE_LENGTH,
						name: id,
						onBlur: onBlur,
						onChange: function onChange(event) {
							return _this2.setPasscodeNumber(event.target.value);
						},
						onFocus: onFocus,
						pattern: '[0-9]*',
						type: 'text',
						value: value,
						hasError: hasValidationError && hasValidationEnabled
					})
				)
			);
		}
	}]);
	return PasscodeNumberInput;
}(Component);

PasscodeNumberInput.propTypes = {
	/** Data attribute targeting component for automation test purposes. */
	'data-test-id': PropTypes.string,
	/** The id of the component. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Passcode number string value. */
	value: PropTypes.string
};

PasscodeNumberInput.defaultProps = {
	'data-test-id': 'passcode-number-input',
	hasValidationEnabled: false
};

var _extends$h = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$g(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$6 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$g(_ref, ["styles"]);

  return React.createElement("svg", _extends$h({ width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM4 7h8v2H4V7z" }));
});

var _extends$i = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$h(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$7 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$h(_ref, ["styles"]);

  return React.createElement("svg", _extends$i({ width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("title", null, "icon-minusoutline-large"), React.createElement("path", { d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM4 7h8v2H4V7z" }));
});

var getMinusOutlineLarge = getThemeIcon(VMIcon$6, GenericIcon$7);

var _extends$j = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$i(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CYBGPlusIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$i(_ref, ["styles"]);

  return React.createElement("svg", _extends$j({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7 7V4h2v3h3v2H9v3H7V9H4V7h3zm1 9A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14z" }));
});

var _extends$k = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$j(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$7 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$j(_ref, ["styles"]);

  return React.createElement("svg", _extends$k({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 0c26.51 0 48 21.49 48 48-.03 26.497-21.503 47.97-48 48C21.49 96 0 74.51 0 48S21.49 0 48 0zm0 8C25.909 8 8 25.909 8 48s17.909 40 40 40 40-17.909 40-40C87.975 25.919 70.081 8.025 48 8zm4 16v20h20v8H52v20h-8V52H24v-8h20V24z" }));
});

var getPlusOutlineLarge = getThemeIcon(VMIcon$7, CYBGPlusIcon);

var sliderInputThumbWidth = '24px';
var sliderInputMarkerWidth = '6px';
var sliderInputRangeTrackHeight = '6px';
var sliderInputTooltipTailWidth = 11;
var sliderInputTooltipTailWidthMultipler = 4;
var msSliderInputThumbHeightDivider = 1.5;
var sliderInputButtonWidth = '32px';
var sliderInputMarkerHeight = '32px';
var sliderInputMarkerPaddingTop = '8px';
var sliderInputRangeHeight = '48px';

var _templateObject$s = taggedTemplateLiteral(['\n\twidth: calc(100% - ', ');\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tdisplay: flex;\n\tmargin-top: calc((-', ' - ', ') / 2 - 1px);\n'], ['\n\twidth: calc(100% - ', ');\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tdisplay: flex;\n\tmargin-top: calc((-', ' - ', ') / 2 - 1px);\n']),
    _templateObject2$d = taggedTemplateLiteral(['\n\twidth: ', ';\n'], ['\n\twidth: ', ';\n']),
    _templateObject3$8 = taggedTemplateLiteral(['\n\t', ' ', ';\n'], ['\n\t', ' ', ';\n']),
    _templateObject4$6 = taggedTemplateLiteral(['\n\tborder-left: ', ' solid ', ';\n\tleft: calc(-', ' / 2);\n\theight: ', ';\n\tposition: relative;\n'], ['\n\tborder-left: ', ' solid ', ';\n\tleft: calc(-', ' / 2);\n\theight: ', ';\n\tposition: relative;\n']),
    _templateObject5$4 = taggedTemplateLiteral(['\n\tdisplay: table;\n\ttransform: translate(-50%);\n\tpadding-top: ', ';\n'], ['\n\tdisplay: table;\n\ttransform: translate(-50%);\n\tpadding-top: ', ';\n']);

var StyledWrapper$7 = styled('div')(_templateObject$s, sliderInputThumbWidth, sliderInputThumbWidth, sliderInputRangeTrackHeight);

var StyledMarkerWrapper = styled('div')(_templateObject2$d, function (props) {
	return props.width + '%';
});

var StyledMarkerInnerWrapper = styled('div')(_templateObject3$8, function (props) {
	return props.visible === 'non-mobile' && 'display: none;';
}, function (_ref) {
	var visible = _ref.visible;
	return visible !== 'always' && '@media (min-width: ' + breakpoint('md1') + ') {\n\t\t\tdisplay: ' + (visible === 'mobile-only' ? 'none' : 'block') + ';\n\t\t}';
});

var StyledMarker = styled('div')(_templateObject4$6, sliderInputMarkerWidth, colours.generalPalette.greyLightest, sliderInputMarkerWidth, sliderInputMarkerHeight);

var StyledMarkerLabel = styled('div')(_templateObject5$4, sliderInputMarkerPaddingTop);

var InternalIntervalMarkers = function InternalIntervalMarkers(_ref2) {
	var customMarkers = _ref2.customMarkers,
	    maxValue = _ref2.maxValue,
	    minValue = _ref2.minValue,
	    stepValue = _ref2.stepValue,
	    dataTestId = _ref2['data-test-id'];

	var WIDTH_MAX = 100;
	var range = maxValue - minValue;
	var intervals = range / stepValue;
	var intervalWidth = WIDTH_MAX / intervals;
	var markers = [].concat(toConsumableArray(Array(intervals).keys()));

	var getSteps = markers.map(function (val) {
		return minValue + val * stepValue;
	});
	var labels = getSteps.map(function (val) {
		var getCustomMarker = customMarkers.find(function (marker) {
			return marker.value === val;
		});
		return getCustomMarker && {
			label: getCustomMarker.label,
			visibility: getCustomMarker.visibility ? getCustomMarker.visibility : 'always'
		};
	});

	return React.createElement(
		StyledWrapper$7,
		{ 'data-test-id': dataTestId },
		labels.map(function (item, index) {
			return React.createElement(
				StyledMarkerWrapper,
				{ width: intervalWidth, key: 'marker-' + index },
				item && React.createElement(
					StyledMarkerInnerWrapper,
					{ visible: item.visibility },
					React.createElement(StyledMarker, null),
					React.createElement(
						StyledMarkerLabel,
						null,
						React.createElement(
							SubLabel,
							{ isFlush: true },
							item.label
						)
					)
				)
			);
		})
	);
};

InternalIntervalMarkers.propTypes = {
	/** Step value passed from slider  */
	stepValue: PropTypes.number,
	/** Maximum value passed from slider */
	maxValue: PropTypes.number.isRequired,
	/** Minimum value passed from slider */
	minValue: PropTypes.number.isRequired,
	/** custom increments passed from slider */
	customMarkers: PropTypes.array.isRequired
};

InternalIntervalMarkers.defaultProps = {};

var _templateObject$t = taggedTemplateLiteral(['\n\t-webkit-appearance: none;\n\theight: ', ';\n    width: 100%;\n    background-color: transparent;\n    position: relative;\n    z-index: 1;\n\tmargin: 0;\n\n\t&:focus {\n\t\toutline: 0;\n  \t\tbox-shadow: none;\n\n\t\t&::-webkit-slider-thumb {\n\t\t\t', '\n\t\t};\n\n\t\t&::-moz-range-thumb {\n\t\t\t', '\n\t\t};\n\n\t\t&::-ms-thumb {\n\t\t\t', '\n\t\t};\n\t}\n\n\t// ::-webkit...\n\t&::-webkit-slider-runnable-track {\n\t\t', '\n\t\tbackground: ', ';\n\t}\n\n\t&::-webkit-slider-thumb {\n\t\t', ';\n\t\t-webkit-appearance: none;\n\t\tmargin-top: calc((', ' - ', ') / 2);\n\t}\n\n\t// ::-moz...\n\t&::-moz-range-track {\n\t\t', '\n\t\tbackground: ', ';\n\t}\n\n\t&::-moz-range-thumb {\n\t\t', ';\n\t\tborder: none;\n \t }\n\n\t// ::-ms...\n\t&::-ms-track {\n\t\t', '\n\t\tbackground: transparent;\n\t\tborder-color: transparent;\n\t\tborder-width: 12px 0;\n\t\tcolor: transparent;\n\t}\n\n  \t&::-ms-fill-lower {\n\t\tbackground: darken(', ', 5%);\n\t}\n\n\t&::-ms-fill-upper {\n\t\tbackground: ', ';\n\t}\n\n\t&::-ms-thumb {\n\t\t', ';\n\t\tmargin-top: 0;\n\t\theight: calc(', ' / ', ');\n\t\twidth: calc(', ' / ', ');\n\t}\n'], ['\n\t-webkit-appearance: none;\n\theight: ', ';\n    width: 100%;\n    background-color: transparent;\n    position: relative;\n    z-index: 1;\n\tmargin: 0;\n\n\t&:focus {\n\t\toutline: 0;\n  \t\tbox-shadow: none;\n\n\t\t&::-webkit-slider-thumb {\n\t\t\t', '\n\t\t};\n\n\t\t&::-moz-range-thumb {\n\t\t\t', '\n\t\t};\n\n\t\t&::-ms-thumb {\n\t\t\t', '\n\t\t};\n\t}\n\n\t// ::-webkit...\n\t&::-webkit-slider-runnable-track {\n\t\t', '\n\t\tbackground: ', ';\n\t}\n\n\t&::-webkit-slider-thumb {\n\t\t', ';\n\t\t-webkit-appearance: none;\n\t\tmargin-top: calc((', ' - ', ') / 2);\n\t}\n\n\t// ::-moz...\n\t&::-moz-range-track {\n\t\t', '\n\t\tbackground: ', ';\n\t}\n\n\t&::-moz-range-thumb {\n\t\t', ';\n\t\tborder: none;\n \t }\n\n\t// ::-ms...\n\t&::-ms-track {\n\t\t', '\n\t\tbackground: transparent;\n\t\tborder-color: transparent;\n\t\tborder-width: 12px 0;\n\t\tcolor: transparent;\n\t}\n\n  \t&::-ms-fill-lower {\n\t\tbackground: darken(', ', 5%);\n\t}\n\n\t&::-ms-fill-upper {\n\t\tbackground: ', ';\n\t}\n\n\t&::-ms-thumb {\n\t\t', ';\n\t\tmargin-top: 0;\n\t\theight: calc(', ' / ', ');\n\t\twidth: calc(', ' / ', ');\n\t}\n']);

var getThumbStyles = function getThumbStyles(props) {
	return '\n\tbackground: ' + props.theme.colours.interaction + ';\n\tborder-radius: ' + spacing.DOUBLE + ';\n\tcursor: pointer;\n\theight: ' + sliderInputThumbWidth + ';\n\twidth: ' + sliderInputThumbWidth + ';\n';
};

var getTrackStyles = '\n\tcursor: pointer;\n\theight: ' + sliderInputRangeTrackHeight + ';\n\ttransition: all 0.3s ease;\n\twidth: 100%;\n';

var getThumbFocusStyles = '\n\toutline: 0;\n \tbox-shadow: 0 0 0 2px ' + colours.component.focusOutline + ';\n';

var StyledRangeInput = styled('input')(_templateObject$t, sliderInputThumbWidth, getThumbFocusStyles, getThumbFocusStyles, getThumbFocusStyles, getTrackStyles, colours.generalPalette.greyLightest, function (props) {
	return getThumbStyles(props);
}, sliderInputRangeTrackHeight, sliderInputThumbWidth, getTrackStyles, colours.generalPalette.greyLightest, function (props) {
	return getThumbStyles(props);
}, getTrackStyles, colours.generalPalette.greyLightest, colours.generalPalette.greyLightest, function (props) {
	return getThumbStyles(props);
}, sliderInputThumbWidth, msSliderInputThumbHeightDivider, sliderInputThumbWidth, msSliderInputThumbHeightDivider);

var passSliderValueFromEvent = function passSliderValueFromEvent(callbackFunc) {
	return function (event) {
		var getIntValueFromEvent = function getIntValueFromEvent(_ref) {
			var value = _ref.currentTarget.value;
			return parseInt(value, 10);
		};
		var intValue = getIntValueFromEvent(event);
		callbackFunc(intValue);
	};
};

var InternalRangeInput = function InternalRangeInput(_ref2) {
	var onChange = _ref2.onChange,
	    slideFinish = _ref2.slideFinish,
	    value = _ref2.value,
	    maxValue = _ref2.maxValue,
	    minValue = _ref2.minValue,
	    stepValue = _ref2.stepValue,
	    dataTestId = _ref2['data-test-id'],
	    id = _ref2.id;

	return React.createElement(StyledRangeInput, {
		id: id,
		type: 'range',
		onChange: passSliderValueFromEvent(onChange),
		onMouseUp: passSliderValueFromEvent(slideFinish),
		onTouchEnd: passSliderValueFromEvent(slideFinish),
		onKeyUp: passSliderValueFromEvent(onChange),
		value: value,
		max: maxValue,
		min: minValue,
		step: stepValue,
		'data-test-id': dataTestId
	});
};

InternalRangeInput.propTypes = {
	/** The id of the component. */
	id: PropTypes.string.isRequired,
	/** Maximum value passed from slider */
	maxValue: PropTypes.number.isRequired,
	/** Minimum value passed from slider */
	minValue: PropTypes.number.isRequired,
	/** Function maps to range input 'onChange' event */
	onChange: PropTypes.func.isRequired,
	/** Function maps to range inputs 'onMouseUp' event */
	slideFinish: PropTypes.func,
	/** Input value */
	value: PropTypes.number.isRequired,
	/** Step value passed from slider  */
	stepValue: PropTypes.number.isRequired,
	/** Data attribute targeting SliderInput for automation test purposes */
	'data-test-id': PropTypes.string
};

InternalRangeInput.defaultProps = {
	slideFinish: function slideFinish() {}
};

var regexes = {
	alphanumericOrSpace: /^[A-Z0-9\s]*$/,
	bfpo: /^BF\d ?\d[A-Z]{2}|BFPO ?\d{1,4}$/,
	legacyEmail: /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,})$/,
	newEmail: /^[!#%$&'*+/=_a-z0-9-]+(\.[!#%$&'*+/=_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i,
	moneyFormatter: /\B(?=(\d{3})+(?!\d))/g,
	postcode: /^(([A-Z]{1,2}\d[A-Z\d]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?\d[A-Z]{2}|(KY\d|MSR|VG|AI)[ -]?\d{4}|[A-Z]{2} ?\d{2}|GE ?CX)$/,
	postcodeAlt: /^([a-zA-Z]){1}([0-9][0-9]|[0-9]|[a-zA-Z][0-9][a-zA-Z]|[a-zA-Z][0-9][0-9]|[a-zA-Z][0-9]){1}([ ]?)([0-9][a-zA-z][a-zA-z]){1}$/,
	simplifiedAlpha: /([a-z])+/i,
	simplifiedNumeric: /([0-9])+/,
	specialCharacters: /([@!#%&'*+-/=?^_`{|}~])+/i
};

var moneyFormatter = regexes.moneyFormatter;


function lengthCalc(value, targetLength) {
	var newValue = value;
	var i = void 0;

	if (value.length < targetLength) {
		for (i = 0; i < targetLength - value.length; i += 1) {
			newValue = '0'.concat(newValue);
		}
	}
	return newValue;
}

var ACCOUNT_NUMBER_TARGET_LENGTH = 8;
var accountNumberFormat = function accountNumberFormat(value) {
	return '' + lengthCalc(value.toString(), ACCOUNT_NUMBER_TARGET_LENGTH);
};

var CARD_NUMBER_TARGET_LENGTH = 16;
var cardNumberFormat = function cardNumberFormat(value) {
	return '' + lengthCalc(value.toString(), CARD_NUMBER_TARGET_LENGTH).replace(/\B(?=(\d{4})+(?!\d))/g, ' ');
};

var PENCE_DIVIDER = 100;
var penceCurrencyFormat = function penceCurrencyFormat(value, removePrefix) {
	return '' + (Math.sign(value) === -1 ? '-' : '') + (!removePrefix ? '£' : '') + (Math.abs(value) / PENCE_DIVIDER).toFixed(2).toString().replace(moneyFormatter, ',');
};

var poundCurrencyFormat = function poundCurrencyFormat(value) {
	return '\xA3' + value.toString().replace(moneyFormatter, ',');
};

var PRODUCT_NUMBER_TARGET_LENGTH = 3;
var productNumberFormat = function productNumberFormat(value) {
	return '' + lengthCalc(value.toString(), PRODUCT_NUMBER_TARGET_LENGTH);
};

var SORT_CODE_TARGET_LENGTH = 6;
var sortCodeFormat = function sortCodeFormat(value) {
	return '' + lengthCalc(value.toString(), SORT_CODE_TARGET_LENGTH).replace(/\B(?=(\d{2})+(?!\d))/g, '-');
};

var BankingUtils = {
	accountNumberFormat: accountNumberFormat,
	cardNumberFormat: cardNumberFormat,
	lengthCalc: lengthCalc,
	penceCurrencyFormat: penceCurrencyFormat,
	poundCurrencyFormat: poundCurrencyFormat,
	productNumberFormat: productNumberFormat,
	sortCodeFormat: sortCodeFormat
};

var hashString = function hashString(str) {
	if (typeof str !== 'string') {
		return new Error(str + ' was not a string.');
	}

	var hash = 0;
	var MAX_VALUE = 5;
	for (var i = 0; i < str.length; i += 1) {
		hash = str.charCodeAt(i) + ((hash << MAX_VALUE) - hash); // eslint-disable-line no-bitwise
	}
	return hash;
};

var _templateObject$u = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']),
    _templateObject2$e = taggedTemplateLiteral(['\n\tposition: relative;\n\twidth: calc(100% - ', ');\n\tflex: none;\n\tpadding-bottom: calc(', ' + ', 'px);\n'], ['\n\tposition: relative;\n\twidth: calc(100% - ', ');\n\tflex: none;\n\tpadding-bottom: calc(', ' + ', 'px);\n']),
    _templateObject3$9 = taggedTemplateLiteral(['\n\tposition: relative;\n\tpadding: ', ';\n\tborder: ', ';\n\tbackground: ', ';\n\tborder-radius: ', ';\n\ttransform: translateX(calc(-50% + ', ' / 2));\n\ttext-align: center;\n\tdisplay: table;\n\tmin-width: ', 'px;\n\twidth: auto;\n\n\t&::before,\n\t&::after {\n\t\tposition: absolute;\n\t\tcontent: \'\';\n\t\twidth: 0;\n\t\theight: 0;\n\t\tleft: calc(50% - ', 'px);\n\t\tborder-width: ', 'px;\n\t\tborder-style: solid;\n\t}\n\n\t&::before {\n\t\tbottom: calc(-', 'px * 2 + ', ');\n\t\tborder-color: ', ' transparent transparent;\n\t\tz-index: 1;\n\t}\n\n\t&::after {\n\t\tbottom: calc(-', 'px * 2);\n\t\tborder-color: ', ' transparent transparent;\n\t}\n'], ['\n\tposition: relative;\n\tpadding: ', ';\n\tborder: ', ';\n\tbackground: ', ';\n\tborder-radius: ', ';\n\ttransform: translateX(calc(-50% + ', ' / 2));\n\ttext-align: center;\n\tdisplay: table;\n\tmin-width: ', 'px;\n\twidth: auto;\n\n\t&::before,\n\t&::after {\n\t\tposition: absolute;\n\t\tcontent: \'\';\n\t\twidth: 0;\n\t\theight: 0;\n\t\tleft: calc(50% - ', 'px);\n\t\tborder-width: ', 'px;\n\t\tborder-style: solid;\n\t}\n\n\t&::before {\n\t\tbottom: calc(-', 'px * 2 + ', ');\n\t\tborder-color: ', ' transparent transparent;\n\t\tz-index: 1;\n\t}\n\n\t&::after {\n\t\tbottom: calc(-', 'px * 2);\n\t\tborder-color: ', ' transparent transparent;\n\t}\n']);

var StyledToolTipWrapper = styled('div')(_templateObject$u, function (props) {
	return props.hasControls && '\n\t\tpadding: 0 ' + spacing.DOUBLE + ';\n\t\tmargin-left: ' + sliderInputButtonWidth + ';\n\t\tmargin-right: ' + sliderInputButtonWidth + ';\n\t';
});

var StyledToolTipBody = styled('div')(_templateObject2$e, sliderInputThumbWidth, spacing.DOUBLE, sliderInputTooltipTailWidth);

var StyledToolTip = styled('div')(_templateObject3$9, spacing.HALF, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, colours.generalPalette.white, function (props) {
	return props.theme.borderRadius;
}, sliderInputThumbWidth, sliderInputTooltipTailWidth * sliderInputTooltipTailWidthMultipler, sliderInputTooltipTailWidth, sliderInputTooltipTailWidth, sliderInputTooltipTailWidth, function (props) {
	return props.theme.borderWidth;
}, colours.generalPalette.white, sliderInputTooltipTailWidth, function (props) {
	return props.theme.colours.borderInteraction;
});

var InternalTooltipSlider = function InternalTooltipSlider(_ref) {
	var tooltipTexts = _ref.tooltipTexts,
	    value = _ref.value,
	    maxValue = _ref.maxValue,
	    minValue = _ref.minValue,
	    stepValue = _ref.stepValue,
	    hasControls = _ref.hasControls,
	    dataTestId = _ref['data-test-id'];

	var PERCENTAGE_DIVIDER = 100;
	var getRange = function getRange(maxValue, minValue) {
		return maxValue - minValue;
	};
	var perStepPercentage = function perStepPercentage(range, stepValue) {
		return PERCENTAGE_DIVIDER / (range / stepValue);
	};
	var currentStep = function currentStep(value, minValue, stepValue) {
		return (value - minValue) / stepValue;
	};
	var getTooltipPosition = function getTooltipPosition(value, maxValue, minValue, stepValue) {
		var leftPosition = 0;
		var range = getRange(maxValue, minValue);
		var stepPercentage = perStepPercentage(range, stepValue);
		var stepNumber = currentStep(value, minValue, stepValue);

		leftPosition = stepPercentage * stepNumber + '%';

		return leftPosition;
	};

	var left = getTooltipPosition(value, maxValue, minValue, stepValue);

	return React.createElement(
		StyledToolTipWrapper,
		{ hasControls: hasControls, 'data-test-id': dataTestId },
		React.createElement(
			StyledToolTipBody,
			null,
			React.createElement(
				StyledToolTip,
				{ style: { left: left } },
				tooltipTexts.map(function (tooltipText, index) {
					return React.createElement(
						SubBody,
						{ key: hashString(index), isFlush: true },
						tooltipText
					);
				})
			)
		)
	);
};

InternalTooltipSlider.propTypes = {
	/** Text to appear in tooltip */
	tooltipTexts: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
	/** Value passed from slider  */
	value: PropTypes.number.isRequired,
	/** Maximum value passed from slider  */
	maxValue: PropTypes.number.isRequired,
	/** Minimum value passed from slider  */
	minValue: PropTypes.number.isRequired,
	/** step value passed from slider */
	stepValue: PropTypes.number.isRequired,
	/** Data attribute targeting SliderInput for automation test purposes */
	'data-test-id': PropTypes.string
};

var main$l = "SliderInput.js";
var packageJson$l = {
	main: main$l,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$v = taggedTemplateLiteral(['\n\tmargin: 0;\n\tpadding: 0;\n\tborder: none;\n\twidth: 100%;\n'], ['\n\tmargin: 0;\n\tpadding: 0;\n\tborder: none;\n\twidth: 100%;\n']),
    _templateObject2$f = taggedTemplateLiteral(['\n\tdisplay: flex;\n\talign-items: flex-start;\n'], ['\n\tdisplay: flex;\n\talign-items: flex-start;\n']),
    _templateObject3$a = taggedTemplateLiteral(['\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tpadding: 0;\n\tmargin-top: calc(-', ' / 2);\n\tbackground: transparent;\n\tborder: none;\n\tsvg {\n\t\tfill: ', ' !important;\n\t\ttransition: fill 0.3s ease-in-out, transform 0.1s ease-in-out;\n\t\theight: ', ';\n\t\twidth: ', ';\n\t}\n'], ['\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tpadding: 0;\n\tmargin-top: calc(-', ' / 2);\n\tbackground: transparent;\n\tborder: none;\n\tsvg {\n\t\tfill: ', ' !important;\n\t\ttransition: fill 0.3s ease-in-out, transform 0.1s ease-in-out;\n\t\theight: ', ';\n\t\twidth: ', ';\n\t}\n']),
    _templateObject4$7 = taggedTemplateLiteral(['\n\theight: ', ';\n\tborder: 0;\n'], ['\n\theight: ', ';\n\tborder: 0;\n']),
    _templateObject5$5 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n\tposition: relative;\n\n\t', ';\n\n\t&::before,\n\t&::after {\n\t\tbackground: ', ';\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: ', ';\n\t\tposition: absolute;\n\t\ttop: calc((', ' + ', ') / 2);\n\t\twidth: ', ';\n\t}\n\n\t&::before {\n\t\tleft: calc((', ' - ', ') / 2);\n\t}\n\n\t&::after {\n\t\tright: calc((', ' - ', ') / 2);\n\t}\n'], ['\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n\tposition: relative;\n\n\t', ';\n\n\t&::before,\n\t&::after {\n\t\tbackground: ', ';\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: ', ';\n\t\tposition: absolute;\n\t\ttop: calc((', ' + ', ') / 2);\n\t\twidth: ', ';\n\t}\n\n\t&::before {\n\t\tleft: calc((', ' - ', ') / 2);\n\t}\n\n\t&::after {\n\t\tright: calc((', ' - ', ') / 2);\n\t}\n']),
    _templateObject6$3 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tpadding-top: calc(', ' - 1px);\n\twidth: calc(100% - ', ');\n\tmargin-left: auto;\n\tmargin-right: auto;\n\n\t', ';\n\t', ';\n'], ['\n\tdisplay: flex;\n\tpadding-top: calc(', ' - 1px);\n\twidth: calc(100% - ', ');\n\tmargin-left: auto;\n\tmargin-right: auto;\n\n\t', ';\n\t', ';\n']),
    _templateObject7$2 = taggedTemplateLiteral(['\n\tdisplay: table;\n\ttransform: translate(-50%);\n'], ['\n\tdisplay: table;\n\ttransform: translate(-50%);\n']),
    _templateObject8$1 = taggedTemplateLiteral(['\n\tdisplay: table;\n\ttransform: translate(50%);\n'], ['\n\tdisplay: table;\n\ttransform: translate(50%);\n']);

var StyledSliderInputFieldSet = styled('fieldset')(_templateObject$v);

var StyledSliderInputWrapper = styled('div')(_templateObject2$f);

var StyledSliderInputControlButton = styled('button')(_templateObject3$a, sliderInputRangeTrackHeight, function (props) {
	return props.disabled ? 'hsl(0deg 0% 46%)' : function (props) {
		return props.theme.colours.interaction;
	};
}, sliderInputButtonWidth, sliderInputButtonWidth);

var StyledSliderInputRange = styled('div')(_templateObject4$7, sliderInputRangeHeight);

var StyledSliderInputBody = styled('div')(_templateObject5$5, function (props) {
	return props.hasControls && 'margin: 0 ' + spacing.DOUBLE + ';';
}, colours.generalPalette.greyLightest, sliderInputMarkerHeight, sliderInputThumbWidth, sliderInputRangeTrackHeight, sliderInputMarkerWidth, sliderInputThumbWidth, sliderInputMarkerWidth, sliderInputThumbWidth, sliderInputMarkerWidth);

var StyledSliderInputLabelWrapper = styled('div')(_templateObject6$3, sliderInputMarkerPaddingTop, sliderInputThumbWidth, function (props) {
	return props.hasMinMaxLabels && 'justify-content: space-between';
}, function (props) {
	return props.customMarkers && 'justify-content: flex-end';
});

var StyledSliderInputMinLabel = styled('div')(_templateObject7$2);

var StyledSliderInputMaxLabel = styled('div')(_templateObject8$1);

var SliderInput = function SliderInput(_ref) {
	var onChange = _ref.onChange,
	    slideFinish = _ref.slideFinish,
	    value = _ref.value,
	    maxValue = _ref.maxValue,
	    minValue = _ref.minValue,
	    stepValue = _ref.stepValue,
	    labelText = _ref.labelText,
	    hasControls = _ref.hasControls,
	    hasMinMaxLabels = _ref.hasMinMaxLabels,
	    tooltipTexts = _ref.tooltipTexts,
	    customMarkers = _ref.customMarkers,
	    theme = _ref.theme,
	    id = _ref.id,
	    ariaLabelMinus = _ref.ariaLabelMinus,
	    ariaLabelPlus = _ref.ariaLabelPlus;

	var stepUp = function stepUp(value, stepValue) {
		return value + stepValue <= maxValue ? value + stepValue : maxValue;
	};
	var stepDown = function stepDown(value, stepValue) {
		return value - stepValue >= minValue ? value - stepValue : minValue;
	};

	var disableMinusButton = value === minValue;
	var disableAddButton = value === maxValue;

	var PlusOutlineIcon = getPlusOutlineLarge(theme.name);
	var MinusOutlineIcon = getMinusOutlineLarge(theme.name);

	var getIntervalMaxLabel = function getIntervalMaxLabel() {
		return customMarkers.find(function (marker) {
			return marker.value === maxValue;
		}).label;
	};

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$l },
		React.createElement(
			StyledSliderInputFieldSet,
			{ 'data-test-id': id + '-fieldset' },
			React.createElement(
				VisuallyHiddenBody,
				null,
				React.createElement(
					'legend',
					null,
					labelText
				)
			),
			tooltipTexts && React.createElement(InternalTooltipSlider, {
				hasControls: hasControls,
				tooltipTexts: tooltipTexts,
				value: value,
				minValue: minValue,
				maxValue: maxValue,
				stepValue: stepValue,
				'data-test-id': id + '-tooltip'
			}),
			React.createElement(
				StyledSliderInputWrapper,
				null,
				hasControls && React.createElement(
					StyledSliderInputControlButton,
					{
						disabled: disableMinusButton,
						type: 'button',
						onClick: function onClick() {
							onChange(stepDown(value, stepValue));
							slideFinish(stepDown(value, stepValue));
						},
						'data-test-id': id + '-subtract-buttton',
						'aria-label': ariaLabelMinus
					},
					React.createElement(MinusOutlineIcon, null)
				),
				React.createElement(
					StyledSliderInputBody,
					{ hasControls: hasControls },
					React.createElement(
						StyledSliderInputRange,
						null,
						React.createElement(
							VisuallyHiddenBody,
							null,
							React.createElement(
								'label',
								{ htmlFor: id },
								labelText
							)
						),
						React.createElement(InternalRangeInput, {
							onChange: onChange,
							slideFinish: slideFinish,
							value: value,
							maxValue: maxValue,
							minValue: minValue,
							stepValue: stepValue,
							id: id,
							'data-test-id': id + '-input'
						}),
						customMarkers && React.createElement(InternalIntervalMarkers, {
							customMarkers: customMarkers,
							stepValue: stepValue,
							maxValue: maxValue,
							minValue: minValue,
							'data-test-id': id + '-markers'
						})
					),
					customMarkers && React.createElement(
						StyledSliderInputLabelWrapper,
						{ customMarkers: customMarkers },
						React.createElement(
							StyledSliderInputMaxLabel,
							null,
							React.createElement(
								SubLabel,
								{ isFlush: true },
								getIntervalMaxLabel()
							)
						)
					),
					hasMinMaxLabels && !customMarkers && React.createElement(
						StyledSliderInputLabelWrapper,
						{ hasMinMaxLabels: hasMinMaxLabels },
						React.createElement(
							StyledSliderInputMinLabel,
							{ 'data-test-id': id + '-min-label' },
							React.createElement(
								SubLabel,
								{ isFlush: true },
								minValue
							)
						),
						React.createElement(
							StyledSliderInputMaxLabel,
							{ 'data-test-id': id + '-max-label' },
							React.createElement(
								SubLabel,
								{ isFlush: true },
								maxValue
							)
						)
					)
				),
				hasControls && React.createElement(
					StyledSliderInputControlButton,
					{
						disabled: disableAddButton,
						type: 'button',
						onClick: function onClick() {
							onChange(stepUp(value, stepValue));
							slideFinish(stepUp(value, stepValue));
						},
						'data-test-id': id + '-add-button',
						'aria-label': ariaLabelPlus
					},
					React.createElement(PlusOutlineIcon, null)
				)
			)
		)
	);
};

SliderInput.propTypes = {
	/** The id of the component */
	id: PropTypes.string.isRequired,
	/** Maxium value */
	maxValue: PropTypes.number.isRequired,
	/** Minimum value */
	minValue: PropTypes.number.isRequired,
	/** Function maps to range input 'onChange' event */
	onChange: PropTypes.func.isRequired,
	/** Function maps to range inputs 'onMouseUp' event */
	slideFinish: PropTypes.func,
	/** Input value */
	value: PropTypes.number.isRequired,
	/** Fieldset legend and input label text */
	labelText: PropTypes.string.isRequired,
	/** Increment of which input will change/snap when using the controls or the input range */
	stepValue: PropTypes.number.isRequired,
	/** Show button controls */
	hasControls: PropTypes.bool,
	/** Show the minValue and maxValue on input range */
	hasMinMaxLabels: PropTypes.bool,
	/** Texts for tooltip. Each Array element goes on a new line*/
	tooltipTexts: PropTypes.arrayOf(PropTypes.string),
	/** Visual marker displayed at these custom increments */
	customMarkers: PropTypes.arrayOf(PropTypes.shape({
		/** Marker value */
		value: PropTypes.number.isRequired,
		/** Marker label text */
		label: PropTypes.string.isRequired,
		/** Visibility of markers. One of: always, non-mobile, mobile-only. Default: always */
		visibility: PropTypes.oneOf(['always', 'non-mobile', 'mobile-only'])
	})),
	//Aria label for the minus button
	ariaLabelMinus: PropTypes.string,
	//Aria label for the plus button
	ariaLabelPlus: PropTypes.string
};

SliderInput.defaultProps = {
	slideFinish: function slideFinish() {},
	ariaLabelPlus: 'Increase slider value',
	ariaLabelMinus: 'Decrease slider value'
};

var SliderInputWithTheme = withTheme(SliderInput);

var main$m = "SortcodeInput.js";
var packageJson$m = {
	main: main$m,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$w = taggedTemplateLiteral(['\n\tdisplay: flex;\n\n\tinput[type=\'number\'] {\n\t\t-moz-appearance: textfield;\n\t}\n\tinput[type=\'number\']::-webkit-inner-spin-button,\n\tinput[type=\'number\']::-webkit-outer-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n'], ['\n\tdisplay: flex;\n\n\tinput[type=\'number\'] {\n\t\t-moz-appearance: textfield;\n\t}\n\tinput[type=\'number\']::-webkit-inner-spin-button,\n\tinput[type=\'number\']::-webkit-outer-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n']),
    _templateObject2$g = taggedTemplateLiteral(['\n\twidth: 50px;\n\tmargin-right: 16px;\n'], ['\n\twidth: 50px;\n\tmargin-right: 16px;\n']),
    _templateObject3$b = taggedTemplateLiteral(['\n\tborder: ', ';\n\tborder-color: ', ';\n\tborder-radius: ', ';\n\t', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\twidth: 100%;\n\ttext-align: center;\n'], ['\n\tborder: ', ';\n\tborder-color: ', ';\n\tborder-radius: ', ';\n\t', ';\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\twidth: 100%;\n\ttext-align: center;\n']);

var CONSTS = {
	MAX_LENGTH: 6,
	BANK_ID: 0,
	BRANCH_ID_1: 1,
	BRANCH_ID_2: 2
};

var StyledWrapper$8 = styled('div')(_templateObject$w);

var StyledInputWrapper$2 = styled('div')(_templateObject2$g);

var StyledInput$6 = styled('input')(_templateObject3$b, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, function (props) {
	return props.hasError ? colours.utility.error : props.theme.colours.borderInteraction;
}, function (props) {
	return props.theme.borderRadius;
}, externalMarginRegular, function (props) {
	return props.theme.isCompact ? '12px' : '16px';
}, spacing.SEXTUPLE, spacing.SINGLE);

var SortcodeInput = function (_Component) {
	inherits(SortcodeInput, _Component);

	function SortcodeInput(props) {
		classCallCheck(this, SortcodeInput);

		var _this = possibleConstructorReturn(this, (SortcodeInput.__proto__ || Object.getPrototypeOf(SortcodeInput)).call(this, props));

		var VALUE_1_START = 0;
		var VALUE_1_END = 2;
		var VALUE_2_END = 4;
		var VALUE_3_END = 6;

		var inputValue1 = props.value ? props.value.slice(VALUE_1_START, VALUE_1_END) : [];
		var inputValue2 = props.value ? props.value.slice(VALUE_1_END, VALUE_2_END) : [];
		var inputValue3 = props.value ? props.value.slice(VALUE_2_END, VALUE_3_END) : [];

		_this.state = {
			inputValue1: inputValue1,
			inputValue2: inputValue2,
			inputValue3: inputValue3
		};

		_this.setSortcodeValue = function (id, value) {
			switch (id) {
				case CONSTS.BANK_ID:
					_this.setState({ inputValue1: value }, function () {
						return _this.returnValidSortcode();
					});
					break;
				case CONSTS.BRANCH_ID_1:
					_this.setState({ inputValue2: value }, function () {
						return _this.returnValidSortcode();
					});
					break;
				case CONSTS.BRANCH_ID_2:
					_this.setState({ inputValue3: value }, function () {
						return _this.returnValidSortcode();
					});
					break;
			}
		};

		_this.returnValidSortcode = function () {
			var sortcodeString = '' + _this.state.inputValue1 + _this.state.inputValue2 + _this.state.inputValue3;
			var isValid = sortcodeString.length === CONSTS.MAX_LENGTH;

			props.onChange({ isValid: isValid, value: sortcodeString });
		};

		_this.handleChange = function (event, inputRef, id) {
			var value = event.target.value;


			var formattedValue = _this.formatValue(value);

			if (formattedValue.length > 1 && inputRef) {
				inputRef.focus();
			}

			_this.setSortcodeValue(id, formattedValue);
		};

		_this.formatValue = function (value) {
			var newValue = value.slice(0, 2).replace(/[^0-9]/g, '');
			if (newValue === '') {
				newValue = [];
			}

			return newValue;
		};
		return _this;
	}

	createClass(SortcodeInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _state = this.state,
			    inputValue1 = _state.inputValue1,
			    inputValue2 = _state.inputValue2,
			    inputValue3 = _state.inputValue3;
			var _props = this.props,
			    hasValidationEnabled = _props.hasValidationEnabled,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    onBlur = _props.onBlur,
			    onFocus = _props.onFocus;


			var inputvalue1Error = inputValue1.length < 2;
			var inputvalue2Error = inputValue2.length < 2;
			var inputvalue3Error = inputValue3.length < 2;

			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$m, hasCustomMargins: true },
				React.createElement(
					StyledWrapper$8,
					null,
					React.createElement(
						StyledInputWrapper$2,
						null,
						React.createElement(StyledInput$6, {
							id: id,
							innerRef: function innerRef(element) {
								_this2.refInput = element;
							},
							hasError: hasValidationEnabled && inputvalue1Error,
							onChange: function onChange(event) {
								_this2.handleChange(event, _this2.numberInput2, CONSTS.BANK_ID);
							},
							onFocus: onFocus,
							type: 'number',
							value: inputValue1
						})
					),
					React.createElement(
						StyledInputWrapper$2,
						null,
						React.createElement(StyledInput$6, {
							hasError: hasValidationEnabled && inputvalue2Error,
							onChange: function onChange(event) {
								_this2.handleChange(event, _this2.numberInput3, CONSTS.BRANCH_ID_1);
							},
							type: 'number',
							value: inputValue2
						})
					),
					React.createElement(
						StyledInputWrapper$2,
						null,
						React.createElement(StyledInput$6, {
							hasError: hasValidationEnabled && inputvalue3Error,
							onBlur: onBlur,
							onChange: function onChange(event) {
								_this2.handleChange(event, null, CONSTS.BRANCH_ID_2);
							},
							type: 'number',
							value: inputValue3
						})
					)
				)
			);
		}
	}]);
	return SortcodeInput;
}(Component);

SortcodeInput.propTypes = {
	/** Validation visual hints enabled boolean. */
	hasValidationEnabled: PropTypes.bool,
	/** Input id attribute string.  */
	id: PropTypes.string,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Sort code value string. */
	value: PropTypes.string
};

var _extends$l = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$k(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$8 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$k(_ref, ["styles"]);

  return React.createElement("svg", _extends$l({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M95.802 3.212c0-.006.003-.013.003-.02l-.003-.018-.004-.176c0-.717-.31-1.347-.758-1.86-.057-.076-.099-.162-.166-.233-.067-.064-.157-.105-.234-.163C94.122.301 93.485 0 92.77.003h-.176L92.57 0c-.012 0-.022.006-.035.006L60.411.208c-1.67.006-3.016 1.443-3.007 3.212.003 1.77 1.363 3.196 3.033 3.19l24.48-.15-52.01 52.201a3.118 3.118 0 0 0 .02 4.422 3.147 3.147 0 0 0 4.44-.016l52.046-52.24.153 24.323c.01 1.667 1.453 3.01 3.232 2.998 1.775-.007 3.212-1.357 3.202-3.02l-.198-31.916zM83.18 86.348a3.2 3.2 0 0 1-3.2 3.2H9.598a3.2 3.2 0 0 1-3.2-3.2V15.964a3.2 3.2 0 0 1 3.2-3.199h41.59V6.367H6.398A6.4 6.4 0 0 0 0 12.765v76.782a6.4 6.4 0 0 0 6.399 6.399H83.18a6.399 6.399 0 0 0 6.398-6.399v-44.79h-6.398v41.59z" }));
});

var _extends$m = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$l(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$8 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$l(_ref, ["styles"]);

  return React.createElement("svg", _extends$m({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M36.888 4.096v8H8.336v71.996h72v-32h8v40h-88V4.096zM92.464.364v24h-8l-.001-10.344-20.201 20.203a44.03 44.03 0 0 1-11.88 8.338A80.542 80.542 0 0 1 56 67.266V76h-8v-8.734A73.774 73.774 0 0 0 44.969 45.5a61.199 61.199 0 0 1-11.586 2.414 13.904 13.904 0 0 1-11.445-4.016l-.297-.33c-4.983-5.435-4.998-13.773-.036-19.226l.29-.32c5.471-5.46 14.329-5.46 19.8 0a41.831 41.831 0 0 1 7.7 11.1 35.775 35.775 0 0 0 9.21-6.556L78.807 8.364H68.464v-8zM27.695 29.537a6.278 6.278 0 0 0 .047 8.848 5.953 5.953 0 0 0 4.758 1.578 53.648 53.648 0 0 0 9.48-1.908 32.764 32.764 0 0 0-5.773-8.211 6.08 6.08 0 0 0-8.512-.307z" }));
});

var getPopoutOutlineLarge = getThemeIcon(VMIcon$8, GenericIcon$8);

var main$n = "WebsiteLink.js";
var packageJson$n = {
	main: main$n,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$x = taggedTemplateLiteral(['\n\tdisplay: inline-flex;\n\tmargin-left: ', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\twidth: ', ';\n\t}\n'], ['\n\tdisplay: inline-flex;\n\tmargin-left: ', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\twidth: ', ';\n\t}\n']),
    _templateObject2$h = taggedTemplateLiteral(['\n\tcolor: ', ';\n\ttext-decoration: underline;\n\tword-wrap: break-word;\n'], ['\n\tcolor: ', ';\n\ttext-decoration: underline;\n\tword-wrap: break-word;\n']);

var StyledIcon = styled('span')(_templateObject$x, function (props) {
	return props.theme.isCompact ? '2px' : '4px';
}, function (props) {
	return props.theme.colours.links;
}, function (props) {
	return props.theme.isCompact ? '8px' : '16px';
}, function (props) {
	return props.theme.isCompact ? '8px' : '16px';
});

var StyledLink = styled('a')(_templateObject2$h, function (props) {
	return props.theme.colours.links;
});

/**
 * When willOpenNewWindow is true `<a>` tag will have `rel = noopener noreferrer`.
 * @example ./Design.md
 */
// eslint-disable-next-line react/prop-types
var WebsiteLink = function WebsiteLink(_ref) {
	var linkText = _ref.linkText,
	    linkTitle = _ref.linkTitle,
	    theme = _ref.theme,
	    url = _ref.url,
	    willOpenNewWindow = _ref.willOpenNewWindow,
	    visuallyHiddenText = _ref.visuallyHiddenText;

	var target = willOpenNewWindow ? '_blank' : '_self';
	var PopoutIcon = getPopoutOutlineLarge(theme.name);

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$n, hasCustomMargins: true, layout: 'inline' },
		React.createElement(
			StyledLink,
			{
				href: '' + url,
				target: target,
				title: linkTitle,
				rel: willOpenNewWindow ? 'noopener noreferrer' : null
			},
			React.createElement(
				'span',
				null,
				linkText || url
			),
			willOpenNewWindow ? React.createElement(
				'span',
				null,
				React.createElement(
					VisuallyHiddenBody,
					null,
					visuallyHiddenText ? visuallyHiddenText : '(Opens in a new tab)'
				),
				React.createElement(
					StyledIcon,
					null,
					React.createElement(PopoutIcon, null)
				)
			) : visuallyHiddenText && React.createElement(
				VisuallyHiddenBody,
				null,
				visuallyHiddenText
			)
		)
	);
};

WebsiteLink.propTypes = {
	/** Displayed text. */
	linkText: PropTypes.string,
	/** Native 'a' title attribute text. */
	linkTitle: PropTypes.string,
	/** Website url. */
	url: PropTypes.string.isRequired,
	/* Opens link in a new tab or window when clicked. */
	willOpenNewWindow: PropTypes.bool,
	/** Visually hidden text for accessibility. */
	visuallyHiddenText: PropTypes.string
};

WebsiteLink.defaultProps = {
	willOpenNewWindow: false
};

var WrappedWebsiteLink = withTheme(WebsiteLink);

var main$o = "UKOnlyMobileNumberInput.js";
var packageJson$o = {
	main: main$o,
	"component-id": 1013,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$y = taggedTemplateLiteral(['\n\tinput {\n\t\tmargin-bottom: ', ';\n\n\t\t', '};\n\t}\n'], ['\n\tinput {\n\t\tmargin-bottom: ', ';\n\n\t\t', '};\n\t}\n']);

var StyledWrapper$9 = styled('div')(_templateObject$y, spacing.DOUBLE, function (props) {
	return props.hasValidationError && 'border: ' + props.theme.borderWidth + ' solid ' + colours.utility.error;
});

var validationReasons$4 = {
	BELOW_MIN: 'BELOW_MIN',
	ABOVE_MAX: 'ABOVE_MAX'
};

var getValidationErrorReason$1 = function getValidationErrorReason(maxLength, minLength, valueToCheck) {
	var valueLength = valueToCheck.replace(/\s+/g, '').length;

	if (valueLength > maxLength) {
		return validationReasons$4.ABOVE_MAX;
	}

	if (valueLength < minLength) {
		return validationReasons$4.BELOW_MIN;
	}

	return '';
};

var onChangeHandler$7 = function onChangeHandler(maxLength, minLength, onChange) {
	return function (output) {
		var value = output.value;


		onChange({
			value: value,
			validationErrorReason: getValidationErrorReason$1(maxLength, minLength, value)
		});
	};
};

/**
 * @example ./Design.md
 */

var UKOnlyMobileNumberInput = function (_Component) {
	inherits(UKOnlyMobileNumberInput, _Component);

	function UKOnlyMobileNumberInput(props) {
		classCallCheck(this, UKOnlyMobileNumberInput);

		var _this = possibleConstructorReturn(this, (UKOnlyMobileNumberInput.__proto__ || Object.getPrototypeOf(UKOnlyMobileNumberInput)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(UKOnlyMobileNumberInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    id = _props.id,
			    hasValidationEnabled = _props.hasValidationEnabled,
			    value = _props.value,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    innerRef = _props.innerRef,
			    contactUsUrl = _props.contactUsUrl,
			    maxLength = _props.maxLength,
			    minLength = _props.minLength;


			var hasValidationError = getValidationErrorReason$1(maxLength, minLength, value) !== '';

			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$o },
				React.createElement(
					StyledWrapper$9,
					null,
					React.createElement(InternalTelephoneInput, {
						characterCount: 18,
						hasValidationError: hasValidationError && hasValidationEnabled,
						id: id,
						innerRef: function innerRef(element) {
							_this2.refInput = element;
						},
						onBlur: onBlur,
						onChange: onChangeHandler$7(maxLength, minLength, onChange),
						onFocus: onFocus,
						value: value
					}),
					React.createElement(
						StandardBody,
						{ isFlush: true },
						'If you want to use an overseas number, please',
						' ',
						React.createElement(WrappedWebsiteLink, { willOpenNewWindow: true, linkText: 'get in touch with us', url: contactUsUrl }),
						'.'
					)
				)
			);
		}
	}]);
	return UKOnlyMobileNumberInput;
}(Component);

UKOnlyMobileNumberInput.propTypes = {
	/** Url used in the 'get in touch with us' link. */
	contactUsUrl: PropTypes.string.isRequired,
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** Sets the ID attribute on the component, needed to attach it to an associated label in the DOM. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** The maximum character length of the input after space removal. */
	maxLength: PropTypes.number,
	/** The minimum character length of the input after space removal. */
	minLength: PropTypes.number,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** The value of the input. */
	value: PropTypes.string.isRequired
};

UKOnlyMobileNumberInput.defaultProps = {
	maxLength: 11,
	minLength: 6
};

var main$p = "UKOnlyPostcodeInput.js";
var packageJson$p = {
	main: main$p,
	"component-id": 1006,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var MAX_CHARS = 8;

var ALPHANUMERIC_OR_SPACE_REGEX = regexes.alphanumericOrSpace,
    BFPO_REGEX = regexes.bfpo,
    POSTCODE_REGEX = regexes.postcode;


var postcodeTypes = {
	BFPO_POSTCODE_TYPE: 'BFPO_POSTCODE_TYPE',
	STANDARD_POSTCODE_TYPE: 'STANDARD_POSTCODE_TYPE'
};

var validationErrorReasons$1 = {
	INVALID_POSTCODE: 'INVALID_POSTCODE',
	BFPO_POSTCODE: 'BFPO_POSTCODE'
};

var getNormalisedValue$1 = function getNormalisedValue(value) {
	return value === null || value === undefined ? '' : value;
};
var getIsBritishForcesPostcode = function getIsBritishForcesPostcode(value) {
	return BFPO_REGEX.test(value);
};
var getIsStandardPostcode = function getIsStandardPostcode(value) {
	return POSTCODE_REGEX.test(value);
};

var getValidationErrorReason$2 = function getValidationErrorReason(allowBFPO, value) {
	var valueForComparison = value.toUpperCase().replace(' ', '');

	var isBritishForcesPostcode = getIsBritishForcesPostcode(valueForComparison);

	if (isBritishForcesPostcode && allowBFPO === false) {
		return validationErrorReasons$1.BFPO_POSTCODE;
	}

	var isValidPostcode = getIsStandardPostcode(valueForComparison);

	return isValidPostcode ? '' : validationErrorReasons$1.INVALID_POSTCODE;
};

var onChangeHandler$8 = function onChangeHandler(allowBFPO, onChange) {
	return function (containedValue) {
		//TODOxVMUI: Need to look at merging reasons with internal input reasons.
		var value = containedValue.value,
		    _validationErrorReason = containedValue._validationErrorReason;

		var normalisedValue = getNormalisedValue$1(value);
		var isLetterOrNumberOrSpace = ALPHANUMERIC_OR_SPACE_REGEX.test(normalisedValue.toUpperCase());

		if (isLetterOrNumberOrSpace === false && normalisedValue !== '') {
			return;
		}

		if (value.length > MAX_CHARS) {
			return;
		}

		var valueForComparison = value.toUpperCase().replace(' ', '');

		var isBritishForcesPostcode = getIsBritishForcesPostcode(valueForComparison);
		var isStandardPostcode = getIsStandardPostcode(valueForComparison);
		var postcodeType = isBritishForcesPostcode && postcodeTypes.BFPO_POSTCODE_TYPE || isStandardPostcode && postcodeTypes.STANDARD_POSTCODE_TYPE || null;

		onChange({
			postcodeType: postcodeType,
			value: normalisedValue,
			validationErrorReason: getValidationErrorReason$2(allowBFPO, normalisedValue)
		});
	};
};

var UKOnlyPostcodeInput = function UKOnlyPostcodeInput(_ref) {
	var allowBFPO = _ref.allowBFPO,
	    dataTestId = _ref['data-test-id'],
	    hasValidationEnabled = _ref.hasValidationEnabled,
	    id = _ref.id,
	    innerRef = _ref.innerRef,
	    onBlur = _ref.onBlur,
	    onChange = _ref.onChange,
	    onFocus = _ref.onFocus,
	    value = _ref.value;

	var normalisedValue = getNormalisedValue$1(value);
	var hasValueError = getValidationErrorReason$2(allowBFPO, normalisedValue) !== '';

	var hasValidationError = !!hasValidationEnabled && hasValueError;

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$p, layout: 'inline-block' },
		React.createElement(InternalStandardTextInput, {
			characterCount: MAX_CHARS,
			'data-test-id': dataTestId,
			hasValidationError: hasValidationError,
			id: id,
			innerRef: innerRef,
			maxLength: MAX_CHARS,
			onBlur: onBlur,
			onChange: onChangeHandler$8(allowBFPO, onChange),
			onFocus: onFocus,
			value: normalisedValue
		})
	);
};

UKOnlyPostcodeInput.propTypes = {
	/** Sets if British Forces Post Office (BFPO) address will not cause validation error. */
	allowBFPO: PropTypes.bool,
	/** Data attribute targeting select for automation test purposes. */
	'data-test-id': PropTypes.string,
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** Sets the ID attribute on the component, needed to attach it to an associated label in the DOM. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * returns: {
  *   validationErrorReason: 'INVALID_POSTCODE'|'BFPO_POSTCODE',
  *   value: string,
  * }
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** values passed into the input. */
	value: PropTypes.string
};

UKOnlyPostcodeInput.defaultProps = {
	allowBFPO: false,
	'data-test-id': 'uk-only-postcode-input'
};

UKOnlyPostcodeInput.validationLiterals = _extends({ WHEN_VALID: '' }, validationErrorReasons$1);

var _extends$n = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$m(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$9 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$m(_ref, ["styles"]);

  return React.createElement("svg", _extends$n({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 62.862l39.413-40.354a4.972 4.972 0 0 1 7.114 0l.144.148a5 5 0 0 1 0 6.988L51.845 73.492A4.96 4.96 0 0 1 48 74.982a4.959 4.959 0 0 1-3.845-1.49L1.329 29.644a5 5 0 0 1 0-6.988l.144-.148a4.972 4.972 0 0 1 7.114 0L48 62.862z" }));
});

var _extends$o = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$n(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$9 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$n(_ref, ["styles"]);

  return React.createElement("svg", _extends$o({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48.799 76.174a7.134 7.134 0 0 1-5.06-2.097L.8 31.137l10.12-10.12 37.88 37.88 37.88-37.88 10.12 10.12-42.94 42.94a7.134 7.134 0 0 1-5.06 2.097z" }));
});

var getChevronDownSolidLarge = getThemeIcon(VMIcon$9, GenericIcon$9);

var componentPaths = [
	{
		name: "ActionAnchor",
		path: "actions/anchors/ActionAnchor",
		styleguidePath: "Actions/Anchors/ActionAnchor",
		importPath: "web-ui-components/lib/actions/anchors"
	},
	{
		name: "ActionButton",
		path: "actions/buttons/ActionButton",
		styleguidePath: "Actions/Buttons/ActionButton",
		importPath: "web-ui-components/lib/actions/buttons"
	},
	{
		name: "SwitchButton",
		path: "actions/buttons/SwitchButton",
		styleguidePath: "Actions/Buttons/SwitchButton",
		importPath: "web-ui-components/lib/actions/buttons"
	},
	{
		name: "EmailLink",
		path: "actions/links/EmailLink",
		styleguidePath: "Actions/Links/EmailLink",
		importPath: "web-ui-components/lib/actions/links"
	},
	{
		name: "PhoneLink",
		path: "actions/links/PhoneLink",
		styleguidePath: "Actions/Links/PhoneLink",
		importPath: "web-ui-components/lib/actions/links"
	},
	{
		name: "WebsiteLink",
		path: "actions/links/WebsiteLink",
		styleguidePath: "Actions/Links/WebsiteLink",
		importPath: "web-ui-components/lib/actions/links"
	},
	{
		name: "InputRadio",
		path: "actions/radios/InputRadio",
		styleguidePath: "Actions/Radios/InputRadio",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "InputRadioGroup",
		path: "actions/radios/InputRadioGroup",
		styleguidePath: "Actions/Radios/InputRadioGroup",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "TallRadioCard",
		path: "actions/radios/TallRadioCard",
		styleguidePath: "Actions/Radios/TallRadioCard",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "WideRadioCard",
		path: "actions/radios/WideRadioCard",
		styleguidePath: "Actions/Radios/WideRadioCard",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "NewWindowAction",
		path: "advisor/actions/NewWindowAction",
		styleguidePath: "Advisor/Actions/NewWindowAction",
		importPath: "web-ui-components/lib/advisor/actions"
	},
	{
		name: "CustomerAlert",
		path: "advisor/alerts/CustomerAlert",
		styleguidePath: "Advisor/Alerts/CustomerAlert",
		importPath: "web-ui-components/lib/advisor/alerts"
	},
	{
		name: "ClickableContentFrame",
		path: "advisor/layout/ClickableContentFrame",
		styleguidePath: "Advisor/Layout/ClickableContentFrame",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "DashboardGrid",
		path: "advisor/layout/DashboardGrid",
		styleguidePath: "Advisor/Layout/DashboardGrid",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "WideModal",
		path: "advisor/layout/WideModal",
		styleguidePath: "Advisor/Layout/WideModal",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "WindowFrame",
		path: "advisor/layout/WindowFrame",
		styleguidePath: "Advisor/Layout/WindowFrame",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "ProductRadioCard",
		path: "advisor/radios/ProductRadioCard",
		styleguidePath: "Advisor/Radios/ProductRadioCard",
		importPath: "web-ui-components/lib/advisor/radios"
	},
	{
		name: "AccountSelect",
		path: "advisor/selects/AccountSelect",
		styleguidePath: "Advisor/Selects/AccountSelect",
		importPath: "web-ui-components/lib/advisor/selects"
	},
	{
		name: "SessionTimeoutTakeover",
		path: "advisor/takeovers/SessionTimeoutTakeover",
		styleguidePath: "Advisor/Takeovers/SessionTimeoutTakeover",
		importPath: "web-ui-components/lib/advisor/takeovers"
	},
	{
		name: "Anchor",
		path: "atoms/buttons/Anchor",
		styleguidePath: "Atoms/Buttons/Anchor",
		importPath: "web-ui-components/lib/atoms/buttons"
	},
	{
		name: "Button",
		path: "atoms/buttons/Button",
		styleguidePath: "Atoms/Buttons/Button",
		importPath: "web-ui-components/lib/atoms/buttons"
	},
	{
		name: "ButtonTitle",
		path: "atoms/buttons/ButtonTitle",
		styleguidePath: "Atoms/Buttons/ButtonTitle",
		importPath: "web-ui-components/lib/atoms/buttons"
	},
	{
		name: "Calendar",
		path: "atoms/forms/Calendar",
		styleguidePath: "Atoms/Forms/Calendar",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Checkbox",
		path: "atoms/forms/Checkbox",
		styleguidePath: "Atoms/Forms/Checkbox",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "CheckboxToggle",
		path: "atoms/forms/CheckboxToggle",
		styleguidePath: "Atoms/Forms/CheckboxToggle",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Datepicker",
		path: "atoms/forms/Datepicker",
		styleguidePath: "Atoms/Forms/Datepicker",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "FieldDescription",
		path: "atoms/forms/FieldDescription",
		styleguidePath: "Atoms/Forms/FieldDescription",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Input",
		path: "atoms/forms/Input/Input",
		styleguidePath: "Atoms/Forms/Input/Input",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "Prefix",
		path: "atoms/forms/Input/Prefix",
		styleguidePath: "Atoms/Forms/Input/Prefix",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "Suffix",
		path: "atoms/forms/Input/Suffix",
		styleguidePath: "Atoms/Forms/Input/Suffix",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "TextPrompt",
		path: "atoms/forms/Input/TextPrompt",
		styleguidePath: "Atoms/Forms/Input/TextPrompt",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "InputClickable",
		path: "atoms/forms/InputClickable",
		styleguidePath: "Atoms/Forms/InputClickable",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "InputRange",
		path: "atoms/forms/InputRange",
		styleguidePath: "Atoms/Forms/InputRange",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "LabelTitle",
		path: "atoms/forms/Label/LabelTitle",
		styleguidePath: "Atoms/Forms/Label/LabelTitle",
		importPath: "web-ui-components/lib/atoms/forms/label"
	},
	{
		name: "Label",
		path: "atoms/forms/Label",
		styleguidePath: "Atoms/Forms/Label",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "MediaCheckbox",
		path: "atoms/forms/MediaCheckbox",
		styleguidePath: "Atoms/Forms/MediaCheckbox",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "MediaRadio",
		path: "atoms/forms/MediaRadio",
		styleguidePath: "Atoms/Forms/MediaRadio",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "MultiSelect",
		path: "atoms/forms/MultiSelect",
		styleguidePath: "Atoms/Forms/MultiSelect",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Radio",
		path: "atoms/forms/Radio",
		styleguidePath: "Atoms/Forms/Radio",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "RadioCard",
		path: "atoms/forms/RadioCard",
		styleguidePath: "Atoms/Forms/RadioCard",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Select",
		path: "atoms/forms/Select",
		styleguidePath: "Atoms/Forms/Select",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Textarea",
		path: "atoms/forms/Textarea",
		styleguidePath: "Atoms/Forms/Textarea",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "TextAreaCharacterCount",
		path: "atoms/forms/TextAreaCharacterCount",
		styleguidePath: "Atoms/Forms/TextAreaCharacterCount",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "TimeEstimationIcon",
		path: "atoms/forms/TimeEstimationIcon",
		styleguidePath: "Atoms/Forms/TimeEstimationIcon",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "AnimatedIcon",
		path: "atoms/iconography/AnimatedIcon",
		styleguidePath: "Atoms/Iconography/AnimatedIcon",
		importPath: "web-ui-components/lib/atoms/iconography"
	},
	{
		name: "DistinctiveGeneratedSymbol",
		path: "atoms/iconography/DistinctiveGeneratedSymbol",
		styleguidePath: "Atoms/Iconography/DistinctiveGeneratedSymbol",
		importPath: "web-ui-components/lib/atoms/iconography"
	},
	{
		name: "Icon",
		path: "atoms/iconography/Icon",
		styleguidePath: "Atoms/Iconography/Icon",
		importPath: "web-ui-components/lib/atoms/iconography"
	},
	{
		name: "Divider",
		path: "atoms/layout/Divider",
		styleguidePath: "Atoms/Layout/Divider",
		importPath: "web-ui-components/lib/atoms/layout"
	},
	{
		name: "UploadPreviewContainer",
		path: "atoms/layout/UploadPreviewContainer",
		styleguidePath: "Atoms/Layout/UploadPreviewContainer",
		importPath: "web-ui-components/lib/atoms/layout"
	},
	{
		name: "AndroidStoreLogo",
		path: "atoms/logo/AndroidStoreLogo",
		styleguidePath: "Atoms/Logo/AndroidStoreLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "AppleStoreLogo",
		path: "atoms/logo/AppleStoreLogo",
		styleguidePath: "Atoms/Logo/AppleStoreLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "BankHeader",
		path: "atoms/logo/BankHeader",
		styleguidePath: "Atoms/Logo/BankHeader",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "BLogo",
		path: "atoms/logo/BLogo",
		styleguidePath: "Atoms/Logo/BLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "BLogoCircular",
		path: "atoms/logo/BLogoCircular",
		styleguidePath: "Atoms/Logo/BLogoCircular",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "CBLogo",
		path: "atoms/logo/CBLogo",
		styleguidePath: "Atoms/Logo/CBLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "CBLogoCircular",
		path: "atoms/logo/CBLogoCircular",
		styleguidePath: "Atoms/Logo/CBLogoCircular",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "Header",
		path: "atoms/logo/Header",
		styleguidePath: "Atoms/Logo/Header",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "SwitchGuaranteeLogo",
		path: "atoms/logo/SwitchGuaranteeLogo",
		styleguidePath: "Atoms/Logo/SwitchGuaranteeLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "VMSecondaryRedLogo",
		path: "atoms/logo/VMSecondaryRedLogo",
		styleguidePath: "Atoms/Logo/VMSecondaryRedLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "YBLogo",
		path: "atoms/logo/YBLogo",
		styleguidePath: "Atoms/Logo/YBLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "YBLogoCircular",
		path: "atoms/logo/YBLogoCircular",
		styleguidePath: "Atoms/Logo/YBLogoCircular",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "Popover",
		path: "atoms/popovers/Popover",
		styleguidePath: "Atoms/Popovers/Popover",
		importPath: "web-ui-components/lib/atoms/popovers"
	},
	{
		name: "IdentityProcessingSignal",
		path: "atoms/signals/IdentityProcessingSignal",
		styleguidePath: "Atoms/Signals/IdentityProcessingSignal",
		importPath: "web-ui-components/lib/atoms/signals"
	},
	{
		name: "UploadProcessingSignal",
		path: "atoms/signals/UploadProcessingSignal",
		styleguidePath: "Atoms/Signals/UploadProcessingSignal",
		importPath: "web-ui-components/lib/atoms/signals"
	},
	{
		name: "BadgeLabel",
		path: "atoms/text/BadgeLabel",
		styleguidePath: "Atoms/Text/BadgeLabel",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "BulletedList",
		path: "atoms/text/BulletedList",
		styleguidePath: "Atoms/Text/BulletedList",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "Callout",
		path: "atoms/text/Callout",
		styleguidePath: "Atoms/Text/Callout",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "List",
		path: "atoms/text/List",
		styleguidePath: "Atoms/Text/List",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "NumberedList",
		path: "atoms/text/NumberedList",
		styleguidePath: "Atoms/Text/NumberedList",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "StatusBadge",
		path: "atoms/text/StatusBadge",
		styleguidePath: "Atoms/Text/StatusBadge",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TextBody",
		path: "atoms/text/TextBody",
		styleguidePath: "Atoms/Text/TextBody",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TextStyled",
		path: "atoms/text/TextStyled",
		styleguidePath: "Atoms/Text/TextStyled",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TheSmallPrint",
		path: "atoms/text/TheSmallPrint",
		styleguidePath: "Atoms/Text/TheSmallPrint",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "Title",
		path: "atoms/text/Title",
		styleguidePath: "Atoms/Text/Title",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TransitionBlock",
		path: "atoms/transitions/TransitionBlock",
		styleguidePath: "Atoms/Transitions/TransitionBlock",
		importPath: "web-ui-components/lib/atoms/transitions"
	},
	{
		name: "EmailInput",
		path: "communication/email/text-inputs/EmailInput",
		styleguidePath: "Communication/Email/Text-inputs/EmailInput",
		importPath: "web-ui-components/lib/communication/email/text-inputs"
	},
	{
		name: "Mail",
		path: "communication/messaging/Mail",
		styleguidePath: "Communication/Messaging/Mail",
		importPath: "web-ui-components/lib/communication/messaging"
	},
	{
		name: "Webchat",
		path: "communication/support/Webchat",
		styleguidePath: "Communication/Support/Webchat",
		importPath: "web-ui-components/lib/communication/support"
	},
	{
		name: "CheckboxContainer",
		path: "data/capture/checkboxes/CheckboxContainer",
		styleguidePath: "Data/Capture/Checkboxes/CheckboxContainer",
		importPath: "web-ui-components/lib/data/capture/checkboxes"
	},
	{
		name: "GenericCheckbox",
		path: "data/capture/checkboxes/GenericCheckbox",
		styleguidePath: "Data/Capture/Checkboxes/GenericCheckbox",
		importPath: "web-ui-components/lib/data/capture/checkboxes"
	},
	{
		name: "StandaloneCheckbox",
		path: "data/capture/checkboxes/StandaloneCheckbox",
		styleguidePath: "Data/Capture/Checkboxes/StandaloneCheckbox",
		importPath: "web-ui-components/lib/data/capture/checkboxes"
	},
	{
		name: "AccountNumberInput",
		path: "data/capture/inputs/AccountNumberInput",
		styleguidePath: "Data/Capture/Inputs/AccountNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "DateOfBirthInput",
		path: "data/capture/inputs/DateOfBirthInput",
		styleguidePath: "Data/Capture/Inputs/DateOfBirthInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "FileUploadInput",
		path: "data/capture/inputs/FileUploadInput",
		styleguidePath: "Data/Capture/Inputs/FileUploadInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "GenericAlphaNumericInput",
		path: "data/capture/inputs/GenericAlphaNumericInput",
		styleguidePath: "Data/Capture/Inputs/GenericAlphaNumericInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "GenericIntegerInput",
		path: "data/capture/inputs/GenericIntegerInput",
		styleguidePath: "Data/Capture/Inputs/GenericIntegerInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "GenericTextInput",
		path: "data/capture/inputs/GenericTextInput",
		styleguidePath: "Data/Capture/Inputs/GenericTextInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "LandlineNumberInput",
		path: "data/capture/inputs/LandlineNumberInput",
		styleguidePath: "Data/Capture/Inputs/LandlineNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "MoneyInput",
		path: "data/capture/inputs/MoneyInput",
		styleguidePath: "Data/Capture/Inputs/MoneyInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "MonthAndYearDateInput",
		path: "data/capture/inputs/MonthAndYearDateInput",
		styleguidePath: "Data/Capture/Inputs/MonthAndYearDateInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "PasscodeNumberInput",
		path: "data/capture/inputs/PasscodeNumberInput",
		styleguidePath: "Data/Capture/Inputs/PasscodeNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "SliderInput",
		path: "data/capture/inputs/SliderInput",
		styleguidePath: "Data/Capture/Inputs/SliderInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "SortcodeInput",
		path: "data/capture/inputs/SortcodeInput",
		styleguidePath: "Data/Capture/Inputs/SortcodeInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "UKOnlyMobileNumberInput",
		path: "data/capture/inputs/UKOnlyMobileNumberInput",
		styleguidePath: "Data/Capture/Inputs/UKOnlyMobileNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "UKOnlyPostcodeInput",
		path: "data/capture/inputs/UKOnlyPostcodeInput",
		styleguidePath: "Data/Capture/Inputs/UKOnlyPostcodeInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "WorldwideMobileNumberInput",
		path: "data/capture/inputs/WorldwideMobileNumberInput",
		styleguidePath: "Data/Capture/Inputs/WorldwideMobileNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "YearsAndMonthsCountInput",
		path: "data/capture/inputs/YearsAndMonthsCountInput",
		styleguidePath: "Data/Capture/Inputs/YearsAndMonthsCountInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "DayOfMonthPicker",
		path: "data/capture/pickers/DayOfMonthPicker",
		styleguidePath: "Data/Capture/Pickers/DayOfMonthPicker",
		importPath: "web-ui-components/lib/data/capture/pickers"
	},
	{
		name: "FileProgressTakeover",
		path: "data/capture/progress/FileProgressTakeover",
		styleguidePath: "Data/Capture/Progress/FileProgressTakeover",
		importPath: "web-ui-components/lib/data/capture/progress"
	},
	{
		name: "GenericRadio",
		path: "data/capture/radios/GenericRadio",
		styleguidePath: "Data/Capture/Radios/GenericRadio",
		importPath: "web-ui-components/lib/data/capture/radios"
	},
	{
		name: "IconifiedRadio",
		path: "data/capture/radios/IconifiedRadio",
		styleguidePath: "Data/Capture/Radios/IconifiedRadio",
		importPath: "web-ui-components/lib/data/capture/radios"
	},
	{
		name: "RadioContainer",
		path: "data/capture/radios/RadioContainer",
		styleguidePath: "Data/Capture/Radios/RadioContainer",
		importPath: "web-ui-components/lib/data/capture/radios"
	},
	{
		name: "AccountCardSelect",
		path: "data/capture/selects/AccountCardSelect",
		styleguidePath: "Data/Capture/Selects/AccountCardSelect",
		importPath: "web-ui-components/lib/data/capture/selects"
	},
	{
		name: "GenericSelect",
		path: "data/capture/selects/GenericSelect",
		styleguidePath: "Data/Capture/Selects/GenericSelect",
		importPath: "web-ui-components/lib/data/capture/selects"
	},
	{
		name: "GenericTextArea",
		path: "data/capture/text-areas/GenericTextArea",
		styleguidePath: "Data/Capture/Text-areas/GenericTextArea",
		importPath: "web-ui-components/lib/data/capture/text-areas"
	},
	{
		name: "InternationalMoneyValue",
		path: "data/display/values/InternationalMoneyValue",
		styleguidePath: "Data/Display/Values/InternationalMoneyValue",
		importPath: "web-ui-components/lib/data/display/values"
	},
	{
		name: "MoneyValue",
		path: "data/display/values/MoneyValue",
		styleguidePath: "Data/Display/Values/MoneyValue",
		importPath: "web-ui-components/lib/data/display/values"
	},
	{
		name: "GenericPaginator",
		path: "data/filter-and-search/paginators/GenericPaginator",
		styleguidePath: "Data/Filter-and-search/Paginators/GenericPaginator",
		importPath: "web-ui-components/lib/data/filter-and-search/paginators"
	},
	{
		name: "SearchSelectInput",
		path: "data/filter-and-search/text-inputs/SearchSelectInput",
		styleguidePath: "Data/Filter-and-search/Text-inputs/SearchSelectInput",
		importPath: "web-ui-components/lib/data/filter-and-search/text-inputs"
	},
	{
		name: "SearchTextInput",
		path: "data/filter-and-search/text-inputs/SearchTextInput",
		styleguidePath: "Data/Filter-and-search/Text-inputs/SearchTextInput",
		importPath: "web-ui-components/lib/data/filter-and-search/text-inputs"
	},
	{
		name: "CompactDescriptionList",
		path: "data/lists/description-lists/CompactDescriptionList",
		styleguidePath: "Data/Lists/Description-lists/CompactDescriptionList",
		importPath: "web-ui-components/lib/data/lists/description-lists"
	},
	{
		name: "GenericDescriptionList",
		path: "data/lists/description-lists/GenericDescriptionList",
		styleguidePath: "Data/Lists/Description-lists/GenericDescriptionList",
		importPath: "web-ui-components/lib/data/lists/description-lists"
	},
	{
		name: "NoResultsTile",
		path: "data/results/tiles/NoResultsTile",
		styleguidePath: "Data/Results/Tiles/NoResultsTile",
		importPath: "web-ui-components/lib/data/results/tiles"
	},
	{
		name: "DocumentLink",
		path: "documents/navigation/links/DocumentLink",
		styleguidePath: "Documents/Navigation/Links/DocumentLink",
		importPath: "web-ui-components/lib/documents/navigation/links"
	},
	{
		name: "DocumentLinkPlate",
		path: "documents/navigation/plates/DocumentLinkPlate",
		styleguidePath: "Documents/Navigation/Plates/DocumentLinkPlate",
		importPath: "web-ui-components/lib/documents/navigation/plates"
	},
	{
		name: "PrintButton",
		path: "documents/printing/buttons/PrintButton",
		styleguidePath: "Documents/Printing/Buttons/PrintButton",
		importPath: "web-ui-components/lib/documents/printing/buttons"
	},
	{
		name: "DocumentStatusBandCard",
		path: "documents/statuses/cards/DocumentStatusBandCard",
		styleguidePath: "Documents/Statuses/Cards/DocumentStatusBandCard",
		importPath: "web-ui-components/lib/documents/statuses/cards"
	},
	{
		name: "FileInput",
		path: "documents/upload/FileInput",
		styleguidePath: "Documents/Upload/FileInput",
		importPath: "web-ui-components/lib/documents/upload"
	},
	{
		name: "AccountCheckboxCard",
		path: "finance/accounts/cards/AccountCheckboxCard",
		styleguidePath: "Finance/Accounts/Cards/AccountCheckboxCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountLegacyUpdateCard",
		path: "finance/accounts/cards/AccountLegacyUpdateCard",
		styleguidePath: "Finance/Accounts/Cards/AccountLegacyUpdateCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountLinkCard",
		path: "finance/accounts/cards/AccountLinkCard",
		styleguidePath: "Finance/Accounts/Cards/AccountLinkCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountPoolCard",
		path: "finance/accounts/cards/AccountPoolCard",
		styleguidePath: "Finance/Accounts/Cards/AccountPoolCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountSelectCard",
		path: "finance/accounts/cards/AccountSelectCard",
		styleguidePath: "Finance/Accounts/Cards/AccountSelectCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountStaticCard",
		path: "finance/accounts/cards/AccountStaticCard",
		styleguidePath: "Finance/Accounts/Cards/AccountStaticCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountAuthorisationPanel",
		path: "finance/accounts/panels/AccountAuthorisationPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountAuthorisationPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountBalancesSelectPanel",
		path: "finance/accounts/panels/AccountBalancesSelectPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountBalancesSelectPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountLegacyPanel",
		path: "finance/accounts/panels/AccountLegacyPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountLegacyPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountPaymentStatusPanel",
		path: "finance/accounts/panels/AccountPaymentStatusPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountPaymentStatusPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountPoolTablePanel",
		path: "finance/accounts/panels/AccountPoolTablePanel",
		styleguidePath: "Finance/Accounts/Panels/AccountPoolTablePanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountRadioCard",
		path: "finance/accounts/radios/AccountRadioCard",
		styleguidePath: "Finance/Accounts/Radios/AccountRadioCard",
		importPath: "web-ui-components/lib/finance/accounts/radios"
	},
	{
		name: "AccountPaymentReviewTable",
		path: "finance/accounts/tables/AccountPaymentReviewTable",
		styleguidePath: "Finance/Accounts/Tables/AccountPaymentReviewTable",
		importPath: "web-ui-components/lib/finance/accounts/tables"
	},
	{
		name: "AccountPaymentSubmittedTable",
		path: "finance/accounts/tables/AccountPaymentSubmittedTable",
		styleguidePath: "Finance/Accounts/Tables/AccountPaymentSubmittedTable",
		importPath: "web-ui-components/lib/finance/accounts/tables"
	},
	{
		name: "AccountPaymentTable",
		path: "finance/accounts/tables/AccountPaymentTable",
		styleguidePath: "Finance/Accounts/Tables/AccountPaymentTable",
		importPath: "web-ui-components/lib/finance/accounts/tables"
	},
	{
		name: "AccountSummaryTile",
		path: "finance/accounts/tiles/AccountSummaryTile",
		styleguidePath: "Finance/Accounts/Tiles/AccountSummaryTile",
		importPath: "web-ui-components/lib/finance/accounts/tiles"
	},
	{
		name: "CurrencySelect",
		path: "finance/currency/selects/CurrencySelect",
		styleguidePath: "Finance/Currency/Selects/CurrencySelect",
		importPath: "web-ui-components/lib/finance/currency/selects"
	},
	{
		name: "BlockField",
		path: "global/layout/BlockField",
		styleguidePath: "Global/Layout/BlockField",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "BlockFieldColumn",
		path: "global/layout/BlockFieldColumn",
		styleguidePath: "Global/Layout/BlockFieldColumn",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "CenterImageContainer",
		path: "global/layout/CenterImageContainer",
		styleguidePath: "Global/Layout/CenterImageContainer",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Column",
		path: "global/layout/Column",
		styleguidePath: "Global/Layout/Column",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Container",
		path: "global/layout/Container",
		styleguidePath: "Global/Layout/Container",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "FlexColumn",
		path: "global/layout/FlexColumn",
		styleguidePath: "Global/Layout/FlexColumn",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "FlexRow",
		path: "global/layout/FlexRow",
		styleguidePath: "Global/Layout/FlexRow",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Frame",
		path: "global/layout/Frame",
		styleguidePath: "Global/Layout/Frame",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "InternalSlot",
		path: "global/layout/InternalSlot",
		styleguidePath: "Global/Layout/InternalSlot",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "LeftAndRightAlignment",
		path: "global/layout/LeftAndRightAlignment",
		styleguidePath: "Global/Layout/LeftAndRightAlignment",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "PageLayout",
		path: "global/layout/PageLayout",
		styleguidePath: "Global/Layout/PageLayout",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "HeaderSection",
		path: "global/layout/Pages/HeaderSection",
		styleguidePath: "Global/Layout/Pages/HeaderSection",
		importPath: "web-ui-components/lib/global/layout/pages"
	},
	{
		name: "ServicingSection",
		path: "global/layout/Pages/ServicingSection",
		styleguidePath: "Global/Layout/Pages/ServicingSection",
		importPath: "web-ui-components/lib/global/layout/pages"
	},
	{
		name: "WorkflowSection",
		path: "global/layout/Pages/WorkflowSection",
		styleguidePath: "Global/Layout/Pages/WorkflowSection",
		importPath: "web-ui-components/lib/global/layout/pages"
	},
	{
		name: "ResponsiveLayoutPair",
		path: "global/layout/ResponsiveLayoutPair",
		styleguidePath: "Global/Layout/ResponsiveLayoutPair",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Row",
		path: "global/layout/Row",
		styleguidePath: "Global/Layout/Row",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "ContentContainer",
		path: "layout/containers/ContentContainer",
		styleguidePath: "Layout/Containers/ContentContainer",
		importPath: "web-ui-components/lib/layout/containers"
	},
	{
		name: "Main",
		path: "layout/containers/Main",
		styleguidePath: "Layout/Containers/Main",
		importPath: "web-ui-components/lib/layout/containers"
	},
	{
		name: "GenericAccordion",
		path: "layout/content/accordions/GenericAccordion",
		styleguidePath: "Layout/Content/Accordions/GenericAccordion",
		importPath: "web-ui-components/lib/layout/content/accordions"
	},
	{
		name: "StatusBanner",
		path: "layout/content/banners/StatusBanner",
		styleguidePath: "Layout/Content/Banners/StatusBanner",
		importPath: "web-ui-components/lib/layout/content/banners"
	},
	{
		name: "GenericDivider",
		path: "layout/content/breaks/GenericDivider",
		styleguidePath: "Layout/Content/Breaks/GenericDivider",
		importPath: "web-ui-components/lib/layout/content/breaks"
	},
	{
		name: "GenericModal",
		path: "layout/content/modals/GenericModal",
		styleguidePath: "Layout/Content/Modals/GenericModal",
		importPath: "web-ui-components/lib/layout/content/modals"
	},
	{
		name: "InformationModal",
		path: "layout/content/modals/InformationModal",
		styleguidePath: "Layout/Content/Modals/InformationModal",
		importPath: "web-ui-components/lib/layout/content/modals"
	},
	{
		name: "MultiButtonModal",
		path: "layout/content/modals/MultiButtonModal",
		styleguidePath: "Layout/Content/Modals/MultiButtonModal",
		importPath: "web-ui-components/lib/layout/content/modals"
	},
	{
		name: "BrandedPanel",
		path: "layout/content/panels/BrandedPanel",
		styleguidePath: "Layout/Content/Panels/BrandedPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ConditionalPanel",
		path: "layout/content/panels/ConditionalPanel",
		styleguidePath: "Layout/Content/Panels/ConditionalPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ContentRevealPanel",
		path: "layout/content/panels/ContentRevealPanel",
		styleguidePath: "Layout/Content/Panels/ContentRevealPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "GenericPanel",
		path: "layout/content/panels/GenericPanel",
		styleguidePath: "Layout/Content/Panels/GenericPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "InformationRevealPanel",
		path: "layout/content/panels/InformationRevealPanel",
		styleguidePath: "Layout/Content/Panels/InformationRevealPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ShellPanel",
		path: "layout/content/panels/ShellPanel",
		styleguidePath: "Layout/Content/Panels/ShellPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ShellSidebarPanel",
		path: "layout/content/panels/ShellSidebarPanel",
		styleguidePath: "Layout/Content/Panels/ShellSidebarPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "SimplePanel",
		path: "layout/content/panels/SimplePanel",
		styleguidePath: "Layout/Content/Panels/SimplePanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "StatusPanel",
		path: "layout/content/panels/StatusPanel",
		styleguidePath: "Layout/Content/Panels/StatusPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "SubformRevealPanel",
		path: "layout/content/panels/SubformRevealPanel",
		styleguidePath: "Layout/Content/Panels/SubformRevealPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ToggleButtonPanel",
		path: "layout/content/panels/ToggleButtonPanel",
		styleguidePath: "Layout/Content/Panels/ToggleButtonPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ProcessingScreenTakeover",
		path: "layout/content/takeovers/ProcessingScreenTakeover",
		styleguidePath: "Layout/Content/Takeovers/ProcessingScreenTakeover",
		importPath: "web-ui-components/lib/layout/content/takeovers"
	},
	{
		name: "AttentionTile",
		path: "layout/content/tiles/AttentionTile",
		styleguidePath: "Layout/Content/Tiles/AttentionTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "GuidanceTile",
		path: "layout/content/tiles/GuidanceTile",
		styleguidePath: "Layout/Content/Tiles/GuidanceTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "OutcomeTile",
		path: "layout/content/tiles/OutcomeTile",
		styleguidePath: "Layout/Content/Tiles/OutcomeTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "RecapTile",
		path: "layout/content/tiles/RecapTile",
		styleguidePath: "Layout/Content/Tiles/RecapTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "StandoutTile",
		path: "layout/content/tiles/StandoutTile",
		styleguidePath: "Layout/Content/Tiles/StandoutTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "ValidationMessageTile",
		path: "layout/content/tiles/ValidationMessageTile",
		styleguidePath: "Layout/Content/Tiles/ValidationMessageTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "GridListToggle",
		path: "layout/content/views/GridListToggle",
		styleguidePath: "Layout/Content/Views/GridListToggle",
		importPath: "web-ui-components/lib/layout/content/views"
	},
	{
		name: "GridViewToggle",
		path: "layout/content/views/GridViewToggle",
		styleguidePath: "Layout/Content/Views/GridViewToggle",
		importPath: "web-ui-components/lib/layout/content/views"
	},
	{
		name: "GenericFieldWrapper",
		path: "layout/fieldWrappers/GenericFieldWrapper",
		styleguidePath: "Layout/Field-wrappers/GenericFieldWrapper",
		importPath: "web-ui-components/lib/layout/fieldWrappers"
	},
	{
		name: "GroupFieldWrapper",
		path: "layout/fieldWrappers/GroupFieldWrapper",
		styleguidePath: "Layout/Field-wrappers/GroupFieldWrapper",
		importPath: "web-ui-components/lib/layout/fieldWrappers"
	},
	{
		name: "MainFixedFooter",
		path: "layout/footers/MainFixedFooter",
		styleguidePath: "Layout/Footers/MainFixedFooter",
		importPath: "web-ui-components/lib/layout/footers"
	},
	{
		name: "Grid",
		path: "layout/grids/Grid",
		styleguidePath: "Layout/Grids/Grid",
		importPath: "web-ui-components/lib/layout/grids"
	},
	{
		name: "Inline",
		path: "layout/grids/Inline",
		styleguidePath: "Layout/Grids/Inline",
		importPath: "web-ui-components/lib/layout/grids"
	},
	{
		name: "ContainedHeader",
		path: "layout/headers/ContainedHeader",
		styleguidePath: "Layout/Headers/ContainedHeader",
		importPath: "web-ui-components/lib/layout/headers"
	},
	{
		name: "FixedFooter",
		path: "layout/sections/footers/FixedFooter",
		styleguidePath: "Layout/Sections/Footers/FixedFooter",
		importPath: "web-ui-components/lib/layout/sections/footers"
	},
	{
		name: "ApplicationFormShell",
		path: "layout/shells/ApplicationFormShell",
		styleguidePath: "Layout/Shells/ApplicationFormShell",
		importPath: "web-ui-components/lib/layout/shells"
	},
	{
		name: "DataManagementShell",
		path: "layout/shells/DataManagementShell",
		styleguidePath: "Layout/Shells/DataManagementShell",
		importPath: "web-ui-components/lib/layout/shells"
	},
	{
		name: "ShellInnerSpacer",
		path: "layout/shells/ShellInnerSpacer",
		styleguidePath: "Layout/Shells/ShellInnerSpacer",
		importPath: "web-ui-components/lib/layout/shells"
	},
	{
		name: "VerticalReviewTable",
		path: "layout/tables/VerticalReviewTable",
		styleguidePath: "Layout/Tables/VerticalReviewTable",
		importPath: "web-ui-components/lib/layout/tables"
	},
	{
		name: "NonUKAddressFieldset",
		path: "location/addresses/fieldsets/NonUKAddressFieldset",
		styleguidePath: "Location/Addresses/Fieldsets/NonUKAddressFieldset",
		importPath: "web-ui-components/lib/location/addresses/fieldsets"
	},
	{
		name: "UKAddressFieldset",
		path: "location/addresses/fieldsets/UKAddressFieldset",
		styleguidePath: "Location/Addresses/Fieldsets/UKAddressFieldset",
		importPath: "web-ui-components/lib/location/addresses/fieldsets"
	},
	{
		name: "UKAddressCaptureModule",
		path: "location/addresses/modules/UKAddressCaptureModule",
		styleguidePath: "Location/Addresses/Modules/UKAddressCaptureModule",
		importPath: "web-ui-components/lib/location/addresses/modules"
	},
	{
		name: "UKAddressCaptureModule2",
		path: "location/addresses/modules/UKAddressCaptureModule2",
		styleguidePath: "Location/Addresses/Modules/UKAddressCaptureModule2",
		importPath: "web-ui-components/lib/location/addresses/modules"
	},
	{
		name: "BaseSelect",
		path: "location/places/selects/BaseSelect",
		styleguidePath: "Location/Places/Selects/BaseSelect",
		importPath: "web-ui-components/lib/location/places/selects"
	},
	{
		name: "CountrySelect",
		path: "location/places/selects/CountrySelect",
		styleguidePath: "Location/Places/Selects/CountrySelect",
		importPath: "web-ui-components/lib/location/places/selects"
	},
	{
		name: "UKCitySelect",
		path: "location/places/selects/UKCitySelect",
		styleguidePath: "Location/Places/Selects/UKCitySelect",
		importPath: "web-ui-components/lib/location/places/selects"
	},
	{
		name: "AccordionItem",
		path: "molecules/accordions/Accordion/AccordionItem",
		styleguidePath: "Molecules/Accordions/Accordion/AccordionItem",
		importPath: "web-ui-components/lib/molecules/accordions/accordion"
	},
	{
		name: "Accordion",
		path: "molecules/accordions/Accordion",
		styleguidePath: "Molecules/Accordions/Accordion",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "AccordionTable",
		path: "molecules/accordions/AccordionTable",
		styleguidePath: "Molecules/Accordions/AccordionTable",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ContentReveal",
		path: "molecules/accordions/ContentReveal",
		styleguidePath: "Molecules/Accordions/ContentReveal",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ExpansionPanel",
		path: "molecules/accordions/ExpansionPanel",
		styleguidePath: "Molecules/Accordions/ExpansionPanel",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ExpansionTable",
		path: "molecules/accordions/ExpansionTable",
		styleguidePath: "Molecules/Accordions/ExpansionTable",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ButtonGroup",
		path: "molecules/buttons/ButtonGroup",
		styleguidePath: "Molecules/Buttons/ButtonGroup",
		importPath: "web-ui-components/lib/molecules/buttons"
	},
	{
		name: "SortingCardGroup",
		path: "molecules/card-groups/SortingCardGroup",
		styleguidePath: "Molecules/Card-groups/SortingCardGroup",
		importPath: "web-ui-components/lib/molecules/card-groups"
	},
	{
		name: "AccountCard",
		path: "molecules/cards/AccountCard",
		styleguidePath: "Molecules/Cards/AccountCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "AccountSummaryLinkCard",
		path: "molecules/cards/AccountSummaryLinkCard",
		styleguidePath: "Molecules/Cards/AccountSummaryLinkCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "DateCard",
		path: "molecules/cards/DateCard",
		styleguidePath: "Molecules/Cards/DateCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "PromoCard",
		path: "molecules/cards/PromoCard",
		styleguidePath: "Molecules/Cards/PromoCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "StackingCard",
		path: "molecules/cards/StackingCard",
		styleguidePath: "Molecules/Cards/StackingCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "Autocomplete",
		path: "molecules/forms/Autocomplete",
		styleguidePath: "Molecules/Forms/Autocomplete",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "ConfirmationCheckbox",
		path: "molecules/forms/ConfirmationCheckbox",
		styleguidePath: "Molecules/Forms/ConfirmationCheckbox",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "DaySelector",
		path: "molecules/forms/DaySelector",
		styleguidePath: "Molecules/Forms/DaySelector",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "FieldBody",
		path: "molecules/forms/Field/FieldBody",
		styleguidePath: "Molecules/Forms/Field/FieldBody",
		importPath: "web-ui-components/lib/molecules/forms/field"
	},
	{
		name: "FieldHeader",
		path: "molecules/forms/Field/FieldHeader",
		styleguidePath: "Molecules/Forms/Field/FieldHeader",
		importPath: "web-ui-components/lib/molecules/forms/field"
	},
	{
		name: "FormField",
		path: "molecules/forms/Field/FormField",
		styleguidePath: "Molecules/Forms/Field/FormField",
		importPath: "web-ui-components/lib/molecules/forms/field"
	},
	{
		name: "Field",
		path: "molecules/forms/Field",
		styleguidePath: "Molecules/Forms/Field",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "PasswordReveal",
		path: "molecules/forms/PasswordReveal",
		styleguidePath: "Molecules/Forms/PasswordReveal",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "RadioCardGroup",
		path: "molecules/forms/RadioCardGroup",
		styleguidePath: "Molecules/Forms/RadioCardGroup",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "Search",
		path: "molecules/forms/Search",
		styleguidePath: "Molecules/Forms/Search",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "SearchForm",
		path: "molecules/forms/SearchForm",
		styleguidePath: "Molecules/Forms/SearchForm",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "SegmentedControl",
		path: "molecules/forms/SegmentedControl",
		styleguidePath: "Molecules/Forms/SegmentedControl",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "SegmentedControlItem",
		path: "molecules/forms/SegmentedControl/SegmentedControlItem",
		styleguidePath: "Molecules/Forms/SegmentedControl/SegmentedControlItem",
		importPath: "web-ui-components/lib/molecules/forms/segmentedControl"
	},
	{
		name: "SegmentedSlider",
		path: "molecules/forms/SegmentedSlider",
		styleguidePath: "Molecules/Forms/SegmentedSlider",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "ValidationMessage",
		path: "molecules/forms/ValidationMessage",
		styleguidePath: "Molecules/Forms/ValidationMessage",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "IconTextDynamic",
		path: "molecules/icon-text-dynamic/IconTextDynamic",
		styleguidePath: "Molecules/IconTextDynamic/IconTextDynamic",
		importPath: "web-ui-components/lib/molecules/icon-text-dynamic"
	},
	{
		name: "IconText",
		path: "molecules/icon-text/IconText",
		styleguidePath: "Molecules/IconText/IconText",
		importPath: "web-ui-components/lib/molecules/icon-text"
	},
	{
		name: "BackAnchor",
		path: "molecules/navigation/BackAnchor",
		styleguidePath: "Molecules/Navigation/BackAnchor",
		importPath: "web-ui-components/lib/molecules/navigation"
	},
	{
		name: "BackButton",
		path: "molecules/navigation/BackButton",
		styleguidePath: "Molecules/Navigation/BackButton",
		importPath: "web-ui-components/lib/molecules/navigation"
	},
	{
		name: "Utility",
		path: "molecules/navigation/Utility",
		styleguidePath: "Molecules/Navigation/Utility",
		importPath: "web-ui-components/lib/molecules/navigation"
	},
	{
		name: "Alert",
		path: "molecules/nbas/Alert",
		styleguidePath: "Molecules/NBAS/Alert",
		importPath: "web-ui-components/lib/molecules/nbas"
	},
	{
		name: "Promo",
		path: "molecules/nbas/Promo",
		styleguidePath: "Molecules/NBAS/Promo",
		importPath: "web-ui-components/lib/molecules/nbas"
	},
	{
		name: "ContrastingFormPanel",
		path: "molecules/panels/ContrastingFormPanel",
		styleguidePath: "Molecules/Panels/ContrastingFormPanel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "DocumentAction",
		path: "molecules/panels/DocumentAction",
		styleguidePath: "Molecules/Panels/DocumentAction",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "IconifiedBulletPoint",
		path: "molecules/panels/IconifiedBulletPoint",
		styleguidePath: "Molecules/Panels/IconifiedBulletPoint",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "Panel",
		path: "molecules/panels/Panel",
		styleguidePath: "Molecules/Panels/Panel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "PanelBody",
		path: "molecules/panels/Panel/PanelBody",
		styleguidePath: "Molecules/Panels/Panel/PanelBody",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "PanelFooter",
		path: "molecules/panels/Panel/PanelFooter",
		styleguidePath: "Molecules/Panels/Panel/PanelFooter",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "PanelHeader",
		path: "molecules/panels/Panel/PanelHeader",
		styleguidePath: "Molecules/Panels/Panel/PanelHeader",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "PanelSector",
		path: "molecules/panels/Panel/PanelSector",
		styleguidePath: "Molecules/Panels/Panel/PanelSector",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "SettingLink",
		path: "molecules/panels/SettingLink",
		styleguidePath: "Molecules/Panels/SettingLink",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "SubordinatePanel",
		path: "molecules/panels/SubordinatePanel",
		styleguidePath: "Molecules/Panels/SubordinatePanel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "TogglePanel",
		path: "molecules/panels/TogglePanel",
		styleguidePath: "Molecules/Panels/TogglePanel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "PayeeCard",
		path: "molecules/payee-cards/PayeeCard",
		styleguidePath: "Molecules/PayeeCard/PayeeCard",
		importPath: "web-ui-components/lib/molecules/payee-cards"
	},
	{
		name: "PaymentReview",
		path: "molecules/payments/PaymentReview",
		styleguidePath: "Molecules/Payments/PaymentReview",
		importPath: "web-ui-components/lib/molecules/payments"
	},
	{
		name: "ProgressIndicator",
		path: "molecules/progress/ProgressIndicator",
		styleguidePath: "Molecules/Progress/ProgressIndicator",
		importPath: "web-ui-components/lib/molecules/progress"
	},
	{
		name: "ProgressIndicatorItem",
		path: "molecules/progress/ProgressIndicator/ProgressIndicatorItem",
		styleguidePath: "Molecules/Progress/ProgressIndicator/ProgressIndicatorItem",
		importPath: "web-ui-components/lib/molecules/progress/progressIndicator"
	},
	{
		name: "ComparisonTable",
		path: "molecules/tables/ComparisonTable",
		styleguidePath: "Molecules/Tables/ComparisonTable",
		importPath: "web-ui-components/lib/molecules/tables"
	},
	{
		name: "DataTable",
		path: "molecules/tables/Table/DataTable",
		styleguidePath: "Molecules/Tables/Table/DataTable",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "Table",
		path: "molecules/tables/Table/Table",
		styleguidePath: "Molecules/Tables/Table/Table",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableBody",
		path: "molecules/tables/Table/TableBody",
		styleguidePath: "Molecules/Tables/Table/TableBody",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableBodyData",
		path: "molecules/tables/Table/TableBodyData",
		styleguidePath: "Molecules/Tables/Table/TableBodyData",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableHead",
		path: "molecules/tables/Table/TableHead",
		styleguidePath: "Molecules/Tables/Table/TableHead",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableHeadData",
		path: "molecules/tables/Table/TableHeadData",
		styleguidePath: "Molecules/Tables/Table/TableHeadData",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableRow",
		path: "molecules/tables/Table/TableRow",
		styleguidePath: "Molecules/Tables/Table/TableRow",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "SectionHeading",
		path: "molecules/text/SectionHeading",
		styleguidePath: "Molecules/Text/SectionHeading",
		importPath: "web-ui-components/lib/molecules/text"
	},
	{
		name: "ConfirmationTile",
		path: "molecules/tile/ConfirmationTile",
		styleguidePath: "Molecules/Tile/ConfirmationTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "ExclamationTile",
		path: "molecules/tile/ExclamationTile",
		styleguidePath: "Molecules/Tile/ExclamationTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "HighlightTile",
		path: "molecules/tile/HighlightTile",
		styleguidePath: "Molecules/Tile/HighlightTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "IconTile",
		path: "molecules/tile/IconTile",
		styleguidePath: "Molecules/Tile/IconTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "NumberedTile",
		path: "molecules/tile/NumberedTile",
		styleguidePath: "Molecules/Tile/NumberedTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "Tile",
		path: "molecules/tile/Tile",
		styleguidePath: "Molecules/Tile/Tile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "TileSector",
		path: "molecules/tile/Tile/TileSector",
		styleguidePath: "Molecules/Tile/Tile/TileSector",
		importPath: "web-ui-components/lib/molecules/tile/tile"
	},
	{
		name: "TileSegment",
		path: "molecules/tile/Tile/TileSegment",
		styleguidePath: "Molecules/Tile/Tile/TileSegment",
		importPath: "web-ui-components/lib/molecules/tile/tile"
	},
	{
		name: "ToggleOption",
		path: "molecules/toggle/ToggleOption",
		styleguidePath: "Molecules/Toggle/ToggleOption",
		importPath: "web-ui-components/lib/molecules/toggle"
	},
	{
		name: "PromoAnchor",
		path: "navigation/anchors/PromoAnchor",
		styleguidePath: "Navigation/Anchors/PromoAnchor",
		importPath: "web-ui-components/lib/navigation/anchors"
	},
	{
		name: "NavigationButton",
		path: "navigation/buttons/NavigationButton",
		styleguidePath: "Navigation/Buttons/NavigationButton",
		importPath: "web-ui-components/lib/navigation/buttons"
	},
	{
		name: "NavigationButtonGroup",
		path: "navigation/buttons/NavigationButtonGroup",
		styleguidePath: "Navigation/Buttons/NavigationButtonGroup",
		importPath: "web-ui-components/lib/navigation/buttons"
	},
	{
		name: "PromoButton",
		path: "navigation/buttons/PromoButton",
		styleguidePath: "Navigation/Buttons/PromoButton",
		importPath: "web-ui-components/lib/navigation/buttons"
	},
	{
		name: "ProgressStepper",
		path: "navigation/indicators/ProgressStepper",
		styleguidePath: "Navigation/Indicators/ProgressStepper",
		importPath: "web-ui-components/lib/navigation/indicators"
	},
	{
		name: "VerticalMenu",
		path: "navigation/menus/VerticalMenu",
		styleguidePath: "Navigation/Menus/VerticalMenu",
		importPath: "web-ui-components/lib/navigation/menus"
	},
	{
		name: "MainNavLink",
		path: "navigation/nav-links/MainNavLink",
		styleguidePath: "Navigation/Nav-links/MainNavLink",
		importPath: "web-ui-components/lib/navigation/nav-links"
	},
	{
		name: "Paginator",
		path: "navigation/pagination/Paginator",
		styleguidePath: "Navigation/Pagination/Paginator",
		importPath: "web-ui-components/lib/navigation/pagination"
	},
	{
		name: "PaginatorNextButton",
		path: "navigation/pagination/Paginator/PaginatorNextButton",
		styleguidePath: "Navigation/Pagination/Paginator/PaginatorNextButton",
		importPath: "web-ui-components/lib/navigation/pagination/paginator"
	},
	{
		name: "PaginatorPageButton",
		path: "navigation/pagination/Paginator/PaginatorPageButton",
		styleguidePath: "Navigation/Pagination/Paginator/PaginatorPageButton",
		importPath: "web-ui-components/lib/navigation/pagination/paginator"
	},
	{
		name: "PaginatorPreviousButton",
		path: "navigation/pagination/Paginator/PaginatorPreviousButton",
		styleguidePath: "Navigation/Pagination/Paginator/PaginatorPreviousButton",
		importPath: "web-ui-components/lib/navigation/pagination/paginator"
	},
	{
		name: "MainSiteNav",
		path: "navigation/site-navs/MainSiteNav",
		styleguidePath: "Navigation/Site-navs/MainSiteNav",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "MobileMainSiteNav",
		path: "navigation/site-navs/MobileMainSiteNav",
		styleguidePath: "Navigation/Site-navs/MobileMainSiteNav",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "UtilityNav",
		path: "navigation/site-navs/UtilityNav",
		styleguidePath: "Navigation/Site-navs/UtilityNav",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "UtilityNavButton",
		path: "navigation/site-navs/UtilityNavButton",
		styleguidePath: "Navigation/Site-navs/UtilityNavButton",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "TabCard",
		path: "navigation/tab-cards/TabCard",
		styleguidePath: "Navigation/Tab-cards/TabCard",
		importPath: "web-ui-components/lib/navigation/tab-cards"
	},
	{
		name: "TabCardBlock",
		path: "navigation/tab-cards/TabCardBlock",
		styleguidePath: "Navigation/Tab-cards/TabCardBlock",
		importPath: "web-ui-components/lib/navigation/tab-cards"
	},
	{
		name: "TabCardSmall",
		path: "navigation/tab-cards/TabCardSmall",
		styleguidePath: "Navigation/Tab-cards/TabCardSmall",
		importPath: "web-ui-components/lib/navigation/tab-cards"
	},
	{
		name: "TabGroup",
		path: "navigation/tab-group/TabGroup",
		styleguidePath: "Navigation/Tab-group/TabGroup",
		importPath: "web-ui-components/lib/navigation/tab-group"
	},
	{
		name: "TransferTakeover",
		path: "navigation/takeovers/TransferTakeover",
		styleguidePath: "Navigation/Takeovers/TransferTakeover",
		importPath: "web-ui-components/lib/navigation/takeovers"
	},
	{
		name: "Card",
		path: "organisms/cards/Card",
		styleguidePath: "Organisms/Cards/Card",
		importPath: "web-ui-components/lib/organisms/cards"
	},
	{
		name: "DistinctiveLinkCard",
		path: "organisms/cards/DistinctiveLinkCard",
		styleguidePath: "Organisms/Cards/DistinctiveLinkCard",
		importPath: "web-ui-components/lib/organisms/cards"
	},
	{
		name: "FilterAction",
		path: "organisms/filters/Filter/FilterActionGroup/FilterAction",
		styleguidePath: "Organisms/Filters/Filter/FilterActionGroup/FilterAction",
		importPath: "web-ui-components/lib/organisms/filters/filter/filterActionGroup"
	},
	{
		name: "FilterActionGroup",
		path: "organisms/filters/Filter/FilterActionGroup",
		styleguidePath: "Organisms/Filters/Filter/FilterActionGroup",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "FilterSector",
		path: "organisms/filters/Filter/FilterSector",
		styleguidePath: "Organisms/Filters/Filter/FilterSector",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "FilterSegment",
		path: "organisms/filters/Filter/FilterSegmentGroup/FilterSegment",
		styleguidePath: "Organisms/Filters/Filter/FilterSegmentGroup/FilterSegment",
		importPath: "web-ui-components/lib/organisms/filters/filter/filterSegmentGroup"
	},
	{
		name: "FilterSegmentGroup",
		path: "organisms/filters/Filter/FilterSegmentGroup",
		styleguidePath: "Organisms/Filters/Filter/FilterSegmentGroup",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "FilterSubSegment",
		path: "organisms/filters/Filter/FilterSubSegmentGroup/FilterSubSegment",
		styleguidePath: "Organisms/Filters/Filter/FilterSubSegmentGroup/FilterSubSegment",
		importPath: "web-ui-components/lib/organisms/filters/filter/filterSubSegmentGroup"
	},
	{
		name: "FilterSubSegmentGroup",
		path: "organisms/filters/Filter/FilterSubSegmentGroup",
		styleguidePath: "Organisms/Filters/Filter/FilterSubSegmentGroup",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "Filter",
		path: "organisms/filters/Filter",
		styleguidePath: "Organisms/Filters/Filter",
		importPath: "web-ui-components/lib/organisms/filters"
	},
	{
		name: "GlobalHeader",
		path: "organisms/global/GlobalHeader",
		styleguidePath: "Organisms/Global/GlobalHeader",
		importPath: "web-ui-components/lib/organisms/global"
	},
	{
		name: "HeroHeader",
		path: "organisms/global/HeroHeader",
		styleguidePath: "Organisms/Global/HeroHeader",
		importPath: "web-ui-components/lib/organisms/global"
	},
	{
		name: "CentredModal",
		path: "organisms/modals/CentredModal",
		styleguidePath: "Organisms/Modals/CentredModal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "ConfirmationModal",
		path: "organisms/modals/ConfirmationModal",
		styleguidePath: "Organisms/Modals/ConfirmationModal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "Loader",
		path: "organisms/modals/Loader",
		styleguidePath: "Organisms/Modals/Loader",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "ModalBody",
		path: "organisms/modals/Modal/ModalBody",
		styleguidePath: "Organisms/Modals/Modal/ModalBody",
		importPath: "web-ui-components/lib/organisms/modals/modal"
	},
	{
		name: "ModalContainer",
		path: "organisms/modals/Modal/ModalContainer",
		styleguidePath: "Organisms/Modals/Modal/ModalContainer",
		importPath: "web-ui-components/lib/organisms/modals/modal"
	},
	{
		name: "ModalHeader",
		path: "organisms/modals/Modal/ModalHeader",
		styleguidePath: "Organisms/Modals/Modal/ModalHeader",
		importPath: "web-ui-components/lib/organisms/modals/modal"
	},
	{
		name: "Modal",
		path: "organisms/modals/Modal",
		styleguidePath: "Organisms/Modals/Modal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "UnfinishedWorkModal",
		path: "organisms/modals/UnfinishedWorkModal",
		styleguidePath: "Organisms/Modals/UnfinishedWorkModal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "DisableTakeover",
		path: "organisms/takeovers/DisableTakeover",
		styleguidePath: "Organisms/Takeovers/DisableTakeover",
		importPath: "web-ui-components/lib/organisms/takeovers"
	},
	{
		name: "LoadingLocalTakeover",
		path: "organisms/takeovers/LoadingLocalTakeover",
		styleguidePath: "Organisms/Takeovers/LoadingLocalTakeover",
		importPath: "web-ui-components/lib/organisms/takeovers"
	},
	{
		name: "Timeline",
		path: "organisms/timelines/Timeline",
		styleguidePath: "Organisms/Timeline/Timeline",
		importPath: "web-ui-components/lib/organisms/timelines"
	},
	{
		name: "ProductSelector",
		path: "products/selection/ProductSelector",
		styleguidePath: "Products/Selection/ProductSelector",
		importPath: "web-ui-components/lib/products/selection"
	},
	{
		name: "EmailCreationInput",
		path: "security/authentication/inputs/EmailCreationInput",
		styleguidePath: "Security/Authentication/Inputs/EmailCreationInput",
		importPath: "web-ui-components/lib/security/authentication/inputs"
	},
	{
		name: "PasswordCreationInput",
		path: "security/authentication/inputs/PasswordCreationInput",
		styleguidePath: "Security/Authentication/Inputs/PasswordCreationInput",
		importPath: "web-ui-components/lib/security/authentication/inputs"
	},
	{
		name: "CallButton",
		path: "telephony/Buttons/CallButton",
		styleguidePath: "Telephony/Buttons/CallButton",
		importPath: "web-ui-components/lib/telephony/buttons"
	},
	{
		name: "CallStatus",
		path: "telephony/Statuses/CallStatus",
		styleguidePath: "Telephony/Statuses/CallStatus",
		importPath: "web-ui-components/lib/telephony/statuses"
	},
	{
		name: "LogoDisplay",
		path: "transactions/logo/LogoDisplay",
		styleguidePath: "Transactions/Logo/LogoDisplay",
		importPath: "web-ui-components/lib/transactions/logo"
	},
	{
		name: "Footer",
		path: "typography/ancillary/Footer",
		styleguidePath: "Typography/Ancillary/Footer",
		importPath: "web-ui-components/lib/typography/ancillary"
	},
	{
		name: "LargeBody",
		path: "typography/body/LargeBody",
		styleguidePath: "Typography/Body/LargeBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SecondaryBody",
		path: "typography/body/SecondaryBody",
		styleguidePath: "Typography/Body/SecondaryBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SignificantBody",
		path: "typography/body/SignificantBody",
		styleguidePath: "Typography/Body/SignificantBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SmallestBody",
		path: "typography/body/SmallestBody",
		styleguidePath: "Typography/Body/SmallestBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "StandardBody",
		path: "typography/body/StandardBody",
		styleguidePath: "Typography/Body/StandardBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SubBody",
		path: "typography/body/SubBody",
		styleguidePath: "Typography/Body/SubBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "VisuallyHiddenBody",
		path: "typography/body/VisuallyHiddenBody",
		styleguidePath: "Typography/Body/VisuallyHiddenBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "PageHeading",
		path: "typography/headings/PageHeading",
		styleguidePath: "Typography/Headings/PageHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "SectionHeading",
		path: "typography/headings/SectionHeading",
		styleguidePath: "Typography/Headings/SectionHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "SubHeading",
		path: "typography/headings/SubHeading",
		styleguidePath: "Typography/Headings/SubHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "SubsectionHeading",
		path: "typography/headings/SubsectionHeading",
		styleguidePath: "Typography/Headings/SubsectionHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "LargeHero",
		path: "typography/heros/LargeHero",
		styleguidePath: "Typography/Heros/LargeHero",
		importPath: "web-ui-components/lib/typography/heros"
	},
	{
		name: "StandardHero",
		path: "typography/heros/StandardHero",
		styleguidePath: "Typography/Heros/StandardHero",
		importPath: "web-ui-components/lib/typography/heros"
	},
	{
		name: "IndicativeHighlight",
		path: "typography/highlights/IndicativeHighlight",
		styleguidePath: "Typography/Highlights/IndicativeHighlight",
		importPath: "web-ui-components/lib/typography/highlights"
	},
	{
		name: "StateIndicator",
		path: "typography/indicators/StateIndicator",
		styleguidePath: "Typography/Indicators/StateIndicator",
		importPath: "web-ui-components/lib/typography/indicators"
	},
	{
		name: "StepIndicator",
		path: "typography/indicators/StepIndicator",
		styleguidePath: "Typography/Indicators/StepIndicator",
		importPath: "web-ui-components/lib/typography/indicators"
	},
	{
		name: "FieldLabel",
		path: "typography/labels/FieldLabel",
		styleguidePath: "Typography/Labels/FieldLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "ProminentLabel",
		path: "typography/labels/ProminentLabel",
		styleguidePath: "Typography/Labels/ProminentLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "StandardLabel",
		path: "typography/labels/StandardLabel",
		styleguidePath: "Typography/Labels/StandardLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "SubLabel",
		path: "typography/labels/SubLabel",
		styleguidePath: "Typography/Labels/SubLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "BulletList",
		path: "typography/lists/BulletList",
		styleguidePath: "Typography/Lists/BulletList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "NegativeList",
		path: "typography/lists/NegativeList",
		styleguidePath: "Typography/Lists/NegativeList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "NumberList",
		path: "typography/lists/NumberList",
		styleguidePath: "Typography/Lists/NumberList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "PositiveList",
		path: "typography/lists/PositiveList",
		styleguidePath: "Typography/Lists/PositiveList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "TickList",
		path: "typography/lists/TickList",
		styleguidePath: "Typography/Lists/TickList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "Identifier",
		path: "typography/modifiers/Identifier",
		styleguidePath: "Typography/Modifiers/Identifier",
		importPath: "web-ui-components/lib/typography/modifiers"
	},
	{
		name: "AbbreviatedTag",
		path: "typography/tags/AbbreviatedTag",
		styleguidePath: "Typography/Tags/AbbreviatedTag",
		importPath: "web-ui-components/lib/typography/tags"
	},
	{
		name: "StatusTag",
		path: "typography/tags/StatusTag",
		styleguidePath: "Typography/Tags/StatusTag",
		importPath: "web-ui-components/lib/typography/tags"
	},
	{
		name: "ValueTag",
		path: "typography/tags/ValueTag",
		styleguidePath: "Typography/Tags/ValueTag",
		importPath: "web-ui-components/lib/typography/tags"
	},
	{
		name: "MostProminentValue",
		path: "typography/values/MostProminentValue",
		styleguidePath: "Typography/Values/MostProminentValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "ProminentValue",
		path: "typography/values/ProminentValue",
		styleguidePath: "Typography/Values/ProminentValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "StandardValue",
		path: "typography/values/StandardValue",
		styleguidePath: "Typography/Values/StandardValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "VeryProminentValue",
		path: "typography/values/VeryProminentValue",
		styleguidePath: "Typography/Values/VeryProminentValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "UserStatusBandCard",
		path: "users/business-users/cards/UserStatusBandCard",
		styleguidePath: "Users/Business-users/Cards/UserStatusBandCard",
		importPath: "web-ui-components/lib/users/business-users/cards"
	}
];

var deprecated = [{
	name: "InputRadio",
	path: "src/actions/radios/InputRadio/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.4.0",
	deprecationDate: "February 17 2020"
}, {
	name: "InputRadioGroup",
	path: "src/actions/radios/InputRadioGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.4.0",
	deprecationDate: "February 17 2020"
}, {
	name: "TallRadioCard",
	path: "src/actions/radios/TallRadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "27.13.0",
	deprecationDate: "September 9 2021"
}, {
	name: "WideRadioCard",
	path: "src/actions/radios/WideRadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "27.13.0",
	deprecationDate: "September 9 2021"
}, {
	name: "Anchor",
	path: "src/atoms/buttons/Anchor/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Button",
	path: "src/atoms/buttons/Button/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "ActionButton",
			path: "Actions/Buttons"
		}, {
			name: "NavigationButton",
			path: "Navigation/Buttons"
		}]
	}],
	deprecationVersion: "27.4.1",
	deprecationDate: "September 10 2020"
}, {
	name: "Checkbox",
	path: "src/atoms/forms/Checkbox/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Datepicker",
	path: "src/atoms/forms/Datepicker/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Calendar",
			path: "Atoms/Forms"
		}
	}],
	deprecationVersion: "7.3.0",
	deprecationDate: "August 30 2018"
}, {
	name: "LabelTitle",
	path: "src/atoms/forms/Label/LabelTitle/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "Label",
	path: "src/atoms/forms/Label/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "Radio",
	path: "src/atoms/forms/Radio/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.2.0",
	deprecationDate: "February 06 2020"
}, {
	name: "RadioCard",
	path: "src/atoms/forms/RadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Select",
	path: "src/atoms/forms/Select/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericSelect",
			path: "Data/Capture/Selects"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "Textarea",
	path: "src/atoms/forms/Textarea/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}],
	deprecationVersion: "19.0.0",
	deprecationDate: "May 03 2019"
}, {
	name: "TextAreaCharacterCount",
	path: "src/atoms/forms/TextAreaCharacterCount/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}],
	deprecationVersion: "20.0.0",
	deprecationDate: "May 15 2019"
}, {
	name: "Icon",
	path: "src/atoms/iconography/Icon/package.json",
	"component-life-cycle": "active",
	deprecations: [{
		replacements: {
			name: "ChevronLeftSmall",
			replacement: "ChevronLeftSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineLarge",
			replacement: "CrossOutlineLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidLarge",
			replacement: "CrossSolidLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidSmall",
			replacement: "CrossSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidLarge",
			replacement: "CycleLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidSmall",
			replacement: "CycleSmall",
			path: "Atoms/Iconography"
		}
	}]
}, {
	name: "Divider",
	path: "src/atoms/layout/Divider/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericDivider",
			path: "Layout/Content/Breaks"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "BankHeader",
	path: "src/atoms/logo/BankHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "Header",
	path: "src/atoms/logo/Header/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "BulletedList",
	path: "src/atoms/text/BulletedList/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "BulletList",
			path: "Typography/Lists"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "Callout",
	path: "src/atoms/text/Callout/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "NumberedList",
	path: "src/atoms/text/NumberedList/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "NumberList",
			path: "Typography/Lists"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "TextBody",
	path: "src/atoms/text/TextBody/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandardBody",
			path: "Typography/Body"
		}
	}],
	deprecationVersion: "22.3.0",
	deprecationDate: "August 05 2019"
}, {
	name: "TextStyled",
	path: "src/atoms/text/TextStyled/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "22.3.0",
	deprecationDate: "August 05 2019"
}, {
	name: "TheSmallPrint",
	path: "src/atoms/text/TheSmallPrint/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SmallestBody",
			path: "Typography/Body"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Title",
	path: "src/atoms/text/Title/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Headings",
			path: "Typography"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "GenericTextInput",
	path: "src/data/capture/inputs/GenericTextInput/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAlphaNumericInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "25.1.0",
	deprecationDate: "March 23 2020"
}, {
	name: "DocumentLink",
	path: "src/documents/navigation/links/DocumentLink/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "DocumentLinkPlate",
	path: "src/documents/navigation/plates/DocumentLinkPlate/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "PrintButton",
	path: "src/documents/printing/buttons/PrintButton/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons/ActionButton"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "FileInput",
	path: "src/documents/upload/FileInput/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "FileUploadInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "AccountLegacyPanel",
	path: "src/finance/accounts/panels/AccountLegacyPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "AccountBalancesSelectPanel",
			path: "Finance/Accounts/Panels"
		}
	}],
	deprecationVersion: "22.1.0",
	deprecationDate: "July 17 2019"
}, {
	name: "CenterImageContainer",
	path: "src/global/layout/CenterImageContainer/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids",
			variant: "Centered"
		}
	}],
	deprecationVersion: "27.9.0",
	deprecationDate: "March 24 2021"
}, {
	name: "Column",
	path: "src/global/layout/Column/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "Container",
	path: "src/global/layout/Container/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentContainer",
			path: "Layout/Sections"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "FlexColumn",
	path: "src/global/layout/FlexColumn/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "FlexRow",
	path: "src/global/layout/FlexRow/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "Frame",
	path: "src/global/layout/Frame/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "LeftAndRightAlignment",
	path: "src/global/layout/LeftAndRightAlignment/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "PageLayout",
	path: "src/global/layout/PageLayout/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "HeaderSection",
	path: "src/global/layout/Pages/HeaderSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ServicingSection",
	path: "src/global/layout/Pages/ServicingSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "DataManagementShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "WorkflowSection",
	path: "src/global/layout/Pages/WorkflowSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "ResponsiveLayoutPair",
	path: "src/global/layout/ResponsiveLayoutPair/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.2.2",
	deprecationDate: "July 31 2020"
}, {
	name: "Row",
	path: "src/global/layout/Row/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "ContentContainer",
	path: "src/layout/containers/ContentContainer/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Main",
	path: "src/layout/containers/Main/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells/ApplicationFormShell"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ContentRevealPanel",
	path: "src/layout/content/panels/ContentRevealPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SubformRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.7.0",
	deprecationDate: "December 16 2020"
}, {
	name: "ShellSidebarPanel",
	path: "src/layout/content/panels/ShellSidebarPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ShellPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.9.0",
	deprecationDate: "March 24 2021"
}, {
	name: "GuidanceTile",
	path: "src/layout/content/tiles/GuidanceTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "RecapTile",
	path: "src/layout/content/tiles/RecapTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "GridViewToggle",
	path: "src/layout/content/views/GridViewToggle/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GridListToggle",
			path: "Layout/Content/Views"
		}
	}],
	deprecationVersion: "28.3.0",
	deprecationDate: "January 21 2022"
}, {
	name: "FixedFooter",
	path: "src/layout/sections/footers/FixedFooter/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "MainFixedFooter",
			path: "Layout/Footers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "AccordionItem",
	path: "src/molecules/accordions/Accordion/AccordionItem/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Accordion",
	path: "src/molecules/accordions/Accordion/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "AccordionTable",
	path: "src/molecules/accordions/AccordionTable/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "ContentReveal",
	path: "src/molecules/accordions/ContentReveal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "24.1.0",
	deprecationDate: "March 05 2020"
}, {
	name: "ExpansionPanel",
	path: "src/molecules/accordions/ExpansionPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "SubformRevealPanel",
			path: "Layout/Content/Panels"
		}, {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions/GenericAccordion"
		}, {
			name: "InformationRevealPanel",
			path: "Layout/Content/Panels"
		}]
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "ExpansionTable",
	path: "src/molecules/accordions/ExpansionTable/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "ButtonGroup",
	path: "src/molecules/buttons/ButtonGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "NavigationButtonGroup",
			path: "Navigation/Buttons"
		}, {
			name: "Inline",
			path: "Layout/Grids"
		}]
	}],
	deprecationVersion: "27.4.1",
	deprecationDate: "September 10 2020"
}, {
	name: "ConfirmationCheckbox",
	path: "src/molecules/forms/ConfirmationCheckbox/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandaloneCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "DaySelector",
	path: "src/molecules/forms/DaySelector/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "FieldBody",
	path: "src/molecules/forms/Field/FieldBody/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "FieldHeader",
	path: "src/molecules/forms/Field/FieldHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "Field",
	path: "src/molecules/forms/Field/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "RadioCardGroup",
	path: "src/molecules/forms/RadioCardGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "SegmentedSlider",
	path: "src/molecules/forms/SegmentedSlider/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SliderInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "28.4.0",
	deprecationDate: "June 21 2022"
}, {
	name: "ValidationMessage",
	path: "src/molecules/forms/ValidationMessage/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ValidationMessageTile",
			path: "Layout/Tiles"
		}
	}],
	deprecationVersion: "22.22.0",
	deprecationDate: "January 20 2020"
}, {
	name: "IconText",
	path: "src/molecules/icon-text/IconText/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "IconTextDynamic",
			path: "Molecules/IconTextDynamic"
		}
	}],
	deprecationVersion: "6.4.0",
	deprecationDate: "August 03 2018"
}, {
	name: "BackAnchor",
	path: "src/molecules/navigation/BackAnchor/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "BackButton",
	path: "src/molecules/navigation/BackButton/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "UtilityNavButton",
			path: "Navigation/Site-navs"
		}
	}],
	deprecationVersion: "25.5.0",
	deprecationDate: "May 13 2020"
}, {
	name: "Utility",
	path: "src/molecules/navigation/Utility/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "UtilityNav",
			path: "Navigation/Site-Navs/UtilityNav"
		}
	}],
	deprecationVersion: "22.12.0",
	deprecationDate: "September 27 2019"
}, {
	name: "ContrastingFormPanel",
	path: "src/molecules/panels/ContrastingFormPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericPanel",
			path: "Layout/Content/Panels",
			variant: "Interaction"
		}
	}],
	deprecationVersion: "33.3.0",
	deprecationDate: "April 03 2024"
}, {
	name: "SubordinatePanel",
	path: "src/molecules/panels/SubordinatePanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ProgressIndicator",
	path: "src/molecules/progress/ProgressIndicator/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}],
	deprecationVersion: "26.0.0",
	deprecationDate: "May 22 2020"
}, {
	name: "ProgressIndicatorItem",
	path: "src/molecules/progress/ProgressIndicator/ProgressIndicatorItem/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}],
	deprecationVersion: "26.0.0",
	deprecationDate: "May 22 2020"
}, {
	name: "SectionHeading",
	path: "src/molecules/text/SectionHeading/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SectionHeading",
			path: "Typography/Headings"
		}
	}],
	deprecationVersion: "23.2.0",
	deprecationDate: "February 06 2020"
}, {
	name: "ConfirmationTile",
	path: "src/molecules/tile/ConfirmationTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "HighlightTile",
	path: "src/molecules/tile/HighlightTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "IconTile",
	path: "src/molecules/tile/IconTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "NavigationButton",
	path: "src/navigation/buttons/NavigationButton/package.json",
	"component-life-cycle": "active",
	deprecations: [{
		variants: ["Confirm", "Continue", "Next", "Submit"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Primary"
		}
	}, {
		variants: ["Back"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Secondary"
		}
	}, {
		variants: ["Cancel"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Tertiary"
		}
	}],
	deprecationVersion: "NO RELEASE VERSION FOUND",
	deprecationDate: "NO RELEASE DATE FOUND"
}, {
	name: "GlobalHeader",
	path: "src/organisms/global/GlobalHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "CentredModal",
	path: "src/organisms/modals/CentredModal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}],
	deprecationVersion: "22.0.0",
	deprecationDate: "July 04 2019"
}, {
	name: "ConfirmationModal",
	path: "src/organisms/modals/ConfirmationModal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericModal",
			path: "Layout/Content/Modals"
		}
	}],
	deprecationVersion: "27.8.0",
	deprecationDate: "January 29 2021"
}, {
	name: "Modal",
	path: "src/organisms/modals/Modal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}],
	deprecationVersion: "22.0.0",
	deprecationDate: "July 04 2019"
}, {
	name: "LargeHero",
	path: "src/typography/heros/LargeHero/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "StandardHero",
	path: "src/typography/heros/StandardHero/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}];

/* eslint-disable no-console */

var deprecatedDictComponents = {};
var deprecatedDictProps = {};
var timeoutDelay = 100;

var CONSOLE_DEPRECATION_MESSAGE_START = 'Deprecation: web-ui-components';

var DeprecationWarnings = {
	logComponent: function logComponent(componentName) {
		var deprecatedComponentObj = componentPaths.find(function (_ref) {
			var name = _ref.name;
			return name === componentName;
		});
		var oldPath = deprecatedComponentObj.styleguidePath;
		deprecatedComponentObj = deprecated.find(function (_ref2) {
			var name = _ref2.name;
			return name.includes(componentName);
		});

		var depreactionReplacements = deprecatedComponentObj.deprecations[0].replacements;
		var hasMultipleReplacements = Array.isArray(depreactionReplacements);
		var newPath = hasMultipleReplacements ? depreactionReplacements.map(function (replacement) {
			return replacement.path + '/' + replacement.name;
		}) : depreactionReplacements.path + '/' + depreactionReplacements.name;

		deprecatedDictComponents[componentName] = { oldPath: oldPath, newPath: newPath };
	},
	logIcon: function logIcon(componentName, deprecatedIcon) {
		var deprecatedComponentObj = componentPaths.find(function (_ref3) {
			var name = _ref3.name;
			return name.includes(componentName);
		});
		var path = deprecatedComponentObj.styleguidePath;
		var oldPath = path + ': ' + deprecatedIcon;
		var newPath = path + ': ' + deprecatedIcon;
		var iconName = componentName + ': ' + deprecatedIcon;

		deprecatedDictComponents[iconName] = { oldPath: oldPath, newPath: newPath };
	},
	logProp: function logProp(packageJson, description) {
		var _packageJson$main$spl = packageJson.main.split('.'),
		    _packageJson$main$spl2 = slicedToArray(_packageJson$main$spl, 1),
		    componentName = _packageJson$main$spl2[0];

		var deprecatedComponentObj = componentPaths.find(function (_ref4) {
			var name = _ref4.name;
			return name.includes(componentName);
		});
		var path = deprecatedComponentObj.styleguidePath;
		deprecatedDictProps[componentName] = { path: path, description: description };
	},
	report: function report() {
		setTimeout(function () {
			var numberOfDeprecations = Object.keys(deprecatedDictComponents).length + Object.keys(deprecatedDictProps).length;
			if (numberOfDeprecations > 0) {
				console.groupCollapsed('Web UI Components Deprecation Warnings. Total: ' + numberOfDeprecations);

				console.groupCollapsed('Components. Total: ' + Object.keys(deprecatedDictComponents).length);
				Object.entries(deprecatedDictComponents).forEach(function (_ref5) {
					var _ref6 = slicedToArray(_ref5, 2),
					    componentName = _ref6[0],
					    info = _ref6[1];

					var oldPath = info.oldPath,
					    newPath = info.newPath;

					console.groupCollapsed(componentName);
					console.warn('Deprecated:', oldPath);

					var hasMultipleReplacements = Array.isArray(newPath);
					if (hasMultipleReplacements) {
						newPath.map(function (replacement, index) {
							return console.warn('Replacement ' + (index + 1) + ':', replacement);
						});
					} else {
						console.warn('Replacement:', newPath);
					}
					console.groupEnd();
				});
				console.groupEnd();

				console.groupCollapsed('Props. Total: ' + Object.keys(deprecatedDictProps).length);
				Object.entries(deprecatedDictProps).forEach(function (_ref7) {
					var _ref8 = slicedToArray(_ref7, 2),
					    componentName = _ref8[0],
					    info = _ref8[1];

					var path = info.path,
					    description = info.description;

					console.groupCollapsed(componentName);
					console.warn('Deprecated:', path);
					console.warn('Reason:', description);
					console.groupEnd();
				});
				console.groupEnd();

				console.groupEnd();
				deprecatedDictComponents = {};
				deprecatedDictProps = {};
			}
		}, timeoutDelay);
	},
	warn: function warn(message) {
		return console.warn(CONSOLE_DEPRECATION_MESSAGE_START + ' -> ' + message);
	}
};

Object.freeze(DeprecationWarnings);

var _extends$p = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$o(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var LoadingOutlineSmallIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$o(_ref, ["styles"]);

  return React.createElement("svg", _extends$p({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M17.62 6.306L15.406 8.52a4.87 4.87 0 1 0 0 6.96l2.214 2.214a8 8 0 1 1 0-11.388z" }));
});

var _extends$q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$p(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$a = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$p(_ref, ["styles"]);

  return React.createElement("svg", _extends$q({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M84 96H56c-.238 0-.475-.02-.709-.062a31.449 31.449 0 0 1-2.518-.56A17.923 17.923 0 0 1 48 93.325a18.772 18.772 0 0 1-7.377 2.63c-.168.019-.453.046-.623.046H12a4 4 0 0 1-4-4V44a8.21 8.21 0 0 1 8-8h8V24C24 10.745 34.745 0 48 0s24 10.745 24 24v8h-8v-8c0-8.837-7.163-16-16-16s-16 7.163-16 16v16a3.999 3.999 0 0 1-4 4H16v44h23.74a10.522 10.522 0 0 0 2.153-.55 21.577 21.577 0 0 1-.825-1.317L34.23 74.246a15.892 15.892 0 0 1 13.846-23.754h.002a15.866 15.866 0 0 1 13.793 23.781l-6.91 11.899c-.252.437-.52.86-.8 1.273.216.075.435.141.655.2.504.132 1.022.254 1.555.355H80V44H36v-8h44a8.21 8.21 0 0 1 8 8v48a4 4 0 0 1-4 4zM48.074 58.492a7.937 7.937 0 0 0-6.135 2.89 7.824 7.824 0 0 0-.775 8.872l6.838 11.886.025.043.016-.027 6.908-11.898a7.825 7.825 0 0 0-.736-8.875 7.95 7.95 0 0 0-6.14-2.891z" }));
});

var _extends$r = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$q(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$a = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$q(_ref, ["styles"]);

  return React.createElement("svg", _extends$r({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7.932 9c-.305 0-.552.223-.552.5v3c0 .276.247.5.552.5.305 0 .553-.224.553-.5v-3c0-.277-.248-.5-.553-.5zm6.078 5c0 .552-.495 1-1.105 1H2.96c-.61 0-1.105-.448-1.105-1V8c0-.552.494-1 1.105-1h9.945c.61 0 1.105.448 1.105 1v6zM4.065 4.5c0-1.933 1.732-3.5 3.867-3.5C10.068 1 11.8 2.567 11.8 4.5V6H4.065V4.5zm8.84 1.5V4.5c0-2.485-2.226-4.5-4.973-4.5C5.186 0 2.96 2.015 2.96 4.5V6C1.74 6 .75 6.895.75 8v6c0 1.104.99 2 2.21 2h9.945c1.22 0 2.21-.896 2.21-2V8c0-1.105-.99-2-2.21-2z" }));
});

var _extends$s = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$r(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMHealthIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$r(_ref, ["styles"]);

  return React.createElement("svg", _extends$s({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M68 0c16.293 0 28 13.099 27.999 30.102-.186 7.302-2.129 14.452-5.618 20.761l-1.507 2.886-7.091-3.704 2.253-4.299A37.352 37.352 0 0 0 88 30c0-12.671-8.338-22-20-22-5.478 0-10.444 2.094-14.419 5.267C57.66 18.709 60 25.137 60 31.163c0 17.942-24 17.942-24 .014-.02-6.014 2.357-12.46 6.482-17.922C38.516 10.086 33.54 8 28 8 16.338 8 8 17.329 7.996 29.83c.838 19.746 14.142 38.062 39.727 57.015l4.718-4.313c4.757-4.372 8.287-7.702 11.309-10.71l.688-.689a183.18 183.18 0 0 0 2.297-2.349l1.463-1.543 2.443-2.66 5.944 5.354c-.605.672-1.205 1.33-1.808 1.98l-.724.778c-3.751 4.008-7.704 7.868-13.669 13.396l-2.554 2.356-7.14 6.515a4 4 0 0 1-5.026.287C16.578 74.321.996 53.577 0 30 0 13.099 11.707 0 28 0c7.79 0 14.673 2.941 20.04 7.421C53.419 2.945 60.289 0 68 0zm-2.764 37.386a4.4 4.4 0 0 1 3.867 2.125L79.65 56.979H96v8H77.618a4.4 4.4 0 0 1-3.767-2.125l-8.344-13.82-13.583 25.099a4.4 4.4 0 0 1-4.123 2.298c-1.704-.098-3.198-1.173-3.773-2.619l-5.237-11.78-1.649 2.947h-9.679v-8h4.988l2.868-5.127a4.4 4.4 0 0 1 7.86.36l5.191 11.68L61.467 39.69a4.403 4.403 0 0 1 3.769-2.305zM48.023 19.281l-.618.954c-2.182 3.53-3.417 7.386-3.405 10.928 0 7.276 8 7.276 8 0 0-3.884-1.446-8.113-3.977-11.882z" }));
});

var _extends$t = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$s(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$b = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$s(_ref, ["styles"]);

  return React.createElement("svg", _extends$t({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M60 5.307a8.008 8.008 0 0 1 8 8v4h20a8.008 8.008 0 0 1 8 8v56a8.008 8.008 0 0 1-8 8H60.64c-.119 0-.347-.016-.464-.025a28.474 28.474 0 0 1-11.59-3.559 28.6 28.6 0 0 1-11.602 3.568L8 89.307a8.008 8.008 0 0 1-8-8v-56a8.008 8.008 0 0 1 8-8h16v8H8v56h28.64a19.259 19.259 0 0 0 4.798-1.072 15.636 15.636 0 0 1-4.506-8.614 12.427 12.427 0 0 1 3.162-10.8c4.748-4.533 12.221-4.532 16.968.002 4.74 4.95 4.91 12.7.393 17.853a18.11 18.11 0 0 1-1.498 1.612c1.59.539 3.24.883 4.912 1.023L88 81.307v-56H60v-12H36v4h18.686v8H28v-12a8.008 8.008 0 0 1 8-8zm-11.424 60a3.965 3.965 0 0 0-2.826 1.172 4.819 4.819 0 0 0-.904 3.961 8 8 0 0 0 2.869 4.717l.902.777a12.052 12.052 0 0 0 2.535-2.18 5.46 5.46 0 0 0 .246-7.28 3.968 3.968 0 0 0-2.822-1.167zm29.395-32.69v42.294h-8V32.618zm-52 0v42.294h-8V32.618z" }));
});

var _extends$u = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$t(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$b = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$t(_ref, ["styles"]);

  return React.createElement("svg", _extends$u({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon briefcase"), React.createElement("path", { d: "M10 6V3.998A2 2 0 0 1 11.982 2h8.037C21.112 2 22 2.885 22 3.998V6h2V4.99c0-.546.432-.99.992-.99h4.018c.547 0 .99.432.99.99V6c1.106 0 2 .912 2 2.005v19.99A1.997 1.997 0 0 1 30 30H2c-1.104 0-2-.912-2-2.005V8.005C0 6.898.888 6 2 6V4.99c0-.546.432-.99.99-.99h4.02c.546 0 .99.432.99.99V6h2zm2-2v2h8V4h-8zM2 8v20h2V8H2zm26 0v20h2V8h-2zM6 8v20h20V8H6z" }));
});

var _extends$v = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$u(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$c = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$u(_ref, ["styles"]);

  return React.createElement("svg", _extends$v({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon building"), React.createElement("path", { d: "M20 30h2V2H10v28h2v-6h8v6zM8 6V0h16v6h8v26H0V6h8zm16 2v22h6V8h-6zM2 30h6V8H2v22zm12-4v4h4v-4h-4zM12 6h8v2h-8V6zm0 6h8v2h-8v-2zm0 6h8v2h-8v-2zm-8-6h2v2H4v-2zm22 0h2v2h-2v-2zM4 18h2v2H4v-2zm22 0h2v2h-2v-2zM4 24h2v2H4v-2zm22 0h2v2h-2v-2z" }));
});

var _extends$w = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$v(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$c = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$v(_ref, ["styles"]);

  return React.createElement("svg", _extends$w({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M20 15v8H8v64h28.082a19.278 19.278 0 0 0 4.797-1.072 15.64 15.64 0 0 1-4.508-8.61 12.09 12.09 0 0 1 3.008-10.642c.107-.12.22-.232.34-.338a12.04 12.04 0 0 1 16.531-.057c4.933 4.923 5.217 12.824.649 18.088a18.43 18.43 0 0 1-1.5 1.614c1.59.538 3.24.88 4.914 1.021L88 87V23H76v-8h16a4 4 0 0 1 4 4v68a8.01 8.01 0 0 1-8 8H60.082c-.117 0-.348-.016-.465-.025a28.474 28.474 0 0 1-11.59-3.559 28.58 28.58 0 0 1-11.601 3.568L8 95a8.01 8.01 0 0 1-8-8V19.512A4.516 4.516 0 0 1 4.512 15zm28.004 56.004a3.993 3.993 0 0 0-2.824 1.191 4.143 4.143 0 0 0-.895 3.942 8.036 8.036 0 0 0 2.871 4.715l.903.777a12.198 12.198 0 0 0 2.539-2.184 5.464 5.464 0 0 0 .242-7.279 3.993 3.993 0 0 0-2.836-1.162zM72-1v80h-8V7H32v72h-8V-1zM20 63v8h-8v-8zm64 0v8h-8v-8zM20 47v8h-8v-8zm64 0v8h-8v-8zm-28 0v8H40v-8zM20 31v8h-8v-8zm64 0v8h-8v-8zm-28 0v8H40v-8zm0-16v8H40v-8z" }));
});

var _extends$x = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$w(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$d = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$w(_ref, ["styles"]);

  return React.createElement("svg", _extends$x({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon clipboard tick"), React.createElement("path", { d: "M22 4h2v2h6v26H2V6h6V4h2V2.02C10 .903 10.902 0 11.982 0h8.037C21.112 0 22 .887 22 2.02V4zm-2 2V2h-8v4h-2v4h12V6h-2zM8 12V8H4v22h24V8h-4v4H8zm3.707 8.536L14.07 22.9l6.608-6.607a1 1 0 0 1 1.414 1.414l-7.314 7.314a.997.997 0 0 1-1.414 0l-3.07-3.07a1 1 0 1 1 1.413-1.414z" }));
});

var _extends$y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$x(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$e = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$x(_ref, ["styles"]);

  return React.createElement("svg", _extends$y({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M0 28.636c0-9.129 4.05-13.693 12.15-13.693h70.057C91.402 14.943 96 19.22 96 27.775v39.716c0 9.063-4.598 13.594-13.793 13.594H12.15c-8.1 0-12.15-4.05-12.15-12.15V28.637zm6 3.516V65.14c0 6.63 3.544 9.945 10.631 9.945h61.3C85.977 75.085 90 71.376 90 63.957v-32.51c0-7.003-4.023-10.504-12.069-10.504h-61.3C9.544 20.943 6 24.679 6 32.152z" }), React.createElement("path", { d: "M75.5 60.43a5 5 0 1 1 0 7.141 5 5 0 1 1 0-7.141zM90 31H6v8.999h84zM13 53.001h50v-6.004H13z" }));
});

var _extends$z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$y(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$d = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$y(_ref, ["styles"]);

  return React.createElement("svg", _extends$z({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M92 14a4 4 0 0 1 4 4v32.782a8 8 0 0 1-2.343 5.657l-1.253 1.254 1.253 1.254A8 8 0 0 1 96 64.603V78a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V18a4 4 0 0 1 4-4zm-4 8H8v52h80v-9.397l-1.252-1.255-1.756 1.754c-3.852 4.03-10.03 4.623-14.662 1.421l-.622-.46a11.002 11.002 0 0 1-3.861-8.37c0-3.221 1.411-6.28 3.977-8.465a11.296 11.296 0 0 1 14.594.496l.54.523 1.786 1.785L88 50.782zM32 58v8H16v-8zm20 0v8H36v-8zm22.9-2.59a3.001 3.001 0 0 0-1.053 2.283c0 .879.385 1.713.938 2.189 1.212.958 2.906.935 4.134-.049l.354-.323 1.817-1.818-1.88-1.88c-1.175-1.229-3.091-1.362-4.31-.403zM52 46v8H16v-8zm28-16v8H16v-8z" }));
});

var _extends$A = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$z(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$e = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$z(_ref, ["styles"]);

  return React.createElement("svg", _extends$A({ height: "72", viewBox: "0 0 96 72", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M55.384 0c7.252 0 12.924 5.507 12.924 12.923 0 4.15-2.197 8.172-6.464 13.521C58.67 30.04 54.828 33 50.343 35.323c.03.177.06.356.092.536.567 5.4-.2 11.844-1.967 17.478l12.266 6.133c8.659 4.349 11.26 5.146 18.65 5.146 2.235 0 5.956-.998 9.231-2.369V14.804c-4.32 1.455-8.43 1.811-14.769 1.811V9.231c7.784 0 11.281-.538 16.81-3.303C93.111 4.701 96 6.486 96 9.231v55.385a3.692 3.692 0 0 1-2.036 3.3C89.387 70.212 83.43 72 79.384 72c-8.74 0-12.368-1.111-21.958-5.928l-11.847-5.925a21.98 21.98 0 0 1-1.943 2.899C40.122 68.048 34.407 72 29.538 72c-8.5 0-14.77-6.264-14.77-12.917 0-7.308 4.95-12.929 14.77-12.929 2.16 0 4.382.495 6.821 1.408 1.625.607 3.18 1.324 5.39 2.436 1.108-3.922 1.665-8.256 1.469-11.934-4.806 1.073-9.839.601-15.006-1.387l2.652-6.892c4.026 1.55 7.742 1.854 11.258.948-1.003-6.645-1.507-11.958-1.507-15.97C40.615 5.948 47.495 0 55.385 0zM1.082 8.465c5.22-5.219 18.16-6.406 31.282-2.794l-1.96 7.12c-9.758-2.686-19.119-2.182-23.02.086v57.277H0V11.076c0-.98.39-1.918 1.082-2.61zM29.538 53.54c-5.518 0-7.384 2.12-7.384 5.544 0 2.573 2.96 5.533 7.384 5.533 2.047 0 5.789-2.588 8.193-5.999.422-.526.825-1.119 1.208-1.765l-.47-.238c-2.012-1.013-3.372-1.64-4.698-2.136-1.678-.628-3.075-.94-4.233-.94zM55.384 7.385c-4.03 0-7.384 2.9-7.384 7.377 0 3.178.369 7.42 1.12 12.783 2.746-1.67 5.11-3.632 7.069-5.845 3.135-3.937 4.734-6.864 4.734-8.777 0-3.288-2.317-5.538-5.539-5.538z", fillRule: "evenodd" }));
});

var _extends$B = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$A(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$f = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$A(_ref, ["styles"]);

  return React.createElement("svg", _extends$B({ height: "72", viewBox: "0 0 96 72", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M55.384 0c7.252 0 12.924 5.507 12.924 12.923 0 4.15-2.197 8.172-6.464 13.521C58.67 30.04 54.828 33 50.343 35.323c.03.177.06.356.092.536.567 5.4-.2 11.844-1.967 17.478l12.266 6.133c8.659 4.349 11.26 5.146 18.65 5.146 2.235 0 5.956-.998 9.231-2.369V14.804c-4.32 1.455-8.43 1.811-14.769 1.811V9.231c7.784 0 11.281-.538 16.81-3.303C93.111 4.701 96 6.486 96 9.231v55.385a3.692 3.692 0 0 1-2.036 3.3C89.387 70.212 83.43 72 79.384 72c-8.74 0-12.368-1.111-21.958-5.928l-11.847-5.925a21.98 21.98 0 0 1-1.943 2.899C40.122 68.048 34.407 72 29.538 72c-8.5 0-14.77-6.264-14.77-12.917 0-7.308 4.95-12.929 14.77-12.929 2.16 0 4.382.495 6.821 1.408 1.625.607 3.18 1.324 5.39 2.436 1.108-3.922 1.665-8.256 1.469-11.934-4.806 1.073-9.839.601-15.006-1.387l2.652-6.892c4.026 1.55 7.742 1.854 11.258.948-1.003-6.645-1.507-11.958-1.507-15.97C40.615 5.948 47.495 0 55.385 0zM1.082 8.465c5.22-5.219 18.16-6.406 31.282-2.794l-1.96 7.12c-9.758-2.686-19.119-2.182-23.02.086v57.277H0V11.076c0-.98.39-1.918 1.082-2.61zM29.538 53.54c-5.518 0-7.384 2.12-7.384 5.544 0 2.573 2.96 5.533 7.384 5.533 2.047 0 5.789-2.588 8.193-5.999.422-.526.825-1.119 1.208-1.765l-.47-.238c-2.012-1.013-3.372-1.64-4.698-2.136-1.678-.628-3.075-.94-4.233-.94zM55.384 7.385c-4.03 0-7.384 2.9-7.384 7.377 0 3.178.369 7.42 1.12 12.783 2.746-1.67 5.11-3.632 7.069-5.845 3.135-3.937 4.734-6.864 4.734-8.777 0-3.288-2.317-5.538-5.539-5.538z", fillRule: "evenodd" }));
});

var _extends$C = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$B(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$f = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$B(_ref, ["styles"]);

  return React.createElement("svg", _extends$C({ width: "32", height: "32", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M28.82 5.3l-6.595 6.6-.636.64.05.9c.11 1.88.313 5.24.49 8.14.153 2.58.3 5 .31 5.2.005.16.007.18-.125.34-.296.36-.848.98-1.312 1.48-.72-1.94-2.236-6.06-3.072-8.36l-1.075-2.96-2.224 2.24-4.09 3.92-.567.58-.018.8c-.014.64-.01 1.8-.008 2.82.002.64.002 1.2 0 1.58-.054-.1-.104-.18-.16-.26-.824-1.32-1.964-3.14-2.312-3.7l-.256-.42-.417-.26c-1.47-.88-3.08-1.9-4.114-2.56h1.493c.782.02 1.672.04 2.352.04.258 0 .492-.02.676-.02l.807-.02.568-.56 3.938-4.08 2.216-2.22-2.943-1.08c-2.21-.8-6.444-2.4-8.424-3.14.508-.46 1.12-1.02 1.478-1.32.1-.08.177-.12.23-.12h.07c.223 0 2.967.18 5.62.36 2.815.18 5.993.4 7.8.5l.903.06 7.234-7.24C27.723 2.16 28.72 2 29.225 2c.328 0 .558.06.678.12.142.38.336 1.76-1.082 3.18zM31.336.68C30.95.3 30.173 0 29.225 0 28.04 0 26.59.46 25.29 1.76l-6.593 6.6C14.983 8.12 5.47 7.5 5.233 7.48H5.08c-.32 0-.875.06-1.505.6-.742.6-2.288 2.06-2.288 2.06-.372.38-.56.84-.516 1.28.03.26.173.74.817 1 .394.14 6.636 2.48 9.518 3.54l-3.938 4.08h-.632c-1.202 0-3.062-.04-3.808-.04h-.234c-.228.02-.696-.1-1.936.94l-.088.08c-.373.38-.46.74-.47 1-.007.24.06.6.427.9.218.18 3.032 1.98 5.338 3.38.554.9 3.1 4.96 3.232 5.18.194.32.51.52.89.52h.032c.367 0 .745-.18 1.117-.54 1.048-1.22.904-1.74.91-1.96.016-.66-.012-3.5.012-4.64l4.087-3.92c1.046 2.86 3.33 9.06 3.484 9.46.253.64.733.78.997.8.044.02.088.02.13.02.396 0 .806-.2 1.14-.54 0 0 1.448-1.52 2.066-2.28.616-.74.59-1.38.58-1.68-.006-.22-.586-9.7-.802-13.4l6.597-6.6c2.338-2.36 1.966-5.18 1.098-6.04z" }));
});

var _extends$D = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$C(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$g = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$C(_ref, ["styles"]);

  return React.createElement("svg", _extends$D({ width: "32", height: "32", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M28.82 5.3l-6.595 6.6-.636.64.05.9c.11 1.88.313 5.24.49 8.14.153 2.58.3 5 .31 5.2.005.16.007.18-.125.34-.296.36-.848.98-1.312 1.48-.72-1.94-2.236-6.06-3.072-8.36l-1.075-2.96-2.224 2.24-4.09 3.92-.567.58-.018.8c-.014.64-.01 1.8-.008 2.82.002.64.002 1.2 0 1.58-.054-.1-.104-.18-.16-.26-.824-1.32-1.964-3.14-2.312-3.7l-.256-.42-.417-.26c-1.47-.88-3.08-1.9-4.114-2.56h1.493c.782.02 1.672.04 2.352.04.258 0 .492-.02.676-.02l.807-.02.568-.56 3.938-4.08 2.216-2.22-2.943-1.08c-2.21-.8-6.444-2.4-8.424-3.14.508-.46 1.12-1.02 1.478-1.32.1-.08.177-.12.23-.12h.07c.223 0 2.967.18 5.62.36 2.815.18 5.993.4 7.8.5l.903.06 7.234-7.24C27.723 2.16 28.72 2 29.225 2c.328 0 .558.06.678.12.142.38.336 1.76-1.082 3.18zM31.336.68C30.95.3 30.173 0 29.225 0 28.04 0 26.59.46 25.29 1.76l-6.593 6.6C14.983 8.12 5.47 7.5 5.233 7.48H5.08c-.32 0-.875.06-1.505.6-.742.6-2.288 2.06-2.288 2.06-.372.38-.56.84-.516 1.28.03.26.173.74.817 1 .394.14 6.636 2.48 9.518 3.54l-3.938 4.08h-.632c-1.202 0-3.062-.04-3.808-.04h-.234c-.228.02-.696-.1-1.936.94l-.088.08c-.373.38-.46.74-.47 1-.007.24.06.6.427.9.218.18 3.032 1.98 5.338 3.38.554.9 3.1 4.96 3.232 5.18.194.32.51.52.89.52h.032c.367 0 .745-.18 1.117-.54 1.048-1.22.904-1.74.91-1.96.016-.66-.012-3.5.012-4.64l4.087-3.92c1.046 2.86 3.33 9.06 3.484 9.46.253.64.733.78.997.8.044.02.088.02.13.02.396 0 .806-.2 1.14-.54 0 0 1.448-1.52 2.066-2.28.616-.74.59-1.38.58-1.68-.006-.22-.586-9.7-.802-13.4l6.597-6.6c2.338-2.36 1.966-5.18 1.098-6.04z" }));
});

var _extends$E = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$D(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$g = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$D(_ref, ["styles"]);

  return React.createElement("svg", _extends$E({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M9.68 50.354A38.428 38.428 0 0 0 62.686 85.88l2.918 7.103a45.822 45.822 0 0 1-17.524 3.45C22.642 96.406 2.028 75.792 2 50.354zM85.164 4l9.27 9.27-5.43 5.43-1.921-1.92-3.82 3.82A46.033 46.033 0 0 1 94.16 50.354a45.66 45.66 0 0 1-8.62 26.88h8.62v7.68H71.12v-23.04h7.68l.001 11.523A38.401 38.401 0 0 0 48.08 11.954 38.127 38.127 0 0 0 15.331 30.29c-1.736 4.444-2.073 7.733-.948 9.278 2.448 3.364 13.54 2.61 20.167 2.156 1.384-.165 2.936-.281 4.462-.394.81-.06 1.596-.121 2.355-.184l-.566-5.68a10.757 10.757 0 0 1 2.832-8.296 11.3 11.3 0 0 1 8.115-3.69c5.556.104 9.981 4.685 9.892 10.242a12.68 12.68 0 0 1-4.785 9.663l-.405.35a19.332 19.332 0 0 1-6.739 3.693l.207 2.081c.028.281.051.562.07.844h5.772v7.68h-6.456c-.062.247-.127.493-.196.739l6.22 4.185a14.134 14.134 0 0 0 8.82 2.763l-.007 7.68a21.747 21.747 0 0 1-13.02-4.02l-5.31-3.574c-.217.32-.446.638-.678.95a13.15 13.15 0 0 1-10.077 6.633 9.968 9.968 0 0 1-11.276-8.224 10.15 10.15 0 0 1 2.048-8.122 10.624 10.624 0 0 1 8.44-4.103c2.718.077 5.393.695 7.868 1.819.244-1.484.29-2.993.139-4.489l-.146-1.485c-.855.079-1.703.139-2.55.203-1.418.105-2.861.21-4.324.382-12.623.855-22.504 1.009-27.079-5.284-2.88-3.956-2.835-9.498.139-16.938l.278-.56C19.269 8.856 40.46.416 60.407 5.955a45.983 45.983 0 0 1 17.43 9.215l3.816-3.819-1.92-1.92zm-50.88 56.621a2.93 2.93 0 0 0-2.314 1.035 2.886 2.886 0 0 0-.69 1.879c.255 1.286.799 2.46 3.214 2.194 1.826-.116 3.382-1.924 4.38-3.42.112-.15.225-.304.333-.454a13.011 13.011 0 0 0-4.923-1.234zm17.464-29.46a3.69 3.69 0 0 0-2.468 1.215 3.04 3.04 0 0 0-.829 2.397l.469 4.736a11.315 11.315 0 0 0 2.565-1.635l.315-.27a4.952 4.952 0 0 0 2.16-3.881 2.409 2.409 0 0 0-2.212-2.562z" }));
});

var _extends$F = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$E(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$h = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$E(_ref, ["styles"]);

  return React.createElement("svg", _extends$F({ xmlns: "http://www.w3.org/2000/svg", width: "64", height: "64", viewBox: "0 0 64 64" }, props), React.createElement("path", { d: "M32.5 29.54c-13.577 0-24.583-5.509-24.583-12.307 0-6.796 11.006-12.308 24.583-12.308 13.575 0 24.583 5.512 24.583 12.308 0 6.798-11.008 12.307-24.583 12.307m0 9.846c-13.577 0-24.583-5.51-24.583-12.308 0-.1.027-.199.032-.297 5.285 4.63 14.305 7.682 24.551 7.682 10.246 0 19.266-3.053 24.551-7.685.005.101.032.2.032.3 0 6.799-11.008 12.308-24.583 12.308m0 9.848c-13.577 0-24.583-5.511-24.583-12.31 0-.1.027-.2.032-.3 5.285 4.63 14.305 7.684 24.551 7.684 10.246 0 19.264-3.054 24.551-7.684.005.1.032.2.032.3 0 6.799-11.008 12.31-24.583 12.31m0 9.843c-13.577 0-24.583-5.509-24.583-12.307 0-.101.027-.2.032-.3 5.285 4.632 14.305 7.684 24.551 7.684 10.246 0 19.264-3.052 24.551-7.684.005.1.032.199.032.3 0 6.798-11.008 12.307-24.583 12.307m28.261-36.922c.796-1.56 1.239-3.21 1.239-4.922C62 7.719 48.791 0 32.5 0 16.206 0 3 7.72 3 17.233c0 1.713.442 3.362 1.239 4.922C3.443 23.716 3 25.368 3 27.078c0 1.711.442 3.363 1.239 4.923C3.443 33.561 3 35.213 3 36.924c0 1.71.442 3.362 1.239 4.923C3.443 43.407 3 45.059 3 46.77 3 56.283 16.206 64 32.5 64 48.791 64 62 56.283 62 46.77c0-1.71-.443-3.362-1.239-4.923.796-1.56 1.239-3.212 1.239-4.923 0-1.71-.443-3.362-1.239-4.923.796-1.56 1.239-3.212 1.239-4.923 0-1.71-.443-3.362-1.239-4.923" }));
});

var _extends$G = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$F(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$h = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$F(_ref, ["styles"]);

  return React.createElement("svg", _extends$G({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M8 4v80h88v8H4a4 4 0 0 1-3.973-3.534L0 88V4zm83.982 8c2.06 0 3.759 1.533 3.991 3.507l.027.463v19.85h-8.035V25.157L84.6 28.505l-7.642 7.607c-2.559 2.554-6.676 5.13-10.888 6.809l-.392.148-.216.543c-1.4 3.384-3.437 6.768-5.59 9.304l-.721.812-.5.498-.184.162-10.45 10.322a4.054 4.054 0 0 1-5.303.33l-.379-.33-8.122-8.032L16.682 74 11 68.386l20.369-20.128a4.054 4.054 0 0 1 5.301-.332l.379.33 8.129 8.03 8.244-8.135.505-.579a24.99 24.99 0 0 0 2.018-2.87h-.007a11.314 11.314 0 0 1-1.634-.31l-.612-.175-1.589-.59c-4.95-1.986-7.814-7.131-6.819-12.527a10.633 10.633 0 0 1 2.955-5.19c1.44-1.427 3.243-2.445 5.467-3.002 5.057-.953 10.087 1.62 12.21 6.083l.632 1.454c.403.93.66 1.924.784 3.003 1.29-.77 2.452-1.598 3.36-2.4l.561-.526 7.635-7.601.011-.01 2.987-2.971h-9.991V12zM55.84 30.615l-.381.038a3.41 3.41 0 0 0-1.575.908c-.385.37-.655.84-.736 1.156-.247 1.348.397 2.684 1.51 3.332l.387.19 1.193.443.29.01c.548.023 1.151.017 1.737-.013l.99-.08.082-.468v-.427l.023-.003.027-.454c.02-.594-.034-1.073-.137-1.43l-.088-.244-.404-.938c-.505-1.26-1.761-2.042-2.918-2.02z" }));
});

var _extends$H = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$G(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$i = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$G(_ref, ["styles"]);

  return React.createElement("svg", _extends$H({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M14.5 14.618h-13c-.276 0-.5-.21-.5-.47v-3.52l3.849-3.243 3.83 2.47.058.053.01-.01.016.01.732-.69-.015-.01L15 4.014v10.134c0 .26-.223.471-.5.471zM1 1.912c0-.26.224-.47.5-.47h13c.277 0 .5.21.5.47v.722L8.611 8.648l-3.79-2.443-.058-.054-.011.01-.015-.01-.224.21L1 9.322v-7.41zM15 .5H1c-.552 0-1 .422-1 .942v13.176c0 .52.448.94 1 .94h14c.552 0 1-.42 1-.94V1.442c0-.52-.448-.942-1-.942z" }));
});

var _extends$I = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$H(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$i = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$H(_ref, ["styles"]);

  return React.createElement("svg", _extends$I({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M54.982.39l12.27 14.141 8.803-1.832 5.177 17.258h9.15v22.871a18.92 18.92 0 0 1-3.187 10.527l-.084.13a18.981 18.981 0 0 1 3.272 10.652V96H17.105c-6.341-.007-11.48-5.146-11.488-11.488v-39.32h8v39.32A3.493 3.493 0 0 0 17.105 88h65.278V74.137c0-1.389-.264-2.765-.778-4.055a19.31 19.31 0 0 1-11.128 3.45 10.553 10.553 0 1 1-.008-21.106 15.997 15.997 0 0 1 11.02 4.746 10.95 10.95 0 0 0 .894-4.344V37.957H14.299a8.68 8.68 0 1 1 0-17.36h16.858zM70.46 60.427a2.553 2.553 0 0 0 .01 5.105c2.23.019 4.415-.623 6.281-1.843a8.763 8.763 0 0 0-6.291-3.262zm2.42-30.47L70.5 22.028l-38.14 7.93zm-52.757 0l1.603-1.36-7.426.002a.68.68 0 1 0 0 1.359zM54.123 11.61l-8.826 7.485 12.982-2.7z" }));
});

var _extends$J = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$I(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$j = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$I(_ref, ["styles"]);

  return React.createElement("svg", _extends$J({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M12 10h1V9h-1v1zm.492-2.008a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM15 14.502a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V5.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v9zM1 3V1.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v2.495H1V3zm14 1h-2.005V1.733C12.995.776 12.26 0 11.354 0H1.639C.811 0 .133.652.022 1.496H0V15a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z" }));
});

var _extends$K = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$J(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPlaceholder = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$J(_ref, ["styles"]);

  return React.createElement("svg", _extends$K({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M96 90.8V5.5l.1-.1-.1-.1V0H-.2v96h5.1l.3.3.3-.3h85l.3.3.3-.3H96v-5.2zM47.9 42.7L12.8 7.6H83L47.9 42.7zm40.5-29.6v70.1l-35-35 35-35.1zm-45.8 35L7.8 82.9V13.4l34.8 34.7zm5.3 5.4l34.8 34.8H13.1l34.8-34.8z" }));
});

var _extends$L = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$K(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconArrowDownSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$K(_ref, ["styles"]);

  return React.createElement("svg", _extends$L({ height: "16", viewBox: "0 0 16 16", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M6.75 11.301L4.647 9.128 3 10.83 8 16l5-5.17-1.648-1.702L9.25 11.3V0h-2.5z" }));
});

var _extends$M = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$L(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconArrowDownSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$L(_ref, ["styles"]);

  return React.createElement("svg", _extends$M({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M10.75 15.301l-2.103-2.173L7 14.83 12 20l5-5.17-1.648-1.702L13.25 15.3V4h-2.5z" }));
});

var _extends$N = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$M(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconArrowUpSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$M(_ref, ["styles"]);

  return React.createElement("svg", _extends$N({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M9.25 4.699l2.103 2.173L13 5.17 8 0 3 5.17l1.648 1.702L6.75 4.7V16h2.5z" }));
});

var _extends$O = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$N(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconArrowUpSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$N(_ref, ["styles"]);

  return React.createElement("svg", _extends$O({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13.25 8.699l2.103 2.173L17 9.17 12 4 7 9.17l1.648 1.702L10.75 8.7V20h2.5z" }));
});

var _extends$P = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$O(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$k = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$O(_ref, ["styles"]);

  return React.createElement("svg", _extends$P({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 57.908l26.275-26.902a3.315 3.315 0 0 1 4.743 0 3.475 3.475 0 0 1 0 4.855L50.564 64.994a3.307 3.307 0 0 1-2.564.993 3.306 3.306 0 0 1-2.564-.993L16.982 35.861a3.475 3.475 0 0 1 0-4.855 3.315 3.315 0 0 1 4.743 0L48 57.908z" }));
});

var _extends$Q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$P(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChevronLeftLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$P(_ref, ["styles"]);

  return React.createElement("svg", _extends$Q({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M33.651 48.179l39.476 38.966a5 5 0 0 1 0 7.117l-.342.338a5 5 0 0 1-7.025 0L22.826 52.22a4.983 4.983 0 0 1-1.14-1.725 5.002 5.002 0 0 1 .825-6.047L66.12 1.4a5 5 0 0 1 7.026 0l.342.338a5 5 0 0 1 0 7.117z" }));
});

var _extends$R = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$Q(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChevronLeftSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$Q(_ref, ["styles"]);

  return React.createElement("svg", _extends$R({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "icon-chevronleft-small"), React.createElement("path", { d: "M17 17.364L14.522 20 7 12l7.522-8L17 6.635 11.958 12" }));
});

var _extends$S = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$R(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChevronLeftSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$R(_ref, ["styles"]);

  return React.createElement("svg", _extends$S({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M38.434 48.12l26.234 25.894a3.449 3.449 0 0 1 0 4.91 3.54 3.54 0 0 1-4.973 0L31.3 50.896a3.437 3.437 0 0 1-.784-1.182 3.45 3.45 0 0 1 .574-4.164l28.845-28.474a3.54 3.54 0 0 1 4.973 0 3.449 3.449 0 0 1 0 4.91z" }));
});

var _extends$T = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$S(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChevronRightSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$S(_ref, ["styles"]);

  return React.createElement("svg", _extends$T({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M62.862 48L22.508 8.587a4.972 4.972 0 0 1 0-7.114l.148-.144a5 5 0 0 1 6.988 0l43.848 42.826A4.96 4.96 0 0 1 74.982 48a4.959 4.959 0 0 1-1.49 3.845L29.644 94.671a5 5 0 0 1-6.988 0l-.148-.144a4.972 4.972 0 0 1 0-7.114L62.862 48z" }));
});

var _extends$U = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$T(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChevronRightSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$T(_ref, ["styles"]);

  return React.createElement("svg", _extends$U({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M57.908 48L31.006 21.725a3.315 3.315 0 0 1 0-4.743 3.475 3.475 0 0 1 4.855 0l29.133 28.454A3.307 3.307 0 0 1 65.987 48a3.306 3.306 0 0 1-.993 2.564L35.861 79.018a3.475 3.475 0 0 1-4.855 0 3.315 3.315 0 0 1 0-4.743L57.908 48z" }));
});

var _extends$V = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$U(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$l = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$U(_ref, ["styles"]);

  return React.createElement("svg", _extends$V({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 33.138L8.587 73.492a4.972 4.972 0 0 1-7.114 0l-.144-.148a5 5 0 0 1 0-6.988l42.826-43.848A4.96 4.96 0 0 1 48 21.018a4.959 4.959 0 0 1 3.845 1.49l42.826 43.848a5 5 0 0 1 0 6.988l-.144.148a4.972 4.972 0 0 1-7.114 0z" }));
});

var _extends$W = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$V(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChevronUpSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$V(_ref, ["styles"]);

  return React.createElement("svg", _extends$W({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 38.092L21.725 64.994a3.315 3.315 0 0 1-4.743 0 3.475 3.475 0 0 1 0-4.855l28.454-29.133A3.307 3.307 0 0 1 48 30.013a3.306 3.306 0 0 1 2.564.993l28.454 29.133a3.475 3.475 0 0 1 0 4.855 3.315 3.315 0 0 1-4.743 0z" }));
});

var _extends$X = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$W(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTriangleDownSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$W(_ref, ["styles"]);

  return React.createElement("svg", _extends$X({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M8 16L0 0h16z" }));
});

var _extends$Y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$X(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTriangleDownSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$X(_ref, ["styles"]);

  return React.createElement("svg", _extends$Y({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon triangle down"), React.createElement("path", { d: "M16 22l-6-12h12z" }));
});

var _extends$Z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$Y(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTriangleLeftSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$Y(_ref, ["styles"]);

  return React.createElement("svg", _extends$Z({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M0 8l16-8v16z" }));
});

var _extends$_ = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$Z(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTriangleLeftSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$Z(_ref, ["styles"]);

  return React.createElement("svg", _extends$_({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon triangle left"), React.createElement("path", { d: "M10 16l12-6v12z" }));
});

var _extends$$ = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$_(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTriangleRightSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$_(_ref, ["styles"]);

  return React.createElement("svg", _extends$$({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon triangle right"), React.createElement("path", { d: "M22 16l-12 6V10z" }));
});

var _extends$10 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$$(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTriangleUpSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$$(_ref, ["styles"]);

  return React.createElement("svg", _extends$10({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M8 0l8 16H0z" }));
});

var _extends$11 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$10(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTriangleUpSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$10(_ref, ["styles"]);

  return React.createElement("svg", _extends$11({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon triangle up"), React.createElement("path", { d: "M16 8.667l6 12H10z" }));
});

var _extends$12 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$11(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconBriefcaseBrandedLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$11(_ref, ["styles"]);

  return React.createElement("svg", _extends$12({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fill: "#D3211D", d: "M1.72 89.391h90.958V25.436H1.72z" }), React.createElement("path", { d: "M60.175 28.131h7.846c.523 0 .95-.428.95-.95v-4.519a.952.952 0 0 0-.95-.949h-7.846a.952.952 0 0 0-.95.949v4.518c0 .523.427.951.95.951M26.352 28.131h7.844a.955.955 0 0 0 .953-.95v-4.519a.954.954 0 0 0-.953-.949h-7.844a.952.952 0 0 0-.953.949v4.518c0 .523.428.951.953.951", fill: "#FEFEFE" }), React.createElement("path", { d: "M66.149 21.713l-.01-5.33-.297-1.442c-.721-1.97-1.732-3.197-3.523-4.288-1.16-.562-2.123-.827-3.414-.891l-24.064.034-1.442.295c-2.217.815-3.572 2.041-4.598 4.17a8.758 8.758 0 0 0-.582 2.771l.01 4.681h4.095v-4.58a3.28 3.28 0 0 1 3.27-3.266h23.208a3.278 3.278 0 0 1 3.267 3.265v4.581h4.08z", fill: "#B2B2B1" }), React.createElement("path", { fill: "#B11B19", d: "M9.77 81.654h74.854V30.33H9.77z" }), React.createElement("path", { fill: "#E22719", d: "M.14 25.435h94.113v28.79l-18.792 3.316h-56.53L.14 54.226z" }), React.createElement("path", { d: "M1.719 89.39V78.649H3.13a2.15 2.15 0 0 1 2.143 2.143v5.043h5.043c1.176 0 2.141.963 2.141 2.14v1.415H1.718zM92.677 89.39V78.649h-1.415a2.15 2.15 0 0 0-2.142 2.143v5.043h-5.042a2.148 2.148 0 0 0-2.143 2.14v1.415h10.742z", fill: "#C5C5C5" }), React.createElement("path", { d: "M76.451 52.547v10.52c0 .986-.807 1.792-1.792 1.792h-7.682a1.797 1.797 0 0 1-1.792-1.792v-10.52c0-.986.806-1.794 1.792-1.794h7.682c.986 0 1.792.808 1.792 1.794", fill: "#FEFEFE" }), React.createElement("path", { fill: "#C5C5C5", d: "M67.708 62.332h6.216v-9.053h-6.216z" }), React.createElement("path", { d: "M29.208 52.547v10.52c0 .986-.805 1.792-1.792 1.792h-7.682a1.797 1.797 0 0 1-1.792-1.792v-10.52c0-.986.806-1.794 1.792-1.794h7.682c.987 0 1.792.808 1.792 1.794", fill: "#FEFEFE" }), React.createElement("path", { fill: "#C5C5C5", d: "M20.468 62.332h6.214v-9.053h-6.214z" }), React.createElement("path", { d: "M36.972 8.26H57.42c.741 0 1.348.607 1.348 1.347v5.134c0 .74-.607 1.346-1.348 1.346H36.972a1.35 1.35 0 0 1-1.344-1.346V9.607c0-.74.605-1.347 1.344-1.347", fill: "#E22719" }));
});

var _extends$13 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$12(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconBriefcaseBrandedSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$12(_ref, ["styles"]);

  return React.createElement("svg", _extends$13({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fill: "#D3211D", d: "M17.146 74.927h60.64V32.291h-60.64z" }), React.createElement("path", { d: "M56.117 34.087h5.23a.636.636 0 0 0 .634-.633V30.44a.635.635 0 0 0-.633-.632h-5.231a.635.635 0 0 0-.634.632v3.013c0 .348.285.633.634.633M33.568 34.087h5.23a.637.637 0 0 0 .634-.633V30.44a.636.636 0 0 0-.635-.632h-5.23a.635.635 0 0 0-.634.632v3.013c0 .348.285.633.635.633", fill: "#FEFEFE" }), React.createElement("path", { d: "M60.1 29.809l-.007-3.554-.198-.961c-.481-1.313-1.155-2.132-2.349-2.858-.773-.375-1.415-.552-2.276-.595l-16.042.023-.962.197c-1.478.543-2.381 1.36-3.065 2.78a5.838 5.838 0 0 0-.388 1.847l.006 3.12h2.73v-3.053c0-1.196.984-2.177 2.18-2.177H55.2c1.196 0 2.178.98 2.178 2.177v3.054h2.72z", fill: "#B2B2B1" }), React.createElement("path", { fill: "#B11B19", d: "M22.513 69.77h49.903V35.552H22.513z" }), React.createElement("path", { fill: "#E22719", d: "M16.093 32.29h62.742v19.194l-12.527 2.21H28.62l-12.528-2.21z" }), React.createElement("path", { d: "M17.146 74.927v-7.161h.941c.786 0 1.429.643 1.429 1.428v3.362h3.362c.784 0 1.427.642 1.427 1.428v.943h-7.16zM77.784 74.927v-7.161h-.942c-.786 0-1.429.643-1.429 1.428v3.362h-3.36c-.786 0-1.43.642-1.43 1.428v.943h7.161z", fill: "#C5C5C5" }), React.createElement("path", { d: "M66.967 50.365v7.013c0 .657-.538 1.194-1.194 1.194h-5.121a1.198 1.198 0 0 1-1.195-1.194v-7.013c0-.658.537-1.196 1.195-1.196h5.12c.658 0 1.195.538 1.195 1.196", fill: "#FEFEFE" }), React.createElement("path", { fill: "#C5C5C5", d: "M61.139 56.888h4.144v-6.035h-4.144z" }), React.createElement("path", { d: "M35.472 50.365v7.013c0 .657-.537 1.194-1.195 1.194h-5.12a1.198 1.198 0 0 1-1.195-1.194v-7.013c0-.658.537-1.196 1.194-1.196h5.121c.658 0 1.195.538 1.195 1.196", fill: "#FEFEFE" }), React.createElement("path", { fill: "#C5C5C5", d: "M29.646 56.888h4.142v-6.035h-4.142z" }), React.createElement("path", { d: "M40.648 20.84H54.28c.494 0 .899.405.899.898v3.423a.901.901 0 0 1-.9.897H40.65a.9.9 0 0 1-.897-.897v-3.423a.9.9 0 0 1 .896-.898", fill: "#E22719" }));
});

var _extends$14 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$13(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMailBrandedLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$13(_ref, ["styles"]);

  return React.createElement("svg", _extends$14({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fill: "#D3211D", d: "M48 6l48 27.871H0z" }), React.createElement("path", { fill: "#B11B19", d: "M0 89.613h96V33.87H0z" }), React.createElement("path", { fill: "#B11B19", d: "M48 89.613h48V33.87H48z" }), React.createElement("path", { fill: "#D3211D", d: "M48 61.742l48 27.87H0z" }), React.createElement("path", { fill: "#E22719", d: "M48 61.742L96 33.87H0z" }), React.createElement("path", { fill: "#FEFEFE", d: "M75.871 44.76V26.129h-57.29v18.63l28.645 16.983z" }), React.createElement("path", { d: "M41.162 56.17l6.956 4.024 6.956-4.024H41.162zM24.774 34.947h46.45v-4.173h-46.45v4.173zm1.76 12.757l7.206 4.17h28.758l7.204-4.17H26.534zm-1.76-8.464h46.45c.002 1.392.002 2.78 0 4.169h-46.45v-4.17z", fill: "#B2B2B1" }));
});

var _extends$15 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$14(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMailBrandedSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$14(_ref, ["styles"]);

  return React.createElement("svg", _extends$15({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fill: "#D3211D", d: "M48 20l32 18.58H16z" }), React.createElement("path", { fill: "#B11B19", d: "M16 75.742h64V38.58H16z" }), React.createElement("path", { fill: "#B11B19", d: "M48 75.742h32V38.58H48z" }), React.createElement("path", { fill: "#D3211D", d: "M48 57.161l32 18.58H16z" }), React.createElement("path", { fill: "#E22719", d: "M48 57.161l32-18.58H16z" }), React.createElement("path", { fill: "#FEFEFE", d: "M66.58 45.84V33.42H28.388v12.42L47.484 57.16z" }), React.createElement("path", { d: "M43.441 53.446l4.637 2.683 4.638-2.683H43.44zM32.516 39.298h30.967v-2.782H32.516v2.782zm1.173 8.505l4.804 2.78h19.172l4.803-2.78H33.689zm-1.173-5.643h30.967v2.78H32.516v-2.78z", fill: "#B2B2B1" }));
});

var _extends$16 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$15(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChatSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$15(_ref, ["styles"]);

  return React.createElement("svg", _extends$16({ width: "24", height: "22", viewBox: "0 0 24 22", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M24 13.518c0-2.57-1.196-4.864-3.067-6.396.131.715.208 1.446.208 2.198 0 5.808-4.109 10.652-9.522 11.693a8.686 8.686 0 0 0 3.793.878 8.707 8.707 0 0 0 3.601-.78c1.392.563 2.908.71 4.164.71a13.259 13.259 0 0 1-1.431-2.67C23.142 17.667 24 15.69 24 13.519z" }), React.createElement("path", { d: "M18.891 9.32c0-5.084-4.227-9.211-9.445-9.211S0 4.234 0 9.32c0 2.65 1.156 5.036 2.998 6.715a14.912 14.912 0 0 1-1.926 3.91c1.887 0 4.315-.295 6.188-1.675a9.588 9.588 0 0 0 2.187.256c5.216 0 9.444-4.123 9.444-9.206z" }));
});

var _extends$17 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$16(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMailOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$16(_ref, ["styles"]);

  return React.createElement("svg", _extends$17({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M14.5 13.5h-13A.5.5 0 0 1 1 13V3.02l6.617 5.297c.01.011.014.026.024.037A.486.486 0 0 0 8 8.495c.13.003.26-.043.358-.142.011-.01.015-.026.025-.037L15 3.02V13a.5.5 0 0 1-.5.5zm-.416-10.999L8 7.371 1.916 2.5h12.168zm1.915-.508a.482.482 0 0 0-.524-.492H.525a.481.481 0 0 0-.523.492L0 2v12.001a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-12l-.002-.008z" }));
});

var _extends$18 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$17(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMailOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$17(_ref, ["styles"]);

  return React.createElement("svg", _extends$18({ height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M18.5 17.5h-13A.5.5 0 0 1 5 17V7.02l6.617 5.297c.01.011.014.026.025.037a.486.486 0 0 0 .358.142c.13.003.26-.043.358-.142.011-.01.015-.026.025-.037L19 7.02V17a.5.5 0 0 1-.5.5zm-.416-10.999L12 11.371 5.916 6.5zm1.915-.508a.482.482 0 0 0-.524-.492H4.525a.481.481 0 0 0-.523.492L4 6v12.001a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-12l-.001-.008z" }));
});

var _extends$19 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$18(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMailReadOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$18(_ref, ["styles"]);

  return React.createElement("svg", _extends$19({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M31.836 60.015l13.089 10.563 1.404 1.407.174-.132.162.132 1.056-1.053 15.693-11.901L86.943 90H9.054l22.782-29.985zM6 39.165l20.934 16.896L6 83.619V39.165zM48 6l40.773 26.208-42.135 31.956-39.507-31.89L48 6zm42 77.619L68.43 55.227 90 38.871v44.748zM48 0L0 30v66h96V30L48 0z" }));
});

var _extends$1a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$19(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMailReadOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$19(_ref, ["styles"]);

  return React.createElement("svg", _extends$1a({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M73.766 76.007L56.127 54.25l-8.151 5.287-.016-.027-.022.038-8.27-5.382L21.96 76.007zm2.077 0h.112v-.09zm.112-3.644V41.388L59.498 52.063zm-55.958-.277l16.304-20.112-16.304-10.608zm1.718-34.375L48 54.762l26.194-16.991L47.908 20.72zm58.237.98l.048.074-.048.03V80H16V36.747h.058l-.058-.09L47.846 16l.193.297.115-.178L80 36.777l-.048.074z" }));
});

var _extends$1b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1a(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMailSentOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1a(_ref, ["styles"]);

  return React.createElement("svg", _extends$1b({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M31.132 57.703L9.907 47.585 76.88 14.356l-45.75 43.347zM48.27 86.395L35.4 61.94l47.181-44.703-34.312 69.16zM95.334 1.32c-.09-.132-.198-.234-.306-.348-.111-.105-.213-.213-.34-.3-.726-.56-1.653-.828-2.598-.576L2.283 44.654c-.057.015-.1.06-.153.078-.972.282-1.788 1.002-2.055 2.061-.135.537-.072 1.068.072 1.572.003.015 0 .024.003.04.009.032.033.056.042.092.105.306.237.594.426.862.09.129.195.234.306.348.153.162.306.306.495.435.156.108.32.177.498.252.138.063.252.162.402.207l27.237 12.985 15.845 30.1c.042.156.147.27.21.414.072.171.144.33.246.483.13.186.276.34.438.495.114.108.22.216.351.31.265.185.547.314.856.416.036.012.057.04.093.048.015.003.03 0 .045.003.504.144 1.035.204 1.569.07 1.059-.265 1.773-1.078 2.061-2.05.018-.057.06-.096.075-.153L95.907 3.91c.252-.94-.015-1.87-.573-2.59z" }));
});

var _extends$1c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1b(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconReplySolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1b(_ref, ["styles"]);

  return React.createElement("svg", _extends$1c({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M37.333 28.187V6L0 44.827l37.333 38.826V60.912C64 60.912 82.667 69.787 96 89.2c-5.333-27.733-21.333-55.467-58.667-61.013z" }));
});

var _extends$1d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1c(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconReplySolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1c(_ref, ["styles"]);

  return React.createElement("svg", _extends$1d({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M40.889 34.791V20L16 45.884 40.889 71.77V56.608c17.778 0 30.222 5.916 39.111 18.859-3.555-18.49-14.222-36.978-39.111-40.676z" }));
});

var _extends$1e = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1d(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTelephoneOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1d(_ref, ["styles"]);

  return React.createElement("svg", _extends$1e({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon telephone"), React.createElement("path", { d: "M9.437 23.304l-.287-.29c-.21-.213-.358-.356-.497-.485-1.364-1.262-2.338-1.168-4.95.932-1.384 1.11-1.823 1.98-1.674 2.748.1.526 1.18 1.924 2.594 3.215 2.154 1.967 10.216-1.19 16.914-7.886 6.73-6.73 9.938-14.852 7.94-16.847-.094-.095-.472-.55-.572-.665-.28-.32-.57-.62-.878-.897-.672-.603-1.318-.992-1.845-1.1-.737-.154-1.604.287-2.722 1.678-2.098 2.61-2.192 3.583-.934 4.945.13.14.273.288.485.498l.29.287.278.274c1.96 1.97-.046 4.95-4.484 9.39-4.443 4.44-7.42 6.442-9.39 4.473l-.268-.27zm1.683-1.143c.59.59 3.183-1.097 6.563-4.474 3.376-3.377 5.065-5.974 4.48-6.56a98.64 98.64 0 0 0-.56-.553c-.222-.22-.39-.392-.545-.56-1.966-2.13-1.883-4.165.845-7.557 1.543-1.92 3.1-2.713 4.687-2.384 2.243.466 4.11 3.015 4.303 3.208 3.04 3.037-.375 12.107-7.942 19.674-7.568 7.566-16.52 10.832-19.676 7.948-1.516-1.385-2.98-3.13-3.21-4.31-.308-1.592.466-3.147 2.385-4.69 3.394-2.727 5.43-2.81 7.56-.842.168.156.338.322.56.544.037.04.43.438.55.556z" }));
});

var _extends$1f = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1e(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTelephoneOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1e(_ref, ["styles"]);

  return React.createElement("svg", _extends$1f({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M8.719 15.673l-.144-.145a7.533 7.533 0 0 0-.248-.243c-.682-.632-1.17-.585-2.475.467-.692.556-.912.991-.837 1.376.05.263.59.964 1.297 1.61 1.077.986 5.108-.596 8.457-3.95 3.365-3.37 4.969-7.44 3.97-8.439-.047-.047-.236-.275-.286-.333-.14-.16-.285-.31-.439-.449-.336-.302-.659-.497-.923-.551-.368-.077-.802.144-1.36.84-1.05 1.308-1.097 1.795-.468 2.478.065.07.137.144.243.249l.145.144.139.137c.98.987-.023 2.48-2.242 4.704-2.222 2.224-3.71 3.226-4.695 2.24l-.134-.135zm.841-.573c.295.296 1.592-.55 3.282-2.24 1.688-1.692 2.532-2.993 2.24-3.287l-.28-.277a8.616 8.616 0 0 1-.273-.28c-.983-1.067-.941-2.087.423-3.786.771-.961 1.55-1.359 2.343-1.194 1.122.234 2.056 1.51 2.152 1.607 1.52 1.521-.187 6.065-3.971 9.855-3.784 3.79-8.26 5.426-9.838 3.981-.758-.693-1.49-1.568-1.605-2.159-.154-.797.233-1.576 1.192-2.349 1.697-1.366 2.715-1.407 3.78-.422.084.078.17.162.28.273.019.02.215.22.275.278z" }));
});

var _extends$1g = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1f(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconBuildingOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1f(_ref, ["styles"]);

  return React.createElement("svg", _extends$1g({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M14 19h1V5H9v14h1v-3h4v3zM8 7V4h8v3h4v13H4V7h4zm8 1v11h3V8h-3zM5 19h3V8H5v11zm6-2v2h2v-2h-2zM10 7h4v1h-4V7zm0 3h4v1h-4v-1zm0 3h4v1h-4v-1zm-4-3h1v1H6v-1zm11 0h1v1h-1v-1zM6 13h1v1H6v-1zm11 0h1v1h-1v-1zM6 16h1v1H6v-1zm11 0h1v1h-1v-1z" }));
});

var _extends$1h = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1g(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCalculatorOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1g(_ref, ["styles"]);

  return React.createElement("svg", _extends$1h({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon calculator"), React.createElement("path", { d: "M4 6.005C4 4.898 4.912 4 6.005 4h19.99C27.102 4 28 4.912 28 6.005v19.99A2.014 2.014 0 0 1 25.995 28H6.005A2.014 2.014 0 0 1 4 25.995V6.005zM6 10v16h20V10H6zm0-4v2h20V6H6zm2 9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2zm0 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2zm6-6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2zm0 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2zm6-6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2zm0 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2z" }));
});

var _extends$1i = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1h(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCalculatorOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1h(_ref, ["styles"]);

  return React.createElement("svg", _extends$1i({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon calculator"), React.createElement("path", { d: "M24 24V10H10v14h14zm-16 .005V9.995C8 8.893 8.893 8 9.995 8h14.01C25.107 8 26 8.893 26 9.995v14.01A1.995 1.995 0 0 1 24.005 26H9.995A1.995 1.995 0 0 1 8 24.005zM12 16v2h2v-2h-2zm0 4v2h2v-2h-2zm4-4v2h2v-2h-2zm0 4v2h2v-2h-2zm4-4v2h2v-2h-2zm0 4v2h2v-2h-2zm-10-8v2h14v-2H10z" }));
});

var _extends$1j = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1i(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CalendarOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1i(_ref, ["styles"]);

  return React.createElement("svg", _extends$1j({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M15.465 1h-3.733V0h-1.066v1H5.333V0H4.266v1h-3.2C.479 1 0 1.45 0 2v13c0 .55.478 1 1.067 1h13.865c.589 0 1.067-.45 1.067-1V2c0-.55.055-1-.534-1zm-.533 13.5c0 .28-.239.5-.533.5h-12.8c-.294 0-.532-.22-.532-.5V5h13.865v9.5zm0-10.5H1.067V2.5c0-.28.238-.5.533-.5h2.666v1h1.067V2h5.333v1h1.066V2H14.4c.294 0 .533.22.533.5V4zM6.399 14v-3h3.2v3H6.4zm1.067-1h1.067v-1H7.466v1zm3.2 1h3.2v-3h-3.2v3zm-4.267-4h3.2V7H6.4v3zm-4.266 0h3.2V7h-3.2v3zm0 4v-3h3.2v3h-3.2zM3.2 13h1.066v-1H3.2v1zm4.266-4V8h1.067v1H7.466zM3.2 9V8h1.066v1H3.2zm8.532 4v-1H12.8v1h-1.067zm0-4V8H12.8v1h-1.067zm-1.066 1h3.2V7h-3.2v3z" }));
});

var _extends$1k = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1j(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCalendaroutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1j(_ref, ["styles"]);

  return React.createElement("svg", _extends$1k({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M19.465 5h-3.733V4h-1.066v1H9.333V4H8.266v1h-3.2C4.479 5 4 5.45 4 6v13c0 .55.478 1 1.067 1h13.865c.589 0 1.067-.45 1.067-1V6c0-.55.055-1-.534-1zm-.533 13.5c0 .28-.239.5-.533.5h-12.8c-.294 0-.532-.22-.532-.5V9h13.865v9.5zm0-10.5H5.067V6.5c0-.28.238-.5.533-.5h2.666v1h1.067V6h5.333v1h1.066V6H18.4c.294 0 .533.22.533.5V8zm-8.533 10v-3h3.2v3h-3.2zm1.067-1h1.067v-1h-1.067v1zm3.2 1h3.2v-3h-3.2v3zm-4.267-4h3.2v-3h-3.2v3zm-4.266 0h3.2v-3h-3.2v3zm0 4v-3h3.2v3h-3.2zM7.2 17h1.066v-1H7.2v1zm4.266-4v-1h1.067v1h-1.067zM7.2 13v-1h1.066v1H7.2zm8.532 4v-1H16.8v1h-1.067zm0-4v-1H16.8v1h-1.067zm-1.066 1h3.2v-3h-3.2v3z" }));
});

var _extends$1l = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1k(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCoinsOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1k(_ref, ["styles"]);

  return React.createElement("svg", _extends$1l({ xmlns: "http://www.w3.org/2000/svg", width: "64", height: "64", viewBox: "0 0 64 64" }, props), React.createElement("path", { d: "M32.5 29.54c-13.577 0-24.583-5.509-24.583-12.307 0-6.796 11.006-12.308 24.583-12.308 13.575 0 24.583 5.512 24.583 12.308 0 6.798-11.008 12.307-24.583 12.307m0 9.846c-13.577 0-24.583-5.51-24.583-12.308 0-.1.027-.199.032-.297 5.285 4.63 14.305 7.682 24.551 7.682 10.246 0 19.266-3.053 24.551-7.685.005.101.032.2.032.3 0 6.799-11.008 12.308-24.583 12.308m0 9.848c-13.577 0-24.583-5.511-24.583-12.31 0-.1.027-.2.032-.3 5.285 4.63 14.305 7.684 24.551 7.684 10.246 0 19.264-3.054 24.551-7.684.005.1.032.2.032.3 0 6.799-11.008 12.31-24.583 12.31m0 9.843c-13.577 0-24.583-5.509-24.583-12.307 0-.101.027-.2.032-.3 5.285 4.632 14.305 7.684 24.551 7.684 10.246 0 19.264-3.052 24.551-7.684.005.1.032.199.032.3 0 6.798-11.008 12.307-24.583 12.307m28.261-36.922c.796-1.56 1.239-3.21 1.239-4.922C62 7.719 48.791 0 32.5 0 16.206 0 3 7.72 3 17.233c0 1.713.442 3.362 1.239 4.922C3.443 23.716 3 25.368 3 27.078c0 1.711.442 3.363 1.239 4.923C3.443 33.561 3 35.213 3 36.924c0 1.71.442 3.362 1.239 4.923C3.443 43.407 3 45.059 3 46.77 3 56.283 16.206 64 32.5 64 48.791 64 62 56.283 62 46.77c0-1.71-.443-3.362-1.239-4.923.796-1.56 1.239-3.212 1.239-4.923 0-1.71-.443-3.362-1.239-4.923.796-1.56 1.239-3.212 1.239-4.923 0-1.71-.443-3.362-1.239-4.923" }));
});

var _extends$1m = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1l(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCoinsOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1l(_ref, ["styles"]);

  return React.createElement("svg", _extends$1m({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12.375 11.385c-3.394 0-6.146-1.377-6.146-3.077 0-1.699 2.752-3.077 6.146-3.077s6.146 1.378 6.146 3.077c0 1.7-2.752 3.077-6.146 3.077m0 2.461c-3.394 0-6.146-1.377-6.146-3.076 0-.026.007-.05.008-.075 1.322 1.158 3.576 1.92 6.138 1.92s4.816-.762 6.138-1.92c.001.025.008.05.008.075 0 1.7-2.752 3.076-6.146 3.076m0 2.462c-3.394 0-6.146-1.377-6.146-3.077 0-.025.007-.05.008-.075 1.322 1.157 3.576 1.921 6.138 1.921s4.816-.764 6.138-1.921c.001.025.008.05.008.075 0 1.7-2.752 3.077-6.146 3.077m0 2.461c-3.394 0-6.146-1.377-6.146-3.077 0-.025.007-.05.008-.075 1.322 1.159 3.576 1.922 6.138 1.922s4.816-.763 6.138-1.922c.001.026.008.05.008.075 0 1.7-2.752 3.077-6.146 3.077m7.065-9.23c.2-.39.31-.803.31-1.23C19.75 5.928 16.448 4 12.375 4S5 5.93 5 8.308c0 .428.11.84.31 1.23-.2.391-.31.804-.31 1.232 0 .427.11.84.31 1.23-.2.39-.31.803-.31 1.231 0 .428.11.84.31 1.23-.2.39-.31.804-.31 1.231C5 18.071 8.302 20 12.375 20s7.375-1.93 7.375-4.308c0-.427-.11-.84-.31-1.23.2-.39.31-.803.31-1.231 0-.428-.11-.84-.31-1.23.2-.39.31-.804.31-1.231 0-.428-.11-.841-.31-1.231" }));
});

var _extends$1n = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1m(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCreditCardOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1m(_ref, ["styles"]);

  return React.createElement("svg", _extends$1n({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M16 34.957C16 28.986 18.7 26 24.1 26h46.705C76.935 26 80 28.798 80 34.393v25.978c0 5.928-3.065 8.892-9.195 8.892H24.1c-5.4 0-8.1-2.649-8.1-7.947v-26.36zm4 2.3v21.577c0 4.336 2.362 6.505 7.087 6.505h40.867c5.364 0 8.046-2.426 8.046-7.279V36.795c0-4.58-2.682-6.87-8.046-6.87H27.087c-4.725 0-7.087 2.443-7.087 7.331z" }), React.createElement("path", { d: "M66 56c.637-.618 1.509-1 2.47-1 1.95 0 3.53 1.567 3.53 3.5S70.42 62 68.47 62A3.533 3.533 0 0 1 66 61c-.637.618-1.509 1-2.47 1-1.95 0-3.53-1.567-3.53-3.5s1.58-3.5 3.53-3.5c.961 0 1.833.382 2.47 1zM76 36H20v6h56zM25 50.927h32.705V47H25z" }));
});

var _extends$1o = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1n(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLoanOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1n(_ref, ["styles"]);

  return React.createElement("svg", _extends$1o({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M2 1v14h12V1H2zM1 0h14v16H1V0zm3.552 4.983a.654.654 0 0 1-.182.478h-.305A.067.067 0 0 0 4 5.526v.409c0 .035.03.065.065.065h1.94c.034 0 .065-.03.065-.065v-.409a.067.067 0 0 0-.066-.065H4.952a.85.85 0 0 0 .174-.513c0-.022-.004-.044-.004-.065h.63c.04 0 .065-.03.065-.07v-.365a.064.064 0 0 0-.065-.065h-.76a1.468 1.468 0 0 1-.092-.448.41.41 0 0 1 .117-.3.496.496 0 0 1 .353-.126c.152 0 .3.039.456.121.03.018.065.01.083-.026l.165-.343a.064.064 0 0 0-.026-.083A1.48 1.48 0 0 0 5.313 3c-.317 0-.56.096-.735.252a.846.846 0 0 0-.274.652c0 .17.044.326.092.479h-.23a.067.067 0 0 0-.066.065v.365c0 .04.03.07.065.07h.378c.005.034.01.07.01.1zM7 4v1h5V4H7zM4 8v1h4V8H4zm6 0v1h2V8h-2zm-6 2v1h4v-1H4zm6 0v1h2v-1h-2zm-6 2v1h4v-1H4zm6 0v1h2v-1h-2z" }));
});

var _extends$1p = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1o(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLoanOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1o(_ref, ["styles"]);

  return React.createElement("svg", _extends$1p({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M6 5v14h12V5H6zM5 4h14v16H5V4zm3.552 4.983a.654.654 0 0 1-.182.478h-.305A.067.067 0 0 0 8 9.526v.409c0 .035.03.065.065.065h1.94c.034 0 .065-.03.065-.065v-.409a.067.067 0 0 0-.066-.065H8.952a.85.85 0 0 0 .174-.513c0-.022-.004-.044-.004-.065h.63c.04 0 .065-.03.065-.07v-.365a.064.064 0 0 0-.065-.065h-.76a1.468 1.468 0 0 1-.092-.448.41.41 0 0 1 .117-.3.496.496 0 0 1 .353-.126c.152 0 .3.039.456.121.03.018.065.01.083-.026l.165-.343a.064.064 0 0 0-.026-.083A1.48 1.48 0 0 0 9.313 7c-.317 0-.56.096-.735.252a.846.846 0 0 0-.274.652c0 .17.044.326.092.479h-.23a.067.067 0 0 0-.066.065v.365c0 .04.03.07.065.07h.378c.005.034.01.07.01.1zM11 8v1h5V8h-5zm-3 4v1h4v-1H8zm6 0v1h2v-1h-2zm-6 2v1h4v-1H8zm6 0v1h2v-1h-2zm-6 2v1h4v-1H8zm6 0v1h2v-1h-2z" }));
});

var _extends$1q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1p(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPoundOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1p(_ref, ["styles"]);

  return React.createElement("svg", _extends$1q({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M5.186 10.574c0 1.252-.552 2.11-1.054 2.55H2.376c-.2 0-.376.163-.376.348v2.18c0 .186.176.348.376.348h11.189c.2 0 .376-.162.376-.348v-2.18c0-.185-.176-.347-.376-.347H7.494a4.326 4.326 0 0 0 1.003-2.737c0-.116-.025-.231-.025-.347h3.638a.36.36 0 0 0 .376-.371V7.722c0-.186-.15-.348-.376-.348H7.72c-.276-.788-.527-1.577-.527-2.388 0-.673.25-1.206.677-1.6.477-.418 1.154-.673 2.032-.673.878 0 1.731.209 2.634.65.176.092.377.046.477-.14l.953-1.832a.327.327 0 0 0-.15-.44C12.736.37 11.256 0 9.576 0 7.745 0 6.34.51 5.336 1.345c-1.028.835-1.58 2.064-1.58 3.478 0 .905.25 1.74.527 2.55h-1.33c-.2 0-.376.163-.376.349V9.67c0 .208.176.37.376.37h2.183c.025.186.05.372.05.534z" }));
});

var _extends$1r = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1q(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPoundOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1q(_ref, ["styles"]);

  return React.createElement("svg", _extends$1r({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M9.186 14.574c0 1.252-.552 2.11-1.054 2.55H6.376c-.2 0-.376.163-.376.348v2.18c0 .186.176.348.376.348h11.189c.2 0 .376-.162.376-.348v-2.18c0-.185-.176-.347-.376-.347h-6.071a4.326 4.326 0 0 0 1.003-2.737c0-.116-.025-.231-.025-.347h3.638a.36.36 0 0 0 .376-.371v-1.948c0-.186-.15-.348-.376-.348h-4.39c-.276-.788-.527-1.577-.527-2.388 0-.673.25-1.206.677-1.6.477-.418 1.154-.673 2.032-.673.878 0 1.731.209 2.634.65.176.092.377.046.477-.14l.953-1.832a.327.327 0 0 0-.15-.44c-1.08-.58-2.56-.951-4.24-.951-1.831 0-3.236.51-4.24 1.345-1.028.835-1.58 2.064-1.58 3.478 0 .905.25 1.74.527 2.55h-1.33c-.2 0-.376.163-.376.349v1.948c0 .208.176.37.376.37h2.183c.025.186.05.372.05.534z" }));
});

var _extends$1s = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1r(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconWalletOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1r(_ref, ["styles"]);

  return React.createElement("svg", _extends$1s({ height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M16 14h1v-1h-1zm.492-2.007a1.5 1.5 0 1 0 0 2.999 1.5 1.5 0 0 0 0-3zM19 18.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5zM5 7V5.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v2.495H5zm14 1h-2.006V5.733c0-.957-.734-1.733-1.639-1.733H5.639c-.828 0-1.506.652-1.617 1.495H4V19a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z" }));
});

var _extends$1t = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1s(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCameraOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1s(_ref, ["styles"]);

  return React.createElement("svg", _extends$1t({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M42 40c9.939 0 18 8.058 18 18 0 9.939-8.061 17.997-18 17.997-9.942 0-18-8.058-18-17.997 0-9.942 8.058-18 18-18zM18 58c0 13.254 10.746 24 24 24s24-10.746 24-24c0-13.257-10.746-24-24-24S18 44.743 18 58zm72 30H6V21.997h84V88zM6 16h24V9.997H6V16zm30 0V4H0v90h96V16H36zm30 18h18v-6H66v6z" }));
});

var _extends$1u = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1t(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCarOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1t(_ref, ["styles"]);

  return React.createElement("svg", _extends$1u({ width: "32", height: "32", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7 22c-.552 0-1-.44-1-1s.448-1 1-1 1 .44 1 1-.448 1-1 1zm0-4c-1.658 0-3 1.34-3 3s1.342 3 3 3 3-1.34 3-3-1.342-3-3-3zm18 4c-.552 0-1-.44-1-1s.448-1 1-1 1 .44 1 1-.448 1-1 1zm0-4c-1.658 0-3 1.34-3 3s1.342 3 3 3 3-1.34 3-3-1.342-3-3-3zm5 0v6c0 1.1-.896 2-2 2H4c-1.104 0-2-.9-2-2v-6c0-1.1.896-2 2-2h24c1.104 0 2 .9 2 2zm-2 11c0 .56-.448 1-1 1s-1-.44-1-1v-1h2v1zM6 29c0 .56-.448 1-1 1s-1-.44-1-1v-1h2v1zM6 6c0-2.22 1.792-4 4-4h12c2.208 0 4 1.78 4 4l1.6 8H4.4L6 6zm26 7v-2c0-.56-.448-1-1-1h-2c-.068 0-.128.02-.192.04L28 6c0-3.32-2.686-6-6-6H10C6.686 0 4 2.68 4 6l-.808 4.04C3.126 10.02 3.068 10 3 10H1c-.552 0-1 .44-1 1v2c0 .56.448 1 1 1h1.4l-.076.38C.956 15.02 0 16.4 0 18v10h2v2c0 1.1.896 2 2 2h2c1.104 0 2-.9 2-2v-2h16v2c0 1.1.896 2 2 2h2c1.104 0 2-.9 2-2v-2h2V18c0-1.6-.956-2.98-2.324-3.62L29.6 14H31c.552 0 1-.44 1-1z" }));
});

var _extends$1v = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1u(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCarOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1u(_ref, ["styles"]);

  return React.createElement("svg", _extends$1v({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7.5 15c-.276 0-.5-.22-.5-.5s.224-.5.5-.5.5.22.5.5-.224.5-.5.5zm0-2c-.829 0-1.5.67-1.5 1.5S6.671 16 7.5 16 9 15.33 9 14.5 8.329 13 7.5 13zm9 2c-.276 0-.5-.22-.5-.5s.224-.5.5-.5.5.22.5.5-.224.5-.5.5zm0-2c-.829 0-1.5.67-1.5 1.5s.671 1.5 1.5 1.5 1.5-.67 1.5-1.5-.671-1.5-1.5-1.5zm2.5 0v3c0 .55-.448 1-1 1H6c-.552 0-1-.45-1-1v-3c0-.55.448-1 1-1h12c.552 0 1 .45 1 1zm-1 5.5c0 .28-.224.5-.5.5s-.5-.22-.5-.5V18h1v.5zm-11 0c0 .28-.224.5-.5.5s-.5-.22-.5-.5V18h1v.5zM7 7c0-1.11.896-2 2-2h6c1.104 0 2 .89 2 2l.8 4H6.2L7 7zm13 3.5v-1c0-.28-.224-.5-.5-.5h-1c-.034 0-.064.01-.096.02L18 7c0-1.66-1.343-3-3-3H9C7.343 4 6 5.34 6 7l-.404 2.02C5.563 9.01 5.534 9 5.5 9h-1c-.276 0-.5.22-.5.5v1c0 .28.224.5.5.5h.7l-.038.19A2.003 2.003 0 0 0 4 13v5h1v1c0 .55.448 1 1 1h1c.552 0 1-.45 1-1v-1h8v1c0 .55.448 1 1 1h1c.552 0 1-.45 1-1v-1h1v-5c0-.8-.478-1.49-1.162-1.81L18.8 11h.7c.276 0 .5-.22.5-.5z" }));
});

var _extends$1w = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1v(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDecorateOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1v(_ref, ["styles"]);

  return React.createElement("svg", _extends$1w({ width: "32", height: "32", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M26 5h3a3 3 0 0 1 3 3v4.222c0 1.52-1.14 2.8-2.65 2.98l-13.467 1.583a1 1 0 0 0-.883.993V20h3v8c0 2.21-1.79 4-4 4s-4-1.79-4-4v-8h3v-2.222c0-1.52 1.14-2.8 2.65-2.98l13.467-1.583a1 1 0 0 0 .883-.993V8a1 1 0 0 0-1-1h-3v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h22a2 2 0 0 1 2 2v3zM2 2v8h22V2H2zm10 20v6a2 2 0 1 0 4 0v-6h-4z" }));
});

var _extends$1x = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1w(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDecorateOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1w(_ref, ["styles"]);

  return React.createElement("svg", _extends$1x({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M17 6.5h1.5A1.5 1.5 0 0 1 20 8v2.11c0 .761-.57 1.402-1.325 1.49l-6.733.793a.5.5 0 0 0-.442.496V14H13v4a2 2 0 1 1-4 0v-4h1.5v-1.11c0-.761.57-1.402 1.325-1.49l6.733-.793a.5.5 0 0 0 .442-.496V8a.5.5 0 0 0-.5-.5H17V9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v1.5zM5 5v4h11V5H5zm5 10v3a1 1 0 0 0 2 0v-3h-2z" }));
});

var _extends$1y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1x(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconGenericMoneyOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1x(_ref, ["styles"]);

  return React.createElement("svg", _extends$1y({ width: "32", height: "32", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13.54 18.12c0 1.08-.44 1.82-.84 2.2h-1.4c-.16 0-.3.14-.3.3v1.88c0 .16.14.3.3.3h8.92c.16 0 .3-.14.3-.3v-1.88c0-.16-.14-.3-.3-.3h-4.84c.36-.46.8-1.3.8-2.36 0-.1-.02-.2-.02-.3h2.9c.18 0 .3-.14.3-.32v-1.68c0-.16-.12-.3-.3-.3h-3.5c-.22-.68-.42-1.36-.42-2.06 0-.58.2-1.04.54-1.38.38-.36.92-.58 1.62-.58.7 0 1.38.18 2.1.56.14.08.3.04.38-.12l.76-1.58c.06-.14.02-.3-.12-.38-.86-.5-2.04-.82-3.38-.82-1.46 0-2.58.44-3.38 1.16-.82.72-1.26 1.78-1.26 3 0 .78.2 1.5.42 2.2h-1.06c-.16 0-.3.14-.3.3v1.68c0 .18.14.32.3.32h1.74c.02.16.04.32.04.46zM16 30C8.268 30 2 23.73 2 16 2 8.268 8.268 2 16 2s14 6.268 14 14c0 7.73-6.268 14-14 14zm0-30C7.162 0 0 7.162 0 16c0 8.836 7.162 16 16 16 8.836 0 16-7.164 16-16 0-8.838-7.164-16-16-16z" }));
});

var _extends$1z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1y(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconGenericMoneyOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1y(_ref, ["styles"]);

  return React.createElement("svg", _extends$1z({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M10.77 13.06c0 .54-.22.91-.42 1.1h-.7c-.08 0-.15.07-.15.15v.94c0 .08.07.15.15.15h4.46c.08 0 .15-.07.15-.15v-.94c0-.08-.07-.15-.15-.15h-2.42c.18-.23.4-.65.4-1.18 0-.05-.01-.1-.01-.15h1.45c.09 0 .15-.07.15-.16v-.84c0-.08-.06-.15-.15-.15h-1.75c-.11-.34-.21-.68-.21-1.03 0-.29.1-.52.27-.69.19-.18.46-.29.81-.29.35 0 .69.09 1.05.28.07.04.15.02.19-.06l.38-.79c.03-.07.01-.15-.06-.19-.43-.25-1.02-.41-1.69-.41-.73 0-1.29.22-1.69.58-.41.36-.63.89-.63 1.5 0 .39.1.75.21 1.1h-.53c-.08 0-.15.07-.15.15v.84c0 .09.07.16.15.16h.87c.01.08.02.16.02.23zM12 19a7 7 0 1 1 .001-14.001A7 7 0 0 1 12 19zm0-15a8 8 0 0 0-8 8 8 8 0 1 0 16 0 8 8 0 0 0-8-8z" }));
});

var _extends$1A = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1z(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPlaneOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1z(_ref, ["styles"]);

  return React.createElement("svg", _extends$1A({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M18.409 6.65l-3.298 3.3-.318.32.026.45c.054.94.156 2.62.244 4.07l.156 2.6c.002.08.003.09-.063.17-.148.18-.424.49-.656.74-.36-.97-1.118-3.03-1.536-4.18l-.538-1.48-1.112 1.12-2.044 1.96-.284.29-.01.4c-.006.32-.004.9-.003 1.41v.79a1.274 1.274 0 0 0-.08-.13l-1.156-1.85-.128-.21-.208-.13a89.31 89.31 0 0 1-2.057-1.28h.747c.391.01.836.02 1.176.02.129 0 .246-.01.338-.01l.403-.01.284-.28 1.969-2.04 1.107-1.11-1.47-.54c-1.105-.4-3.222-1.2-4.212-1.57.254-.23.56-.51.739-.66.049-.04.088-.06.115-.06h.035c.111 0 1.483.09 2.809.18 1.408.09 2.996.2 3.9.25l.451.03 3.617-3.62C17.86 5.08 18.359 5 18.61 5c.164 0 .279.03.339.06.07.19.168.88-.541 1.59zm1.256-2.31c-.192-.19-.58-.34-1.054-.34-.592 0-1.318.23-1.968.88l-3.296 3.3c-1.857-.12-6.613-.43-6.731-.44H6.54c-.161 0-.438.03-.753.3-.37.3-1.144 1.03-1.144 1.03-.186.19-.28.42-.258.64.014.13.086.37.408.5.197.07 3.318 1.24 4.759 1.77l-1.97 2.04h-.315c-.601 0-1.53-.02-1.904-.02h-.117c-.114.01-.348-.05-.968.47l-.044.04c-.186.19-.23.37-.234.5-.004.12.03.3.213.45.11.09 1.516.99 2.669 1.69.277.45 1.55 2.48 1.616 2.59.097.16.255.26.445.26h.016c.184 0 .373-.09.559-.27.524-.61.452-.87.455-.98.008-.33-.006-1.75.006-2.32l2.043-1.96c.523 1.43 1.665 4.53 1.742 4.73.126.32.366.39.498.4a.15.15 0 0 0 .065.01c.198 0 .403-.1.57-.27 0 0 .724-.76 1.033-1.14.308-.37.295-.69.29-.84-.003-.11-.293-4.85-.401-6.7l3.298-3.3c1.168-1.18.982-2.59.548-3.02z" }));
});

var _extends$1B = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1A(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconWeddingOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1A(_ref, ["styles"]);

  return React.createElement("svg", _extends$1B({ width: "28", height: "32", viewBox: "0 0 28 32", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M15.15 8.05l1.767-1.767C23.25 7.53 28 12.75 28 19c0 7.18-6.268 13-14 13S0 26.18 0 19C0 12.94 4.466 7.848 10.51 6.407l2.083 1.668C6.603 8.715 2 13.39 2 19c0 6.04 5.34 11 12 11s12-4.96 12-11c0-5.69-4.736-10.418-10.85-10.95zM16 0h2v6h-2V0zm-6 0h2v6h-2V0zm9.09 4l.25-.252L17.97 2h-7.94L8.66 3.748 8.91 4h10.18zm-1.975 2h-6.23L14 9.154 17.115 6zM14 12L6 3.9 9.056 0h9.888L22 3.9 14 12z" }));
});

var _extends$1C = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1B(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconWeddingOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1B(_ref, ["styles"]);

  return React.createElement("svg", _extends$1C({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M12.575 8.025l.884-.884C16.625 7.764 19 10.375 19 13.5c0 3.59-3.134 6.5-7 6.5s-7-2.91-7-6.5c0-3.03 2.233-5.576 5.255-6.296l1.042.833C8.302 8.357 6 10.696 6 13.5c0 3.02 2.67 5.5 6 5.5s6-2.48 6-5.5c0-2.844-2.368-5.21-5.425-5.475zM13 4h1v3h-1V4zm-3 0h1v3h-1V4zm4.545 2l.125-.126L13.985 5h-3.97l-.685.874.125.126h5.09zm-.987 1h-3.116L12 8.577 13.558 7zM12 10L8 5.95 9.528 4h4.944L16 5.95 12 10z" }));
});

var _extends$1D = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1C(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Desktop = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1C(_ref, ["styles"]);

  return React.createElement("svg", _extends$1D({ width: "64", height: "58", viewBox: "0 0 64 58", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "Laptop"), React.createElement("path", { d: "M56 29V5a2.667 2.667 0 0 0-2.667-2.667H10.667A2.667 2.667 0 0 0 8 5v29.333l-5.333 16V53a2.667 2.667 0 0 0 2.666 2.667h21.334A9.947 9.947 0 0 0 36 46.733a4.107 4.107 0 0 0-2.933-4.266A4.027 4.027 0 0 0 28 46.333a9.893 9.893 0 0 0 9.333 9.334h21.334A2.667 2.667 0 0 0 61.333 53v-2.667L57.813 39.8a8 8 0 0 0-7.573-5.467H13.333m8-21.333h21.334m-21.334 8h5.334m2.666 0h5.334m2.666 0h5.334", stroke: "#000", strokeWidth: "4", fill: "none", fillRule: "evenodd", strokeLinejoin: "round" }));
});

var _extends$1E = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1D(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var DualAvatar = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1D(_ref, ["styles"]);

  return React.createElement("svg", _extends$1E({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M91.16 69.029a47.915 47.915 0 0 1-2.533 4.546c-2.57-5.268-6.435-9.498-10.973-12.12C74.704 64.305 71.009 66 67 66c-3.952 0-7.598-1.647-10.527-4.424-1.863 1.156-3.59 2.61-5.143 4.314C55.495 72.297 58 80.525 58 89.5c0 1.877-.11 3.722-.321 5.524a47.952 47.952 0 0 1-5.416.79c.48-2.356.737-4.81.737-7.322 0-8.95-3.257-16.855-8.255-22.3a8.184 8.184 0 0 0-.238-.049l.08-.123a25.584 25.584 0 0 0-5.209-4.304C36.475 64.408 32.885 66 29 66c-4.001 0-7.689-1.688-10.636-4.528-4.449 2.763-8.123 7.292-10.486 12.887a47.936 47.936 0 0 1-3.039-5.33c2.57-4.928 6.042-9.024 10.114-11.906C12.783 53.459 11.5 48.918 11.5 44c0-12.15 7.835-22 17.5-22s17.5 9.85 17.5 22c0 4.918-1.284 9.46-3.453 13.123A30.204 30.204 0 0 1 48 61.547a30.204 30.204 0 0 1 4.953-4.424C50.783 53.459 49.5 48.918 49.5 44c0-12.15 7.835-22 17.5-22s17.5 9.85 17.5 22c0 4.918-1.284 9.46-3.453 13.123 4.072 2.882 7.544 6.978 10.114 11.906zM29 60c6.627 0 12-7.163 12-16s-5.373-16-12-16-12 7.163-12 16 5.373 16 12 16zm38 0c6.627 0 12-7.163 12-16s-5.373-16-12-16-12 7.163-12 16 5.373 16 12 16z" }), React.createElement("path", { d: "M48 96C21.49 96 0 74.51 0 48S21.49 0 48 0s48 21.49 48 48-21.49 48-48 48zm0-6c23.196 0 42-18.804 42-42S71.196 6 48 6 6 24.804 6 48s18.804 42 42 42z" }));
});

var _extends$1F = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1E(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Favourite = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1E(_ref, ["styles"]);

  return React.createElement("svg", _extends$1F({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 27" }, props), React.createElement("path", { d: "M14 21.565l-7.717 4.057 1.473-8.593-6.243-6.086 8.628-1.254L14 1.87l3.859 7.819 8.628 1.254-6.243 6.086 1.473 8.593L14 21.565z" }));
});

var _extends$1G = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1F(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconAbroadOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1F(_ref, ["styles"]);

  return React.createElement("svg", _extends$1G({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M2.5 15.059h11v-1.005h-11v1.005zm.611-11.14L1.697 2.5l-.708.71 1.415 1.42.707-.71zM1 13.052h14v-1.004H1v1.004zm-1-2.008h16V10.04H0v1.004zM15.01 3.21l-.707-.709-1.414 1.42.707.71 1.415-1.42zM7.5 2.008h1V0h-1v2.008zM2.994 9.035C2.994 6.26 5.235 4.01 8 4.01c2.764 0 5.005 2.25 5.005 5.025H14c0-3.326-2.687-6.023-6-6.023-3.314 0-6 2.697-6 6.023h.994z" }));
});

var _extends$1H = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1G(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconAbroadOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1G(_ref, ["styles"]);

  return React.createElement("svg", _extends$1H({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M6.5 19.059h11v-1.005h-11v1.005zm.611-11.14L5.697 6.5l-.708.71 1.415 1.42.707-.71zM5 17.052h14v-1.004H5v1.004zm-1-2.008h16V14.04H4v1.004zM19.01 7.21l-.707-.709-1.414 1.42.707.71 1.415-1.42zM11.5 6.008h1V4h-1v2.008zm-4.506 7.027C6.994 10.26 9.236 8.01 12 8.01c2.764 0 5.006 2.25 5.006 5.025H18c0-3.326-2.687-6.023-6-6.023-3.314 0-6 2.697-6 6.023h.994z" }));
});

var _extends$1I = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1H(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconAlertOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1H(_ref, ["styles"]);

  return React.createElement("svg", _extends$1I({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M3 12s.974-1.432.998-3h8.003c.011 1.569.999 3 .999 3H3zm5 3a1.5 1.5 0 0 1-1.5-1.5c0-.176.036-.343.092-.5h2.816c.056.157.092.324.092.5A1.5 1.5 0 0 1 8 15zM4 6h8v3H4V6zm0-1a4 4 0 0 1 8 0v1H4V5zm11 8s-2-2.447-2-4.027V5A5 5 0 0 0 3 5v3.944C3 10.533 1 13 1 13h4.558a2.412 2.412 0 0 0-.058.5 2.5 2.5 0 1 0 5 0c0-.172-.024-.338-.057-.5H15z" }));
});

var _extends$1J = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1I(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconAlertOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1I(_ref, ["styles"]);

  return React.createElement("svg", _extends$1J({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M7 16s.974-1.432.998-3h8.003c.011 1.569.999 3 .999 3H7zm5 3a1.5 1.5 0 0 1-1.5-1.5c0-.176.036-.343.092-.5h2.816c.056.157.092.324.092.5A1.5 1.5 0 0 1 12 19zm-4-9h8v3H8v-3zm0-1a4 4 0 0 1 8 0v1H8V9zm11 8s-2-2.447-2-4.027V9A5 5 0 0 0 7 9v3.944C7 14.533 5 17 5 17h4.557a2.412 2.412 0 0 0-.057.5 2.5 2.5 0 1 0 5 0c0-.172-.024-.338-.057-.5H19z" }));
});

var _extends$1K = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1J(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$m = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1J(_ref, ["styles"]);

  return React.createElement("svg", _extends$1K({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M89.977 36.744c0 5.985-.069 11.97.016 17.955.131 9.132-3.816 16.446-10.205 22.695-8.719 8.527-19.322 14.043-30.618 18.404-.686.262-1.656.274-2.336.008-12.2-4.75-23.614-10.738-32.59-20.479-5.442-5.905-8.304-12.757-8.239-20.83.1-12.48.056-24.963-.005-37.444-.01-1.966.636-3.007 2.6-3.683C21.12 9.063 33.59 4.606 46.113.3c1.13-.39 2.633-.404 3.76-.016 12.593 4.33 25.134 8.806 37.718 13.159 1.773.613 2.422 1.588 2.408 3.374-.057 6.643-.023 13.285-.023 19.927zM76.748 71.928C71.541 61.31 60.624 54 48 54c-12.616 0-23.527 7.3-28.738 17.908C26.34 79.354 35.4 84.814 47.995 89.815c11.743-4.626 20.537-9.805 27.597-16.71.4-.391.785-.783 1.156-1.177zM48 48c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z" }));
});

var _extends$1L = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1K(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconAuthorisationSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1K(_ref, ["styles"]);

  return React.createElement("svg", _extends$1L({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M75.985 40.496c0 3.99-.046 7.98.01 11.97.088 6.088-2.544 10.964-6.803 15.13-5.813 5.685-12.881 9.362-20.412 12.27-.457.174-1.104.182-1.558.004-8.133-3.166-15.742-7.158-21.726-13.652-3.628-3.937-5.536-8.505-5.493-13.886.067-8.32.037-16.642-.003-24.964-.006-1.31.424-2.004 1.733-2.454 8.348-2.872 16.66-5.843 25.01-8.714.753-.26 1.755-.27 2.507-.01 8.394 2.886 16.755 5.87 25.145 8.772 1.182.408 1.615 1.059 1.605 2.25-.038 4.428-.015 8.856-.015 13.284zm-8.82 23.456C63.694 56.873 56.416 52 48 52c-8.41 0-15.685 4.867-19.159 11.939 4.72 4.963 10.759 8.603 19.156 11.938 7.828-3.085 13.691-6.537 18.398-11.14.266-.261.523-.522.77-.785zM48 48c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z" }));
});

var _extends$1M = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1L(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconAvatarOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1L(_ref, ["styles"]);

  return React.createElement("svg", _extends$1M({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M12.858 13.033a6.95 6.95 0 0 0-1.145-1.502 15.042 15.042 0 0 0-1.34-1.162c.692-.777 1.127-1.884 1.127-3.118 0-2.348-1.567-4.25-3.5-4.25s-3.5 1.902-3.5 4.25c0 1.234.436 2.341 1.128 3.118-.444.346-.936.757-1.341 1.162a6.95 6.95 0 0 0-1.145 1.502A6.975 6.975 0 0 1 1 8a7 7 0 0 1 14 0c0 1.977-.823 3.76-2.142 5.033M5.5 7.25c0-1.795 1.12-3.25 2.5-3.25s2.5 1.455 2.5 3.25-1.12 3.25-2.5 3.25-2.5-1.455-2.5-3.25M8 15a6.957 6.957 0 0 1-4.12-1.35c.203-.345.574-.899 1.14-1.466.411-.411.912-.826 1.356-1.17.486.31 1.037.487 1.624.487.586 0 1.139-.178 1.624-.487.444.344.945.759 1.355 1.17a7.437 7.437 0 0 1 1.14 1.466A6.957 6.957 0 0 1 8 15M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0" }));
});

var _extends$1N = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1M(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconAvatarOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1M(_ref, ["styles"]);

  return React.createElement("svg", _extends$1N({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M16.858 17.032a6.95 6.95 0 0 0-1.145-1.501 15.042 15.042 0 0 0-1.34-1.162c.692-.777 1.127-1.884 1.127-3.118 0-2.348-1.567-4.25-3.5-4.25s-3.5 1.902-3.5 4.25c0 1.234.436 2.341 1.127 3.118-.443.346-.935.757-1.34 1.162a6.95 6.95 0 0 0-1.146 1.501A6.975 6.975 0 0 1 5 12a7 7 0 0 1 14 0c0 1.977-.823 3.76-2.142 5.032M9.5 11.252c0-1.795 1.12-3.25 2.5-3.25s2.5 1.455 2.5 3.25-1.12 3.25-2.5 3.25-2.5-1.455-2.5-3.25M12 19a6.957 6.957 0 0 1-4.12-1.35c.203-.345.574-.899 1.14-1.466.411-.411.912-.826 1.356-1.17.486.31 1.038.487 1.624.487.586 0 1.139-.178 1.624-.487.444.344.945.759 1.355 1.17a7.437 7.437 0 0 1 1.14 1.466A6.957 6.957 0 0 1 12 19m0-15a8 8 0 1 0 0 16 8 8 0 0 0 0-16" }));
});

var _extends$1O = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1N(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconBlockedFilledLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1N(_ref, ["styles"]);

  return React.createElement("svg", _extends$1O({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("rect", { width: "96", height: "96", rx: "48" }), React.createElement("path", { fill: "#FFF", d: "M48 39.515l12.728-12.728 8.485 8.485L56.485 48l12.728 12.728-8.485 8.485L48 56.485 35.272 69.213l-8.485-8.485L39.515 48 26.787 35.272l8.485-8.485L48 39.515z" }));
});

var _extends$1P = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1O(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconBlockedFilledSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1O(_ref, ["styles"]);

  return React.createElement("svg", _extends$1P({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("rect", { x: "15", y: "17", width: "64", height: "64", rx: "32" }), React.createElement("path", { fill: "#FFF", d: "M47.215 44.729L53.944 38l4.486 4.486-6.729 6.729 6.729 6.729-4.486 4.486-6.729-6.729-6.729 6.729L36 55.944l6.729-6.729L36 42.486 40.486 38l6.729 6.729z" }));
});

var _extends$1Q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1P(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCallIncomingSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1P(_ref, ["styles"]);

  return React.createElement("svg", _extends$1Q({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M81.898 25.597c0-2.883-2.323-5.225-5.187-5.225H55.827l4.874-5.77a5.253 5.253 0 0 0-.595-7.36 5.166 5.166 0 0 0-7.311.596L40.67 22.214a5.24 5.24 0 0 0 0 6.764l12.125 14.376a5.157 5.157 0 0 0 3.955 1.841c1.188 0 2.38-.406 3.356-1.242a5.247 5.247 0 0 0 .595-7.361l-4.874-5.775H76.71c2.864-.002 5.187-2.336 5.187-5.22zM31.056 28c.476-.49.608-1.115.388-1.857-.205-.745-.75-1.527-1.646-2.337L11.033 9.1c-.17-.185-.559-.409-1.14-.662-.526-.224-.917-.304-1.206-.255-.655-.101-1.172.112-1.565.644l-3.537 4.391L27.88 32.146l3.177-4.147zm30.406 41.077c-1.544-.48-2.695-.842-3.469-1.076-.76-.24-1.26-.412-1.477-.503-1.182-.5-2.512-1.287-3.973-2.35l-21.84-17.323c-1.321-1.006-2.436-2.09-3.336-3.262-.582-.692-1.322-1.815-2.233-3.39-.905-1.572-1.045-3.095-.421-4.585.124-.295.38-.709.789-1.245L1.389 16.259c-2.561 6.096-1.58 14.53 2.944 25.321 1.852 4.293 4.923 8.895 9.222 13.79 4.294 4.904 9.753 9.944 16.365 15.133 4.765 3.787 9.696 7.072 14.8 9.859 5.094 2.777 10.154 5.246 15.177 7.384 2.362 1.011 4.874 1.662 7.53 1.962 2.663.304 5.64.375 8.928.192 3.293-.177 6.005-.552 8.131-1.14 2.108-.59 3.924-1.527 5.422-2.814l-24.11-19.082c-1.355 1.954-2.796 2.696-4.336 2.212zm32.246 5.087L76.203 60.459c-.399-.315-.96-.628-1.697-.943-1.563-.667-2.711-.406-3.467.753L67.79 64.28 91.9 83.37l3.27-4.068c.476-1.125.75-1.988.825-2.568.073-.594-.685-1.449-2.287-2.571z" }));
});

var _extends$1R = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1Q(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCallIncomingSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1Q(_ref, ["styles"]);

  return React.createElement("svg", _extends$1R({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M70.599 33.065c0-1.922-1.55-3.483-3.458-3.483H53.218l3.25-3.847a3.502 3.502 0 0 0-.398-4.907 3.444 3.444 0 0 0-4.873.398l-8.084 9.583a3.493 3.493 0 0 0 0 4.51l8.084 9.584a3.438 3.438 0 0 0 4.873.399 3.498 3.498 0 0 0 .397-4.907l-3.25-3.85h13.924a3.47 3.47 0 0 0 3.458-3.48zm-33.895 1.601c.317-.326.405-.743.259-1.238-.137-.497-.5-1.018-1.097-1.558l-12.51-9.804c-.115-.123-.373-.273-.761-.441-.35-.15-.61-.203-.804-.17-.436-.068-.781.074-1.043.429L18.39 24.81l16.196 12.62 2.118-2.765zM56.975 62.05c-1.03-.32-1.797-.56-2.313-.717-.507-.16-.84-.274-.985-.335-.788-.333-1.674-.858-2.649-1.566L36.47 47.882c-.881-.67-1.624-1.392-2.224-2.174-.389-.462-.882-1.21-1.489-2.26-.603-1.048-.697-2.064-.28-3.057.082-.196.253-.472.525-.83L16.926 26.84c-1.707 4.063-1.054 9.686 1.963 16.88 1.234 2.862 3.281 5.93 6.148 9.193 2.863 3.27 6.502 6.63 10.91 10.089a68.993 68.993 0 0 0 9.866 6.573 116.569 116.569 0 0 0 10.119 4.923 17.743 17.743 0 0 0 5.02 1.307c1.775.203 3.76.25 5.952.129 2.195-.118 4.002-.369 5.42-.761 1.406-.392 2.616-1.018 3.615-1.875L59.865 60.576c-.903 1.302-1.864 1.797-2.89 1.474zm21.497 3.392l-11.67-9.136c-.266-.21-.64-.418-1.132-.629-1.041-.444-1.807-.27-2.31.502l-2.167 2.675L77.267 71.58l2.18-2.712c.317-.75.5-1.325.55-1.712.048-.396-.457-.966-1.525-1.714z" }));
});

var _extends$1S = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1R(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$n = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1R(_ref, ["styles"]);

  return React.createElement("svg", _extends$1S({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M71.997 48.033H48v-24.03a3 3 0 0 0-3-3c-1.659 0-3 1.341-3 3v26.931c0 .024-.015.042-.015.069 0 .642.252 1.206.603 1.692.543.774 1.395 1.308 2.412 1.308.048 0 .084-.024.132-.027h26.865c1.665 0 3.015-1.332 3.015-2.973 0-1.647-1.35-2.97-3.015-2.97" }), React.createElement("path", { d: "M48 0c26.508 0 48 21.492 48 48.003s-21.492 48-48 48c-26.511 0-48-21.489-48-48S21.489 0 48 0zm0 90.003c23.193 0 42-18.804 42-42 0-23.193-18.807-42-42-42-23.196 0-42 18.807-42 42 0 23.196 18.804 42 42 42z" }));
});

var _extends$1T = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1S(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconClockOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1S(_ref, ["styles"]);

  return React.createElement("svg", _extends$1T({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M63.998 48.022H48v-16.02a2 2 0 1 0-4 0v17.954c0 .016-.01.028-.01.046 0 .428.168.804.402 1.128.362.516.93.872 1.608.872.032 0 .056-.016.088-.018h17.91c1.11 0 2.01-.888 2.01-1.982 0-1.098-.9-1.98-2.01-1.98" }), React.createElement("path", { d: "M48 16c17.672 0 32 14.328 32 32.002 0 17.674-14.328 32-32 32-17.674 0-32-14.326-32-32S30.326 16 48 16zm0 60.002c15.462 0 28-12.536 28-28 0-15.462-12.538-28-28-28-15.464 0-28 12.538-28 28 0 15.464 12.536 28 28 28z" }));
});

var _extends$1U = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1T(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconClockSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1T(_ref, ["styles"]);

  return React.createElement("svg", _extends$1U({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { fillRule: "evenodd", d: "M63.998 48.021H48v-16.02a2 2 0 1 0-4 0v17.954c0 .016-.01.028-.01.046 0 .428.168.804.402 1.128.362.516.93.872 1.608.872.032 0 .056-.016.088-.018h17.91c1.11 0 2.01-.888 2.01-1.982 0-1.098-.9-1.98-2.01-1.98M48 16c-17.674 0-32 14.328-32 32.001S30.326 80 48 80c17.672 0 32-14.326 32-31.999S65.672 16 48 16" }));
});

var _extends$1V = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1U(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconConferenceLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1U(_ref, ["styles"]);

  return React.createElement("svg", _extends$1V({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7.345 9.982l-6.046.539 2.556 4.427 3.49-4.966zm.592-6.62V.5h.393v2.862h2.36L8.134 8.867 5.577 3.362h2.36zm5.584 9.202l2.309 1.333.17.098-.197.34-.17-.098-2.308-1.332-1.18 2.043-3.49-4.966 6.046.539-1.18 2.043zM.367 14.237l-.17.099-.197-.34.17-.1 2.479-1.43.17-.098.197.34-.17.098-2.48 1.431z" }));
});

var _extends$1W = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1V(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconConferenceSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1V(_ref, ["styles"]);

  return React.createElement("svg", _extends$1W({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M11.345 13.482l-6.046.539 2.556 4.427 3.49-4.966zm.592-6.62V4h.393v2.862h2.36l-2.556 5.505-2.557-5.505h2.36zm5.584 9.202l2.309 1.333.17.098-.197.34-.17-.098-2.308-1.332-1.18 2.043-3.49-4.966 6.046.539-1.18 2.043zM4.367 17.737l-.17.099-.197-.34.17-.1 2.479-1.43.17-.098.197.34-.17.098-2.48 1.431z" }));
});

var _extends$1X = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1W(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCredentialsOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1W(_ref, ["styles"]);

  return React.createElement("svg", _extends$1X({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 14.618c-3.556-1.953-5.356-5.723-6.232-8.471h12.464c-.876 2.748-2.675 6.518-6.232 8.47M8 1.913s3 2.353 7 .942c0 0-.116.972-.5 2.384v-.031h-13v.031C1.115 3.826 1 2.854 1 2.854c4 1.411 7-.942 7-.942M8 .5s-3 3.765-8 .941c0 0 .5 10.823 8 14.118 7.5-3.295 8-14.118 8-14.118C11 4.265 8 .5 8 .5" }));
});

var _extends$1Y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1X(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCredentialsOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1X(_ref, ["styles"]);

  return React.createElement("svg", _extends$1Y({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 18.118c-3.556-1.953-5.356-5.723-6.232-8.471h12.464c-.876 2.748-2.675 6.518-6.232 8.47m0-12.705s3 2.353 7 .942c0 0-.116.972-.5 2.384v-.031h-13v.031C5.115 7.326 5 6.354 5 6.354c4 1.411 7-.942 7-.942M12 4s-3 3.765-8 .941c0 0 .5 10.823 8 14.118 7.5-3.295 8-14.118 8-14.118C15 7.765 12 4 12 4" }));
});

var _extends$1Z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1Y(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCrossSolidCircleSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1Y(_ref, ["styles"]);

  return React.createElement("svg", _extends$1Z({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M48 80.002c-17.673 0-32-14.327-32-32C16 30.327 30.327 16 48 16c17.673 0 32 14.327 32 32.002 0 17.673-14.327 32-32 32zm15.346-47.348a2.233 2.233 0 0 0-3.156 0L48 44.846 35.808 32.654a2.233 2.233 0 0 0-3.157 0 2.23 2.23 0 0 0 0 3.156l12.192 12.192-12.192 12.192a2.23 2.23 0 0 0 0 3.157c.871.87 2.286.87 3.157 0L48 51.159 60.19 63.35c.87.87 2.285.87 3.156 0 .871-.873.871-2.286 0-3.157l-12.19-12.192 12.19-12.192c.871-.87.871-2.285 0-3.156z" }));
});

var _extends$1_ = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1Z(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$o = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1Z(_ref, ["styles"]);

  return React.createElement("svg", _extends$1_({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M20.42 20.42a6.252 6.252 0 0 0 0 8.843l18.733 18.734-18.735 18.746a6.251 6.251 0 0 0 8.842 8.837l18.734-18.735L66.738 75.58a6.252 6.252 0 1 0 8.842-8.843L56.835 47.992l18.739-18.74a6.248 6.248 0 0 0 .003-8.834 6.24 6.24 0 0 0-8.827-.003L48.01 39.155 29.263 20.42a6.253 6.253 0 0 0-8.843.002z" }));
});

var _extends$1$ = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1_(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCrossThinOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1_(_ref, ["styles"]);

  return React.createElement("svg", _extends$1$({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15.673.327a1.117 1.117 0 0 0-1.578 0L8.001 6.422 1.906.327A1.117 1.117 0 0 0 .327 1.905L6.423 8 .327 14.096a1.117 1.117 0 0 0 1.578 1.578l6.096-6.096 6.094 6.096a1.117 1.117 0 0 0 1.578-1.578L9.58 8l6.094-6.095a1.117 1.117 0 0 0 0-1.578" }));
});

var _extends$20 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1$(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCrossThinOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1$(_ref, ["styles"]);

  return React.createElement("svg", _extends$20({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19.673 4.327a1.117 1.117 0 0 0-1.578 0l-6.094 6.095-6.095-6.095a1.117 1.117 0 0 0-1.579 1.578L10.423 12l-6.096 6.096a1.117 1.117 0 0 0 1.578 1.578l6.096-6.096 6.094 6.096a1.117 1.117 0 0 0 1.578-1.578L13.58 12l6.094-6.095a1.117 1.117 0 0 0 0-1.578" }));
});

var _extends$21 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$20(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$p = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$20(_ref, ["styles"]);

  return React.createElement("svg", _extends$21({ width: "16", height: "16", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M29.9 29.901a4.103 4.103 0 0 0 0 5.803l12.294 12.294L29.9 60.3a4.102 4.102 0 0 0 5.803 5.8l12.294-12.296 12.3 12.296a4.103 4.103 0 1 0 5.803-5.803L53.8 47.993l12.296-12.298a4.1 4.1 0 0 0 .002-5.797 4.095 4.095 0 0 0-5.792-.001L48.007 42.196 35.704 29.9a4.104 4.104 0 0 0-5.803.001z" }), React.createElement("path", { d: "M48 0c26.508 0 48 21.492 48 48.003s-21.492 48-48 48c-26.511 0-48-21.489-48-48S21.489 0 48 0zm0 90.003c23.193 0 42-18.804 42-42 0-23.193-18.807-42-42-42-23.196 0-42 18.807-42 42 0 23.196 18.804 42 42 42z" }));
});

var _extends$22 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$21(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCrossoutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$21(_ref, ["styles"]);

  return React.createElement("svg", _extends$22({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M35.934 35.934a2.735 2.735 0 0 0 0 3.868L44.13 48 35.933 56.2a2.735 2.735 0 0 0 3.868 3.866l8.197-8.197 8.2 8.197a2.735 2.735 0 1 0 3.868-3.869l-8.2-8.2 8.198-8.2a2.734 2.734 0 0 0 0-3.864 2.73 2.73 0 0 0-3.861-.001l-8.198 8.199-8.202-8.198a2.736 2.736 0 0 0-3.869.001z" }), React.createElement("path", { d: "M48 16c17.672 0 32 14.328 32 32.001S65.672 80 48 80c-17.674 0-32-14.326-32-31.999S30.326 16 48 16zm0 60c15.462 0 28-12.536 28-28 0-15.462-12.538-28-28-28-15.464 0-28 12.538-28 28 0 15.464 12.536 28 28 28z" }));
});

var _extends$23 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$22(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CycleLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$22(_ref, ["styles"]);

  return React.createElement("svg", _extends$23({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "icon-cycle-large"), React.createElement("path", { d: "M11.786 14.123l.81 1.467c.138.246.028.427-.24.41l-3.92-.275c-.266-.018-.39-.24-.27-.49l1.732-3.676c.117-.252.324-.26.458-.016l.793 1.428c.323-.223.626-.48.9-.767a6.08 6.08 0 0 0 1.677-4.224c0-1.605-.61-3.11-1.676-4.223a5.844 5.844 0 0 0-.92-.78.681.681 0 0 1-.184-.92.62.62 0 0 1 .882-.19c.404.275.78.595 1.122.95A7.443 7.443 0 0 1 15 7.982a7.441 7.441 0 0 1-2.05 5.164c-.354.37-.744.698-1.164.98zm-6.94-11.13c-.32.22-.62.477-.896.763A6.088 6.088 0 0 0 2.273 7.98c0 1.607.61 3.11 1.677 4.224.28.293.59.553.92.78.294.2.376.612.184.92a.617.617 0 0 1-.88.19 6.965 6.965 0 0 1-1.124-.95C1.745 11.784 1 9.944 1 7.98c0-1.962.748-3.802 2.05-5.163a7.282 7.282 0 0 1 1.16-.976L3.418.41C3.282.166 3.392-.016 3.66 0l3.86.262c.27.017.39.237.27.49L6.078 4.366c-.12.254-.326.26-.46.016l-.77-1.39z" }));
});

var _extends$24 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$23(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCycleSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$23(_ref, ["styles"]);

  return React.createElement("svg", _extends$24({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M32.857 23.506l-3.247-5.868c-.544-.982-.106-1.707.97-1.633l15.674 1.093c1.066.075 1.56.957 1.085 1.963l-6.93 14.702c-.47 1.004-1.297 1.036-1.835.06l-3.17-5.711a23.341 23.341 0 0 0-3.607 3.068c-4.268 4.452-6.706 10.47-6.706 16.895 0 6.425 2.438 12.442 6.706 16.897a23.484 23.484 0 0 0 3.681 3.119c1.176.801 1.508 2.445.738 3.678s-2.344 1.57-3.526.766a28.43 28.43 0 0 1-4.49-3.806c-5.218-5.443-8.2-12.8-8.2-20.652s2.986-15.211 8.2-20.652a28.209 28.209 0 0 1 4.657-3.919zM60.614 68.03a23.36 23.36 0 0 0 3.587-3.053c4.268-4.455 6.705-10.472 6.705-16.897 0-6.425-2.437-12.443-6.705-16.897a23.484 23.484 0 0 0-3.681-3.12c-1.174-.8-1.504-2.444-.734-3.677.77-1.234 2.344-1.57 3.522-.766a28.353 28.353 0 0 1 4.492 3.806c5.218 5.443 8.2 12.8 8.2 20.652s-2.99 15.21-8.204 20.654a28.568 28.568 0 0 1-4.637 3.903l3.168 5.724c.544.978.106 1.707-.973 1.637L49.92 78.953c-1.084-.07-1.563-.948-1.084-1.956l6.856-14.466c.481-1.014 1.305-1.038 1.845-.064l3.078 5.564z" }));
});

var _extends$25 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$24(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCycleSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$24(_ref, ["styles"]);

  return React.createElement("svg", _extends$25({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon cycle"), React.createElement("path", { d: "M8.64 27.57l-1.593 2.76c-.267.462-.052.803.476.768l7.69-.514c.523-.035.765-.45.532-.923l-3.4-6.915c-.23-.472-.636-.487-.9-.028L9.89 25.404c-.636-.42-1.23-.903-1.77-1.443-2.094-2.094-3.29-4.924-3.29-7.946s1.196-5.852 3.29-7.947c.55-.55 1.156-1.04 1.806-1.467a1.25 1.25 0 1 0-1.368-2.09 13.817 13.817 0 0 0-2.203 1.79c-2.56 2.56-4.023 6.02-4.023 9.713s1.465 7.154 4.023 9.713c.695.695 1.46 1.313 2.285 1.843zM22.258 6.63c.632.417 1.22.898 1.76 1.436 2.094 2.095 3.29 4.925 3.29 7.947s-1.196 5.852-3.29 7.947c-.55.55-1.156 1.04-1.806 1.467a1.25 1.25 0 0 0 1.368 2.09 13.78 13.78 0 0 0 2.204-1.79c2.56-2.56 4.023-6.02 4.023-9.713S28.34 8.86 25.782 6.3a13.89 13.89 0 0 0-2.275-1.836l1.554-2.692c.267-.46.052-.803-.477-.77l-7.573.49c-.532.033-.767.446-.532.92l3.364 6.804c.236.477.64.488.905.03l1.51-2.617z" }));
});

var _extends$26 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$25(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCycleSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$25(_ref, ["styles"]);

  return React.createElement("svg", _extends$26({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon cycle"), React.createElement("path", { d: "M11.873 21.873l-.79 1.37c-.17.292-.033.51.298.493l4.505-.215c.332-.015.476-.266.325-.56l-2.066-4.01c-.152-.295-.41-.3-.577-.01l-.683 1.182A5.36 5.36 0 0 1 11 16.017c0-1.421.54-2.748 1.48-3.727a4.92 4.92 0 0 1 .804-.682 1 1 0 0 0-1.127-1.652 7.04 7.04 0 0 0-1.12.95A7.35 7.35 0 0 0 9 16.015c0 1.94.74 3.763 2.037 5.113.26.27.54.52.837.744zm7.248-9.958c.14.117.274.242.4.374.94.978 1.48 2.305 1.48 3.726s-.54 2.748-1.48 3.727a4.908 4.908 0 0 1-.804.68 1.001 1.001 0 0 0 1.127 1.653c.403-.276.78-.594 1.12-.95 1.297-1.35 2.037-3.17 2.037-5.11s-.74-3.763-2.036-5.113a7.09 7.09 0 0 0-.832-.74l.77-1.337c.167-.287.033-.51-.298-.493l-4.452.204c-.33.015-.476.266-.323.56l2.05 3.957c.15.294.41.3.576.012l.665-1.152z" }));
});

var _extends$27 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$26(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDialSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$26(_ref, ["styles"]);

  return React.createElement("svg", _extends$27({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M76.856 52.591c-2.84 0-5.143 2.325-5.143 5.194v-3.89c0-2.869-2.303-5.194-5.143-5.194s-5.143 2.325-5.143 5.193v-3.89c0-2.868-2.303-5.193-5.144-5.193-2.84 0-5.143 2.325-5.143 5.193v-14.81c0-2.869-2.303-5.194-5.144-5.194-2.84 0-5.143 2.325-5.143 5.194v29.055l-5.073-5.122a5.109 5.109 0 0 0-7.274 0 5.23 5.23 0 0 0 0 7.345l5.506 5.56a17.427 17.427 0 0 1 4.496 7.946C40.92 89.41 49.346 96 58.994 96h.807C72.06 96 82 85.964 82 73.585v-15.8c0-2.869-2.303-5.194-5.144-5.194zM21.5 0C17.365 0 14 3.365 14 7.5c0 4.136 3.365 7.5 7.5 7.5 4.136 0 7.5-3.364 7.5-7.5C29 3.365 25.635 0 21.5 0zM46.5 0C42.365 0 39 3.365 39 7.5c0 4.136 3.365 7.5 7.5 7.5 4.136 0 7.5-3.364 7.5-7.5C54 3.365 50.636 0 46.5 0zM70.5 0C66.365 0 63 3.365 63 7.5c0 4.136 3.364 7.5 7.5 7.5S78 11.636 78 7.5C78 3.365 74.635 0 70.5 0zM70.5 25c-4.135 0-7.5 3.365-7.5 7.5 0 4.136 3.364 7.5 7.5 7.5s7.5-3.364 7.5-7.5c0-4.135-3.365-7.5-7.5-7.5zM21.5 25c-4.136 0-7.5 3.365-7.5 7.5 0 4.136 3.365 7.5 7.5 7.5 4.136 0 7.5-3.364 7.5-7.5 0-4.135-3.365-7.5-7.5-7.5z" }));
});

var _extends$28 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$27(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDialSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$27(_ref, ["styles"]);

  return React.createElement("svg", _extends$28({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M66.904 51.06c-1.893 0-3.429 1.551-3.429 3.463V51.93c0-1.912-1.535-3.462-3.428-3.462-1.894 0-3.43 1.55-3.43 3.462v-2.593c0-1.912-1.534-3.462-3.428-3.462s-3.429 1.55-3.429 3.462v-9.874c0-1.912-1.535-3.462-3.429-3.462s-3.429 1.55-3.429 3.462v19.37l-3.382-3.414a3.406 3.406 0 0 0-4.849 0 3.486 3.486 0 0 0 0 4.897l3.67 3.706a11.618 11.618 0 0 1 2.998 5.297C42.947 75.606 48.564 80 54.996 80h.538c8.173 0 14.8-6.69 14.8-14.943V54.523c0-1.912-1.536-3.462-3.43-3.462zM30 16c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zM46.667 16c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zM62.667 16c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zM62.667 32.667c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zM30 32.667c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" }));
});

var _extends$29 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$28(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Disallowed = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$28(_ref, ["styles"]);

  return React.createElement("svg", _extends$29({ viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M20.267 32.024A31.853 31.853 0 0 0 16 48c0 17.673 14.327 32 32 32 5.9 0 11.426-1.596 16.171-4.38zM31.394 20.64L75.38 64.574A31.85 31.85 0 0 0 80 48c0-17.673-14.327-32-32-32a31.85 31.85 0 0 0-16.606 4.64zM48 96C21.49 96 0 74.51 0 48S21.49 0 48 0s48 21.49 48 48-21.49 48-48 48z" }));
});

var _extends$2a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$29(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDotSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$29(_ref, ["styles"]);

  return React.createElement("svg", _extends$2a({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon dot"), React.createElement("path", { d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z" }));
});

var _extends$2b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2a(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDotSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2a(_ref, ["styles"]);

  return React.createElement("svg", _extends$2b({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon dot"), React.createElement("path", { d: "M20 16c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4z" }));
});

var _extends$2c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2b(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDownloadSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2b(_ref, ["styles"]);

  return React.createElement("svg", _extends$2c({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon download"), React.createElement("path", { d: "M4 24h24v-6h4v10H0V18h4v6zm14-8.343l4.01-4.01 2.828 2.828-8.84 8.84-8.838-8.84 2.828-2.828 4.01 4.01V2h4v13.657z" }));
});

var _extends$2d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2c(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDownloadSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2c(_ref, ["styles"]);

  return React.createElement("svg", _extends$2d({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon download"), React.createElement("path", { d: "M18 18.185l3.113-3.113 1.414 1.414-5.507 5.507-5.507-5.507 1.414-1.414 3.07 3.07V8h2v10.185zM28 20v6H6v-6h2v4h18v-4h2z" }));
});

var _extends$2e = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2d(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconEditDisallowedOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2d(_ref, ["styles"]);

  return React.createElement("svg", _extends$2e({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 96C21.49 96 0 74.51 0 48S21.49 0 48 0s48 21.49 48 48-21.49 48-48 48zm0-5c23.748 0 43-19.252 43-43S71.748 5 48 5 5 24.252 5 48s19.252 43 43 43z" }), React.createElement("path", { d: "M15.159 18.896c.406-.544.97-1.203 1.69-1.977.64-.687.58-.61 1.069-1.083.326-.315.593-.562.801-.74l62.04 61.926-1.123.772-.949.738-1.037.726-1.047.876-61.444-61.238z" }), React.createElement("path", { d: "M20 73.894l3.913-13.98 14.682-14.23 17.75-16.223 6.62-6.416c2.479-2.37 6.373-2.866 8.851-.496l2.853 2.602c2.568 2.457 2.972 7.217.404 9.67l-6.569 6.416L50.698 58.24 36.413 71.235l-14.498 4.607L20 73.894zM25.719 64L23 72.227l8.507-2.748L25.72 64zm32.223-31.328l-30.398 28.31 7.203 7.036 30.233-28.18-7.038-7.166zm6.714-7.16l-4.474 4.518 7.62 7.588 4.974-4.677c1.062-1.022 2.224-2.683.53-4.599a40.298 40.298 0 0 0-3.723-3.686c-1.478-1.177-2.723-1.455-4.927.856z" }));
});

var _extends$2f = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2e(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconEditDisallowedOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2e(_ref, ["styles"]);

  return React.createElement("svg", _extends$2f({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 80c-17.673 0-32-14.327-32-32 0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32zm0-3.333c15.832 0 28.667-12.835 28.667-28.667S63.832 19.333 48 19.333 19.333 32.168 19.333 48 32.168 76.667 48 76.667z" }), React.createElement("path", { d: "M26.106 28.597c.27-.362.646-.801 1.127-1.318.426-.458.386-.406.712-.721.217-.21.396-.375.535-.494l41.36 41.284-.75.515-.632.491-.691.484-.698.584-40.963-40.825z" }), React.createElement("path", { d: "M29.333 65.262l2.609-9.32 9.788-9.486L53.563 35.64l4.414-4.277c1.652-1.58 4.248-1.91 5.9-.33l1.903 1.734c1.712 1.638 1.98 4.812.269 6.447l-4.38 4.278L49.8 54.827l-9.524 8.663-9.665 3.071-1.277-1.299zm3.813-6.595l-1.813 5.484 5.672-1.832-3.86-3.652zM54.628 37.78L34.363 56.655l4.802 4.69L59.32 42.56l-4.692-4.778zm4.476-4.773l-2.982 3.012 5.08 5.059 3.315-3.118c.709-.681 1.483-1.789.354-3.066a26.866 26.866 0 0 0-2.483-2.458c-.985-.784-1.814-.97-3.284.571z" }));
});

var _extends$2g = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2f(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconEllipsisSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2f(_ref, ["styles"]);

  return React.createElement("svg", _extends$2g({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M6 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" }));
});

var _extends$2h = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2g(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2g(_ref, ["styles"]);

  return React.createElement("svg", _extends$2h({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm-.932-9.452L7 4h2l-.068 1.548L8.65 9H7.35l-.283-3.452zM7 11.005c0-.288.096-.528.287-.719A.968.968 0 0 1 8 10a.975.975 0 0 1 1 1.005.962.962 0 0 1-.287.709A.968.968 0 0 1 8 12a.968.968 0 0 1-.713-.286.962.962 0 0 1-.287-.709z", fillRule: "evenodd" }));
});

var _extends$2i = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2h(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconExclamationCircleSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2h(_ref, ["styles"]);

  return React.createElement("svg", _extends$2i({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "icon-exclamation-small"), React.createElement("path", { d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-1a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm-.932-9.452L11 8h2l-.068 1.548L12.65 13h-1.3l-.282-3.452zM11 15.005A.98.98 0 0 1 12 14a.977.977 0 0 1 1 1.006c0 .28-.096.517-.287.708-.19.19-.428.286-.713.286s-.522-.095-.713-.286a.967.967 0 0 1-.287-.71z" }));
});

var _extends$2j = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2i(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconExclamationLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2i(_ref, ["styles"]);

  return React.createElement("svg", _extends$2j({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M6.135 3.095L6 0h4l-.135 3.095L9.297 10H6.703l-.568-6.905zM6 14.011c0-.577.191-1.056.573-1.438C6.955 12.191 7.431 12 8 12c.57 0 1.045.191 1.427.573.382.382.573.861.573 1.438 0 .562-.191 1.034-.573 1.416C9.045 15.809 8.569 16 8 16c-.57 0-1.045-.191-1.427-.573-.382-.382-.573-.854-.573-1.416z" }));
});

var _extends$2k = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2j(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconExclamationSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2j(_ref, ["styles"]);

  return React.createElement("svg", _extends$2k({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M10.135 7.095L10 4h4l-.135 3.095L13.297 14h-2.594l-.568-6.905zM10 18.011c0-.577.191-1.056.573-1.438.382-.382.858-.573 1.427-.573.57 0 1.045.191 1.427.573.382.382.573.861.573 1.438 0 .562-.191 1.034-.573 1.416-.382.382-.858.573-1.427.573-.57 0-1.045-.191-1.427-.573-.382-.382-.573-.854-.573-1.416z" }));
});

var _extends$2l = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2k(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var EyehideOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2k(_ref, ["styles"]);

  return React.createElement("svg", _extends$2l({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15.955 7.652c.068.091.068.206-.069.275l-1.121 1.12a9.392 9.392 0 0 1-3.73 2.358l-.046-.092-.8-1.396-.046-.091a2.91 2.91 0 0 0 .8-2.037c0-1.67-1.327-3.02-2.974-3.02-.229 0-.458.046-.687.091l-.045-.091-.55-.961a9.744 9.744 0 0 1 8.26 2.837l1.008 1.007zm-7.3 3.09l.046.09.595 1.007A9.62 9.62 0 0 1 1.15 9.048L.05 7.927a.209.209 0 0 1 0-.275l.984-1.007A9.902 9.902 0 0 1 4.88 4.242l.045.092.778 1.35.07.092a3.078 3.078 0 0 0-.756 2.013c0 1.67 1.327 3.02 2.975 3.02.228 0 .457-.022.663-.068zm-2.196-3.8l1.533 2.655c-.984 0-1.762-.8-1.762-1.785 0-.32.091-.618.229-.87zm3.317.847c0 .343-.091.64-.228.916l-1.556-2.7h.023c.96 0 1.761.8 1.761 1.784zm.07 2.38l.823 1.396.961 1.67-.755.435-1.099-1.9-.663-1.166-.64-1.076-1.717-2.997-.618-1.076-.8-1.373-.962-1.647L5.131 2 6.23 3.876l.64 1.122.618 1.075 1.74 3.02.617 1.076z" }));
});

var _extends$2m = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2l(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconEyehideOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2l(_ref, ["styles"]);

  return React.createElement("svg", _extends$2m({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19.955 11.652c.068.091.068.206-.069.275l-1.121 1.12a9.392 9.392 0 0 1-3.73 2.358l-.046-.092-.8-1.396-.046-.091a2.91 2.91 0 0 0 .8-2.037c0-1.67-1.327-3.02-2.974-3.02-.229 0-.458.046-.687.091l-.045-.091-.55-.961a9.744 9.744 0 0 1 8.26 2.837l1.008 1.007zm-7.3 3.09l.046.09.595 1.007a9.62 9.62 0 0 1-8.146-2.791L4.05 11.927a.209.209 0 0 1 0-.275l.984-1.007A9.902 9.902 0 0 1 8.88 8.242l.045.092.778 1.35.07.092a3.078 3.078 0 0 0-.756 2.013c0 1.67 1.327 3.02 2.975 3.02.228 0 .457-.022.663-.068zm-2.196-3.8l1.533 2.655c-.984 0-1.762-.8-1.762-1.785 0-.32.091-.618.229-.87zm3.317.847c0 .343-.091.64-.228.916l-1.556-2.7h.023c.96 0 1.761.8 1.761 1.784zm.07 2.38l.823 1.396.961 1.67-.755.435-1.099-1.9-.663-1.166-.64-1.076-1.717-2.997-.618-1.076-.8-1.373-.962-1.647L9.131 6l1.099 1.876.64 1.122.618 1.075 1.74 3.02.617 1.076z" }));
});

var _extends$2n = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2m(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var EyeshowOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2m(_ref, ["styles"]);

  return React.createElement("svg", _extends$2n({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15.952 7.918c.068.091.068.206-.046.274l-1.097 1.12a9.544 9.544 0 0 1-13.661 0L.051 8.192a.208.208 0 0 1 0-.274l1.006-1.005a9.736 9.736 0 0 1 13.89 0l1.005 1.005zm-7.928 3.175c1.622 0 2.97-1.347 2.97-3.015 0-1.668-1.325-3.016-2.97-3.016-1.644 0-2.97 1.348-2.97 3.016s1.326 3.015 2.97 3.015zm0-1.256a1.77 1.77 0 0 1-1.759-1.782 1.77 1.77 0 0 1 1.76-1.782c.97 0 1.758.798 1.758 1.782a1.77 1.77 0 0 1-1.759 1.782z" }));
});

var _extends$2o = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2n(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconEyeshowOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2n(_ref, ["styles"]);

  return React.createElement("svg", _extends$2o({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19.952 11.918c.068.091.068.206-.046.274l-1.097 1.12a9.544 9.544 0 0 1-13.661 0l-1.097-1.12a.208.208 0 0 1 0-.274l1.006-1.005a9.736 9.736 0 0 1 13.89 0l1.005 1.005zm-7.928 3.175c1.622 0 2.97-1.347 2.97-3.015 0-1.668-1.325-3.016-2.97-3.016-1.644 0-2.97 1.348-2.97 3.016s1.326 3.015 2.97 3.015zm0-1.256a1.77 1.77 0 0 1-1.759-1.782 1.77 1.77 0 0 1 1.76-1.782c.97 0 1.758.798 1.758 1.782a1.77 1.77 0 0 1-1.759 1.782z" }));
});

var _extends$2p = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2o(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFaceOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2o(_ref, ["styles"]);

  return React.createElement("svg", _extends$2p({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M5.586 8c.571 0 1.035-.433 1.035-.966 0-.532-.464-.965-1.035-.965s-1.034.433-1.034.965c0 .533.463.966 1.034.966M8 15.034A7.034 7.034 0 1 1 8 .966a7.034 7.034 0 1 1 0 14.068M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m2.552 8c.57 0 1.034-.433 1.034-.966 0-.532-.463-.965-1.034-.965-.572 0-1.035.433-1.035.965 0 .533.463.966 1.035.966m-2.276.966A6.049 6.049 0 0 0 3.034 12h1.21a5.034 5.034 0 0 1 4.032-2.023c1.65 0 3.111.797 4.032 2.023h1.21a6.047 6.047 0 0 0-5.242-3.034" }));
});

var _extends$2q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2p(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFaceOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2p(_ref, ["styles"]);

  return React.createElement("svg", _extends$2q({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M9.586 12c.571 0 1.035-.433 1.035-.966 0-.532-.464-.965-1.035-.965s-1.034.433-1.034.965c0 .533.463.966 1.034.966M12 19.034a7.034 7.034 0 1 1 0-14.068 7.034 7.034 0 1 1 0 14.068M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16m2.552 8c.57 0 1.034-.433 1.034-.966 0-.532-.463-.965-1.034-.965-.572 0-1.035.433-1.035.965 0 .533.463.966 1.035.966m-2.276.966A6.049 6.049 0 0 0 7.034 16h1.21a5.034 5.034 0 0 1 4.032-2.023c1.65 0 3.111.797 4.032 2.023h1.21a6.047 6.047 0 0 0-5.242-3.034" }));
});

var _extends$2r = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2q(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFlagLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2q(_ref, ["styles"]);

  return React.createElement("svg", _extends$2r({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon flag"), React.createElement("path", { d: "M2 18.894v12.1C2 31.548 1.536 32 1 32c-.552 0-1-.466-1-1.007V1.918l1.31-.485C3.643.57 6.412 0 9.482 0c3.307 0 6.565.68 9.672 2.016C21.4 2.98 23.48 3.46 25.326 3.46c1.448 0 2.702-.284 3.793-.795l2.878-1.348v17.336l-.424.54C30.287 20.833 28.21 22 25.326 22c-1.84 0-3.865-.484-6.03-1.415-3.637-1.562-7.44-2.352-11.312-2.352-1.99 0-3.856.21-5.548.568l-.44.094zm5.987-2.66c4.146 0 8.217.845 12.1 2.514 1.95.838 3.708 1.253 5.24 1.253 2.09 0 3.658-.746 4.673-2.037v-13.5c-1.424.667-2.973.997-4.673.997-2.15 0-4.492-.546-6.962-1.605-2.86-1.23-5.85-1.853-8.882-1.853-2.66 0-5.197.464-7.478 1.31L2 16.85a28.925 28.925 0 0 1 5.987-.617z" }));
});

var _extends$2s = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2r(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFlagSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2r(_ref, ["styles"]);

  return React.createElement("svg", _extends$2s({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M5 13.447v6.05a.507.507 0 0 1-.5.503.507.507 0 0 1-.5-.503V4.959l.655-.242A11.801 11.801 0 0 1 8.741 4c1.654 0 3.283.34 4.837 1.008 1.123.482 2.163.722 3.086.722.724 0 1.351-.142 1.897-.398L20 4.66v8.668l-.212.27c-.643.82-1.682 1.403-3.124 1.403-.92 0-1.932-.242-3.015-.707a14.257 14.257 0 0 0-5.657-1.176c-.995 0-1.928.104-2.774.283l-.22.047H5zm2.994-1.33c2.073 0 4.109.422 6.05 1.257.976.419 1.855.627 2.62.627 1.046 0 1.83-.373 2.337-1.019v-6.75a5.425 5.425 0 0 1-2.336.498c-1.075 0-2.247-.273-3.482-.802a11.19 11.19 0 0 0-4.441-.926c-1.33 0-2.599.232-3.74.655L5 12.425c.96-.203 1.962-.309 2.994-.309v.001z" }));
});

var _extends$2t = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2s(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFlipChartOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2s(_ref, ["styles"]);

  return React.createElement("svg", _extends$2t({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M93 6a2.998 2.998 0 1 1 0 5.998h-3V65.98a6.002 6.002 0 0 1-6 6.001H58.086l7.467 13.742c.921 1.365.375 3.104-1.221 3.896-1.593.786-3.633.321-4.551-1.044l-8.337-15.34a2.498 2.498 0 0 1-.405-1.254h-6.081a2.469 2.469 0 0 1-.405 1.254l-8.334 15.34c-.918 1.365-2.958 1.83-4.551 1.044-1.599-.792-2.142-2.531-1.224-3.896l7.47-13.742H12c-3.312 0-6-2.687-6-6V11.997H3c-1.659 0-3-1.34-3-3.002A2.996 2.996 0 0 1 3 6h90zm-9 8.997v-2.993h-2.97c-.012 0-.018-.006-.03-.006H15c-.012 0-.018.006-.03.006H12V62.98c0 1.659 1.341 3 3 3h66c1.656 0 3-1.341 3-3V14.997z" }), React.createElement("path", { d: "M76.5 23.809a3 3 0 0 0-4.098 1.094L53.868 41.824 39.219 31.39c-.75-1.112-2.238-1.583-3.63-1.307-.264.036-.51.11-.756.216-.051.024-.114.02-.165.048-.054.027-.081.072-.129.096-.216.123-.405.27-.591.444a2.888 2.888 0 0 0-.447.515c-.03.042-.072.066-.099.111l-15 17.926a3.023 3.023 0 0 0 1.098 4.124 2.983 2.983 0 0 0 4.098-1.104l13.23-15.805 13.953 9.933c.231.345.534.63.888.852.225.285.498.542.831.737a3.004 3.004 0 0 0 4.098-1.103l21-19.17a2.996 2.996 0 0 0-1.098-4.094z" }));
});

var _extends$2u = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2t(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFlipChartOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2t(_ref, ["styles"]);

  return React.createElement("svg", _extends$2u({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M78 20a1.999 1.999 0 1 1 0 3.999h-2v35.987c0 2.21-1.792 4-4 4H54.724l4.978 9.162c.614.91.25 2.07-.814 2.597-1.062.524-2.422.214-3.034-.695l-5.558-10.227a1.665 1.665 0 0 1-.27-.836h-4.054a1.646 1.646 0 0 1-.27.836L40.146 75.05c-.612.91-1.972 1.22-3.034.695-1.066-.527-1.428-1.687-.816-2.597l4.98-9.161H24c-2.208 0-4-1.792-4-4V23.998h-2c-1.106 0-2-.894-2-2.002 0-1.103.894-1.997 2-1.997h60zm-6 5.998v-1.995h-1.98c-.008 0-.012-.004-.02-.004H26c-.008 0-.012.004-.02.004H24v33.984c0 1.105.894 2 2 2h44a2 2 0 0 0 2-2V25.998z" }), React.createElement("path", { d: "M67 31.872a2 2 0 0 0-2.732.73l-12.356 11.28-9.766-6.955c-.5-.742-1.492-1.056-2.42-.872-.176.024-.34.074-.504.144-.034.016-.076.014-.11.032-.036.018-.054.048-.086.064-.144.082-.27.18-.394.296a1.925 1.925 0 0 0-.298.344c-.02.028-.048.044-.066.074l-10 11.95A2.015 2.015 0 0 0 29 51.71c.956.557 2.18.23 2.732-.736l8.82-10.537 9.302 6.622c.154.23.356.42.592.568.15.19.332.362.554.492.956.55 2.18.222 2.732-.736l14-12.78a1.997 1.997 0 0 0-.732-2.73z" }));
});

var _extends$2v = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2u(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFolderOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2u(_ref, ["styles"]);

  return React.createElement("svg", _extends$2v({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M87 24H6V9c0-1.656 1.344-3 3-3h24c1.656 0 3 1.344 3 3v9h51c1.656 0 3 1.341 3 2.997A3.002 3.002 0 0 1 87 24zm3 9v54.003A2.999 2.999 0 0 1 87 90H9c-1.656 0-3-1.341-3-2.997V30h84zm0-21.003H42V6a6 6 0 0 0-6-6H6a6 6 0 0 0-6 6v84a6 6 0 0 0 6 6h84a6 6 0 0 0 6-6V18a6 6 0 0 0-6-6.003z" }));
});

var _extends$2w = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2v(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFolderOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2v(_ref, ["styles"]);

  return React.createElement("svg", _extends$2w({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M74 32H20V22a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v6h34a1.999 1.999 0 1 1 0 4zm2 6v36.002A1.999 1.999 0 0 1 74 76H22c-1.104 0-2-.894-2-1.998V36h56zm0-14.002H44V20a4 4 0 0 0-4-4H20a4 4 0 0 0-4 4v56a4 4 0 0 0 4 4h56a4 4 0 0 0 4-4V28a4 4 0 0 0-4-4.002z" }));
});

var _extends$2x = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2w(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFormerLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2w(_ref, ["styles"]);

  return React.createElement("svg", _extends$2x({ height: "16", viewBox: "0 0 16 16", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fillRule: "evenodd", d: "M14.645 13.858l1.183-1.183a.557.557 0 1 0-.789-.788l-1.182 1.182-1.182-1.182a.557.557 0 1 0-.788.788l1.182 1.183-1.182 1.181a.558.558 0 0 0 .788.789l1.182-1.182 1.182 1.182a.557.557 0 1 0 .789-.789l-1.183-1.181zM6.4 8.533a3.733 3.733 0 1 1 0-7.466 3.733 3.733 0 0 1 0 7.466zM11.2 4.8a4.8 4.8 0 1 0-7.149 4.184A6.397 6.397 0 0 0 0 14.934V16h1.067v-1.067A5.333 5.333 0 0 1 6.4 9.6c1.436 0 2.737.57 3.695 1.493.232-.27.496-.51.788-.715a6.412 6.412 0 0 0-2.135-1.394A4.796 4.796 0 0 0 11.2 4.8z" }));
});

var _extends$2y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2x(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFormerSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2x(_ref, ["styles"]);

  return React.createElement("svg", _extends$2y({ height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fillRule: "evenodd", d: "M18.645 17.858l1.183-1.183a.557.557 0 1 0-.789-.788l-1.182 1.182-1.182-1.182a.557.557 0 1 0-.788.788l1.182 1.183-1.182 1.181a.558.558 0 0 0 .788.789l1.182-1.182 1.182 1.182a.557.557 0 1 0 .789-.789l-1.183-1.181zM10.4 12.533a3.733 3.733 0 1 1 0-7.466 3.733 3.733 0 0 1 0 7.466zM15.2 8.8a4.8 4.8 0 1 0-7.149 4.184A6.397 6.397 0 0 0 4 18.934V20h1.067v-1.067A5.333 5.333 0 0 1 10.4 13.6c1.436 0 2.737.57 3.695 1.493.232-.27.496-.51.788-.715a6.412 6.412 0 0 0-2.135-1.394A4.796 4.796 0 0 0 15.2 8.8z" }));
});

var _extends$2z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2y(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconGhostOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2y(_ref, ["styles"]);

  return React.createElement("svg", _extends$2z({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M8.363 0H8.03C4.945 0 2.4 2.472 2.4 5.535v10.138c0 .126.09.24.205.295.114.054.258.039.357-.04l1.42-1.125 1.11 1.101a.332.332 0 0 0 .467 0l1.085-1.077 1.084 1.077a.33.33 0 0 0 .466 0l1.084-1.077 1.083 1.077a.33.33 0 0 0 .466 0l1.084-1.077 1.084 1.077a.33.33 0 0 0 .232.096.245.245 0 0 0 .108-.025c.123-.05.185-.17.185-.302V5.535A5.532 5.532 0 0 0 8.363 0zM13 14.62l-.702-.72a.303.303 0 0 0-.435 0l-1.03 1.034-1.03-1.033a.31.31 0 0 0-.443 0l-1.033 1.033-1.034-1.033a.314.314 0 0 0-.444 0l-1.033 1.033-1.034-1.033a.337.337 0 0 0-.435-.024l-1.077.848V5.646C3.269 3.051 5.415.96 8.009.96h.32a4.665 4.665 0 0 1 4.67 4.686v8.974z" }), React.createElement("path", { d: "M6.385 4.48a.786.786 0 1 0 .001 1.571.786.786 0 0 0-.001-1.571zm0 .942a.157.157 0 1 1 0-.315.157.157 0 0 1 0 .315zM10.225 4.48a.786.786 0 1 0 .001 1.571.786.786 0 0 0-.001-1.571zm0 .942a.157.157 0 1 1 0-.315.157.157 0 0 1 0 .315z" }));
});

var _extends$2A = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2z(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconGhostOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2z(_ref, ["styles"]);

  return React.createElement("svg", _extends$2A({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M11.963 4h-.334C8.545 4 6 6.472 6 9.535v10.138c0 .126.09.24.205.295.114.054.258.039.357-.04l1.42-1.125 1.11 1.101a.332.332 0 0 0 .467 0l1.085-1.077 1.084 1.077a.33.33 0 0 0 .466 0l1.084-1.077 1.083 1.077a.33.33 0 0 0 .466 0l1.084-1.077 1.084 1.077a.33.33 0 0 0 .232.096.245.245 0 0 0 .108-.025c.123-.05.185-.17.185-.302V9.535A5.532 5.532 0 0 0 11.963 4zM16.6 18.62l-.702-.72a.303.303 0 0 0-.435 0l-1.03 1.034-1.03-1.033a.31.31 0 0 0-.443 0l-1.033 1.033-1.034-1.033a.314.314 0 0 0-.444 0l-1.033 1.033-1.034-1.033a.337.337 0 0 0-.435-.024l-1.077.848V9.646c0-2.595 2.146-4.686 4.74-4.686h.32a4.665 4.665 0 0 1 4.67 4.686v8.974z" }), React.createElement("path", { d: "M9.985 8.48a.786.786 0 1 0 .001 1.571.786.786 0 0 0-.001-1.571zm0 .942a.157.157 0 1 1 0-.315.157.157 0 0 1 0 .315zM13.825 8.48a.786.786 0 1 0 .001 1.571.786.786 0 0 0-.001-1.571zm0 .942a.157.157 0 1 1 0-.315.157.157 0 0 1 0 .315z" }));
});

var _extends$2B = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2A(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconGraph = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2A(_ref, ["styles"]);

  return React.createElement("svg", _extends$2B({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 1.333A.664.664 0 0 0 7.333 2v12c0 .365.301.667.667.667A.67.67 0 0 0 8.667 14V2A.664.664 0 0 0 8 1.333zM8 0c1.104 0 2 .89 2 2v12c0 1.1-.896 2-2 2s-2-.9-2-2V2c0-1.11.896-2 2-2zm6 5.333a.664.664 0 0 0-.667.667v8c0 .365.301.667.667.667a.67.67 0 0 0 .667-.667V6A.664.664 0 0 0 14 5.333zM14 4c1.104 0 2 .89 2 2v8c0 1.1-.896 2-2 2s-2-.9-2-2V6c0-1.11.896-2 2-2zM2 9.333a.664.664 0 0 0-.667.667v4c0 .365.301.667.667.667A.67.67 0 0 0 2.667 14v-4A.664.664 0 0 0 2 9.333zM2 8c1.104 0 2 .89 2 2v4c0 1.1-.896 2-2 2s-2-.9-2-2v-4c0-1.11.896-2 2-2z" }));
});

var _extends$2C = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2B(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GridLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2B(_ref, ["styles"]);

  return React.createElement("svg", _extends$2C({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fillRule: "evenodd", d: "M7 9h2V7H7v2zm-1 1h4V6H6v4zm1-7h2V1H7v2zM6 4h4V0H6v4zm1 11h2v-2.001H7v2zm-1 1h4v-4H6v4zm7-7h2V7h-2v2zm-1 1h4V6h-4v4zm1-7h2V1h-2v2zm-1 1h4V0h-4v4zm1 11h2v-2.001h-2v2zm-1 1h4v-4h-4v4zM1 15h2v-2.001H1v2zm-1 1h4v-4H0v4zM1 3h2V1H1v2zM0 4h4V0H0v4zm1 5h2V7H1v2zm-1 1h4V6H0v4z" }));
});

var _extends$2D = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2C(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconGridSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2C(_ref, ["styles"]);

  return React.createElement("svg", _extends$2D({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { fillRule: "evenodd", d: "M11 13h2v-2h-2v2zm-1 1h4v-4h-4v4zm1-7h2V5h-2v2zm-1 1h4V4h-4v4zm1 11h2v-2.001h-2v2zm-1 1h4v-4h-4v4zm7-7h2v-2h-2v2zm-1 1h4v-4h-4v4zm1-7h2V5h-2v2zm-1 1h4V4h-4v4zm1 11h2v-2.001h-2v2zm-1 1h4v-4h-4v4zM5 19h2v-2.001H5v2zm-1 1h4v-4H4v4zM5 7h2V5H5v2zM4 8h4V4H4v4zm1 5h2v-2H5v2zm-1 1h4v-4H4v4z" }));
});

var _extends$2E = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2D(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconHouseOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2D(_ref, ["styles"]);

  return React.createElement("svg", _extends$2E({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M94.804 37.466c3.048 2.468-.338 7.052-3.387 4.584l-1.354-1.058v51.834c0 1.764-1.355 3.174-2.71 3.174H8.78c-1.694 0-3.048-1.41-3.048-3.174V40.992L4.716 42.05C1.668 44.518-1.72 39.934.99 37.466L46.373.793c1.016-1.057 2.371-1.057 3.387 0C70.42 17.366 72.451 19.13 94.804 37.466zM48.158 7.4L10.845 37.298V91.4h22.457V52.247h29.712V91.4h22.112V37.298zM38.4 57.6v32h19.2v-32z" }));
});

var _extends$2F = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2E(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconHouseOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2E(_ref, ["styles"]);

  return React.createElement("svg", _extends$2F({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M79.203 40.977c2.032 1.646-.226 4.702-2.258 3.056l-.903-.705v34.556c0 1.176-.903 2.116-1.806 2.116H21.853c-1.129 0-2.032-.94-2.032-2.116V43.328l-.677.705c-2.032 1.646-4.29-1.41-2.484-3.056l30.255-24.448c.678-.705 1.581-.705 2.258 0 13.773 11.049 15.128 12.224 30.03 24.448zM48.106 20.933L23.23 40.866v36.067h14.971V50.832H58.01v26.101h14.74V40.866zM41.6 54.4v21.333h12.8V54.4z" }));
});

var _extends$2G = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2F(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconInboxOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2F(_ref, ["styles"]);

  return React.createElement("svg", _extends$2G({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M45.849 53.13a3.011 3.011 0 0 0 2.151.885 3.01 3.01 0 0 0 2.148-.885l14.985-14.982a3.033 3.033 0 0 0 0-4.281 3.031 3.031 0 0 0-4.284 0L51 43.716V2.997A2.999 2.999 0 0 0 48 0c-1.659 0-3 1.341-3 2.997v40.719l-9.852-9.849a3.027 3.027 0 0 0-4.281 4.281zM90 86.997c0 1.656-1.344 3-3 3H9a3 3 0 0 1-3-3V62.994a2.997 2.997 0 0 1 3-2.997h15v12h48v-12h15c1.656 0 3 1.341 3 2.997zm-6-75H72v6h7.713L90 53.994H66v12H30v-12H6l10.287-35.997H24v-6H12l-12 42v36c0 3.318 2.685 6 6 6h84c3.312 0 6-2.682 6-6v-36z", fillRule: "evenodd" }));
});

var _extends$2H = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2G(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconInboxOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2G(_ref, ["styles"]);

  return React.createElement("svg", _extends$2H({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M46.567 51.421c.396.396.914.592 1.434.59a2.006 2.006 0 0 0 1.432-.59l9.99-9.988a2.022 2.022 0 0 0 0-2.854 2.02 2.02 0 0 0-2.856 0l-6.566 6.566V17.998a2 2 0 0 0-2-1.998c-1.106 0-2 .894-2 1.998v27.147l-6.568-6.566a2.018 2.018 0 0 0-2.854 2.854zM76.002 74a2 2 0 0 1-2 2H22a2 2 0 0 1-2-2V57.997c0-1.104.894-1.998 2-1.998h10v8h32.002v-8h10a2 2 0 0 1 2 1.998zm-4-50.002h-8v4h5.142l6.858 24h-16v8H36v-8H20l6.857-24h5.143v-4h-8L16 52v24C16 78.213 17.79 80 20 80h56.002c2.208 0 4-1.788 4-4V52z", fillRule: "evenodd" }));
});

var _extends$2I = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2H(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconInfoOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2H(_ref, ["styles"]);

  return React.createElement("svg", _extends$2I({ height: "16", viewBox: "0 0 96 96", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 0C21.533 0 0 21.533 0 48s21.533 48 48 48 48-21.533 48-48S74.467 0 48 0zm0 90C24.84 90 6 71.16 6 48S24.84 6 48 6s42 18.842 42 42-18.841 42-42 42zm0-69.703a5.768 5.768 0 0 0-5.76 5.763c0 3.174 2.584 5.757 5.76 5.757s5.76-2.583 5.76-5.757A5.768 5.768 0 0 0 48 20.297zm.274 20.297a4.389 4.389 0 0 0-4.388 4.389v26.331a4.389 4.389 0 0 0 8.777 0V44.983a4.389 4.389 0 0 0-4.389-4.389z" }));
});

var _extends$2J = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2I(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconInfoOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2I(_ref, ["styles"]);

  return React.createElement("svg", _extends$2J({ height: "16", viewBox: "0 0 96 96", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 16c-17.645 0-32 14.355-32 32s14.355 32 32 32 32-14.355 32-32-14.355-32-32-32zm0 60c-15.44 0-28-12.56-28-28s12.56-28 28-28 28 12.561 28 28-12.56 28-28 28zm0-46.469a3.845 3.845 0 0 0-3.84 3.842c0 2.117 1.723 3.838 3.84 3.838s3.84-1.721 3.84-3.838A3.845 3.845 0 0 0 48 29.531zm.183 13.532a2.926 2.926 0 0 0-2.926 2.926v17.554a2.926 2.926 0 0 0 5.852 0V45.989a2.926 2.926 0 0 0-2.926-2.926z" }));
});

var _extends$2K = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2J(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLinkedGroup = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2J(_ref, ["styles"]);

  return React.createElement("svg", _extends$2K({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "Linked Group"), React.createElement("desc", null, "Linked group icon."), React.createElement("g", { fillRule: "evenodd" }, React.createElement("path", { d: "M55 55a7 7 0 0 1 7 7v14a7 7 0 0 1-7 7H41a7 7 0 0 1-7-7V62a7 7 0 0 1 7-7zm-2 4H43a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V64a5 5 0 0 0-5-5zM55 15a7 7 0 0 1 7 7v14a7 7 0 0 1-7 7H41a7 7 0 0 1-7-7V22a7 7 0 0 1 7-7zm-2 4H43a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V24a5 5 0 0 0-5-5zM21 55a7 7 0 0 1 7 7v14a7 7 0 0 1-7 7H7a7 7 0 0 1-7-7V62a7 7 0 0 1 7-7zm-2 4H9a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V64a5 5 0 0 0-5-5zM89 55a7 7 0 0 1 7 7v14a7 7 0 0 1-7 7H75a7 7 0 0 1-7-7V62a7 7 0 0 1 7-7zm-2 4H77a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V64a5 5 0 0 0-5-5z" }), React.createElement("path", { d: "M46 40h4v15h-4zM34.546 38.126l2.828 2.828-16.97 16.97-2.829-2.828zM61.222 37.393l-2.829 2.829 18.385 18.385 2.829-2.829z" })));
});

var _extends$2L = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2K(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLoadingOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2K(_ref, ["styles"]);

  return React.createElement("svg", _extends$2L({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M13.62 2.306L11.406 4.52a4.87 4.87 0 1 0 0 6.96l2.214 2.214a8 8 0 1 1 0-11.388z" }));
});

var _extends$2M = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2L(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLocationOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2L(_ref, ["styles"]);

  return React.createElement("svg", _extends$2M({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M3 6.063C3 3.267 5.238 1 8 1c2.76 0 5 2.267 5 5.063S8 14.5 8 14.5 3 8.86 3 6.063zM8 0a6 6 0 0 0-6 6c0 3.314 6 9.999 6 9.999s6-6.685 6-10A6 6 0 0 0 8 0zm6 10h-1l1.5 5H11l-1 1h5.999l-2-6zM8 7A1.5 1.5 0 1 1 7.998 4 1.5 1.5 0 0 1 8 7zm0-4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM1.5 15L3 10H2l-2 6h6l-1-1H1.5z" }));
});

var _extends$2N = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2M(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLocationOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2M(_ref, ["styles"]);

  return React.createElement("svg", _extends$2N({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7 10.063C7 7.268 9.239 5 12 5s5 2.268 5 5.063c0 2.796-5 8.438-5 8.438s-5-5.642-5-8.438zM12 4a6 6 0 0 0-6 6c0 3.315 6 10 6 10s6-6.685 6-10a6 6 0 0 0-6-6zm6 10.001h-1L18.5 19H15l-1 1.001h6l-2-6zM12 11a1.5 1.5 0 1 1-.001-2.999A1.5 1.5 0 0 1 12 11zm0-4a2.5 2.5 0 1 0 .001 5.001A2.5 2.5 0 0 0 12 7zM5.5 19L7 14.001H6l-2 6h6L9 19H5.5z" }));
});

var _extends$2O = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2N(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLockSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2N(_ref, ["styles"]);

  return React.createElement("svg", _extends$2O({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M12.182 13c-.305 0-.552.223-.552.5v3c0 .276.247.5.552.5.305 0 .553-.224.553-.5v-3c0-.277-.248-.5-.553-.5zm6.078 5c0 .552-.495 1-1.105 1H7.21c-.61 0-1.105-.448-1.105-1v-6c0-.552.494-1 1.105-1h9.945c.61 0 1.105.448 1.105 1v6zM8.315 8.5c0-1.933 1.732-3.5 3.867-3.5 2.136 0 3.868 1.567 3.868 3.5V10H8.315V8.5zm8.84 1.5V8.5c0-2.485-2.226-4.5-4.973-4.5C9.436 4 7.21 6.015 7.21 8.5V10C5.99 10 5 10.895 5 12v6c0 1.104.99 2 2.21 2h9.945c1.22 0 2.21-.896 2.21-2v-6c0-1.105-.99-2-2.21-2z" }));
});

var _extends$2P = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2O(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLogoutOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2O(_ref, ["styles"]);

  return React.createElement("svg", _extends$2P({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M11.328 12.127c-.22-.22-.22-.578 0-.771l2.756-2.757H4.286a.559.559 0 0 1-.565-.565c0-.317.248-.565.565-.565h9.798l-2.756-2.756a.566.566 0 0 1 .8-.8l3.72 3.722a.365.365 0 0 1 .07.082c.013 0 .013.014.013.014l.041.083c.014 0 .014.014.014.028a.105.105 0 0 1 .028.068c.014.042.014.07.014.11 0 .042 0 .07-.014.11-.014.028-.014.042-.028.07-.014 0-.014.014-.014.027-.013.014-.027.042-.04.07 0 .013-.015.027-.015.027a.365.365 0 0 1-.069.083l-3.72 3.72a.552.552 0 0 1-.4.166.552.552 0 0 1-.4-.166zM.565 16A.577.577 0 0 1 0 15.435V.565C0 .248.248 0 .565 0h7.442c.317 0 .565.248.565.565v5.554a.559.559 0 0 1-.565.565.559.559 0 0 1-.565-.565V1.13H1.13v13.74h6.312V9.88c0-.317.248-.565.565-.565.317 0 .565.248.565.565v5.554a.559.559 0 0 1-.565.565H.565z" }));
});

var _extends$2Q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2P(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLogoutOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2P(_ref, ["styles"]);

  return React.createElement("svg", _extends$2Q({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M15.328 16.127c-.22-.22-.22-.578 0-.771l2.756-2.757H8.286a.559.559 0 0 1-.565-.565c0-.317.248-.565.565-.565h9.798l-2.756-2.756a.566.566 0 0 1 .8-.8l3.72 3.722a.365.365 0 0 1 .07.082c.013 0 .013.014.013.014l.041.083c.014 0 .014.014.014.028a.105.105 0 0 1 .028.068.303.303 0 0 1 .014.11c0 .042 0 .07-.014.11-.014.028-.014.042-.028.07-.014 0-.014.014-.014.027-.013.014-.027.042-.04.07 0 .013-.015.027-.015.027a.365.365 0 0 1-.069.083l-3.72 3.72a.552.552 0 0 1-.4.166.552.552 0 0 1-.4-.166zM4.565 20A.577.577 0 0 1 4 19.435V4.565C4 4.248 4.248 4 4.565 4h7.442c.317 0 .565.248.565.565v5.554a.559.559 0 0 1-.565.565.559.559 0 0 1-.565-.565V5.13H5.13v13.74h6.312V13.88c0-.317.248-.565.565-.565.317 0 .565.248.565.565v5.554a.559.559 0 0 1-.565.565H4.565z" }));
});

var _extends$2R = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2Q(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var MagnifySolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2Q(_ref, ["styles"]);

  return React.createElement("svg", _extends$2R({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon magnify"), React.createElement("path", { d: "M31.28 27.07l-7.653-7.653a12.46 12.46 0 0 0 1.82-6.5C25.446 5.994 19.448 0 12.526 0 5.608-.002 0 5.608 0 12.53c0 6.918 5.996 12.915 12.915 12.915 2.303 0 4.456-.626 6.31-1.71l7.693 7.7c.753.75 1.975.75 2.726 0l1.91-1.91c.75-.752.478-1.702-.273-2.454zM3.857 12.53c0-4.793 3.883-8.676 8.673-8.676s9.06 4.267 9.06 9.06a8.677 8.677 0 0 1-8.675 8.676c-4.792-.002-9.06-4.27-9.06-9.06z" }));
});

var _extends$2S = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2R(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMagnifySolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2R(_ref, ["styles"]);

  return React.createElement("svg", _extends$2S({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon magnify small"), React.createElement("path", { d: "M22.708 20.997l-3.11-3.11c.47-.768.74-1.673.74-2.64 0-2.812-2.436-5.247-5.248-5.247S10 12.278 10 15.09c0 2.81 2.436 5.247 5.247 5.247a5.06 5.06 0 0 0 2.563-.694l3.126 3.127a.785.785 0 0 0 1.108 0l.776-.776c.305-.305.194-.69-.11-.996zm-11.14-5.907c0-1.947 1.576-3.524 3.522-3.524s3.68 1.734 3.68 3.68c0 1.947-1.577 3.525-3.523 3.525s-3.68-1.734-3.68-3.68z" }));
});

var _extends$2T = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2S(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMakeCallSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2S(_ref, ["styles"]);

  return React.createElement("svg", _extends$2T({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M39.432 25.597c0-2.883 2.323-5.225 5.187-5.225h20.884l-4.874-5.77a5.253 5.253 0 0 1 .595-7.36 5.166 5.166 0 0 1 7.311.596L80.66 22.214a5.24 5.24 0 0 1 0 6.764L68.535 43.354a5.157 5.157 0 0 1-3.955 1.841 5.134 5.134 0 0 1-3.356-1.242 5.247 5.247 0 0 1-.595-7.361l4.874-5.775H44.62c-2.864-.002-5.187-2.336-5.187-5.22zM31.056 28c.476-.49.608-1.115.388-1.857-.205-.745-.75-1.527-1.646-2.337L11.033 9.1c-.17-.185-.559-.409-1.14-.662-.526-.224-.917-.304-1.206-.255-.655-.101-1.172.112-1.565.644l-3.537 4.391L27.88 32.146l3.177-4.147zm30.406 41.077c-1.544-.48-2.695-.842-3.469-1.076-.76-.24-1.26-.412-1.477-.503-1.182-.5-2.512-1.287-3.973-2.35l-21.84-17.323c-1.321-1.006-2.436-2.09-3.336-3.262-.582-.692-1.322-1.815-2.233-3.39-.905-1.572-1.045-3.095-.421-4.585.124-.295.38-.709.789-1.245L1.389 16.259c-2.561 6.096-1.58 14.53 2.944 25.321 1.852 4.293 4.923 8.895 9.222 13.79 4.294 4.904 9.753 9.944 16.365 15.133 4.765 3.787 9.696 7.072 14.8 9.859 5.094 2.777 10.154 5.246 15.177 7.384 2.362 1.011 4.874 1.662 7.53 1.962 2.663.304 5.64.375 8.928.192 3.293-.177 6.005-.552 8.131-1.14 2.108-.59 3.924-1.527 5.422-2.814l-24.11-19.082c-1.355 1.954-2.796 2.696-4.336 2.212zm32.246 5.087L76.203 60.459c-.399-.315-.96-.628-1.697-.943-1.563-.667-2.711-.406-3.467.753L67.79 64.28 91.9 83.37l3.27-4.068c.476-1.125.75-1.988.825-2.568.073-.594-.685-1.449-2.287-2.571z" }));
});

var _extends$2U = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2T(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMakeCallSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2T(_ref, ["styles"]);

  return React.createElement("svg", _extends$2U({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M42.288 33.065c0-1.922 1.549-3.483 3.458-3.483h13.923l-3.25-3.847a3.502 3.502 0 0 1 .397-4.907 3.444 3.444 0 0 1 4.874.398l8.083 9.583a3.493 3.493 0 0 1 0 4.51l-8.083 9.584a3.438 3.438 0 0 1-4.874.399 3.498 3.498 0 0 1-.396-4.907l3.249-3.85H45.746a3.47 3.47 0 0 1-3.458-3.48zm-5.584 1.601c.317-.326.405-.743.259-1.238-.137-.497-.5-1.018-1.097-1.558l-12.51-9.804c-.115-.123-.373-.273-.761-.441-.35-.15-.61-.203-.804-.17-.436-.068-.781.074-1.043.429L18.39 24.81l16.196 12.62 2.118-2.765zM56.975 62.05c-1.03-.32-1.797-.56-2.313-.717-.507-.16-.84-.274-.985-.335-.788-.333-1.674-.858-2.649-1.566L36.47 47.882c-.881-.67-1.624-1.392-2.224-2.174-.389-.462-.882-1.21-1.489-2.26-.603-1.048-.697-2.064-.28-3.057.082-.196.253-.472.525-.83L16.926 26.84c-1.707 4.063-1.054 9.686 1.963 16.88 1.234 2.862 3.281 5.93 6.148 9.193 2.863 3.27 6.502 6.63 10.91 10.089a68.993 68.993 0 0 0 9.866 6.573 116.569 116.569 0 0 0 10.119 4.923 17.743 17.743 0 0 0 5.02 1.307c1.775.203 3.76.25 5.952.129 2.195-.118 4.002-.369 5.42-.761 1.406-.392 2.616-1.018 3.615-1.875L59.865 60.576c-.903 1.302-1.864 1.797-2.89 1.474zm21.497 3.392l-11.67-9.136c-.266-.21-.64-.418-1.132-.629-1.041-.444-1.807-.27-2.31.502l-2.167 2.675L77.267 71.58l2.18-2.712c.317-.75.5-1.325.55-1.712.048-.396-.457-.966-1.525-1.714z" }));
});

var _extends$2V = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2U(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMaskOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2U(_ref, ["styles"]);

  return React.createElement("svg", _extends$2V({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("g", { fillRule: "evenodd" }, React.createElement("path", { d: "M85.542 26.776l-5.792-5.74V1.548C79.75.693 79.05 0 78.187 0h-18.75c-.862 0-1.562.693-1.562 1.548v19.488l-.447.443a30.89 30.89 0 0 0-17.856 0l-.447-.443V1.548c0-.855-.7-1.548-1.562-1.548h-18.75c-.863 0-1.563.693-1.563 1.548v19.488l-5.792 5.74c-.293.29-.458.684-.458 1.095v23.226c-.009 2.557 2.076 4.636 4.656 4.645a4.709 4.709 0 0 0 1.775-.34 4.652 4.652 0 0 0 2.944 3.152v3.381c.014 10.575 6.066 20.23 15.625 24.93v7.587c0 .855.7 1.548 1.563 1.548h21.874C60.3 96 61 95.307 61 94.452v-7.587c9.559-4.7 15.61-14.355 15.625-24.93v-3.381a4.652 4.652 0 0 0 2.944-3.153c2.39.963 5.115-.176 6.087-2.545.23-.559.346-1.156.344-1.76V27.872c0-.41-.165-.804-.458-1.095zM21.938 55.742a1.556 1.556 0 0 1-1.563-1.548V40.258H17.25v10.839c0 .855-.7 1.548-1.562 1.548a1.556 1.556 0 0 1-1.563-1.548V28.512l5.792-5.74c.293-.29.458-.684.458-1.095V3.097H36v18.58c0 .411.165.805.458 1.095l5.792 5.74v11.746c0 .855-.7 1.548-1.562 1.548a1.556 1.556 0 0 1-1.563-1.548v-6.193H36v20.129c0 .855-.7 1.548-1.562 1.548a1.556 1.556 0 0 1-1.563-1.548V40.258H29.75v13.936c0 .855-.7 1.548-1.562 1.548a1.556 1.556 0 0 1-1.563-1.548V40.258H23.5v13.936c0 .855-.7 1.548-1.562 1.548zm35.937 37.161h-18.75v-4.722a27.843 27.843 0 0 0 18.75 0v4.722zM73.5 61.935c-.016 13.676-11.2 24.758-25 24.775-13.8-.017-24.984-11.099-25-24.775v-3.381a4.678 4.678 0 0 0 1.563-.93 4.647 4.647 0 0 0 6.25 0 4.697 4.697 0 0 0 6.593-.3 4.602 4.602 0 0 0 1.219-3.13v-9.576c.5.184 1.029.28 1.563.285 2.588 0 4.687-2.08 4.687-4.645V27.871c0-.41-.165-.804-.458-1.095l-2.812-2.787a27.9 27.9 0 0 1 12.793 0l-2.812 2.787c-.294.29-.46.684-.461 1.095v12.387c0 2.566 2.099 4.645 4.687 4.645a4.671 4.671 0 0 0 1.563-.285v9.576c-.011 2.554 2.069 4.634 4.646 4.645a4.69 4.69 0 0 0 3.166-1.208 4.647 4.647 0 0 0 6.25 0c.455.408.986.723 1.563.929v3.375zm9.375-10.838c0 .855-.7 1.548-1.563 1.548a1.556 1.556 0 0 1-1.562-1.548V40.258h-3.125v13.936c0 .855-.7 1.548-1.563 1.548a1.556 1.556 0 0 1-1.562-1.548V40.258h-3.125v13.936c0 .855-.7 1.548-1.563 1.548a1.556 1.556 0 0 1-1.562-1.548V40.258h-3.125v13.936c0 .855-.7 1.548-1.563 1.548A1.556 1.556 0 0 1 61 54.194v-20.13h-3.125v6.194c0 .855-.7 1.548-1.563 1.548a1.556 1.556 0 0 1-1.562-1.548V28.512l5.792-5.74c.293-.29.458-.684.458-1.095V3.097h15.625v18.58c0 .411.165.805.458 1.095l5.792 5.74v22.585z" }), React.createElement("path", { d: "M49 79.8a4.8 4.8 0 0 1-4.8-4.8H41a8 8 0 0 0 16 0h-3.2a4.8 4.8 0 0 1-4.8 4.8zM45.026 64.923c.154.051.316.078.478.077H53v-3.007h-5.415l2.339-7.043-2.849-.95-2.998 9.021c-.261.788.163 1.64.949 1.902z" })));
});

var _extends$2W = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2V(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMaskOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2V(_ref, ["styles"]);

  return React.createElement("svg", _extends$2W({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("g", { fillRule: "evenodd" }, React.createElement("path", { d: "M72.695 33.85l-3.862-3.826V17.032c0-.57-.466-1.032-1.041-1.032h-12.5c-.576 0-1.042.462-1.042 1.032v12.992l-.298.295a20.594 20.594 0 0 0-11.904 0l-.298-.295V17.032c0-.57-.466-1.032-1.042-1.032h-12.5c-.575 0-1.041.462-1.041 1.032v12.992l-3.862 3.827a1.027 1.027 0 0 0-.305.73v15.484c-.006 1.704 1.384 3.09 3.104 3.096a3.14 3.14 0 0 0 1.184-.227c.267.977 1 1.762 1.962 2.102v2.254c.01 7.05 4.044 13.487 10.417 16.62v5.058c0 .57.466 1.032 1.041 1.032h14.584c.575 0 1.041-.462 1.041-1.032V73.91c6.373-3.133 10.407-9.57 10.417-16.62v-2.254a3.102 3.102 0 0 0 1.962-2.102c1.594.642 3.41-.118 4.059-1.697.152-.372.23-.77.229-1.172V34.58c0-.274-.11-.537-.305-.73zM30.292 53.162a1.037 1.037 0 0 1-1.042-1.032v-9.29h-2.083v7.226c0 .57-.467 1.032-1.042 1.032a1.037 1.037 0 0 1-1.042-1.032V35.008l3.862-3.827c.195-.193.305-.456.305-.73V18.066h10.417v12.387c0 .273.11.536.305.73l3.861 3.826v7.83c0 .57-.466 1.033-1.041 1.033a1.037 1.037 0 0 1-1.042-1.032v-4.13h-2.083v13.42c0 .57-.467 1.032-1.042 1.032a1.037 1.037 0 0 1-1.042-1.032v-9.29H35.5v9.29c0 .57-.466 1.032-1.042 1.032a1.037 1.037 0 0 1-1.041-1.032v-9.29h-2.084v9.29c0 .57-.466 1.032-1.041 1.032zM54.25 77.935h-12.5v-3.148a18.562 18.562 0 0 0 12.5 0v3.148zM64.667 57.29C64.656 66.407 57.2 73.796 48 73.806c-9.2-.01-16.656-7.399-16.667-16.516v-2.254a3.119 3.119 0 0 0 1.042-.62 3.098 3.098 0 0 0 4.167 0 3.131 3.131 0 0 0 4.395-.2c.525-.57.815-1.315.813-2.087v-6.383c.334.122.686.186 1.042.19 1.726 0 3.125-1.387 3.125-3.097V34.58c0-.274-.11-.537-.306-.73l-1.875-1.858a18.6 18.6 0 0 1 8.53 0L50.39 33.85a1.028 1.028 0 0 0-.308.73v8.258c0 1.71 1.4 3.096 3.125 3.096a3.114 3.114 0 0 0 1.042-.19v6.384c-.008 1.703 1.38 3.09 3.098 3.097a3.127 3.127 0 0 0 2.11-.805 3.098 3.098 0 0 0 4.167 0c.303.272.657.482 1.042.619v2.25zm6.25-7.225c0 .57-.467 1.032-1.042 1.032a1.037 1.037 0 0 1-1.042-1.032v-7.226H66.75v9.29c0 .57-.466 1.032-1.042 1.032a1.037 1.037 0 0 1-1.041-1.032v-9.29h-2.084v9.29c0 .57-.466 1.032-1.041 1.032A1.037 1.037 0 0 1 60.5 52.13v-9.29h-2.083v9.29c0 .57-.467 1.032-1.042 1.032a1.037 1.037 0 0 1-1.042-1.032v-13.42H54.25v4.13c0 .57-.466 1.032-1.042 1.032a1.037 1.037 0 0 1-1.041-1.032v-7.831l3.861-3.827c.195-.193.305-.456.305-.73V18.066H66.75v12.387c0 .273.11.536.305.73l3.862 3.826v15.057z" }), React.createElement("path", { d: "M48.333 69.2a3.2 3.2 0 0 1-3.2-3.2H43a5.333 5.333 0 0 0 10.667 0h-2.134a3.2 3.2 0 0 1-3.2 3.2zM45.684 59.282c.103.034.21.052.319.051H51V57.33h-3.61l1.56-4.696-1.9-.633-1.999 6.014a1.003 1.003 0 0 0 .633 1.268z" })));
});

var _extends$2X = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2W(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMinusLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2W(_ref, ["styles"]);

  return React.createElement("svg", _extends$2X({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M0 9.333V6.667h16v2.666z" }));
});

var _extends$2Y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2X(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMinusOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2X(_ref, ["styles"]);

  return React.createElement("svg", _extends$2Y({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "icon-minusoutline-small"), React.createElement("path", { d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-1a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm-4-8h8v2H8v-2z" }));
});

var _extends$2Z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2Y(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMinusSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2Y(_ref, ["styles"]);

  return React.createElement("svg", _extends$2Z({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M4 13.333v-2.666h16v2.666z" }));
});

var _extends$2_ = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2Z(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMinusSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2Z(_ref, ["styles"]);

  return React.createElement("svg", _extends$2_({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M48 16c17.672 0 32 14.326 32 32 0 17.672-14.328 32-32 32-17.674 0-32-14.328-32-32 0-17.674 14.326-32 32-32zm13.363 27.333H35.287c-1.08 0-1.954 2.238-1.954 5.003 0 2.76.874 4.997 1.954 4.997h26.076c1.08 0 1.954-2.237 1.954-4.997 0-2.765-.874-5.003-1.954-5.003" }));
});

var _extends$2$ = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2_(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMobileOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2_(_ref, ["styles"]);

  return React.createElement("svg", _extends$2$({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M12 3H4V2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1zm-8 7h8V4H4v6zm8 4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3h8v3zM11 0H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z", fillRule: "evenodd" }));
});

var _extends$30 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2$(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMobileOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2$(_ref, ["styles"]);

  return React.createElement("svg", _extends$30({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M16 7H8V6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1zm-8 7h8V8H8v6zm8 4a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-3h8v3zM15 4H9a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-3 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z", fillRule: "evenodd" }));
});

var _extends$31 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$30(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMoneyLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$30(_ref, ["styles"]);

  return React.createElement("svg", _extends$31({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M13.073 10a1.17 1.17 0 0 1-1.17 1.171H1.17c-.647 0-1.171-.524-1.171-1.17V3.17C0 2.524.524 2 1.17 2h10.732c.647 0 1.171.524 1.171 1.17V10zm-1.658-.195c.16 0 .292-.131.292-.293V3.66a.294.294 0 0 0-.292-.293H1.659a.293.293 0 0 0-.293.293v5.853c0 .162.131.293.293.293h9.756zm3.414-4.878c.648 0 1.171.523 1.171 1.17v6.83a1.17 1.17 0 0 1-1.17 1.171H4.097a1.17 1.17 0 0 1-1.171-1.17v-1.172h1.366v.683c0 .162.13.293.292.293h9.756c.161 0 .293-.132.293-.293V6.586a.294.294 0 0 0-.293-.293h-.682V4.927h1.17zM6.537 3.95a2.634 2.634 0 1 1 0 5.268 2.634 2.634 0 0 1 0-5.268zm0 3.903a1.269 1.269 0 1 0-.002-2.538 1.269 1.269 0 0 0 .002 2.538z" }));
});

var _extends$32 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$31(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMoneySmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$31(_ref, ["styles"]);

  return React.createElement("svg", _extends$32({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M17.073 14a1.17 1.17 0 0 1-1.17 1.171H5.17c-.647 0-1.171-.524-1.171-1.17V7.17C4 6.524 4.524 6 5.17 6h10.732c.647 0 1.171.524 1.171 1.17V14zm-1.658-.195c.16 0 .292-.131.292-.293V7.66a.294.294 0 0 0-.292-.293H5.659a.293.293 0 0 0-.293.293v5.853c0 .162.131.293.293.293h9.756zm3.414-4.878c.648 0 1.171.523 1.171 1.17v6.83a1.17 1.17 0 0 1-1.17 1.171H8.097a1.17 1.17 0 0 1-1.171-1.17v-1.172h1.366v.683c0 .162.13.293.292.293h9.756c.161 0 .293-.132.293-.293v-5.853a.294.294 0 0 0-.293-.293h-.682V8.927h1.17zm-8.292-.976a2.634 2.634 0 1 1 0 5.268 2.634 2.634 0 0 1 0-5.268zm0 3.903a1.269 1.269 0 1 0-.002-2.538 1.269 1.269 0 0 0 .002 2.538z" }));
});

var _extends$33 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$32(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconNoResults = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$32(_ref, ["styles"]);

  return React.createElement("svg", _extends$33({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("g", { fillRule: "evenodd" }, React.createElement("path", { d: "M49.297 26.159l-4.37 9.512H4.355C1.452 34.989 0 33.403 0 30.915c0-2.489 1.452-4.074 4.355-4.756zM41.42 43l-4.37 9.512H4.355C1.452 51.83 0 50.245 0 47.756 0 45.267 1.452 43.682 4.355 43zM34.021 59.5l-4.37 9.512H4.355C1.452 68.33 0 66.745 0 64.256c0-2.489 1.452-4.074 4.355-4.756zM57.416 59.697l-4.589 9.594h38.766C94.53 68.67 96 67.07 96 64.494s-1.47-4.176-4.407-4.797zM65.035 43l-4.59 9.594h31.148C94.53 51.973 96 50.374 96 47.797S94.53 43.62 91.593 43zM72.705 26l-4.589 9.594h23.477C94.53 34.973 96 33.374 96 30.797S94.53 26.62 91.593 26zM70.184 20.889L42.417 78.817a5.244 5.244 0 0 1-6.906 2.504l-.651-.298a5.244 5.244 0 0 1-2.55-7.036l27.766-57.928a5.244 5.244 0 0 1 6.906-2.504l.652.297a5.244 5.244 0 0 1 2.55 7.037z" })));
});

var _extends$34 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$33(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconOnlineOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$33(_ref, ["styles"]);

  return React.createElement("svg", _extends$34({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M14.988 11.5A19.829 19.829 0 0 0 14.77 9h3.546c.365.767.599 1.61.662 2.5h-3.99zm3.328 3.5H14.77c.119-.781.197-1.618.218-2.5h3.99a6.943 6.943 0 0 1-.663 2.5zm-4.753 3.819c.425-.695.776-1.669 1.026-2.82h3.146a6.999 6.999 0 0 1-4.172 2.82zM12 19c-.679 0-1.277-1.19-1.638-3.001h3.275C13.277 17.811 12.68 19 12 19zm-5.734-3.001H9.41c.25 1.151.6 2.125 1.026 2.82a7 7 0 0 1-4.171-2.82zM5.02 12.5h3.991c.021.882.1 1.719.218 2.5H5.684a6.944 6.944 0 0 1-.663-2.5zM5.684 9H9.23a19.736 19.736 0 0 0-.218 2.5h-3.99c.063-.89.297-1.733.662-2.5zm4.753-3.819C10.011 5.877 9.66 6.85 9.41 8H6.266a6.997 6.997 0 0 1 4.17-2.819zm3.556 7.319c-.018.89-.085 1.733-.188 2.5h-3.61a22.18 22.18 0 0 1-.188-2.5h3.986zm0-1h-3.986c.018-.89.085-1.733.188-2.5h3.61c.104.767.17 1.61.188 2.5zM12 5c.679 0 1.277 1.189 1.637 3h-3.275c.361-1.811.959-3 1.638-3zm5.734 3h-3.145c-.25-1.15-.601-2.123-1.026-2.819A6.998 6.998 0 0 1 17.734 8zm2.241 3.5C19.715 7.316 16.249 4 12 4c-4.25 0-7.715 3.316-7.975 7.5H4v1h.025C4.285 16.684 7.75 20 12 20s7.715-3.316 7.975-7.5H20v-1h-.025z" }));
});

var _extends$35 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$34(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconOnlineOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$34(_ref, ["styles"]);

  return React.createElement("svg", _extends$35({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M10.988 7.5A19.83 19.83 0 0 0 10.77 5h3.546c.365.767.6 1.61.662 2.5h-3.99zm3.328 3.5H10.77c.119-.781.197-1.618.218-2.5h3.99a6.943 6.943 0 0 1-.662 2.5zm-4.753 3.82c.425-.696.777-1.67 1.026-2.82h3.146a6.999 6.999 0 0 1-4.172 2.82zM8 15c-.679 0-1.277-1.19-1.638-3h3.276c-.36 1.81-.959 3-1.638 3zm-5.734-3H5.41c.25 1.15.6 2.124 1.026 2.82A7 7 0 0 1 2.266 12zM1.022 8.5h3.99c.021.882.1 1.719.218 2.5H1.685a6.944 6.944 0 0 1-.663-2.5zM1.685 5H5.23a19.737 19.737 0 0 0-.217 2.5H1.022c.063-.89.297-1.733.663-2.5zm4.752-3.818C6.012 1.877 5.66 2.85 5.41 4H2.266a6.997 6.997 0 0 1 4.17-2.818zM9.993 8.5c-.018.89-.084 1.733-.188 2.5h-3.61a22.18 22.18 0 0 1-.187-2.5h3.985zm0-1H6.008c.018-.89.084-1.733.187-2.5h3.61c.104.767.17 1.61.188 2.5zM8 1c.68 0 1.277 1.189 1.638 3H6.362C6.723 2.19 7.322 1 8 1zm5.734 3H10.59c-.25-1.15-.6-2.123-1.026-2.818A6.998 6.998 0 0 1 13.734 4zm2.241 3.5C15.716 3.316 12.25 0 8 0S.285 3.316.025 7.5H0v1h.025C.285 12.684 3.751 16 8 16c4.25 0 7.716-3.316 7.975-7.5H16v-1h-.025z" }));
});

var _extends$36 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$35(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPageOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$35(_ref, ["styles"]);

  return React.createElement("svg", _extends$36({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M13.5 14.5a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-13A.5.5 0 0 1 3 1h6.5v4h4v9.5zM13.268 4H10.5V1.232L13.268 4zm1.23 0L10.5.002V0H2a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4h-.002z" }));
});

var _extends$37 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$36(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPageOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$36(_ref, ["styles"]);

  return React.createElement("svg", _extends$37({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M18 18.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5H14v4h4v9.5zM17.768 8H15V5.232L17.768 8zm1.23 0L15 4.002V4H6.5a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V8h-.002z" }));
});

var _extends$38 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$37(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPauseFilledLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$37(_ref, ["styles"]);

  return React.createElement("svg", _extends$38({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("circle", { cx: "48", cy: "48", r: "48" }), React.createElement("path", { fill: "#FFF", d: "M28 28h15v40H28zM53 28h15v40H53z" }));
});

var _extends$39 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$38(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPauseFilledSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$38(_ref, ["styles"]);

  return React.createElement("svg", _extends$39({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("circle", { cx: "48", cy: "48", r: "32" }), React.createElement("path", { fill: "#FFF", d: "M34.667 34.667h10v26.667h-10zM51.333 34.667h10v26.667h-10z" }));
});

var _extends$3a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$39(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPauseOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$39(_ref, ["styles"]);

  return React.createElement("svg", _extends$3a({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fillRule: "evenodd", d: "M8.857 16h4.572V0H8.857v16zM10 14.857h2.286V1.143H10v13.714zM2 16h4.571V0H2v16zm1.143-1.143h2.286V1.143H3.143v13.714z" }));
});

var _extends$3b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3a(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPauseOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3a(_ref, ["styles"]);

  return React.createElement("svg", _extends$3b({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { fillRule: "evenodd", d: "M12.857 20h4.572V4h-4.572v16zM14 18.857h2.286V5.143H14v13.714zM6 20h4.571V4H6v16zm1.143-1.143h2.286V5.143H7.143v13.714z" }));
});

var _extends$3c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3b(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$r = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3b(_ref, ["styles"]);

  return React.createElement("svg", _extends$3c({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("rect", { width: "96", height: "96", rx: "48" }), React.createElement("path", { d: "M51 49h20.08c2.16 0 3.92 1.856 3.92 4 0 2.208-1.72 4-3.92 4H46.92c-1.08 0-2.056-.46-2.772-1.168A3.957 3.957 0 0 1 43 53.016v-32.04c0-2.2 1.856-3.976 4-3.976 2.208 0 4 1.72 4 3.98V49z", fill: "#FFF" }));
});

var _extends$3d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3c(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPendingFilledSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3c(_ref, ["styles"]);

  return React.createElement("svg", _extends$3d({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("rect", { x: "15", y: "17", width: "64", height: "64", rx: "32" }), React.createElement("path", { d: "M49 49h10.04c1.08 0 1.96.928 1.96 2 0 1.104-.86 2-1.96 2H46.96A1.974 1.974 0 0 1 45 51.008v-16.02c0-1.1.928-1.988 2-1.988 1.104 0 2 .86 2 1.99V49z", fill: "#FFF" }));
});

var _extends$3e = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3d(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPersonOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3d(_ref, ["styles"]);

  return React.createElement("svg", _extends$3e({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M14.367 14.753V16h-1.43v-1.247c0-2.755-2.195-4.987-4.904-4.987-2.708 0-4.903 2.233-4.903 4.987V16H1.7v-1.247c0-2.527 1.448-4.78 3.644-5.827a4.901 4.901 0 0 1-2.112-4.043C3.232 2.187 5.382 0 8.033 0c2.65 0 4.801 2.187 4.801 4.883a4.9 4.9 0 0 1-2.112 4.043c2.196 1.048 3.645 3.3 3.645 5.827zM4.68 4.875c0 1.864 1.502 3.375 3.353 3.375 1.853 0 3.353-1.51 3.353-3.375 0-1.864-1.5-3.375-3.353-3.375-1.851 0-3.353 1.511-3.353 3.375z" }));
});

var _extends$3f = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3e(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPersonOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3e(_ref, ["styles"]);

  return React.createElement("svg", _extends$3f({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M18.667 18.753V20h-1.43v-1.247c0-2.755-2.195-4.987-4.904-4.987-2.708 0-4.903 2.233-4.903 4.987V20H6v-1.247c0-2.527 1.448-4.78 3.644-5.827a4.901 4.901 0 0 1-2.112-4.043C7.532 6.187 9.682 4 12.333 4c2.65 0 4.801 2.187 4.801 4.883a4.9 4.9 0 0 1-2.112 4.043c2.196 1.048 3.645 3.3 3.645 5.827zM8.98 8.875c0 1.864 1.502 3.375 3.353 3.375 1.853 0 3.353-1.51 3.353-3.375 0-1.864-1.5-3.375-3.353-3.375-1.851 0-3.353 1.511-3.353 3.375z" }));
});

var _extends$3g = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3f(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPhoneHoldLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3f(_ref, ["styles"]);

  return React.createElement("svg", _extends$3g({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7.834.55L9.07.568s.14.12.173.173a.572.572 0 0 1 .12.205c.22.84.296 2.644.011 3.469-.01.053-.085.128-.128.17-.042.043-.246.117-.246.117l-1.138-.007L7.834.55zm.01 14.931l-.026-4.145 1.138.007s.204.077.248.12c.043.043.118.119.13.173.284.818.231 2.621.022 3.458a.554.554 0 0 1-.117.203 1.23 1.23 0 0 1-.17.17l-1.225.014zM6.436 7.843s.005.88.029 1.181c.023.301.08.914.18 1.204.054.162.206.463.325.56.076.055.334.1.334.1l.026 4.145s-.548-.187-.721-.295a3.874 3.874 0 0 1-.637-.552 7.043 7.043 0 0 1-.737-1.014c-.163-.29-.403-.937-.513-1.26a13.57 13.57 0 0 1-.374-1.441 16.953 16.953 0 0 1-.161-1.655c-.012-.247-.039-.977-.039-.977s.017-.73.026-.977c.02-.408.078-1.245.14-1.653.062-.365.24-1.083.356-1.437.105-.321.337-.964.496-1.253.149-.278.51-.77.724-1.004.15-.15.448-.427.63-.544.16-.096.718-.285.718-.285l.027 4.145s-.258.041-.333.094c-.128.107-.276.407-.318.557-.095.289-.145.9-.164 1.201-.02.28-.014 1.16-.014 1.16zm2.767-2.271l1.383-.049.17 4.844-1.384.048-.17-4.843zm2.075-.073l1.384-.048.17 4.843-1.385.049-.169-4.844z" }));
});

var _extends$3h = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3g(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPhoneHoldSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3g(_ref, ["styles"]);

  return React.createElement("svg", _extends$3h({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M11.834 4.55l1.235.018s.14.12.173.173a.572.572 0 0 1 .12.205c.22.84.296 2.644.011 3.469-.01.053-.085.128-.128.17-.042.043-.246.117-.246.117l-1.138-.007-.027-4.145zm.01 14.931l-.026-4.145 1.138.007s.204.077.248.12c.043.043.118.119.13.173.284.818.231 2.621.022 3.458a.554.554 0 0 1-.117.203c-.032.053-.17.17-.17.17l-1.225.014zm-1.408-7.638s.005.88.029 1.181c.023.301.08.914.18 1.204.054.162.206.463.325.56.076.055.334.1.334.1l.026 4.145s-.548-.187-.721-.295a3.874 3.874 0 0 1-.637-.552 7.043 7.043 0 0 1-.737-1.014c-.163-.29-.403-.937-.513-1.26a13.57 13.57 0 0 1-.374-1.441 16.953 16.953 0 0 1-.161-1.655c-.012-.247-.039-.977-.039-.977s.017-.73.026-.977c.02-.408.078-1.245.14-1.653.062-.365.24-1.083.356-1.437.105-.321.337-.964.496-1.253.149-.278.51-.77.724-1.004.15-.15.448-.427.63-.544.16-.096.718-.285.718-.285l.027 4.145s-.258.041-.333.094c-.128.107-.276.407-.318.557-.095.289-.145.9-.164 1.201-.02.28-.014 1.16-.014 1.16zm2.767-2.271l1.383-.049.17 4.844-1.384.048-.17-4.843zm2.075-.073l1.384-.048.17 4.843-1.385.049-.169-4.844z" }));
});

var _extends$3i = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3h(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPhoneLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3h(_ref, ["styles"]);

  return React.createElement("svg", _extends$3i({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M15.658 9.232l-.02 1.284s-.124.146-.18.18a.595.595 0 0 1-.213.124c-.872.23-2.749.308-3.607.012-.056-.01-.133-.088-.178-.133-.044-.044-.121-.256-.121-.256l.008-1.183 4.31-.028zm-15.53.01l4.312-.028-.008 1.184s-.08.213-.124.258c-.045.045-.124.124-.18.135-.85.296-2.726.241-3.596.023a.576.576 0 0 1-.212-.121 1.279 1.279 0 0 1-.177-.178L.129 9.242zm7.945-1.465s-.916.006-1.229.03c-.313.025-.95.085-1.252.187-.168.057-.482.216-.583.34-.056.078-.103.346-.103.346l-4.31.028s.193-.571.306-.75a4.03 4.03 0 0 1 .574-.663c.236-.214.763-.608 1.054-.766.303-.17.975-.42 1.31-.534.37-.125 1.12-.32 1.5-.389.424-.07 1.285-.153 1.72-.167a123.3 123.3 0 0 1 1.017-.04s.76.017 1.016.026c.424.02 1.295.081 1.719.146.38.064 1.126.25 1.494.37.334.11 1.003.35 1.303.516.29.155.8.531 1.045.753.155.155.444.466.565.655.1.167.297.747.297.747l-4.31.027s-.044-.267-.1-.345c-.11-.134-.422-.288-.578-.332-.3-.098-.937-.15-1.25-.17-.29-.02-1.205-.015-1.205-.015z" }));
});

var _extends$3j = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3i(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPhoneRingLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3i(_ref, ["styles"]);

  return React.createElement("svg", _extends$3j({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M.889 1.113L2.027.009s.236-.02.314 0c.079 0 .236.038.294.077.962.562 2.67 2.131 3.16 3.139.04.058.04.193.04.27 0 .078-.118.33-.118.33l-1.04 1.027-3.788-3.74zM14.454 14.66l-3.787-3.74 1.04-1.026s.255-.116.333-.116c.079 0 .216 0 .275.039 1.001.484 2.59 2.17 3.16 3.119.039.058.078.213.078.29.02.078 0 .31 0 .31l-1.099 1.124zM6.241 9.004s.804.794 1.099 1.046c.294.252.902.756 1.256.93.196.097.608.233.804.213.118-.02.393-.213.393-.213l3.787 3.74s-.667.328-.922.387a4.974 4.974 0 0 1-1.08.077c-.392-.02-1.196-.136-1.589-.252-.412-.116-1.217-.484-1.61-.678a17.423 17.423 0 0 1-1.648-.969 21.767 21.767 0 0 1-1.648-1.356c-.236-.213-.923-.852-.923-.852s-.647-.678-.863-.91c-.353-.388-1.06-1.202-1.374-1.628a17.105 17.105 0 0 1-.981-1.627C.746 6.524.372 5.73.255 5.323.137 4.936.02 4.161 0 3.753c0-.27.02-.793.078-1.065.06-.232.393-.91.393-.91l3.788 3.739s-.197.271-.216.387c-.02.213.117.62.216.795.176.348.686.949.942 1.24.235.27 1.04 1.065 1.04 1.065zm4.977-4.17s.413.407.491.504c.118.136.353.426.432.581.078.174.216.446.275.717.039.213.058.484.058.64 0 .174-.058.697-.058.697l-.668-.485s.02-.348 0-.465c0-.116-.039-.29-.078-.426a2.245 2.245 0 0 0-.236-.484c-.078-.116-.255-.33-.333-.426-.079-.097-.373-.407-.373-.407s-.295-.271-.412-.368a6.382 6.382 0 0 0-.432-.33c-.118-.058-.294-.174-.49-.232-.138-.039-.315-.058-.432-.078H8.49L8 3.614s.53-.058.706-.058c.177 0 .452.019.648.058.294.038.57.174.726.27.157.098.452.31.589.427.137.116.55.523.55.523zm.89-1.778s.392.407.49.504c.118.136.353.426.432.581.078.175.216.446.274.717.04.213.06.484.06.64 0 .174-.06.697-.06.697l-.667-.484s.02-.35 0-.465c0-.117-.039-.291-.078-.427a2.245 2.245 0 0 0-.236-.484c-.078-.116-.255-.33-.333-.426a13.014 13.014 0 0 0-.373-.407s-.295-.271-.412-.368a6.382 6.382 0 0 0-.432-.33c-.118-.058-.295-.174-.49-.232-.138-.039-.315-.058-.432-.077H9.38l-.491-.66s.53-.057.706-.057c.177 0 .452.02.648.058.294.039.57.174.726.271.157.097.451.31.589.426.137.117.55.523.55.523zM13.41 1.98s.351.33.418.43c.1.115.302.363.368.495.067.149.185.38.235.611.033.182.05.413.05.546 0 .148-.05.594-.05.594l-.57-.413s.018-.297 0-.396c0-.1-.033-.248-.066-.364a1.914 1.914 0 0 0-.2-.413c-.068-.099-.218-.28-.285-.363a11.097 11.097 0 0 0-.318-.347s-.251-.231-.352-.314a5.442 5.442 0 0 0-.368-.28c-.1-.05-.25-.15-.418-.199-.117-.033-.268-.05-.368-.066h-.402l-.418-.562s.451-.05.602-.05c.15 0 .385.017.552.05.251.033.486.15.62.232.133.082.384.264.501.363.118.1.469.446.469.446z" }));
});

var _extends$3k = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3j(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPhoneRingSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3j(_ref, ["styles"]);

  return React.createElement("svg", _extends$3k({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M4.889 5.113l1.138-1.104s.236-.02.314 0c.079 0 .236.038.294.077.962.562 2.67 2.131 3.16 3.139.04.058.04.193.04.27 0 .078-.118.33-.118.33l-1.04 1.027-3.788-3.74zM18.454 18.66l-3.787-3.74 1.04-1.026s.255-.116.333-.116c.079 0 .216 0 .275.039 1.001.484 2.59 2.17 3.16 3.119.039.058.078.213.078.29.02.078 0 .31 0 .31l-1.099 1.124zm-8.213-5.656s.804.794 1.099 1.046c.294.252.902.756 1.256.93.196.097.608.233.804.213.118-.02.393-.213.393-.213l3.787 3.74s-.667.328-.922.387a4.974 4.974 0 0 1-1.08.077c-.392-.02-1.196-.136-1.589-.252-.412-.116-1.217-.484-1.61-.678a17.423 17.423 0 0 1-1.648-.969 21.767 21.767 0 0 1-1.648-1.356c-.236-.213-.923-.852-.923-.852s-.647-.678-.863-.91c-.353-.388-1.06-1.202-1.374-1.628a17.105 17.105 0 0 1-.981-1.627c-.196-.388-.57-1.182-.687-1.589-.118-.387-.235-1.162-.255-1.57 0-.27.02-.793.078-1.065.06-.232.393-.91.393-.91l3.788 3.739s-.197.271-.216.387c-.02.213.117.62.216.795.176.348.686.949.942 1.24.235.27 1.04 1.065 1.04 1.065zm4.977-4.17s.413.407.491.504c.118.136.353.426.432.581.078.174.216.446.275.717.039.213.058.484.058.64 0 .174-.058.697-.058.697l-.668-.485s.02-.348 0-.465c0-.116-.039-.29-.078-.426a2.245 2.245 0 0 0-.236-.484c-.078-.116-.255-.33-.333-.426-.079-.097-.373-.407-.373-.407s-.295-.271-.412-.368a6.382 6.382 0 0 0-.432-.33c-.118-.058-.294-.174-.49-.232-.138-.039-.315-.058-.432-.078h-.471L12 7.614s.53-.058.706-.058c.177 0 .452.019.648.058.294.038.57.174.726.27.157.098.452.31.589.427.137.116.55.523.55.523zm.89-1.778s.392.407.49.504c.118.136.353.426.432.581.078.175.216.446.274.717.04.213.06.484.06.64 0 .174-.06.697-.06.697l-.667-.484s.02-.35 0-.465c0-.117-.039-.291-.078-.427a2.245 2.245 0 0 0-.236-.484c-.078-.116-.255-.33-.333-.426a13.014 13.014 0 0 0-.373-.407s-.295-.271-.412-.368a6.382 6.382 0 0 0-.432-.33c-.118-.058-.295-.174-.49-.232-.138-.039-.315-.058-.432-.077h-.471l-.491-.66s.53-.057.706-.057c.177 0 .452.02.648.058.294.039.57.174.726.271.157.097.451.31.589.426.137.117.55.523.55.523zM17.41 5.98s.351.33.418.43c.1.115.302.363.368.495.067.149.185.38.235.611.033.182.05.413.05.546 0 .148-.05.594-.05.594l-.57-.413s.018-.297 0-.396c0-.1-.033-.248-.066-.364a1.914 1.914 0 0 0-.2-.413c-.068-.099-.218-.28-.285-.363a11.097 11.097 0 0 0-.318-.347s-.251-.231-.352-.314a5.442 5.442 0 0 0-.368-.28c-.1-.05-.25-.15-.418-.199-.117-.033-.268-.05-.368-.066h-.402l-.418-.562s.451-.05.602-.05c.15 0 .385.017.552.05.251.033.486.15.62.232.133.082.384.264.501.363.118.1.469.446.469.446z" }));
});

var _extends$3l = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3k(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPhoneSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3k(_ref, ["styles"]);

  return React.createElement("svg", _extends$3l({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M19.658 13.232l-.02 1.284s-.124.146-.18.18a.595.595 0 0 1-.213.124c-.872.23-2.749.308-3.607.012-.056-.01-.133-.088-.178-.133-.044-.044-.121-.256-.121-.256l.008-1.183 4.31-.028zm-15.53.01l4.312-.028-.008 1.184s-.08.213-.124.258c-.045.045-.124.124-.18.135-.85.296-2.726.241-3.596.023a.576.576 0 0 1-.212-.121 1.279 1.279 0 0 1-.177-.178l-.014-1.273zm7.945-1.465s-.916.006-1.229.03c-.313.025-.95.085-1.252.187-.168.057-.482.216-.583.34-.056.078-.103.346-.103.346l-4.31.028s.193-.571.306-.75a4.03 4.03 0 0 1 .574-.663c.236-.214.763-.608 1.054-.766.303-.17.975-.42 1.31-.534.37-.125 1.12-.32 1.5-.389.424-.07 1.285-.153 1.72-.167a123.3 123.3 0 0 1 1.017-.04s.76.017 1.016.026c.424.02 1.295.081 1.719.146.38.064 1.126.25 1.494.37.334.11 1.003.35 1.303.516.29.155.8.531 1.045.753.155.155.444.466.565.655.1.167.297.747.297.747l-4.31.027s-.044-.267-.1-.345c-.11-.134-.422-.288-.578-.332-.3-.098-.937-.15-1.25-.17-.29-.02-1.205-.015-1.205-.015z" }));
});

var _extends$3m = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3l(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPlusLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3l(_ref, ["styles"]);

  return React.createElement("svg", _extends$3m({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M9.333 6.667V0H6.667v6.667H0v2.666h6.667V16h2.666V9.333H16V6.667z" }));
});

var _extends$3n = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3m(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPlusOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3m(_ref, ["styles"]);

  return React.createElement("svg", _extends$3n({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M11 11V8h2v3h3v2h-3v3h-2v-3H8v-2h3zm1 9a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-1a7 7 0 1 0 0-14 7 7 0 0 0 0 14z" }));
});

var _extends$3o = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3n(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPlusSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3n(_ref, ["styles"]);

  return React.createElement("svg", _extends$3o({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13.333 10.667V4h-2.666v6.667H4v2.666h6.667V20h2.666v-6.667H20v-2.666z" }));
});

var _extends$3p = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3o(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPlusSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3o(_ref, ["styles"]);

  return React.createElement("svg", _extends$3p({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon plus"), React.createElement("path", { d: "M18 14V8h-2v6h-6v2h6v6h2v-6h6v-2z" }));
});

var _extends$3q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3p(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconProspectLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3p(_ref, ["styles"]);

  return React.createElement("svg", _extends$3q({ height: "16", viewBox: "0 0 16 16", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fillRule: "evenodd", d: "M15.467 12.8h-1.6v-1.6a.534.534 0 1 0-1.067 0v1.6h-1.6a.534.534 0 0 0 0 1.067h1.6v1.6a.534.534 0 0 0 1.067 0v-1.6h1.6a.533.533 0 1 0 0-1.068M2.667 4.8a3.734 3.734 0 1 1 7.467 0 3.734 3.734 0 0 1-7.467 0m6.081 4.185a4.8 4.8 0 1 0-4.697 0A6.397 6.397 0 0 0 0 14.933V16h1.067v-1.067A5.333 5.333 0 0 1 6.4 9.6c1.436 0 2.737.57 3.696 1.493.231-.27.495-.51.787-.715a6.414 6.414 0 0 0-2.135-1.393" }));
});

var _extends$3r = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3q(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconProspectSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3q(_ref, ["styles"]);

  return React.createElement("svg", _extends$3r({ height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fillRule: "evenodd", d: "M19.467 16.8h-1.6v-1.6a.534.534 0 1 0-1.067 0v1.6h-1.6a.534.534 0 0 0 0 1.067h1.6v1.6a.534.534 0 0 0 1.067 0v-1.6h1.6a.533.533 0 1 0 0-1.068M6.667 8.8a3.734 3.734 0 1 1 7.467 0 3.734 3.734 0 0 1-7.467 0m6.081 4.185a4.8 4.8 0 1 0-4.697 0A6.397 6.397 0 0 0 4 18.933V20h1.067v-1.067A5.333 5.333 0 0 1 10.4 13.6c1.436 0 2.737.57 3.696 1.493.231-.27.495-.51.787-.715a6.414 6.414 0 0 0-2.135-1.393" }));
});

var _extends$3s = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3r(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconQuestionSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3r(_ref, ["styles"]);

  return React.createElement("svg", _extends$3s({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon question"), React.createElement("path", { d: "M16.39 2c5.472 0 9.133 3.503 9.133 8.64 0 4.02-2.874 6.886-7.362 7.443v2.23h-4.763v-6.21h2.992c2.44 0 4.093-1.394 4.093-3.464 0-2.35-1.653-3.982-4.094-3.982-2.64 0-4.33 1.83-4.804 4.578l-4.92-.995C6.98 5.863 10.837 2 16.388 2zm-.67 21.338a3.066 3.066 0 0 1 3.11 3.065c0 1.712-1.298 3.026-3.11 3.026s-3.11-1.315-3.11-3.027c0-1.632 1.3-3.065 3.11-3.065z" }));
});

var _extends$3t = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3s(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconQuestionSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3s(_ref, ["styles"]);

  return React.createElement("svg", _extends$3t({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon question"), React.createElement("path", { d: "M17.293 6c4.104 0 6.85 2.627 6.85 6.48 0 3.015-2.155 5.164-5.52 5.582v1.672h-3.574v-4.658h2.243c1.83 0 3.07-1.045 3.07-2.598 0-1.762-1.24-2.986-3.07-2.986-1.978 0-3.248 1.373-3.602 3.434L10 12.18C10.236 8.896 13.13 6 17.293 6zm-.502 16.003a2.3 2.3 0 0 1 2.334 2.3c0 1.283-.974 2.268-2.333 2.268s-2.332-.984-2.332-2.268c0-1.224.974-2.3 2.333-2.3z" }));
});

var _extends$3u = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3t(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var RadioIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3t(_ref, ["styles"]);

  return React.createElement("svg", _extends$3u({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("circle", { cx: "48", cy: "48", r: "35" }));
});

var _extends$3v = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3u(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconRetrieveLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3u(_ref, ["styles"]);

  return React.createElement("svg", _extends$3v({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M9 8V4L0 8.5 9 13V9h7V8H9z" }));
});

var _extends$3w = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3v(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconRetrieveSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3v(_ref, ["styles"]);

  return React.createElement("svg", _extends$3w({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13 12V8l-9 4.5 9 4.5v-4h7v-1h-7z" }));
});

var _extends$3x = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3w(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconSettingsOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3w(_ref, ["styles"]);

  return React.createElement("svg", _extends$3x({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M91.98 55.671c1.698 1.843 4.826 4.28 3.828 6.544l-3.982 9.596c-.96 2.332-4.893 1.842-7.388 1.919l-4.24.134a41.488 41.488 0 0 1-6.41 6.381l-.143 4.241c-.087 2.515.393 6.43-1.92 7.389l-9.593 3.944c-2.313.96-4.73-2.12-6.563-3.838l-3.09-2.88a40.771 40.771 0 0 1-9.037 0l-3.109 2.88c-1.823 1.679-4.26 4.797-6.562 3.838l-9.595-3.982c-2.331-.96-1.842-4.894-1.919-7.389l-.124-4.231a41.488 41.488 0 0 1-6.39-6.41l-4.231-.144c-2.504-.087-6.428.393-7.388-1.92L.181 62.149c-.96-2.312 2.13-4.74 3.838-6.563l2.878-3.09a40.776 40.776 0 0 1 0-9.058l-2.878-3.1C2.339 38.516-.78 36.078.18 33.776l3.981-9.596c.96-2.332 4.884-1.842 7.379-1.919l4.24-.134a41.488 41.488 0 0 1 6.4-6.381l.153-4.242c.096-2.494-.393-6.419 1.92-7.378L33.846.18c2.313-.96 4.75 2.13 6.573 3.838l3.08 2.879a40.762 40.762 0 0 1 9.056 0l3.1-2.879c1.822-1.68 4.269-4.798 6.572-3.838l9.594 3.982c2.331.96 1.842 4.884 1.919 7.379l.134 4.25a41.488 41.488 0 0 1 6.37 6.391l4.251.154c2.504.086 6.419-.394 7.378 1.919l3.943 9.595c.96 2.313-2.12 4.74-3.837 6.573l-2.879 3.09a40.785 40.785 0 0 1 0 9.048l2.879 3.11zm-6.208-1.1l-.428-1.495c.288-2.585.288-7.515 0-10.1l.428-1.51c1.476-1.576 6.198-4.583 5.374-6.57l-3.39-8.249c-.824-1.987-6.264-.655-8.416-.73L78 25.372c-1.62-2.024-5.194-5.327-7.214-6.953l-.575-1.245c0-1.174 1.152-7.96-.852-8.784l-8.246-3.423c-1.979-.825-4.995 3.761-6.561 5.205l-1.037.656c-2.586-.289-8.185-.289-10.771 0l-1.288-.656C39.89 8.703 37.036 4.175 35.048 5l-8.246 3.39c-1.988.825-.807 6.07-.89 8.215l-.173 1.2c-2.028 1.623-6.43 5.957-8.059 7.98l-1.045.066c-2.144.066-7.494-.855-8.319 1.149l-3.422 8.248c-.825 1.98 3.833 4.576 5.276 6.143l.807 1.585c-.29 2.588-.29 7.512 0 10.1l-.807 1.421c-1.468 1.567-6.068 4.707-5.243 6.695l3.389 8.248c.825 1.988 6.142.523 8.294.597l1.848.386c1.625 2.032 4.928 5.52 6.954 7.151l.434 1.734c.066 2.144-.107 7.692.956 8.302l8.246 3.423c1.979.825 4.767-3.807 6.334-5.25l1.362-.568c2.58.288 7.684.288 10.265 0l1.468.568c1.575 1.476 4.649 6.042 6.636 5.217l8.246-3.39c1.988-.825.58-6.108.654-8.27l.578-1.603c2.03-1.623 5.386-5.29 7.017-7.314l1.682-.328c2.144-.066 7.885 1.056 8.71-.949l3.178-7.954c.858-1.946-3.946-5.037-5.406-6.62z" }), React.createElement("path", { d: "M48 70c-12.15 0-22-9.85-22-22s9.85-22 22-22 22 9.85 22 22-9.85 22-22 22zm0-5c9.389 0 17-7.611 17-17s-7.611-17-17-17-17 7.611-17 17 7.611 17 17 17z" }));
});

var _extends$3y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3x(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconSettingsOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3x(_ref, ["styles"]);

  return React.createElement("svg", _extends$3y({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M77.32 53.114c1.132 1.228 3.217 2.853 2.552 4.363l-2.655 6.397c-.64 1.554-3.262 1.228-4.925 1.28l-2.827.089a27.659 27.659 0 0 1-4.273 4.254l-.095 2.827c-.058 1.676.262 4.286-1.28 4.926l-6.396 2.63c-1.541.639-3.153-1.415-4.375-2.56l-2.06-1.919a27.18 27.18 0 0 1-6.025 0l-2.072 1.92c-1.215 1.119-2.84 3.198-4.375 2.558l-6.396-2.655c-1.555-.64-1.229-3.262-1.28-4.925l-.083-2.821a27.659 27.659 0 0 1-4.26-4.273l-2.82-.096c-1.67-.058-4.286.262-4.926-1.28l-2.628-6.397c-.64-1.541 1.42-3.16 2.558-4.375l1.919-2.06a27.184 27.184 0 0 1 0-6.039l-1.919-2.066c-1.12-1.216-3.198-2.84-2.558-4.376l2.654-6.397c.64-1.554 3.256-1.228 4.919-1.279l2.827-.09a27.659 27.659 0 0 1 4.266-4.254l.102-2.827c.064-1.663-.262-4.28 1.28-4.92l6.396-2.628c1.541-.64 3.166 1.42 4.381 2.558L45 20.6a27.175 27.175 0 0 1 6.038 0l2.066-1.92c1.215-1.12 2.846-3.198 4.381-2.558l6.396 2.654c1.555.64 1.228 3.256 1.28 4.92l.089 2.833a27.659 27.659 0 0 1 4.247 4.26l2.834.103c1.67.058 4.279-.262 4.918 1.28l2.63 6.397c.639 1.541-1.414 3.16-2.56 4.381l-1.918 2.06a27.19 27.19 0 0 1 0 6.033l1.919 2.072zm-4.139-.733l-.285-.997c.192-1.723.192-5.01 0-6.733l.285-1.008c.984-1.05 4.132-3.054 3.583-4.38l-2.26-5.498c-.55-1.325-4.176-.437-5.61-.487L68 32.915c-1.08-1.35-3.463-3.552-4.81-4.636l-.383-.83c0-.782.768-5.306-.567-5.856l-5.498-2.282c-1.32-.55-3.33 2.508-4.374 3.47l-.691.438c-1.725-.193-5.457-.193-7.181 0l-.858-.438c-1.045-.979-2.948-3.998-4.273-3.448l-5.497 2.26c-1.325.55-.538 4.047-.593 5.477l-.116.8c-1.351 1.082-4.287 3.971-5.372 5.32l-.697.044c-1.43.044-4.996-.57-5.546.766l-2.281 5.499c-.55 1.32 2.555 3.05 3.517 4.095l.538 1.057c-.193 1.725-.193 5.008 0 6.733l-.538.948c-.979 1.044-4.045 3.138-3.495 4.463l2.259 5.499c.55 1.325 4.095.348 5.53.397l1.232.258c1.083 1.354 3.285 3.68 4.635 4.767l.29 1.156c.044 1.43-.072 5.128.637 5.535l5.497 2.282c1.32.55 3.179-2.538 4.223-3.5l.908-.379c1.72.192 5.122.192 6.843 0l.98.378c1.05.985 3.098 4.029 4.423 3.479l5.498-2.26c1.324-.55.386-4.072.436-5.513l.385-1.07c1.353-1.081 3.59-3.526 4.677-4.875l1.122-.22c1.43-.043 5.257.705 5.807-.631l2.119-5.303c.571-1.298-2.632-3.358-3.605-4.414z" }), React.createElement("path", { d: "M48 62.667c-8.1 0-14.667-6.567-14.667-14.667S39.9 33.333 48 33.333 62.667 39.9 62.667 48 56.1 62.667 48 62.667zm0-3.334c6.26 0 11.333-5.074 11.333-11.333 0-6.26-5.074-11.333-11.333-11.333-6.26 0-11.333 5.074-11.333 11.333 0 6.26 5.074 11.333 11.333 11.333z" }));
});

var _extends$3z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3y(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconSheetLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3y(_ref, ["styles"]);

  return React.createElement("svg", _extends$3z({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fillRule: "evenodd", d: "M14.4 14.933h-1.6V12.8h2.133v1.6a.533.533 0 0 1-.533.533zm-5.867 0h3.2V12.8h-3.2v2.133zm-4.266 0h3.2V12.8h-3.2v2.133zm-2.667 0a.533.533 0 0 1-.533-.533v-1.6H3.2v2.133H1.6zm-.533-3.2H3.2v-3.2H1.067v3.2zm0-4.267H3.2v-3.2H1.067v3.2zm0-5.867c0-.294.239-.532.533-.532h1.6V3.2H1.067V1.6zm3.2 10.134h3.2v-3.2h-3.2v3.2zm0-4.267h3.2v-3.2h-3.2v3.2zm0-4.266h3.2V1.067h-3.2V3.2zm4.266 8.533h3.2v-3.2h-3.2v3.2zm0-4.267h3.2v-3.2h-3.2v3.2zm0-4.266h3.2V1.067h-3.2V3.2zm4.267 8.533h2.133v-3.2H12.8v3.2zm0-4.267h2.133v-3.2H12.8v3.2zm0-6.4h1.6c.294 0 .533.24.533.533V3.2H12.8V1.067zM1.067 0C.477 0 0 .477 0 1.067v13.866C0 15.522.477 16 1.067 16h13.866c.59 0 1.067-.478 1.067-1.067V1.067C16 .477 15.522 0 14.933 0H1.067z" }));
});

var _extends$3A = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3z(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconSheetSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3z(_ref, ["styles"]);

  return React.createElement("svg", _extends$3A({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { fillRule: "evenodd", d: "M18.4 18.933h-1.6V16.8h2.133v1.6a.533.533 0 0 1-.533.533zm-5.867 0h3.2V16.8h-3.2v2.133zm-4.266 0h3.2V16.8h-3.2v2.133zm-2.667 0a.533.533 0 0 1-.533-.533v-1.6H7.2v2.133H5.6zm-.533-3.2H7.2v-3.2H5.067v3.2zm0-4.267H7.2v-3.2H5.067v3.2zm0-5.867c0-.294.239-.532.533-.532h1.6V7.2H5.067V5.6zm3.2 10.134h3.2v-3.2h-3.2v3.2zm0-4.267h3.2v-3.2h-3.2v3.2zm0-4.266h3.2V5.067h-3.2V7.2zm4.266 8.533h3.2v-3.2h-3.2v3.2zm0-4.267h3.2v-3.2h-3.2v3.2zm0-4.266h3.2V5.067h-3.2V7.2zm4.267 8.533h2.133v-3.2H16.8v3.2zm0-4.267h2.133v-3.2H16.8v3.2zm0-6.4h1.6c.294 0 .533.24.533.533V7.2H16.8V5.067zM5.067 4C4.477 4 4 4.477 4 5.067v13.866C4 19.522 4.477 20 5.067 20h13.866c.59 0 1.067-.478 1.067-1.067V5.067C20 4.477 19.522 4 18.933 4H5.067z" }));
});

var _extends$3B = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3A(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconSliderOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3A(_ref, ["styles"]);

  return React.createElement("svg", _extends$3B({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M89.6 76.603a3.2 3.2 0 0 1-3.2 3.2H73.6a3.2 3.2 0 0 1-3.2-3.2v-12.8a3.2 3.2 0 0 1 3.2-3.203h12.8a3.2 3.2 0 0 1 3.2 3.203zm0-22.403h-6.4V3h-6.4v51.2h-6.4c-3.533 0-6.4 2.87-6.4 6.4v19.203c0 3.533 2.867 6.4 6.4 6.4h6.4V92.6h6.4v-6.397h6.4c3.533 0 6.4-2.867 6.4-6.4V60.6c0-3.53-2.867-6.4-6.4-6.4zm-64 9.603a3.2 3.2 0 0 1-3.2 3.2H9.6a3.2 3.2 0 0 1-3.2-3.2V51a3.196 3.196 0 0 1 3.2-3.197h12.8c1.77 0 3.2 1.43 3.2 3.197zm0-22.4h-6.4V3h-6.4v38.403H6.4a6.402 6.402 0 0 0-6.4 6.4v19.2c0 3.533 2.867 6.4 6.4 6.4h6.4V92.6h6.4V73.403h6.4c3.533 0 6.4-2.867 6.4-6.4v-19.2c0-3.533-2.867-6.4-6.4-6.4zm32-9.6A3.196 3.196 0 0 1 54.4 35H41.6c-1.77 0-3.2-1.43-3.2-3.197V19a3.196 3.196 0 0 1 3.2-3.197h12.8c1.77 0 3.2 1.43 3.2 3.197zm6.4-16c0-3.533-2.867-6.4-6.4-6.4h-6.4V3h-6.4v6.403h-6.4a6.402 6.402 0 0 0-6.4 6.4V35a6.403 6.403 0 0 0 6.4 6.403h6.4V92.6h6.4V41.403h6.4c3.533 0 6.4-2.867 6.4-6.403z" }));
});

var _extends$3C = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3B(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconSliderOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3B(_ref, ["styles"]);

  return React.createElement("svg", _extends$3C({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M75.733 67.069a2.133 2.133 0 0 1-2.133 2.133h-8.533a2.133 2.133 0 0 1-2.134-2.133v-8.534c0-1.18.954-2.135 2.134-2.135H73.6c1.18 0 2.133.956 2.133 2.135zm0-14.936h-4.266V18H67.2v34.133h-4.267a4.27 4.27 0 0 0-4.266 4.267v12.802a4.268 4.268 0 0 0 4.266 4.267H67.2v4.264h4.267V73.47h4.266A4.268 4.268 0 0 0 80 69.202V56.4a4.27 4.27 0 0 0-4.267-4.267zm-42.666 6.402a2.133 2.133 0 0 1-2.134 2.134H22.4a2.133 2.133 0 0 1-2.133-2.134V50a2.13 2.13 0 0 1 2.133-2.131h8.533A2.13 2.13 0 0 1 33.067 50zm0-14.933H28.8V18h-4.267v25.602h-4.266A4.268 4.268 0 0 0 16 47.87v12.8a4.268 4.268 0 0 0 4.267 4.266h4.266v12.798H28.8V64.935h4.267a4.268 4.268 0 0 0 4.266-4.266v-12.8a4.268 4.268 0 0 0-4.266-4.267zm21.333-6.4a2.13 2.13 0 0 1-2.133 2.131h-8.534a2.13 2.13 0 0 1-2.133-2.13v-8.536a2.13 2.13 0 0 1 2.133-2.132h8.534a2.13 2.13 0 0 1 2.133 2.132zm4.267-10.667A4.268 4.268 0 0 0 54.4 22.27h-4.267V18h-4.266v4.269H41.6a4.268 4.268 0 0 0-4.267 4.266v12.798a4.269 4.269 0 0 0 4.267 4.27h4.267v34.13h4.266v-34.13H54.4a4.269 4.269 0 0 0 4.267-4.27z" }));
});

var _extends$3D = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3C(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconStatementOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3C(_ref, ["styles"]);

  return React.createElement("svg", _extends$3D({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13 96h71V0H13z" }), React.createElement("path", { fill: "#FEFEFE", d: "M18 90h61V6H18z" }), React.createElement("path", { fill: "#4A4A4A", d: "M24 76h24v-4H24z" }), React.createElement("path", { fill: "#B2B2B1", d: "M24 63h49v-4H24zM24 50h49v-4H24zM24 37h49v-4H24zM24 24h49v-4H24z" }));
});

var _extends$3E = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3D(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconStatementOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3D(_ref, ["styles"]);

  return React.createElement("svg", _extends$3E({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M24 80h47.333V16H24z" }), React.createElement("path", { fill: "#FEFEFE", d: "M27.333 76H68V20H27.333z" }), React.createElement("path", { fill: "#4A4A4A", d: "M31.333 66.667h16V64h-16z" }), React.createElement("path", { fill: "#B2B2B1", d: "M31.333 58H64v-2.667H31.333zM31.333 49.333H64v-2.666H31.333zM31.333 40.667H64V38H31.333zM31.333 32H64v-2.667H31.333z" }));
});

var _extends$3F = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3E(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconStatusOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3E(_ref, ["styles"]);

  return React.createElement("svg", _extends$3F({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7.902 14.507l1.447 1.334-2.126.669.68-2.003zm7.94-7.636l1.64 1.559-7.435 6.965-1.686-1.6 7.48-6.924zm1.774-1.81a.564.564 0 0 1 .388-.148c.147 0 .37.146.472.242l.848.82c.214.2.214.525 0 .724l-1.21 1.126-1.708-1.637 1.21-1.127zM7.188 13.594l-.006.03-1.03 3.252.756.63 3.308-1.086.042.008h.162l8.005-7.446 1.641-1.562c.642-.597.541-1.756-.1-2.354l-.714-.633c-.619-.577-1.708-.577-2.327 0l-1.538 1.682-8.199 7.3v.18zm12.247-4.58v9.987H4.562V5.014h9.569v-.999H4.562c-.587 0-1.062.448-1.062 1V19c0 .552.475.999 1.062.999h14.873c.587 0 1.063-.447 1.063-1V9.015h-1.063z" }));
});

var _extends$3G = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3F(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTickCircleOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3F(_ref, ["styles"]);

  return React.createElement("svg", _extends$3G({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-1a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm-1.023-3a.85.85 0 0 1-.666-.316L8.17 12.986a.77.77 0 0 1 .161-1.115.86.86 0 0 1 1.17.155l1.41 1.774 3.544-5.425a.861.861 0 0 1 1.15-.255.775.775 0 0 1 .268 1.098l-4.186 6.406a.84.84 0 0 1-.672.374c-.012.002-.025.002-.038.002z" }));
});

var _extends$3H = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3G(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTickCircularFilledSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3G(_ref, ["styles"]);

  return React.createElement("svg", _extends$3H({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 80c-17.672 0-32-14.324-32-32 0-17.672 14.328-32 32-32s32 14.328 32 32c0 17.676-14.328 32-32 32zm-4.092-16c.052 0 .104 0 .152-.004 1.104-.052 2.108-.604 2.688-1.5l16.744-25.624c.98-1.496.496-3.46-1.072-4.392-1.564-.928-3.628-.468-4.6 1.02L43.644 55.2l-5.64-7.096c-1.112-1.404-3.204-1.688-4.68-.62-1.472 1.064-1.76 3.06-.644 4.46l8.564 10.796c.632.796 1.624 1.26 2.664 1.26z" }));
});

var _extends$3I = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3H(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTickInterfaceOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3H(_ref, ["styles"]);

  return React.createElement("svg", _extends$3I({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15.71 5.032l-7.473 7.8-1.404 1.466a.98.98 0 0 1-.702.302.979.979 0 0 1-.701-.302l-1.404-1.465-3.737-3.9a1.07 1.07 0 0 1 0-1.466l1.404-1.465a.978.978 0 0 1 .702-.302.98.98 0 0 1 .702.302L6.13 9.18l6.772-7.079a.98.98 0 0 1 .702-.301.98.98 0 0 1 .702.301l1.404 1.466a1.07 1.07 0 0 1 0 1.465" }));
});

var _extends$3J = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3I(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTickInterfaceOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3I(_ref, ["styles"]);

  return React.createElement("svg", _extends$3J({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19.71 9.232l-7.473 7.8-1.404 1.466a.98.98 0 0 1-.702.302.979.979 0 0 1-.701-.302l-1.404-1.465-3.737-3.9a1.07 1.07 0 0 1 0-1.466l1.404-1.465a.978.978 0 0 1 .702-.302.98.98 0 0 1 .702.302l3.034 3.178 6.772-7.079A.98.98 0 0 1 17.605 6a.98.98 0 0 1 .702.301l1.404 1.466a1.07 1.07 0 0 1 0 1.465" }));
});

var _extends$3K = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3J(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTickOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3J(_ref, ["styles"]);

  return React.createElement("svg", _extends$3K({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fillRule: "evenodd", d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm-1.023-3a.85.85 0 0 1-.666-.316L4.17 8.986a.77.77 0 0 1 .161-1.115.86.86 0 0 1 1.17.155L6.911 9.8l3.544-5.425a.861.861 0 0 1 1.15-.255.775.775 0 0 1 .268 1.098l-4.186 6.406a.84.84 0 0 1-.672.374C7.003 12 6.99 12 6.977 12z" }));
});

var _extends$3L = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3K(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTickOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3K(_ref, ["styles"]);

  return React.createElement("svg", _extends$3L({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "icon-tickoutline-small"), React.createElement("path", { d: "M7.113 11.314L5 13.457 9.48 18 19 8.12 16.865 6l-7.408 7.69-2.343-2.376zm9.03-6.008c.388-.4 1.03-.41 1.425-.016l2.137 2.118a1 1 0 0 1 .016 1.404l-9.52 9.882a1.001 1.001 0 0 1-1.433.008l-4.48-4.544a1.001 1.001 0 0 1 0-1.404l2.114-2.143a1.004 1.004 0 0 1 1.426 0l1.62 1.646 6.698-6.95z" }));
});

var _extends$3M = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3L(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTimelineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3L(_ref, ["styles"]);

  return React.createElement("svg", _extends$3M({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7.733 12.292a4.334 4.334 0 0 1 0-8.584V0h1.22v3.71a4.334 4.334 0 0 1 0 8.58V16h-1.22v-3.708z" }));
});

var _extends$3N = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3M(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTimelineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3M(_ref, ["styles"]);

  return React.createElement("svg", _extends$3N({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M11.733 16.292a4.334 4.334 0 0 1 0-8.584V4h1.22v3.71a4.334 4.334 0 0 1 0 8.58V20h-1.22v-3.708z" }));
});

var _extends$3O = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3N(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTimelineStartLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3N(_ref, ["styles"]);

  return React.createElement("svg", _extends$3O({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7.733 8.625a4.334 4.334 0 1 1 1.22-.002V16h-1.22V8.625z" }));
});

var _extends$3P = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3O(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTimelineStartSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3O(_ref, ["styles"]);

  return React.createElement("svg", _extends$3P({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M11.733 12.625a4.334 4.334 0 1 1 1.22-.002V20h-1.22v-7.375z" }));
});

var _extends$3Q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3P(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconToolOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3P(_ref, ["styles"]);

  return React.createElement("svg", _extends$3Q({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13.692 8.012a4.031 4.031 0 0 1-4.763.693l-5.814 5.809c-.45.449-1.178.449-1.628 0a1.149 1.149 0 0 1 0-1.626l5.815-5.807a4.02 4.02 0 0 1 3.5-5.934l-.772.77v3.251l.814.812h3.254l.771-.77a4.004 4.004 0 0 1-1.177 2.802m1.821-5.07l-2.228 2.226-2.035-.407-.406-2.03L13.072.503a5.18 5.18 0 0 0-5.89 1.007 5.161 5.161 0 0 0-1.241 5.304L.674 12.076a2.297 2.297 0 0 0 0 3.25 2.303 2.303 0 0 0 3.254 0l5.268-5.26a5.177 5.177 0 0 0 5.31-1.24 5.167 5.167 0 0 0 1.007-5.883" }));
});

var _extends$3R = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3Q(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconToolOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3Q(_ref, ["styles"]);

  return React.createElement("svg", _extends$3R({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M17.692 12.012a4.031 4.031 0 0 1-4.763.693l-5.814 5.809c-.45.449-1.178.449-1.628 0a1.149 1.149 0 0 1 0-1.626l5.815-5.807a4.02 4.02 0 0 1 3.5-5.934l-.772.77v3.251l.814.812h3.254l.771-.77a4.004 4.004 0 0 1-1.177 2.802m1.821-5.07l-2.228 2.226-2.035-.407-.406-2.03 2.228-2.227a5.18 5.18 0 0 0-5.89 1.007 5.161 5.161 0 0 0-1.241 5.304l-5.267 5.261a2.297 2.297 0 0 0 0 3.25 2.303 2.303 0 0 0 3.254 0l5.268-5.26a5.177 5.177 0 0 0 5.31-1.24 5.167 5.167 0 0 0 1.007-5.883" }));
});

var _extends$3S = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3R(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTransactionMethodOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3R(_ref, ["styles"]);

  return React.createElement("svg", _extends$3S({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M96 89.617C96 93.142 92.154 96 87.403 96H8.597C3.851 96 0 93.14 0 89.617V52.383C0 48.859 3.851 46 8.597 46h78.806C92.153 46 96 48.858 96 52.383zM88.566 91C89.904 91 91 90.183 91 89.182V52.818c0-1-1.096-1.818-2.434-1.818H7.434C6.091 51 5 51.815 5 52.818v36.364C5 90.185 6.09 91 7.434 91z" }), React.createElement("path", { d: "M11.781 46.448c-2.89-2.51-8.136-8.426-8.136-8.426-3.297-3.414-3.915-8.17-1.38-10.618L29.047 1.54c2.535-2.448 7.267-1.664 10.564 1.75l41.782 43.267s-67.6 1.64-69.613-.108zm62.478-.083L35.207 5.926c-.933-.966-2.277-1.185-2.998-.488L6.05 30.698c-.722.697-.55 2.048.383 3.014 0 0 7.887 8.914 12.191 12.625 1.186 1.022 55.634.028 55.634.028z" }), React.createElement("path", { d: "M45.592 73.226c0 1.173-.46 1.978-.878 2.39h-1.463c-.167 0-.313.153-.313.327v2.043c0 .174.146.326.313.326h9.324c.167 0 .313-.152.313-.326v-2.043c0-.174-.146-.326-.313-.326h-5.06c.377-.5.837-1.413.837-2.565 0-.11-.021-.218-.021-.326h3.031c.188 0 .314-.153.314-.348v-1.826c0-.174-.126-.326-.314-.326h-3.658c-.23-.74-.44-1.479-.44-2.24 0-.63.21-1.13.565-1.5.398-.39.962-.63 1.694-.63s1.442.196 2.195.609c.146.087.313.043.397-.13l.794-1.718c.063-.152.021-.326-.125-.413-.9-.544-2.132-.892-3.533-.892-1.526 0-2.697.479-3.533 1.261-.857.783-1.317 1.935-1.317 3.261 0 .848.209 1.63.439 2.392h-1.108c-.167 0-.314.152-.314.326v1.826c0 .195.147.348.314.348h1.819c.02.173.041.347.041.5zM48 83c-6.627 0-12-5.374-12-12 0-6.627 5.373-12 12-12s12 5.373 12 12c0 6.626-5.373 12-12 12zM27.12 10.187L61.89 46h-9.775L22.033 15.155zM32 71c0 8.836 7.162 16 16 16 8.836 0 16-7.164 16-16 0-8.838-7.164-16-16-16-8.838 0-16 7.162-16 16z" }));
});

var _extends$3T = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3S(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTransactionMethodOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3S(_ref, ["styles"]);

  return React.createElement("svg", _extends$3T({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M81 75.554c0 2.398-2.604 4.34-5.82 4.34H21.82c-3.213 0-5.82-1.944-5.82-4.34V50.235c0-2.396 2.607-4.34 5.82-4.34h53.36c3.216 0 5.82 1.943 5.82 4.34zm-4.642 1.34c.903 0 1.642-.551 1.642-1.227V51.122c0-.676-.739-1.227-1.642-1.227H21.642c-.906 0-1.642.55-1.642 1.227v24.545c0 .678.736 1.228 1.642 1.228z" }), React.createElement("path", { d: "M23.55 46.453c-1.97-1.704-5.545-5.72-5.545-5.72-2.248-2.317-2.669-5.546-.941-7.208L35.32 15.967c1.728-1.661 4.953-1.13 7.2 1.188L71 46.526s-46.078 1.114-47.45-.073zm42.45.246L39.266 18.622c-.639-.671-1.559-.823-2.053-.339L19.306 35.821c-.494.484-.377 1.422.262 2.093 0 0 5.4 6.188 8.346 8.765.812.71 38.086.02 38.086.02z" }), React.createElement("path", { d: "M46.358 64.609c0 .782-.321 1.319-.614 1.594H44.72a.224.224 0 0 0-.22.217v1.363c0 .116.102.217.22.217h6.526c.117 0 .22-.101.22-.217V66.42a.224.224 0 0 0-.22-.217h-3.541c.263-.333.585-.942.585-1.71 0-.073-.015-.145-.015-.218h2.122c.132 0 .22-.101.22-.232v-1.217a.214.214 0 0 0-.22-.217h-2.56c-.162-.493-.308-.986-.308-1.493 0-.42.146-.754.395-1 .278-.26.673-.42 1.186-.42s1.01.13 1.536.405c.103.058.22.03.278-.087l.556-1.144a.211.211 0 0 0-.088-.276C50.763 58.232 49.9 58 48.92 58c-1.068 0-1.887.319-2.473.84-.6.522-.922 1.29-.922 2.174 0 .566.147 1.087.308 1.595h-.776a.224.224 0 0 0-.22.217v1.217c0 .13.103.232.22.232h1.273c.015.116.03.232.03.334zM48 71a8 8 0 1 1 .001-16.001A8 8 0 0 1 48 71zM34.104 21.293L58 46h-6.622l-20.78-21.268zM37 63c0 6.075 4.924 11 11 11 6.075 0 11-4.925 11-11 0-6.076-4.925-11-11-11-6.076 0-11 4.924-11 11z" }));
});

var _extends$3U = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3T(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTransferLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3T(_ref, ["styles"]);

  return React.createElement("svg", _extends$3U({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7 8V4l9 4.5L7 13V9H0V8h7z" }));
});

var _extends$3V = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3U(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTransferSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3U(_ref, ["styles"]);

  return React.createElement("svg", _extends$3V({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M11 12V8l9 4.5-9 4.5v-4H4v-1h7z" }));
});

var _extends$3W = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3V(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTrashLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3V(_ref, ["styles"]);

  return React.createElement("svg", _extends$3W({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M78 12H66V3a3 3 0 0 0-3-3H33c-1.659 0-3 1.341-3 3v9H18c-3.702 0-6 2.614-6 6v6c0 3.422 2.888 6 6 6v60c0 3.315 2.685 6 6 6h48a6 6 0 0 0 6-6V30c3.85 0 6-2.771 6-6v-6c0-3.312-2.688-6-6-6zm-6 78H24V30h48v60zM36 12V6h24v6H36zm42 12H18v-6h60v6zM60 83.997h6V36h-6v47.997zM45 84h6V36h-6v48zm-15-.003h6V36h-6v47.997z" }));
});

var _extends$3X = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3W(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTrashSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3W(_ref, ["styles"]);

  return React.createElement("svg", _extends$3X({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M68 24h-8v-6a2 2 0 0 0-2-2H38c-1.106 0-2 .894-2 2v6h-8c-2.468 0-4 1.743-4 4v4c0 2.281 1.925 4 4 4v40c0 2.21 1.79 4 4 4h32a4 4 0 0 0 4-4V36c2.567 0 4-1.847 4-4v-4c0-2.208-1.792-4-4-4zm-4 52H32V36h32v40zM40 24v-4h16v4H40zm28 8H28v-4h40v4zM56 72h4V40h-4v32zm-10 0h4V40h-4v32zm-10 0h4V40h-4v32z" }));
});

var _extends$3Y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3X(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconUpload = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3X(_ref, ["styles"]);

  return React.createElement("svg", _extends$3Y({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M64 74.5h.667v-.03C77.663 73.826 89 67 89 50c0-11.17-7-20-20-21 0-10-6-21-21-21-14 0-22 12-21 24-12 0-20 8.21-20 19 0 16 10.558 22.598 22.667 23.442v.058H32V81h-6v-.07C11.47 79.904 0 67.792 0 53c0-13.113 9.014-24.12 21.183-27.164C22.75 12.415 34.16 2 48 2c12.869 0 23.635 9.003 26.343 21.054C86.828 26.489 96 37.924 96 51.5c0 15.79-12.405 28.681-28 29.463V81h-4z" }), React.createElement("path", { d: "M45 47.743L32.282 60.46a3 3 0 1 1-4.242-4.242L45.718 38.54A2.992 2.992 0 0 1 48 37.665a2.992 2.992 0 0 1 2.282.875L67.96 56.218a3 3 0 1 1-4.242 4.242L51 47.743V90a3 3 0 0 1-6 0z" }));
});

var _extends$3Z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3Y(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconUsageOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3Y(_ref, ["styles"]);

  return React.createElement("svg", _extends$3Z({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M19.406 19H5.594c-.294 0-.532-.224-.532-.5v-3.74l4.09-3.445 4.07 2.624.061.057.011-.01.017.01.777-.733-.016-.01 5.866-5.52V18.5c0 .276-.238.5-.532.5zM5.063 5.5c0-.276.237-.5.53-.5h13.813c.294 0 .532.224.532.5v.768l-6.789 6.39-4.027-2.596-.061-.057-.012.01-.016-.01-.237.223-3.733 3.145V5.5zM19.938 4H5.063C4.476 4 4 4.448 4 5v14c0 .552.476 1 1.063 1h14.875c.586 0 1.062-.448 1.062-1V5c0-.552-.476-1-1.063-1z" }));
});

var _extends$3_ = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3Z(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var WarningTriangle = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3Z(_ref, ["styles"]);

  return React.createElement("svg", _extends$3_({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 0l48 96H0zm-.5 69.5c-1.708 0-3.135.573-4.28 1.719-1.147 1.146-1.72 2.584-1.72 4.313 0 1.687.573 3.103 1.72 4.25 1.145 1.145 2.572 1.718 4.28 1.718 1.708 0 3.135-.573 4.28-1.719 1.147-1.146 1.72-2.562 1.72-4.249 0-1.73-.573-3.167-1.72-4.313-1.145-1.146-2.572-1.719-4.28-1.719zm6-36h-12l.405 8.667L43.608 61.5h7.784l1.703-19.333z", fillRule: "evenodd" }));
});

var _extends$3$ = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3_(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconArchiveOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3_(_ref, ["styles"]);

  return React.createElement("svg", _extends$3$({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M91.56 22.632c0-.364-.08-.73-.241-1.074a2.33 2.33 0 0 0-1.627-1.296L48.784.243a2.408 2.408 0 0 0-2.109 0L5.365 20.444A2.441 2.441 0 0 0 4 22.551v50.796c0 .932.522 1.783 1.366 2.189l41.31 20.2c.02 0 .02 0 .04.02.06.021.12.041.18.082.02 0 .04.02.08.02l.181.061c.02 0 .04.02.06.02.06.02.141.02.201.04h.06c.081 0 .181.021.262.021.08 0 .18 0 .26-.02h.061c.06 0 .14-.02.2-.04.021 0 .041-.021.061-.021l.18-.06c.021 0 .041-.021.081-.021.06-.02.12-.04.181-.081.02 0 .02 0 .04-.02l41.43-20.262a2.452 2.452 0 0 0 1.366-2.188V22.693c-.04-.02-.04-.04-.04-.06zM47.72 5.126l35.827 17.527-13.194 6.463L34.525 11.59 47.72 5.126zm0 35.053L11.892 22.653l17.11-8.368L64.83 31.81l-17.11 8.368zM8.82 26.563l36.49 17.85v45.245L8.82 71.808V26.563zm41.31 63.095V44.414l17.13-8.389v11.833c0 1.337 1.084 2.432 2.41 2.432 1.325 0 2.41-1.095 2.41-2.432V33.655l14.66-7.173v45.244L50.13 89.658z" }));
});

var _extends$40 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3$(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconArchiveOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3$(_ref, ["styles"]);

  return React.createElement("svg", _extends$40({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M77.373 31.088a1.69 1.69 0 0 0-.16-.716c-.215-.459-.63-.77-1.085-.864L48.856 16.162a1.605 1.605 0 0 0-1.406 0L19.91 29.63a1.627 1.627 0 0 0-.91 1.405v33.864c0 .622.348 1.189.91 1.46l27.54 13.466c.014 0 .014 0 .027.014.04.013.08.027.12.054.014 0 .027.013.054.013l.12.041c.014 0 .027.013.04.013.04.014.094.014.135.027h.04c.053 0 .12.014.174.014.053 0 .12 0 .174-.014h.04c.04 0 .094-.013.134-.027.013 0 .027-.013.04-.013l.12-.04c.014 0 .027-.014.054-.014a.473.473 0 0 0 .12-.054c.014 0 .014 0 .027-.014l27.62-13.507c.55-.27.911-.838.911-1.46V31.13c-.027-.014-.027-.027-.027-.04zm-29.227-11.67l23.885 11.684-8.796 4.309L39.35 23.726l8.796-4.309zm0 23.368L24.262 31.102l11.407-5.579 23.884 11.684-11.407 5.579zm-25.933-9.077l24.327 11.9v30.163l-24.327-11.9V33.709zm27.54 42.063V45.61l11.42-5.592v7.888c0 .892.723 1.621 1.607 1.621s1.607-.729 1.607-1.62v-9.47l9.773-4.781v30.163L49.753 75.772z" }));
});

var _extends$41 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$40(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconBriefcaseOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$40(_ref, ["styles"]);

  return React.createElement("svg", _extends$41({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M9 7V5.999A1 1 0 0 1 9.991 5h4.018c.547 0 .991.442.991.999V7h1v-.505c0-.273.216-.495.496-.495h2.009c.274 0 .495.216.495.495V7c.553 0 1 .456 1 1.002v9.995A.999.999 0 0 1 19 19H5c-.552 0-1-.456-1-1.003V8.002A.999.999 0 0 1 5 7v-.505C5 6.222 5.216 6 5.495 6h2.01c.273 0 .495.216.495.495V7h1zm1-1v1h4V6h-4zM5 8v10h1V8H5zm13 0v10h1V8h-1zM7 8v10h10V8H7z" }));
});

var _extends$42 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$41(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChartOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$41(_ref, ["styles"]);

  return React.createElement("svg", _extends$42({ height: "64", viewBox: "0 0 64 64", width: "64", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M42 60.004V43.998l18 .004c-.072 7.972-11.93 15.982-18 16.002zM38 40v23.998l4 .004c19.766-3.06 22-20.004 22-20.004V40h-.102zm-4-8h-2.136l-1.21 1.3-18.796 18.108C7 46.38 4 39.548 4 32 4 16.536 16.536 4 32 4s28 12.536 28 28zm-4 27.898c-5.726-.406-10.96-2.546-15.222-5.874L30 38.802zM32 0C14.326 0 0 14.326 0 32c0 16.996 13.262 30.86 30 31.896v.102h4V36h30v-4C64 14.326 49.672 0 32 0z" }));
});

var _extends$43 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$42(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChartOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$42(_ref, ["styles"]);

  return React.createElement("svg", _extends$43({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M14.5 19.001v-4.002l4.5.002c-.018 1.993-2.983 3.995-4.5 4zM13.5 14v6h1c4.942-.765 5.5-5 5.5-5v-1h-6.5zm-1-2h-.534l-.302.325-4.7 4.527A6.959 6.959 0 0 1 5 12a7 7 0 1 1 14 0h-6.5zm-1 6.974a6.97 6.97 0 0 1-3.806-1.468L11.5 13.7v5.274zM12 4a8 8 0 0 0-8 8c0 4.249 3.316 7.715 7.5 7.974V20h1v-7H20v-1a8 8 0 0 0-8-8z" }));
});

var _extends$44 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$43(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconClipboardTickOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$43(_ref, ["styles"]);

  return React.createElement("svg", _extends$44({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M15 6h1v1h3v13H5V7h3V6h1v-.99C9 4.452 9.451 4 9.991 4h4.018c.547 0 .991.444.991 1.01V6zm-1 1V5h-4v2H9v2h6V7h-1zm-6 3V8H6v11h12V8h-2v2H8zm1.827 4.435l1.145 1.269 3.201-3.547a.452.452 0 0 1 .685 0 .58.58 0 0 1 0 .759l-3.543 3.926a.45.45 0 0 1-.685 0l-1.488-1.648a.577.577 0 0 1 0-.759c.19-.21.496-.21.685 0z" }));
});

var _extends$45 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$44(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDiaryOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$44(_ref, ["styles"]);

  return React.createElement("svg", _extends$45({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon diary"), React.createElement("path", { d: "M0 3.988A3.99 3.99 0 0 1 3.988 0h24.024A3.99 3.99 0 0 1 32 3.988v24.024A3.99 3.99 0 0 1 28.012 32H3.988A3.99 3.99 0 0 1 0 28.012V3.988zM6 30v-4H4v-4h2v-4H4v-4h2v-4H4V6h2V2H3.988A1.99 1.99 0 0 0 2 3.988v24.024A1.99 1.99 0 0 0 3.988 30H6zm2 0h20.012A1.99 1.99 0 0 0 30 28.012V3.988A1.99 1.99 0 0 0 28.012 2H8v28zm2-24h18v10H10V6zm2 8h14V8H12v6zm-2 11c0-.552.445-1 1-1h16c.552 0 1 .45 1 1 0 .552-.445 1-1 1H11c-.552 0-1-.45-1-1zm0-4c0-.552.445-1 1-1h16c.552 0 1 .45 1 1 0 .552-.445 1-1 1H11c-.552 0-1-.45-1-1z" }));
});

var _extends$46 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$45(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDiaryOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$45(_ref, ["styles"]);

  return React.createElement("svg", _extends$46({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M4 5.994C4 4.893 4.895 4 5.994 4h12.012C19.108 4 20 4.895 20 5.994v12.012A1.995 1.995 0 0 1 18.006 20H5.994A1.995 1.995 0 0 1 4 18.006V5.994zM7 19v-2H6v-2h1v-2H6v-2h1V9H6V7h1V5H5.994A.995.995 0 0 0 5 5.994v12.012c0 .548.446.994.994.994H7zm1 0h10.006a.995.995 0 0 0 .994-.994V5.994A.995.995 0 0 0 18.006 5H8v14zM9 7h9v5H9V7zm1 4h7V8h-7v3zm-1 5.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5z" }));
});

var _extends$47 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$46(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFileLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$46(_ref, ["styles"]);

  return React.createElement("svg", _extends$47({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M10.77 11H5.23c-.254 0-.46.224-.46.5 0 .277.206.5.46.5h5.54c.254 0 .46-.223.46-.5 0-.276-.206-.5-.46-.5zm2.307 3.5c0 .277-.207.5-.462.5h-9.23c-.255 0-.462-.223-.462-.5v-13c0-.276.207-.5.462-.5h6v4h3.692v9.5zm-2.77-13.268L12.864 4h-2.555V1.232zM14 4L10.308.002V0H2.462C2.206 0 2 .224 2 .5v15c0 .277.206.5.462.5h11.076c.255 0 .462-.223.462-.5V4h-.001zm-9.23 4.5c0 .277.207.5.462.5h5.538c.255 0 .462-.223.462-.5s-.207-.5-.462-.5H5.231c-.255 0-.462.223-.462.5z" }));
});

var _extends$48 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$47(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFileSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$47(_ref, ["styles"]);

  return React.createElement("svg", _extends$48({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M14.77 15H9.23c-.254 0-.46.224-.46.5 0 .277.206.5.46.5h5.54c.254 0 .46-.223.46-.5 0-.276-.206-.5-.46-.5zm2.307 3.5c0 .276-.207.5-.462.5h-9.23c-.255 0-.462-.224-.462-.5v-13c0-.276.207-.5.462-.5h6v4h3.692v9.5zm-2.77-13.268L16.864 8h-2.555V5.232zM18 8l-3.691-3.998V4H6.462C6.206 4 6 4.224 6 4.5v15c0 .276.206.5.462.5h11.076c.255 0 .462-.224.462-.5V8h-.001zm-9.23 4.5c0 .277.207.5.462.5h5.538c.255 0 .462-.223.462-.5s-.207-.5-.462-.5H9.231c-.255 0-.462.223-.462.5z" }));
});

var _extends$49 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$48(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$s = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$48(_ref, ["styles"]);

  return React.createElement("svg", _extends$49({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon list"), React.createElement("path", { d: "M6.5 9a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5zm0 8a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5zm0 8.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5zM12 7a1 1 0 0 1 1-1h13.26a1 1 0 0 1 0 2H13c-.552 0-1-.45-1-1zm0 8a1 1 0 0 1 1-1h13.26a1 1 0 0 1 0 2H13c-.552 0-1-.45-1-1zm0 8a1 1 0 0 1 1-1h13.26a1 1 0 0 1 0 2H13c-.552 0-1-.45-1-1z" }));
});

var _extends$4a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$49(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconListOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$49(_ref, ["styles"]);

  return React.createElement("svg", _extends$4a({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M5.72 8.256c-.95 0-1.72-.73-1.72-1.628C4 5.729 4.77 5 5.72 5c.949 0 1.72.73 1.72 1.628 0 .899-.771 1.628-1.72 1.628zm0 5.21c-.95 0-1.72-.73-1.72-1.629 0-.898.77-1.628 1.72-1.628.949 0 1.72.73 1.72 1.628 0 .899-.771 1.628-1.72 1.628zm0 5.534C4.77 19 4 18.27 4 17.372c0-.899.77-1.628 1.72-1.628.949 0 1.72.73 1.72 1.628 0 .899-.771 1.628-1.72 1.628zM9.503 6.953c0-.359.308-.65.688-.65h9.121c.38 0 .688.292.688.65 0 .36-.308.652-.688.652h-9.121c-.38 0-.688-.293-.688-.652zm0 5.21c0-.36.308-.651.688-.651h9.121c.38 0 .688.293.688.65 0 .36-.308.652-.688.652h-9.121c-.38 0-.688-.293-.688-.651zm0 5.21c0-.36.308-.652.688-.652h9.121c.38 0 .688.293.688.651 0 .36-.308.651-.688.651h-9.121c-.38 0-.688-.293-.688-.65z" }));
});

var _extends$4b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4a(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPencilSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4a(_ref, ["styles"]);

  return React.createElement("svg", _extends$4b({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M14.873 1.126C13.563-.187 12.577.01 12.577.01L.917 11.672 0 16l4.33-.918L15.99 3.423c-.001 0 .196-.984-1.116-2.297h-.001zm-10.8 13.436l-1.477.317a3.387 3.387 0 0 0-.627-.847 3.379 3.379 0 0 0-.848-.629l.318-1.475.427-.426s.803.017 1.71.925c.906.905.924 1.71.924 1.71l-.427.426v-.001z" }));
});

var _extends$4c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4b(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPencilSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4b(_ref, ["styles"]);

  return React.createElement("svg", _extends$4c({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon pencil"), React.createElement("path", { d: "M22.872 9.126c-1.31-1.312-2.295-1.115-2.295-1.115L8.917 19.67 8 23.997l4.33-.918 11.66-11.656c-.002 0 .195-.984-1.117-2.297zm-10.8 13.433l-1.476.317c-.142-.266-.314-.533-.627-.847s-.582-.485-.848-.628l.318-1.475.427-.426s.803.017 1.71.925c.906.905.924 1.71.924 1.71l-.427.425z" }));
});

var _extends$4d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4c(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPrinterOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4c(_ref, ["styles"]);

  return React.createElement("svg", _extends$4d({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M18 29.998a6 6 0 1 0 0 12 6 6 0 0 0 0-12zm72 39.001a3.002 3.002 0 0 1-3 3.003H72V54H24v18.003H9c-1.656 0-3-1.344-3-3.003V27.001a3 3 0 0 1 3-3.003h78A3 3 0 0 1 90 27v41.998zM30 90h36V60H30v30zm0-71.998h36V5.997H30v12.004zm63 0H72V0H24v18H3c-1.656 0-3 1.342-3 2.998v54.001a3.004 3.004 0 0 0 3 3.003h21V96h48V78.002h21c1.656 0 3-1.347 3-3.003V20.998A2.999 2.999 0 0 0 93 18zM36 29.998a6 6 0 1 0 0 12 6 6 0 0 0 0-12z", fillRule: "evenodd" }));
});

var _extends$4e = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4d(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPrinterOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4d(_ref, ["styles"]);

  return React.createElement("svg", _extends$4e({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M28 35.998a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm48 26A2.001 2.001 0 0 1 74 64H64V51.998H32V64H22c-1.104 0-2-.896-2-2.002V34a2 2 0 0 1 2-2.002h52A2 2 0 0 1 76 34zm-40 14h24v-20H36zM36 28h24v-8.002H36zm42 0H64V16H32v12H18c-1.104 0-2 .894-2 1.998v36c0 1.104.896 2.002 2 2.002h14v11.998h32V68h14c1.104 0 2-.898 2-2.002v-36A1.999 1.999 0 0 0 78 28zm-38 7.998a4 4 0 1 0 0 8 4 4 0 0 0 0-8z", fillRule: "evenodd" }));
});

var _extends$4f = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4e(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTagOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4e(_ref, ["styles"]);

  return React.createElement("svg", _extends$4f({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon tag"), React.createElement("path", { d: "M4 10L16 0l12 10v22H4V10zm2 20h20V10.937L16 2.604 6 10.937V30zm10-14c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-2a2 2 0 1 0 .001-3.999A2 2 0 0 0 16 14zm-4 5c0-.552.45-1 1-1 .552 0 1 .45 1 1v8c0 .552-.45 1-1 1-.552 0-1-.45-1-1v-8zm6 0c0-.552.45-1 1-1 .552 0 1 .45 1 1v8c0 .552-.45 1-1 1-.552 0-1-.45-1-1v-8z" }));
});

var _extends$4g = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4f(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTagOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4f(_ref, ["styles"]);

  return React.createElement("svg", _extends$4g({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M6 9l6-5 6 5v11H6V9zm1 10h10V9.469l-5-4.167-5 4.167V19zm5-7a2 2 0 1 1-.001-3.999A2 2 0 0 1 12 12zm0-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-2 2.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0v-4zm3 0a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0v-4z" }));
});

var _extends$4h = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4g(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$t = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4g(_ref, ["styles"]);

  return React.createElement("svg", _extends$4h({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M5.953 16a1.7 1.7 0 0 1-1.331-.632L.34 9.972c-.558-.7-.413-1.698.323-2.23.737-.534 1.784-.393 2.34.31l2.82 3.547L12.908.75c.487-.745 1.518-.974 2.302-.51.783.465 1.024 1.448.535 2.195L7.373 15.247c-.29.447-.792.726-1.343.75-.025.002-.05.002-.076.002V16z" }));
});

var _extends$4i = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4h(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTickSolidSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4h(_ref, ["styles"]);

  return React.createElement("svg", _extends$4i({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon tick"), React.createElement("path", { d: "M13.954 24a1.7 1.7 0 0 1-1.332-.632L8.34 17.972c-.558-.7-.413-1.698.323-2.23.737-.534 1.784-.393 2.34.31l2.82 3.547L20.91 8.75c.487-.745 1.518-.974 2.302-.51.783.465 1.024 1.448.535 2.195l-8.373 12.812c-.29.447-.792.726-1.343.75-.025.002-.05.002-.076.002z" }));
});

var _extends$4j = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4i(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTrophyOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4i(_ref, ["styles"]);

  return React.createElement("svg", _extends$4j({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon trophy"), React.createElement("path", { d: "M28 14h-2.058c.037-.33.058-.66.058-.998V6h3.938L28 14zm-4-5v4.002c0 3.864-3.134 7-7 7s-7-3.136-7-7V2h14v7zM6 14L4.062 6H8v7.002c0 .338.022.67.06.998H6zM26 4V0H8v4H4a2 2 0 0 0-2 2s1.66 6.8 2 8 .896 2 2 2h2.523c1.13 3.192 4.002 5.556 7.477 5.94v8.057h-4v2h10v-2h-4V21.94c3.477-.384 6.348-2.75 7.477-5.94H28c1.105 0 1.723-1.002 2-2s2-8 2-8a2 2 0 0 0-2-2h-4z" }));
});

var _extends$4k = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4j(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTrophyOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4j(_ref, ["styles"]);

  return React.createElement("svg", _extends$4k({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M17.867 11h-1.098c.02-.164.031-.33.031-.498V7h2.1l-1.033 4zm-2.134-2.5v2.002c0 1.932-1.671 3.5-3.733 3.5-2.062 0-3.733-1.568-3.733-3.5V5h7.466v3.5zm-9.6 2.5L5.1 7h2.1v3.502c0 .169.012.335.032.499H6.133zM16.8 6V4H7.2v2H5.067C4.477 6 4 6.448 4 7c0 0 .885 3.4 1.067 4 .181.6.478 1 1.066 1H7.48c.603 1.597 2.134 2.779 3.988 2.971V19H9.333v1h5.334v-1h-2.134V14.97c1.855-.192 3.386-1.375 3.988-2.97h1.346c.589 0 .919-.501 1.066-1C19.081 10.5 20 7 20 7c0-.553-.477-1-1.067-1H16.8z" }));
});

var _extends$4l = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4k(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconWatchOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4k(_ref, ["styles"]);

  return React.createElement("svg", _extends$4l({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon watch"), React.createElement("path", { d: "M22 5.605C25.587 7.68 28 11.558 28 16s-2.413 8.32-6 10.395V32H10v-5.605C6.413 24.32 4 20.442 4 16s2.413-8.32 6-10.395V0h12v5.605zm-2-.922V2h-8v2.683C13.25 4.24 14.597 4 16 4s2.75.24 4 .683zm0 22.634c-1.25.442-2.597.683-4 .683s-2.75-.24-4-.683V30h8v-2.683zM16 26c5.523 0 10-4.477 10-10S21.523 6 16 6 6 10.477 6 16s4.477 10 10 10zm0-10h5.02c.54 0 .98.464.98 1 0 .552-.43 1-.98 1h-6.04a.987.987 0 0 1-.98-.996v-8.01c0-.55.464-.994 1-.994.552 0 1 .43 1 .995V16z" }));
});

var _extends$4m = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4l(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconWatchOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4l(_ref, ["styles"]);

  return React.createElement("svg", _extends$4m({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M15 6.803A5.998 5.998 0 0 1 18 12a5.998 5.998 0 0 1-3 5.198V20H9v-2.802A5.998 5.998 0 0 1 6 12a5.998 5.998 0 0 1 3-5.197V4h6v2.803zm-1-.462V5h-4v1.341A5.977 5.977 0 0 1 12 6c.701 0 1.375.12 2 .341zm0 11.317A5.99 5.99 0 0 1 12 18c-.701 0-1.375-.12-2-.341V19h4v-1.341zM12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0-5h2.51a.5.5 0 0 1 .49.5c0 .276-.215.5-.49.5h-3.02a.493.493 0 0 1-.49-.498V8.497c0-.275.232-.497.5-.497.276 0 .5.215.5.498V12z" }));
});



var icons = /*#__PURE__*/Object.freeze({
	__proto__: null,
	Placeholder: iconPlaceholder,
	ArrowDownSolidLarge: iconArrowDownSolidLarge,
	ArrowDownSolidSmall: iconArrowDownSolidSmall,
	ArrowUpSolidLarge: iconArrowUpSolidLarge,
	ArrowUpSolidSmall: iconArrowUpSolidSmall,
	ChevronDownSolidLarge: GenericIcon$9,
	ChevronDownSolidSmall: GenericIcon$k,
	ChevronLeftLarge: iconChevronLeftLarge,
	ChevronLeftSmall: iconChevronLeftSmall,
	ChevronLeftSolidSmall: iconChevronLeftSolidSmall,
	ChevronRightSolidLarge: iconChevronRightSolidLarge,
	ChevronRightSolidSmall: iconChevronRightSolidSmall,
	ChevronUpSolidLarge: GenericIcon$l,
	ChevronUpSolidSmall: iconChevronUpSolidSmall,
	TriangleDownSolidLarge: iconTriangleDownSolidLarge,
	TriangleDownSolidSmall: iconTriangleDownSolidSmall,
	TriangleLeftSolidLarge: iconTriangleLeftSolidLarge,
	TriangleLeftSolidSmall: iconTriangleLeftSolidSmall,
	TriangleRightLarge: GenericIcon,
	TriangleRightSolidSmall: iconTriangleRightSolidSmall,
	TriangleUpSolidLarge: iconTriangleUpSolidLarge,
	TriangleUpSolidSmall: iconTriangleUpSolidSmall,
	BriefcaseBrandedLarge: iconBriefcaseBrandedLarge,
	BriefcaseBrandedSmall: iconBriefcaseBrandedSmall,
	MailBrandedLarge: iconMailBrandedLarge,
	MailBrandedSmall: iconMailBrandedSmall,
	ChatSolidLarge: iconChatSolidLarge,
	MailOutlineLarge: iconMailOutlineLarge,
	MailOutlineSmall: iconMailOutlineSmall,
	MailReadOutlineLarge: iconMailReadOutlineLarge,
	MailReadOutlineSmall: iconMailReadOutlineSmall,
	MailSentOutlineLarge: iconMailSentOutlineLarge,
	ReplySolidLarge: iconReplySolidLarge,
	ReplySolidSmall: iconReplySolidSmall,
	TelephoneOutlineLarge: iconTelephoneOutlineLarge,
	TelephoneOutlineSmall: iconTelephoneOutlineSmall,
	BuildingOutlineLarge: GenericIcon$c,
	BuildingOutlineSmall: iconBuildingOutlineSmall,
	CalculatorOutlineLarge: iconCalculatorOutlineLarge,
	CalculatorOutlineSmall: iconCalculatorOutlineSmall,
	CalendarOutlineLarge: CalendarOutlineLarge,
	CalendarOutlineSmall: iconCalendaroutlineSmall,
	CoinsOutlineLarge: iconCoinsOutlineLarge,
	CoinsOutlineSmall: iconCoinsOutlineSmall,
	CreditCardOutlineLarge: GenericIcon$e,
	CreditCardOutlineSmall: iconCreditCardOutlineSmall,
	LoanOutlineLarge: iconLoanOutlineLarge,
	LoanOutlineSmall: iconLoanOutlineSmall,
	MoneyNote: GenericIcon$f,
	PoundOutlineLarge: iconPoundOutlineLarge,
	PoundOutlineSmall: iconPoundOutlineSmall,
	TimeIsMoney: GenericIcon$h,
	WalletOutlineLarge: GenericIcon$j,
	WalletOutlineSmall: iconWalletOutlineSmall,
	CameraOutlineLarge: iconCameraOutlineLarge,
	CarOutlineLarge: iconCarOutlineLarge,
	CarOutlineSmall: iconCarOutlineSmall,
	DecorateOutlineLarge: iconDecorateOutlineLarge,
	DecorateOutlineSmall: iconDecorateOutlineSmall,
	GenericMoneyOutlineLarge: iconGenericMoneyOutlineLarge,
	GenericMoneyOutlineSmall: iconGenericMoneyOutlineSmall,
	PlaneOutlineLarge: GenericIcon$g,
	PlaneOutlineSmall: iconPlaneOutlineSmall,
	WeddingOutlineLarge: iconWeddingOutlineLarge,
	WeddingOutlineSmall: iconWeddingOutlineSmall,
	Desktop: Desktop,
	DualAvatar: DualAvatar,
	Favourite: Favourite,
	AbroadOutlineLarge: iconAbroadOutlineLarge,
	AbroadOutlineSmall: iconAbroadOutlineSmall,
	AlertOutlineLarge: iconAlertOutlineLarge,
	AlertOutlineSmall: iconAlertOutlineSmall,
	AuthorisationLarge: GenericIcon$m,
	AuthorisationSmall: iconAuthorisationSmall,
	AvatarOutlineLarge: iconAvatarOutlineLarge,
	AvatarOutlineSmall: iconAvatarOutlineSmall,
	BlockedFilledLarge: iconBlockedFilledLarge,
	BlockedFilledSmall: iconBlockedFilledSmall,
	CallIncomingSolidLarge: iconCallIncomingSolidLarge,
	CallIncomingSolidSmall: iconCallIncomingSolidSmall,
	Checkbox: CheckboxIcon,
	ClockOutlineLarge: GenericIcon$n,
	ClockOutlineSmall: iconClockOutlineSmall,
	ClockSolidLarge: ClockSolidLarge,
	ClockSolidSmall: iconClockSolidSmall,
	ConferenceLarge: iconConferenceLarge,
	ConferenceSmall: iconConferenceSmall,
	CredentialsOutlineLarge: iconCredentialsOutlineLarge,
	CredentialsOutlineSmall: iconCredentialsOutlineSmall,
	CrossSolidCircleLarge: GenericIcon$1,
	CrossSolidCircleSmall: iconCrossSolidCircleSmall,
	CrossRoundedSolidLarge: GenericIcon$5,
	CrossSolidLarge: GenericIcon$5,
	CrossRoundedSolidSmall: GenericIcon$o,
	CrossSolidSmall: GenericIcon$o,
	crossThinOutlineLarge: iconCrossThinOutlineLarge,
	crossThinOutlineSmall: iconCrossThinOutlineSmall,
	crossOutlineLarge: GenericIcon$p,
	CrossOutlineLarge: GenericIcon$p,
	crossOutlineSmall: iconCrossoutlineSmall,
	CrossOutlineSmall: iconCrossoutlineSmall,
	CycleLarge: CycleLarge,
	CycleSmall: iconCycleSmall,
	CycleSolidLarge: iconCycleSolidLarge,
	CycleSolidSmall: iconCycleSolidSmall,
	DialSolidLarge: iconDialSolidLarge,
	DialSolidSmall: iconDialSolidSmall,
	Disallowed: Disallowed,
	DotSolidLarge: iconDotSolidLarge,
	DotSolidSmall: iconDotSolidSmall,
	DownloadSolidLarge: iconDownloadSolidLarge,
	DownloadSolidSmall: iconDownloadSolidSmall,
	EditDisallowedOutlineLarge: iconEditDisallowedOutlineLarge,
	EditDisallowedOutlineSmall: iconEditDisallowedOutlineSmall,
	EllipsisLarge: GenericIcon$6,
	EllipsisSmall: iconEllipsisSmall,
	ExclamationCircleLarge: GenericIcon$q,
	ExclamationCircleSmall: iconExclamationCircleSmall,
	ExclamationLarge: iconExclamationLarge,
	ExclamationSmall: iconExclamationSmall,
	EyehideOutlineLarge: EyehideOutlineLarge,
	EyehideOutlineSmall: iconEyehideOutlineSmall,
	EyeshowOutlineLarge: EyeshowOutlineLarge,
	EyeshowOutlineSmall: iconEyeshowOutlineSmall,
	faceOutlineLarge: iconFaceOutlineLarge,
	faceOutlineSmall: iconFaceOutlineSmall,
	FlagLarge: iconFlagLarge,
	FlagSmall: iconFlagSmall,
	FlipChartOutlineLarge: iconFlipChartOutlineLarge,
	FlipChartOutlineSmall: iconFlipChartOutlineSmall,
	FolderOutlineLarge: iconFolderOutlineLarge,
	FolderOutlineSmall: iconFolderOutlineSmall,
	FormerLarge: iconFormerLarge,
	FormerSmall: iconFormerSmall,
	GhostOutlineLarge: iconGhostOutlineLarge,
	GhostOutlineSmall: iconGhostOutlineSmall,
	Graph: iconGraph,
	GridLarge: GridLarge,
	GridSmall: iconGridSmall,
	HouseOutlineLarge: iconHouseOutlineLarge,
	HouseOutlineSmall: iconHouseOutlineSmall,
	InboxOutlineLarge: iconInboxOutlineLarge,
	InboxOutlineSmall: iconInboxOutlineSmall,
	InfoOutlineLarge: iconInfoOutlineLarge,
	InfoOutlineSmall: iconInfoOutlineSmall,
	LinkedGroup: iconLinkedGroup,
	LoadingOutlineLarge: iconLoadingOutlineLarge,
	LoadingOutlineSmall: LoadingOutlineSmallIcon,
	LocationOutlineLarge: iconLocationOutlineLarge,
	LocationOutlineSmall: iconLocationOutlineSmall,
	LockFilled: GenericIcon$2,
	LockOutlineLarge: GenericIcon$a,
	LockOutlineSmall: iconLockSmall,
	LogoutOutlineLarge: iconLogoutOutlineLarge,
	LogoutOutlineSmall: iconLogoutOutlineSmall,
	MagnifySolidLarge: MagnifySolidLarge,
	MagnifySolidSmall: iconMagnifySolidSmall,
	MakeCallSolidLarge: iconMakeCallSolidLarge,
	MakeCallSolidSmall: iconMakeCallSolidSmall,
	MaskOutlineLarge: iconMaskOutlineLarge,
	MaskOutlineSmall: iconMaskOutlineSmall,
	MinusLarge: iconMinusLarge,
	MinusOutlineLarge: GenericIcon$7,
	MinusOutlineSmall: iconMinusOutlineSmall,
	MinusSmall: iconMinusSmall,
	MinusSolidLarge: MinusSolidLarge,
	MinusSolidSmall: iconMinusSolidSmall,
	MobileOutlineLarge: iconMobileOutlineLarge,
	MobileOutlineSmall: iconMobileOutlineSmall,
	MoneyLarge: iconMoneyLarge,
	MoneySmall: iconMoneySmall,
	NoResults: iconNoResults,
	OnlineOutlineLarge: iconOnlineOutlineLarge,
	OnlineOutlineSmall: iconOnlineOutlineSmall,
	PageOutlineLarge: iconPageOutlineLarge,
	PageOutlineSmall: iconPageOutlineSmall,
	PauseFilledLarge: iconPauseFilledLarge,
	PauseFilledSmall: iconPauseFilledSmall,
	PauseOutlineLarge: iconPauseOutlineLarge,
	PauseOutlineSmall: iconPauseOutlineSmall,
	PendingFilledLarge: GenericIcon$r,
	PendingFilledSmall: iconPendingFilledSmall,
	PersonOutlineLarge: iconPersonOutlineLarge,
	PersonOutlineSmall: iconPersonOutlineSmall,
	PhoneHoldLarge: iconPhoneHoldLarge,
	PhoneHoldSmall: iconPhoneHoldSmall,
	PhoneLarge: iconPhoneLarge,
	PhoneRingLarge: iconPhoneRingLarge,
	PhoneRingSmall: iconPhoneRingSmall,
	PhoneSmall: iconPhoneSmall,
	PlusLarge: iconPlusLarge,
	PlusOutlineLarge: CYBGPlusIcon,
	PlusOutlineSmall: iconPlusOutlineSmall,
	PlusSmall: iconPlusSmall,
	PlusSolidSmall: iconPlusSolidSmall,
	PopoutOutlineLarge: GenericIcon$8,
	ProspectLarge: iconProspectLarge,
	ProspectSmall: iconProspectSmall,
	QuestionSolidLarge: iconQuestionSolidLarge,
	QuestionSolidSmall: iconQuestionSolidSmall,
	Radio: RadioIcon,
	RetrieveLarge: iconRetrieveLarge,
	RetrieveSmall: iconRetrieveSmall,
	SettingsOutlineLarge: iconSettingsOutlineLarge,
	SettingsOutlineSmall: iconSettingsOutlineSmall,
	SheetLarge: iconSheetLarge,
	SheetSmall: iconSheetSmall,
	SliderOutlineLarge: iconSliderOutlineLarge,
	SliderOutlineSmall: iconSliderOutlineSmall,
	StatementOutlineLarge: iconStatementOutlineLarge,
	StatementOutlineSmall: iconStatementOutlineSmall,
	StatusOutlineLarge: GenericIcon$3,
	StatusOutlineSmall: iconStatusOutlineSmall,
	TickOutlineCircleSmall: iconTickCircleOutlineSmall,
	TickOutlineCircleFilledLarge: GenericIcon$4,
	TickOutlineCircleFilledSmall: iconTickCircularFilledSmall,
	TickInterfaceOutlineLarge: iconTickInterfaceOutlineLarge,
	TickInterfaceOutlineSmall: iconTickInterfaceOutlineSmall,
	TickOutlineCircleLarge: iconTickOutlineLarge,
	TickOutlineLarge: iconTickOutlineLarge,
	TickOutlineSmall: iconTickOutlineSmall,
	TimelineLarge: iconTimelineLarge,
	TimelineSmall: iconTimelineSmall,
	TimelineStartLarge: iconTimelineStartLarge,
	TimelineStartSmall: iconTimelineStartSmall,
	ToolOutlineLarge: iconToolOutlineLarge,
	ToolOutlineSmall: iconToolOutlineSmall,
	TransactionMethodOutlineLarge: iconTransactionMethodOutlineLarge,
	TransactionMethodOutlineSmall: iconTransactionMethodOutlineSmall,
	TransferLarge: iconTransferLarge,
	TransferSmall: iconTransferSmall,
	TrashLarge: iconTrashLarge,
	TrashSmall: iconTrashSmall,
	Upload: iconUpload,
	UsageOutlineLarge: GenericIcon$i,
	UsageOutlineSmall: iconUsageOutlineSmall,
	WarningTriangle: WarningTriangle,
	ArchiveOutlineLarge: iconArchiveOutlineLarge,
	ArchiveOutlineSmall: iconArchiveOutlineSmall,
	BriefcaseOutlineLarge: GenericIcon$b,
	BriefcaseOutlineSmall: iconBriefcaseOutlineSmall,
	ChartOutlineLarge: iconChartOutlineLarge,
	ChartOutlineSmall: iconChartOutlineSmall,
	ClipboardTickOutlineLarge: GenericIcon$d,
	ClipboardTickOutlineSmall: iconClipboardTickOutlineSmall,
	DiaryOutlineLarge: iconDiaryOutlineLarge,
	DiaryOutlineSmall: iconDiaryOutlineSmall,
	FileLarge: iconFileLarge,
	FileSmall: iconFileSmall,
	ListOutlineLarge: GenericIcon$s,
	ListOutlineSmall: iconListOutlineSmall,
	PencilSolidLarge: iconPencilSolidLarge,
	PencilSolidSmall: iconPencilSolidSmall,
	PrinterOutlineLarge: iconPrinterOutlineLarge,
	PrinterOutlineSmall: iconPrinterOutlineSmall,
	TagOutlineLarge: iconTagOutlineLarge,
	TagOutlineSmall: iconTagOutlineSmall,
	TickSolidLarge: GenericIcon$t,
	TickSolidSmall: iconTickSolidSmall,
	TrophyOutlineLarge: iconTrophyOutlineLarge,
	TrophyOutlineSmall: iconTrophyOutlineSmall,
	WatchOutlineLarge: iconWatchOutlineLarge,
	WatchOutlineSmall: iconWatchOutlineSmall
});

var _extends$4n = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4m(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPlaceholder$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4m(_ref, ["styles"]);

  return React.createElement("svg", _extends$4n({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M96 90.8V5.5l.1-.1-.1-.1V0H-.2v96h5.1l.3.3.3-.3h85l.3.3.3-.3H96v-5.2zM47.9 42.7L12.8 7.6H83L47.9 42.7zm40.5-29.6v70.1l-35-35 35-35.1zm-45.8 35L7.8 82.9V13.4l34.8 34.7zm5.3 5.4l34.8 34.8H13.1l34.8-34.8z" }));
});

var _extends$4o = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4n(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconArrowDownSolidLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4n(_ref, ["styles"]);

  return React.createElement("svg", _extends$4o({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M10.667 56l7.608-7.476 22.859 23.031V1.333a1 1 0 0 1 1-1h8.667a1 1 0 0 1 1 1V70.69l22.392-22.23 7.478 7.605L45.867 91.54z" }));
});

var _extends$4p = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4o(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconArrowDownSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4o(_ref, ["styles"]);

  return React.createElement("svg", _extends$4p({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M23.333 53.17l5.072-4.984 15.24 15.354V17.059a1 1 0 0 1 1-1h5.111a1 1 0 0 1 1 1v45.905l14.928-14.821 4.986 5.07-23.87 23.65z" }));
});

var _extends$4q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4p(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconArrowUpSolidLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4p(_ref, ["styles"]);

  return React.createElement("svg", _extends$4q({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M10.667 40.666l7.608 7.476 22.859-23.03v70.221a1 1 0 0 0 1 1h8.667a1 1 0 0 0 1-1V25.976l22.392 22.23 7.478-7.605L45.867 5.127z" }));
});

var _extends$4r = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4q(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconArrowUpSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4q(_ref, ["styles"]);

  return React.createElement("svg", _extends$4r({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M23.333 42.947l5.072 4.984 15.24-15.353v46.48a1 1 0 0 0 1 1h5.111a1 1 0 0 0 1-1V33.155l14.928 14.82 4.986-5.07-23.87-23.65z" }));
});

var _extends$4s = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4r(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$j = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4r(_ref, ["styles"]);

  return React.createElement("svg", _extends$4s({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48.36 66.434a4.756 4.756 0 0 1-3.373-1.398L16.361 36.409l6.746-6.747 25.254 25.254 25.253-25.254 6.747 6.747-28.627 28.627a4.756 4.756 0 0 1-3.373 1.398z" }));
});

var _extends$4t = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4s(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChevronLeftLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4s(_ref, ["styles"]);

  return React.createElement("svg", _extends$4t({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M20.782 48.24a7.134 7.134 0 0 1 2.097-5.059L65.819.241l10.12 10.12-37.88 37.88 37.88 37.88-10.12 10.12L22.88 53.3a7.134 7.134 0 0 1-2.097-5.06z" }));
});

var _extends$4u = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4t(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChevronLeftSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4t(_ref, ["styles"]);

  return React.createElement("svg", _extends$4u({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M29.975 48.048a4.756 4.756 0 0 1 1.398-3.373L60 16.048l6.746 6.746-25.253 25.254 25.253 25.254L60 80.048 31.373 51.42a4.756 4.756 0 0 1-1.398-3.373z" }));
});

var _extends$4v = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4u(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChevronLeftSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4u(_ref, ["styles"]);

  return React.createElement("svg", _extends$4v({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M38.434 48.12l26.234 25.894a3.449 3.449 0 0 1 0 4.91 3.54 3.54 0 0 1-4.973 0L31.3 50.896a3.437 3.437 0 0 1-.784-1.182 3.45 3.45 0 0 1 .574-4.164l28.845-28.474a3.54 3.54 0 0 1 4.973 0 3.449 3.449 0 0 1 0 4.91z" }));
});

var _extends$4w = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4v(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChevronRightSolidLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4v(_ref, ["styles"]);

  return React.createElement("svg", _extends$4w({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M75.94 48.24a7.134 7.134 0 0 0-2.098-5.059L30.902.241l-10.12 10.12 37.88 37.88-37.88 37.88 10.12 10.12 42.94-42.94a7.134 7.134 0 0 0 2.097-5.06z" }));
});

var _extends$4x = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4w(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChevronRightSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4w(_ref, ["styles"]);

  return React.createElement("svg", _extends$4x({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M66.746 48.048a4.756 4.756 0 0 0-1.398-3.373L36.722 16.048l-6.747 6.746 25.253 25.254-25.253 25.254 6.747 6.746L65.348 51.42a4.756 4.756 0 0 0 1.398-3.373z" }));
});

var _extends$4y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4x(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$k = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4x(_ref, ["styles"]);

  return React.createElement("svg", _extends$4y({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48.36 20.662a7.134 7.134 0 0 0-5.06 2.097L.36 65.7l10.12 10.12 37.88-37.88 37.881 37.88 10.12-10.12-42.94-42.94a7.134 7.134 0 0 0-5.06-2.097z" }));
});

var _extends$4z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4y(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChevronUpSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4y(_ref, ["styles"]);

  return React.createElement("svg", _extends$4z({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48.36 29.662a4.756 4.756 0 0 0-3.373 1.398L16.361 59.687l6.746 6.747L48.361 41.18l25.253 25.254 6.747-6.747L51.734 31.06a4.756 4.756 0 0 0-3.373-1.398z" }));
});

var _extends$4A = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4z(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconSwitch = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4z(_ref, ["styles"]);

  return React.createElement("svg", _extends$4A({ height: "21", viewBox: "0 0 23 21", width: "23", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M9 14.168h5.831a.861.861 0 0 0 .861-.861V9l5.728 5.168-5.728 5.168V15.89M13.42 6.168H7.589a.861.861 0 0 0-.861.861v4.307L1 6.168 6.728 1v3.445", fill: "none", stroke: "hsl(5, 88%, 47%)", strokeLinejoin: "round", strokeWidth: "2" }));
});

var _extends$4B = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4A(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTriangleDownSolidLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4A(_ref, ["styles"]);

  return React.createElement("svg", _extends$4B({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M94.71 14.312L48 82.355 1.29 14.312" }));
});

var _extends$4C = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4B(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTriangleDownSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4B(_ref, ["styles"]);

  return React.createElement("svg", _extends$4C({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M78.86 25.624L47.72 70.986 16.582 25.624" }));
});

var _extends$4D = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4C(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTriangleLeftSolidLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4C(_ref, ["styles"]);

  return React.createElement("svg", _extends$4D({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M82.227 94.85L14.184 48.142 82.227 1.432" }));
});

var _extends$4E = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4D(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTriangleLeftSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4D(_ref, ["styles"]);

  return React.createElement("svg", _extends$4E({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M70.539 16.37L25.177 47.51l45.362 31.14" }));
});

var _extends$4F = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4E(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTriangleRightSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4E(_ref, ["styles"]);

  return React.createElement("svg", _extends$4F({ height: "16", viewBox: "0 0 96 96", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M25.678 16.664l45.362 31.14-45.362 31.14" }));
});

var _extends$4G = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4F(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTriangleUpSolidLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4F(_ref, ["styles"]);

  return React.createElement("svg", _extends$4G({ height: "16", viewBox: "0 0 96 96", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M95 81.667L48.29 13.624 1.582 81.667" }));
});

var _extends$4H = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4G(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTriangleUpSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4G(_ref, ["styles"]);

  return React.createElement("svg", _extends$4H({ width: "16", height: "16", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M79.151 70.298l-31.14-45.362-31.139 45.362" }));
});

var _extends$4I = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4H(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconBriefcaseBrandedLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4H(_ref, ["styles"]);

  return React.createElement("svg", _extends$4I({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fill: "#D3211D", d: "M1.72 89.391h90.958V25.436H1.72z" }), React.createElement("path", { d: "M60.175 28.131h7.846c.523 0 .95-.428.95-.95v-4.519a.952.952 0 0 0-.95-.949h-7.846a.952.952 0 0 0-.95.949v4.518c0 .523.427.951.95.951M26.352 28.131h7.844a.955.955 0 0 0 .953-.95v-4.519a.954.954 0 0 0-.953-.949h-7.844a.952.952 0 0 0-.953.949v4.518c0 .523.428.951.953.951", fill: "#FEFEFE" }), React.createElement("path", { d: "M66.149 21.713l-.01-5.33-.297-1.442c-.721-1.97-1.732-3.197-3.523-4.288-1.16-.562-2.123-.827-3.414-.891l-24.064.034-1.442.295c-2.217.815-3.572 2.041-4.598 4.17a8.758 8.758 0 0 0-.582 2.771l.01 4.681h4.095v-4.58a3.28 3.28 0 0 1 3.27-3.266h23.208a3.278 3.278 0 0 1 3.267 3.265v4.581h4.08z", fill: "#B2B2B1" }), React.createElement("path", { fill: "#B11B19", d: "M9.77 81.654h74.854V30.33H9.77z" }), React.createElement("path", { fill: "#E22719", d: "M.14 25.435h94.113v28.79l-18.792 3.316h-56.53L.14 54.226z" }), React.createElement("path", { d: "M1.719 89.39V78.649H3.13a2.15 2.15 0 0 1 2.143 2.143v5.043h5.043c1.176 0 2.141.963 2.141 2.14v1.415H1.718zM92.677 89.39V78.649h-1.415a2.15 2.15 0 0 0-2.142 2.143v5.043h-5.042a2.148 2.148 0 0 0-2.143 2.14v1.415h10.742z", fill: "#C5C5C5" }), React.createElement("path", { d: "M76.451 52.547v10.52c0 .986-.807 1.792-1.792 1.792h-7.682a1.797 1.797 0 0 1-1.792-1.792v-10.52c0-.986.806-1.794 1.792-1.794h7.682c.986 0 1.792.808 1.792 1.794", fill: "#FEFEFE" }), React.createElement("path", { fill: "#C5C5C5", d: "M67.708 62.332h6.216v-9.053h-6.216z" }), React.createElement("path", { d: "M29.208 52.547v10.52c0 .986-.805 1.792-1.792 1.792h-7.682a1.797 1.797 0 0 1-1.792-1.792v-10.52c0-.986.806-1.794 1.792-1.794h7.682c.987 0 1.792.808 1.792 1.794", fill: "#FEFEFE" }), React.createElement("path", { fill: "#C5C5C5", d: "M20.468 62.332h6.214v-9.053h-6.214z" }), React.createElement("path", { d: "M36.972 8.26H57.42c.741 0 1.348.607 1.348 1.347v5.134c0 .74-.607 1.346-1.348 1.346H36.972a1.35 1.35 0 0 1-1.344-1.346V9.607c0-.74.605-1.347 1.344-1.347", fill: "#E22719" }));
});

var _extends$4J = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4I(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconBriefcaseBrandedSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4I(_ref, ["styles"]);

  return React.createElement("svg", _extends$4J({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fill: "#D3211D", d: "M17.146 74.927h60.64V32.291h-60.64z" }), React.createElement("path", { d: "M56.117 34.087h5.23a.636.636 0 0 0 .634-.633V30.44a.635.635 0 0 0-.633-.632h-5.231a.635.635 0 0 0-.634.632v3.013c0 .348.285.633.634.633M33.568 34.087h5.23a.637.637 0 0 0 .634-.633V30.44a.636.636 0 0 0-.635-.632h-5.23a.635.635 0 0 0-.634.632v3.013c0 .348.285.633.635.633", fill: "#FEFEFE" }), React.createElement("path", { d: "M60.1 29.809l-.007-3.554-.198-.961c-.481-1.313-1.155-2.132-2.349-2.858-.773-.375-1.415-.552-2.276-.595l-16.042.023-.962.197c-1.478.543-2.381 1.36-3.065 2.78a5.838 5.838 0 0 0-.388 1.847l.006 3.12h2.73v-3.053c0-1.196.984-2.177 2.18-2.177H55.2c1.196 0 2.178.98 2.178 2.177v3.054h2.72z", fill: "#B2B2B1" }), React.createElement("path", { fill: "#B11B19", d: "M22.513 69.77h49.903V35.552H22.513z" }), React.createElement("path", { fill: "#E22719", d: "M16.093 32.29h62.742v19.194l-12.527 2.21H28.62l-12.528-2.21z" }), React.createElement("path", { d: "M17.146 74.927v-7.161h.941c.786 0 1.429.643 1.429 1.428v3.362h3.362c.784 0 1.427.642 1.427 1.428v.943h-7.16zM77.784 74.927v-7.161h-.942c-.786 0-1.429.643-1.429 1.428v3.362h-3.36c-.786 0-1.43.642-1.43 1.428v.943h7.161z", fill: "#C5C5C5" }), React.createElement("path", { d: "M66.967 50.365v7.013c0 .657-.538 1.194-1.194 1.194h-5.121a1.198 1.198 0 0 1-1.195-1.194v-7.013c0-.658.537-1.196 1.195-1.196h5.12c.658 0 1.195.538 1.195 1.196", fill: "#FEFEFE" }), React.createElement("path", { fill: "#C5C5C5", d: "M61.139 56.888h4.144v-6.035h-4.144z" }), React.createElement("path", { d: "M35.472 50.365v7.013c0 .657-.537 1.194-1.195 1.194h-5.12a1.198 1.198 0 0 1-1.195-1.194v-7.013c0-.658.537-1.196 1.194-1.196h5.121c.658 0 1.195.538 1.195 1.196", fill: "#FEFEFE" }), React.createElement("path", { fill: "#C5C5C5", d: "M29.646 56.888h4.142v-6.035h-4.142z" }), React.createElement("path", { d: "M40.648 20.84H54.28c.494 0 .899.405.899.898v3.423a.901.901 0 0 1-.9.897H40.65a.9.9 0 0 1-.897-.897v-3.423a.9.9 0 0 1 .896-.898", fill: "#E22719" }));
});

var _extends$4K = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4J(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMailBrandedLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4J(_ref, ["styles"]);

  return React.createElement("svg", _extends$4K({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fill: "#D3211D", d: "M48 6l48 27.871H0z" }), React.createElement("path", { fill: "#B11B19", d: "M0 89.613h96V33.87H0z" }), React.createElement("path", { fill: "#B11B19", d: "M48 89.613h48V33.87H48z" }), React.createElement("path", { fill: "#D3211D", d: "M48 61.742l48 27.87H0z" }), React.createElement("path", { fill: "#E22719", d: "M48 61.742L96 33.87H0z" }), React.createElement("path", { fill: "#FEFEFE", d: "M75.871 44.76V26.129h-57.29v18.63l28.645 16.983z" }), React.createElement("path", { d: "M41.162 56.17l6.956 4.024 6.956-4.024H41.162zM24.774 34.947h46.45v-4.173h-46.45v4.173zm1.76 12.757l7.206 4.17h28.758l7.204-4.17H26.534zm-1.76-8.464h46.45c.002 1.392.002 2.78 0 4.169h-46.45v-4.17z", fill: "#B2B2B1" }));
});

var _extends$4L = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4K(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMailBrandedSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4K(_ref, ["styles"]);

  return React.createElement("svg", _extends$4L({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fill: "#D3211D", d: "M48 20l32 18.58H16z" }), React.createElement("path", { fill: "#B11B19", d: "M16 75.742h64V38.58H16z" }), React.createElement("path", { fill: "#B11B19", d: "M48 75.742h32V38.58H48z" }), React.createElement("path", { fill: "#D3211D", d: "M48 57.161l32 18.58H16z" }), React.createElement("path", { fill: "#E22719", d: "M48 57.161l32-18.58H16z" }), React.createElement("path", { fill: "#FEFEFE", d: "M66.58 45.84V33.42H28.388v12.42L47.484 57.16z" }), React.createElement("path", { d: "M43.441 53.446l4.637 2.683 4.638-2.683H43.44zM32.516 39.298h30.967v-2.782H32.516v2.782zm1.173 8.505l4.804 2.78h19.172l4.803-2.78H33.689zm-1.173-5.643h30.967v2.78H32.516v-2.78z", fill: "#B2B2B1" }));
});

var _extends$4M = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4L(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChatSolidLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4L(_ref, ["styles"]);

  return React.createElement("svg", _extends$4M({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M68 4v20h-8V12H8v36h8v10.344L26.344 48l7.393.001c.006-4.833.995-12.421 6.337-17.872A14 14 0 1 1 59.898 49.9l-.039.038c-4.193 4.078-12.287 5.415-17.404 5.852C44.162 62.793 50.473 67.992 58 68h9.656L78 78.344V68h10V36H72v-8h24v48H86v7.172a6.006 6.006 0 0 1-6.004 6.002 5.988 5.988 0 0 1-4.238-1.758L64.344 76H58c-11.886-.013-21.75-8.655-23.664-20h-4.68L18.242 67.414a5.99 5.99 0 0 1-4.238 1.76A6.006 6.006 0 0 1 8 63.172V56H0V4zM50 34.004a5.978 5.978 0 0 0-4.242 1.754 17.625 17.625 0 0 0-4.02 12.066 24.726 24.726 0 0 0 12.524-3.603A5.996 5.996 0 0 0 50 34.004z" }));
});

var _extends$4N = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4M(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMailOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4M(_ref, ["styles"]);

  return React.createElement("svg", _extends$4N({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M96 88H0V36h8v44h80V28.441L54.492 55.13c-.172.121-.344.238-.508.355a11.971 11.971 0 0 1 3.711 8.797A9.838 9.838 0 0 1 47.996 74c-5.52-.007-9.991-4.48-9.996-10a13.455 13.455 0 0 1 3.828-8.61c-.113-.093-.23-.19-.352-.285L10.508 29.902l-6.719-5.156A9.27 9.27 0 0 1 9.273 8H96v8H9.273a1.272 1.272 0 0 0-.738 2.309l6.934 5.32 31.054 25.27c.473.382.93.755 1.372 1.117a67.13 67.13 0 0 1 1.828-1.305l33.253-26.496A8 8 0 0 1 96 28.44zM47.871 60.656A5.729 5.729 0 0 0 46 64.04 1.993 1.993 0 0 0 47.996 66a1.88 1.88 0 0 0 1.7-1.719c0-1.148-.247-1.996-1.825-3.625z" }));
});

var _extends$4O = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4N(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMailOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4N(_ref, ["styles"]);

  return React.createElement("svg", _extends$4O({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M80 74.333H15.998V39.667h5.333V69h53.334V34.628L52.327 52.419l-.339.237a7.98 7.98 0 0 1 2.474 5.865A6.559 6.559 0 0 1 47.996 65a6.672 6.672 0 0 1-6.664-6.667 8.97 8.97 0 0 1 2.552-5.74c-.075-.062-.153-.127-.234-.19L23.004 35.603l-4.479-3.438A6.18 6.18 0 0 1 22.181 21H80v5.333H22.181a.848.848 0 0 0-.492 1.54l4.623 3.546 20.703 16.847c.315.255.62.503.914.744.409-.302.815-.592 1.218-.87l22.17-17.663a5.334 5.334 0 0 1 8.682 4.15zM47.912 56.104a3.82 3.82 0 0 0-1.247 2.255 1.328 1.328 0 0 0 1.33 1.308 1.254 1.254 0 0 0 1.133-1.146c0-.766-.164-1.33-1.216-2.417z" }));
});

var _extends$4P = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4O(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMailReadOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4O(_ref, ["styles"]);

  return React.createElement("svg", _extends$4P({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M50.51 4.381l42.24 34.56a3.842 3.842 0 0 1-.454 6.267l-38.4 23.04-.075.052a11.47 11.47 0 0 1 3.567 8.445 9.444 9.444 0 0 1-9.312 9.33 9.608 9.608 0 0 1-9.596-9.6 12.917 12.917 0 0 1 3.675-8.265l-.128-.105L9.68 48.699v39.296h76.8v-38.4h7.68v42.24a3.84 3.84 0 0 1-3.84 3.84H5.84A3.84 3.84 0 0 1 2 91.835v-49.92a3.84 3.84 0 0 1 5.816-3.292l38.4 23.04c.155.094.304.198.447.31.453.372.892.728 1.316 1.077a64.444 64.444 0 0 1 1.755-1.253l33.93-20.366-35.625-29.148L15.9 37.673l-4.762-6.03L45.699 4.34a3.836 3.836 0 0 1 4.811.041zm-2.569 68.865a5.566 5.566 0 0 0-1.781 3.267 1.913 1.913 0 0 0 1.916 1.882 1.805 1.805 0 0 0 1.631-1.65c0-1.106-.236-1.924-1.766-3.499zM71.12 38.075v7.68H25.04v-7.68z" }));
});

var _extends$4Q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4P(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMailReadOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4P(_ref, ["styles"]);

  return React.createElement("svg", _extends$4Q({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M49.34 18.93L77.5 41.97a2.561 2.561 0 0 1-.302 4.177l-25.6 15.36-.05.035a7.647 7.647 0 0 1 2.377 5.63 6.296 6.296 0 0 1-6.208 6.22 6.405 6.405 0 0 1-6.397-6.4 8.611 8.611 0 0 1 2.45-5.51l-.085-.07L22.12 48.474v26.198h51.2v-25.6h5.12v28.16a2.56 2.56 0 0 1-2.56 2.56H19.56a2.56 2.56 0 0 1-2.56-2.56v-33.28a2.56 2.56 0 0 1 3.878-2.195l25.6 15.36c.103.063.202.132.297.207.302.248.595.485.877.718.393-.29.783-.569 1.17-.835l22.62-13.578-23.75-19.432-21.424 16.927-3.176-4.02 23.04-18.202a2.558 2.558 0 0 1 3.208.027zm-1.712 45.91a3.71 3.71 0 0 0-1.188 2.177c.011.697.58 1.256 1.277 1.255a1.204 1.204 0 0 0 1.088-1.1c0-.738-.158-1.283-1.177-2.333zM63.08 41.391v5.12H32.36v-5.12z" }));
});

var _extends$4R = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4Q(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMailSentOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4Q(_ref, ["styles"]);

  return React.createElement("svg", _extends$4R({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M31.132 57.703L9.907 47.585 76.88 14.356l-45.75 43.347zM48.27 86.395L35.4 61.94l47.181-44.703-34.312 69.16zM95.334 1.32c-.09-.132-.198-.234-.306-.348-.111-.105-.213-.213-.34-.3-.726-.56-1.653-.828-2.598-.576L2.283 44.654c-.057.015-.1.06-.153.078-.972.282-1.788 1.002-2.055 2.061-.135.537-.072 1.068.072 1.572.003.015 0 .024.003.04.009.032.033.056.042.092.105.306.237.594.426.862.09.129.195.234.306.348.153.162.306.306.495.435.156.108.32.177.498.252.138.063.252.162.402.207l27.237 12.985 15.845 30.1c.042.156.147.27.21.414.072.171.144.33.246.483.13.186.276.34.438.495.114.108.22.216.351.31.265.185.547.314.856.416.036.012.057.04.093.048.015.003.03 0 .045.003.504.144 1.035.204 1.569.07 1.059-.265 1.773-1.078 2.061-2.05.018-.057.06-.096.075-.153L95.907 3.91c.252-.94-.015-1.87-.573-2.59z" }));
});

var _extends$4S = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4R(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconReplySolidLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4R(_ref, ["styles"]);

  return React.createElement("svg", _extends$4S({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M37.333 28.187V6L0 44.827l37.333 38.826V60.912C64 60.912 82.667 69.787 96 89.2c-5.333-27.733-21.333-55.467-58.667-61.013z" }));
});

var _extends$4T = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4S(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconReplySolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4S(_ref, ["styles"]);

  return React.createElement("svg", _extends$4T({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M40.889 34.791V20L16 45.884 40.889 71.77V56.608c17.778 0 30.222 5.916 39.111 18.859-3.555-18.49-14.222-36.978-39.111-40.676z" }));
});

var _extends$4U = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4T(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTelephoneOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4T(_ref, ["styles"]);

  return React.createElement("svg", _extends$4U({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M35.963.76c5.454 1.818 12.068 8.432 13.885 13.886 1.286 3.856.955 6.834-1.096 9.63l-.49.633-.549.634-.708.747-3.763 3.772.024.078c.698 1.942 2.602 4.787 5.744 8.353l1.538 1.696c.542.583 1.114 1.181 1.715 1.796l.872.88c5.312 5.313 9.523 8.514 12.234 9.675l.565.218 3.776-3.763.747-.708.634-.55.633-.49c2.796-2.05 5.774-2.38 9.63-1.095 5.454 1.817 12.068 8.431 13.886 13.885 1.285 3.856.954 6.834-1.097 9.63l-.489.633-.55.634-.708.747-2.168 2.179a30.247 30.247 0 0 1-2.128 1.883c-2.265 1.814-4.616 3.11-7.155 3.666-5.477 1.201-10.925.783-16.76-1.014l-1.353-.44 2.587-7.595c5.056 1.722 9.472 2.162 13.807 1.211 1.147-.251 2.473-.982 3.858-2.091a22.358 22.358 0 0 0 1.566-1.389l1.862-1.87.727-.768.308-.366.126-.165c.331-.452.422-.712.211-1.512l-.257-.836c-1.019-3.057-5.753-7.79-8.81-8.81-1.335-.445-1.693-.471-2.164-.173l-.349.253-.366.309-.767.726-5.015 5.008a4.012 4.012 0 0 1-2.837 1.175c-5.223 0-11.56-4.225-19.858-12.523S34.938 33.904 34.938 28.681c0-.887.293-1.744.827-2.44l.348-.397 5.296-5.311.438-.471.309-.366.126-.165c.425-.58.455-.846-.046-2.348-1.02-3.057-5.753-7.791-8.81-8.81l-.836-.257c-.686-.181-.975-.14-1.328.084l-.35.253-.365.308-.768.727-1.87 1.862a22.358 22.358 0 0 0-1.389 1.566c-1.11 1.385-1.84 2.711-2.091 3.858-2.02 9.213 2.427 22.68 16.158 36.273l1.398 1.348 2.211 2.01a73.61 73.61 0 0 1 3.505 3.386c6.303 6.553 9.42 12.877 7.388 19.591-.718 2.373-2.093 4.582-4.107 6.596-5.388 5.388-15.269 5.386-23.835 2.296l-.556-.21-.763.557c-5.781 4.018-14.066 6.34-24.346 6.542L0 95.178v-8.025c7.61 0 13.685-1.313 18.108-3.313l.347-.165-.17-.125c-2.322-1.76-4.225-3.783-5.471-5.976l-.354-.662c-2.743-5.485-1.304-11.683 3.127-15.027 4.719-3.562 11.078-2.656 15.554 2.61 3.968 4.668 4.456 11.01 1.535 16.605l-.223.396.678.176c4.633 1.105 9.232 1.018 11.733-.972l.444-.396c1.11-1.11 1.78-2.186 2.101-3.246.935-3.09-1.02-7.056-5.491-11.704l-1.464-1.463c-.257-.248-.523-.5-.8-.759l-3.475-3.18C19.599 44.115 13.894 27.352 16.59 15.054c.556-2.54 1.852-4.89 3.666-7.155.397-.495.805-.97 1.23-1.435l.807-.85 2.42-2.391.676-.617c.105-.09.207-.177.31-.261l.633-.49c2.796-2.05 5.774-2.381 9.63-1.096zM25.027 69.692c-1.792-2.109-3.372-2.334-4.606-1.402-1.337 1.008-1.8 3.002-.784 5.033.93 1.861 2.856 3.603 5.274 5.053l.256.148.275-.4c1.745-2.698 1.748-5.588-.106-8.048z" }));
});

var _extends$4V = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4U(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTelephoneOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4U(_ref, ["styles"]);

  return React.createElement("svg", _extends$4V({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M39.975 16.507c3.636 1.212 8.045 5.621 9.257 9.257.857 2.57.637 4.556-.73 6.42l-.327.422-.366.422-.472.498-2.51 2.515.017.052c.465 1.295 1.734 3.191 3.83 5.569l1.025 1.131c.361.388.742.787 1.143 1.197l.581.587c3.542 3.541 6.349 5.676 8.156 6.45l.377.145 2.518-2.509.498-.472.422-.366.422-.326c1.864-1.368 3.85-1.588 6.42-.731 3.636 1.212 8.045 5.62 9.257 9.257.857 2.57.637 4.555-.73 6.42l-.327.422-.367.422-.471.498-1.446 1.453c-.46.445-.924.859-1.419 1.255-1.51 1.21-3.077 2.073-4.77 2.445-3.65.8-7.283.521-11.173-.677l-.902-.293 1.724-5.063c3.371 1.148 6.315 1.44 9.206.807.764-.167 1.648-.655 2.571-1.394.354-.284.697-.59 1.045-.926l1.24-1.247.485-.512.206-.244.084-.11c.22-.3.281-.474.14-1.008l-.17-.557c-.68-2.038-3.836-5.194-5.874-5.873-.89-.297-1.129-.315-1.443-.115l-.233.168-.244.206-.511.484-3.343 3.339a2.675 2.675 0 0 1-1.891.783c-3.483 0-7.708-2.817-13.24-8.348s-8.348-9.757-8.348-13.24c0-.59.196-1.162.551-1.626l.232-.265 3.53-3.54.293-.314.206-.244.084-.11c.284-.388.303-.564-.03-1.566-.68-2.038-3.836-5.194-5.874-5.873l-.557-.171c-.457-.121-.65-.094-.886.056l-.232.168-.244.206-.512.484-1.247 1.241c-.336.348-.642.69-.926 1.045-.74.923-1.227 1.807-1.394 2.571-1.347 6.143 1.618 15.121 10.772 24.182l.932.9 1.474 1.34c.886.808 1.62 1.511 2.337 2.257 4.202 4.368 6.28 8.584 4.925 13.06-.478 1.582-1.395 3.055-2.738 4.398-3.592 3.592-10.18 3.59-15.89 1.53l-.37-.14-.51.372c-3.854 2.679-9.377 4.226-16.23 4.361l-.988.01v-5.35c5.073 0 9.123-.875 12.072-2.209l.231-.11-.113-.083c-1.548-1.173-2.817-2.522-3.648-3.984l-.236-.442c-1.828-3.656-.868-7.788 2.085-10.018 3.146-2.374 7.386-1.77 10.37 1.74 2.645 3.113 2.97 7.34 1.023 11.07l-.149.265.453.117c3.088.737 6.154.679 7.821-.648l.296-.264c.74-.74 1.187-1.458 1.401-2.164.623-2.06-.68-4.704-3.66-7.803l-.977-.975a48.557 48.557 0 0 0-.533-.506l-2.317-2.12C29.066 45.41 25.263 34.235 27.06 26.037c.372-1.693 1.235-3.26 2.445-4.77.264-.33.536-.646.82-.957l.537-.567 1.614-1.594.45-.41c.07-.062.139-.12.207-.175l.422-.326c1.865-1.368 3.85-1.588 6.42-.731zm-7.29 45.954c-1.195-1.406-2.248-1.556-3.071-.935-.891.673-1.2 2.002-.523 3.356.62 1.24 1.905 2.402 3.516 3.368l.171.099.183-.267c1.164-1.798 1.166-3.725-.07-5.365z" }));
});

var _extends$4W = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4V(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconBuildingOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4V(_ref, ["styles"]);

  return React.createElement("svg", _extends$4W({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M29.333 26.667V32h-8v42.667h18.722c1.092-.101 2.167-.341 3.198-.715a10.427 10.427 0 0 1-3.006-5.74 8.06 8.06 0 0 1 2.006-7.095c.07-.08.147-.154.226-.225a8.027 8.027 0 0 1 11.021-.038 8.846 8.846 0 0 1 .432 12.059c-.311.378-.645.737-1 1.075 1.06.36 2.16.588 3.276.681l18.459-.002V32h-8v-5.333h10.666A2.667 2.667 0 0 1 80 29.333v45.334A5.34 5.34 0 0 1 74.667 80H56.055c-.078 0-.232-.01-.31-.017a18.982 18.982 0 0 1-7.727-2.372 19.053 19.053 0 0 1-7.734 2.379l-18.95.01A5.34 5.34 0 0 1 16 74.667V29.674a3.01 3.01 0 0 1 3.008-3.007zm18.67 37.336a2.662 2.662 0 0 0-1.883.794 2.762 2.762 0 0 0-.597 2.627 5.357 5.357 0 0 0 1.914 3.144l.602.518a8.132 8.132 0 0 0 1.693-1.456 3.642 3.642 0 0 0 .161-4.853 2.662 2.662 0 0 0-1.89-.774zM64 16v53.333h-5.333v-48H37.333v48H32V16zM29.333 58.667V64H24v-5.333zm42.667 0V64h-5.333v-5.333zM29.333 48v5.333H24V48zM72 48v5.333h-5.333V48zm-18.667 0v5.333H42.667V48zm-24-10.667v5.334H24v-5.334zm42.667 0v5.334h-5.333v-5.334zm-18.667 0v5.334H42.667v-5.334zm0-10.666V32H42.667v-5.333z" }));
});

var _extends$4X = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4W(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCalculatorOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4W(_ref, ["styles"]);

  return React.createElement("svg", _extends$4X({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M91 0v8H11v80h72V28a4.004 4.004 0 0 0-4-4H27a4 4 0 1 0 0 8h44v8H27c-6.627 0-12-5.373-12-12s5.373-12 12-12h52c6.624.007 11.993 5.376 12 12v68H3V0zM27.258 72v8h-8.516v-8zm16 0v8h-8.516v-8zm16 0v8h-8.516v-8zM75 60v20h-8V60zm-47.742 0v8h-8.516v-8zm16 0v8h-8.516v-8zm16 0v8h-8.516v-8zm-32-12v8h-8.516v-8zm16 0v8h-8.516v-8zm16 0v8h-8.516v-8zm16 0v8h-8.516v-8z" }));
});

var _extends$4Y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4X(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCalculatorOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4X(_ref, ["styles"]);

  return React.createElement("svg", _extends$4Y({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M77.667 16v5.333H24.333v53.334h48v-40A2.67 2.67 0 0 0 69.667 32H35a2.667 2.667 0 0 0 0 5.333h29.333v5.334H35a8 8 0 0 1 0-16h34.667a8.009 8.009 0 0 1 8 8V80H19V16zM35.172 64v5.333h-5.677V64zm10.667 0v5.333H40.16V64zm10.666 0v5.333h-5.677V64zM67 56v13.333h-5.333V56zm-31.828 0v5.333h-5.677V56zm10.667 0v5.333H40.16V56zm10.666 0v5.333h-5.677V56zm-21.333-8v5.333h-5.677V48zm10.667 0v5.333H40.16V48zm10.666 0v5.333h-5.677V48zm10.667 0v5.333h-5.677V48z" }));
});

var _extends$4Z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4Y(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCalendaroutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4Y(_ref, ["styles"]);

  return React.createElement("svg", _extends$4Z({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M21-1c2.786.138 5.506.897 7.96 2.223A18.463 18.463 0 0 1 36.989-1H57c2.802.13 5.538.89 8.004 2.225A19.463 19.463 0 0 1 73.012-1H83c6.624.007 11.993 5.376 12 12v14.041c-.002 6.627-5.373 11.998-12 12h-.004l-68-.041.008-8L83 29.041c2.209 0 4-1.791 4-4V11a4.004 4.004 0 0 0-4-4H73c-.14.129-.637.043-1.066.133A16.705 16.705 0 0 1 75 17c0 5.523-4.477 10-10 10s-10-4.477-10-10a16.825 16.825 0 0 1 3.086-9.857A5.792 5.792 0 0 0 56.973 7H37a5.53 5.53 0 0 0-1.082.135A16.665 16.665 0 0 1 39 17c0 5.523-4.477 10-10 10s-10-4.477-10-10a16.751 16.751 0 0 1 3.043-9.86A5.805 5.805 0 0 0 20.957 7H11a4.004 4.004 0 0 0-4 4v76h80V45.045h8V95H-1V11C-.993 4.376 4.376-.993 11-1zm6.258 72v8h-8.516v-8zm16 0v8h-8.516v-8zm16 0v8h-8.516v-8zm16 0v8h-8.516v-8zm-48-12v8h-8.516v-8zm16 0v8h-8.516v-8zm16 0v8h-8.516v-8zm16 0v8h-8.516v-8zm-48-12v8h-8.516v-8zm16 0v8h-8.516v-8zm16 0v8h-8.516v-8zm16 0v8h-8.516v-8zM65.004 11.258A8.836 8.836 0 0 0 63 17a2 2 0 1 0 4 0 8.903 8.903 0 0 0-1.996-5.742zm-36.02-.004A8.943 8.943 0 0 0 27 17a2 2 0 0 0 4 0 8.86 8.86 0 0 0-2.016-5.746z" }));
});

var _extends$4_ = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4Z(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCalendaroutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4Z(_ref, ["styles"]);

  return React.createElement("svg", _extends$4_({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M30.667 16c1.857.092 3.67.598 5.307 1.482A12.309 12.309 0 0 1 41.326 16h13.34c1.868.086 3.692.593 5.337 1.483A12.975 12.975 0 0 1 65.34 16H72a8.009 8.009 0 0 1 8 8v9.36a8.002 8.002 0 0 1-8 8h-.003l-45.333-.027.005-5.333L72 36.027a2.667 2.667 0 0 0 2.667-2.666V24A2.67 2.67 0 0 0 72 21.333h-6.667c-.093.086-.424.029-.71.089A11.136 11.136 0 0 1 66.666 28a6.667 6.667 0 0 1-13.334 0c-.02-2.352.7-4.651 2.058-6.572a3.862 3.862 0 0 0-.743-.095H41.333a3.686 3.686 0 0 0-.721.09A11.11 11.11 0 0 1 42.667 28a6.667 6.667 0 0 1-13.334 0c-.032-2.35.678-4.65 2.029-6.573a3.87 3.87 0 0 0-.724-.094H24A2.67 2.67 0 0 0 21.333 24v50.667h53.334v-27.97H80V80H16V24a8.009 8.009 0 0 1 8-8zm4.172 48v5.333H29.16V64zm10.666 0v5.333h-5.677V64zm10.667 0v5.333h-5.677V64zm10.667 0v5.333H61.16V64zm-32-8v5.333H29.16V56zm10.666 0v5.333h-5.677V56zm10.667 0v5.333h-5.677V56zm10.667 0v5.333H61.16V56zm-32-8v5.333H29.16V48zm10.666 0v5.333h-5.677V48zm10.667 0v5.333h-5.677V48zm10.667 0v5.333H61.16V48zm-6.836-23.828A5.89 5.89 0 0 0 58.667 28a1.333 1.333 0 1 0 2.666 0 5.935 5.935 0 0 0-1.33-3.828zm-24.013-.003A5.962 5.962 0 0 0 34.667 28a1.333 1.333 0 0 0 2.666 0 5.906 5.906 0 0 0-1.343-3.83z" }));
});

var _extends$4$ = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4_(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCoinsOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4_(_ref, ["styles"]);

  return React.createElement("svg", _extends$4$({ xmlns: "http://www.w3.org/2000/svg", width: "64", height: "64", viewBox: "0 0 64 64" }, props), React.createElement("path", { d: "M32.5 29.54c-13.577 0-24.583-5.509-24.583-12.307 0-6.796 11.006-12.308 24.583-12.308 13.575 0 24.583 5.512 24.583 12.308 0 6.798-11.008 12.307-24.583 12.307m0 9.846c-13.577 0-24.583-5.51-24.583-12.308 0-.1.027-.199.032-.297 5.285 4.63 14.305 7.682 24.551 7.682 10.246 0 19.266-3.053 24.551-7.685.005.101.032.2.032.3 0 6.799-11.008 12.308-24.583 12.308m0 9.848c-13.577 0-24.583-5.511-24.583-12.31 0-.1.027-.2.032-.3 5.285 4.63 14.305 7.684 24.551 7.684 10.246 0 19.264-3.054 24.551-7.684.005.1.032.2.032.3 0 6.799-11.008 12.31-24.583 12.31m0 9.843c-13.577 0-24.583-5.509-24.583-12.307 0-.101.027-.2.032-.3 5.285 4.632 14.305 7.684 24.551 7.684 10.246 0 19.264-3.052 24.551-7.684.005.1.032.199.032.3 0 6.798-11.008 12.307-24.583 12.307m28.261-36.922c.796-1.56 1.239-3.21 1.239-4.922C62 7.719 48.791 0 32.5 0 16.206 0 3 7.72 3 17.233c0 1.713.442 3.362 1.239 4.922C3.443 23.716 3 25.368 3 27.078c0 1.711.442 3.363 1.239 4.923C3.443 33.561 3 35.213 3 36.924c0 1.71.442 3.362 1.239 4.923C3.443 43.407 3 45.059 3 46.77 3 56.283 16.206 64 32.5 64 48.791 64 62 56.283 62 46.77c0-1.71-.443-3.362-1.239-4.923.796-1.56 1.239-3.212 1.239-4.923 0-1.71-.443-3.362-1.239-4.923.796-1.56 1.239-3.212 1.239-4.923 0-1.71-.443-3.362-1.239-4.923" }));
});

var _extends$50 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4$(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCoinsOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4$(_ref, ["styles"]);

  return React.createElement("svg", _extends$50({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12.375 11.385c-3.394 0-6.146-1.377-6.146-3.077 0-1.699 2.752-3.077 6.146-3.077s6.146 1.378 6.146 3.077c0 1.7-2.752 3.077-6.146 3.077m0 2.461c-3.394 0-6.146-1.377-6.146-3.076 0-.026.007-.05.008-.075 1.322 1.158 3.576 1.92 6.138 1.92s4.816-.762 6.138-1.92c.001.025.008.05.008.075 0 1.7-2.752 3.076-6.146 3.076m0 2.462c-3.394 0-6.146-1.377-6.146-3.077 0-.025.007-.05.008-.075 1.322 1.157 3.576 1.921 6.138 1.921s4.816-.764 6.138-1.921c.001.025.008.05.008.075 0 1.7-2.752 3.077-6.146 3.077m0 2.461c-3.394 0-6.146-1.377-6.146-3.077 0-.025.007-.05.008-.075 1.322 1.159 3.576 1.922 6.138 1.922s4.816-.763 6.138-1.922c.001.026.008.05.008.075 0 1.7-2.752 3.077-6.146 3.077m7.065-9.23c.2-.39.31-.803.31-1.23C19.75 5.928 16.448 4 12.375 4S5 5.93 5 8.308c0 .428.11.84.31 1.23-.2.391-.31.804-.31 1.232 0 .427.11.84.31 1.23-.2.39-.31.803-.31 1.231 0 .428.11.84.31 1.23-.2.39-.31.804-.31 1.231C5 18.071 8.302 20 12.375 20s7.375-1.93 7.375-4.308c0-.427-.11-.84-.31-1.23.2-.39.31-.803.31-1.231 0-.428-.11-.84-.31-1.23.2-.39.31-.804.31-1.231 0-.428-.11-.841-.31-1.231" }));
});

var _extends$51 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$50(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCreditCardOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$50(_ref, ["styles"]);

  return React.createElement("svg", _extends$51({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M77.333 25A2.667 2.667 0 0 1 80 27.667V49.52a5.333 5.333 0 0 1-1.562 3.771l-.836.836.836.836c1 1 1.562 2.357 1.562 3.772v8.93a2.667 2.667 0 0 1-2.667 2.667H18.667A2.667 2.667 0 0 1 16 67.667v-40A2.667 2.667 0 0 1 18.667 25zm-2.666 5.333H21.333V65h53.334v-6.264l-.835-.837-1.17 1.17c-2.568 2.685-6.688 3.08-9.775.946l-.415-.306a7.334 7.334 0 0 1-2.574-5.58c0-2.148.94-4.187 2.651-5.644a7.53 7.53 0 0 1 9.73.33l.36.35 1.19 1.19.838-.834zm-37.334 24v5.334H26.667v-5.334zm13.334 0v5.334H40v-5.334zm15.267-1.727c-.446.38-.703.937-.703 1.523 0 .585.257 1.142.626 1.459.808.639 1.937.623 2.756-.032l.235-.216 1.212-1.212-1.253-1.253c-.783-.82-2.061-.908-2.873-.269zm-15.267-6.273v5.334h-24v-5.334zm18.666-10.666V41H26.667v-5.333z" }));
});

var _extends$52 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$51(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLoanOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$51(_ref, ["styles"]);

  return React.createElement("svg", _extends$52({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M2 1v14h12V1H2zM1 0h14v16H1V0zm3.552 4.983a.654.654 0 0 1-.182.478h-.305A.067.067 0 0 0 4 5.526v.409c0 .035.03.065.065.065h1.94c.034 0 .065-.03.065-.065v-.409a.067.067 0 0 0-.066-.065H4.952a.85.85 0 0 0 .174-.513c0-.022-.004-.044-.004-.065h.63c.04 0 .065-.03.065-.07v-.365a.064.064 0 0 0-.065-.065h-.76a1.468 1.468 0 0 1-.092-.448.41.41 0 0 1 .117-.3.496.496 0 0 1 .353-.126c.152 0 .3.039.456.121.03.018.065.01.083-.026l.165-.343a.064.064 0 0 0-.026-.083A1.48 1.48 0 0 0 5.313 3c-.317 0-.56.096-.735.252a.846.846 0 0 0-.274.652c0 .17.044.326.092.479h-.23a.067.067 0 0 0-.066.065v.365c0 .04.03.07.065.07h.378c.005.034.01.07.01.1zM7 4v1h5V4H7zM4 8v1h4V8H4zm6 0v1h2V8h-2zm-6 2v1h4v-1H4zm6 0v1h2v-1h-2zm-6 2v1h4v-1H4zm6 0v1h2v-1h-2z" }));
});

var _extends$53 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$52(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLoanOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$52(_ref, ["styles"]);

  return React.createElement("svg", _extends$53({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M6 5v14h12V5H6zM5 4h14v16H5V4zm3.552 4.983a.654.654 0 0 1-.182.478h-.305A.067.067 0 0 0 8 9.526v.409c0 .035.03.065.065.065h1.94c.034 0 .065-.03.065-.065v-.409a.067.067 0 0 0-.066-.065H8.952a.85.85 0 0 0 .174-.513c0-.022-.004-.044-.004-.065h.63c.04 0 .065-.03.065-.07v-.365a.064.064 0 0 0-.065-.065h-.76a1.468 1.468 0 0 1-.092-.448.41.41 0 0 1 .117-.3.496.496 0 0 1 .353-.126c.152 0 .3.039.456.121.03.018.065.01.083-.026l.165-.343a.064.064 0 0 0-.026-.083A1.48 1.48 0 0 0 9.313 7c-.317 0-.56.096-.735.252a.846.846 0 0 0-.274.652c0 .17.044.326.092.479h-.23a.067.067 0 0 0-.066.065v.365c0 .04.03.07.065.07h.378c.005.034.01.07.01.1zM11 8v1h5V8h-5zm-3 4v1h4v-1H8zm6 0v1h2v-1h-2zm-6 2v1h4v-1H8zm6 0v1h2v-1h-2zm-6 2v1h4v-1H8zm6 0v1h2v-1h-2z" }));
});

var _extends$54 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$53(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPoundOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$53(_ref, ["styles"]);

  return React.createElement("svg", _extends$54({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M75.063 71.541v.822a14.99 14.99 0 0 1-2.734 9.625 9.148 9.148 0 0 1-7.49 3.296 15.474 15.474 0 0 1-7.237-1.836 57.244 57.244 0 0 1-7.943-5.236 32.288 32.288 0 0 0 1.152-8.29c.017-3.4-.558-6.776-1.7-9.979a51.112 51.112 0 0 0-3.887-8.202h24.995v-8.715H39.251a98.515 98.515 0 0 1-6.616-10.288 17.49 17.49 0 0 1-2.12-8.281 13.375 13.375 0 0 1 5.213-10.785 20.992 20.992 0 0 1 13.637-4.318 21.591 21.591 0 0 1 14.14 4.573 15.505 15.505 0 0 1 5.85 11.606l.04.78h9.974l-.017-.839a23.938 23.938 0 0 0-4.073-13.162 26.48 26.48 0 0 0-10.662-9.078A34.525 34.525 0 0 0 49.49.004a34.725 34.725 0 0 0-15.058 3.163 25.636 25.636 0 0 0-10.473 8.824 22.126 22.126 0 0 0-3.822 12.595 24.09 24.09 0 0 0 2.104 9.975 55.114 55.114 0 0 0 4.875 8.465H15.063v8.715h18.543a59.174 59.174 0 0 1 5.7 9.416 21.472 21.472 0 0 1 2.015 9.154c0 .488-.028 1.047-.088 1.673a27.602 27.602 0 0 0-14.7-4.94 16.268 16.268 0 0 0-11.06 3.863 12.823 12.823 0 0 0-4.469 10.059 12.392 12.392 0 0 0 4.543 9.88 18.066 18.066 0 0 0 12 3.787 23.349 23.349 0 0 0 10.639-2.394 21.154 21.154 0 0 0 7.28-6.008 57.528 57.528 0 0 0 9.639 6.008 24.886 24.886 0 0 0 10.876 2.394 17.567 17.567 0 0 0 14.061-5.936 24.511 24.511 0 0 0 5.02-16.334v-.822zm-36.828 9.087a13.466 13.466 0 0 1-4.182 3.796 12.708 12.708 0 0 1-6.507 1.632c-2 .146-3.99-.4-5.637-1.548a4.56 4.56 0 0 1-1.794-3.667 4.433 4.433 0 0 1 1.84-3.713 7.663 7.663 0 0 1 4.831-1.498 13.15 13.15 0 0 1 5.738 1.39 34.662 34.662 0 0 1 5.711 3.608z" }));
});

var _extends$55 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$54(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPoundOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$54(_ref, ["styles"]);

  return React.createElement("svg", _extends$55({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M66.182 64.624v.548a9.993 9.993 0 0 1-1.822 6.416 6.099 6.099 0 0 1-4.993 2.198 10.316 10.316 0 0 1-4.825-1.224 38.162 38.162 0 0 1-5.295-3.49c.494-1.802.752-3.66.768-5.527a19.529 19.529 0 0 0-1.134-6.653 34.075 34.075 0 0 0-2.591-5.468h16.663v-5.81H42.308a65.677 65.677 0 0 1-4.41-6.86 11.66 11.66 0 0 1-1.414-5.52 8.917 8.917 0 0 1 3.475-7.19 13.995 13.995 0 0 1 9.091-2.878 14.394 14.394 0 0 1 9.427 3.048 10.337 10.337 0 0 1 3.9 7.738l.027.52h6.649l-.01-.56a15.959 15.959 0 0 0-2.716-8.774 17.653 17.653 0 0 0-7.108-6.053 23.016 23.016 0 0 0-10.085-2.152 23.15 23.15 0 0 0-10.039 2.108 17.09 17.09 0 0 0-6.982 5.882 14.75 14.75 0 0 0-2.548 8.397 16.06 16.06 0 0 0 1.403 6.65 36.743 36.743 0 0 0 3.25 5.644h-8.035v5.81h12.361a39.45 39.45 0 0 1 3.8 6.277 14.314 14.314 0 0 1 1.344 6.102c0 .326-.02.698-.059 1.116a18.401 18.401 0 0 0-9.8-3.293 10.845 10.845 0 0 0-7.373 2.575 8.549 8.549 0 0 0-2.98 6.706 8.261 8.261 0 0 0 3.03 6.586 12.044 12.044 0 0 0 7.999 2.525 15.566 15.566 0 0 0 7.093-1.596 14.102 14.102 0 0 0 4.854-4.005 38.352 38.352 0 0 0 6.425 4.005 16.59 16.59 0 0 0 7.25 1.596 11.711 11.711 0 0 0 9.375-3.957 16.34 16.34 0 0 0 3.346-10.89v-.547zm-24.551 6.058a8.977 8.977 0 0 1-2.789 2.53 8.472 8.472 0 0 1-4.337 1.088 5.831 5.831 0 0 1-3.758-1.032 3.04 3.04 0 0 1-1.197-2.445 2.955 2.955 0 0 1 1.227-2.475 5.108 5.108 0 0 1 3.22-.998 8.767 8.767 0 0 1 3.826.926 23.108 23.108 0 0 1 3.808 2.406z" }));
});

var _extends$56 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$55(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconWalletOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$55(_ref, ["styles"]);

  return React.createElement("svg", _extends$56({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M53.056 16l8.213 9.466 5.892-1.227 3.466 11.552h6.126v15.31a12.664 12.664 0 0 1-2.134 7.047l-.056.086a12.706 12.706 0 0 1 2.19 7.13V80H27.7a7.699 7.699 0 0 1-7.69-7.69V45.99h5.355v26.32a2.338 2.338 0 0 0 2.335 2.335h43.696v-9.28c0-.93-.176-1.85-.52-2.714a12.926 12.926 0 0 1-7.45 2.309 7.064 7.064 0 1 1-.005-14.128 10.708 10.708 0 0 1 7.377 3.177 7.33 7.33 0 0 0 .598-2.908v-9.954H25.823a5.81 5.81 0 1 1 0-11.62l11.284-.001zm10.36 40.187a1.709 1.709 0 0 0 .006 3.418 7.567 7.567 0 0 0 4.205-1.235 5.866 5.866 0 0 0-4.211-2.183zm1.62-20.396l-1.593-5.308-25.532 5.308zm-35.316 0l1.073-.91h-4.97a.455.455 0 1 0 0 .91zM52.48 23.51l-5.908 5.01 8.69-1.807z", fillRule: "evenodd" }));
});

var _extends$57 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$56(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCameraOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$56(_ref, ["styles"]);

  return React.createElement("svg", _extends$57({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M42 40c9.939 0 18 8.058 18 18 0 9.939-8.061 17.997-18 17.997-9.942 0-18-8.058-18-17.997 0-9.942 8.058-18 18-18zM18 58c0 13.254 10.746 24 24 24s24-10.746 24-24c0-13.257-10.746-24-24-24S18 44.743 18 58zm72 30H6V21.997h84V88zM6 16h24V9.997H6V16zm30 0V4H0v90h96V16H36zm30 18h18v-6H66v6z" }));
});

var _extends$58 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$57(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCarOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$57(_ref, ["styles"]);

  return React.createElement("svg", _extends$58({ height: "32", viewBox: "0 0 96 88", width: "32", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M76 0a4 4 0 0 1 3.622 2.303l.173.432L86.88 24H92a4 4 0 0 1 3.973 3.534L96 28v4a4 4 0 0 1-3.534 3.973L92 36h-4.008l-.019 31.534L88 68v16a4 4 0 0 1-3.534 3.973L84 88h-8a4 4 0 0 1-3.973-3.534L72 84V71.814a18.802 18.802 0 0 1-5.408-1.676l-.6-.31-.714.365c-1.9.901-3.97 1.486-6.186 1.72l-1.12.087H38l-1.12-.088a19.173 19.173 0 0 1-5.222-1.295l-.964-.424-.714-.365-.6.31a18.803 18.803 0 0 1-5.376 1.67L24 84a4 4 0 0 1-3.534 3.973L20 88h-8a4 4 0 0 1-3.973-3.534L8 84V40h8v24h6l.237-.017c-2.26-2.567-3.727-5.61-4.173-8.941-.578-5.2 3.458-9.57 9.091-10.763 3.337-.675 6.895-.145 9.728 1.489 3.146 1.813 5.132 4.843 5.118 8.512-.251 3.579-1.737 6.898-4.19 9.692l.4.034h19.55l.444-.035c-2.253-2.565-3.717-5.604-4.163-8.93-.577-5.199 3.459-9.57 9.092-10.762 3.337-.675 6.894-.145 9.728 1.489 3.146 1.813 5.132 4.843 5.118 8.512-.252 3.583-1.741 6.906-4.199 9.702l.191.018h6.004L80 28.652 73.116 8H56a4 4 0 0 1-3.534 3.973L52 12h-8a4 4 0 0 1-3.973-3.534L40 8H23.016L17.3 28H76v8H4a4 4 0 0 1-3.973-3.534L0 32v-4a4 4 0 0 1 3.534-3.973L4 24h6.124l6.03-21.099A4 4 0 0 1 19.519.03L20 0zM64.755 52.113c-1.913.405-2.833 1.402-2.773 1.955.255 1.9 1.258 3.742 2.875 5.31l.635.575.512.407.385-.298c1.766-1.461 2.929-3.168 3.391-4.864l.14-.635.07-.569c0-.283-.225-.674-.763-1.063l-.36-.232-.503-.25c-1.054-.447-2.384-.583-3.609-.336zm-35.978 0c-1.913.405-2.834 1.402-2.773 1.955.255 1.9 1.258 3.742 2.874 5.31l.635.575.511.407.386-.298c1.766-1.461 2.93-3.168 3.391-4.864l.14-.635.07-.569c0-.283-.225-.674-.762-1.063l-.36-.232-.503-.25c-1.055-.447-2.384-.583-3.61-.336z" }));
});

var _extends$59 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$58(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCarOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$58(_ref, ["styles"]);

  return React.createElement("svg", _extends$59({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7.5 15c-.276 0-.5-.22-.5-.5s.224-.5.5-.5.5.22.5.5-.224.5-.5.5zm0-2c-.829 0-1.5.67-1.5 1.5S6.671 16 7.5 16 9 15.33 9 14.5 8.329 13 7.5 13zm9 2c-.276 0-.5-.22-.5-.5s.224-.5.5-.5.5.22.5.5-.224.5-.5.5zm0-2c-.829 0-1.5.67-1.5 1.5s.671 1.5 1.5 1.5 1.5-.67 1.5-1.5-.671-1.5-1.5-1.5zm2.5 0v3c0 .55-.448 1-1 1H6c-.552 0-1-.45-1-1v-3c0-.55.448-1 1-1h12c.552 0 1 .45 1 1zm-1 5.5c0 .28-.224.5-.5.5s-.5-.22-.5-.5V18h1v.5zm-11 0c0 .28-.224.5-.5.5s-.5-.22-.5-.5V18h1v.5zM7 7c0-1.11.896-2 2-2h6c1.104 0 2 .89 2 2l.8 4H6.2L7 7zm13 3.5v-1c0-.28-.224-.5-.5-.5h-1c-.034 0-.064.01-.096.02L18 7c0-1.66-1.343-3-3-3H9C7.343 4 6 5.34 6 7l-.404 2.02C5.563 9.01 5.534 9 5.5 9h-1c-.276 0-.5.22-.5.5v1c0 .28.224.5.5.5h.7l-.038.19A2.003 2.003 0 0 0 4 13v5h1v1c0 .55.448 1 1 1h1c.552 0 1-.45 1-1v-1h8v1c0 .55.448 1 1 1h1c.552 0 1-.45 1-1v-1h1v-5c0-.8-.478-1.49-1.162-1.81L18.8 11h.7c.276 0 .5-.22.5-.5z" }));
});

var _extends$5a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$59(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDecorateOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$59(_ref, ["styles"]);

  return React.createElement("svg", _extends$5a({ width: "32", height: "32", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M26 5h3a3 3 0 0 1 3 3v4.222c0 1.52-1.14 2.8-2.65 2.98l-13.467 1.583a1 1 0 0 0-.883.993V20h3v8c0 2.21-1.79 4-4 4s-4-1.79-4-4v-8h3v-2.222c0-1.52 1.14-2.8 2.65-2.98l13.467-1.583a1 1 0 0 0 .883-.993V8a1 1 0 0 0-1-1h-3v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h22a2 2 0 0 1 2 2v3zM2 2v8h22V2H2zm10 20v6a2 2 0 1 0 4 0v-6h-4z" }));
});

var _extends$5b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5a(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDecorateOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5a(_ref, ["styles"]);

  return React.createElement("svg", _extends$5b({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M17 6.5h1.5A1.5 1.5 0 0 1 20 8v2.11c0 .761-.57 1.402-1.325 1.49l-6.733.793a.5.5 0 0 0-.442.496V14H13v4a2 2 0 1 1-4 0v-4h1.5v-1.11c0-.761.57-1.402 1.325-1.49l6.733-.793a.5.5 0 0 0 .442-.496V8a.5.5 0 0 0-.5-.5H17V9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v1.5zM5 5v4h11V5H5zm5 10v3a1 1 0 0 0 2 0v-3h-2z" }));
});

var _extends$5c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5b(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconGenericMoneyOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5b(_ref, ["styles"]);

  return React.createElement("svg", _extends$5c({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M51.144 17.963l.49.008.79.065c6.97.785 12.2 6.759 12.061 13.794l-.01.32-.05.948c-.39 4.83-2.728 9.295-6.256 12.184l-.306.244-.556.507a58.154 58.154 0 0 1-10.873 7.474l.232 2.421h9.335v7.994h-9.215a37.1 37.1 0 0 1-1.447 7.39l-.184.562 10.767 7.477c3.776 2.832 8.332 4.417 12.956 4.554l1.068.005.697-.027c3.632-.31 8.494-3.626 12.897-7.884L72 76v-8h20a4 4 0 0 1 3.973 3.534L96 72v20h-8l.002-9.14c-4.984 4.611-10.538 8.103-15.883 8.887l-.96.112-.962.04c-6.439.124-12.743-1.773-17.935-5.335l-1.023-.734-9.399-6.523c-.23.393-.47.784-.718 1.174l-.38.585-.659.956-.337.604c-2.44 4.14-6.343 7.214-11.002 8.646l-.425.126-.98.25-1.091.212c-7.37 1.053-14.24-3.94-15.516-11.318a14.34 14.34 0 0 1 3.273-11.606 14.368 14.368 0 0 1 10.592-5.011l.383-.004.292.013a35.186 35.186 0 0 1 12.833 3.523 29.487 29.487 0 0 0 .772-4.962l.059-1.35-.003-1.27-.045-1.103-.16-1.862-1.324.464a58.23 58.23 0 0 1-9.328 2.256l-1.909.266-.972-7.934a50.235 50.235 0 0 0 12.566-3.224l.167-.071-1.4-14.477a15.3 15.3 0 0 1 3.643-10.876l.261-.299a15.325 15.325 0 0 1 10.712-5.052zm-26.32 53.955l-.5.024a6.364 6.364 0 0 0-4.243 2.194c-1.216 1.418-1.746 3.298-1.458 5.093.517 2.992 3.264 5.054 6.061 4.78l.215-.025.763-.15a11.28 11.28 0 0 0 7.31-5.473l.162-.3.255-.422.724-1.046.632-1 .39-.677-.966-.486a27.226 27.226 0 0 0-7.666-2.319l-.615-.083zM66.663 7.775C84.43 15.267 95.986 32.658 96 51.93a47.528 47.528 0 0 1-1.188 10.578l-.428 1.727-7.728-2.065A39.538 39.538 0 0 0 88 51.935c-.011-16.06-9.64-30.552-24.448-36.796a40.022 40.022 0 0 0-43.437 8.17 39.947 39.947 0 0 0-9.827 41.974l.44 1.186-7.454 2.9c-7-17.956-2.563-38.355 11.263-51.79C28.363 4.144 48.894.282 66.663 7.775zM51.31 25.963l-.463.043a7.322 7.322 0 0 0-4.47 2.357c-1.243 1.38-1.912 3.18-1.886 4.91l.01.288 1.09 11.21 1.103-.7a49.808 49.808 0 0 0 3.243-2.32l.777-.618 1.263-1.06.717-.64c2.087-1.634 3.425-4.032 3.718-6.544l.03-.315.041-.797c.123-2.862-1.938-5.337-4.605-5.756l-.218-.03z" }));
});

var _extends$5d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5c(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconGenericMoneyOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5c(_ref, ["styles"]);

  return React.createElement("svg", _extends$5d({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M50.096 28.308l.327.006.526.043c4.63.522 8.108 4.477 8.042 9.145l-.007.265-.034.632c-.258 3.198-1.797 6.155-4.122 8.082l-.252.203-.371.338a38.77 38.77 0 0 1-7.25 4.983l.156 1.614h6.223v5.33H47.19a24.733 24.733 0 0 1-.965 4.926l-.122.374 7.177 4.985a15.194 15.194 0 0 0 8.638 3.036l.712.003.465-.017c2.42-.208 5.662-2.418 8.597-5.257L64 67v-5.333h13.333a2.667 2.667 0 0 1 2.65 2.355l.017.311v13.334h-5.333v-6.093c-3.322 3.074-7.024 5.401-10.588 5.924l-.64.074-.641.028c-4.293.082-8.495-1.183-11.957-3.557l-.682-.49-6.265-4.35c-.154.263-.314.524-.48.784l-.252.39-.44.638-.225.402a12.867 12.867 0 0 1-7.274 5.746l-.344.102-.653.167-.728.141c-4.912.703-9.493-2.626-10.343-7.545a9.56 9.56 0 0 1 2.182-7.737 9.579 9.579 0 0 1 7.004-3.34l.312-.003.195.008a23.457 23.457 0 0 1 8.555 2.349c.119-.48.218-.968.3-1.458.101-.619.173-1.242.215-1.85l.04-.9-.002-.847-.03-.736-.108-1.24-.882.308a38.82 38.82 0 0 1-6.219 1.505l-1.272.177-.648-5.29a33.49 33.49 0 0 0 8.377-2.149l.111-.047-.933-9.651a10.2 10.2 0 0 1 2.379-7.193l.224-.257a10.216 10.216 0 0 1 7.141-3.369zM32.55 64.278l-.333.017a4.243 4.243 0 0 0-2.829 1.463 4.219 4.219 0 0 0-.972 3.395c.342 1.98 2.15 3.348 4 3.19l.184-.02.509-.1a7.52 7.52 0 0 0 4.844-3.597l.138-.252.17-.281.482-.698.421-.666.26-.452-.644-.324a18.15 18.15 0 0 0-4.999-1.529l-.521-.072zm27.893-42.762A31.975 31.975 0 0 1 80 50.954c0 2.374-.265 4.739-.792 7.051l-.285 1.152-5.152-1.377c.595-2.226.897-4.52.896-6.824a26.645 26.645 0 0 0-16.299-24.53 26.682 26.682 0 0 0-28.958 5.447 26.631 26.631 0 0 0-6.551 27.982l.293.79-4.97 1.935c-4.665-11.971-1.708-25.57 7.51-34.527s22.904-11.531 34.75-6.537zM50.208 33.642l-.31.029a4.881 4.881 0 0 0-2.979 1.57c-.817.908-1.262 2.086-1.258 3.223l.007.244.726 7.473.736-.467a33.206 33.206 0 0 0 2.162-1.547l.518-.412.842-.707.478-.426c1.373-1.075 2.26-2.646 2.47-4.297l.03-.276.026-.53c.081-1.895-1.272-3.535-3.032-3.832l-.183-.026z" }));
});

var _extends$5e = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5d(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPlaneOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5d(_ref, ["styles"]);

  return React.createElement("svg", _extends$5e({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M18.409 6.65l-3.298 3.3-.318.32.026.45c.054.94.156 2.62.244 4.07l.156 2.6c.002.08.003.09-.063.17-.148.18-.424.49-.656.74-.36-.97-1.118-3.03-1.536-4.18l-.538-1.48-1.112 1.12-2.044 1.96-.284.29-.01.4c-.006.32-.004.9-.003 1.41v.79a1.274 1.274 0 0 0-.08-.13l-1.156-1.85-.128-.21-.208-.13a89.31 89.31 0 0 1-2.057-1.28h.747c.391.01.836.02 1.176.02.129 0 .246-.01.338-.01l.403-.01.284-.28 1.969-2.04 1.107-1.11-1.47-.54c-1.105-.4-3.222-1.2-4.212-1.57.254-.23.56-.51.739-.66.049-.04.088-.06.115-.06h.035c.111 0 1.483.09 2.809.18 1.408.09 2.996.2 3.9.25l.451.03 3.617-3.62C17.86 5.08 18.359 5 18.61 5c.164 0 .279.03.339.06.07.19.168.88-.541 1.59zm1.256-2.31c-.192-.19-.58-.34-1.054-.34-.592 0-1.318.23-1.968.88l-3.296 3.3c-1.857-.12-6.613-.43-6.731-.44H6.54c-.161 0-.438.03-.753.3-.37.3-1.144 1.03-1.144 1.03-.186.19-.28.42-.258.64.014.13.086.37.408.5.197.07 3.318 1.24 4.759 1.77l-1.97 2.04h-.315c-.601 0-1.53-.02-1.904-.02h-.117c-.114.01-.348-.05-.968.47l-.044.04c-.186.19-.23.37-.234.5-.004.12.03.3.213.45.11.09 1.516.99 2.669 1.69.277.45 1.55 2.48 1.616 2.59.097.16.255.26.445.26h.016c.184 0 .373-.09.559-.27.524-.61.452-.87.455-.98.008-.33-.006-1.75.006-2.32l2.043-1.96c.523 1.43 1.665 4.53 1.742 4.73.126.32.366.39.498.4a.15.15 0 0 0 .065.01c.198 0 .403-.1.57-.27 0 0 .724-.76 1.033-1.14.308-.37.295-.69.29-.84-.003-.11-.293-4.85-.401-6.7l3.298-3.3c1.168-1.18.982-2.59.548-3.02z" }));
});

var _extends$5f = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5e(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconWeddingOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5e(_ref, ["styles"]);

  return React.createElement("svg", _extends$5f({ height: "32", viewBox: "0 0 64 96", width: "28", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M44 0a4 4 0 0 1 3.214 1.618l.259.397 8 14a4 4 0 0 1-.442 4.596l-.355.362-20 18a4 4 0 0 1-2.407 1.018c-3.084.208-5.3.5-6.546.837a23.827 23.827 0 0 0-5.55 2.283 24.1 24.1 0 0 0-8.588 8.263A23.869 23.869 0 0 0 8 64a23.842 23.842 0 0 0 3.533 12.541 24.133 24.133 0 0 0 9.941 9.035A23.885 23.885 0 0 0 32 88a23.862 23.862 0 0 0 12.692-3.626 24.132 24.132 0 0 0 8.526-9.146 23.806 23.806 0 0 0 2.188-5.893C55.799 67.6 56 65.815 56 64c0-2.879-.505-5.682-1.48-8.32a23.936 23.936 0 0 0-3.223-5.953 24.164 24.164 0 0 0-3.656-3.931l-1.045-.849 4.87-6.347a32.164 32.164 0 0 1 6.258 6.364 31.936 31.936 0 0 1 4.3 7.944A31.942 31.942 0 0 1 64 64c0 2.41-.267 4.79-.792 7.105a31.806 31.806 0 0 1-2.923 7.872A32.132 32.132 0 0 1 48.93 91.16 31.862 31.862 0 0 1 32 96a31.885 31.885 0 0 1-14.04-3.237A32.133 32.133 0 0 1 4.716 80.728 31.842 31.842 0 0 1 0 64a31.869 31.869 0 0 1 4.786-16.842 32.127 32.127 0 0 1 11.439-11.005 31.828 31.828 0 0 1 7.262-3.007L11.172 20.828a4 4 0 0 1-.935-4.184l.206-.473 7.2-14A4 4 0 0 1 20.706.03L21.2 0zM23.64 8l-4.748 9.232 13.256 13.256 14.78-13.3L41.676 8z" }));
});

var _extends$5g = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5f(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconWeddingOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5f(_ref, ["styles"]);

  return React.createElement("svg", _extends$5g({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M56.333 16c.851 0 1.644.405 2.143 1.079l.173.265 5.333 9.333c.566.99.435 2.218-.295 3.063l-.236.242-13.334 12c-.444.4-1.009.638-1.604.679-2.057.138-3.533.333-4.365.558-1.295.35-2.536.861-3.699 1.521a16.067 16.067 0 0 0-7.313 8.908 15.982 15.982 0 0 0-.803 5.019 15.895 15.895 0 0 0 2.355 8.36 16.089 16.089 0 0 0 6.628 6.024 15.923 15.923 0 0 0 7.017 1.616 15.908 15.908 0 0 0 8.461-2.417 16.088 16.088 0 0 0 5.685-6.098 15.87 15.87 0 0 0 1.458-3.929c.263-1.156.396-2.347.396-3.556 0-1.92-.336-3.788-.986-5.546a15.958 15.958 0 0 0-2.15-3.97 16.11 16.11 0 0 0-2.437-2.62l-.696-.566 3.247-4.231a21.443 21.443 0 0 1 4.172 4.242 21.29 21.29 0 0 1 2.866 5.296 21.295 21.295 0 0 1 1.318 7.395c0 1.607-.179 3.193-.529 4.736a21.204 21.204 0 0 1-1.948 5.248 21.388 21.388 0 0 1-7.57 8.122A21.241 21.241 0 0 1 48.333 80a21.256 21.256 0 0 1-14.464-5.653 21.422 21.422 0 0 1-3.725-4.528A21.228 21.228 0 0 1 27 58.667a21.246 21.246 0 0 1 3.19-11.228 21.418 21.418 0 0 1 7.626-7.337 21.219 21.219 0 0 1 4.842-2.005l-8.21-8.211a2.667 2.667 0 0 1-.623-2.79l.137-.316 4.8-9.333a2.667 2.667 0 0 1 2.042-1.427l.33-.02zM42.76 21.333l-3.165 6.155 8.837 8.837 9.853-8.866-3.501-6.126z" }));
});

var _extends$5h = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5g(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Desktop$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5g(_ref, ["styles"]);

  return React.createElement("svg", _extends$5h({ width: "64", height: "58", viewBox: "0 0 64 58", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "Laptop"), React.createElement("path", { d: "M56 29V5a2.667 2.667 0 0 0-2.667-2.667H10.667A2.667 2.667 0 0 0 8 5v29.333l-5.333 16V53a2.667 2.667 0 0 0 2.666 2.667h21.334A9.947 9.947 0 0 0 36 46.733a4.107 4.107 0 0 0-2.933-4.266A4.027 4.027 0 0 0 28 46.333a9.893 9.893 0 0 0 9.333 9.334h21.334A2.667 2.667 0 0 0 61.333 53v-2.667L57.813 39.8a8 8 0 0 0-7.573-5.467H13.333m8-21.333h21.334m-21.334 8h5.334m2.666 0h5.334m2.666 0h5.334", stroke: "#000", strokeWidth: "4", fill: "none", fillRule: "evenodd", strokeLinejoin: "round" }));
});

var _extends$5i = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5h(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var DualAvatar$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5h(_ref, ["styles"]);

  return React.createElement("svg", _extends$5i({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M91.16 69.029a47.915 47.915 0 0 1-2.533 4.546c-2.57-5.268-6.435-9.498-10.973-12.12C74.704 64.305 71.009 66 67 66c-3.952 0-7.598-1.647-10.527-4.424-1.863 1.156-3.59 2.61-5.143 4.314C55.495 72.297 58 80.525 58 89.5c0 1.877-.11 3.722-.321 5.524a47.952 47.952 0 0 1-5.416.79c.48-2.356.737-4.81.737-7.322 0-8.95-3.257-16.855-8.255-22.3a8.184 8.184 0 0 0-.238-.049l.08-.123a25.584 25.584 0 0 0-5.209-4.304C36.475 64.408 32.885 66 29 66c-4.001 0-7.689-1.688-10.636-4.528-4.449 2.763-8.123 7.292-10.486 12.887a47.936 47.936 0 0 1-3.039-5.33c2.57-4.928 6.042-9.024 10.114-11.906C12.783 53.459 11.5 48.918 11.5 44c0-12.15 7.835-22 17.5-22s17.5 9.85 17.5 22c0 4.918-1.284 9.46-3.453 13.123A30.204 30.204 0 0 1 48 61.547a30.204 30.204 0 0 1 4.953-4.424C50.783 53.459 49.5 48.918 49.5 44c0-12.15 7.835-22 17.5-22s17.5 9.85 17.5 22c0 4.918-1.284 9.46-3.453 13.123 4.072 2.882 7.544 6.978 10.114 11.906zM29 60c6.627 0 12-7.163 12-16s-5.373-16-12-16-12 7.163-12 16 5.373 16 12 16zm38 0c6.627 0 12-7.163 12-16s-5.373-16-12-16-12 7.163-12 16 5.373 16 12 16z" }), React.createElement("path", { d: "M48 96C21.49 96 0 74.51 0 48S21.49 0 48 0s48 21.49 48 48-21.49 48-48 48zm0-6c23.196 0 42-18.804 42-42S71.196 6 48 6 6 24.804 6 48s18.804 42 42 42z" }));
});

var _extends$5j = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5i(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Favourite$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5i(_ref, ["styles"]);

  return React.createElement("svg", _extends$5j({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 27" }, props), React.createElement("path", { d: "M14 21.565l-7.717 4.057 1.473-8.593-6.243-6.086 8.628-1.254L14 1.87l3.859 7.819 8.628 1.254-6.243 6.086 1.473 8.593L14 21.565z" }));
});

var _extends$5k = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5j(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconAbroadOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5j(_ref, ["styles"]);

  return React.createElement("svg", _extends$5k({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M71 86.237v8.023H23v-8.023zm12-12.034v8.023H11v-8.023zm-7.863-29.987a9.974 9.974 0 0 1 3.871 7.925 16.82 16.82 0 0 1-3.043 9.883c.356.084.72.133 1.086.145H95v8.023H77.008a18.63 18.63 0 0 1-7.934-2.24 18.507 18.507 0 0 1-8.054 2.24H-1v-8.023h62.008c.37-.01.74-.058 1.102-.14a16.58 16.58 0 0 1-3.086-9.104 10.04 10.04 0 0 1 5.228-9.617 9.983 9.983 0 0 1 10.885.908zm-22.37-30.41c11.918 2.473 20.91 12.386 22.285 24.57l-7.993.91c-.986-8.701-7.408-15.778-15.92-17.543s-17.186 2.182-21.5 9.784c-4.315 7.602-3.292 17.137 2.534 23.635l-5.96 5.435c-8.16-9.097-9.593-22.448-3.552-33.093 6.04-10.645 18.187-16.172 30.106-13.699zm16.241 36.33c-.2 0-.4.027-.594.078a2.238 2.238 0 0 0-1.398 2.378 8.796 8.796 0 0 0 2.004 5.311 8.96 8.96 0 0 0 1.988-5.762c0-.621-.287-1.207-.777-1.586a1.957 1.957 0 0 0-1.223-.42zM87 38.101v8.022h-8v-8.022zm-72 0v8.022H7v-8.022zm6.543-27.19l5.656 5.672-5.656 5.672-5.656-5.672zm50.914 0l5.656 5.672-5.656 5.672-5.656-5.672zM51 2v8.023h-8V2z" }));
});

var _extends$5l = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5k(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconAbroadOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5k(_ref, ["styles"]);

  return React.createElement("svg", _extends$5l({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M64 73.158v5.348H32v-5.348zm8-8.022v5.348H24v-5.348zm-5.242-19.992a6.65 6.65 0 0 1 2.58 5.283 11.213 11.213 0 0 1-2.028 6.59c.238.055.48.087.724.096H80v5.348H68.005a12.42 12.42 0 0 1-5.289-1.493 12.338 12.338 0 0 1-5.37 1.493H16v-5.348h41.339c.247-.007.493-.039.734-.094a11.053 11.053 0 0 1-2.057-6.07 6.694 6.694 0 0 1 3.485-6.41 6.655 6.655 0 0 1 7.257.605zM51.844 24.87c7.946 1.65 13.94 8.258 14.857 16.38l-5.328.607c-.657-5.8-4.94-10.519-10.614-11.695-5.675-1.177-11.457 1.455-14.333 6.523-2.876 5.068-2.195 11.424 1.69 15.756l-3.974 3.624c-5.44-6.065-6.395-14.966-2.368-22.063 4.027-7.096 12.124-10.78 20.07-9.132zm10.828 24.22c-.134.001-.267.019-.396.053a1.492 1.492 0 0 0-.932 1.585 5.864 5.864 0 0 0 1.336 3.541 5.973 5.973 0 0 0 1.325-3.842 1.336 1.336 0 0 0-1.333-1.337zm11.995-8.022v5.348h-5.334v-5.348zm-48 0v5.348h-5.334v-5.348zm4.362-18.127l3.77 3.782-3.77 3.781-3.771-3.781zm33.942 0l3.771 3.782-3.77 3.781-3.771-3.781zM50.667 17v5.348h-5.334V17z" }));
});

var _extends$5m = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5l(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconAlertOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5l(_ref, ["styles"]);

  return React.createElement("svg", _extends$5m({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M47.47 95.023c-6.489-.007-11.748-5.266-11.755-11.755h7.837a3.918 3.918 0 0 0 7.837 0V79.35H23.373a11.184 11.184 0 0 1-4.996-21.182l1.925-.96 1.52-13.676c2.1-11.252 7.595-18.335 16.375-21.349.943-.32 1.867-.692 2.77-1.111l-1.29-1.276a11.021 11.021 0 1 1 15.586-.002l-1.331 1.33c.86.414 1.742.779 2.644 1.094 8.948 3.14 14.502 10.217 16.503 21.032l1.56 13.956 1.924.962a11.184 11.184 0 0 1-4.995 21.182h-4.506v-7.837h4.506a3.346 3.346 0 0 0 1.49-6.335l-5.735-2.87-1.99-17.912a17.325 17.325 0 0 0-11.354-14.785 30.8 30.8 0 0 1-6.535-3.155 31.978 31.978 0 0 1-6.703 3.14c-6 2.058-9.654 6.994-11.175 15.091l-1.948 17.621-5.736 2.87a3.346 3.346 0 0 0 1.49 6.335h35.854v11.755c-.007 6.49-5.266 11.748-11.755 11.755zm0-86.202a3.182 3.182 0 0 0-2.251 5.432l2.263 2.261 2.24-2.263a3.18 3.18 0 0 0-2.251-5.43z" }));
});

var _extends$5n = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5m(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconAlertOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5m(_ref, ["styles"]);

  return React.createElement("svg", _extends$5n({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48.45 79.655a7.845 7.845 0 0 1-7.837-7.837h5.224a2.612 2.612 0 0 0 5.225 0v-2.612H32.385a7.456 7.456 0 0 1-3.33-14.121l1.282-.64 1.013-9.118c1.4-7.501 5.064-12.223 10.917-14.232a18.557 18.557 0 0 0 1.847-.741l-.86-.85a7.348 7.348 0 1 1 10.39-.002l-.887.886c.573.277 1.162.52 1.763.73 5.965 2.093 9.668 6.811 11.002 14.022l1.04 9.303 1.283.642a7.456 7.456 0 0 1-3.33 14.12H61.51v-5.224h3.004a2.23 2.23 0 0 0 .993-4.223l-3.824-1.913-1.326-11.941a11.55 11.55 0 0 0-7.569-9.858 20.533 20.533 0 0 1-4.357-2.103 21.319 21.319 0 0 1-4.468 2.093c-4 1.373-6.437 4.664-7.45 10.062l-1.3 11.747-3.823 1.913a2.23 2.23 0 0 0 .994 4.223h23.901v7.837a7.845 7.845 0 0 1-7.836 7.837zm0-57.468a2.121 2.121 0 0 0-1.502 3.621l1.51 1.508 1.493-1.51a2.12 2.12 0 0 0-1.501-3.62z" }));
});

var _extends$5o = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5n(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$l = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5n(_ref, ["styles"]);

  return React.createElement("svg", _extends$5o({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M89.977 36.744c0 5.985-.069 11.97.016 17.955.131 9.132-3.816 16.446-10.205 22.695-8.719 8.527-19.322 14.043-30.618 18.404-.686.262-1.656.274-2.336.008-12.2-4.75-23.614-10.738-32.59-20.479-5.442-5.905-8.304-12.757-8.239-20.83.1-12.48.056-24.963-.005-37.444-.01-1.966.636-3.007 2.6-3.683C21.12 9.063 33.59 4.606 46.113.3c1.13-.39 2.633-.404 3.76-.016 12.593 4.33 25.134 8.806 37.718 13.159 1.773.613 2.422 1.588 2.408 3.374-.057 6.643-.023 13.285-.023 19.927zM76.748 71.928C71.541 61.31 60.624 54 48 54c-12.616 0-23.527 7.3-28.738 17.908C26.34 79.354 35.4 84.814 47.995 89.815c11.743-4.626 20.537-9.805 27.597-16.71.4-.391.785-.783 1.156-1.177zM48 48c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z" }));
});

var _extends$5p = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5o(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconAuthorisationSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5o(_ref, ["styles"]);

  return React.createElement("svg", _extends$5p({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M75.985 40.496c0 3.99-.046 7.98.01 11.97.088 6.088-2.544 10.964-6.803 15.13-5.813 5.685-12.881 9.362-20.412 12.27-.457.174-1.104.182-1.558.004-8.133-3.166-15.742-7.158-21.726-13.652-3.628-3.937-5.536-8.505-5.493-13.886.067-8.32.037-16.642-.003-24.964-.006-1.31.424-2.004 1.733-2.454 8.348-2.872 16.66-5.843 25.01-8.714.753-.26 1.755-.27 2.507-.01 8.394 2.886 16.755 5.87 25.145 8.772 1.182.408 1.615 1.059 1.605 2.25-.038 4.428-.015 8.856-.015 13.284zm-8.82 23.456C63.694 56.873 56.416 52 48 52c-8.41 0-15.685 4.867-19.159 11.939 4.72 4.963 10.759 8.603 19.156 11.938 7.828-3.085 13.691-6.537 18.398-11.14.266-.261.523-.522.77-.785zM48 48c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z" }));
});

var _extends$5q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5p(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconAvatarOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5p(_ref, ["styles"]);

  return React.createElement("svg", _extends$5q({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M70.319 74.881l4.849 5.955a45.735 45.735 0 0 1-29.053 10.33 48.024 48.024 0 0 1-5.612-.332 45.718 45.718 0 0 1-23.475-9.994l4.845-5.959c14.107 11.484 34.339 11.484 48.446 0zM50.345-.805a46.096 46.096 0 0 1 39.56 60.214c-.231.699-.517 1.38-.855 2.034A18.101 18.101 0 0 1 69.6 71.086l-23.503-2.932-25.014 3.125a11.578 11.578 0 0 0-6.717 3.285l-3.954 3.954-5.43-5.43 3.954-3.954A19.29 19.29 0 0 1 20.13 63.66l13.185-1.648a34.485 34.485 0 0 1-10.063-20.955c-1.7-12.56 6.818-24.223 19.3-26.426a23.052 23.052 0 0 1 26.585 22.774 34.725 34.725 0 0 1-10.219 24.613l11.839 1.479a10.57 10.57 0 0 0 11.456-5.548c.155-.298.286-.608.394-.926a38.411 38.411 0 1 0-74.372-5.408 36.954 36.954 0 0 0 2.83 9.311L4.07 64.102A44.675 44.675 0 0 1 .655 52.857 46.114 46.114 0 0 1 50.345-.805zM43.69 22.224c-8.405 1.606-14.052 9.552-12.804 18.018 1.316 12.334 10.727 20.202 15.21 20.202 5.394 0 15.36-9.501 15.36-23.04a15.375 15.375 0 0 0-17.766-15.18z" }));
});

var _extends$5r = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5q(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconAvatarOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5q(_ref, ["styles"]);

  return React.createElement("svg", _extends$5r({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M62.88 66.587l3.232 3.97a30.49 30.49 0 0 1-19.369 6.887c-1.25-.001-2.5-.075-3.741-.222a30.479 30.479 0 0 1-15.65-6.662l3.23-3.973c9.405 7.656 22.893 7.656 32.297 0zM49.562 16.13a30.73 30.73 0 0 1 26.374 40.142 9.37 9.37 0 0 1-.57 1.357 12.067 12.067 0 0 1-12.968 6.428l-15.668-1.955-16.677 2.084a7.719 7.719 0 0 0-4.477 2.19l-2.636 2.636-3.62-3.62 2.636-2.636a12.86 12.86 0 0 1 7.462-3.65l8.79-1.099a22.99 22.99 0 0 1-6.708-13.97c-1.133-8.373 4.545-16.148 12.866-17.617A15.368 15.368 0 0 1 62.09 41.602a23.15 23.15 0 0 1-6.813 16.41l7.893.985c3.086.61 6.202-.9 7.637-3.698a4.38 4.38 0 0 0 .263-.618 25.607 25.607 0 1 0-49.582-3.605c.353 2.143.987 4.23 1.887 6.208L18.713 59.4a29.783 29.783 0 0 1-2.276-7.496A30.742 30.742 0 0 1 49.563 16.13zm-4.436 15.352a10.65 10.65 0 0 0-8.536 12.013c.877 8.222 7.15 13.467 10.14 13.467 3.596 0 10.24-6.333 10.24-15.36a10.25 10.25 0 0 0-11.844-10.12z" }));
});

var _extends$5s = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5r(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconBlockedFilledLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5r(_ref, ["styles"]);

  return React.createElement("svg", _extends$5s({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("rect", { width: "96", height: "96", rx: "48" }), React.createElement("path", { fill: "#FFF", d: "M48 39.515l12.728-12.728 8.485 8.485L56.485 48l12.728 12.728-8.485 8.485L48 56.485 35.272 69.213l-8.485-8.485L39.515 48 26.787 35.272l8.485-8.485L48 39.515z" }));
});

var _extends$5t = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5s(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconBlockedFilledSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5s(_ref, ["styles"]);

  return React.createElement("svg", _extends$5t({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("rect", { x: "15", y: "17", width: "64", height: "64", rx: "32" }), React.createElement("path", { fill: "#FFF", d: "M47.215 44.729L53.944 38l4.486 4.486-6.729 6.729 6.729 6.729-4.486 4.486-6.729-6.729-6.729 6.729L36 55.944l6.729-6.729L36 42.486 40.486 38l6.729 6.729z" }));
});

var _extends$5u = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5t(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCallIncomingSolidLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5t(_ref, ["styles"]);

  return React.createElement("svg", _extends$5u({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M81.898 25.597c0-2.883-2.323-5.225-5.187-5.225H55.827l4.874-5.77a5.253 5.253 0 0 0-.595-7.36 5.166 5.166 0 0 0-7.311.596L40.67 22.214a5.24 5.24 0 0 0 0 6.764l12.125 14.376a5.157 5.157 0 0 0 3.955 1.841c1.188 0 2.38-.406 3.356-1.242a5.247 5.247 0 0 0 .595-7.361l-4.874-5.775H76.71c2.864-.002 5.187-2.336 5.187-5.22zM31.056 28c.476-.49.608-1.115.388-1.857-.205-.745-.75-1.527-1.646-2.337L11.033 9.1c-.17-.185-.559-.409-1.14-.662-.526-.224-.917-.304-1.206-.255-.655-.101-1.172.112-1.565.644l-3.537 4.391L27.88 32.146l3.177-4.147zm30.406 41.077c-1.544-.48-2.695-.842-3.469-1.076-.76-.24-1.26-.412-1.477-.503-1.182-.5-2.512-1.287-3.973-2.35l-21.84-17.323c-1.321-1.006-2.436-2.09-3.336-3.262-.582-.692-1.322-1.815-2.233-3.39-.905-1.572-1.045-3.095-.421-4.585.124-.295.38-.709.789-1.245L1.389 16.259c-2.561 6.096-1.58 14.53 2.944 25.321 1.852 4.293 4.923 8.895 9.222 13.79 4.294 4.904 9.753 9.944 16.365 15.133 4.765 3.787 9.696 7.072 14.8 9.859 5.094 2.777 10.154 5.246 15.177 7.384 2.362 1.011 4.874 1.662 7.53 1.962 2.663.304 5.64.375 8.928.192 3.293-.177 6.005-.552 8.131-1.14 2.108-.59 3.924-1.527 5.422-2.814l-24.11-19.082c-1.355 1.954-2.796 2.696-4.336 2.212zm32.246 5.087L76.203 60.459c-.399-.315-.96-.628-1.697-.943-1.563-.667-2.711-.406-3.467.753L67.79 64.28 91.9 83.37l3.27-4.068c.476-1.125.75-1.988.825-2.568.073-.594-.685-1.449-2.287-2.571z" }));
});

var _extends$5v = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5u(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCallIncomingSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5u(_ref, ["styles"]);

  return React.createElement("svg", _extends$5v({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M70.599 33.065c0-1.922-1.55-3.483-3.458-3.483H53.218l3.25-3.847a3.502 3.502 0 0 0-.398-4.907 3.444 3.444 0 0 0-4.873.398l-8.084 9.583a3.493 3.493 0 0 0 0 4.51l8.084 9.584a3.438 3.438 0 0 0 4.873.399 3.498 3.498 0 0 0 .397-4.907l-3.25-3.85h13.924a3.47 3.47 0 0 0 3.458-3.48zm-33.895 1.601c.317-.326.405-.743.259-1.238-.137-.497-.5-1.018-1.097-1.558l-12.51-9.804c-.115-.123-.373-.273-.761-.441-.35-.15-.61-.203-.804-.17-.436-.068-.781.074-1.043.429L18.39 24.81l16.196 12.62 2.118-2.765zM56.975 62.05c-1.03-.32-1.797-.56-2.313-.717-.507-.16-.84-.274-.985-.335-.788-.333-1.674-.858-2.649-1.566L36.47 47.882c-.881-.67-1.624-1.392-2.224-2.174-.389-.462-.882-1.21-1.489-2.26-.603-1.048-.697-2.064-.28-3.057.082-.196.253-.472.525-.83L16.926 26.84c-1.707 4.063-1.054 9.686 1.963 16.88 1.234 2.862 3.281 5.93 6.148 9.193 2.863 3.27 6.502 6.63 10.91 10.089a68.993 68.993 0 0 0 9.866 6.573 116.569 116.569 0 0 0 10.119 4.923 17.743 17.743 0 0 0 5.02 1.307c1.775.203 3.76.25 5.952.129 2.195-.118 4.002-.369 5.42-.761 1.406-.392 2.616-1.018 3.615-1.875L59.865 60.576c-.903 1.302-1.864 1.797-2.89 1.474zm21.497 3.392l-11.67-9.136c-.266-.21-.64-.418-1.132-.629-1.041-.444-1.807-.27-2.31.502l-2.167 2.675L77.267 71.58l2.18-2.712c.317-.75.5-1.325.55-1.712.048-.396-.457-.966-1.525-1.714z" }));
});

var _extends$5w = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5v(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCheckbox = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5v(_ref, ["styles"]);

  return React.createElement("svg", _extends$5w({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M36.136 59.588L73.4 21l8.1 7.823-44.935 46.532-.157-.15-.15.155L14.5 54.35l7.823-8.1 13.813 13.338z" }));
});

var _extends$5x = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5w(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$m = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5w(_ref, ["styles"]);

  return React.createElement("svg", _extends$5x({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48.002 0C74.51 0 96 21.49 96 47.998S74.51 95.997 48.002 95.997C27.069 95.995 8.55 82.429 2.238 62.47c-5.19-16.412-1.144-34.034 9.98-46.472H2.703V8h24v24h-8l-.001-11.248C7.57 32.702 4.643 50.586 12.13 65.734c8.747 17.695 29.093 26.366 47.915 20.42C78.868 80.206 90.54 61.42 87.534 41.911S67.74 8.003 48.002 8zm2.088 16v32.346H72v8H50.09A11.108 11.108 0 0 1 39.29 68.43a9.598 9.598 0 0 1-9.588-9.585c0-5.227 3.776-10.5 12.211-10.5h.176V15.999zm-8 40.346h-.176c-4.024 0-4.202 1.658-4.21 2.402v.098a1.589 1.589 0 0 0 1.587 1.585c.465 0 2.783-.199 2.799-4.085z", fillRule: "evenodd" }));
});

var _extends$5y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5x(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconClockOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5x(_ref, ["styles"]);

  return React.createElement("svg", _extends$5y({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48.002 16c17.673 0 32 14.327 32 32s-14.327 32-32 32a32.002 32.002 0 0 1-23.856-53.334h-6.344v-5.333h16v16H28.47l-.001-7.498c-7.42 7.968-9.372 19.89-4.38 29.99 5.831 11.796 19.396 17.577 31.944 13.613 12.549-3.965 20.33-16.49 18.326-29.495s-13.196-22.607-26.356-22.61zm1.392 10.667v21.565h14.608v5.333H49.394a7.406 7.406 0 0 1-7.199 8.057 6.399 6.399 0 0 1-6.392-6.39c0-3.485 2.517-7 8.14-7h.118V26.667zm-5.333 26.898h-.117c-2.808 0-2.808 1.211-2.808 1.667a1.06 1.06 0 0 0 1.06 1.057c.309 0 1.855-.133 1.865-2.724z", fillRule: "evenodd" }));
});

var _extends$5z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5y(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconClockSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5y(_ref, ["styles"]);

  return React.createElement("svg", _extends$5z({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { fillRule: "evenodd", d: "M71.997 48.031H48V24.002a3 3 0 0 0-3-3c-1.659 0-3 1.341-3 3v26.93c0 .024-.015.042-.015.07 0 .641.252 1.205.603 1.691.543.774 1.395 1.308 2.412 1.308.048 0 .084-.024.132-.027h26.865c1.665 0 3.015-1.332 3.015-2.973 0-1.647-1.35-2.97-3.015-2.97M48 0C21.489 0 0 21.491 0 48.002 0 74.511 21.489 96 48 96c26.508 0 48-21.488 48-47.998C96 21.491 74.508 0 48 0" }));
});

var _extends$5A = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5z(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconClockSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5z(_ref, ["styles"]);

  return React.createElement("svg", _extends$5A({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { fillRule: "evenodd", d: "M63.998 48.021H48v-16.02a2 2 0 1 0-4 0v17.954c0 .016-.01.028-.01.046 0 .428.168.804.402 1.128.362.516.93.872 1.608.872.032 0 .056-.016.088-.018h17.91c1.11 0 2.01-.888 2.01-1.982 0-1.098-.9-1.98-2.01-1.98M48 16c-17.674 0-32 14.328-32 32.001S30.326 80 48 80c17.672 0 32-14.326 32-31.999S65.672 16 48 16" }));
});

var _extends$5B = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5A(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconConferenceLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5A(_ref, ["styles"]);

  return React.createElement("svg", _extends$5B({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7.345 9.982l-6.046.539 2.556 4.427 3.49-4.966zm.592-6.62V.5h.393v2.862h2.36L8.134 8.867 5.577 3.362h2.36zm5.584 9.202l2.309 1.333.17.098-.197.34-.17-.098-2.308-1.332-1.18 2.043-3.49-4.966 6.046.539-1.18 2.043zM.367 14.237l-.17.099-.197-.34.17-.1 2.479-1.43.17-.098.197.34-.17.098-2.48 1.431z" }));
});

var _extends$5C = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5B(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconConferenceSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5B(_ref, ["styles"]);

  return React.createElement("svg", _extends$5C({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M11.345 13.482l-6.046.539 2.556 4.427 3.49-4.966zm.592-6.62V4h.393v2.862h2.36l-2.556 5.505-2.557-5.505h2.36zm5.584 9.202l2.309 1.333.17.098-.197.34-.17-.098-2.308-1.332-1.18 2.043-3.49-4.966 6.046.539-1.18 2.043zM4.367 17.737l-.17.099-.197-.34.17-.1 2.479-1.43.17-.098.197.34-.17.098-2.48 1.431z" }));
});

var _extends$5D = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5C(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCredentialsOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5C(_ref, ["styles"]);

  return React.createElement("svg", _extends$5D({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 14.618c-3.556-1.953-5.356-5.723-6.232-8.471h12.464c-.876 2.748-2.675 6.518-6.232 8.47M8 1.913s3 2.353 7 .942c0 0-.116.972-.5 2.384v-.031h-13v.031C1.115 3.826 1 2.854 1 2.854c4 1.411 7-.942 7-.942M8 .5s-3 3.765-8 .941c0 0 .5 10.823 8 14.118 7.5-3.295 8-14.118 8-14.118C11 4.265 8 .5 8 .5" }));
});

var _extends$5E = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5D(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCredentialsOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5D(_ref, ["styles"]);

  return React.createElement("svg", _extends$5E({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 18.118c-3.556-1.953-5.356-5.723-6.232-8.471h12.464c-.876 2.748-2.675 6.518-6.232 8.47m0-12.705s3 2.353 7 .942c0 0-.116.972-.5 2.384v-.031h-13v.031C5.115 7.326 5 6.354 5 6.354c4 1.411 7-.942 7-.942M12 4s-3 3.765-8 .941c0 0 .5 10.823 8 14.118 7.5-3.295 8-14.118 8-14.118C15 7.765 12 4 12 4" }));
});

var _extends$5F = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5E(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$n = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5E(_ref, ["styles"]);

  return React.createElement("svg", _extends$5F({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M48 96.003c-26.51 0-48-21.49-48-48C0 21.49 21.49 0 48 0s48 21.49 48 48.003c0 26.51-21.49 48-48 48zm23.02-71.022a3.35 3.35 0 0 0-4.735 0L48 43.269 29.712 24.98a3.35 3.35 0 0 0-4.735 0 3.344 3.344 0 0 0 0 4.734l18.288 18.288-18.288 18.288a3.344 3.344 0 0 0 0 4.735 3.35 3.35 0 0 0 4.735 0L48 52.738l18.285 18.288a3.35 3.35 0 0 0 4.734 0 3.35 3.35 0 0 0 0-4.735L52.735 48.003l18.284-18.288a3.35 3.35 0 0 0 0-4.734z" }));
});

var _extends$5G = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5F(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCrossSolidCircleSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5F(_ref, ["styles"]);

  return React.createElement("svg", _extends$5G({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M48 80.002c-17.673 0-32-14.327-32-32C16 30.327 30.327 16 48 16c17.673 0 32 14.327 32 32.002 0 17.673-14.327 32-32 32zm15.346-47.348a2.233 2.233 0 0 0-3.156 0L48 44.846 35.808 32.654a2.233 2.233 0 0 0-3.157 0 2.23 2.23 0 0 0 0 3.156l12.192 12.192-12.192 12.192a2.23 2.23 0 0 0 0 3.157c.871.87 2.286.87 3.157 0L48 51.159 60.19 63.35c.87.87 2.285.87 3.156 0 .871-.873.871-2.286 0-3.157l-12.19-12.192 12.19-12.192c.871-.87.871-2.285 0-3.156z" }));
});

var _extends$5H = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5G(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$o = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5G(_ref, ["styles"]);

  return React.createElement("svg", _extends$5H({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M72.133 17.58l6.464 6.465L54.4 48.241l24.197 24.197-6.464 6.464-24.196-24.196L23.74 78.902l-6.464-6.464 24.196-24.197-24.196-24.196 6.464-6.464 24.197 24.196z" }));
});

var _extends$5I = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5H(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCrossThinOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5H(_ref, ["styles"]);

  return React.createElement("svg", _extends$5I({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15.673.327a1.117 1.117 0 0 0-1.578 0L8.001 6.422 1.906.327A1.117 1.117 0 0 0 .327 1.905L6.423 8 .327 14.096a1.117 1.117 0 0 0 1.578 1.578l6.096-6.096 6.094 6.096a1.117 1.117 0 0 0 1.578-1.578L9.58 8l6.094-6.095a1.117 1.117 0 0 0 0-1.578" }));
});

var _extends$5J = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5I(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCrossThinOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5I(_ref, ["styles"]);

  return React.createElement("svg", _extends$5J({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19.673 4.327a1.117 1.117 0 0 0-1.578 0l-6.094 6.095-6.095-6.095a1.117 1.117 0 0 0-1.579 1.578L10.423 12l-6.096 6.096a1.117 1.117 0 0 0 1.578 1.578l6.096-6.096 6.094 6.096a1.117 1.117 0 0 0 1.578-1.578L13.58 12l6.094-6.095a1.117 1.117 0 0 0 0-1.578" }));
});

var _extends$5K = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5J(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$p = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5J(_ref, ["styles"]);

  return React.createElement("svg", _extends$5K({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M87.887 21.656c12.578 18.847 10.243 43.892-5.516 60.086l-.482.488a47.852 47.852 0 0 1-33.941 14.035C25.06 96.25 5.37 80.068.92 57.618S8.498 12.699 29.648 3.953c21.15-8.746 45.534-1.334 58.239 17.703zM47.947 8.308c-19.072.014-35.48 13.499-39.188 32.207-3.708 18.71 6.316 37.432 23.941 44.72 17.626 7.288 37.945 1.111 48.532-14.754 10.587-15.864 8.494-36.998-5-50.478A39.88 39.88 0 0 0 47.949 8.308zM62.09 28.49l5.656 5.656-14.143 14.142 14.143 14.143-5.656 5.656-14.143-14.143-14.142 14.143-5.656-5.656L42.29 48.288 28.149 34.146l5.656-5.656 14.142 14.142z" }));
});

var _extends$5L = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5K(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCrossoutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5K(_ref, ["styles"]);

  return React.createElement("svg", _extends$5L({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M74.591 30.54c8.386 12.564 6.829 29.26-3.677 40.057l-.321.325a31.901 31.901 0 0 1-22.628 9.357c-15.258-.01-28.384-10.798-31.351-25.765s5.051-29.946 19.151-35.776c14.1-5.831 30.356-.89 38.826 11.802zM47.965 21.64c-12.715.01-23.653 8.999-26.125 21.472s4.21 24.954 15.96 29.813c11.75 4.858 25.297.74 32.355-9.836 7.058-10.576 5.663-24.666-3.333-33.652a26.587 26.587 0 0 0-18.857-7.797zm9.428 13.454l3.771 3.771-9.429 9.428 9.43 9.43-3.772 3.77-9.428-9.429-9.428 9.429-3.771-3.77 9.428-9.43-9.428-9.428 3.77-3.77 9.429 9.428z" }));
});

var _extends$5M = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5L(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCycleLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5L(_ref, ["styles"]);

  return React.createElement("svg", _extends$5M({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M2.804 8.006v8l9.417-.001C1.106 28.43-2.947 46.031 2.225 62.433 8.525 82.412 27.058 96 48.012 96a48.056 48.056 0 0 0 13.195-1.836l-2.2-7.695c-18.79 5.366-38.71-3.624-47.114-21.264-7.192-15.096-4.149-32.747 6.913-44.547v11.346h8.002V8.006H2.804zm32.084-6.183l2.184 7.695c18.777-5.33 38.66 3.661 47.056 21.278 7.172 15.05 4.173 32.644-6.81 44.448l-.001-11.242h-8.002v23.999H93.32v-8h-9.524c12.654-14.156 15.996-34.874 7.528-52.638C81.254 6.236 57.412-4.554 34.888 1.823z" }));
});

var _extends$5N = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5M(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCycleSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5M(_ref, ["styles"]);

  return React.createElement("svg", _extends$5N({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M18.136 20.91v5.332h6.277a32 32 0 0 0 23.862 53.33c2.975.003 5.935-.41 8.797-1.224l-1.467-5.13c-12.527 3.578-25.807-2.416-31.41-14.176-4.794-10.064-2.765-21.831 4.61-29.698v7.564h5.334V20.91H18.136zm21.39-4.123l1.456 5.13c12.517-3.553 25.773 2.441 31.37 14.186 4.782 10.033 2.782 21.763-4.54 29.632V58.24h-5.335v16H78.48v-5.334l-6.35.001c8.437-9.437 10.665-23.25 5.02-35.093-6.714-14.085-22.608-21.278-37.624-17.027z" }));
});

var _extends$5O = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5N(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCycleSolidLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5N(_ref, ["styles"]);

  return React.createElement("svg", _extends$5O({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M93.196 8.006v8l-9.417-.001c11.115 12.425 15.168 30.026 9.996 46.428C87.475 82.412 68.942 96 47.988 96a48.056 48.056 0 0 1-13.195-1.836l2.2-7.695c18.79 5.366 38.71-3.624 47.114-21.264 7.192-15.096 4.149-32.747-6.913-44.547v11.346h-8.002V8.006zM61.112 1.823l-2.184 7.695c-18.777-5.33-38.66 3.661-47.056 21.278C4.7 45.846 7.7 63.44 18.682 75.244l.001-11.242h8.002v23.999H2.68v-8h9.524C-.45 65.845-3.792 45.127 4.676 27.363 14.746 6.236 38.588-4.554 61.112 1.823z" }));
});

var _extends$5P = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5O(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconCycleSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5O(_ref, ["styles"]);

  return React.createElement("svg", _extends$5P({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M78.398 20.91v5.332H72.12a32 32 0 0 1-23.861 53.33 32.037 32.037 0 0 1-8.797-1.224l1.466-5.13c12.528 3.578 25.808-2.416 31.41-14.176 4.795-10.064 2.766-21.831-4.609-29.698v7.564h-5.334V20.91zm-21.39-4.123l-1.456 5.13c-12.518-3.553-25.773 2.441-31.37 14.186-4.782 10.033-2.782 21.763 4.54 29.632V58.24h5.334v16H18.054v-5.334l6.35.001c-8.437-9.437-10.665-23.25-5.02-35.093 6.714-14.085 22.608-21.278 37.624-17.027z" }));
});

var _extends$5Q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5P(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDialSolidLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5P(_ref, ["styles"]);

  return React.createElement("svg", _extends$5Q({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M76.856 52.591c-2.84 0-5.143 2.325-5.143 5.194v-3.89c0-2.869-2.303-5.194-5.143-5.194s-5.143 2.325-5.143 5.193v-3.89c0-2.868-2.303-5.193-5.144-5.193-2.84 0-5.143 2.325-5.143 5.193v-14.81c0-2.869-2.303-5.194-5.144-5.194-2.84 0-5.143 2.325-5.143 5.194v29.055l-5.073-5.122a5.109 5.109 0 0 0-7.274 0 5.23 5.23 0 0 0 0 7.345l5.506 5.56a17.427 17.427 0 0 1 4.496 7.946C40.92 89.41 49.346 96 58.994 96h.807C72.06 96 82 85.964 82 73.585v-15.8c0-2.869-2.303-5.194-5.144-5.194zM21.5 0C17.365 0 14 3.365 14 7.5c0 4.136 3.365 7.5 7.5 7.5 4.136 0 7.5-3.364 7.5-7.5C29 3.365 25.635 0 21.5 0zM46.5 0C42.365 0 39 3.365 39 7.5c0 4.136 3.365 7.5 7.5 7.5 4.136 0 7.5-3.364 7.5-7.5C54 3.365 50.636 0 46.5 0zM70.5 0C66.365 0 63 3.365 63 7.5c0 4.136 3.364 7.5 7.5 7.5S78 11.636 78 7.5C78 3.365 74.635 0 70.5 0zM70.5 25c-4.135 0-7.5 3.365-7.5 7.5 0 4.136 3.364 7.5 7.5 7.5s7.5-3.364 7.5-7.5c0-4.135-3.365-7.5-7.5-7.5zM21.5 25c-4.136 0-7.5 3.365-7.5 7.5 0 4.136 3.365 7.5 7.5 7.5 4.136 0 7.5-3.364 7.5-7.5 0-4.135-3.365-7.5-7.5-7.5z" }));
});

var _extends$5R = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5Q(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDialSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5Q(_ref, ["styles"]);

  return React.createElement("svg", _extends$5R({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M66.904 51.06c-1.893 0-3.429 1.551-3.429 3.463V51.93c0-1.912-1.535-3.462-3.428-3.462-1.894 0-3.43 1.55-3.43 3.462v-2.593c0-1.912-1.534-3.462-3.428-3.462s-3.429 1.55-3.429 3.462v-9.874c0-1.912-1.535-3.462-3.429-3.462s-3.429 1.55-3.429 3.462v19.37l-3.382-3.414a3.406 3.406 0 0 0-4.849 0 3.486 3.486 0 0 0 0 4.897l3.67 3.706a11.618 11.618 0 0 1 2.998 5.297C42.947 75.606 48.564 80 54.996 80h.538c8.173 0 14.8-6.69 14.8-14.943V54.523c0-1.912-1.536-3.462-3.43-3.462zM30 16c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zM46.667 16c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zM62.667 16c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zM62.667 32.667c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zM30 32.667c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" }));
});

var _extends$5S = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5R(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDisallowed = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5R(_ref, ["styles"]);

  return React.createElement("svg", _extends$5S({ viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M20.267 32.024A31.853 31.853 0 0 0 16 48c0 17.673 14.327 32 32 32 5.9 0 11.426-1.596 16.171-4.38zM31.394 20.64L75.38 64.574A31.85 31.85 0 0 0 80 48c0-17.673-14.327-32-32-32a31.85 31.85 0 0 0-16.606 4.64zM48 96C21.49 96 0 74.51 0 48S21.49 0 48 0s48 21.49 48 48-21.49 48-48 48z" }));
});

var _extends$5T = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5S(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDotSolidLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5S(_ref, ["styles"]);

  return React.createElement("svg", _extends$5T({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 0c26.51 0 48 21.49 48 48-.031 26.497-21.503 47.969-48 48C21.49 96 0 74.51 0 48S21.49 0 48 0z" }));
});

var _extends$5U = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5T(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDotSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5T(_ref, ["styles"]);

  return React.createElement("svg", _extends$5U({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 16c17.673 0 32 14.327 32 32-.02 17.665-14.335 31.98-32 32-17.673 0-32-14.327-32-32s14.327-32 32-32z" }));
});

var _extends$5V = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5U(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDownloadSolidLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5U(_ref, ["styles"]);

  return React.createElement("svg", _extends$5V({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M12.698 66.879v16.695h66.783V66.88h8.348v25.043H4.35V66.88zM68.696 0c8.068 0 14.608 6.54 14.608 14.609 0 8.068-6.54 14.608-14.608 14.608a51.88 51.88 0 0 1-15.265-2.274 57.795 57.795 0 0 0-3.518 19.812V65.2l7.63-7.63 5.902 5.903-17.706 17.705-17.706-17.705 5.902-5.902 7.63 7.629V46.755a66.147 66.147 0 0 1 4.097-22.865L10.567 7.904 14.03.306l35.006 15.947a65.712 65.712 0 0 1 7.002-10.77A14.543 14.543 0 0 1 67.45 0zm0 8.348h-1.248a6.226 6.226 0 0 0-4.887 2.35 56.93 56.93 0 0 0-5.67 8.56 43.6 43.6 0 0 0 11.805 1.612 6.26 6.26 0 0 0 0-12.522z" }));
});

var _extends$5W = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5V(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDownloadSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5V(_ref, ["styles"]);

  return React.createElement("svg", _extends$5W({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M25.266 60.586v11.13h44.522v-11.13h5.565V77.28H19.701V60.586zM62.598 16c5.379 0 9.739 4.36 9.739 9.739 0 5.379-4.36 9.74-9.74 9.74a34.587 34.587 0 0 1-10.176-1.517 38.53 38.53 0 0 0-2.345 13.208v12.297l5.087-5.087 3.934 3.935-11.803 11.804L35.49 58.315l3.934-3.935 5.086 5.086.001-12.296a44.098 44.098 0 0 1 2.73-15.243L23.846 21.269l2.31-5.065 23.337 10.631a43.808 43.808 0 0 1 4.668-7.18A9.695 9.695 0 0 1 61.766 16zm0 5.565h-.832a4.15 4.15 0 0 0-3.258 1.567 37.954 37.954 0 0 0-3.78 5.706 29.067 29.067 0 0 0 7.87 1.075 4.174 4.174 0 0 0 0-8.348z" }));
});

var _extends$5X = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5W(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconEditDisallowedOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5W(_ref, ["styles"]);

  return React.createElement("svg", _extends$5X({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 96C21.49 96 0 74.51 0 48S21.49 0 48 0s48 21.49 48 48-21.49 48-48 48zm0-5c23.748 0 43-19.252 43-43S71.748 5 48 5 5 24.252 5 48s19.252 43 43 43z" }), React.createElement("path", { d: "M15.159 18.896c.406-.544.97-1.203 1.69-1.977.64-.687.58-.61 1.069-1.083.326-.315.593-.562.801-.74l62.04 61.926-1.123.772-.949.738-1.037.726-1.047.876-61.444-61.238z" }), React.createElement("path", { d: "M20 73.894l3.913-13.98 14.682-14.23 17.75-16.223 6.62-6.416c2.479-2.37 6.373-2.866 8.851-.496l2.853 2.602c2.568 2.457 2.972 7.217.404 9.67l-6.569 6.416L50.698 58.24 36.413 71.235l-14.498 4.607L20 73.894zM25.719 64L23 72.227l8.507-2.748L25.72 64zm32.223-31.328l-30.398 28.31 7.203 7.036 30.233-28.18-7.038-7.166zm6.714-7.16l-4.474 4.518 7.62 7.588 4.974-4.677c1.062-1.022 2.224-2.683.53-4.599a40.298 40.298 0 0 0-3.723-3.686c-1.478-1.177-2.723-1.455-4.927.856z" }));
});

var _extends$5Y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5X(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconEditDisallowedOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5X(_ref, ["styles"]);

  return React.createElement("svg", _extends$5Y({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 80c-17.673 0-32-14.327-32-32 0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32zm0-3.333c15.832 0 28.667-12.835 28.667-28.667S63.832 19.333 48 19.333 19.333 32.168 19.333 48 32.168 76.667 48 76.667z" }), React.createElement("path", { d: "M26.106 28.597c.27-.362.646-.801 1.127-1.318.426-.458.386-.406.712-.721.217-.21.396-.375.535-.494l41.36 41.284-.75.515-.632.491-.691.484-.698.584-40.963-40.825z" }), React.createElement("path", { d: "M29.333 65.262l2.609-9.32 9.788-9.486L53.563 35.64l4.414-4.277c1.652-1.58 4.248-1.91 5.9-.33l1.903 1.734c1.712 1.638 1.98 4.812.269 6.447l-4.38 4.278L49.8 54.827l-9.524 8.663-9.665 3.071-1.277-1.299zm3.813-6.595l-1.813 5.484 5.672-1.832-3.86-3.652zM54.628 37.78L34.363 56.655l4.802 4.69L59.32 42.56l-4.692-4.778zm4.476-4.773l-2.982 3.012 5.08 5.059 3.315-3.118c.709-.681 1.483-1.789.354-3.066a26.866 26.866 0 0 0-2.483-2.458c-.985-.784-1.814-.97-3.284.571z" }));
});

var _extends$5Z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5Y(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconEllipsisSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5Y(_ref, ["styles"]);

  return React.createElement("svg", _extends$5Z({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M23.619 40a7.619 7.619 0 1 1 0 15.238 7.619 7.619 0 0 1 0-15.238zM48 40a7.619 7.619 0 1 1 0 15.238A7.619 7.619 0 0 1 48 40zm24.381 0a7.619 7.619 0 1 1 0 15.238 7.619 7.619 0 0 1 0-15.238z" }));
});

var _extends$5_ = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5Z(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5Z(_ref, ["styles"]);

  return React.createElement("svg", _extends$5_({ height: "16", viewBox: "0 0 96 96", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 0c26.51 0 48 21.49 48 48S74.51 96 48 96 0 74.51 0 48 21.49 0 48 0zm0 61.714c-1.952 0-3.583.655-4.892 1.965-1.31 1.31-1.965 2.953-1.965 4.93 0 1.927.655 3.545 1.965 4.855 1.31 1.31 2.94 1.965 4.892 1.965s3.583-.655 4.892-1.965c1.31-1.31 1.965-2.928 1.965-4.856 0-1.976-.655-3.62-1.965-4.93-1.31-1.309-2.94-1.964-4.892-1.964zm6.857-41.143H41.143l.463 10.613 1.946 23.673h8.896l1.946-23.673z", fillRule: "evenodd" }));
});

var _extends$5$ = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5_(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconExclamationCircleSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5_(_ref, ["styles"]);

  return React.createElement("svg", _extends$5$({ height: "16", viewBox: "0 0 96 96", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 16c17.673 0 32 14.327 32 32S65.673 80 48 80 16 65.673 16 48s14.327-32 32-32zm0 41.143c-1.301 0-2.388.436-3.262 1.31-.873.873-1.31 1.968-1.31 3.286 0 1.285.437 2.364 1.31 3.237.874.873 1.96 1.31 3.262 1.31s2.388-.437 3.262-1.31c.873-.873 1.31-1.952 1.31-3.237 0-1.318-.437-2.413-1.31-3.286-.874-.874-1.96-1.31-3.262-1.31zm4.571-27.429H43.43l.308 7.076 1.298 15.781h5.93l1.298-15.781z", fillRule: "evenodd" }));
});

var _extends$60 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5$(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconExclamationLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5$(_ref, ["styles"]);

  return React.createElement("svg", _extends$60({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M6.135 3.095L6 0h4l-.135 3.095L9.297 10H6.703l-.568-6.905zM6 14.011c0-.577.191-1.056.573-1.438C6.955 12.191 7.431 12 8 12c.57 0 1.045.191 1.427.573.382.382.573.861.573 1.438 0 .562-.191 1.034-.573 1.416C9.045 15.809 8.569 16 8 16c-.57 0-1.045-.191-1.427-.573-.382-.382-.573-.854-.573-1.416z" }));
});

var _extends$61 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$60(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconExclamationSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$60(_ref, ["styles"]);

  return React.createElement("svg", _extends$61({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M10.135 7.095L10 4h4l-.135 3.095L13.297 14h-2.594l-.568-6.905zM10 18.011c0-.577.191-1.056.573-1.438.382-.382.858-.573 1.427-.573.57 0 1.045.191 1.427.573.382.382.573.861.573 1.438 0 .562-.191 1.034-.573 1.416-.382.382-.858.573-1.427.573-.57 0-1.045-.191-1.427-.573-.382-.382-.573-.854-.573-1.416z" }));
});

var _extends$62 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$61(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconEyehideOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$61(_ref, ["styles"]);

  return React.createElement("svg", _extends$62({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15.955 7.652c.068.091.068.206-.069.275l-1.121 1.12a9.392 9.392 0 0 1-3.73 2.358l-.046-.092-.8-1.396-.046-.091a2.91 2.91 0 0 0 .8-2.037c0-1.67-1.327-3.02-2.974-3.02-.229 0-.458.046-.687.091l-.045-.091-.55-.961a9.744 9.744 0 0 1 8.26 2.837l1.008 1.007zm-7.3 3.09l.046.09.595 1.007A9.62 9.62 0 0 1 1.15 9.048L.05 7.927a.209.209 0 0 1 0-.275l.984-1.007A9.902 9.902 0 0 1 4.88 4.242l.045.092.778 1.35.07.092a3.078 3.078 0 0 0-.756 2.013c0 1.67 1.327 3.02 2.975 3.02.228 0 .457-.022.663-.068zm-2.196-3.8l1.533 2.655c-.984 0-1.762-.8-1.762-1.785 0-.32.091-.618.229-.87zm3.317.847c0 .343-.091.64-.228.916l-1.556-2.7h.023c.96 0 1.761.8 1.761 1.784zm.07 2.38l.823 1.396.961 1.67-.755.435-1.099-1.9-.663-1.166-.64-1.076-1.717-2.997-.618-1.076-.8-1.373-.962-1.647L5.131 2 6.23 3.876l.64 1.122.618 1.075 1.74 3.02.617 1.076z" }));
});

var _extends$63 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$62(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconEyehideOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$62(_ref, ["styles"]);

  return React.createElement("svg", _extends$63({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19.955 11.652c.068.091.068.206-.069.275l-1.121 1.12a9.392 9.392 0 0 1-3.73 2.358l-.046-.092-.8-1.396-.046-.091a2.91 2.91 0 0 0 .8-2.037c0-1.67-1.327-3.02-2.974-3.02-.229 0-.458.046-.687.091l-.045-.091-.55-.961a9.744 9.744 0 0 1 8.26 2.837l1.008 1.007zm-7.3 3.09l.046.09.595 1.007a9.62 9.62 0 0 1-8.146-2.791L4.05 11.927a.209.209 0 0 1 0-.275l.984-1.007A9.902 9.902 0 0 1 8.88 8.242l.045.092.778 1.35.07.092a3.078 3.078 0 0 0-.756 2.013c0 1.67 1.327 3.02 2.975 3.02.228 0 .457-.022.663-.068zm-2.196-3.8l1.533 2.655c-.984 0-1.762-.8-1.762-1.785 0-.32.091-.618.229-.87zm3.317.847c0 .343-.091.64-.228.916l-1.556-2.7h.023c.96 0 1.761.8 1.761 1.784zm.07 2.38l.823 1.396.961 1.67-.755.435-1.099-1.9-.663-1.166-.64-1.076-1.717-2.997-.618-1.076-.8-1.373-.962-1.647L9.131 6l1.099 1.876.64 1.122.618 1.075 1.74 3.02.617 1.076z" }));
});

var _extends$64 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$63(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconEyeshowOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$63(_ref, ["styles"]);

  return React.createElement("svg", _extends$64({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15.952 7.918c.068.091.068.206-.046.274l-1.097 1.12a9.544 9.544 0 0 1-13.661 0L.051 8.192a.208.208 0 0 1 0-.274l1.006-1.005a9.736 9.736 0 0 1 13.89 0l1.005 1.005zm-7.928 3.175c1.622 0 2.97-1.347 2.97-3.015 0-1.668-1.325-3.016-2.97-3.016-1.644 0-2.97 1.348-2.97 3.016s1.326 3.015 2.97 3.015zm0-1.256a1.77 1.77 0 0 1-1.759-1.782 1.77 1.77 0 0 1 1.76-1.782c.97 0 1.758.798 1.758 1.782a1.77 1.77 0 0 1-1.759 1.782z" }));
});

var _extends$65 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$64(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconEyeshowOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$64(_ref, ["styles"]);

  return React.createElement("svg", _extends$65({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19.952 11.918c.068.091.068.206-.046.274l-1.097 1.12a9.544 9.544 0 0 1-13.661 0l-1.097-1.12a.208.208 0 0 1 0-.274l1.006-1.005a9.736 9.736 0 0 1 13.89 0l1.005 1.005zm-7.928 3.175c1.622 0 2.97-1.347 2.97-3.015 0-1.668-1.325-3.016-2.97-3.016-1.644 0-2.97 1.348-2.97 3.016s1.326 3.015 2.97 3.015zm0-1.256a1.77 1.77 0 0 1-1.759-1.782 1.77 1.77 0 0 1 1.76-1.782c.97 0 1.758.798 1.758 1.782a1.77 1.77 0 0 1-1.759 1.782z" }));
});

var _extends$66 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$65(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFaceOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$65(_ref, ["styles"]);

  return React.createElement("svg", _extends$66({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M5.586 8c.571 0 1.035-.433 1.035-.966 0-.532-.464-.965-1.035-.965s-1.034.433-1.034.965c0 .533.463.966 1.034.966M8 15.034A7.034 7.034 0 1 1 8 .966a7.034 7.034 0 1 1 0 14.068M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m2.552 8c.57 0 1.034-.433 1.034-.966 0-.532-.463-.965-1.034-.965-.572 0-1.035.433-1.035.965 0 .533.463.966 1.035.966m-2.276.966A6.049 6.049 0 0 0 3.034 12h1.21a5.034 5.034 0 0 1 4.032-2.023c1.65 0 3.111.797 4.032 2.023h1.21a6.047 6.047 0 0 0-5.242-3.034" }));
});

var _extends$67 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$66(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFaceOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$66(_ref, ["styles"]);

  return React.createElement("svg", _extends$67({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M9.586 12c.571 0 1.035-.433 1.035-.966 0-.532-.464-.965-1.035-.965s-1.034.433-1.034.965c0 .533.463.966 1.034.966M12 19.034a7.034 7.034 0 1 1 0-14.068 7.034 7.034 0 1 1 0 14.068M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16m2.552 8c.57 0 1.034-.433 1.034-.966 0-.532-.463-.965-1.034-.965-.572 0-1.035.433-1.035.965 0 .533.463.966 1.035.966m-2.276.966A6.049 6.049 0 0 0 7.034 16h1.21a5.034 5.034 0 0 1 4.032-2.023c1.65 0 3.111.797 4.032 2.023h1.21a6.047 6.047 0 0 0-5.242-3.034" }));
});

var _extends$68 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$67(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFlagLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$67(_ref, ["styles"]);

  return React.createElement("svg", _extends$68({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M22 96h-8V20.87l-5.281-1.442a4.817 4.817 0 0 1-.43-.144A9.999 9.999 0 1 1 21.999 10v4.246c4.47.41 8.975-.115 13.231-1.54l12.332-4.11a40.505 40.505 0 0 1 28.773 1.197l15.238 6.53A3.997 3.997 0 0 1 93.999 20v48a4 4 0 0 1-5.575 3.675l-15.238-6.53a32.516 32.516 0 0 0-23.093-.962l-12.332 4.11a40.49 40.49 0 0 1-11.695 2.07l-.226-8a32.63 32.63 0 0 0 9.39-1.656l12.332-4.11a40.452 40.452 0 0 1 28.773 1.196l9.664 4.14V22.637l-12.813-5.492a32.505 32.505 0 0 0-23.093-.959l-12.332 4.111A40.34 40.34 0 0 1 22 22.274zM11.105 11.785l2.895.79v-2.575a2 2 0 1 0-2.895 1.785z" }));
});

var _extends$69 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$68(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFlagSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$68(_ref, ["styles"]);

  return React.createElement("svg", _extends$69({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M30.334 80h-5.333V29.913l-3.52-.961a3.211 3.211 0 0 1-.287-.097 6.666 6.666 0 1 1 9.14-6.189v2.831c2.98.273 5.983-.076 8.82-1.026l8.222-2.74a27.004 27.004 0 0 1 19.182.797l10.16 4.355a2.665 2.665 0 0 1 1.616 2.45v32a2.666 2.666 0 0 1-3.716 2.45L64.46 59.43a21.678 21.678 0 0 0-15.396-.64l-8.22 2.74a26.994 26.994 0 0 1-7.798 1.38l-.15-5.334c2.129-.06 4.238-.431 6.26-1.104l8.22-2.74a26.969 26.969 0 0 1 19.183.797l6.443 2.76V31.092l-8.542-3.662a21.67 21.67 0 0 0-15.396-.639l-8.22 2.741a26.894 26.894 0 0 1-10.509 1.318zm-7.263-56.143l1.93.527v-1.718a1.333 1.333 0 1 0-1.93 1.19z" }));
});

var _extends$6a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$69(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFlipChartOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$69(_ref, ["styles"]);

  return React.createElement("svg", _extends$6a({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M93 6a2.998 2.998 0 1 1 0 5.998h-3V65.98a6.002 6.002 0 0 1-6 6.001H58.086l7.467 13.742c.921 1.365.375 3.104-1.221 3.896-1.593.786-3.633.321-4.551-1.044l-8.337-15.34a2.498 2.498 0 0 1-.405-1.254h-6.081a2.469 2.469 0 0 1-.405 1.254l-8.334 15.34c-.918 1.365-2.958 1.83-4.551 1.044-1.599-.792-2.142-2.531-1.224-3.896l7.47-13.742H12c-3.312 0-6-2.687-6-6V11.997H3c-1.659 0-3-1.34-3-3.002A2.996 2.996 0 0 1 3 6h90zm-9 8.997v-2.993h-2.97c-.012 0-.018-.006-.03-.006H15c-.012 0-.018.006-.03.006H12V62.98c0 1.659 1.341 3 3 3h66c1.656 0 3-1.341 3-3V14.997z" }), React.createElement("path", { d: "M76.5 23.809a3 3 0 0 0-4.098 1.094L53.868 41.824 39.219 31.39c-.75-1.112-2.238-1.583-3.63-1.307-.264.036-.51.11-.756.216-.051.024-.114.02-.165.048-.054.027-.081.072-.129.096-.216.123-.405.27-.591.444a2.888 2.888 0 0 0-.447.515c-.03.042-.072.066-.099.111l-15 17.926a3.023 3.023 0 0 0 1.098 4.124 2.983 2.983 0 0 0 4.098-1.104l13.23-15.805 13.953 9.933c.231.345.534.63.888.852.225.285.498.542.831.737a3.004 3.004 0 0 0 4.098-1.103l21-19.17a2.996 2.996 0 0 0-1.098-4.094z" }));
});

var _extends$6b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6a(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFlipChartOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6a(_ref, ["styles"]);

  return React.createElement("svg", _extends$6b({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M78 20a1.999 1.999 0 1 1 0 3.999h-2v35.987c0 2.21-1.792 4-4 4H54.724l4.978 9.162c.614.91.25 2.07-.814 2.597-1.062.524-2.422.214-3.034-.695l-5.558-10.227a1.665 1.665 0 0 1-.27-.836h-4.054a1.646 1.646 0 0 1-.27.836L40.146 75.05c-.612.91-1.972 1.22-3.034.695-1.066-.527-1.428-1.687-.816-2.597l4.98-9.161H24c-2.208 0-4-1.792-4-4V23.998h-2c-1.106 0-2-.894-2-2.002 0-1.103.894-1.997 2-1.997h60zm-6 5.998v-1.995h-1.98c-.008 0-.012-.004-.02-.004H26c-.008 0-.012.004-.02.004H24v33.984c0 1.105.894 2 2 2h44a2 2 0 0 0 2-2V25.998z" }), React.createElement("path", { d: "M67 31.872a2 2 0 0 0-2.732.73l-12.356 11.28-9.766-6.955c-.5-.742-1.492-1.056-2.42-.872-.176.024-.34.074-.504.144-.034.016-.076.014-.11.032-.036.018-.054.048-.086.064-.144.082-.27.18-.394.296a1.925 1.925 0 0 0-.298.344c-.02.028-.048.044-.066.074l-10 11.95A2.015 2.015 0 0 0 29 51.71c.956.557 2.18.23 2.732-.736l8.82-10.537 9.302 6.622c.154.23.356.42.592.568.15.19.332.362.554.492.956.55 2.18.222 2.732-.736l14-12.78a1.997 1.997 0 0 0-.732-2.73z" }));
});

var _extends$6c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6b(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFolderOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6b(_ref, ["styles"]);

  return React.createElement("svg", _extends$6c({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M87 24H6V9c0-1.656 1.344-3 3-3h24c1.656 0 3 1.344 3 3v9h51c1.656 0 3 1.341 3 2.997A3.002 3.002 0 0 1 87 24zm3 9v54.003A2.999 2.999 0 0 1 87 90H9c-1.656 0-3-1.341-3-2.997V30h84zm0-21.003H42V6a6 6 0 0 0-6-6H6a6 6 0 0 0-6 6v84a6 6 0 0 0 6 6h84a6 6 0 0 0 6-6V18a6 6 0 0 0-6-6.003z" }));
});

var _extends$6d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6c(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFolderOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6c(_ref, ["styles"]);

  return React.createElement("svg", _extends$6d({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M74 32H20V22a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v6h34a1.999 1.999 0 1 1 0 4zm2 6v36.002A1.999 1.999 0 0 1 74 76H22c-1.104 0-2-.894-2-1.998V36h56zm0-14.002H44V20a4 4 0 0 0-4-4H20a4 4 0 0 0-4 4v56a4 4 0 0 0 4 4h56a4 4 0 0 0 4-4V28a4 4 0 0 0-4-4.002z" }));
});

var _extends$6e = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6d(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFormerLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6d(_ref, ["styles"]);

  return React.createElement("svg", _extends$6e({ height: "16", viewBox: "0 0 16 16", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fillRule: "evenodd", d: "M14.645 13.858l1.183-1.183a.557.557 0 1 0-.789-.788l-1.182 1.182-1.182-1.182a.557.557 0 1 0-.788.788l1.182 1.183-1.182 1.181a.558.558 0 0 0 .788.789l1.182-1.182 1.182 1.182a.557.557 0 1 0 .789-.789l-1.183-1.181zM6.4 8.533a3.733 3.733 0 1 1 0-7.466 3.733 3.733 0 0 1 0 7.466zM11.2 4.8a4.8 4.8 0 1 0-7.149 4.184A6.397 6.397 0 0 0 0 14.934V16h1.067v-1.067A5.333 5.333 0 0 1 6.4 9.6c1.436 0 2.737.57 3.695 1.493.232-.27.496-.51.788-.715a6.412 6.412 0 0 0-2.135-1.394A4.796 4.796 0 0 0 11.2 4.8z" }));
});

var _extends$6f = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6e(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFormerSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6e(_ref, ["styles"]);

  return React.createElement("svg", _extends$6f({ height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fillRule: "evenodd", d: "M18.645 17.858l1.183-1.183a.557.557 0 1 0-.789-.788l-1.182 1.182-1.182-1.182a.557.557 0 1 0-.788.788l1.182 1.183-1.182 1.181a.558.558 0 0 0 .788.789l1.182-1.182 1.182 1.182a.557.557 0 1 0 .789-.789l-1.183-1.181zM10.4 12.533a3.733 3.733 0 1 1 0-7.466 3.733 3.733 0 0 1 0 7.466zM15.2 8.8a4.8 4.8 0 1 0-7.149 4.184A6.397 6.397 0 0 0 4 18.934V20h1.067v-1.067A5.333 5.333 0 0 1 10.4 13.6c1.436 0 2.737.57 3.695 1.493.232-.27.496-.51.788-.715a6.412 6.412 0 0 0-2.135-1.394A4.796 4.796 0 0 0 15.2 8.8z" }));
});

var _extends$6g = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6f(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconGhostOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6f(_ref, ["styles"]);

  return React.createElement("svg", _extends$6g({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M8.363 0H8.03C4.945 0 2.4 2.472 2.4 5.535v10.138c0 .126.09.24.205.295.114.054.258.039.357-.04l1.42-1.125 1.11 1.101a.332.332 0 0 0 .467 0l1.085-1.077 1.084 1.077a.33.33 0 0 0 .466 0l1.084-1.077 1.083 1.077a.33.33 0 0 0 .466 0l1.084-1.077 1.084 1.077a.33.33 0 0 0 .232.096.245.245 0 0 0 .108-.025c.123-.05.185-.17.185-.302V5.535A5.532 5.532 0 0 0 8.363 0zM13 14.62l-.702-.72a.303.303 0 0 0-.435 0l-1.03 1.034-1.03-1.033a.31.31 0 0 0-.443 0l-1.033 1.033-1.034-1.033a.314.314 0 0 0-.444 0l-1.033 1.033-1.034-1.033a.337.337 0 0 0-.435-.024l-1.077.848V5.646C3.269 3.051 5.415.96 8.009.96h.32a4.665 4.665 0 0 1 4.67 4.686v8.974z" }), React.createElement("path", { d: "M6.385 4.48a.786.786 0 1 0 .001 1.571.786.786 0 0 0-.001-1.571zm0 .942a.157.157 0 1 1 0-.315.157.157 0 0 1 0 .315zM10.225 4.48a.786.786 0 1 0 .001 1.571.786.786 0 0 0-.001-1.571zm0 .942a.157.157 0 1 1 0-.315.157.157 0 0 1 0 .315z" }));
});

var _extends$6h = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6g(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconGhostOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6g(_ref, ["styles"]);

  return React.createElement("svg", _extends$6h({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M11.963 4h-.334C8.545 4 6 6.472 6 9.535v10.138c0 .126.09.24.205.295.114.054.258.039.357-.04l1.42-1.125 1.11 1.101a.332.332 0 0 0 .467 0l1.085-1.077 1.084 1.077a.33.33 0 0 0 .466 0l1.084-1.077 1.083 1.077a.33.33 0 0 0 .466 0l1.084-1.077 1.084 1.077a.33.33 0 0 0 .232.096.245.245 0 0 0 .108-.025c.123-.05.185-.17.185-.302V9.535A5.532 5.532 0 0 0 11.963 4zM16.6 18.62l-.702-.72a.303.303 0 0 0-.435 0l-1.03 1.034-1.03-1.033a.31.31 0 0 0-.443 0l-1.033 1.033-1.034-1.033a.314.314 0 0 0-.444 0l-1.033 1.033-1.034-1.033a.337.337 0 0 0-.435-.024l-1.077.848V9.646c0-2.595 2.146-4.686 4.74-4.686h.32a4.665 4.665 0 0 1 4.67 4.686v8.974z" }), React.createElement("path", { d: "M9.985 8.48a.786.786 0 1 0 .001 1.571.786.786 0 0 0-.001-1.571zm0 .942a.157.157 0 1 1 0-.315.157.157 0 0 1 0 .315zM13.825 8.48a.786.786 0 1 0 .001 1.571.786.786 0 0 0-.001-1.571zm0 .942a.157.157 0 1 1 0-.315.157.157 0 0 1 0 .315z" }));
});

var _extends$6i = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6h(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconGraph$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6h(_ref, ["styles"]);

  return React.createElement("svg", _extends$6i({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M8 1.333A.664.664 0 0 0 7.333 2v12c0 .365.301.667.667.667A.67.67 0 0 0 8.667 14V2A.664.664 0 0 0 8 1.333zM8 0c1.104 0 2 .89 2 2v12c0 1.1-.896 2-2 2s-2-.9-2-2V2c0-1.11.896-2 2-2zm6 5.333a.664.664 0 0 0-.667.667v8c0 .365.301.667.667.667a.67.67 0 0 0 .667-.667V6A.664.664 0 0 0 14 5.333zM14 4c1.104 0 2 .89 2 2v8c0 1.1-.896 2-2 2s-2-.9-2-2V6c0-1.11.896-2 2-2zM2 9.333a.664.664 0 0 0-.667.667v4c0 .365.301.667.667.667A.67.67 0 0 0 2.667 14v-4A.664.664 0 0 0 2 9.333zM2 8c1.104 0 2 .89 2 2v4c0 1.1-.896 2-2 2s-2-.9-2-2v-4c0-1.11.896-2 2-2z" }));
});

var _extends$6j = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6i(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconGridLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6i(_ref, ["styles"]);

  return React.createElement("svg", _extends$6j({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fillRule: "evenodd", d: "M7 9h2V7H7v2zm-1 1h4V6H6v4zm1-7h2V1H7v2zM6 4h4V0H6v4zm1 11h2v-2.001H7v2zm-1 1h4v-4H6v4zm7-7h2V7h-2v2zm-1 1h4V6h-4v4zm1-7h2V1h-2v2zm-1 1h4V0h-4v4zm1 11h2v-2.001h-2v2zm-1 1h4v-4h-4v4zM1 15h2v-2.001H1v2zm-1 1h4v-4H0v4zM1 3h2V1H1v2zM0 4h4V0H0v4zm1 5h2V7H1v2zm-1 1h4V6H0v4z" }));
});

var _extends$6k = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6j(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconGridSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6j(_ref, ["styles"]);

  return React.createElement("svg", _extends$6k({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { fillRule: "evenodd", d: "M11 13h2v-2h-2v2zm-1 1h4v-4h-4v4zm1-7h2V5h-2v2zm-1 1h4V4h-4v4zm1 11h2v-2.001h-2v2zm-1 1h4v-4h-4v4zm7-7h2v-2h-2v2zm-1 1h4v-4h-4v4zm1-7h2V5h-2v2zm-1 1h4V4h-4v4zm1 11h2v-2.001h-2v2zm-1 1h4v-4h-4v4zM5 19h2v-2.001H5v2zm-1 1h4v-4H4v4zM5 7h2V5H5v2zM4 8h4V4H4v4zm1 5h2v-2H5v2zm-1 1h4v-4H4v4z" }));
});

var _extends$6l = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6k(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconHouseOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6k(_ref, ["styles"]);

  return React.createElement("svg", _extends$6l({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M84 0a4 4 0 0 1 3.673 2.416l.163.45 7.618 25.775-7.672 2.268-6.77-22.91H15.21L8.985 36h19.016v-8a4 4 0 0 1 1.017-2.664l.35-.346 15.999-14a4 4 0 0 1 4.876-.302l.392.303 16 14a4 4 0 0 1 1.335 2.52L68 28v8h24c5.15 0 5.327 7.457.533 7.971L92 44v48a4 4 0 0 1-3.533 3.972l-.467.027h-8c-3.495 0-6.371-.558-10.028-1.746l-4.577-1.558c-1.724-.565-2.335-.679-3.162-.694h-.464c-.828.015-1.439.13-3.163.694l-3.166 1.082c-3.874 1.348-6.792 2.055-10.155 2.196l-1.284.026H8a4 4 0 0 1-3.973-3.533l-.026-.467V52h8v36H44c2.541 0 4.693-.42 7.658-1.389l3.665-1.246a28.227 28.227 0 0 1-7.273-16.226c-.57-6.705 3.766-12.847 10.349-14.668a14.121 14.121 0 0 1 12.102 2.362c3.466 2.613 5.503 6.676 5.493 11.201-.35 6.519-2.955 12.58-7.294 17.34l2.489.848c3.187 1.108 5.41 1.65 7.873 1.758l.937.02h4v-44H64a4 4 0 0 1-3.972-3.533L60 39.999V29.815L48 19.312l-12 10.5v10.187a4 4 0 0 1-3.533 3.973L32 44h-28a4 4 0 0 1-3.98-4.401l.076-.466 8-36A4 4 0 0 1 11.539.027L12 0zM65.176 62.874a6.1 6.1 0 0 0-4.686-.682c-2.85.788-4.71 3.422-4.475 6.2a20.185 20.185 0 0 0 5.49 11.883l.516.516.392-.386c3.08-3.189 5.037-7.274 5.506-11.59l.081-1c.002-1.793-.849-3.491-2.314-4.595zM28 60c2.051 0 3.742 1.38 3.973 3.157l.027.417v4.852c0 1.974-1.79 3.574-4 3.574-2.051 0-3.742-1.38-3.973-3.157l-.027-.417v-4.852c0-1.974 1.791-3.574 4-3.574zm20-28c2.051 0 3.742 1.38 3.973 3.157l.027.417v4.853c0 1.973-1.791 3.573-4 3.573-2.051 0-3.742-1.38-3.973-3.157L44 40.426v-4.853c0-1.974 1.79-3.574 4-3.574z" }));
});

var _extends$6m = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6l(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconHouseOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6l(_ref, ["styles"]);

  return React.createElement("svg", _extends$6m({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M79.203 40.977c2.032 1.646-.226 4.702-2.258 3.056l-.903-.705v34.556c0 1.176-.903 2.116-1.806 2.116H21.853c-1.129 0-2.032-.94-2.032-2.116V43.328l-.677.705c-2.032 1.646-4.29-1.41-2.484-3.056l30.255-24.448c.678-.705 1.581-.705 2.258 0 13.773 11.049 15.128 12.224 30.03 24.448zM48.106 20.933L23.23 40.866v36.067h14.971V50.832H58.01v26.101h14.74V40.866zM41.6 54.4v21.333h12.8V54.4z" }));
});

var _extends$6n = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6m(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconInboxOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6m(_ref, ["styles"]);

  return React.createElement("svg", _extends$6n({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M45.849 53.13a3.011 3.011 0 0 0 2.151.885 3.01 3.01 0 0 0 2.148-.885l14.985-14.982a3.033 3.033 0 0 0 0-4.281 3.031 3.031 0 0 0-4.284 0L51 43.716V2.997A2.999 2.999 0 0 0 48 0c-1.659 0-3 1.341-3 2.997v40.719l-9.852-9.849a3.027 3.027 0 0 0-4.281 4.281zM90 86.997c0 1.656-1.344 3-3 3H9a3 3 0 0 1-3-3V62.994a2.997 2.997 0 0 1 3-2.997h15v12h48v-12h15c1.656 0 3 1.341 3 2.997zm-6-75H72v6h7.713L90 53.994H66v12H30v-12H6l10.287-35.997H24v-6H12l-12 42v36c0 3.318 2.685 6 6 6h84c3.312 0 6-2.682 6-6v-36z", fillRule: "evenodd" }));
});

var _extends$6o = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6n(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconInboxOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6n(_ref, ["styles"]);

  return React.createElement("svg", _extends$6o({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M46.567 51.421c.396.396.914.592 1.434.59a2.006 2.006 0 0 0 1.432-.59l9.99-9.988a2.022 2.022 0 0 0 0-2.854 2.02 2.02 0 0 0-2.856 0l-6.566 6.566V17.998a2 2 0 0 0-2-1.998c-1.106 0-2 .894-2 1.998v27.147l-6.568-6.566a2.018 2.018 0 0 0-2.854 2.854zM76.002 74a2 2 0 0 1-2 2H22a2 2 0 0 1-2-2V57.997c0-1.104.894-1.998 2-1.998h10v8h32.002v-8h10a2 2 0 0 1 2 1.998zm-4-50.002h-8v4h5.142l6.858 24h-16v8H36v-8H20l6.857-24h5.143v-4h-8L16 52v24C16 78.213 17.79 80 20 80h56.002c2.208 0 4-1.788 4-4V52z", fillRule: "evenodd" }));
});

var _extends$6p = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6o(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconInfoOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6o(_ref, ["styles"]);

  return React.createElement("svg", _extends$6p({ height: "81", viewBox: "0 0 82 81", width: "82", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M80.626 29.904c5.486 19.583-4.157 40.236-22.692 48.603a14.182 14.182 0 0 1-13.56-1.065A14.763 14.763 0 0 1 37.57 65V30.714h6.858V65a7.932 7.932 0 0 0 3.663 6.68 7.248 7.248 0 0 0 7.016.58c15.45-6.97 23.49-24.181 18.922-40.503C69.462 15.435 53.656 4.9 36.833 6.962 20.01 9.025 7.217 23.07 6.729 40.012 6.24 56.952 18.202 71.71 34.878 74.74l-1.216 6.75C13.652 77.86-.705 60.158-.124 39.83.456 19.5 15.8 2.647 35.986.166c20.184-2.481 39.153 10.156 44.64 29.738zM44.429 17v6.857H37.57V17z" }));
});

var _extends$6q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6p(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconInfoOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6p(_ref, ["styles"]);

  return React.createElement("svg", _extends$6q({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M74.562 39.744c3.658 13.055-2.77 26.823-15.128 32.401a9.455 9.455 0 0 1-9.04-.71 9.842 9.842 0 0 1-4.535-8.294V40.284h4.572V63.14a5.288 5.288 0 0 0 2.442 4.453 4.832 4.832 0 0 0 4.677.386c10.3-4.646 15.66-16.12 12.615-27.001s-13.583-17.905-24.798-16.53-19.744 10.738-20.07 22.033c-.325 11.294 7.65 21.133 18.767 23.152l-.81 4.5c-13.34-2.42-22.912-14.221-22.525-27.773.387-13.553 10.617-24.79 24.073-26.443 13.456-1.654 26.103 6.77 29.76 19.826zM50.431 31.14v4.571h-4.572v-4.571z" }));
});

var _extends$6r = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6q(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLinkedGroup$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6q(_ref, ["styles"]);

  return React.createElement("svg", _extends$6r({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "Linked Group"), React.createElement("desc", null, "Linked group icon."), React.createElement("g", { fillRule: "evenodd" }, React.createElement("path", { d: "M55 55a7 7 0 0 1 7 7v14a7 7 0 0 1-7 7H41a7 7 0 0 1-7-7V62a7 7 0 0 1 7-7zm-2 4H43a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V64a5 5 0 0 0-5-5zM55 15a7 7 0 0 1 7 7v14a7 7 0 0 1-7 7H41a7 7 0 0 1-7-7V22a7 7 0 0 1 7-7zm-2 4H43a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V24a5 5 0 0 0-5-5zM21 55a7 7 0 0 1 7 7v14a7 7 0 0 1-7 7H7a7 7 0 0 1-7-7V62a7 7 0 0 1 7-7zm-2 4H9a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V64a5 5 0 0 0-5-5zM89 55a7 7 0 0 1 7 7v14a7 7 0 0 1-7 7H75a7 7 0 0 1-7-7V62a7 7 0 0 1 7-7zm-2 4H77a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V64a5 5 0 0 0-5-5z" }), React.createElement("path", { d: "M46 40h4v15h-4zM34.546 38.126l2.828 2.828-16.97 16.97-2.829-2.828zM61.222 37.393l-2.829 2.829 18.385 18.385 2.829-2.829z" })));
});

var _extends$6s = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6r(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLoadingOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6r(_ref, ["styles"]);

  return React.createElement("svg", _extends$6s({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M16.205 90.33A46.96 46.96 0 0 0 32.2 93.12c25.98 0 47.04-21.06 47.04-47.04 0-20.22-12.874-37.98-31.683-44.475a4.8 4.8 0 1 0-3.133 9.075c14.968 5.167 25.216 19.306 25.216 35.4 0 20.678-16.762 37.44-37.44 37.44-4.399 0-8.687-.757-12.73-2.219a4.8 4.8 0 1 0-3.265 9.028z" }));
});

var _extends$6t = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6s(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLoadingOutlineSmall = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6s(_ref, ["styles"]);

  return React.createElement("svg", _extends$6t({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M27.147 76.605a31.307 31.307 0 0 0 10.663 1.86c17.32 0 31.36-14.04 31.36-31.36 0-13.48-8.582-25.32-21.121-29.65a3.2 3.2 0 0 0-2.09 6.05c9.98 3.445 16.811 12.871 16.811 23.6 0 13.785-11.175 24.96-24.96 24.96-2.932 0-5.791-.504-8.487-1.479a3.2 3.2 0 0 0-2.176 6.019z" }));
});

var _extends$6u = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6t(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLocationOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6t(_ref, ["styles"]);

  return React.createElement("svg", _extends$6u({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M79.47 60.008l15.997 27.997c1.448 2.533-.218 5.654-3.02 5.96l-.452.024H4.005c-2.917 0-4.8-2.994-3.675-5.58l.203-.404L16.53 60.008l6.945 3.969L10.901 85.99h74.202L72.524 63.977zM48 2c21.963 0 31.996 15.05 31.996 31.996 0 3.036-.44 6.127-1.384 9.502-4.872 14.116-14.439 25.453-28.554 33.923a4 4 0 0 1-4.283-.107C31.25 67.59 21.872 56.662 17.803 44.501l-.43-1.357 7.661-2.298c2.983 9.944 10.351 19.214 22.249 27.78l.825.578.765-.494c10.447-6.953 17.626-15.703 21.585-26.151l.52-1.435c.682-2.458 1.019-4.831 1.019-7.128C71.997 20.946 64.699 10 48 10c-16.306 0-23.667 10.52-23.986 23.134l-.011.863h-8C16.004 17.11 26.056 2 48 2zm0 19.998c6.627 0 11.999 5.371 11.999 11.998S54.627 45.995 48 45.995s-11.999-5.372-11.999-11.999S41.373 21.998 48 21.998zm0 7.999a4 4 0 1 0 0 7.999 4 4 0 0 0 0-8z" }));
});

var _extends$6v = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6u(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLocationOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6u(_ref, ["styles"]);

  return React.createElement("svg", _extends$6v({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M69.98 55.672l10.665 18.665c.965 1.688-.145 3.769-2.014 3.973l-.301.016H19.67c-1.945 0-3.2-1.996-2.45-3.72l.135-.27 10.666-18.664 4.63 2.646-8.384 14.675h49.469l-8.387-14.675zM49 17c14.642 0 21.33 10.033 21.33 21.33 0 2.025-.292 4.085-.922 6.335-3.248 9.41-9.626 16.97-19.036 22.615a2.666 2.666 0 0 1-2.856-.07c-9.682-6.484-15.935-13.768-18.647-21.876l-.287-.904 5.107-1.533c1.99 6.63 6.901 12.81 14.833 18.52l.55.385.51-.329c6.965-4.635 11.75-10.468 14.39-17.434l.347-.957c.454-1.638.679-3.22.679-4.751 0-8.7-4.865-15.998-15.998-15.998-10.87 0-15.778 7.013-15.99 15.422l-.008.576h-5.333C27.67 27.072 34.37 17 49 17zm0 13.332a7.999 7.999 0 1 1 0 15.998 7.999 7.999 0 0 1 0-15.998zm0 5.332a2.666 2.666 0 1 0 0 5.333 2.666 2.666 0 0 0 0-5.333z" }));
});

var _extends$6w = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6v(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLockSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6v(_ref, ["styles"]);

  return React.createElement("svg", _extends$6w({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M71.667 80H53c-.158 0-.317-.013-.473-.042a20.966 20.966 0 0 1-1.678-.372 11.949 11.949 0 0 1-3.182-1.37 12.515 12.515 0 0 1-4.918 1.753 4.426 4.426 0 0 1-.416.031H23.667A2.667 2.667 0 0 1 21 77.333v-32A5.473 5.473 0 0 1 26.333 40h5.334v-8c0-8.837 7.163-16 16-16s16 7.163 16 16v5.333h-5.334V32c0-5.891-4.775-10.667-10.666-10.667S37 26.11 37 32v10.667a2.666 2.666 0 0 1-2.667 2.666h-8v29.334H42.16c.49-.072.971-.195 1.435-.368a14.385 14.385 0 0 1-.55-.877l-4.558-7.925a10.594 10.594 0 0 1 9.23-15.836h.002a10.578 10.578 0 0 1 9.195 15.854l-4.607 7.933c-.168.292-.346.573-.534.849.145.05.29.094.438.133.336.088.68.169 1.036.237H69V45.333H39.667V40H69a5.473 5.473 0 0 1 5.333 5.333v32A2.667 2.667 0 0 1 71.667 80zm-23.95-25.005a5.291 5.291 0 0 0-4.09 1.927 5.216 5.216 0 0 0-.518 5.914l4.559 7.924.017.029.01-.018 4.606-7.933a5.217 5.217 0 0 0-.491-5.916 5.3 5.3 0 0 0-4.094-1.927z" }));
});

var _extends$6x = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6w(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLogoutOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6w(_ref, ["styles"]);

  return React.createElement("svg", _extends$6x({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M15.938 18.016c7.732 0 14 6.268 14 14-.05 3.939-.308 7.873-.77 11.785a205.201 205.201 0 0 0 33.576 2.215l17.68-.001-7.316-7.315 5.656-5.656 16.972 16.972-16.972 16.968-5.656-5.656 7.314-7.313H62.744a213.93 213.93 0 0 1-34.748-2.304 265.205 265.205 0 0 1-.736 3.754A143.554 143.554 0 0 0 24 87.133V88h48.63V72h8v24H16v-8.867a150.506 150.506 0 0 1 3.416-33.238c.27-1.344.525-2.622.756-3.864a35.53 35.53 0 0 1-12.98-5.89 13.937 13.937 0 0 1-5.255-10.934v-1.191c0-7.732 6.269-14 14-14zm0 8a6.007 6.007 0 0 0-6 6v1.191a5.966 5.966 0 0 0 2.252 4.684 26.07 26.07 0 0 0 9.119 4.168c.416-3.88.629-7.555.629-10.043a6.007 6.007 0 0 0-6-6zM80 0v28h-8V8H24v4h-8V0z" }));
});

var _extends$6y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6x(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconLogoutOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6x(_ref, ["styles"]);

  return React.createElement("svg", _extends$6y({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M27.208 28.01a9.333 9.333 0 0 1 9.334 9.334 75.083 75.083 0 0 1-.513 7.857 136.8 136.8 0 0 0 22.384 1.476H70.2L65.322 41.8l3.77-3.77 11.315 11.314-11.314 11.312-3.771-3.77 4.876-4.876H58.413a142.62 142.62 0 0 1-23.166-1.536c-.15.805-.316 1.635-.49 2.503a95.703 95.703 0 0 0-2.174 21.112v.578h32.42V64h5.334v16H27.25v-5.911c-.066-7.448.698-14.88 2.277-22.16.18-.895.35-1.747.504-2.575a23.687 23.687 0 0 1-8.653-3.927 9.291 9.291 0 0 1-3.503-7.289v-.794a9.333 9.333 0 0 1 9.333-9.334zm0 5.334a4.004 4.004 0 0 0-4 4v.794a3.978 3.978 0 0 0 1.502 3.122 17.38 17.38 0 0 0 6.079 2.78c.277-2.587.42-5.037.42-6.696a4.004 4.004 0 0 0-4-4zM69.917 16v18.667h-5.334V21.333h-32V24H27.25v-8z" }));
});

var _extends$6z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6y(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMagnifySolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6y(_ref, ["styles"]);

  return React.createElement("svg", _extends$6z({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M85.656 91.906L62.21 68.461c-14.132 11.337-34.364 10.89-47.982-1.06a36.96 36.96 0 0 1 4.545-58.424A36.934 36.934 0 0 1 75.847 39.95h-7.385c-.001-13.563-9.24-25.383-22.402-28.66-13.162-3.277-26.864 2.83-33.225 14.81-6.361 11.98-3.747 26.752 6.34 35.82 10.692 9.33 26.47 9.86 37.763 1.27l-2.666-2.669c-4.491-4.504-4.491-11.793 0-16.298 4.56-4.354 11.739-4.354 16.3 0 4.5 4.501 4.5 11.797 0 16.298l-2.93 2.928 23.236 23.236zM62.421 48.229a4.143 4.143 0 0 0-2.926 7.071l2.926 2.928 2.928-2.928a4.143 4.143 0 0 0-2.928-7.07z" }));
});

var _extends$6A = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6z(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMagnifySolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6z(_ref, ["styles"]);

  return React.createElement("svg", _extends$6A({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M72.771 77.604L57.14 61.974c-9.422 7.558-22.91 7.26-31.988-.707a24.64 24.64 0 0 1 3.03-38.95 24.623 24.623 0 0 1 38.05 20.65h-4.924A19.693 19.693 0 1 0 28.45 57.614a19.934 19.934 0 0 0 25.176.846l-1.778-1.78a7.695 7.695 0 0 1 0-10.864 7.869 7.869 0 0 1 10.866 0c3 3 3 7.864 0 10.865l-1.953 1.952 15.49 15.49zm-15.49-29.118A2.762 2.762 0 0 0 55.33 53.2l1.95 1.952 1.953-1.952a2.762 2.762 0 0 0-1.952-4.714z" }));
});

var _extends$6B = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6A(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMakeCallSolidLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6A(_ref, ["styles"]);

  return React.createElement("svg", _extends$6B({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M39.432 25.597c0-2.883 2.323-5.225 5.187-5.225h20.884l-4.874-5.77a5.253 5.253 0 0 1 .595-7.36 5.166 5.166 0 0 1 7.311.596L80.66 22.214a5.24 5.24 0 0 1 0 6.764L68.535 43.354a5.157 5.157 0 0 1-3.955 1.841 5.134 5.134 0 0 1-3.356-1.242 5.247 5.247 0 0 1-.595-7.361l4.874-5.775H44.62c-2.864-.002-5.187-2.336-5.187-5.22zM31.056 28c.476-.49.608-1.115.388-1.857-.205-.745-.75-1.527-1.646-2.337L11.033 9.1c-.17-.185-.559-.409-1.14-.662-.526-.224-.917-.304-1.206-.255-.655-.101-1.172.112-1.565.644l-3.537 4.391L27.88 32.146l3.177-4.147zm30.406 41.077c-1.544-.48-2.695-.842-3.469-1.076-.76-.24-1.26-.412-1.477-.503-1.182-.5-2.512-1.287-3.973-2.35l-21.84-17.323c-1.321-1.006-2.436-2.09-3.336-3.262-.582-.692-1.322-1.815-2.233-3.39-.905-1.572-1.045-3.095-.421-4.585.124-.295.38-.709.789-1.245L1.389 16.259c-2.561 6.096-1.58 14.53 2.944 25.321 1.852 4.293 4.923 8.895 9.222 13.79 4.294 4.904 9.753 9.944 16.365 15.133 4.765 3.787 9.696 7.072 14.8 9.859 5.094 2.777 10.154 5.246 15.177 7.384 2.362 1.011 4.874 1.662 7.53 1.962 2.663.304 5.64.375 8.928.192 3.293-.177 6.005-.552 8.131-1.14 2.108-.59 3.924-1.527 5.422-2.814l-24.11-19.082c-1.355 1.954-2.796 2.696-4.336 2.212zm32.246 5.087L76.203 60.459c-.399-.315-.96-.628-1.697-.943-1.563-.667-2.711-.406-3.467.753L67.79 64.28 91.9 83.37l3.27-4.068c.476-1.125.75-1.988.825-2.568.073-.594-.685-1.449-2.287-2.571z" }));
});

var _extends$6C = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6B(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMakeCallSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6B(_ref, ["styles"]);

  return React.createElement("svg", _extends$6C({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M42.288 33.065c0-1.922 1.549-3.483 3.458-3.483h13.923l-3.25-3.847a3.502 3.502 0 0 1 .397-4.907 3.444 3.444 0 0 1 4.874.398l8.083 9.583a3.493 3.493 0 0 1 0 4.51l-8.083 9.584a3.438 3.438 0 0 1-4.874.399 3.498 3.498 0 0 1-.396-4.907l3.249-3.85H45.746a3.47 3.47 0 0 1-3.458-3.48zm-5.584 1.601c.317-.326.405-.743.259-1.238-.137-.497-.5-1.018-1.097-1.558l-12.51-9.804c-.115-.123-.373-.273-.761-.441-.35-.15-.61-.203-.804-.17-.436-.068-.781.074-1.043.429L18.39 24.81l16.196 12.62 2.118-2.765zM56.975 62.05c-1.03-.32-1.797-.56-2.313-.717-.507-.16-.84-.274-.985-.335-.788-.333-1.674-.858-2.649-1.566L36.47 47.882c-.881-.67-1.624-1.392-2.224-2.174-.389-.462-.882-1.21-1.489-2.26-.603-1.048-.697-2.064-.28-3.057.082-.196.253-.472.525-.83L16.926 26.84c-1.707 4.063-1.054 9.686 1.963 16.88 1.234 2.862 3.281 5.93 6.148 9.193 2.863 3.27 6.502 6.63 10.91 10.089a68.993 68.993 0 0 0 9.866 6.573 116.569 116.569 0 0 0 10.119 4.923 17.743 17.743 0 0 0 5.02 1.307c1.775.203 3.76.25 5.952.129 2.195-.118 4.002-.369 5.42-.761 1.406-.392 2.616-1.018 3.615-1.875L59.865 60.576c-.903 1.302-1.864 1.797-2.89 1.474zm21.497 3.392l-11.67-9.136c-.266-.21-.64-.418-1.132-.629-1.041-.444-1.807-.27-2.31.502l-2.167 2.675L77.267 71.58l2.18-2.712c.317-.75.5-1.325.55-1.712.048-.396-.457-.966-1.525-1.714z" }));
});

var _extends$6D = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6C(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMaskOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6C(_ref, ["styles"]);

  return React.createElement("svg", _extends$6D({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("g", { fillRule: "evenodd" }, React.createElement("path", { d: "M85.542 26.776l-5.792-5.74V1.548C79.75.693 79.05 0 78.187 0h-18.75c-.862 0-1.562.693-1.562 1.548v19.488l-.447.443a30.89 30.89 0 0 0-17.856 0l-.447-.443V1.548c0-.855-.7-1.548-1.562-1.548h-18.75c-.863 0-1.563.693-1.563 1.548v19.488l-5.792 5.74c-.293.29-.458.684-.458 1.095v23.226c-.009 2.557 2.076 4.636 4.656 4.645a4.709 4.709 0 0 0 1.775-.34 4.652 4.652 0 0 0 2.944 3.152v3.381c.014 10.575 6.066 20.23 15.625 24.93v7.587c0 .855.7 1.548 1.563 1.548h21.874C60.3 96 61 95.307 61 94.452v-7.587c9.559-4.7 15.61-14.355 15.625-24.93v-3.381a4.652 4.652 0 0 0 2.944-3.153c2.39.963 5.115-.176 6.087-2.545.23-.559.346-1.156.344-1.76V27.872c0-.41-.165-.804-.458-1.095zM21.938 55.742a1.556 1.556 0 0 1-1.563-1.548V40.258H17.25v10.839c0 .855-.7 1.548-1.562 1.548a1.556 1.556 0 0 1-1.563-1.548V28.512l5.792-5.74c.293-.29.458-.684.458-1.095V3.097H36v18.58c0 .411.165.805.458 1.095l5.792 5.74v11.746c0 .855-.7 1.548-1.562 1.548a1.556 1.556 0 0 1-1.563-1.548v-6.193H36v20.129c0 .855-.7 1.548-1.562 1.548a1.556 1.556 0 0 1-1.563-1.548V40.258H29.75v13.936c0 .855-.7 1.548-1.562 1.548a1.556 1.556 0 0 1-1.563-1.548V40.258H23.5v13.936c0 .855-.7 1.548-1.562 1.548zm35.937 37.161h-18.75v-4.722a27.843 27.843 0 0 0 18.75 0v4.722zM73.5 61.935c-.016 13.676-11.2 24.758-25 24.775-13.8-.017-24.984-11.099-25-24.775v-3.381a4.678 4.678 0 0 0 1.563-.93 4.647 4.647 0 0 0 6.25 0 4.697 4.697 0 0 0 6.593-.3 4.602 4.602 0 0 0 1.219-3.13v-9.576c.5.184 1.029.28 1.563.285 2.588 0 4.687-2.08 4.687-4.645V27.871c0-.41-.165-.804-.458-1.095l-2.812-2.787a27.9 27.9 0 0 1 12.793 0l-2.812 2.787c-.294.29-.46.684-.461 1.095v12.387c0 2.566 2.099 4.645 4.687 4.645a4.671 4.671 0 0 0 1.563-.285v9.576c-.011 2.554 2.069 4.634 4.646 4.645a4.69 4.69 0 0 0 3.166-1.208 4.647 4.647 0 0 0 6.25 0c.455.408.986.723 1.563.929v3.375zm9.375-10.838c0 .855-.7 1.548-1.563 1.548a1.556 1.556 0 0 1-1.562-1.548V40.258h-3.125v13.936c0 .855-.7 1.548-1.563 1.548a1.556 1.556 0 0 1-1.562-1.548V40.258h-3.125v13.936c0 .855-.7 1.548-1.563 1.548a1.556 1.556 0 0 1-1.562-1.548V40.258h-3.125v13.936c0 .855-.7 1.548-1.563 1.548A1.556 1.556 0 0 1 61 54.194v-20.13h-3.125v6.194c0 .855-.7 1.548-1.563 1.548a1.556 1.556 0 0 1-1.562-1.548V28.512l5.792-5.74c.293-.29.458-.684.458-1.095V3.097h15.625v18.58c0 .411.165.805.458 1.095l5.792 5.74v22.585z" }), React.createElement("path", { d: "M49 79.8a4.8 4.8 0 0 1-4.8-4.8H41a8 8 0 0 0 16 0h-3.2a4.8 4.8 0 0 1-4.8 4.8zM45.026 64.923c.154.051.316.078.478.077H53v-3.007h-5.415l2.339-7.043-2.849-.95-2.998 9.021c-.261.788.163 1.64.949 1.902z" })));
});

var _extends$6E = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6D(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMaskOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6D(_ref, ["styles"]);

  return React.createElement("svg", _extends$6E({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("g", { fillRule: "evenodd" }, React.createElement("path", { d: "M72.695 33.85l-3.862-3.826V17.032c0-.57-.466-1.032-1.041-1.032h-12.5c-.576 0-1.042.462-1.042 1.032v12.992l-.298.295a20.594 20.594 0 0 0-11.904 0l-.298-.295V17.032c0-.57-.466-1.032-1.042-1.032h-12.5c-.575 0-1.041.462-1.041 1.032v12.992l-3.862 3.827a1.027 1.027 0 0 0-.305.73v15.484c-.006 1.704 1.384 3.09 3.104 3.096a3.14 3.14 0 0 0 1.184-.227c.267.977 1 1.762 1.962 2.102v2.254c.01 7.05 4.044 13.487 10.417 16.62v5.058c0 .57.466 1.032 1.041 1.032h14.584c.575 0 1.041-.462 1.041-1.032V73.91c6.373-3.133 10.407-9.57 10.417-16.62v-2.254a3.102 3.102 0 0 0 1.962-2.102c1.594.642 3.41-.118 4.059-1.697.152-.372.23-.77.229-1.172V34.58c0-.274-.11-.537-.305-.73zM30.292 53.162a1.037 1.037 0 0 1-1.042-1.032v-9.29h-2.083v7.226c0 .57-.467 1.032-1.042 1.032a1.037 1.037 0 0 1-1.042-1.032V35.008l3.862-3.827c.195-.193.305-.456.305-.73V18.066h10.417v12.387c0 .273.11.536.305.73l3.861 3.826v7.83c0 .57-.466 1.033-1.041 1.033a1.037 1.037 0 0 1-1.042-1.032v-4.13h-2.083v13.42c0 .57-.467 1.032-1.042 1.032a1.037 1.037 0 0 1-1.042-1.032v-9.29H35.5v9.29c0 .57-.466 1.032-1.042 1.032a1.037 1.037 0 0 1-1.041-1.032v-9.29h-2.084v9.29c0 .57-.466 1.032-1.041 1.032zM54.25 77.935h-12.5v-3.148a18.562 18.562 0 0 0 12.5 0v3.148zM64.667 57.29C64.656 66.407 57.2 73.796 48 73.806c-9.2-.01-16.656-7.399-16.667-16.516v-2.254a3.119 3.119 0 0 0 1.042-.62 3.098 3.098 0 0 0 4.167 0 3.131 3.131 0 0 0 4.395-.2c.525-.57.815-1.315.813-2.087v-6.383c.334.122.686.186 1.042.19 1.726 0 3.125-1.387 3.125-3.097V34.58c0-.274-.11-.537-.306-.73l-1.875-1.858a18.6 18.6 0 0 1 8.53 0L50.39 33.85a1.028 1.028 0 0 0-.308.73v8.258c0 1.71 1.4 3.096 3.125 3.096a3.114 3.114 0 0 0 1.042-.19v6.384c-.008 1.703 1.38 3.09 3.098 3.097a3.127 3.127 0 0 0 2.11-.805 3.098 3.098 0 0 0 4.167 0c.303.272.657.482 1.042.619v2.25zm6.25-7.225c0 .57-.467 1.032-1.042 1.032a1.037 1.037 0 0 1-1.042-1.032v-7.226H66.75v9.29c0 .57-.466 1.032-1.042 1.032a1.037 1.037 0 0 1-1.041-1.032v-9.29h-2.084v9.29c0 .57-.466 1.032-1.041 1.032A1.037 1.037 0 0 1 60.5 52.13v-9.29h-2.083v9.29c0 .57-.467 1.032-1.042 1.032a1.037 1.037 0 0 1-1.042-1.032v-13.42H54.25v4.13c0 .57-.466 1.032-1.042 1.032a1.037 1.037 0 0 1-1.041-1.032v-7.831l3.861-3.827c.195-.193.305-.456.305-.73V18.066H66.75v12.387c0 .273.11.536.305.73l3.862 3.826v15.057z" }), React.createElement("path", { d: "M48.333 69.2a3.2 3.2 0 0 1-3.2-3.2H43a5.333 5.333 0 0 0 10.667 0h-2.134a3.2 3.2 0 0 1-3.2 3.2zM45.684 59.282c.103.034.21.052.319.051H51V57.33h-3.61l1.56-4.696-1.9-.633-1.999 6.014a1.003 1.003 0 0 0 .633 1.268z" })));
});

var _extends$6F = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6E(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMinusLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6E(_ref, ["styles"]);

  return React.createElement("svg", _extends$6F({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M0 9.333V6.667h16v2.666z" }));
});

var _extends$6G = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6F(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMinusOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6F(_ref, ["styles"]);

  return React.createElement("svg", _extends$6G({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "icon-minusoutline-small"), React.createElement("path", { d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-1a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm-4-8h8v2H8v-2z" }));
});

var _extends$6H = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6G(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMinusSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6G(_ref, ["styles"]);

  return React.createElement("svg", _extends$6H({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M4 13.333v-2.666h16v2.666z" }));
});

var _extends$6I = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6H(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMinusSolidLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6H(_ref, ["styles"]);

  return React.createElement("svg", _extends$6I({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 0c26.51 0 48 21.49 48 48-.031 26.497-21.503 47.969-48 48C21.49 96 0 74.51 0 48S21.49 0 48 0zm33.6 43.2H14.4v9.6h67.2z" }));
});

var _extends$6J = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6I(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMinusSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6I(_ref, ["styles"]);

  return React.createElement("svg", _extends$6J({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 16c17.673 0 32 14.327 32 32-.02 17.665-14.335 31.98-32 32-17.673 0-32-14.327-32-32s14.327-32 32-32zm22.4 28.8H25.6v6.4h44.8z" }));
});

var _extends$6K = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6J(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMobileOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6J(_ref, ["styles"]);

  return React.createElement("svg", _extends$6K({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M75.36.205a4 4 0 0 1 4 4v88a4 4 0 0 1-4 4H54.579a7.947 7.947 0 0 1-5.659-2.344l-1.254-1.254-1.253 1.254a7.945 7.945 0 0 1-5.657 2.344H19.36a4 4 0 0 1-4-4v-88a4 4 0 0 1 4-4zm-4 8h-48v80h17.396l1.254-1.254-1.816-1.817a11.004 11.004 0 1 1 15.838-15.226 11.283 11.283 0 0 1-.67 15.005l-2.037 2.038 1.252 1.254-2.828 2.828 2.83-2.828h16.78zM47.666 74.052a2.98 2.98 0 0 0-2.289 1.059 3.308 3.308 0 0 0 .473 4.367l1.816 1.816 1.819-1.816a3.31 3.31 0 0 0 .472-4.367 2.98 2.98 0 0 0-2.29-1.059zm7.694-61.847v8h-16v-8z" }));
});

var _extends$6L = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6K(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMobileOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6K(_ref, ["styles"]);

  return React.createElement("svg", _extends$6L({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M66.36 16.205a2.667 2.667 0 0 1 2.666 2.666v58.667a2.667 2.667 0 0 1-2.666 2.667H52.506a5.298 5.298 0 0 1-3.772-1.563l-.836-.836-.836.836a5.297 5.297 0 0 1-3.771 1.563H29.026a2.667 2.667 0 0 1-2.666-2.667V18.87a2.667 2.667 0 0 1 2.666-2.666H66.36zm-2.667 5.333h-32V74.87h11.598l.836-.836-1.211-1.21a7.336 7.336 0 1 1 10.558-10.152 7.522 7.522 0 0 1-.402 9.959l-1.402 1.403.834.836-1.885 1.886 1.887-1.886h11.187V21.538zM47.898 65.436a1.986 1.986 0 0 0-1.526.706c-.648.91-.513 2.16.315 2.912l1.21 1.21 1.213-1.21c.827-.751.962-2.002.315-2.912a1.987 1.987 0 0 0-1.527-.706zm5.128-41.231v5.333H42.36v-5.333h10.666z" }));
});

var _extends$6M = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6L(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMoneyLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6L(_ref, ["styles"]);

  return React.createElement("svg", _extends$6M({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M21.906 24.644l-5.704 5.61L1.596 15.4 16.25 1l5.607 5.706-5.235 5.144 65.379.001c7.627 0 13.83 6.1 13.996 13.687l.003.312a17.44 17.44 0 0 1-12.428 16.704L65.92 47.85l17.65 5.295A17.441 17.441 0 0 1 96 69.85c0 7.733-6.268 14.001-14 14.001L17.19 83.85l4.715 4.794-5.704 5.61L1.596 79.4 16.25 65l5.607 5.706-5.235 5.144 65.377.001a6 6 0 0 0 5.997-5.776L88 69.85a9.441 9.441 0 0 0-6.728-9.043l-29.208-8.762-31.62 10.54a15.532 15.532 0 0 1-4.912.797C6.954 63.382 0 56.428 0 47.85c0-1.67.27-3.328.797-4.912C3.51 34.8 12.306 30.402 20.444 33.115l31.62 10.54 29.209-8.763A9.44 9.44 0 0 0 88 25.85a6 6 0 0 0-6-5.999l-64.809-.001zm-3.992 16.06a7.532 7.532 0 1 0 0 14.291l21.437-7.145z" }));
});

var _extends$6N = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6M(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconMoneySmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6M(_ref, ["styles"]);

  return React.createElement("svg", _extends$6N({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M30.604 32.763l-3.803 3.74-9.737-9.903 9.77-9.6 3.738 3.804-3.491 3.429 43.586.001a9.333 9.333 0 0 1 9.33 9.063l.003.27c0 5.134-3.368 9.66-8.286 11.136l-11.767 3.53 11.767 3.53A11.627 11.627 0 0 1 80 62.9a9.334 9.334 0 0 1-9.334 9.334l-43.206-.001 3.144 3.197-3.803 3.739-9.737-9.902 9.77-9.6 3.738 3.804L27.08 66.9h43.585a4 4 0 0 0 3.996-3.8l.005-.2c0-2.78-1.824-5.23-4.486-6.028L50.71 51.03l-21.08 7.027a10.355 10.355 0 0 1-3.274.531C20.636 58.588 16 53.952 16 48.233c0-1.113.18-2.218.531-3.274 1.809-5.426 7.673-8.358 13.098-6.55l21.08 7.027 19.473-5.841a6.293 6.293 0 0 0 4.485-6.028 4 4 0 0 0-4-4H27.461zm-2.661 10.706a5.021 5.021 0 1 0 0 9.528l14.29-4.764z" }));
});

var _extends$6O = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6N(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconNoResults$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6N(_ref, ["styles"]);

  return React.createElement("svg", _extends$6O({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("g", { fillRule: "evenodd" }, React.createElement("path", { d: "M49.297 26.159l-4.37 9.512H4.355C1.452 34.989 0 33.403 0 30.915c0-2.489 1.452-4.074 4.355-4.756zM41.42 43l-4.37 9.512H4.355C1.452 51.83 0 50.245 0 47.756 0 45.267 1.452 43.682 4.355 43zM34.021 59.5l-4.37 9.512H4.355C1.452 68.33 0 66.745 0 64.256c0-2.489 1.452-4.074 4.355-4.756zM57.416 59.697l-4.589 9.594h38.766C94.53 68.67 96 67.07 96 64.494s-1.47-4.176-4.407-4.797zM65.035 43l-4.59 9.594h31.148C94.53 51.973 96 50.374 96 47.797S94.53 43.62 91.593 43zM72.705 26l-4.589 9.594h23.477C94.53 34.973 96 33.374 96 30.797S94.53 26.62 91.593 26zM70.184 20.889L42.417 78.817a5.244 5.244 0 0 1-6.906 2.504l-.651-.298a5.244 5.244 0 0 1-2.55-7.036l27.766-57.928a5.244 5.244 0 0 1 6.906-2.504l.652.297a5.244 5.244 0 0 1 2.55 7.037z" })));
});

var _extends$6P = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6O(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconOnlineOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6O(_ref, ["styles"]);

  return React.createElement("svg", _extends$6P({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M84.263 0v4.897a5.399 5.399 0 0 0 1.22 3.383l.423.466c5.258 5.314 5.258 13.87-.03 19.214-4.745 4.694-10.452 4.59-17.19 1.23l-.848-.438-.925-.425a22.73 22.73 0 0 0-8.4-1.878l-1.201.002-1.044.053a22.738 22.738 0 0 0-13.732 5.876l-.8.764-4.052 4.052L20.24 54c-8.052 7.724-8.351 20.503-.814 28.449 7.854 7.457 20.123 7.395 27.954-.033l16.582-16.585-7.164-7.136a18.68 18.68 0 0 1-3.784-6.22l-.31-.922-1.077-.371a19.148 19.148 0 0 1-5.087-2.925l-.94-.795-7.08-7.079 5.657-5.656 6.915 6.925c.35.312.715.599 1.094.86a18.97 18.97 0 0 1 3.982-8.494l.795-.895c1.732-1.678 4.004-2.672 6.603-2.819l.616-.004.41.018.823.084a10.06 10.06 0 0 1 7.326 5.088c2.294 4.232 1.302 9.492-2.417 12.634a18.76 18.76 0 0 1-8.59 3.977c.102.152.21.3.322.446l.512.612 9.88 9.839a4 4 0 0 1 .338 5.284l-.333.378-18.66 18.658c-10.77 11.229-28.591 11.645-40.022.785-10.47-11.028-10.31-28.298.177-39.125l.749-.745L32.08 31.487l3.995-3.994c4.971-4.988 11.442-8.072 18.403-8.854l1.31-.12 1.128-.055a30.707 30.707 0 0 1 11.973 2.035l1.282.524 1.208.561c4.58 2.431 6.981 2.558 8.84.72 2.174-2.197 2.174-5.735.035-7.898a13.402 13.402 0 0 1-3.957-8.595l-.034-.892V0zm-1.644 33.849a24.277 24.277 0 0 1-3.45 27.982l-.715.748-5.66-5.653a16.278 16.278 0 0 0 3.184-18.497l-.39-.767zm-18.625 4.446l-.165.001c-.486.029-.948.231-1.06.317l-.481.554a10.82 10.82 0 0 0-2.293 5.051l-.009.072.174-.023a10.768 10.768 0 0 0 4.4-1.799l.644-.489c.781-.66.992-1.779.526-2.638-.308-.554-.856-.933-1.28-1.001z" }));
});

var _extends$6Q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6P(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconOnlineOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6P(_ref, ["styles"]);

  return React.createElement("svg", _extends$6Q({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M72.175 16v3.264a3.6 3.6 0 0 0 .814 2.256l.282.31c3.505 3.543 3.505 9.247-.02 12.81-3.164 3.13-6.968 3.06-11.46.82l-.566-.292-.616-.283a15.153 15.153 0 0 0-5.6-1.252l-.801.001-.696.035a15.159 15.159 0 0 0-9.155 3.918l-.532.51-2.702 2.7L29.493 52c-5.368 5.15-5.567 13.669-.543 18.966 5.236 4.971 13.416 4.93 18.637-.022L58.64 59.888l-4.776-4.758a12.454 12.454 0 0 1-2.523-4.147l-.207-.614-.717-.248a12.765 12.765 0 0 1-3.392-1.95l-.626-.53-4.72-4.719 3.771-3.77 4.61 4.616c.233.207.476.398.729.572a12.663 12.663 0 0 1 2.655-5.661l.53-.597c1.155-1.118 2.67-1.781 4.402-1.879l.41-.003.274.012.549.056a6.707 6.707 0 0 1 4.884 3.392 6.782 6.782 0 0 1-1.611 8.423 12.506 12.506 0 0 1-5.728 2.65c.07.102.141.201.215.298l.342.408L64.298 58c.965.96 1.04 2.475.226 3.522l-.222.252-12.44 12.439c-7.18 7.486-19.06 7.764-26.681.523-6.98-7.352-6.874-18.865.118-26.083l.499-.497 11.59-11.163 2.663-2.664a20.503 20.503 0 0 1 12.268-5.902l.874-.08.752-.037a20.471 20.471 0 0 1 7.981 1.357l.856.35.805.373c3.054 1.621 4.654 1.706 5.893.48 1.45-1.465 1.45-3.823.023-5.265a8.935 8.935 0 0 1-2.637-5.73l-.023-.594V16zM71.08 38.566a16.185 16.185 0 0 1-2.3 18.655l-.478.498-3.772-3.769a10.852 10.852 0 0 0 2.122-12.33l-.26-.512zM58.662 41.53l-.11.001c-.324.019-.631.154-.706.211l-.32.37a7.213 7.213 0 0 0-1.53 3.367l-.005.048.116-.016a7.179 7.179 0 0 0 2.933-1.199l.43-.326c.52-.44.66-1.186.35-1.759-.205-.37-.571-.622-.853-.667z" }));
});

var _extends$6R = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6Q(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPageOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6Q(_ref, ["styles"]);

  return React.createElement("svg", _extends$6R({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M13.5 14.5a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-13A.5.5 0 0 1 3 1h6.5v4h4v9.5zM13.268 4H10.5V1.232L13.268 4zm1.23 0L10.5.002V0H2a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4h-.002z" }));
});

var _extends$6S = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6R(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPageOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6R(_ref, ["styles"]);

  return React.createElement("svg", _extends$6S({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M18 18.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5H14v4h4v9.5zM17.768 8H15V5.232L17.768 8zm1.23 0L15 4.002V4H6.5a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V8h-.002z" }));
});

var _extends$6T = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6S(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPauseFilledLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6S(_ref, ["styles"]);

  return React.createElement("svg", _extends$6T({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("circle", { cx: "48", cy: "48", r: "48" }), React.createElement("path", { fill: "#FFF", d: "M28 28h15v40H28zM53 28h15v40H53z" }));
});

var _extends$6U = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6T(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPauseFilledSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6T(_ref, ["styles"]);

  return React.createElement("svg", _extends$6U({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("circle", { cx: "48", cy: "48", r: "32" }), React.createElement("path", { fill: "#FFF", d: "M34.667 34.667h10v26.667h-10zM51.333 34.667h10v26.667h-10z" }));
});

var _extends$6V = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6U(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPauseOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6U(_ref, ["styles"]);

  return React.createElement("svg", _extends$6V({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fillRule: "evenodd", d: "M8.857 16h4.572V0H8.857v16zM10 14.857h2.286V1.143H10v13.714zM2 16h4.571V0H2v16zm1.143-1.143h2.286V1.143H3.143v13.714z" }));
});

var _extends$6W = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6V(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPauseOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6V(_ref, ["styles"]);

  return React.createElement("svg", _extends$6W({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { fillRule: "evenodd", d: "M12.857 20h4.572V4h-4.572v16zM14 18.857h2.286V5.143H14v13.714zM6 20h4.571V4H6v16zm1.143-1.143h2.286V5.143H7.143v13.714z" }));
});

var _extends$6X = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6W(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$r = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6W(_ref, ["styles"]);

  return React.createElement("svg", _extends$6X({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M49.92 2C75.37 2 96 22.63 96 48.08S75.37 94.16 49.92 94.16c-20.096-.001-37.874-13.025-43.935-32.186-4.983-15.756-1.098-32.673 9.581-44.614H6.432V9.68h23.04v23.04h-7.68l-.001-10.798C11.105 33.396 8.294 50.565 15.483 65.107c8.397 16.988 27.93 25.312 46 19.603s29.275-23.744 26.389-42.473C84.986 23.508 68.87 9.684 49.92 9.68zm2.004 15.36v31.054H72.96v7.68H51.924a10.664 10.664 0 0 1-10.366 11.602 9.214 9.214 0 0 1-9.205-9.202c0-5.018 3.624-10.08 11.723-10.08h.168V17.36zm-7.68 38.734h-.168c-4.043 0-4.043 1.744-4.043 2.4a1.525 1.525 0 0 0 1.525 1.522c.446 0 2.671-.191 2.686-3.922z" }));
});

var _extends$6Y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6X(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPendingFilledSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6X(_ref, ["styles"]);

  return React.createElement("svg", _extends$6Y({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48.396 17c16.966 0 30.72 13.754 30.72 30.72s-13.754 30.72-30.72 30.72a30.722 30.722 0 0 1-22.902-51.2h-6.09v-5.12h15.36v15.36h-5.12v-7.2c-7.125 7.65-9 19.096-4.207 28.791 5.599 11.325 18.62 16.875 30.667 13.069 12.047-3.806 19.517-15.83 17.593-28.315S61.029 22.122 48.396 22.12zm1.336 10.24v20.702h14.024v5.12H49.732a7.11 7.11 0 0 1-6.911 7.736 6.143 6.143 0 0 1-6.137-6.136c0-3.345 2.417-6.72 7.815-6.72h.113V27.24zm-5.12 25.822h-.113c-2.695 0-2.695 1.163-2.695 1.6.001.561.456 1.015 1.017 1.016.297 0 1.78-.128 1.79-2.616z" }));
});

var _extends$6Z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6Y(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPersonOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6Y(_ref, ["styles"]);

  return React.createElement("svg", _extends$6Z({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M14.367 14.753V16h-1.43v-1.247c0-2.755-2.195-4.987-4.904-4.987-2.708 0-4.903 2.233-4.903 4.987V16H1.7v-1.247c0-2.527 1.448-4.78 3.644-5.827a4.901 4.901 0 0 1-2.112-4.043C3.232 2.187 5.382 0 8.033 0c2.65 0 4.801 2.187 4.801 4.883a4.9 4.9 0 0 1-2.112 4.043c2.196 1.048 3.645 3.3 3.645 5.827zM4.68 4.875c0 1.864 1.502 3.375 3.353 3.375 1.853 0 3.353-1.51 3.353-3.375 0-1.864-1.5-3.375-3.353-3.375-1.851 0-3.353 1.511-3.353 3.375z" }));
});

var _extends$6_ = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6Z(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPersonOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6Z(_ref, ["styles"]);

  return React.createElement("svg", _extends$6_({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M18.667 18.753V20h-1.43v-1.247c0-2.755-2.195-4.987-4.904-4.987-2.708 0-4.903 2.233-4.903 4.987V20H6v-1.247c0-2.527 1.448-4.78 3.644-5.827a4.901 4.901 0 0 1-2.112-4.043C7.532 6.187 9.682 4 12.333 4c2.65 0 4.801 2.187 4.801 4.883a4.9 4.9 0 0 1-2.112 4.043c2.196 1.048 3.645 3.3 3.645 5.827zM8.98 8.875c0 1.864 1.502 3.375 3.353 3.375 1.853 0 3.353-1.51 3.353-3.375 0-1.864-1.5-3.375-3.353-3.375-1.851 0-3.353 1.511-3.353 3.375z" }));
});

var _extends$6$ = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6_(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPhoneHoldLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6_(_ref, ["styles"]);

  return React.createElement("svg", _extends$6$({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7.834.55L9.07.568s.14.12.173.173a.572.572 0 0 1 .12.205c.22.84.296 2.644.011 3.469-.01.053-.085.128-.128.17-.042.043-.246.117-.246.117l-1.138-.007L7.834.55zm.01 14.931l-.026-4.145 1.138.007s.204.077.248.12c.043.043.118.119.13.173.284.818.231 2.621.022 3.458a.554.554 0 0 1-.117.203 1.23 1.23 0 0 1-.17.17l-1.225.014zM6.436 7.843s.005.88.029 1.181c.023.301.08.914.18 1.204.054.162.206.463.325.56.076.055.334.1.334.1l.026 4.145s-.548-.187-.721-.295a3.874 3.874 0 0 1-.637-.552 7.043 7.043 0 0 1-.737-1.014c-.163-.29-.403-.937-.513-1.26a13.57 13.57 0 0 1-.374-1.441 16.953 16.953 0 0 1-.161-1.655c-.012-.247-.039-.977-.039-.977s.017-.73.026-.977c.02-.408.078-1.245.14-1.653.062-.365.24-1.083.356-1.437.105-.321.337-.964.496-1.253.149-.278.51-.77.724-1.004.15-.15.448-.427.63-.544.16-.096.718-.285.718-.285l.027 4.145s-.258.041-.333.094c-.128.107-.276.407-.318.557-.095.289-.145.9-.164 1.201-.02.28-.014 1.16-.014 1.16zm2.767-2.271l1.383-.049.17 4.844-1.384.048-.17-4.843zm2.075-.073l1.384-.048.17 4.843-1.385.049-.169-4.844z" }));
});

var _extends$70 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6$(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPhoneHoldSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6$(_ref, ["styles"]);

  return React.createElement("svg", _extends$70({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M11.834 4.55l1.235.018s.14.12.173.173a.572.572 0 0 1 .12.205c.22.84.296 2.644.011 3.469-.01.053-.085.128-.128.17-.042.043-.246.117-.246.117l-1.138-.007-.027-4.145zm.01 14.931l-.026-4.145 1.138.007s.204.077.248.12c.043.043.118.119.13.173.284.818.231 2.621.022 3.458a.554.554 0 0 1-.117.203c-.032.053-.17.17-.17.17l-1.225.014zm-1.408-7.638s.005.88.029 1.181c.023.301.08.914.18 1.204.054.162.206.463.325.56.076.055.334.1.334.1l.026 4.145s-.548-.187-.721-.295a3.874 3.874 0 0 1-.637-.552 7.043 7.043 0 0 1-.737-1.014c-.163-.29-.403-.937-.513-1.26a13.57 13.57 0 0 1-.374-1.441 16.953 16.953 0 0 1-.161-1.655c-.012-.247-.039-.977-.039-.977s.017-.73.026-.977c.02-.408.078-1.245.14-1.653.062-.365.24-1.083.356-1.437.105-.321.337-.964.496-1.253.149-.278.51-.77.724-1.004.15-.15.448-.427.63-.544.16-.096.718-.285.718-.285l.027 4.145s-.258.041-.333.094c-.128.107-.276.407-.318.557-.095.289-.145.9-.164 1.201-.02.28-.014 1.16-.014 1.16zm2.767-2.271l1.383-.049.17 4.844-1.384.048-.17-4.843zm2.075-.073l1.384-.048.17 4.843-1.385.049-.169-4.844z" }));
});

var _extends$71 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$70(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPhoneLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$70(_ref, ["styles"]);

  return React.createElement("svg", _extends$71({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M15.658 9.232l-.02 1.284s-.124.146-.18.18a.595.595 0 0 1-.213.124c-.872.23-2.749.308-3.607.012-.056-.01-.133-.088-.178-.133-.044-.044-.121-.256-.121-.256l.008-1.183 4.31-.028zm-15.53.01l4.312-.028-.008 1.184s-.08.213-.124.258c-.045.045-.124.124-.18.135-.85.296-2.726.241-3.596.023a.576.576 0 0 1-.212-.121 1.279 1.279 0 0 1-.177-.178L.129 9.242zm7.945-1.465s-.916.006-1.229.03c-.313.025-.95.085-1.252.187-.168.057-.482.216-.583.34-.056.078-.103.346-.103.346l-4.31.028s.193-.571.306-.75a4.03 4.03 0 0 1 .574-.663c.236-.214.763-.608 1.054-.766.303-.17.975-.42 1.31-.534.37-.125 1.12-.32 1.5-.389.424-.07 1.285-.153 1.72-.167a123.3 123.3 0 0 1 1.017-.04s.76.017 1.016.026c.424.02 1.295.081 1.719.146.38.064 1.126.25 1.494.37.334.11 1.003.35 1.303.516.29.155.8.531 1.045.753.155.155.444.466.565.655.1.167.297.747.297.747l-4.31.027s-.044-.267-.1-.345c-.11-.134-.422-.288-.578-.332-.3-.098-.937-.15-1.25-.17-.29-.02-1.205-.015-1.205-.015z" }));
});

var _extends$72 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$71(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPhoneRingLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$71(_ref, ["styles"]);

  return React.createElement("svg", _extends$72({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M.889 1.113L2.027.009s.236-.02.314 0c.079 0 .236.038.294.077.962.562 2.67 2.131 3.16 3.139.04.058.04.193.04.27 0 .078-.118.33-.118.33l-1.04 1.027-3.788-3.74zM14.454 14.66l-3.787-3.74 1.04-1.026s.255-.116.333-.116c.079 0 .216 0 .275.039 1.001.484 2.59 2.17 3.16 3.119.039.058.078.213.078.29.02.078 0 .31 0 .31l-1.099 1.124zM6.241 9.004s.804.794 1.099 1.046c.294.252.902.756 1.256.93.196.097.608.233.804.213.118-.02.393-.213.393-.213l3.787 3.74s-.667.328-.922.387a4.974 4.974 0 0 1-1.08.077c-.392-.02-1.196-.136-1.589-.252-.412-.116-1.217-.484-1.61-.678a17.423 17.423 0 0 1-1.648-.969 21.767 21.767 0 0 1-1.648-1.356c-.236-.213-.923-.852-.923-.852s-.647-.678-.863-.91c-.353-.388-1.06-1.202-1.374-1.628a17.105 17.105 0 0 1-.981-1.627C.746 6.524.372 5.73.255 5.323.137 4.936.02 4.161 0 3.753c0-.27.02-.793.078-1.065.06-.232.393-.91.393-.91l3.788 3.739s-.197.271-.216.387c-.02.213.117.62.216.795.176.348.686.949.942 1.24.235.27 1.04 1.065 1.04 1.065zm4.977-4.17s.413.407.491.504c.118.136.353.426.432.581.078.174.216.446.275.717.039.213.058.484.058.64 0 .174-.058.697-.058.697l-.668-.485s.02-.348 0-.465c0-.116-.039-.29-.078-.426a2.245 2.245 0 0 0-.236-.484c-.078-.116-.255-.33-.333-.426-.079-.097-.373-.407-.373-.407s-.295-.271-.412-.368a6.382 6.382 0 0 0-.432-.33c-.118-.058-.294-.174-.49-.232-.138-.039-.315-.058-.432-.078H8.49L8 3.614s.53-.058.706-.058c.177 0 .452.019.648.058.294.038.57.174.726.27.157.098.452.31.589.427.137.116.55.523.55.523zm.89-1.778s.392.407.49.504c.118.136.353.426.432.581.078.175.216.446.274.717.04.213.06.484.06.64 0 .174-.06.697-.06.697l-.667-.484s.02-.35 0-.465c0-.117-.039-.291-.078-.427a2.245 2.245 0 0 0-.236-.484c-.078-.116-.255-.33-.333-.426a13.014 13.014 0 0 0-.373-.407s-.295-.271-.412-.368a6.382 6.382 0 0 0-.432-.33c-.118-.058-.295-.174-.49-.232-.138-.039-.315-.058-.432-.077H9.38l-.491-.66s.53-.057.706-.057c.177 0 .452.02.648.058.294.039.57.174.726.271.157.097.451.31.589.426.137.117.55.523.55.523zM13.41 1.98s.351.33.418.43c.1.115.302.363.368.495.067.149.185.38.235.611.033.182.05.413.05.546 0 .148-.05.594-.05.594l-.57-.413s.018-.297 0-.396c0-.1-.033-.248-.066-.364a1.914 1.914 0 0 0-.2-.413c-.068-.099-.218-.28-.285-.363a11.097 11.097 0 0 0-.318-.347s-.251-.231-.352-.314a5.442 5.442 0 0 0-.368-.28c-.1-.05-.25-.15-.418-.199-.117-.033-.268-.05-.368-.066h-.402l-.418-.562s.451-.05.602-.05c.15 0 .385.017.552.05.251.033.486.15.62.232.133.082.384.264.501.363.118.1.469.446.469.446z" }));
});

var _extends$73 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$72(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPhoneRingSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$72(_ref, ["styles"]);

  return React.createElement("svg", _extends$73({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M4.889 5.113l1.138-1.104s.236-.02.314 0c.079 0 .236.038.294.077.962.562 2.67 2.131 3.16 3.139.04.058.04.193.04.27 0 .078-.118.33-.118.33l-1.04 1.027-3.788-3.74zM18.454 18.66l-3.787-3.74 1.04-1.026s.255-.116.333-.116c.079 0 .216 0 .275.039 1.001.484 2.59 2.17 3.16 3.119.039.058.078.213.078.29.02.078 0 .31 0 .31l-1.099 1.124zm-8.213-5.656s.804.794 1.099 1.046c.294.252.902.756 1.256.93.196.097.608.233.804.213.118-.02.393-.213.393-.213l3.787 3.74s-.667.328-.922.387a4.974 4.974 0 0 1-1.08.077c-.392-.02-1.196-.136-1.589-.252-.412-.116-1.217-.484-1.61-.678a17.423 17.423 0 0 1-1.648-.969 21.767 21.767 0 0 1-1.648-1.356c-.236-.213-.923-.852-.923-.852s-.647-.678-.863-.91c-.353-.388-1.06-1.202-1.374-1.628a17.105 17.105 0 0 1-.981-1.627c-.196-.388-.57-1.182-.687-1.589-.118-.387-.235-1.162-.255-1.57 0-.27.02-.793.078-1.065.06-.232.393-.91.393-.91l3.788 3.739s-.197.271-.216.387c-.02.213.117.62.216.795.176.348.686.949.942 1.24.235.27 1.04 1.065 1.04 1.065zm4.977-4.17s.413.407.491.504c.118.136.353.426.432.581.078.174.216.446.275.717.039.213.058.484.058.64 0 .174-.058.697-.058.697l-.668-.485s.02-.348 0-.465c0-.116-.039-.29-.078-.426a2.245 2.245 0 0 0-.236-.484c-.078-.116-.255-.33-.333-.426-.079-.097-.373-.407-.373-.407s-.295-.271-.412-.368a6.382 6.382 0 0 0-.432-.33c-.118-.058-.294-.174-.49-.232-.138-.039-.315-.058-.432-.078h-.471L12 7.614s.53-.058.706-.058c.177 0 .452.019.648.058.294.038.57.174.726.27.157.098.452.31.589.427.137.116.55.523.55.523zm.89-1.778s.392.407.49.504c.118.136.353.426.432.581.078.175.216.446.274.717.04.213.06.484.06.64 0 .174-.06.697-.06.697l-.667-.484s.02-.35 0-.465c0-.117-.039-.291-.078-.427a2.245 2.245 0 0 0-.236-.484c-.078-.116-.255-.33-.333-.426a13.014 13.014 0 0 0-.373-.407s-.295-.271-.412-.368a6.382 6.382 0 0 0-.432-.33c-.118-.058-.295-.174-.49-.232-.138-.039-.315-.058-.432-.077h-.471l-.491-.66s.53-.057.706-.057c.177 0 .452.02.648.058.294.039.57.174.726.271.157.097.451.31.589.426.137.117.55.523.55.523zM17.41 5.98s.351.33.418.43c.1.115.302.363.368.495.067.149.185.38.235.611.033.182.05.413.05.546 0 .148-.05.594-.05.594l-.57-.413s.018-.297 0-.396c0-.1-.033-.248-.066-.364a1.914 1.914 0 0 0-.2-.413c-.068-.099-.218-.28-.285-.363a11.097 11.097 0 0 0-.318-.347s-.251-.231-.352-.314a5.442 5.442 0 0 0-.368-.28c-.1-.05-.25-.15-.418-.199-.117-.033-.268-.05-.368-.066h-.402l-.418-.562s.451-.05.602-.05c.15 0 .385.017.552.05.251.033.486.15.62.232.133.082.384.264.501.363.118.1.469.446.469.446z" }));
});

var _extends$74 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$73(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPhoneSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$73(_ref, ["styles"]);

  return React.createElement("svg", _extends$74({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M19.658 13.232l-.02 1.284s-.124.146-.18.18a.595.595 0 0 1-.213.124c-.872.23-2.749.308-3.607.012-.056-.01-.133-.088-.178-.133-.044-.044-.121-.256-.121-.256l.008-1.183 4.31-.028zm-15.53.01l4.312-.028-.008 1.184s-.08.213-.124.258c-.045.045-.124.124-.18.135-.85.296-2.726.241-3.596.023a.576.576 0 0 1-.212-.121 1.279 1.279 0 0 1-.177-.178l-.014-1.273zm7.945-1.465s-.916.006-1.229.03c-.313.025-.95.085-1.252.187-.168.057-.482.216-.583.34-.056.078-.103.346-.103.346l-4.31.028s.193-.571.306-.75a4.03 4.03 0 0 1 .574-.663c.236-.214.763-.608 1.054-.766.303-.17.975-.42 1.31-.534.37-.125 1.12-.32 1.5-.389.424-.07 1.285-.153 1.72-.167a123.3 123.3 0 0 1 1.017-.04s.76.017 1.016.026c.424.02 1.295.081 1.719.146.38.064 1.126.25 1.494.37.334.11 1.003.35 1.303.516.29.155.8.531 1.045.753.155.155.444.466.565.655.1.167.297.747.297.747l-4.31.027s-.044-.267-.1-.345c-.11-.134-.422-.288-.578-.332-.3-.098-.937-.15-1.25-.17-.29-.02-1.205-.015-1.205-.015z" }));
});

var _extends$75 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$74(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPlusLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$74(_ref, ["styles"]);

  return React.createElement("svg", _extends$75({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M9.333 6.667V0H6.667v6.667H0v2.666h6.667V16h2.666V9.333H16V6.667z" }));
});

var _extends$76 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$75(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPlusOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$75(_ref, ["styles"]);

  return React.createElement("svg", _extends$76({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 16c17.673 0 32 14.327 32 32-.02 17.665-14.335 31.98-32 32-17.673 0-32-14.327-32-32s14.327-32 32-32zm0 5.333c-14.728 0-26.667 11.94-26.667 26.667S33.273 74.667 48 74.667 74.667 62.727 74.667 48C74.65 33.28 62.72 21.35 48 21.333zM50.667 32l-.001 13.333H64v5.334l-13.334-.001V64h-5.333V50.666H32v-5.333h13.333V32z" }));
});

var _extends$77 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$76(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPlusSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$76(_ref, ["styles"]);

  return React.createElement("svg", _extends$77({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13.333 10.667V4h-2.666v6.667H4v2.666h6.667V20h2.666v-6.667H20v-2.666z" }));
});

var _extends$78 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$77(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPlusSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$77(_ref, ["styles"]);

  return React.createElement("svg", _extends$78({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon plus"), React.createElement("path", { d: "M18 14V8h-2v6h-6v2h6v6h2v-6h6v-2z" }));
});

var _extends$79 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$78(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconProspectLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$78(_ref, ["styles"]);

  return React.createElement("svg", _extends$79({ height: "16", viewBox: "0 0 16 16", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fillRule: "evenodd", d: "M15.467 12.8h-1.6v-1.6a.534.534 0 1 0-1.067 0v1.6h-1.6a.534.534 0 0 0 0 1.067h1.6v1.6a.534.534 0 0 0 1.067 0v-1.6h1.6a.533.533 0 1 0 0-1.068M2.667 4.8a3.734 3.734 0 1 1 7.467 0 3.734 3.734 0 0 1-7.467 0m6.081 4.185a4.8 4.8 0 1 0-4.697 0A6.397 6.397 0 0 0 0 14.933V16h1.067v-1.067A5.333 5.333 0 0 1 6.4 9.6c1.436 0 2.737.57 3.696 1.493.231-.27.495-.51.787-.715a6.414 6.414 0 0 0-2.135-1.393" }));
});

var _extends$7a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$79(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconProspectSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$79(_ref, ["styles"]);

  return React.createElement("svg", _extends$7a({ height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { fillRule: "evenodd", d: "M19.467 16.8h-1.6v-1.6a.534.534 0 1 0-1.067 0v1.6h-1.6a.534.534 0 0 0 0 1.067h1.6v1.6a.534.534 0 0 0 1.067 0v-1.6h1.6a.533.533 0 1 0 0-1.068M6.667 8.8a3.734 3.734 0 1 1 7.467 0 3.734 3.734 0 0 1-7.467 0m6.081 4.185a4.8 4.8 0 1 0-4.697 0A6.397 6.397 0 0 0 4 18.933V20h1.067v-1.067A5.333 5.333 0 0 1 10.4 13.6c1.436 0 2.737.57 3.696 1.493.231-.27.495-.51.787-.715a6.414 6.414 0 0 0-2.135-1.393" }));
});

var _extends$7b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7a(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconQuestionSolidLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7a(_ref, ["styles"]);

  return React.createElement("svg", _extends$7b({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 0c26.51 0 48 21.49 48 48S74.51 96 48 96 0 74.51 0 48 21.49 0 48 0zm0 5.926C24.763 5.926 5.926 24.763 5.926 48S24.763 90.074 48 90.074 90.074 71.237 90.074 48 71.237 5.926 48 5.926zm-2.462 66.69a4.923 4.923 0 1 1 0 9.846 4.923 4.923 0 0 1 0-9.847zm14.498-53.13a16.821 16.821 0 0 1 5.195 12.2c0 5.78-2.703 9.826-9.734 14.87-5.379 3.87-6.69 5.929-6.69 10.216v5.997h-5.515v-5.997c0-6.213 2.336-9.952 9.02-14.639 5.609-3.935 7.403-6.597 7.403-10.454a11.395 11.395 0 0 0-3.538-8.307 11.441 11.441 0 0 0-8.456-3.14l-.132.002a12.265 12.265 0 0 0-8.976 3.606 12.212 12.212 0 0 0-3.553 9.004l.057 1.81h-5.523l-.048-1.706a17.622 17.622 0 0 1 5.14-12.939c3.425-3.437 8.117-5.327 12.868-5.224a17.003 17.003 0 0 1 12.482 4.7z" }));
});

var _extends$7c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7b(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconQuestionSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7b(_ref, ["styles"]);

  return React.createElement("svg", _extends$7c({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 16c17.673 0 32 14.327 32 32S65.673 80 48 80 16 65.673 16 48s14.327-32 32-32zm0 3.95C32.509 19.95 19.95 32.51 19.95 48S32.51 76.05 48 76.05 76.05 63.49 76.05 48 63.49 19.95 48 19.95zm-1.641 44.46a3.282 3.282 0 1 1 0 6.564 3.282 3.282 0 0 1 0-6.564zm9.665-35.42a11.214 11.214 0 0 1 3.463 8.135c0 3.852-1.802 6.55-6.489 9.912-3.586 2.58-4.46 3.953-4.46 6.81v4h-3.677v-4c0-4.141 1.558-6.634 6.014-9.758 3.739-2.624 4.935-4.398 4.935-6.97a7.596 7.596 0 0 0-2.359-5.537 7.627 7.627 0 0 0-5.637-2.094l-.088.001a8.177 8.177 0 0 0-5.984 2.404 8.141 8.141 0 0 0-2.369 6.003l.038 1.207H35.73l-.032-1.138a11.748 11.748 0 0 1 3.427-8.626c2.283-2.291 5.412-3.55 8.579-3.483a11.335 11.335 0 0 1 8.32 3.134z" }));
});

var _extends$7d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7c(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconRadio = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7c(_ref, ["styles"]);

  return React.createElement("svg", _extends$7d({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("circle", { cx: "48", cy: "48", r: "35" }));
});

var _extends$7e = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7d(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconRetrieveLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7d(_ref, ["styles"]);

  return React.createElement("svg", _extends$7e({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M9 8V4L0 8.5 9 13V9h7V8H9z" }));
});

var _extends$7f = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7e(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconRetrieveSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7e(_ref, ["styles"]);

  return React.createElement("svg", _extends$7f({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13 12V8l-9 4.5 9 4.5v-4h7v-1h-7z" }));
});

var _extends$7g = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7f(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconSettingsOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7f(_ref, ["styles"]);

  return React.createElement("svg", _extends$7g({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M88.782 46.223l-1.809.965a4.049 4.049 0 0 0-2.13 3.426 38.809 38.809 0 0 1-.259 3.28 35.662 35.662 0 0 1-1.42 6.544 4.073 4.073 0 0 0 .842 3.95l1.338 1.492a40.692 40.692 0 0 1-3.96 6.963l-2.012-.436a3.984 3.984 0 0 0-3.814 1.241 36.27 36.27 0 0 1-7.546 6.402 4.055 4.055 0 0 0-1.868 3.572l.076 2.068a39.46 39.46 0 0 1-7.468 2.741l-1.26-1.635a3.989 3.989 0 0 0-3.74-1.52c-1.632.24-3.279.367-4.928.38a35.725 35.725 0 0 1-4.867-.38 3.989 3.989 0 0 0-3.74 1.52l-1.26 1.636a39.364 39.364 0 0 1-7.468-2.742l.076-2.068a4.055 4.055 0 0 0-1.868-3.572 36.27 36.27 0 0 1-7.546-6.402 3.984 3.984 0 0 0-3.813-1.242l-2.015.437a40.575 40.575 0 0 1-3.958-6.963l1.338-1.493a4.073 4.073 0 0 0 .845-3.942 36.615 36.615 0 0 1-1.681-9.817 4.049 4.049 0 0 0-2.131-3.44l-1.81-.966a40.557 40.557 0 0 1 1.388-7.91l1.981-.276a4.013 4.013 0 0 0 3.16-2.477 36.383 36.383 0 0 1 4.954-8.62 4.076 4.076 0 0 0 .554-4.014l-.76-1.89a40.309 40.309 0 0 1 6.104-5.165l1.68 1.065a3.974 3.974 0 0 0 4.01.147 35.546 35.546 0 0 1 9.29-3.415 4.02 4.02 0 0 0 2.976-2.714l.613-1.918a39.798 39.798 0 0 1 4.007-.231c1.303.01 2.626.086 3.95.23l.614 1.92a4.02 4.02 0 0 0 2.976 2.713 35.546 35.546 0 0 1 9.29 3.415 3.974 3.974 0 0 0 4.009-.147l1.68-1.065a40.313 40.313 0 0 1 6.325 5.393l-1.521 5.6-9.329 7.929-.66-.822c-5.75-6.829-14.907-9.662-23.46-7.257C32.145 30.09 25.34 40.3 26.224 51.36a13.703 13.703 0 0 0 8.228 11.695 13.507 13.507 0 0 0 14.112-2.123l15.044-12.786a15.001 15.001 0 0 1-1.348 6.968c-2.417 5.271-7.648 8.644-13.402 8.64l-.005 8.09c8.878.005 16.95-5.198 20.68-13.332A23.183 23.183 0 0 0 70.65 42.16l11.67-9.92a4.05 4.05 0 0 0 1.284-2.024l2.435-8.962a4.074 4.074 0 0 0-.835-3.718 48.342 48.342 0 0 0-11.73-9.925 3.975 3.975 0 0 0-4.185.047L67.36 8.88a43.51 43.51 0 0 0-6.976-2.565l-.697-2.18a4.019 4.019 0 0 0-3.149-2.748c-2.53-.43-5.09-.654-7.656-.673a47.875 47.875 0 0 0-7.713.673 4.019 4.019 0 0 0-3.149 2.747l-.696 2.18a43.51 43.51 0 0 0-6.977 2.565l-1.927-1.221a3.975 3.975 0 0 0-4.185-.048 48.342 48.342 0 0 0-11.73 9.926 4.075 4.075 0 0 0-.683 4.171l.87 2.163a44.493 44.493 0 0 0-3.711 6.462l-2.275.318a4.016 4.016 0 0 0-3.234 2.675A48.81 48.81 0 0 0 .861 46.836c-.096 2.56 1.245 4.902 3.448 6.072l.691.37a44.776 44.776 0 0 0 1.261 7.355L4.724 62.35a4.074 4.074 0 0 0-.775 4.145 48.82 48.82 0 0 0 6.582 12.053c1.564 2.033 4.088 2.954 6.521 2.412l.777-.168a44.303 44.303 0 0 0 5.645 4.788l-.087 2.367a4.053 4.053 0 0 0 2.049 3.68 47.443 47.443 0 0 0 12.732 4.933 6.445 6.445 0 0 0 6.512-2.379l.476-.617c1.22.112 2.443.173 3.668.182 1.263-.01 2.503-.07 3.729-.183l.484.628a6.424 6.424 0 0 0 6.458 2.38 47.515 47.515 0 0 0 12.778-4.943 4.053 4.053 0 0 0 2.049-3.68l-.087-2.368a44.303 44.303 0 0 0 5.645-4.788l.799.173c2.41.537 4.936-.384 6.463-2.37 2.784-3.73 5-7.788 6.618-12.1a4.074 4.074 0 0 0-.775-4.145l-1.535-1.714c.49-1.89.854-3.814 1.088-5.757l.167-1.599.704-.375c2.194-1.166 3.536-3.507 3.442-6.018a48.892 48.892 0 0 0-2.615-13.561l-7.567 2.663a40.643 40.643 0 0 1 1.945 8.495zm-45.38 8.52c-1.616 1.373-3.86 1.711-5.802.873s-3.25-2.709-3.384-4.837c-.589-7.37 3.903-14.109 10.822-16.313 5.412-1.519 11.347.317 15.073 4.743l.321.395.307.405z" }));
});

var _extends$7h = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7g(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconSettingsOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7g(_ref, ["styles"]);

  return React.createElement("svg", _extends$7h({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M74.473 46.053l-1.205.644a2.7 2.7 0 0 0-1.42 2.284 25.872 25.872 0 0 1-.173 2.187 23.775 23.775 0 0 1-.948 4.362 2.716 2.716 0 0 0 .562 2.633l.892.995a27.128 27.128 0 0 1-2.64 4.642l-1.341-.29a2.656 2.656 0 0 0-2.542.827 24.18 24.18 0 0 1-5.031 4.268 2.704 2.704 0 0 0-1.246 2.381l.051 1.379a26.307 26.307 0 0 1-4.979 1.827l-.84-1.09a2.66 2.66 0 0 0-2.493-1.013c-1.088.16-2.186.244-3.286.253a23.817 23.817 0 0 1-3.244-.253 2.66 2.66 0 0 0-2.493 1.013l-.84 1.091a26.243 26.243 0 0 1-4.979-1.828l.05-1.379a2.704 2.704 0 0 0-1.245-2.381 24.18 24.18 0 0 1-5.03-4.268 2.656 2.656 0 0 0-2.543-.828l-1.343.291a27.05 27.05 0 0 1-2.638-4.642l.891-.995a2.716 2.716 0 0 0 .564-2.628 24.41 24.41 0 0 1-1.12-6.545 2.7 2.7 0 0 0-1.422-2.293l-1.206-.644c.132-1.774.442-3.544.925-5.273l1.321-.184a2.675 2.675 0 0 0 2.107-1.652 24.255 24.255 0 0 1 3.302-5.747c.589-.76.73-1.781.37-2.676l-.508-1.26a26.873 26.873 0 0 1 4.07-3.443l1.12.71a2.65 2.65 0 0 0 2.673.098 23.697 23.697 0 0 1 6.194-2.277 2.68 2.68 0 0 0 1.984-1.809l.408-1.279a26.532 26.532 0 0 1 2.672-.154c.868.007 1.75.058 2.634.154l.408 1.28A2.68 2.68 0 0 0 52.9 24.35a23.697 23.697 0 0 1 6.194 2.276 2.65 2.65 0 0 0 2.672-.098l1.121-.71a26.876 26.876 0 0 1 4.216 3.596l-1.014 3.733-6.219 5.286-.44-.548c-3.833-4.553-9.938-6.441-15.64-4.838a15.885 15.885 0 0 0-11.023 16.431c.213 3.404 2.336 6.438 5.485 7.797s6.789.811 9.409-1.416l10.029-8.524a10 10 0 0 1-.899 4.646c-1.611 3.514-5.099 5.762-8.934 5.76l-.004 5.393c5.919.004 11.3-3.465 13.786-8.888a15.455 15.455 0 0 0 .746-10.901l7.78-6.613a2.7 2.7 0 0 0 .856-1.35l1.624-5.975a2.716 2.716 0 0 0-.557-2.478 32.228 32.228 0 0 0-7.82-6.617 2.65 2.65 0 0 0-2.79.031l-1.285.815a29.006 29.006 0 0 0-4.651-1.71l-.465-1.454a2.679 2.679 0 0 0-2.099-1.83 31.83 31.83 0 0 0-5.104-.45 31.917 31.917 0 0 0-5.142.45 2.679 2.679 0 0 0-2.1 1.83l-.464 1.454a29.006 29.006 0 0 0-4.65 1.71l-1.286-.815a2.65 2.65 0 0 0-2.79-.031 32.228 32.228 0 0 0-7.82 6.617 2.717 2.717 0 0 0-.455 2.78l.58 1.443a29.662 29.662 0 0 0-2.474 4.308l-1.516.211a2.677 2.677 0 0 0-2.156 1.784 32.54 32.54 0 0 0-1.742 9.007c-.064 1.707.83 3.268 2.299 4.048l.46.246a29.85 29.85 0 0 0 .842 4.904l-1.025 1.144a2.716 2.716 0 0 0-.517 2.764 32.547 32.547 0 0 0 4.388 8.035c1.042 1.355 2.725 1.97 4.347 1.608l.519-.112a29.535 29.535 0 0 0 3.763 3.192l-.058 1.578a2.702 2.702 0 0 0 1.365 2.454 31.629 31.629 0 0 0 8.488 3.288 4.297 4.297 0 0 0 4.342-1.586l.317-.412c.813.075 1.629.116 2.445.122a29.678 29.678 0 0 0 2.487-.122l.322.419a4.282 4.282 0 0 0 4.306 1.586 31.676 31.676 0 0 0 8.518-3.295 2.702 2.702 0 0 0 1.366-2.454l-.058-1.578a29.535 29.535 0 0 0 3.763-3.192l.533.115a4.274 4.274 0 0 0 4.31-1.58 32.605 32.605 0 0 0 4.41-8.066 2.716 2.716 0 0 0-.516-2.764l-1.023-1.142c.327-1.261.57-2.543.726-3.838l.11-1.066.47-.25a4.356 4.356 0 0 0 2.295-4.012 32.594 32.594 0 0 0-1.744-9.041l-5.044 1.775a27.095 27.095 0 0 1 1.296 5.663zm-30.253 5.68c-1.077.916-2.573 1.141-3.868.582s-2.167-1.805-2.256-3.224c-.393-4.914 2.602-9.406 7.215-10.875 3.608-1.013 7.564.211 10.048 3.162l.215.263.204.27z" }));
});

var _extends$7i = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7h(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconSheetLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7h(_ref, ["styles"]);

  return React.createElement("svg", _extends$7i({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fillRule: "evenodd", d: "M14.4 14.933h-1.6V12.8h2.133v1.6a.533.533 0 0 1-.533.533zm-5.867 0h3.2V12.8h-3.2v2.133zm-4.266 0h3.2V12.8h-3.2v2.133zm-2.667 0a.533.533 0 0 1-.533-.533v-1.6H3.2v2.133H1.6zm-.533-3.2H3.2v-3.2H1.067v3.2zm0-4.267H3.2v-3.2H1.067v3.2zm0-5.867c0-.294.239-.532.533-.532h1.6V3.2H1.067V1.6zm3.2 10.134h3.2v-3.2h-3.2v3.2zm0-4.267h3.2v-3.2h-3.2v3.2zm0-4.266h3.2V1.067h-3.2V3.2zm4.266 8.533h3.2v-3.2h-3.2v3.2zm0-4.267h3.2v-3.2h-3.2v3.2zm0-4.266h3.2V1.067h-3.2V3.2zm4.267 8.533h2.133v-3.2H12.8v3.2zm0-4.267h2.133v-3.2H12.8v3.2zm0-6.4h1.6c.294 0 .533.24.533.533V3.2H12.8V1.067zM1.067 0C.477 0 0 .477 0 1.067v13.866C0 15.522.477 16 1.067 16h13.866c.59 0 1.067-.478 1.067-1.067V1.067C16 .477 15.522 0 14.933 0H1.067z" }));
});

var _extends$7j = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7i(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconSheetSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7i(_ref, ["styles"]);

  return React.createElement("svg", _extends$7j({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { fillRule: "evenodd", d: "M18.4 18.933h-1.6V16.8h2.133v1.6a.533.533 0 0 1-.533.533zm-5.867 0h3.2V16.8h-3.2v2.133zm-4.266 0h3.2V16.8h-3.2v2.133zm-2.667 0a.533.533 0 0 1-.533-.533v-1.6H7.2v2.133H5.6zm-.533-3.2H7.2v-3.2H5.067v3.2zm0-4.267H7.2v-3.2H5.067v3.2zm0-5.867c0-.294.239-.532.533-.532h1.6V7.2H5.067V5.6zm3.2 10.134h3.2v-3.2h-3.2v3.2zm0-4.267h3.2v-3.2h-3.2v3.2zm0-4.266h3.2V5.067h-3.2V7.2zm4.266 8.533h3.2v-3.2h-3.2v3.2zm0-4.267h3.2v-3.2h-3.2v3.2zm0-4.266h3.2V5.067h-3.2V7.2zm4.267 8.533h2.133v-3.2H16.8v3.2zm0-4.267h2.133v-3.2H16.8v3.2zm0-6.4h1.6c.294 0 .533.24.533.533V7.2H16.8V5.067zM5.067 4C4.477 4 4 4.477 4 5.067v13.866C4 19.522 4.477 20 5.067 20h13.866c.59 0 1.067-.478 1.067-1.067V5.067C20 4.477 19.522 4 18.933 4H5.067z" }));
});

var _extends$7k = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7j(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconSliderOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7j(_ref, ["styles"]);

  return React.createElement("svg", _extends$7k({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M89.6 76.603a3.2 3.2 0 0 1-3.2 3.2H73.6a3.2 3.2 0 0 1-3.2-3.2v-12.8a3.2 3.2 0 0 1 3.2-3.203h12.8a3.2 3.2 0 0 1 3.2 3.203zm0-22.403h-6.4V3h-6.4v51.2h-6.4c-3.533 0-6.4 2.87-6.4 6.4v19.203c0 3.533 2.867 6.4 6.4 6.4h6.4V92.6h6.4v-6.397h6.4c3.533 0 6.4-2.867 6.4-6.4V60.6c0-3.53-2.867-6.4-6.4-6.4zm-64 9.603a3.2 3.2 0 0 1-3.2 3.2H9.6a3.2 3.2 0 0 1-3.2-3.2V51a3.196 3.196 0 0 1 3.2-3.197h12.8c1.77 0 3.2 1.43 3.2 3.197zm0-22.4h-6.4V3h-6.4v38.403H6.4a6.402 6.402 0 0 0-6.4 6.4v19.2c0 3.533 2.867 6.4 6.4 6.4h6.4V92.6h6.4V73.403h6.4c3.533 0 6.4-2.867 6.4-6.4v-19.2c0-3.533-2.867-6.4-6.4-6.4zm32-9.6A3.196 3.196 0 0 1 54.4 35H41.6c-1.77 0-3.2-1.43-3.2-3.197V19a3.196 3.196 0 0 1 3.2-3.197h12.8c1.77 0 3.2 1.43 3.2 3.197zm6.4-16c0-3.533-2.867-6.4-6.4-6.4h-6.4V3h-6.4v6.403h-6.4a6.402 6.402 0 0 0-6.4 6.4V35a6.403 6.403 0 0 0 6.4 6.403h6.4V92.6h6.4V41.403h6.4c3.533 0 6.4-2.867 6.4-6.403z" }));
});

var _extends$7l = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7k(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconSliderOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7k(_ref, ["styles"]);

  return React.createElement("svg", _extends$7l({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M75.733 67.069a2.133 2.133 0 0 1-2.133 2.133h-8.533a2.133 2.133 0 0 1-2.134-2.133v-8.534c0-1.18.954-2.135 2.134-2.135H73.6c1.18 0 2.133.956 2.133 2.135zm0-14.936h-4.266V18H67.2v34.133h-4.267a4.27 4.27 0 0 0-4.266 4.267v12.802a4.268 4.268 0 0 0 4.266 4.267H67.2v4.264h4.267V73.47h4.266A4.268 4.268 0 0 0 80 69.202V56.4a4.27 4.27 0 0 0-4.267-4.267zm-42.666 6.402a2.133 2.133 0 0 1-2.134 2.134H22.4a2.133 2.133 0 0 1-2.133-2.134V50a2.13 2.13 0 0 1 2.133-2.131h8.533A2.13 2.13 0 0 1 33.067 50zm0-14.933H28.8V18h-4.267v25.602h-4.266A4.268 4.268 0 0 0 16 47.87v12.8a4.268 4.268 0 0 0 4.267 4.266h4.266v12.798H28.8V64.935h4.267a4.268 4.268 0 0 0 4.266-4.266v-12.8a4.268 4.268 0 0 0-4.266-4.267zm21.333-6.4a2.13 2.13 0 0 1-2.133 2.131h-8.534a2.13 2.13 0 0 1-2.133-2.13v-8.536a2.13 2.13 0 0 1 2.133-2.132h8.534a2.13 2.13 0 0 1 2.133 2.132zm4.267-10.667A4.268 4.268 0 0 0 54.4 22.27h-4.267V18h-4.266v4.269H41.6a4.268 4.268 0 0 0-4.267 4.266v12.798a4.269 4.269 0 0 0 4.267 4.27h4.267v34.13h4.266v-34.13H54.4a4.269 4.269 0 0 0 4.267-4.27z" }));
});

var _extends$7m = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7l(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconStatementOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7l(_ref, ["styles"]);

  return React.createElement("svg", _extends$7m({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M84 0v88a8.01 8.01 0 0 1-8 8h-8.006a18.685 18.685 0 0 1-7.935-2.234A18.526 18.526 0 0 1 52.006 96h-8.012a18.553 18.553 0 0 1-7.978-2.238A18.278 18.278 0 0 1 28.01 96H20a8.01 8.01 0 0 1-8-8V0zm-8 8H20v80h8.002a5.326 5.326 0 0 0 1.08-.137 16.544 16.544 0 0 1-3.072-9.086 10.006 10.006 0 0 1 16.113-8.68A9.936 9.936 0 0 1 45.994 78a16.82 16.82 0 0 1-3.086 9.855c.366.086.738.134 1.113.145h7.973c.372-.01.741-.058 1.104-.14a16.488 16.488 0 0 1-3.088-9.079 10.006 10.006 0 0 1 16.113-8.683A9.942 9.942 0 0 1 69.994 78a16.752 16.752 0 0 1-3.043 9.855c.357.084.72.132 1.086.145H76zM59.996 76c-.2.001-.4.027-.594.078a2.232 2.232 0 0 0-1.4 2.371 8.77 8.77 0 0 0 2.006 5.297A8.929 8.929 0 0 0 61.994 78a1.991 1.991 0 0 0-.777-1.582A1.959 1.959 0 0 0 59.996 76zm-23.998 0a2.404 2.404 0 0 0-.596.078 2.232 2.232 0 0 0-1.4 2.371 8.805 8.805 0 0 0 1.988 5.293A8.847 8.847 0 0 0 37.994 78a1.991 1.991 0 0 0-.777-1.582A1.957 1.957 0 0 0 35.998 76zM52 48v8H24v-8zm20 0v8H60v-8zM52 32v8H24v-8zm20 0v8H60v-8zM52 16v8H24v-8zm20 0v8H60v-8z" }));
});

var _extends$7n = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7m(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconStatementOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7m(_ref, ["styles"]);

  return React.createElement("svg", _extends$7n({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M72 16v58.667A5.34 5.34 0 0 1 66.667 80h-5.338a12.457 12.457 0 0 1-5.29-1.49A12.35 12.35 0 0 1 50.671 80h-5.342c-1.862-.09-3.68-.6-5.319-1.492-1.64.9-3.467 1.411-5.337 1.492h-5.34A5.34 5.34 0 0 1 24 74.667V16zm-5.333 5.333H29.333v53.334h5.335a3.55 3.55 0 0 0 .72-.091 11.03 11.03 0 0 1-2.048-6.058 6.67 6.67 0 0 1 10.742-5.786A6.624 6.624 0 0 1 46.662 68c.021 2.352-.699 4.65-2.057 6.57.244.057.493.09.743.097h5.315c.247-.008.494-.039.735-.094a10.992 10.992 0 0 1-2.058-6.052 6.67 6.67 0 0 1 10.742-5.79A6.628 6.628 0 0 1 62.662 68a11.168 11.168 0 0 1-2.028 6.57c.238.056.48.088.724.097h5.309zm-10.67 45.334a1.6 1.6 0 0 0-.395.052 1.488 1.488 0 0 0-.934 1.58 5.846 5.846 0 0 0 1.337 3.532A5.953 5.953 0 0 0 57.33 68c.001-.413-.19-.803-.518-1.055a1.306 1.306 0 0 0-.814-.278zm-15.998 0c-.134 0-.268.018-.397.052a1.488 1.488 0 0 0-.934 1.58 5.87 5.87 0 0 0 1.325 3.53A5.898 5.898 0 0 0 41.33 68c.001-.413-.19-.803-.518-1.055a1.305 1.305 0 0 0-.812-.278zM50.667 48v5.333H32V48zM64 48v5.333h-8V48zM50.667 37.333v5.334H32v-5.334zm13.333 0v5.334h-8v-5.334zM50.667 26.667V32H32v-5.333zm13.333 0V32h-8v-5.333z" }));
});

var _extends$7o = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7n(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconStatusOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7n(_ref, ["styles"]);

  return React.createElement("svg", _extends$7o({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M40.768 21.181v5.12H22.494V72.38h46.08v-20.48h5.12v25.6h-56.32V21.18zM70.919 16a7.68 7.68 0 1 1 0 15.36h-1.452c.122.154.253.3.392.44l1.595 1.62a2.558 2.558 0 0 1-.012 3.606L50.737 57.73l-3.62-3.62 18.91-18.909a10.147 10.147 0 0 1-2.405-4.236 10.324 10.324 0 0 1-4.228-2.395L33.512 54.453l-2.473 9.105 9.105-2.473 1.295-1.295-4.435-4.435 3.62-3.62 6.245 6.245a2.56 2.56 0 0 1 0 3.62l-3.587 3.588a2.56 2.56 0 0 1-1.14.66L28.069 69.67a2.56 2.56 0 0 1-3.14-3.14l3.82-14.075a2.56 2.56 0 0 1 .66-1.14l28.16-28.16c.994-.994 2.604-1 3.605-.014l1.61 1.585c.144.143.296.277.455.403V23.68A7.68 7.68 0 0 1 70.92 16zm0 5.12a2.56 2.56 0 0 0-2.56 2.56v2.56h2.56a2.56 2.56 0 1 0 0-5.12z" }));
});

var _extends$7p = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7o(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTickCircleOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7o(_ref, ["styles"]);

  return React.createElement("svg", _extends$7p({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-1a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm-1.023-3a.85.85 0 0 1-.666-.316L8.17 12.986a.77.77 0 0 1 .161-1.115.86.86 0 0 1 1.17.155l1.41 1.774 3.544-5.425a.861.861 0 0 1 1.15-.255.775.775 0 0 1 .268 1.098l-4.186 6.406a.84.84 0 0 1-.672.374c-.012.002-.025.002-.038.002z" }));
});

var _extends$7q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7p(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTickCircularFilledSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7p(_ref, ["styles"]);

  return React.createElement("svg", _extends$7q({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 16c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32c-.02-17.665-14.335-31.98-32-32z" }), React.createElement("g", { fill: "none", fillRule: "evenodd" }, React.createElement("path", { d: "M16 16h64v64H16z" }), React.createElement("path", { d: "M42.738 63.679a2.34 2.34 0 0 1-1.668.757h-.056c-.618 0-1.211-.244-1.648-.678l-9.322-9.259 3.295-3.273 7.594 7.543 21.663-23.666 3.448 3.115z", fill: "#fff" })), "g>");
});

var _extends$7r = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7q(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTickInterfaceOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7q(_ref, ["styles"]);

  return React.createElement("svg", _extends$7r({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M15.71 5.032l-7.473 7.8-1.404 1.466a.98.98 0 0 1-.702.302.979.979 0 0 1-.701-.302l-1.404-1.465-3.737-3.9a1.07 1.07 0 0 1 0-1.466l1.404-1.465a.978.978 0 0 1 .702-.302.98.98 0 0 1 .702.302L6.13 9.18l6.772-7.079a.98.98 0 0 1 .702-.301.98.98 0 0 1 .702.301l1.404 1.466a1.07 1.07 0 0 1 0 1.465" }));
});

var _extends$7s = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7r(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTickInterfaceOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7r(_ref, ["styles"]);

  return React.createElement("svg", _extends$7s({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M19.71 9.232l-7.473 7.8-1.404 1.466a.98.98 0 0 1-.702.302.979.979 0 0 1-.701-.302l-1.404-1.465-3.737-3.9a1.07 1.07 0 0 1 0-1.466l1.404-1.465a.978.978 0 0 1 .702-.302.98.98 0 0 1 .702.302l3.034 3.178 6.772-7.079A.98.98 0 0 1 17.605 6a.98.98 0 0 1 .702.301l1.404 1.466a1.07 1.07 0 0 1 0 1.465" }));
});

var _extends$7t = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7s(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTickOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7s(_ref, ["styles"]);

  return React.createElement("svg", _extends$7t({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { fillRule: "evenodd", d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm-1.023-3a.85.85 0 0 1-.666-.316L4.17 8.986a.77.77 0 0 1 .161-1.115.86.86 0 0 1 1.17.155L6.911 9.8l3.544-5.425a.861.861 0 0 1 1.15-.255.775.775 0 0 1 .268 1.098l-4.186 6.406a.84.84 0 0 1-.672.374C7.003 12 6.99 12 6.977 12z" }));
});

var _extends$7u = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7t(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTickOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7t(_ref, ["styles"]);

  return React.createElement("svg", _extends$7u({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M67.908 28.54l4.734 4.307-32 35.2a3.202 3.202 0 0 1-2.29 1.047h-.077a3.2 3.2 0 0 1-2.262-.938l-12.8-12.8 4.524-4.525L38.164 61.26l29.744-32.718zm0-6.4a6.405 6.405 0 0 0-4.736 2.095L37.944 51.987l-5.68-5.681a6.4 6.4 0 0 0-9.052 0l-4.525 4.525a6.4 6.4 0 0 0 0 9.05l12.8 12.8a9.537 9.537 0 0 0 7.025 2.81 9.646 9.646 0 0 0 6.868-3.141l31.998-35.198a6.4 6.4 0 0 0-.43-9.04l-4.734-4.306a6.4 6.4 0 0 0-4.306-1.666z" }));
});

var _extends$7v = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7u(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTimelineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7u(_ref, ["styles"]);

  return React.createElement("svg", _extends$7v({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7.733 12.292a4.334 4.334 0 0 1 0-8.584V0h1.22v3.71a4.334 4.334 0 0 1 0 8.58V16h-1.22v-3.708z" }));
});

var _extends$7w = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7v(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTimelineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7v(_ref, ["styles"]);

  return React.createElement("svg", _extends$7w({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M11.733 16.292a4.334 4.334 0 0 1 0-8.584V4h1.22v3.71a4.334 4.334 0 0 1 0 8.58V20h-1.22v-3.708z" }));
});

var _extends$7x = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7w(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTimelineStartLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7w(_ref, ["styles"]);

  return React.createElement("svg", _extends$7x({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7.733 8.625a4.334 4.334 0 1 1 1.22-.002V16h-1.22V8.625z" }));
});

var _extends$7y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7x(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTimelineStartSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7x(_ref, ["styles"]);

  return React.createElement("svg", _extends$7y({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M11.733 12.625a4.334 4.334 0 1 1 1.22-.002V20h-1.22v-7.375z" }));
});

var _extends$7z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7y(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconToolOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7y(_ref, ["styles"]);

  return React.createElement("svg", _extends$7z({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13.692 8.012a4.031 4.031 0 0 1-4.763.693l-5.814 5.809c-.45.449-1.178.449-1.628 0a1.149 1.149 0 0 1 0-1.626l5.815-5.807a4.02 4.02 0 0 1 3.5-5.934l-.772.77v3.251l.814.812h3.254l.771-.77a4.004 4.004 0 0 1-1.177 2.802m1.821-5.07l-2.228 2.226-2.035-.407-.406-2.03L13.072.503a5.18 5.18 0 0 0-5.89 1.007 5.161 5.161 0 0 0-1.241 5.304L.674 12.076a2.297 2.297 0 0 0 0 3.25 2.303 2.303 0 0 0 3.254 0l5.268-5.26a5.177 5.177 0 0 0 5.31-1.24 5.167 5.167 0 0 0 1.007-5.883" }));
});

var _extends$7A = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7z(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconToolOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7z(_ref, ["styles"]);

  return React.createElement("svg", _extends$7A({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M17.692 12.012a4.031 4.031 0 0 1-4.763.693l-5.814 5.809c-.45.449-1.178.449-1.628 0a1.149 1.149 0 0 1 0-1.626l5.815-5.807a4.02 4.02 0 0 1 3.5-5.934l-.772.77v3.251l.814.812h3.254l.771-.77a4.004 4.004 0 0 1-1.177 2.802m1.821-5.07l-2.228 2.226-2.035-.407-.406-2.03 2.228-2.227a5.18 5.18 0 0 0-5.89 1.007 5.161 5.161 0 0 0-1.241 5.304l-5.267 5.261a2.297 2.297 0 0 0 0 3.25 2.303 2.303 0 0 0 3.254 0l5.268-5.26a5.177 5.177 0 0 0 5.31-1.24 5.167 5.167 0 0 0 1.007-5.883" }));
});

var _extends$7B = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7A(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTransactionMethodOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7A(_ref, ["styles"]);

  return React.createElement("svg", _extends$7B({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M96 89.617C96 93.142 92.154 96 87.403 96H8.597C3.851 96 0 93.14 0 89.617V52.383C0 48.859 3.851 46 8.597 46h78.806C92.153 46 96 48.858 96 52.383zM88.566 91C89.904 91 91 90.183 91 89.182V52.818c0-1-1.096-1.818-2.434-1.818H7.434C6.091 51 5 51.815 5 52.818v36.364C5 90.185 6.09 91 7.434 91z" }), React.createElement("path", { d: "M11.781 46.448c-2.89-2.51-8.136-8.426-8.136-8.426-3.297-3.414-3.915-8.17-1.38-10.618L29.047 1.54c2.535-2.448 7.267-1.664 10.564 1.75l41.782 43.267s-67.6 1.64-69.613-.108zm62.478-.083L35.207 5.926c-.933-.966-2.277-1.185-2.998-.488L6.05 30.698c-.722.697-.55 2.048.383 3.014 0 0 7.887 8.914 12.191 12.625 1.186 1.022 55.634.028 55.634.028z" }), React.createElement("path", { d: "M45.592 73.226c0 1.173-.46 1.978-.878 2.39h-1.463c-.167 0-.313.153-.313.327v2.043c0 .174.146.326.313.326h9.324c.167 0 .313-.152.313-.326v-2.043c0-.174-.146-.326-.313-.326h-5.06c.377-.5.837-1.413.837-2.565 0-.11-.021-.218-.021-.326h3.031c.188 0 .314-.153.314-.348v-1.826c0-.174-.126-.326-.314-.326h-3.658c-.23-.74-.44-1.479-.44-2.24 0-.63.21-1.13.565-1.5.398-.39.962-.63 1.694-.63s1.442.196 2.195.609c.146.087.313.043.397-.13l.794-1.718c.063-.152.021-.326-.125-.413-.9-.544-2.132-.892-3.533-.892-1.526 0-2.697.479-3.533 1.261-.857.783-1.317 1.935-1.317 3.261 0 .848.209 1.63.439 2.392h-1.108c-.167 0-.314.152-.314.326v1.826c0 .195.147.348.314.348h1.819c.02.173.041.347.041.5zM48 83c-6.627 0-12-5.374-12-12 0-6.627 5.373-12 12-12s12 5.373 12 12c0 6.626-5.373 12-12 12zM27.12 10.187L61.89 46h-9.775L22.033 15.155zM32 71c0 8.836 7.162 16 16 16 8.836 0 16-7.164 16-16 0-8.838-7.164-16-16-16-8.838 0-16 7.162-16 16z" }));
});

var _extends$7C = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7B(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTransactionMethodOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7B(_ref, ["styles"]);

  return React.createElement("svg", _extends$7C({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M81 75.554c0 2.398-2.604 4.34-5.82 4.34H21.82c-3.213 0-5.82-1.944-5.82-4.34V50.235c0-2.396 2.607-4.34 5.82-4.34h53.36c3.216 0 5.82 1.943 5.82 4.34zm-4.642 1.34c.903 0 1.642-.551 1.642-1.227V51.122c0-.676-.739-1.227-1.642-1.227H21.642c-.906 0-1.642.55-1.642 1.227v24.545c0 .678.736 1.228 1.642 1.228z" }), React.createElement("path", { d: "M23.55 46.453c-1.97-1.704-5.545-5.72-5.545-5.72-2.248-2.317-2.669-5.546-.941-7.208L35.32 15.967c1.728-1.661 4.953-1.13 7.2 1.188L71 46.526s-46.078 1.114-47.45-.073zm42.45.246L39.266 18.622c-.639-.671-1.559-.823-2.053-.339L19.306 35.821c-.494.484-.377 1.422.262 2.093 0 0 5.4 6.188 8.346 8.765.812.71 38.086.02 38.086.02z" }), React.createElement("path", { d: "M46.358 64.609c0 .782-.321 1.319-.614 1.594H44.72a.224.224 0 0 0-.22.217v1.363c0 .116.102.217.22.217h6.526c.117 0 .22-.101.22-.217V66.42a.224.224 0 0 0-.22-.217h-3.541c.263-.333.585-.942.585-1.71 0-.073-.015-.145-.015-.218h2.122c.132 0 .22-.101.22-.232v-1.217a.214.214 0 0 0-.22-.217h-2.56c-.162-.493-.308-.986-.308-1.493 0-.42.146-.754.395-1 .278-.26.673-.42 1.186-.42s1.01.13 1.536.405c.103.058.22.03.278-.087l.556-1.144a.211.211 0 0 0-.088-.276C50.763 58.232 49.9 58 48.92 58c-1.068 0-1.887.319-2.473.84-.6.522-.922 1.29-.922 2.174 0 .566.147 1.087.308 1.595h-.776a.224.224 0 0 0-.22.217v1.217c0 .13.103.232.22.232h1.273c.015.116.03.232.03.334zM48 71a8 8 0 1 1 .001-16.001A8 8 0 0 1 48 71zM34.104 21.293L58 46h-6.622l-20.78-21.268zM37 63c0 6.075 4.924 11 11 11 6.075 0 11-4.925 11-11 0-6.076-4.925-11-11-11-6.076 0-11 4.924-11 11z" }));
});

var _extends$7D = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7C(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTransferLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7C(_ref, ["styles"]);

  return React.createElement("svg", _extends$7D({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7 8V4l9 4.5L7 13V9H0V8h7z" }));
});

var _extends$7E = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7D(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTransferSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7D(_ref, ["styles"]);

  return React.createElement("svg", _extends$7E({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M11 12V8l9 4.5-9 4.5v-4H4v-1h7z" }));
});

var _extends$7F = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7E(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTrashLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7E(_ref, ["styles"]);

  return React.createElement("svg", _extends$7F({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M60 0a4 4 0 0 1 4 4v4h24v8H60a3.999 3.999 0 0 1-4-4V8H40v4a3.999 3.999 0 0 1-4 4H16v4a4 4 0 0 1 3.992 3.766L23.772 88h48.457l3.529-60H28v-8h52a4.002 4.002 0 0 1 3.992 4.234l-4 68A4 4 0 0 1 76 96H20a4 4 0 0 1-3.992-3.766L12.228 28H12a3.999 3.999 0 0 1-4-4V12a4 4 0 0 1 4-4h20V4a3.999 3.999 0 0 1 4-4zm-3.543 36a11.172 11.172 0 0 1 11.16 11.73l-1.623 28.496-7.988-.453 1.623-28.468A3.176 3.176 0 0 0 56.457 44h-1.281A3.18 3.18 0 0 0 52 47.176v21.648c-.007 6.17-5.006 11.17-11.176 11.176a11.167 11.167 0 0 1-11.16-10.617l-1.658-29.156 7.988-.454 1.658 29.184A3.175 3.175 0 0 0 44 68.824V47.176c.006-6.17 5.006-11.17 11.176-11.176z" }));
});

var _extends$7G = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7F(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTrashSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7F(_ref, ["styles"]);

  return React.createElement("svg", _extends$7G({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M55.667 16a2.667 2.667 0 0 1 2.666 2.667v2.666h16v5.334H55.667A2.666 2.666 0 0 1 53 24v-2.667H42.333V24a2.666 2.666 0 0 1-2.666 2.667H26.333v2.666a2.667 2.667 0 0 1 2.662 2.51l2.52 42.824h32.304l2.353-40H34.333v-5.334H69a2.668 2.668 0 0 1 2.661 2.823L68.995 77.49A2.666 2.666 0 0 1 66.333 80H29a2.666 2.666 0 0 1-2.661-2.51l-2.52-42.823h-.152A2.666 2.666 0 0 1 21 32v-8a2.667 2.667 0 0 1 2.667-2.667H37v-2.666A2.666 2.666 0 0 1 39.667 16zm-2.362 24a7.448 7.448 0 0 1 7.44 7.82l-1.082 18.998-5.326-.302 1.082-18.98a2.117 2.117 0 0 0-2.114-2.203h-.854a2.12 2.12 0 0 0-2.118 2.118v14.432a7.458 7.458 0 0 1-7.45 7.45 7.445 7.445 0 0 1-7.44-7.078l-1.106-19.437 5.326-.302 1.105 19.455A2.117 2.117 0 0 0 45 61.883V47.45A7.458 7.458 0 0 1 52.45 40z" }));
});

var _extends$7H = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7G(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconUpload$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7G(_ref, ["styles"]);

  return React.createElement("svg", _extends$7H({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M74.696 21.579c10.785 1.88 18.337 11.702 17.384 22.608-.952 10.907-10.092 19.27-21.04 19.253H60.416a46.66 46.66 0 0 0-10.496 1.057V80.72c-.009 7.419-6.021 13.431-13.44 13.44a13.44 13.44 0 0 1-9.799-22.639A40.06 40.06 0 0 1 42.24 58.932v-17.6l-7.02 7.02-5.43-5.43 16.29-16.288 16.29 16.289-5.43 5.43-7.02-7.02v15.32a57.903 57.903 0 0 1 10.481-.893H71.04c7.294.017 13.263-5.799 13.435-13.09.173-7.292-5.515-13.384-12.801-13.711a3.84 3.84 0 0 1-3.503-2.753C64.935 15.221 54.12 8.281 42.784 9.916 31.45 11.554 23.038 21.269 23.04 32.72c0 1.079-.44 2.11-1.219 2.857a3.697 3.697 0 0 1-2.887 1.07 9.394 9.394 0 0 1-.653-.072h-.026a9.592 9.592 0 1 0-.004 19.185h4.789v7.68h-4.789c-9.025 0-16.53-6.945-17.228-15.943-.698-8.998 5.645-17.018 14.562-18.41C17.247 15.088 28.225 4.02 42.208 2.244 56.192.469 69.588 8.44 74.696 21.579zM42.24 67.56a37.242 37.242 0 0 0-9.769 9 5.98 5.98 0 0 0-1.751 4.159 5.76 5.76 0 1 0 11.52 0z" }));
});

var _extends$7I = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7H(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconUsageOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7H(_ref, ["styles"]);

  return React.createElement("svg", _extends$7I({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M21.333 19v53.333H80v5.334H18.667a2.667 2.667 0 0 1-2.65-2.356L16 75V19zm55.989 5.333c1.373 0 2.505 1.022 2.66 2.338l.018.309v13.233h-5.357v-7.109L72.4 35.337l-5.094 5.071c-1.706 1.702-4.45 3.42-7.258 4.54l-.262.098-.144.362c-.933 2.256-2.291 4.512-3.727 6.202l-.48.542-.333.332-.123.108-6.967 6.882a2.703 2.703 0 0 1-3.536.22l-.252-.221-5.415-5.354-11.688 11.548-3.788-3.743 13.58-13.419a2.703 2.703 0 0 1 3.534-.221l.252.22 5.42 5.353 5.496-5.423.336-.386c.456-.551.915-1.207 1.345-1.913h-.004a7.543 7.543 0 0 1-1.089-.206l-.408-.118-1.06-.393c-3.3-1.324-5.21-4.754-4.545-8.351a7.088 7.088 0 0 1 1.97-3.46c.96-.952 2.162-1.63 3.644-2.001 3.371-.636 6.725 1.08 8.14 4.055l.421.969c.269.62.44 1.282.523 2.001.86-.512 1.635-1.064 2.24-1.599l.374-.35 5.086-5.065.011-.01 1.992-1.98H63.93v-5.294zm-24.096 12.41l-.254.026a2.273 2.273 0 0 0-1.05.605c-.256.246-.436.56-.49.77a2.137 2.137 0 0 0 1.006 2.222l.259.127.795.295.194.007c.365.015.767.01 1.157-.009l.66-.054.055-.311v-.285l.015-.002.018-.303c.013-.396-.022-.715-.091-.953l-.058-.163-.27-.625c-.337-.84-1.174-1.361-1.946-1.346z" }));
});

var _extends$7J = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7I(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var WarningTriangle$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7I(_ref, ["styles"]);

  return React.createElement("svg", _extends$7J({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 0l48 96H0zm-.5 69.5c-1.708 0-3.135.573-4.28 1.719-1.147 1.146-1.72 2.584-1.72 4.313 0 1.687.573 3.103 1.72 4.25 1.145 1.145 2.572 1.718 4.28 1.718 1.708 0 3.135-.573 4.28-1.719 1.147-1.146 1.72-2.562 1.72-4.249 0-1.73-.573-3.167-1.72-4.313-1.145-1.146-2.572-1.719-4.28-1.719zm6-36h-12l.405 8.667L43.608 61.5h7.784l1.703-19.333z", fillRule: "evenodd" }));
});

var _extends$7K = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7J(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var AboutYou = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7J(_ref, ["styles"]);

  return React.createElement("svg", _extends$7K({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M96 0v23.467a6.407 6.407 0 0 1-6.4 6.4H66.133a2.133 2.133 0 1 0 0 4.266H89.6a6.4 6.4 0 1 1 0 12.8H66.133a2.133 2.133 0 0 0 0 4.267H89.6a6.4 6.4 0 1 1 0 12.8H66.133a2.133 2.133 0 0 0 0 4.267H89.6a6.407 6.407 0 0 1 6.4 6.4V96H8.533a8.533 8.533 0 0 1 0-17.067h6.392a8.564 8.564 0 0 0 5.33-1.868l7.434-5.948c-7.53-4.849-15.52-18.179-15.52-30.403 0-13.04 10.38-25.84 20.958-25.84 10.577 0 20.958 12.8 20.958 25.84 0 12.942-8.957 27.124-16.84 31.168l6.425 5.508a16.415 16.415 0 0 0 5.45 1.858h4.583c4.69.005 8.49 3.87 8.494 8.64H57.95c-.003-2.385-1.903-4.317-4.247-4.32l-5.13-.032a19.989 19.989 0 0 1-7.599-2.81l-8.915-7.641-9.138 7.31a12.847 12.847 0 0 1-7.988 2.805h-6.4a4.267 4.267 0 1 0 0 8.533h83.2V74.667a2.135 2.135 0 0 0-2.133-2.134H66.133a6.4 6.4 0 1 1 0-12.8H89.6a2.133 2.133 0 1 0 0-4.266H66.133a6.4 6.4 0 1 1 0-12.8H89.6a2.133 2.133 0 0 0 0-4.267H66.133a6.4 6.4 0 1 1 0-12.8H89.6a2.135 2.135 0 0 0 2.133-2.133v-19.2H4.267V70.4H0V0zM33.127 19.18c-8.148 0-16.766 11.07-16.766 21.534 0 11.25 10.028 27.993 16.766 27.993 6.737 0 16.766-16.743 16.766-27.993 0-10.464-8.618-21.534-16.766-21.534z" }));
});

var _extends$7L = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7K(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Accounts = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7K(_ref, ["styles"]);

  return React.createElement("svg", _extends$7L({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M55.384 12c7.252 0 12.924 5.507 12.924 12.923 0 4.15-2.197 8.172-6.464 13.521C58.67 42.04 54.828 45 50.343 47.323c.03.177.06.356.092.536.567 5.4-.2 11.844-1.967 17.478l12.266 6.133c8.659 4.349 11.26 5.146 18.65 5.146 2.235 0 5.956-.998 9.231-2.369V26.804c-4.32 1.455-8.43 1.811-14.769 1.811v-7.384c7.784 0 11.281-.538 16.81-3.303 2.455-1.227 5.344.558 5.344 3.303v55.385a3.692 3.692 0 0 1-2.036 3.3C89.387 82.212 83.43 84 79.384 84c-8.74 0-12.368-1.111-21.958-5.928l-11.847-5.925a21.98 21.98 0 0 1-1.943 2.899C40.122 80.048 34.407 84 29.538 84c-8.5 0-14.77-6.264-14.77-12.917 0-7.308 4.95-12.929 14.77-12.929 2.16 0 4.382.495 6.821 1.408 1.625.607 3.18 1.324 5.39 2.436 1.108-3.922 1.665-8.256 1.469-11.934-4.806 1.073-9.839.601-15.006-1.387l2.652-6.892c4.026 1.55 7.742 1.854 11.258.948-1.003-6.645-1.507-11.958-1.507-15.97 0-8.814 6.88-14.763 14.77-14.763zM1.082 20.465c5.22-5.219 18.16-6.406 31.282-2.794l-1.96 7.12c-9.758-2.686-19.119-2.182-23.02.086v57.277H0V23.076c0-.98.39-1.918 1.082-2.61zM29.538 65.54c-5.518 0-7.384 2.12-7.384 5.544 0 2.573 2.96 5.533 7.384 5.533 2.047 0 5.789-2.588 8.193-5.999.422-.526.825-1.119 1.208-1.765l-.47-.238c-2.012-1.013-3.372-1.64-4.698-2.136-1.678-.628-3.075-.94-4.233-.94zm25.846-46.154c-4.03 0-7.384 2.9-7.384 7.377 0 3.178.369 7.42 1.12 12.783 2.746-1.67 5.11-3.632 7.069-5.845 3.135-3.937 4.734-6.864 4.734-8.777 0-3.288-2.317-5.538-5.539-5.538z" }));
});

var _extends$7M = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7L(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var AllSystemsGo = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7L(_ref, ["styles"]);

  return React.createElement("svg", _extends$7M({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M61.312.917c3.347 1.904 6.77 4.593 6.77 10.092 0 .12-.011.238-.032.355l-1.011 5.385a87.687 87.687 0 0 1-4.178 15.072c-.03.078-.065.154-.104.227l-1.155 2.168h9.83c3.95-.041 7.867.72 11.512 2.236 6.977 2.975 8.44 7.018 8.44 9.887 0 3.465-.559 5.573-1.871 7.044a1.965 1.965 0 0 0-.029 2.668 6.878 6.878 0 0 1 1.9 4.68 7.755 7.755 0 0 1-2.977 5.364c-.946.944-1.84 1.834-1.84 2.632v4.797a7.712 7.712 0 0 1-3.487 6.393c-1.046.852-1.33 1.148-1.33 1.603a14.623 14.623 0 0 1-4.528 10.146c-2.662 2.651-7.65 3.896-17.213 4.294a44.309 44.309 0 0 1-14.716-1.864 61.213 61.213 0 0 1-8.103-2.85l-.048-.023c-.684-.345-2.325-1.312-9.61-11.34a12.672 12.672 0 0 1-7.701.754l-2.344-.5c-3.501-.751-5.884-3.992-5.546-7.542.338-3.55 3.291-6.287 6.872-6.368a6.922 6.922 0 0 1 5.962 3.037c1.386 2.003 2.64 3.79 3.772 5.384a8.712 8.712 0 0 0 2.751-6.368V45.82H7.884v40.61h21.36v3.868H5.942c-.515 0-1.01-.203-1.374-.566A1.93 1.93 0 0 1 4 88.365v-44.48c0-.513.204-1.005.568-1.367a1.945 1.945 0 0 1 1.374-.567H33.24c.515 0 1.01.204 1.374.567.364.362.568.854.568 1.367V68.28a12.555 12.555 0 0 1-4.36 9.533c6.224 8.56 7.825 9.808 8.124 9.985a57.113 57.113 0 0 0 7.478 2.597 40.624 40.624 0 0 0 13.422 1.701c8.266-.343 12.778-1.32 14.63-3.165a10.754 10.754 0 0 0 3.39-7.41 5.85 5.85 0 0 1 2.759-4.6c1.316-1.07 2.06-1.754 2.06-3.397v-4.797a7.77 7.77 0 0 1 2.976-5.367l.351-.35c.805-.813 1.489-1.581 1.489-2.279a3.007 3.007 0 0 0-.888-2.075 5.837 5.837 0 0 1-.007-7.84c.246-.275.895-1.002.895-4.477 0-3.088-3.31-5.149-6.086-6.333a25.36 25.36 0 0 0-9.378-1.922H58.373c-.682 0-1.314-.355-1.665-.937s-.37-1.305-.05-1.904l2.61-4.897a83.824 83.824 0 0 0 3.952-14.298l.976-5.21c-.047-2.848-1.327-4.58-4.81-6.563-.74-.42-1.621-.52-2.437-.274a3.097 3.097 0 0 0-1.874 1.573L38.759 38.93l-3.494-1.692L51.591 3.865C52.445 2.149 53.973.86 55.813.302s3.83-.336 5.499.615zM19.225 70.154c-.023 0-.047 0-.07.002-1.476.038-2.694 1.344-2.834 3.04-.14 1.695.842 3.243 2.285 3.601l2.149.531a6.99 6.99 0 0 0 4.168-.24 537.764 537.764 0 0 1-3.315-5.486c-.535-.912-1.429-1.455-2.383-1.448z" }));
});

var _extends$7N = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7M(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Help = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7M(_ref, ["styles"]);

  return React.createElement("svg", _extends$7N({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M41.494 95.82a28.096 28.096 0 0 1-5.816-.597c-8.684-1.832-9.98-6.567-9.98-9.223a8.405 8.405 0 0 1 2.5-6.234C31 77.012 35.854 75.859 44.071 76a25.726 25.726 0 0 1 13.8 5.035 16.18 16.18 0 0 0 17.358-2.43 17.553 17.553 0 0 0 1.844-1.785 12.11 12.11 0 0 1-9.28.094c-7.251-3.004-9.907-12.664-6.044-21.988a19.571 19.571 0 0 1 5.113-7.293 11.879 11.879 0 0 1 10.78-2.617 12.661 12.661 0 0 1 6.062 3.433A39.11 39.11 0 0 0 84 44C84 24.118 67.882 8 48 8S12 24.118 12 44a57.57 57.57 0 0 0 3.516 18.05l.257.532c2.256 5.445 6.752 8.027 9.37 6.941 2.623-1.085 3.97-6.09 1.716-11.535a6.197 6.197 0 0 0-3.45-3.746 7.076 7.076 0 0 0-5.604.656l-3.692-7.093a15.05 15.05 0 0 1 12.032-1.082 13.915 13.915 0 0 1 8.105 8.203c3.863 9.324 1.207 18.984-6.045 21.988-7.162 2.969-15.748-1.828-19.68-10.93l-.181-.359A63.535 63.535 0 0 1 4 44C4 19.7 23.7 0 48 0s44 19.7 44 44a66.46 66.46 0 0 1-3.102 18.332 24.558 24.558 0 0 1-34.734 25.805l-.625-.367a18.204 18.204 0 0 0-9.61-3.77c-8.12-.188-9.85 1.2-10.126 1.473-.037.035-.106.101-.106.52-.006-.02.627.769 3.635 1.402 3.277.643 6.657.548 9.893-.278l.63-.156 1.903 7.773-.654.16a32.866 32.866 0 0 1-7.61.926zm33.229-43.152a3.818 3.818 0 0 0-2.575.969 11.67 11.67 0 0 0-3.007 4.351c-2.254 5.446-.907 10.45 1.716 11.535 2.63 1.09 7.116-1.496 9.37-6.94l.257-.532.133-.32-.03-.106-1.671-6.223a4.632 4.632 0 0 0-4.193-2.734z" }));
});

var _extends$7O = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7N(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconProjection = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7N(_ref, ["styles"]);

  return React.createElement("svg", _extends$7O({ viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M8 4v80h88v8H0V4zm88 8v24h-8V25.355L76.867 36.488a34.787 34.787 0 0 1-11.125 6.938 34.882 34.882 0 0 1-6.941 11.129L45.402 67.957 34.465 57.02 17.02 74.465l-5.657-5.656 23.102-23.102 10.937 10.938 7.743-7.747a20.848 20.848 0 0 0 2.87-3.777 10.727 10.727 0 0 1-3.113-.789l-.832-.355a11.183 11.183 0 0 1-6.722-12.832 11.402 11.402 0 0 1 8.11-8.11 11.17 11.17 0 0 1 12.835 6.723l.36.844c.414.987.678 2.031.78 3.097a20.663 20.663 0 0 0 3.778-2.867L82.043 20H72v-8zM56 30.71c-.174.001-.347.024-.516.067a3.28 3.28 0 0 0-1.511.871 3.36 3.36 0 0 0-.887 1.524 3.26 3.26 0 0 0 2.137 3.453l.832.355a5.918 5.918 0 0 0 3.308.07 5.996 5.996 0 0 0-.07-3.312l-.36-.84A3.468 3.468 0 0 0 56 30.711z" }));
});

var _extends$7P = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7O(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Spending = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7O(_ref, ["styles"]);

  return React.createElement("svg", _extends$7P({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M12.998 9.927l4.79 14.369a23.704 23.704 0 0 0-1.933 9.406v23.79c0 6.567 5.324 11.891 11.89 11.891h2.093c1.309 0 2.585.215 3.786.618a23.773 23.773 0 0 0-3.01 4.601l-1.095 2.191a11.313 11.313 0 0 0-1.195 5.06c0 6.247 5.065 11.312 11.313 11.312 1.756 0 3.488-.409 5.06-1.194 5.588-2.794 7.853-9.59 5.059-15.178l-2.192-4.382a19.85 19.85 0 0 0-1.178-2.044c1.732-.64 3.59-.984 5.5-.984h6.166c2.409 0 4.742.493 6.88 1.405a25.468 25.468 0 0 0-3.076 4.75l-.628 1.255a11.313 11.313 0 0 0-1.194 5.06c0 6.247 5.065 11.312 11.313 11.312 1.756 0 3.488-.409 5.059-1.194 5.588-2.794 7.853-9.59 5.06-15.178l-.628-1.255a25.468 25.468 0 0 0-3.077-4.75 17.527 17.527 0 0 1 6.88-1.405h.713v-7.927h-.713c-4.784 0-9.365 1.34-13.294 3.744a25.454 25.454 0 0 0-13.295-3.744h-6.166a23.76 23.76 0 0 0-11.564 3 19.803 19.803 0 0 0-10.484-3h-2.092a3.964 3.964 0 0 1-3.964-3.964V42.28l5.07 15.212h57.635L96 9.92H39.637a23.698 23.698 0 0 0-16.17 6.343L18.711 2H0v7.927zm27.476 66.03l2.191 4.381a3.385 3.385 0 1 1-6.056 0l1.096-2.19a15.846 15.846 0 0 1 2.166-3.257c.218.342.42.698.603 1.065zm33.273 3.126l.628 1.255a3.385 3.385 0 1 1-6.056 0l.627-1.255a17.538 17.538 0 0 1 2.4-3.606 17.538 17.538 0 0 1 2.401 3.606zm-34.11-61.236H86.33l-6.342 31.717H34.567l-8.188-24.56c2.834-4.311 7.714-7.157 13.258-7.157z" }));
});

var _extends$7Q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7P(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var YourMoney = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7P(_ref, ["styles"]);

  return React.createElement("svg", _extends$7Q({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M54.982.39l12.27 14.141 8.803-1.832 5.177 17.258h9.15v22.871a18.92 18.92 0 0 1-3.187 10.527l-.084.13a18.981 18.981 0 0 1 3.272 10.652V96H17.105c-6.341-.007-11.48-5.146-11.488-11.488v-39.32h8v39.32A3.493 3.493 0 0 0 17.105 88h65.278V74.137c0-1.389-.264-2.765-.778-4.055a19.31 19.31 0 0 1-11.128 3.45 10.553 10.553 0 1 1-.008-21.106 15.997 15.997 0 0 1 11.02 4.746 10.95 10.95 0 0 0 .894-4.344V37.957H14.299a8.68 8.68 0 1 1 0-17.36h16.858zM70.46 60.427a2.553 2.553 0 0 0 .01 5.105c2.23.019 4.415-.623 6.281-1.843a8.763 8.763 0 0 0-6.291-3.262zm2.42-30.47L70.5 22.028l-38.14 7.93zm-52.757 0l1.603-1.36-7.426.002a.68.68 0 1 0 0 1.359zM54.123 11.61l-8.826 7.485 12.982-2.7z" }));
});

var _extends$7R = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7Q(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconArchiveOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7Q(_ref, ["styles"]);

  return React.createElement("svg", _extends$7R({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M91.56 22.632c0-.364-.08-.73-.241-1.074a2.33 2.33 0 0 0-1.627-1.296L48.784.243a2.408 2.408 0 0 0-2.109 0L5.365 20.444A2.441 2.441 0 0 0 4 22.551v50.796c0 .932.522 1.783 1.366 2.189l41.31 20.2c.02 0 .02 0 .04.02.06.021.12.041.18.082.02 0 .04.02.08.02l.181.061c.02 0 .04.02.06.02.06.02.141.02.201.04h.06c.081 0 .181.021.262.021.08 0 .18 0 .26-.02h.061c.06 0 .14-.02.2-.04.021 0 .041-.021.061-.021l.18-.06c.021 0 .041-.021.081-.021.06-.02.12-.04.181-.081.02 0 .02 0 .04-.02l41.43-20.262a2.452 2.452 0 0 0 1.366-2.188V22.693c-.04-.02-.04-.04-.04-.06zM47.72 5.126l35.827 17.527-13.194 6.463L34.525 11.59 47.72 5.126zm0 35.053L11.892 22.653l17.11-8.368L64.83 31.81l-17.11 8.368zM8.82 26.563l36.49 17.85v45.245L8.82 71.808V26.563zm41.31 63.095V44.414l17.13-8.389v11.833c0 1.337 1.084 2.432 2.41 2.432 1.325 0 2.41-1.095 2.41-2.432V33.655l14.66-7.173v45.244L50.13 89.658z" }));
});

var _extends$7S = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7R(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconArchiveOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7R(_ref, ["styles"]);

  return React.createElement("svg", _extends$7S({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M77.373 31.088a1.69 1.69 0 0 0-.16-.716c-.215-.459-.63-.77-1.085-.864L48.856 16.162a1.605 1.605 0 0 0-1.406 0L19.91 29.63a1.627 1.627 0 0 0-.91 1.405v33.864c0 .622.348 1.189.91 1.46l27.54 13.466c.014 0 .014 0 .027.014.04.013.08.027.12.054.014 0 .027.013.054.013l.12.041c.014 0 .027.013.04.013.04.014.094.014.135.027h.04c.053 0 .12.014.174.014.053 0 .12 0 .174-.014h.04c.04 0 .094-.013.134-.027.013 0 .027-.013.04-.013l.12-.04c.014 0 .027-.014.054-.014a.473.473 0 0 0 .12-.054c.014 0 .014 0 .027-.014l27.62-13.507c.55-.27.911-.838.911-1.46V31.13c-.027-.014-.027-.027-.027-.04zm-29.227-11.67l23.885 11.684-8.796 4.309L39.35 23.726l8.796-4.309zm0 23.368L24.262 31.102l11.407-5.579 23.884 11.684-11.407 5.579zm-25.933-9.077l24.327 11.9v30.163l-24.327-11.9V33.709zm27.54 42.063V45.61l11.42-5.592v7.888c0 .892.723 1.621 1.607 1.621s1.607-.729 1.607-1.62v-9.47l9.773-4.781v30.163L49.753 75.772z" }));
});

var _extends$7T = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7S(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconBriefcaseOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7S(_ref, ["styles"]);

  return React.createElement("svg", _extends$7T({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M56 20.307a5.339 5.339 0 0 1 5.333 5.333v2.667h13.334A5.339 5.339 0 0 1 80 33.64v37.334a5.339 5.339 0 0 1-5.333 5.333h-18.24c-.08 0-.232-.01-.31-.017a18.983 18.983 0 0 1-7.726-2.372 19.067 19.067 0 0 1-7.735 2.379l-19.323.01A5.339 5.339 0 0 1 16 70.974V33.64a5.339 5.339 0 0 1 5.333-5.333H32v5.333H21.333v37.334h19.094a12.84 12.84 0 0 0 3.198-.715 10.424 10.424 0 0 1-3.004-5.742 8.285 8.285 0 0 1 2.108-7.2 8.19 8.19 0 0 1 11.313 0 8.811 8.811 0 0 1 .261 11.903c-.31.378-.644.737-.998 1.074 1.06.36 2.16.589 3.274.682l18.088-.002V33.64H56v-8H40v2.667h12.457v5.333h-17.79v-8A5.339 5.339 0 0 1 40 20.307zm-7.616 40a2.643 2.643 0 0 0-1.884.781c-.58.749-.801 1.715-.603 2.641a5.333 5.333 0 0 0 1.913 3.145l.601.518a8.035 8.035 0 0 0 1.69-1.453 3.64 3.64 0 0 0 .165-4.855 2.645 2.645 0 0 0-1.882-.777zM67.98 38.514V66.71h-5.333V38.514zm-34.666 0V66.71H27.98V38.514z" }));
});

var _extends$7U = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7T(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChartOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7T(_ref, ["styles"]);

  return React.createElement("svg", _extends$7U({ height: "64", viewBox: "0 0 64 64", width: "64", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M42 60.004V43.998l18 .004c-.072 7.972-11.93 15.982-18 16.002zM38 40v23.998l4 .004c19.766-3.06 22-20.004 22-20.004V40h-.102zm-4-8h-2.136l-1.21 1.3-18.796 18.108C7 46.38 4 39.548 4 32 4 16.536 16.536 4 32 4s28 12.536 28 28zm-4 27.898c-5.726-.406-10.96-2.546-15.222-5.874L30 38.802zM32 0C14.326 0 0 14.326 0 32c0 16.996 13.262 30.86 30 31.896v.102h4V36h30v-4C64 14.326 49.672 0 32 0z" }));
});

var _extends$7V = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7U(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconChartOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7U(_ref, ["styles"]);

  return React.createElement("svg", _extends$7V({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M14.5 19.001v-4.002l4.5.002c-.018 1.993-2.983 3.995-4.5 4zM13.5 14v6h1c4.942-.765 5.5-5 5.5-5v-1h-6.5zm-1-2h-.534l-.302.325-4.7 4.527A6.959 6.959 0 0 1 5 12a7 7 0 1 1 14 0h-6.5zm-1 6.974a6.97 6.97 0 0 1-3.806-1.468L11.5 13.7v5.274zM12 4a8 8 0 0 0-8 8c0 4.249 3.316 7.715 7.5 7.974V20h1v-7H20v-1a8 8 0 0 0-8-8z" }));
});

var _extends$7W = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7V(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconClipboardTickOutlineLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7V(_ref, ["styles"]);

  return React.createElement("svg", _extends$7W({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon clipboard tick"), React.createElement("path", { d: "M22 4h2v2h6v26H2V6h6V4h2V2.02C10 .903 10.902 0 11.982 0h8.037C21.112 0 22 .887 22 2.02V4zm-2 2V2h-8v4h-2v4h12V6h-2zM8 12V8H4v22h24V8h-4v4H8zm3.707 8.536L14.07 22.9l6.608-6.607a1 1 0 0 1 1.414 1.414l-7.314 7.314a.997.997 0 0 1-1.414 0l-3.07-3.07a1 1 0 1 1 1.413-1.414z" }));
});

var _extends$7X = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7W(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconClipboardTickOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7W(_ref, ["styles"]);

  return React.createElement("svg", _extends$7X({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M15 6h1v1h3v13H5V7h3V6h1v-.99C9 4.452 9.451 4 9.991 4h4.018c.547 0 .991.444.991 1.01V6zm-1 1V5h-4v2H9v2h6V7h-1zm-6 3V8H6v11h12V8h-2v2H8zm1.827 4.435l1.145 1.269 3.201-3.547a.452.452 0 0 1 .685 0 .58.58 0 0 1 0 .759l-3.543 3.926a.45.45 0 0 1-.685 0l-1.488-1.648a.577.577 0 0 1 0-.759c.19-.21.496-.21.685 0z" }));
});

var _extends$7Y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7X(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDiaryOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7X(_ref, ["styles"]);

  return React.createElement("svg", _extends$7Y({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M96 0v96H46.045v-8H88V8H12a4.005 4.005 0 0 0-4 4v10c.012.353.058.703.137 1.047A16.76 16.76 0 0 1 18 20c5.523 0 10 4.477 10 10s-4.477 10-10 10a16.669 16.669 0 0 1-9.865-3.08A5.79 5.79 0 0 0 8 38.012V58c.012.367.059.732.14 1.09A16.798 16.798 0 0 1 18 56c5.523 0 10 4.477 10 10s-4.477 10-10 10a16.711 16.711 0 0 1-9.87-3.066c-.078.346-.122.7-.13 1.054V84a4.004 4.004 0 0 0 4 4h14.041a4.001 4.001 0 0 0 4-4.004L30 16.002l8-.004.041 67.994a12.003 12.003 0 0 1-12 12.008H12C5.376 95.993.007 90.625 0 84V74c.117-2.8.877-5.534 2.223-7.992A18.56 18.56 0 0 1 0 58.028V38a18.48 18.48 0 0 1 2.22-8.033A18.573 18.573 0 0 1 0 22.043V12C.007 5.376 5.376.007 12 0zM18 64a8.833 8.833 0 0 0-5.742 2.004A8.903 8.903 0 0 0 18 68a2 2 0 1 0 0-4zm58.9-30.956A11.995 11.995 0 0 1 84 44c.033 9.082-9.32 18.91-18.14 23.543a4.009 4.009 0 0 1-3.72 0C53.32 62.91 43.968 53.082 44 43.984a11.995 11.995 0 0 1 20-8.922 11.995 11.995 0 0 1 12.9-2.018zM56 40a4.005 4.005 0 0 0-4 4c-.018 4.559 5.312 11.266 12 15.395 6.688-4.133 12.018-10.836 12-15.38A4 4 0 0 0 68 44a4 4 0 1 1-8 0 4.005 4.005 0 0 0-4-4zM18 28a8.933 8.933 0 0 0-5.746 1.986A8.879 8.879 0 0 0 18 32a2 2 0 1 0 0-4z" }));
});

var _extends$7Z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7Y(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconDiaryOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7Y(_ref, ["styles"]);

  return React.createElement("svg", _extends$7Z({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M80 16v64H46.697v-5.333h27.97V21.333H24A2.67 2.67 0 0 0 21.333 24v6.667c.008.235.039.468.091.698A11.174 11.174 0 0 1 28 29.333a6.667 6.667 0 0 1 0 13.334c-2.354.03-4.657-.69-6.577-2.054a3.86 3.86 0 0 0-.09.728v13.326c.008.244.04.488.094.726 1.92-1.36 4.22-2.08 6.573-2.06a6.667 6.667 0 0 1 0 13.334 11.14 11.14 0 0 1-6.58-2.045 3.55 3.55 0 0 0-.087.704V72A2.67 2.67 0 0 0 24 74.667h9.36a2.667 2.667 0 0 0 2.667-2.67L36 26.668l5.333-.003.028 45.33a8.002 8.002 0 0 1-8 8.005H24a8.009 8.009 0 0 1-8-8v-6.667c.078-1.866.585-3.69 1.482-5.328A12.373 12.373 0 0 1 16 54.685V41.333a12.32 12.32 0 0 1 1.48-5.355A12.382 12.382 0 0 1 16 30.695V24a8.009 8.009 0 0 1 8-8zM28 58.667a5.888 5.888 0 0 0-3.828 1.336A5.935 5.935 0 0 0 28 61.333a1.333 1.333 0 1 0 0-2.666zm39.266-20.638A7.997 7.997 0 0 1 72 45.333c.022 6.055-6.214 12.607-12.094 15.696a2.673 2.673 0 0 1-2.479 0c-5.88-3.089-12.116-9.641-12.094-15.706a7.997 7.997 0 0 1 13.334-5.948 7.996 7.996 0 0 1 8.6-1.346zm-13.933 4.638a2.67 2.67 0 0 0-2.666 2.666c-.012 3.04 3.541 7.51 8 10.263 4.458-2.755 8.011-7.224 8-10.252a2.667 2.667 0 0 0-5.334-.01 2.667 2.667 0 1 1-5.333 0 2.67 2.67 0 0 0-2.667-2.667zm-25.333-8a5.955 5.955 0 0 0-3.83 1.324A5.919 5.919 0 0 0 28 37.333a1.333 1.333 0 1 0 0-2.666z" }));
});

var _extends$7_ = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7Z(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFileLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7Z(_ref, ["styles"]);

  return React.createElement("svg", _extends$7_({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M10.77 11H5.23c-.254 0-.46.224-.46.5 0 .277.206.5.46.5h5.54c.254 0 .46-.223.46-.5 0-.276-.206-.5-.46-.5zm2.307 3.5c0 .277-.207.5-.462.5h-9.23c-.255 0-.462-.223-.462-.5v-13c0-.276.207-.5.462-.5h6v4h3.692v9.5zm-2.77-13.268L12.864 4h-2.555V1.232zM14 4L10.308.002V0H2.462C2.206 0 2 .224 2 .5v15c0 .277.206.5.462.5h11.076c.255 0 .462-.223.462-.5V4h-.001zm-9.23 4.5c0 .277.207.5.462.5h5.538c.255 0 .462-.223.462-.5s-.207-.5-.462-.5H5.231c-.255 0-.462.223-.462.5z" }));
});

var _extends$7$ = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7_(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconFileSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7_(_ref, ["styles"]);

  return React.createElement("svg", _extends$7$({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M14.77 15H9.23c-.254 0-.46.224-.46.5 0 .277.206.5.46.5h5.54c.254 0 .46-.223.46-.5 0-.276-.206-.5-.46-.5zm2.307 3.5c0 .276-.207.5-.462.5h-9.23c-.255 0-.462-.224-.462-.5v-13c0-.276.207-.5.462-.5h6v4h3.692v9.5zm-2.77-13.268L16.864 8h-2.555V5.232zM18 8l-3.691-3.998V4H6.462C6.206 4 6 4.224 6 4.5v15c0 .276.206.5.462.5h11.076c.255 0 .462-.224.462-.5V8h-.001zm-9.23 4.5c0 .277.207.5.462.5h5.538c.255 0 .462-.223.462-.5s-.207-.5-.462-.5H9.231c-.255 0-.462.223-.462.5z" }));
});

var _extends$80 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7$(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$s = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7$(_ref, ["styles"]);

  return React.createElement("svg", _extends$80({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M33.48 67.516l5.656 5.656L18.164 94.14 5.196 81.172l5.656-5.656 7.312 7.312zm59.984 8.828v8h-48v-8zM33.48 35.516l5.656 5.656L18.164 62.14 5.196 49.172l5.656-5.656 7.312 7.312zm59.984 8.828v8h-48v-8zM33.48 3.516l5.656 5.656L18.164 30.14 5.196 17.172l5.656-5.656 7.312 7.312zm59.984 8.828v8h-48v-8z" }));
});

var _extends$81 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$80(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconListOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$80(_ref, ["styles"]);

  return React.createElement("svg", _extends$81({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M38.784 60.355l3.77 3.77-13.98 13.979-8.646-8.645 3.77-3.771 4.875 4.875zm39.99 5.885v5.333h-32V66.24zm-39.99-27.219l3.77 3.771-13.98 13.979-8.646-8.646 3.77-3.77 4.875 4.874zm39.99 5.886v5.333h-32v-5.333zm-39.99-27.219l3.77 3.77-13.98 13.98-8.646-8.646 3.77-3.77 4.875 4.874zm39.99 5.885v5.334h-32v-5.334z" }));
});

var _extends$82 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$81(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPencilSolidLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$81(_ref, ["styles"]);

  return React.createElement("svg", _extends$82({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M76.424 1.155l4.001 2.824a6.3 6.3 0 0 1 1.515 8.767L77.7 18.758l-6.278-4.426 3.443-4.878-1.74-1.226-4.054 5.744 5.876 4.148a6.3 6.3 0 0 1 1.519 8.767L43.817 71.393l-6.194-4.546L69.366 23.58l-6.858-4.837a5.062 5.062 0 0 1-1.504-1.676 7.37 7.37 0 0 1-1.354 3.873L23.114 71.141l-1.19 11.156 9.63-5.677-4.923-3.578 4.515-6.21 11.059 8.033-5.603 7.924-15.25 8.658a4.505 4.505 0 0 1-2.51.736 5.202 5.202 0 0 1-2.985-.953 5.03 5.03 0 0 1-2.07-5.021l1.91-17.925L33.5 43.823c-.684.378-1.395.708-2.126.986l-1.879.712-2.73-7.177 1.883-.716a8.346 8.346 0 0 0 5.04-5.333l4.406-11.891A19.016 19.016 0 0 1 49.401 9.068a9.418 9.418 0 0 1 8.61 1.608 7.257 7.257 0 0 1 2.426 3.067 5.03 5.03 0 0 1 .844-2.058l6.368-9.022a6.293 6.293 0 0 1 8.775-1.508zm-24.18 15.184a2.813 2.813 0 0 0-.743.116 11.677 11.677 0 0 0-6.206 6.619L41.86 32.34 53.25 16.691a1.588 1.588 0 0 0-1.005-.352z" }));
});

var _extends$83 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$82(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPencilSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$82(_ref, ["styles"]);

  return React.createElement("svg", _extends$83({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M67.225 16.77l2.667 1.882a4.2 4.2 0 0 1 1.01 5.845l-2.827 4.007-4.185-2.95 2.295-3.252-1.16-.818-2.703 3.83 3.918 2.765a4.2 4.2 0 0 1 1.012 5.845l-21.765 29.67-4.13-3.03L62.52 31.72l-4.573-3.225a3.374 3.374 0 0 1-1.003-1.118 4.905 4.905 0 0 1-.901 2.583L31.685 63.427l-.793 7.437 6.42-3.785-3.282-2.385 3.01-4.14 7.372 5.355-3.735 5.283-10.167 5.772a3.003 3.003 0 0 1-1.673.49 3.468 3.468 0 0 1-1.99-.635 3.354 3.354 0 0 1-1.38-3.347l1.273-11.95 11.87-16.308c-.457.252-.93.472-1.418.658l-1.252.475-1.82-4.785 1.255-.478a5.564 5.564 0 0 0 3.36-3.555l2.938-7.927a12.677 12.677 0 0 1 7.537-7.558 6.279 6.279 0 0 1 5.74 1.073 4.838 4.838 0 0 1 1.618 2.045c.079-.479.265-.948.562-1.373l4.245-6.015a4.195 4.195 0 0 1 5.85-1.005zm-16.12 10.122c-.168.003-.334.03-.495.077a7.784 7.784 0 0 0-4.138 4.413l-2.29 6.177 7.593-10.432a1.058 1.058 0 0 0-.67-.235z" }));
});

var _extends$84 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$83(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPrinterOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$83(_ref, ["styles"]);

  return React.createElement("svg", _extends$84({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M90.379 20H96v56H84v-8h4V28.05a47.653 47.653 0 0 0-9.086 1.266c2 2.156 3.104 4.993 3.086 7.934.14 5.099-3.04 9.7-7.86 11.371A12.031 12.031 0 0 1 58 37.328a11.427 11.427 0 0 1 3.055-7.98A48.473 48.473 0 0 0 49.545 28H8v40h8V52h64v44H16V80.008h8V88h48V60H24v16H0V20h49.545a54.464 54.464 0 0 1 20.416 3.824A53.677 53.677 0 0 1 90.379 20zM69.992 32.605c-3.285 1.73-4 3.118-3.992 4.704a4.023 4.023 0 0 0 1.684 3.28 4.113 4.113 0 0 0 3.845.47A3.758 3.758 0 0 0 74 37.312c-.012-1.648-.72-3.003-4.008-4.707zM72 0a8.01 8.01 0 0 1 8 8v8h-8V8H24v8h-8V8a8.01 8.01 0 0 1 8-8z" }));
});

var _extends$85 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$84(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconPrinterOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$84(_ref, ["styles"]);

  return React.createElement("svg", _extends$85({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M76.253 29.333H80v37.334h-8v-5.334h2.667V34.701c-2.042.085-4.07.368-6.058.843a7.705 7.705 0 0 1 2.058 5.29 7.797 7.797 0 0 1-5.24 7.58 8.02 8.02 0 0 1-10.76-7.529 7.618 7.618 0 0 1 2.036-5.32 32.315 32.315 0 0 0-7.673-.898H21.333v26.666h5.334V50.667h42.666V80H26.667V69.339H32v5.328h32V56H32v10.667H16V29.333h33.03a36.31 36.31 0 0 1 13.61 2.55 35.785 35.785 0 0 1 13.613-2.55zM62.66 37.737c-2.19 1.154-2.666 2.078-2.661 3.135a2.682 2.682 0 0 0 1.122 2.188c.75.525 1.711.642 2.564.312a2.505 2.505 0 0 0 1.647-2.497c-.007-1.099-.48-2.003-2.672-3.138zM64 16a5.34 5.34 0 0 1 5.333 5.333v5.334H64v-5.334H32v5.334h-5.333v-5.334A5.34 5.34 0 0 1 32 16h32z" }));
});

var _extends$86 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$85(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTagOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$85(_ref, ["styles"]);

  return React.createElement("svg", _extends$86({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M34.977 94.157a7.052 7.052 0 0 1-4.713-1.792L4.354 69.186a7.075 7.075 0 0 1-.464-10.084l36.274-39.18a10.337 10.337 0 0 1 7.563-3.303h7.512v7.68h-7.512a2.643 2.643 0 0 0-1.93.843L9.938 63.876l25 22.369 36.154-39.038c.45-.486.7-1.125.698-1.788V32.207H70.49l-.06 2.558a10.806 10.806 0 0 1-9.735 10.849 10.428 10.428 0 0 1-8.505-3.282 10.551 10.551 0 0 1-2.783-8.7 10.827 10.827 0 0 1 10.875-9.105h2.711l.312-13.147a9.671 9.671 0 0 1 19.335.229 1.66 1.66 0 0 0 2.434 1.68 10.109 10.109 0 0 1 9.086-3.6v7.68a7.328 7.328 0 0 0-2.696.375l-.034.108-.645.642a9.27 9.27 0 0 1-15.825-6.555 2.02 2.02 0 0 0-1.92-2.25 1.94 1.94 0 0 0-2.055 1.875l-.311 12.964h1.117a7.69 7.69 0 0 1 7.68 7.68v13.21c.003 2.598-.976 5.1-2.741 7.006L40.171 91.9a7.043 7.043 0 0 1-5.194 2.257zm25.305-61.95a3.216 3.216 0 0 0-3.262 2.46 2.857 2.857 0 0 0 .754 2.393 2.78 2.78 0 0 0 2.332.896 3.17 3.17 0 0 0 2.644-3.281l.06-2.468z" }));
});

var _extends$87 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$86(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTagOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$86(_ref, ["styles"]);

  return React.createElement("svg", _extends$87({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M38.985 80.27a4.702 4.702 0 0 1-3.142-1.195L18.57 63.622a4.717 4.717 0 0 1-.31-6.722l24.183-26.12a6.891 6.891 0 0 1 5.042-2.203h5.008v5.12h-5.008c-.489 0-.955.205-1.287.562L22.293 60.082 38.96 74.995 63.062 48.97c.3-.325.467-.75.465-1.193V38.97h-.867l-.04 1.705a7.204 7.204 0 0 1-6.49 7.232 6.952 6.952 0 0 1-5.67-2.187 7.034 7.034 0 0 1-1.855-5.8 7.218 7.218 0 0 1 7.25-6.07h1.807l.208-8.765a6.447 6.447 0 0 1 12.89.152 1.107 1.107 0 0 0 1.623 1.12 6.74 6.74 0 0 1 6.057-2.4v5.12c-.61-.03-1.22.055-1.797.25l-.023.073-.43.427a6.18 6.18 0 0 1-10.55-4.37 1.347 1.347 0 0 0-1.28-1.5 1.294 1.294 0 0 0-1.37 1.25l-.207 8.643h.745a5.127 5.127 0 0 1 5.12 5.12v8.807a6.864 6.864 0 0 1-1.828 4.67L42.448 78.765a4.695 4.695 0 0 1-3.463 1.505zm16.87-41.3a2.144 2.144 0 0 0-2.175 1.64c-.087.58.098 1.169.503 1.594.394.434.97.656 1.555.598a2.113 2.113 0 0 0 1.762-2.188l.04-1.645z" }));
});

var _extends$88 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$87(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$t = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$87(_ref, ["styles"]);

  return React.createElement("svg", _extends$88({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M29.254 86.8a6.295 6.295 0 0 1-4.394-1.776L0 60.784l8.788-8.57 20.25 19.75L86.805 10 96 18.155 33.851 84.817a6.289 6.289 0 0 1-4.449 1.983z" }));
});

var _extends$89 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$88(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTickSolidSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$88(_ref, ["styles"]);

  return React.createElement("svg", _extends$89({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M35.502 73.2a4.197 4.197 0 0 1-2.929-1.184L16 55.856l5.859-5.713 13.5 13.166L73.87 22 80 27.437 38.567 71.878a4.193 4.193 0 0 1-2.965 1.322z" }));
});

var _extends$8a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$89(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTrophyOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$89(_ref, ["styles"]);

  return React.createElement("svg", _extends$8a({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M72 0v8H28v32c0 11.046 8.954 20 20 20s20-8.954 20-20V24c0-7.732 6.268-14 14-14s14 6.268 14 14a24.668 24.668 0 0 1-14.436 20.98l-3.062-7.39A16.594 16.594 0 0 0 88 23.957 6 6 0 1 0 76 24v16c-.016 14.098-10.439 25.758-24 27.712v4.733c-.007 6.625-5.376 11.993-12 12h-4.445A7.557 7.557 0 0 0 29.148 88H72v8H24a4 4 0 0 1-4-4c.01-8.587 6.968-15.545 15.555-15.555H40a4.004 4.004 0 0 0 4-4v-4.733c-11.152-1.607-20.181-9.777-23.047-20.47C8.618 43.089.103 33.764 0 24.043a14 14 0 0 1 20.001-12.67L20 4a4 4 0 0 1 4-4zM14 18a6 6 0 0 0-6 6c.056 5.259 4.95 10.86 12 14.234V24a6 6 0 0 0-6-6z" }));
});

var _extends$8b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$8a(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconTrophyOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$8a(_ref, ["styles"]);

  return React.createElement("svg", _extends$8b({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M64 16v5.333H34.667v21.334C34.667 50.03 40.637 56 48 56c7.364 0 13.333-5.97 13.333-13.333V32A9.333 9.333 0 0 1 80 32a16.446 16.446 0 0 1-9.624 13.987l-2.041-4.927c3.584-1.679 5.999-5.145 6.332-9.089a4 4 0 0 0-8 .029v10.667c-.011 9.399-6.96 17.172-16 18.474v3.156a8.009 8.009 0 0 1-8 8h-2.964a5.038 5.038 0 0 0-4.27 2.37H64V80H32a2.667 2.667 0 0 1-2.667-2.667c.007-5.724 4.646-10.363 10.37-10.37h2.964a2.67 2.67 0 0 0 2.666-2.666V61.14c-7.435-1.071-13.455-6.519-15.364-13.648C21.745 44.725 16.069 38.51 16 32.03a9.333 9.333 0 0 1 13.334-8.447v-4.915A2.667 2.667 0 0 1 32 16zM25.333 28a4 4 0 0 0-4 4c.038 3.506 3.3 7.24 8 9.489V32a4 4 0 0 0-4-4z" }));
});

var _extends$8c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$8b(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconWatchOutlineLarge$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$8b(_ref, ["styles"]);

  return React.createElement("svg", _extends$8c({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 0c26.51 0 48 21.49 48 48-.029 26.498-21.502 47.971-48 48C21.49 96 0 74.51 0 48S21.49 0 48 0zm0 8C25.909 8 8 25.909 8 48s17.909 40 40 40 40-17.909 40-40C87.974 25.92 70.08 8.026 48 8zm4 68v8h-8v-8zM25.371 64.973l5.656 5.656-5.656 5.656-5.656-5.656zm45.258 0l5.656 5.656-5.656 5.656-5.656-5.656zM52.133 24v19.867H72v8H52.133v2.172a10.954 10.954 0 0 1-9.965 11.137A10.665 10.665 0 0 1 30.824 53.82a10.952 10.952 0 0 1 11.137-9.953h2.172V24zM38.809 54.344a2.654 2.654 0 0 0 .773 2.078c.549.538 1.3.817 2.066.77a3.04 3.04 0 0 0 2.485-3.153v-2.172h-2.168a3.04 3.04 0 0 0-3.156 2.477zM84 44v8h-8v-8zm-64 0v8h-8v-8zm50.629-24.285l5.656 5.656-5.656 5.656-5.656-5.656zm-45.258 0l5.656 5.656-5.656 5.656-5.656-5.656zM52 12v8h-8v-8z" }));
});

var _extends$8d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$8c(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var iconWatchOutlineSmall$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$8c(_ref, ["styles"]);

  return React.createElement("svg", _extends$8d({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 16c17.673 0 32 14.327 32 32-.02 17.665-14.335 31.98-32 32-17.673 0-32-14.327-32-32s14.327-32 32-32zm0 5.333c-14.728 0-26.667 11.94-26.667 26.667S33.273 74.667 48 74.667 74.667 62.727 74.667 48C74.649 33.28 62.72 21.35 48 21.333zm2.667 45.334V72h-5.334v-5.333zm-17.753-7.352l3.77 3.77-3.77 3.772-3.77-3.771zm30.172 0l3.77 3.77-3.77 3.772-3.77-3.771zM50.756 32v13.245H64v5.333H50.755v1.448a7.302 7.302 0 0 1-6.643 7.425 7.118 7.118 0 0 1-5.662-2.238 7.11 7.11 0 0 1-1.9-5.333 7.302 7.302 0 0 1 7.424-6.635h1.448V32zm-8.884 20.23a1.77 1.77 0 0 0 .516 1.385c.366.358.866.544 1.378.513a2.027 2.027 0 0 0 1.656-2.102v-1.448h-1.445a2.026 2.026 0 0 0-2.105 1.651zM72 45.332v5.334h-5.333v-5.334zm-42.667 0v5.334H24v-5.334zm33.753-16.19l3.77 3.771-3.77 3.77-3.77-3.77zm-30.172 0l3.77 3.771-3.77 3.77-3.77-3.77zM50.667 24v5.333h-5.334V24z" }));
});

var _extends$8e = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$8d(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var Timer = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$8d(_ref, ["styles"]);

  return React.createElement("svg", _extends$8e({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M56.175 17.1c18.005 4.003 31.098 19.709 31.457 38.193.375 19.297-13.237 36.098-32.338 39.914-19.1 3.816-38.222-6.443-45.43-24.374C3.384 54.713 8.202 36.54 21.246 25.6H12.12v-3.84h14.72c1.06 0 1.92.86 1.92 1.92V38.4h-3.84V27.365c-12.811 9.796-17.718 26.952-11.625 42.11 6.547 16.288 23.918 25.607 41.27 22.14C71.916 88.15 84.28 72.89 83.94 55.364c-.333-17.104-12.672-31.59-29.508-34.883H52.63V8.275h7.595c1.16 0 2.11-1.013 2.11-2.276s-.95-2.275-2.11-2.275h-19.41c-1.16 0-2.11 1.012-2.11 2.275s.95 2.276 2.11 2.276h7.595V18.41h-.459l.009 2.106a46.378 46.378 0 0 0-10.51 1.243L36.44 18a50.592 50.592 0 0 1 8.425-1.256v-4.746h-4.05c-3.13 0-5.655-2.691-5.655-5.999C35.16 2.692 37.686 0 40.815 0h19.41c3.13 0 5.655 2.692 5.655 6 0 3.307-2.526 5.998-5.655 5.998h-4.05zM50.52 55.04h15.36v3.38H51.76v3.852c0 4.34-3.767 6.848-8.233 6.848-1.879 0-3.681-.699-5.01-1.943-1.33-1.244-2.077-2.932-2.077-4.693 0-4.344 3.395-7.444 9.57-7.444h.67V25.6h3.84zm-2.364 7.232V58.42H46.01c-4.205 0-5.965 1.608-5.965 4.065 0 .863.366 1.691 1.019 2.302.653.611 1.54.955 2.463.955 2.688 0 4.629-1.293 4.629-3.469zM72.304 20.92l-2.584-2.584a5.787 5.787 0 0 1 8.184 0l4.201 4.2a5.787 5.787 0 0 1 0 8.185l-2.584-2.584a2.133 2.133 0 0 0 0-3.017l-4.2-4.2a2.133 2.133 0 0 0-3.017 0z" }));
});



var vmIcons = /*#__PURE__*/Object.freeze({
	__proto__: null,
	Placeholder: iconPlaceholder$1,
	ArrowDownSolidLarge: iconArrowDownSolidLarge$1,
	ArrowDownSolidSmall: iconArrowDownSolidSmall$1,
	ArrowUpSolidLarge: iconArrowUpSolidLarge$1,
	ArrowUpSolidSmall: iconArrowUpSolidSmall$1,
	ChevronDownSolidLarge: VMIcon$9,
	ChevronDownSolidSmall: VMIcon$j,
	ChevronLeftLarge: iconChevronLeftLarge$1,
	ChevronLeftSmall: iconChevronLeftSmall$1,
	ChevronLeftSolidSmall: iconChevronLeftSolidSmall$1,
	ChevronRightSolidLarge: iconChevronRightSolidLarge$1,
	ChevronRightSolidSmall: iconChevronRightSolidSmall$1,
	ChevronUpSolidLarge: VMIcon$k,
	ChevronUpSolidSmall: iconChevronUpSolidSmall$1,
	Switch: iconSwitch,
	TriangleDownSolidLarge: iconTriangleDownSolidLarge$1,
	TriangleDownSolidSmall: iconTriangleDownSolidSmall$1,
	TriangleLeftSolidLarge: iconTriangleLeftSolidLarge$1,
	TriangleLeftSolidSmall: iconTriangleLeftSolidSmall$1,
	TriangleRightLarge: VMIcon,
	TriangleRightSolidSmall: iconTriangleRightSolidSmall$1,
	TriangleUpSolidLarge: iconTriangleUpSolidLarge$1,
	TriangleUpSolidSmall: iconTriangleUpSolidSmall$1,
	BriefcaseBrandedLarge: iconBriefcaseBrandedLarge$1,
	BriefcaseBrandedSmall: iconBriefcaseBrandedSmall$1,
	MailBrandedLarge: iconMailBrandedLarge$1,
	MailBrandedSmall: iconMailBrandedSmall$1,
	ChatSolidLarge: iconChatSolidLarge$1,
	MailOutlineLarge: iconMailOutlineLarge$1,
	MailOutlineSmall: iconMailOutlineSmall$1,
	MailReadOutlineLarge: iconMailReadOutlineLarge$1,
	MailReadOutlineSmall: iconMailReadOutlineSmall$1,
	MailSentOutlineLarge: iconMailSentOutlineLarge$1,
	ReplySolidLarge: iconReplySolidLarge$1,
	ReplySolidSmall: iconReplySolidSmall$1,
	TelephoneOutlineLarge: iconTelephoneOutlineLarge$1,
	TelephoneOutlineSmall: iconTelephoneOutlineSmall$1,
	BuildingOutlineLarge: VMIcon$c,
	BuildingOutlineSmall: iconBuildingOutlineSmall$1,
	CalculatorOutlineLarge: iconCalculatorOutlineLarge$1,
	CalculatorOutlineSmall: iconCalculatorOutlineSmall$1,
	CalendarOutlineLarge: iconCalendaroutlineLarge,
	CalendarOutlineSmall: iconCalendaroutlineSmall$1,
	CoinsOutlineLarge: iconCoinsOutlineLarge$1,
	CoinsOutlineSmall: iconCoinsOutlineSmall$1,
	CreditCardOutlineLarge: VMIcon$d,
	CreditCardOutlineSmall: iconCreditCardOutlineSmall$1,
	LoanOutlineLarge: iconLoanOutlineLarge$1,
	LoanOutlineSmall: iconLoanOutlineSmall$1,
	MoneyNote: VMIcon$e,
	PoundOutlineLarge: iconPoundOutlineLarge$1,
	PoundOutlineSmall: iconPoundOutlineSmall$1,
	TimeIsMoney: VMIcon$g,
	WalletOutlineLarge: VMIcon$i,
	WalletOutlineSmall: iconWalletOutlineSmall$1,
	CameraOutlineLarge: iconCameraOutlineLarge$1,
	CarOutlineLarge: iconCarOutlineLarge$1,
	CarOutlineSmall: iconCarOutlineSmall$1,
	DecorateOutlineLarge: iconDecorateOutlineLarge$1,
	DecorateOutlineSmall: iconDecorateOutlineSmall$1,
	GenericMoneyOutlineLarge: iconGenericMoneyOutlineLarge$1,
	GenericMoneyOutlineSmall: iconGenericMoneyOutlineSmall$1,
	Health: VMHealthIcon,
	PlaneOutlineLarge: VMIcon$f,
	PlaneOutlineSmall: iconPlaneOutlineSmall$1,
	WeddingOutlineLarge: iconWeddingOutlineLarge$1,
	WeddingOutlineSmall: iconWeddingOutlineSmall$1,
	Desktop: Desktop$1,
	DualAvatar: DualAvatar$1,
	Favourite: Favourite$1,
	AbroadOutlineLarge: iconAbroadOutlineLarge$1,
	AbroadOutlineSmall: iconAbroadOutlineSmall$1,
	AlertOutlineLarge: iconAlertOutlineLarge$1,
	AlertOutlineSmall: iconAlertOutlineSmall$1,
	AuthorisationLarge: VMIcon$l,
	AuthorisationSmall: iconAuthorisationSmall$1,
	AvatarOutlineLarge: iconAvatarOutlineLarge$1,
	AvatarOutlineSmall: iconAvatarOutlineSmall$1,
	BlockedFilledLarge: iconBlockedFilledLarge$1,
	BlockedFilledSmall: iconBlockedFilledSmall$1,
	CallIncomingSolidLarge: iconCallIncomingSolidLarge$1,
	CallIncomingSolidSmall: iconCallIncomingSolidSmall$1,
	Checkbox: iconCheckbox,
	ClockOutlineLarge: VMIcon$m,
	ClockOutlineSmall: iconClockOutlineSmall$1,
	ClockSolidLarge: iconClockSolidLarge,
	ClockSolidSmall: iconClockSolidSmall$1,
	ConferenceLarge: iconConferenceLarge$1,
	ConferenceSmall: iconConferenceSmall$1,
	CredentialsOutlineLarge: iconCredentialsOutlineLarge$1,
	CredentialsOutlineSmall: iconCredentialsOutlineSmall$1,
	CrossSolidCircleLarge: VMIcon$n,
	CrossSolidCircleSmall: iconCrossSolidCircleSmall$1,
	CrossRoundedSolidLarge: VMIcon$4,
	CrossSolidLarge: VMIcon$4,
	CrossRoundedSolidSmall: VMIcon$o,
	CrossSolidSmall: VMIcon$o,
	crossThinOutlineLarge: iconCrossThinOutlineLarge$1,
	crossThinOutlineSmall: iconCrossThinOutlineSmall$1,
	crossOutlineLarge: VMIcon$p,
	CrossOutlineLarge: VMIcon$p,
	crossOutlineSmall: iconCrossoutlineSmall$1,
	CrossOutlineSmall: iconCrossoutlineSmall$1,
	CycleLarge: iconCycleLarge,
	CycleSmall: iconCycleSmall$1,
	CycleSolidLarge: iconCycleSolidLarge$1,
	CycleSolidSmall: iconCycleSolidSmall$1,
	DialSolidLarge: iconDialSolidLarge$1,
	DialSolidSmall: iconDialSolidSmall$1,
	Disallowed: iconDisallowed,
	DotSolidLarge: iconDotSolidLarge$1,
	DotSolidSmall: iconDotSolidSmall$1,
	DownloadSolidLarge: iconDownloadSolidLarge$1,
	DownloadSolidSmall: iconDownloadSolidSmall$1,
	EditDisallowedOutlineLarge: iconEditDisallowedOutlineLarge$1,
	EditDisallowedOutlineSmall: iconEditDisallowedOutlineSmall$1,
	EllipsisLarge: VMIcon$5,
	EllipsisSmall: iconEllipsisSmall$1,
	ExclamationCircleLarge: VMIcon$q,
	ExclamationCircleSmall: iconExclamationCircleSmall$1,
	ExclamationLarge: iconExclamationLarge$1,
	ExclamationSmall: iconExclamationSmall$1,
	EyehideOutlineLarge: iconEyehideOutlineLarge,
	EyehideOutlineSmall: iconEyehideOutlineSmall$1,
	EyeshowOutlineLarge: iconEyeshowOutlineLarge,
	EyeshowOutlineSmall: iconEyeshowOutlineSmall$1,
	faceOutlineLarge: iconFaceOutlineLarge$1,
	faceOutlineSmall: iconFaceOutlineSmall$1,
	FlagLarge: iconFlagLarge$1,
	FlagSmall: iconFlagSmall$1,
	FlipChartOutlineLarge: iconFlipChartOutlineLarge$1,
	FlipChartOutlineSmall: iconFlipChartOutlineSmall$1,
	FolderOutlineLarge: iconFolderOutlineLarge$1,
	FolderOutlineSmall: iconFolderOutlineSmall$1,
	FormerLarge: iconFormerLarge$1,
	FormerSmall: iconFormerSmall$1,
	GhostOutlineLarge: iconGhostOutlineLarge$1,
	GhostOutlineSmall: iconGhostOutlineSmall$1,
	Graph: iconGraph$1,
	GridLarge: iconGridLarge,
	GridSmall: iconGridSmall$1,
	HouseOutlineLarge: iconHouseOutlineLarge$1,
	HouseOutlineSmall: iconHouseOutlineSmall$1,
	InboxOutlineLarge: iconInboxOutlineLarge$1,
	InboxOutlineSmall: iconInboxOutlineSmall$1,
	InfoOutlineLarge: iconInfoOutlineLarge$1,
	InfoOutlineSmall: iconInfoOutlineSmall$1,
	LinkedGroup: iconLinkedGroup$1,
	LoadingOutlineLarge: iconLoadingOutlineLarge$1,
	LoadingOutlineSmall: iconLoadingOutlineSmall,
	LocationOutlineLarge: iconLocationOutlineLarge$1,
	LocationOutlineSmall: iconLocationOutlineSmall$1,
	LockFilled: VMIcon$1,
	LockOutlineLarge: VMIcon$a,
	LockOutlineSmall: iconLockSmall$1,
	LogoutOutlineLarge: iconLogoutOutlineLarge$1,
	LogoutOutlineSmall: iconLogoutOutlineSmall$1,
	MagnifySolidLarge: iconMagnifySolidLarge,
	MagnifySolidSmall: iconMagnifySolidSmall$1,
	MakeCallSolidLarge: iconMakeCallSolidLarge$1,
	MakeCallSolidSmall: iconMakeCallSolidSmall$1,
	MaskOutlineLarge: iconMaskOutlineLarge$1,
	MaskOutlineSmall: iconMaskOutlineSmall$1,
	MinusLarge: iconMinusLarge$1,
	MinusOutlineLarge: VMIcon$6,
	MinusOutlineSmall: iconMinusOutlineSmall$1,
	MinusSmall: iconMinusSmall$1,
	MinusSolidLarge: iconMinusSolidLarge,
	MinusSolidSmall: iconMinusSolidSmall$1,
	MobileOutlineLarge: iconMobileOutlineLarge$1,
	MobileOutlineSmall: iconMobileOutlineSmall$1,
	MoneyLarge: iconMoneyLarge$1,
	MoneySmall: iconMoneySmall$1,
	NoResults: iconNoResults$1,
	OnlineOutlineLarge: iconOnlineOutlineLarge$1,
	OnlineOutlineSmall: iconOnlineOutlineSmall$1,
	PageOutlineLarge: iconPageOutlineLarge$1,
	PageOutlineSmall: iconPageOutlineSmall$1,
	PauseFilledLarge: iconPauseFilledLarge$1,
	PauseFilledSmall: iconPauseFilledSmall$1,
	PauseOutlineLarge: iconPauseOutlineLarge$1,
	PauseOutlineSmall: iconPauseOutlineSmall$1,
	PendingFilledLarge: VMIcon$r,
	PendingFilledSmall: iconPendingFilledSmall$1,
	PersonOutlineLarge: iconPersonOutlineLarge$1,
	PersonOutlineSmall: iconPersonOutlineSmall$1,
	PhoneHoldLarge: iconPhoneHoldLarge$1,
	PhoneHoldSmall: iconPhoneHoldSmall$1,
	PhoneLarge: iconPhoneLarge$1,
	PhoneRingLarge: iconPhoneRingLarge$1,
	PhoneRingSmall: iconPhoneRingSmall$1,
	PhoneSmall: iconPhoneSmall$1,
	PlusLarge: iconPlusLarge$1,
	PlusOutlineLarge: VMIcon$7,
	PlusOutlineSmall: iconPlusOutlineSmall$1,
	PlusSmall: iconPlusSmall$1,
	PlusSolidSmall: iconPlusSolidSmall$1,
	PopoutOutlineLarge: VMIcon$8,
	ProspectLarge: iconProspectLarge$1,
	ProspectSmall: iconProspectSmall$1,
	QuestionSolidLarge: iconQuestionSolidLarge$1,
	QuestionSolidSmall: iconQuestionSolidSmall$1,
	Radio: iconRadio,
	RetrieveLarge: iconRetrieveLarge$1,
	RetrieveSmall: iconRetrieveSmall$1,
	SettingsOutlineLarge: iconSettingsOutlineLarge$1,
	SettingsOutlineSmall: iconSettingsOutlineSmall$1,
	SheetLarge: iconSheetLarge$1,
	SheetSmall: iconSheetSmall$1,
	SliderOutlineLarge: iconSliderOutlineLarge$1,
	SliderOutlineSmall: iconSliderOutlineSmall$1,
	StatementOutlineLarge: iconStatementOutlineLarge$1,
	StatementOutlineSmall: iconStatementOutlineSmall$1,
	StatusOutlineLarge: VMIcon$2,
	StatusOutlineSmall: iconStatusOutlineSmall$1,
	TickOutlineCircleSmall: iconTickCircleOutlineSmall$1,
	TickOutlineCircleFilledLarge: VMIcon$3,
	TickOutlineCircleFilledSmall: iconTickCircularFilledSmall$1,
	TickInterfaceOutlineLarge: iconTickInterfaceOutlineLarge$1,
	TickInterfaceOutlineSmall: iconTickInterfaceOutlineSmall$1,
	TickOutlineCircleLarge: iconTickOutlineLarge$1,
	TickOutlineLarge: iconTickOutlineLarge$1,
	TickOutlineSmall: iconTickOutlineSmall$1,
	TimelineLarge: iconTimelineLarge$1,
	TimelineSmall: iconTimelineSmall$1,
	TimelineStartLarge: iconTimelineStartLarge$1,
	TimelineStartSmall: iconTimelineStartSmall$1,
	ToolOutlineLarge: iconToolOutlineLarge$1,
	ToolOutlineSmall: iconToolOutlineSmall$1,
	TransactionMethodOutlineLarge: iconTransactionMethodOutlineLarge$1,
	TransactionMethodOutlineSmall: iconTransactionMethodOutlineSmall$1,
	TransferLarge: iconTransferLarge$1,
	TransferSmall: iconTransferSmall$1,
	TrashLarge: iconTrashLarge$1,
	TrashSmall: iconTrashSmall$1,
	Upload: iconUpload$1,
	UsageOutlineLarge: VMIcon$h,
	UsageOutlineSmall: iconUsageOutlineSmall$1,
	WarningTriangle: WarningTriangle$1,
	AboutYou: AboutYou,
	Accounts: Accounts,
	AllSystemsGo: AllSystemsGo,
	Help: Help,
	Projection: iconProjection,
	Spending: Spending,
	YourMoney: YourMoney,
	ArchiveOutlineLarge: iconArchiveOutlineLarge$1,
	ArchiveOutlineSmall: iconArchiveOutlineSmall$1,
	BriefcaseOutlineLarge: VMIcon$b,
	BriefcaseOutlineSmall: iconBriefcaseOutlineSmall$1,
	ChartOutlineLarge: iconChartOutlineLarge$1,
	ChartOutlineSmall: iconChartOutlineSmall$1,
	ClipboardTickOutlineLarge: iconClipboardTickOutlineLarge,
	ClipboardTickOutlineSmall: iconClipboardTickOutlineSmall$1,
	DiaryOutlineLarge: iconDiaryOutlineLarge$1,
	DiaryOutlineSmall: iconDiaryOutlineSmall$1,
	FileLarge: iconFileLarge$1,
	FileSmall: iconFileSmall$1,
	ListOutlineLarge: VMIcon$s,
	ListOutlineSmall: iconListOutlineSmall$1,
	PencilSolidLarge: iconPencilSolidLarge$1,
	PencilSolidSmall: iconPencilSolidSmall$1,
	PrinterOutlineLarge: iconPrinterOutlineLarge$1,
	PrinterOutlineSmall: iconPrinterOutlineSmall$1,
	TagOutlineLarge: iconTagOutlineLarge$1,
	TagOutlineSmall: iconTagOutlineSmall$1,
	TickSolidLarge: VMIcon$t,
	TickSolidSmall: iconTickSolidSmall$1,
	TrophyOutlineLarge: iconTrophyOutlineLarge$1,
	TrophyOutlineSmall: iconTrophyOutlineSmall$1,
	WatchOutlineLarge: iconWatchOutlineLarge$1,
	WatchOutlineSmall: iconWatchOutlineSmall$1,
	Timer: Timer
});

var main$q = "Icon.js";
var deprecations$1 = [{
	replacements: {
		name: "ChevronLeftSmall",
		replacement: "ChevronLeftSolidSmall",
		path: "Atoms/Iconography"
	}
}, {
	replacements: {
		name: "crossOutlineLarge",
		replacement: "CrossOutlineLarge",
		path: "Atoms/Iconography"
	}
}, {
	replacements: {
		name: "crossOutlineSmall",
		replacement: "CrossOutlineSmall",
		path: "Atoms/Iconography"
	}
}, {
	replacements: {
		name: "crossOutlineSmall",
		replacement: "CrossOutlineSmall",
		path: "Atoms/Iconography"
	}
}, {
	replacements: {
		name: "CrossRoundedSolidLarge",
		replacement: "CrossSolidLarge",
		path: "Atoms/Iconography"
	}
}, {
	replacements: {
		name: "CrossRoundedSolidSmall",
		replacement: "CrossSolidSmall",
		path: "Atoms/Iconography"
	}
}, {
	replacements: {
		name: "CycleSolidLarge",
		replacement: "CycleLarge",
		path: "Atoms/Iconography"
	}
}, {
	replacements: {
		name: "CycleSolidSmall",
		replacement: "CycleSmall",
		path: "Atoms/Iconography"
	}
}];
var packageJson$q = {
	main: main$q,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	deprecations: deprecations$1
};

var _templateObject$z = taggedTemplateLiteral(['\n\tsvg {\n\t\tfill: ', ';\n\t\twidth: ', ';\n\t\theight: ', ';\n\t\tposition: relative;\n\t\tz-index: 1;\n\t\tdisplay: block;\n\t\tpointer-events: none;\n\t}\n\t.u-fill-status-archived {\n\t\tfill: hsl(353, 98%, 41%);\n\t}\n\t.u-fill-status-paused {\n\t\tfill: hsl(205, 100%, 61%);\n\t}\n\t.u-fill-status-active {\n\t\tfill: hsl(143, 100%, 39%);\n\t}\n\t.u-fill-status-pending {\n\t\tfill: hsl(18, 87%, 56%);\n\t}\n'], ['\n\tsvg {\n\t\tfill: ', ';\n\t\twidth: ', ';\n\t\theight: ', ';\n\t\tposition: relative;\n\t\tz-index: 1;\n\t\tdisplay: block;\n\t\tpointer-events: none;\n\t}\n\t.u-fill-status-archived {\n\t\tfill: hsl(353, 98%, 41%);\n\t}\n\t.u-fill-status-paused {\n\t\tfill: hsl(205, 100%, 61%);\n\t}\n\t.u-fill-status-active {\n\t\tfill: hsl(143, 100%, 39%);\n\t}\n\t.u-fill-status-pending {\n\t\tfill: hsl(18, 87%, 56%);\n\t}\n']);

var isNumber = function isNumber(v) {
	return (/^-?[0-9]+$/.test('' + v)
	);
};

var loadPresents = function loadPresents(cb) {
	return function (config) {
		return function (val) {
			return cb(val) ? val : config[val];
		};
	};
};

var sizeConfig = {
	xxs: 12,
	xs: 16,
	sm: 24,
	md: 32,
	lg: 64,
	xl: 128
};

var allowInt = loadPresents(isNumber);

var addPx = function addPx(value) {
	return value === undefined ? value : value + 'px';
};

var setSize = allowInt(sizeConfig);

var StyledIconWrapper$1 = styled$1('div')(_templateObject$z, function (props) {
	return props.color ? colours.generalPalette[props.color] : props.theme.colours.iconFill;
}, addPx(setSize(sizeConfig.xs)), addPx(setSize(sizeConfig.xs)));

var setStatusColor = function setStatusColor(c) {
	return c && 'u-fill-' + c;
};

var setCustomColor = function setCustomColor(color) {
	return color && colours.generalPalette[color];
};

var deprecatedIcons = ['ChevronLeftSmall', 'crossOutlineLarge', 'crossOutlineSmall', 'CrossRoundedSolidLarge', 'CrossRoundedSolidSmall', 'CycleSolidLarge', 'CycleSolidSmall'];

// eslint-disable-next-line react/prop-types
var Icon = function Icon(_ref) {
	var iconType = _ref.iconType,
	    backingClassName = _ref.backingClassName,
	    backingSize = _ref.backingSize,
	    size = _ref.size,
	    color = _ref.color,
	    className = _ref.className,
	    theme = _ref.theme;

	deprecatedIcons.forEach(function (deprecatedIcon) {
		if (deprecatedIcon === iconType) {
			DeprecationWarnings.logIcon('Icon', deprecatedIcon);
		}
	});

	var themeName = theme.name;

	var ChosenIcon = themeName === 'vm' ? vmIcons[iconType] : icons[iconType];

	if (!ChosenIcon) {
		// We really want to use the icons variable in the prop validation,
		// but webpack is mangling the icon names causing the prop validation
		// to fail. For now, this console statement is he best approach to
		// providing useful info to the user.
		// eslint-disable-next-line no-console
		console.warn('Unexpected icon type ' + iconType);
		return React.createElement('span', null);
	}

	if (process.env.NODE_ENV !== 'test') {
		ChosenIcon.displayName = iconType;
	}

	var props = {
		style: {
			width: addPx(setSize(size)),
			height: addPx(setSize(size)),
			fill: setCustomColor(color)
		},
		className: classnames(className, setStatusColor(color))
	};

	if (!backingSize) {
		return React.createElement(
			StyledIconWrapper$1,
			null,
			React.createElement(ChosenIcon, props)
		);
	}
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$q, hasCustomMargins: true },
		React.createElement(
			'div',
			{
				className: classnames('c-a-backing-icon', 'c-a-backing-icon--bordered', defineProperty({}, 'c-a-backing-icon--size-' + backingSize, backingSize), backingClassName)
			},
			React.createElement(
				StyledIconWrapper$1,
				null,
				React.createElement(ChosenIcon, props)
			)
		)
	);
};

Icon.propTypes = {
	/** A custom class name for backing element. */
	backingClassName: PropTypes.string,
	/** Sets the size of an icon. */
	backingSize: PropTypes.oneOf(['xxs', 'xs', 'sm', 'md', 'lg', 'xl']),
	/** A custom class name. */
	className: PropTypes.string,
	/** Sets the fill colour of the icon. */
	color: PropTypes.string,
	/** Sets the icon to display. */
	iconType: PropTypes.string.isRequired,
	/** Sets the size of an icon. */
	size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

Icon.defaultProps = {};

var WrappedIcon = withTheme(Icon);

var main$r = "ConditionalPanel.js";
var packageJson$r = {
	main: main$r,
	"component-id": 981,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$A = taggedTemplateLiteral(['\n\tbackground-color: white;\n\tborder-radius: 4px 0 0 4px;\n\t', ';\n\tmargin: 0 16px 24px 10px;\n\tpadding-bottom: 8px;\n\tpadding-left: 16px;\n\tposition: relative;\n\n\t:after {\n\t\tcontent: \'\';\n\t\twidth: 4px;\n\t\theight: 100%;\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tborder-radius: 4px;\n\t\tbackground-color: ', ';\n\t}\n'], ['\n\tbackground-color: white;\n\tborder-radius: 4px 0 0 4px;\n\t', ';\n\tmargin: 0 16px 24px 10px;\n\tpadding-bottom: 8px;\n\tpadding-left: 16px;\n\tposition: relative;\n\n\t:after {\n\t\tcontent: \'\';\n\t\twidth: 4px;\n\t\theight: 100%;\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tborder-radius: 4px;\n\t\tbackground-color: ', ';\n\t}\n']);

var StyledWrapper$a = styled('div')(_templateObject$A, function (props) {
	return !props.isVisible && 'display: none;';
}, function (props) {
	return props.theme.colours.interaction;
});

/**
 * @example ./Design.md
 */
var ConditionalPanel = function ConditionalPanel(_ref) {
	var children = _ref.children,
	    isVisible = _ref.isVisible;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$r, hasCustomMargins: true },
		React.createElement(
			StyledWrapper$a,
			{ isVisible: isVisible },
			children
		)
	);
};

ConditionalPanel.propTypes = {
	/** Content of the Panel. */
	children: PropTypes.node.isRequired,
	/** This will hide the panel when set to false. */
	isVisible: PropTypes.bool.isRequired
};

ConditionalPanel.defaultProps = {};

var _templateObject$B = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: ', ';\n\tborder-color: ', ';\n\tborder-style: solid;\n\tborder-width: ', ';\n\t', '\n\t', '\n\tborder-radius: ', ';\n\tdisplay: inline-flex;\n\tflex-grow: 1;\n\tposition: relative;\n\n\t', ';\n\n\tlabel {\n\t\talign-items: ', ';\n\t\tbox-sizing: border-box;\n\t\tcolor: ', ';\n\t\tcursor: ', ';\n\t\tdisplay: inline-flex;\n\t\t', ';\n\n\t\t', ';\n\n\t\t// IE11 Solution to content stress test\n\t\t&:after {\n\t\t\tdisplay: block;\n\t\t\tcontent: \'\';\n\t\t\tmin-height: inherit;\n\t\t\tfont-size: 0;\n\t\t}\n\t}\n\n\tsvg {\n\t\tborder: 2px solid ', ';\n\t\tbackground: ', ';\n\t\tborder-radius: 100%;\n\t\theight: 24px;\n\t\tmargin-right: ', ';\n\t\twidth: 24px;\n\t}\n\n\tinput + label svg {\n\t\t', '\n\t\t', '\n\t\tflex-shrink: 0;\n\t}\n\n\t', '\n\t', '\n'], ['\n\talign-items: center;\n\tbackground: ', ';\n\tborder-color: ', ';\n\tborder-style: solid;\n\tborder-width: ', ';\n\t', '\n\t', '\n\tborder-radius: ', ';\n\tdisplay: inline-flex;\n\tflex-grow: 1;\n\tposition: relative;\n\n\t', ';\n\n\tlabel {\n\t\talign-items: ', ';\n\t\tbox-sizing: border-box;\n\t\tcolor: ', ';\n\t\tcursor: ', ';\n\t\tdisplay: inline-flex;\n\t\t', ';\n\n\t\t', ';\n\n\t\t// IE11 Solution to content stress test\n\t\t&:after {\n\t\t\tdisplay: block;\n\t\t\tcontent: \'\';\n\t\t\tmin-height: inherit;\n\t\t\tfont-size: 0;\n\t\t}\n\t}\n\n\tsvg {\n\t\tborder: 2px solid ', ';\n\t\tbackground: ', ';\n\t\tborder-radius: 100%;\n\t\theight: 24px;\n\t\tmargin-right: ', ';\n\t\twidth: 24px;\n\t}\n\n\tinput + label svg {\n\t\t', '\n\t\t', '\n\t\tflex-shrink: 0;\n\t}\n\n\t', '\n\t', '\n']),
    _templateObject2$i = taggedTemplateLiteral(['\n\tdisplay: flex;\n'], ['\n\tdisplay: flex;\n']);

var StyledWrapper$b = styled('div')(_templateObject$B, function (props) {
	return props.isDisabled ? colours.component.backgroundDisabled : colours.component.background;
}, colours.component.borderDisabled, function (props) {
	return props.theme.borderWidth;
}, function (props) {
	return !props.hasIcon && props.theme.name === 'vm' && 'background: transparent;\n\tborder: none;';
}, function (props) {
	return props.isChecked && !props.isDisabled && 'border-color: ' + props.theme.colours.interaction + ';';
}, function (props) {
	return props.theme.borderRadius;
}, inputStyles, function (props) {
	return props.hasSubLabel ? 'flex-start' : 'center';
}, function (props) {
	return props.theme.colours.bodyText;
}, function (props) {
	return props.isDisabled ? 'not-allowed' : 'pointer';
}, function (props) {
	return !props.hasIcon && props.theme.name === 'vm' ? 'padding: 0' : 'min-height: 32px; min-width: 98px; padding: ' + spacing.SINGLE + ' ' + spacing.DOUBLE;
}, function (props) {
	return props.isCard && '\n\t\t\t\tbackground-color: white;\n\t\t\t\tborder: ' + spacing.QUARTER + ' solid;\n\t\t\t\tborder-color: ' + (props.isChecked && !props.isDisabled ? props.theme.colours.interaction : colours.component.borderDisabled) + ';\n\t\t\t\tborder-radius: 5px;\n\t\t\t\tbox-shadow: ' + (props.currentCheckedId ? '0' : props.theme.boxShadow) + ';\n\t\t\t\tcursor: ' + (props.isDisabled ? 'not-allowed' : 'pointer') + ';\n\t\t\t\tmax-width: 565px;\n\t\t\t\tpadding: ' + spacing.DOUBLE + ';\n\t\t\t\tposition: relative;\n\t\t\t\ttext-align: left;\n\t\t\t\twidth: 100%;\n\t\t';
}, function (props) {
	return props.theme.colours.interaction;
}, function (props) {
	return props.isDisabled ? colours.component.backgroundDisabled : colours.component.background;
}, spacing.SINGLE, function (props) {
	return props.isDisabled && 'border-color: ' + colours.component.borderDisabled + ';';
}, function (props) {
	return props.hasError && !props.isDisabled && 'border-color: ' + colours.utility.error + ';';
}, function (props) {
	return props.hasIcon && '\n\t\tsvg {\n\t\t\tborder: 0;\n\t\t\tborder-radius: 0;\n\t\t\tfill: ' + (props.isChecked ? props.theme.colours.primary : colours.component.borderDisabled) + ';\n\t\t}\n\t';
}, function (props) {
	return props.hasGridIcon && 'svg { margin-right: ' + spacing.ONE_AND_HALF + '; }';
});

var StyledRadioIcon = styled('div')(_templateObject2$i);

var getIconFillColour$1 = function getIconFillColour(isChecked, isDisabled, hasError, theme) {
	if (isChecked && isDisabled) {
		return colours.component.borderDisabled;
	}
	if (hasError && isChecked) {
		return colours.utility.error;
	}
	if (isChecked) {
		return theme.colours.interaction;
	}
	if (isDisabled) {
		return colours.component.backgroundDisabled;
	}
	return 'transparent';
};

var BaseInputRadio = function (_Component) {
	inherits(BaseInputRadio, _Component);

	function BaseInputRadio(props) {
		classCallCheck(this, BaseInputRadio);

		var _this = possibleConstructorReturn(this, (BaseInputRadio.__proto__ || Object.getPrototypeOf(BaseInputRadio)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(BaseInputRadio, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    hasError = _props.hasError,
			    hasSubLabelStyling = _props.hasSubLabelStyling,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    isChecked = _props.isChecked,
			    isDisabled = _props.isDisabled,
			    labelText = _props.labelText,
			    name = _props.name,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    subLabelText = _props.subLabelText,
			    theme = _props.theme,
			    dataTestId = _props['data-test-id'],
			    isCard = _props.isCard;


			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				StyledWrapper$b,
				{
					hasError: hasError,
					numberOfWords: labelText.split(' ').length,
					isChecked: isChecked,
					isDisabled: isDisabled,
					hasSubLabel: !!subLabelText,
					'data-test-id': dataTestId + '-' + id + '-wrapper',
					isCard: isCard
				},
				React.createElement('input', {
					checked: isChecked,
					disabled: isDisabled,
					id: id,
					'data-test-id': dataTestId + '-' + id + '-input',
					name: name,
					onBlur: onBlur,
					onChange: onChange,
					onFocus: onFocus,
					type: 'radio',
					value: labelText,
					ref: function ref(element) {
						_this2.refInput = element;
					}
				}),
				React.createElement(
					'label',
					{ htmlFor: id },
					React.createElement(
						StyledRadioIcon,
						null,
						React.createElement(RadioIcon, { fill: getIconFillColour$1(isChecked, isDisabled, hasError, theme) })
					),
					React.createElement(
						InternalStandardBody,
						{ isFlush: true },
						hasSubLabelStyling ? React.createElement(
							StandardLabel,
							{ isFlush: true, 'data-test-id': dataTestId + '-' + id + '-label' },
							labelText
						) : React.createElement(
							'span',
							{ 'data-test-id': dataTestId + '-' + id + '-label' },
							labelText
						),
						subLabelText && React.createElement(
							SubBody,
							{ isFlush: true, 'data-test-id': dataTestId + '-' + id + '-sublabel' },
							React.createElement(
								'span',
								null,
								subLabelText
							)
						)
					)
				)
			);
		}
	}]);
	return BaseInputRadio;
}(Component);

var basePropTypes = {
	/** Changes radio colour when set to true. */
	hasError: PropTypes.bool,
	/** An ID HTML attribute for the radio element. Must be unique on any individual page. */
	id: PropTypes.string.isRequired,
	/** Boolean controlling whether radio input is checked. */
	isChecked: PropTypes.bool,
	/** Boolean controlling whether radio input is disabled. */
	isDisabled: PropTypes.bool,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** The radio input label. */
	labelText: PropTypes.string.isRequired,
	/** HTML name attribute value that this radio option belongs to. */
	name: PropTypes.string.isRequired,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Boolean determined from items passed whether sub level styling should be applied. */
	hasSubLabelStyling: PropTypes.bool,
	/** Data attribute targeting inner html close button for automation test purposes. */
	'data-test-id': PropTypes.string,
	/** Radio Card Layout */
	isCard: PropTypes.bool
};

var baseDefaultProps$2 = {
	hasError: false,
	isChecked: false,
	isDisabled: false,
	'data-test-id': 'internal-radio',
	isCard: false
};

BaseInputRadio.propTypes = basePropTypes;
BaseInputRadio.defaultProps = baseDefaultProps$2;

var InternalRadio = {
	Default: withTheme(BaseInputRadio)
};

var main$s = "GenericRadio.js";
var variants$3 = ["InlineSet", "StackedSet"];
var packageJson$s = {
	main: main$s,
	variants: variants$3,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$C = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']);

var StyledInputWrapper$3 = styled('div')(_templateObject$C, function (props) {
	return props.isStacked ? '\n\t\tdisplay: flex;\n\t\tmargin-bottom: ' + (props.isLastRadio ? '0' : spacing.TRIPLE) + ';\n\t' : '\n\t\tdisplay: flex;\n\t\t@media (min-width: ' + breakpoints.sm1 + ') {\n\t\t\tdisplay: inline-flex;\n\t\t}\n\t\tmargin-bottom: ' + spacing.TRIPLE + ';\n\t\tmargin-right: ' + spacing.TRIPLE + ';\n\t';
});

var StyledWrapper$c = styled('div')(_templateObject$C, function (props) {
	return props.isStacked ? '\n\t\tdisplay: inline-flex;\n\t\tflex-direction: column;\n\t\t' : '\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\t\tflex-direction: row;\n\t\t';
});

var Base$1 = function (_Component) {
	inherits(Base, _Component);

	function Base(props) {
		classCallCheck(this, Base);

		var _this = possibleConstructorReturn(this, (Base.__proto__ || Object.getPrototypeOf(Base)).call(this, props));

		_this.radioRef = null;
		return _this;
	}

	createClass(Base, [{
		key: 'handleOnChange',
		value: function handleOnChange(id) {
			this.props.onChange(id);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    groupName = _props.groupName,
			    hasError = _props.hasError,
			    hasSubLabelStyling = _props.hasSubLabelStyling,
			    id = _props.id,
			    items = _props.items,
			    innerRef = _props.innerRef,
			    isStacked = _props.isStacked,
			    onBlur = _props.onBlur,
			    onFocus = _props.onFocus,
			    selectedId = _props.selectedId,
			    dataTestId = _props['data-test-id'],
			    isCard = _props.isCard;


			return React.createElement(
				StyledWrapper$c,
				{ id: id, isStacked: isStacked },
				items.map(function (_ref, index) {
					var id = _ref.id,
					    labelText = _ref.labelText,
					    subLabelText = _ref.subLabelText;

					var blur = index === items.length - 1 ? onBlur : undefined;
					var focus = index === 0 ? onFocus : undefined;
					var ref = index === 0 ? innerRef : undefined;
					var isLastRadio = index === items.length - 1;
					return React.createElement(
						StyledInputWrapper$3,
						{ isLastRadio: isLastRadio, isStacked: isStacked, key: id },
						React.createElement(InternalRadio.Default, {
							hasError: hasError,
							hasSubLabelStyling: hasSubLabelStyling,
							id: groupName + '-' + id,
							isChecked: id === selectedId,
							innerRef: ref,
							labelText: labelText,
							name: groupName,
							onBlur: blur,
							onChange: function onChange() {
								return _this2.handleOnChange(id);
							},
							onFocus: focus,
							subLabelText: isStacked && subLabelText,
							'data-test-id': dataTestId,
							isCard: isCard
						})
					);
				})
			);
		}
	}]);
	return Base;
}(Component);

var InlineSet$1 = function InlineSet(_ref2) {
	var groupName = _ref2.groupName,
	    hasError = _ref2.hasError,
	    id = _ref2.id,
	    innerRef = _ref2.innerRef,
	    items = _ref2.items,
	    onBlur = _ref2.onBlur,
	    _onChange = _ref2.onChange,
	    onFocus = _ref2.onFocus,
	    selectedId = _ref2.selectedId,
	    xraySuppressed = _ref2.xraySuppressed,
	    dataTestId = _ref2['data-test-id'],
	    isCard = _ref2.isCard;
	return React.createElement(
		InternalComponentFrame,
		{
			variant: 'InlineSet',
			packageJson: packageJson$s,
			xraySuppressed: xraySuppressed,
			hasCustomMargins: true
		},
		React.createElement(Base$1, {
			groupName: groupName,
			hasError: hasError,
			id: id,
			items: items,
			innerRef: innerRef,
			onBlur: onBlur,
			onChange: function onChange(id) {
				return _onChange(id);
			},
			onFocus: onFocus,
			selectedId: selectedId,
			'data-test-id': dataTestId,
			isCard: isCard
		})
	);
};

var StackedSet$2 = function StackedSet(_ref3) {
	var groupName = _ref3.groupName,
	    hasError = _ref3.hasError,
	    id = _ref3.id,
	    items = _ref3.items,
	    innerRef = _ref3.innerRef,
	    onBlur = _ref3.onBlur,
	    _onChange2 = _ref3.onChange,
	    onFocus = _ref3.onFocus,
	    selectedId = _ref3.selectedId,
	    xraySuppressed = _ref3.xraySuppressed,
	    dataTestId = _ref3['data-test-id'],
	    isCard = _ref3.isCard;

	var hasSubLabelStyling = items.some(function (item) {
		return !!item.subLabelText;
	});

	return React.createElement(
		InternalComponentFrame,
		{ variant: 'StackedSet', packageJson: packageJson$s, xraySuppressed: xraySuppressed },
		React.createElement(Base$1, {
			groupName: groupName,
			hasError: hasError,
			hasSubLabelStyling: hasSubLabelStyling,
			id: id,
			innerRef: innerRef,
			items: items,
			isStacked: true,
			onBlur: onBlur,
			onChange: function onChange(id) {
				return _onChange2(id);
			},
			onFocus: onFocus,
			selectedId: selectedId,
			'data-test-id': dataTestId,
			isCard: isCard
		})
	);
};

var baseProps$5 = {
	/** String applied to each radio elements html name attribute. */
	groupName: PropTypes.string.isRequired,
	/** Changes radio colour when set to true. */
	hasError: PropTypes.bool,
	/** Boolean determined from items passed whether sub level styling should be applied. */
	hasSubLabelStyling: PropTypes.bool,
	/** An ID HTML attribute for the entire component. Must be unique on any individual page */
	id: PropTypes.string,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Items. */
	items: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.string.isRequired,
		labelText: PropTypes.string.isRequired,
		subLabelText: PropTypes.string
	})).isRequired,
	/** Callback function triggered on blur of the last radio. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change of the first radio. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Selected radio id. */
	selectedId: PropTypes.string,
	xraySuppressed: PropTypes.bool,
	/** Partial Data attribute targeting component for automation test purposes - appended by -{id}-wrapper, -{id}-input, -{id}-label and -{id}-sublabel */
	'data-test-id': PropTypes.string,
	/** Radio Card Layout */
	isCard: PropTypes.bool
};

Base$1.propTypes = _extends({}, baseProps$5);
InlineSet$1.propTypes = _extends({}, baseProps$5);
StackedSet$2.propTypes = _extends({}, baseProps$5, { isStacked: PropTypes.bool });

var baseDefaultProps$3 = {
	hasError: false,
	hasSubLabelStyling: false,
	'data-test-id': 'generic-radio',
	isCard: false
};

Base$1.defaultProps = baseDefaultProps$3;
InlineSet$1.defaultProps = baseDefaultProps$3;
StackedSet$2.defaultProps = baseDefaultProps$3;

var GenericRadio = {
	InlineSet: InlineSet$1,
	StackedSet: StackedSet$2
};

var main$t = "WorldwideMobileNumberInput.js";
var packageJson$t = {
	main: main$t,
	"component-id": 1011,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$D = taggedTemplateLiteral(['\n\tinput {\n\t\tmargin-bottom: ', ';\n\n\t\t', '};\n\t}\n'], ['\n\tinput {\n\t\tmargin-bottom: ', ';\n\n\t\t', '};\n\t}\n']);

var StyledWrapper$d = styled('div')(_templateObject$D, spacing.DOUBLE, function (props) {
	return props.hasValidationError && 'border: ' + props.theme.borderWidth + ' solid ' + colours.utility.error;
});

var validationReasons$5 = {
	BELOW_MIN: 'BELOW_MIN',
	ABOVE_MAX: 'ABOVE_MAX',
	NOT_VALID_UK_MOBILE: 'NOT_VALID_UK_MOBILE'
};

var getValidationErrorReason$3 = function getValidationErrorReason(overseasMaxLength, overseasMinLength, ukMaxLength, ukMinLength, valueToCheck, region) {
	var valueLength = valueToCheck.replace(/\s+/g, '').length;

	// UK validation
	if (region === 'uk') {
		// UK & Overseas validation
		if (valueLength > ukMaxLength) {
			return validationReasons$5.ABOVE_MAX;
		}

		if (valueLength < ukMinLength) {
			return validationReasons$5.BELOW_MIN;
		}

		if (!valueToCheck.startsWith('07')) {
			return validationReasons$5.NOT_VALID_UK_MOBILE;
		}
	}

	// Overseas validation
	if (region === 'overseas') {
		// UK & Overseas validation
		if (valueLength > overseasMaxLength) {
			return validationReasons$5.ABOVE_MAX;
		}

		if (valueLength < overseasMinLength) {
			return validationReasons$5.BELOW_MIN;
		}
	}

	return '';
};

var valueOnChangeHandler = function valueOnChangeHandler(overseasMaxLength, overseasMinLength, ukMaxLength, ukMinLength, onChange, region) {
	return function (output) {
		var value = output.value;


		onChange({
			region: region,
			value: value,
			validationErrorReason: getValidationErrorReason$3(overseasMaxLength, overseasMinLength, ukMaxLength, ukMinLength, value, region)
		});
	};
};

var radioOnChangeHandler = function radioOnChangeHandler(overseasMaxLength, overseasMinLength, ukMaxLength, ukMinLength, onChange, value) {
	return function (id) {
		var type = id.startsWith('uk') ? 'uk' : id.startsWith('overseas') ? 'overseas' : '';

		onChange({
			region: type,
			value: value,
			validationErrorReason: getValidationErrorReason$3(overseasMaxLength, overseasMinLength, ukMaxLength, ukMinLength, value, type)
		});
	};
};

/**
 * @example ./Design.md
 */

var WorldwideMobileNumberInput = function (_Component) {
	inherits(WorldwideMobileNumberInput, _Component);

	function WorldwideMobileNumberInput(props) {
		classCallCheck(this, WorldwideMobileNumberInput);

		var _this = possibleConstructorReturn(this, (WorldwideMobileNumberInput.__proto__ || Object.getPrototypeOf(WorldwideMobileNumberInput)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(WorldwideMobileNumberInput, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    id = _props.id,
			    hasValidationEnabled = _props.hasValidationEnabled,
			    value = _props.value,
			    onBlur = _props.onBlur,
			    onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    innerRef = _props.innerRef,
			    ukMaxLength = _props.ukMaxLength,
			    ukMinLength = _props.ukMinLength,
			    overseasMaxLength = _props.overseasMaxLength,
			    overseasMinLength = _props.overseasMinLength,
			    region = _props.region;


			var hasValidationError = getValidationErrorReason$3(overseasMaxLength, overseasMinLength, ukMaxLength, ukMinLength, value, region) !== '';

			if (innerRef) {
				innerRef(this);
			}

			var radioItems = [{ id: 'uk-radio-item-' + id, labelText: 'UK' }, { id: 'overseas-radio-item-' + id, labelText: 'Overseas' }];

			var selectedId = region !== '' ? region + '-radio-item-' + id : region;

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$t, hasCustomMargins: true },
				React.createElement(
					StyledWrapper$d,
					null,
					React.createElement(GenericRadio.InlineSet, {
						groupName: 'worldwide-radios-' + id,
						items: radioItems,
						onChange: radioOnChangeHandler(overseasMaxLength, overseasMinLength, ukMaxLength, ukMinLength, onChange, value),
						selectedId: selectedId,
						xraySuppressed: true
					}),
					React.createElement(
						ConditionalPanel,
						{ isVisible: selectedId !== '' },
						React.createElement(InternalTelephoneInput, {
							characterCount: 18,
							id: id,
							value: value,
							onBlur: onBlur,
							onChange: valueOnChangeHandler(overseasMaxLength, overseasMinLength, ukMaxLength, ukMinLength, onChange, region),
							onFocus: onFocus,
							innerRef: function innerRef(element) {
								_this2.refInput = element;
							},
							hasValidationError: hasValidationError && hasValidationEnabled
						})
					)
				)
			);
		}
	}]);
	return WorldwideMobileNumberInput;
}(Component);

WorldwideMobileNumberInput.propTypes = {
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value [number],
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Sets the ID attribute on the component, needed to attach it to an associated label in the DOM. */
	id: PropTypes.string.isRequired,
	/** The value of the input. */
	value: PropTypes.string.isRequired,
	/** The maximum character length of the input after space removal. */
	ukMaxLength: PropTypes.number,
	/** The minimum character length of the input after space removal. */
	ukMinLength: PropTypes.number,
	/** The maximum character length of the input after space removal. */
	overseasMaxLength: PropTypes.number,
	/** The minimum character length of the input after space removal. */
	overseasMinLength: PropTypes.number,
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** Sets where the number is located. An empty string leaves it unset.  */
	region: PropTypes.oneOf(['uk', 'overseas', '']).isRequired
};

WorldwideMobileNumberInput.defaultProps = {
	ukMaxLength: 11,
	ukMinLength: 6,
	overseasMaxLength: 14,
	overseasMinLength: 6
};

var main$u = "YearsAndMonthsCountInput.js";
var packageJson$u = {
	main: main$u,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$E = taggedTemplateLiteral(['\n\tdisplay: flex;\n'], ['\n\tdisplay: flex;\n']),
    _templateObject2$j = taggedTemplateLiteral(['\n\tborder: ', ';\n\tborder-radius: ', ';\n\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\twidth: 100%;\n\ttext-align: center;\n\n\t', '};\n'], ['\n\tborder: ', ';\n\tborder-radius: ', ';\n\n\tbox-sizing: border-box;\n\tfont-size: ', ';\n\tmin-height: ', ';\n\tpadding: ', ';\n\twidth: 100%;\n\ttext-align: center;\n\n\t', '};\n']),
    _templateObject3$c = taggedTemplateLiteral(['\n\twidth: 60px;\n\tmargin-right: ', ';\n'], ['\n\twidth: 60px;\n\tmargin-right: ', ';\n']),
    _templateObject4$8 = taggedTemplateLiteral(['\n\twidth: 60px;\n'], ['\n\twidth: 60px;\n']);

var StyledYearsAndMonthsInput = styled('div')(_templateObject$E);

var StyledInput$7 = styled('input')(_templateObject2$j, function (props) {
	return props.theme.borderWidth + ' solid ' + props.theme.colours.borderInteraction;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.isCompact ? '12px' : '16px';
}, spacing.SEXTUPLE, spacing.SINGLE, function (props) {
	return props.hasError && 'border: ' + props.theme.borderWidth + ' solid ' + colours.utility.error;
});

var StyledYearsInput = styled('div')(_templateObject3$c, spacing.DOUBLE);

var StyledMonthsInput = styled('div')(_templateObject4$8);

var ZERO_TO_NINE$1 = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
var ONE_TO_NINE$1 = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
var ZERO_TO_ONE$1 = ['0', '1'];

var validationReasons$6 = {
	INVALID: 'INVALID'
};

var checkIsValidMonthValue$1 = function checkIsValidMonthValue(value) {
	var getValidMonthSecondDigits = function getValidMonthSecondDigits(firstDigit) {
		switch (firstDigit) {
			case '0':
				return ONE_TO_NINE$1;
			case '1':
				return ZERO_TO_ONE$1;
			default:
				return [];
		}
	};

	if (value.length === 1) {
		return ZERO_TO_NINE$1.includes(value);
	} else if (value.length === 2) {
		var _value$split = value.split(''),
		    _value$split2 = slicedToArray(_value$split, 2),
		    firstDigit = _value$split2[0],
		    secondDigit = _value$split2[1];

		var validSecondDigits = getValidMonthSecondDigits(firstDigit);
		return validSecondDigits.includes(secondDigit);
	}

	return false;
};

var checkIsValidYearValue$1 = function checkIsValidYearValue(value) {
	var getValidYearSecondDigits = function getValidYearSecondDigits(firstDigit) {
		switch (firstDigit) {
			case '0':
				return ONE_TO_NINE$1;
			default:
				return ZERO_TO_NINE$1;
		}
	};

	if (value.length === 1) {
		return ZERO_TO_NINE$1.includes(value);
	} else if (value.length === 2) {
		var _value$split3 = value.split(''),
		    _value$split4 = slicedToArray(_value$split3, 2),
		    firstDigit = _value$split4[0],
		    secondDigit = _value$split4[1];

		var validSecondDigits = getValidYearSecondDigits(firstDigit);
		return validSecondDigits.includes(secondDigit);
	}

	return false;
};

var stripLastDigit$1 = function stripLastDigit(value) {
	return value.slice(0, value.length - 1);
};

var limitInputForMonths = function limitInputForMonths(event) {
	var value = event.target.value;


	if (!checkIsValidMonthValue$1(value)) {
		event.target.value = stripLastDigit$1(value);
	}
};

var limitInputForYears = function limitInputForYears(event) {
	var value = event.target.value;


	if (!checkIsValidYearValue$1(value)) {
		event.target.value = stripLastDigit$1(value);
	}
};

var checkValueIsInvalid = function checkValueIsInvalid(stateObj) {
	var MAX_YEARS = 99;
	var MAX_MONTHS = 11;

	if (stateObj.months === undefined || stateObj.years === undefined) {
		return true;
	}

	if (parseInt(stateObj.years, 10) < 0 || parseInt(stateObj.years, 10) > MAX_YEARS) {
		return true;
	}

	return parseInt(stateObj.months, 10) < 0 || parseInt(stateObj.months, 10) > MAX_MONTHS;
};

var YearsAndMonthsCountInput = function (_Component) {
	inherits(YearsAndMonthsCountInput, _Component);

	function YearsAndMonthsCountInput(props) {
		classCallCheck(this, YearsAndMonthsCountInput);

		var _this = possibleConstructorReturn(this, (YearsAndMonthsCountInput.__proto__ || Object.getPrototypeOf(YearsAndMonthsCountInput)).call(this, props));

		_this.state = {
			years: parseInt(_this.props.value.years, 10) || undefined,
			months: parseInt(_this.props.value.months, 10) || undefined,
			hasError: false
		};

		_this.setMonths = _this.setMonths.bind(_this);
		_this.setYears = _this.setYears.bind(_this);
		return _this;
	}

	createClass(YearsAndMonthsCountInput, [{
		key: 'setMonths',
		value: function setMonths(event) {
			var value = event.target.value;
			var years = this.state.years;


			var stateObj = {
				months: value,
				years: years
			};

			this.updateState(stateObj);
		}
	}, {
		key: 'setYears',
		value: function setYears(event) {
			var value = event.target.value;
			var months = this.state.months;


			var stateObj = {
				months: months,
				years: value
			};

			this.updateState(stateObj);
		}
	}, {
		key: 'updateState',
		value: function updateState(stateObj) {
			var onChange = this.props.onChange;


			var hasError = checkValueIsInvalid(stateObj);

			var returnObj = {
				value: {
					months: stateObj.months,
					years: stateObj.years
				},
				validationErrorReason: hasError ? validationReasons$6.INVALID : null
			};

			this.setState(_extends({}, stateObj, {
				hasError: hasError
			}), function () {
				onChange(returnObj);
			});
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _state = this.state,
			    hasError = _state.hasError,
			    months = _state.months,
			    years = _state.years;
			var _props = this.props,
			    hasValidationEnabled = _props.hasValidationEnabled,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    onBlur = _props.onBlur,
			    onFocus = _props.onFocus;


			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$u },
				React.createElement(
					StyledYearsAndMonthsInput,
					null,
					React.createElement(
						StyledYearsInput,
						null,
						React.createElement(
							InternalControlLabel,
							{ htmlFor: id + '-years' },
							'Years'
						),
						React.createElement(StyledInput$7, {
							id: id + '-years',
							innerRef: function innerRef(element) {
								_this2.refInput = element;
							},
							inputMode: 'numeric',
							maxLength: 2,
							max: 99,
							min: 0,
							name: id + '-years',
							onChange: this.setYears,
							onFocus: onFocus,
							onInput: function onInput(e) {
								return limitInputForYears(e);
							},
							size: 2,
							pattern: '[0-9]*',
							type: 'text',
							value: years,
							hasError: hasError && hasValidationEnabled
						})
					),
					React.createElement(
						StyledMonthsInput,
						null,
						React.createElement(
							InternalControlLabel,
							{ htmlFor: id + '-months' },
							'Months'
						),
						React.createElement(StyledInput$7, {
							id: id + '-months',
							inputMode: 'numeric',
							max: 11,
							maxLength: 2,
							min: 0,
							name: id + '-months',
							onBlur: onBlur,
							onChange: this.setMonths,
							onInput: function onInput(e) {
								return limitInputForMonths(e);
							},
							pattern: '[0-9]*',
							size: 2,
							type: 'text',
							value: months,
							hasError: hasError && hasValidationEnabled
						})
					)
				)
			);
		}
	}]);
	return YearsAndMonthsCountInput;
}(Component);

YearsAndMonthsCountInput.propTypes = {
	/** Sets if validation highlighting is shown. */
	hasValidationEnabled: PropTypes.bool,
	/** The unique id of the component. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change.
  *
  * Returns object:
  *
  * value { years: [number], months: [number] },
  *
  * validationErrorReason [string]
  */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Sets the years and months. */
	value: PropTypes.shape({
		years: PropTypes.number,
		months: PropTypes.number
	})
};

YearsAndMonthsCountInput.defaultProps = {
	hasValidationEnabled: false
};

var main$v = "DayOfMonthPicker.js";
var packageJson$v = {
	main: main$v,
	"component-id": 949,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$F = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmax-width: ', ';\n'], ['\n\tbackground-color: ', ';\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmax-width: ', ';\n']),
    _templateObject2$k = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\theight: ', ';\n\tjustify-content: center;\n\twidth: ', ';\n\n\tinput[type=\'radio\'] {\n\t\tclip: rect(1px, 1px, 1px, 1px);\n\t\twidth: 1px;\n\t\theight: 1px;\n\t\toverflow: hidden;\n\t\tposition: absolute;\n\n\t\t+ span {\n\t\t\talign-items: center;\n\t\t\tdisplay: flex;\n\t\t\theight: ', ';\n\t\t\tjustify-content: center;\n\t\t\twidth: ', ';\n\t\t\tcursor: pointer;\n\n\t\t\t:hover {\n\t\t\t\tborder: 2px solid ', ';\n\t\t\t\tborder-radius: 100%;\n\t\t\t}\n\t\t}\n\n\t\t&:checked + span {\n\t\t\tbackground-color: ', ';\n\t\t\tborder-radius: 100%;\n\t\t\tcolor: ', ';\n\t\t}\n\n\t\t&:disabled + span {\n\t\t\tcolor: ', ';\n\t\t\tcursor: default;\n\t\t\tborder: 0;\n\t\t\tposition: relative;\n\n\t\t\t&::after {\n\t\t\t\tcontent: \'\';\n\t\t\t\tbackground-color: ', ';\n\t\t\t\theight: 80%;\n\t\t\t\twidth: 1px;\n\t\t\t\tposition: absolute;\n\t\t\t\ttransform: rotate(45deg);\n\t\t\t}\n\t\t}\n\t\t/* TODOxVM: Pull this from the theme/global colour config once available */\n\t\t&:focus + span {\n\t\t\tbox-shadow: 0 0 0 2px hsl(208, 59%, 60%);\n\t\t\tborder-radius: 100%;\n\t\t}\n\t}\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\theight: ', ';\n\tjustify-content: center;\n\twidth: ', ';\n\n\tinput[type=\'radio\'] {\n\t\tclip: rect(1px, 1px, 1px, 1px);\n\t\twidth: 1px;\n\t\theight: 1px;\n\t\toverflow: hidden;\n\t\tposition: absolute;\n\n\t\t+ span {\n\t\t\talign-items: center;\n\t\t\tdisplay: flex;\n\t\t\theight: ', ';\n\t\t\tjustify-content: center;\n\t\t\twidth: ', ';\n\t\t\tcursor: pointer;\n\n\t\t\t:hover {\n\t\t\t\tborder: 2px solid ', ';\n\t\t\t\tborder-radius: 100%;\n\t\t\t}\n\t\t}\n\n\t\t&:checked + span {\n\t\t\tbackground-color: ', ';\n\t\t\tborder-radius: 100%;\n\t\t\tcolor: ', ';\n\t\t}\n\n\t\t&:disabled + span {\n\t\t\tcolor: ', ';\n\t\t\tcursor: default;\n\t\t\tborder: 0;\n\t\t\tposition: relative;\n\n\t\t\t&::after {\n\t\t\t\tcontent: \'\';\n\t\t\t\tbackground-color: ', ';\n\t\t\t\theight: 80%;\n\t\t\t\twidth: 1px;\n\t\t\t\tposition: absolute;\n\t\t\t\ttransform: rotate(45deg);\n\t\t\t}\n\t\t}\n\t\t/* TODOxVM: Pull this from the theme/global colour config once available */\n\t\t&:focus + span {\n\t\t\tbox-shadow: 0 0 0 2px hsl(208, 59%, 60%);\n\t\t\tborder-radius: 100%;\n\t\t}\n\t}\n']);

var StyledWrapper$e = styled('div')(_templateObject$F, colours.generalPalette.white, function (props) {
	return props.theme.isCompact ? '14rem' : '21rem';
});

var StyledDayLabel = styled('label')(_templateObject2$k, function (props) {
	return props.theme.isCompact ? spacing.QUADRUPLE : spacing.SEXTUPLE;
}, function (props) {
	return props.theme.isCompact ? spacing.QUADRUPLE : spacing.SEXTUPLE;
}, function (props) {
	return props.theme.isCompact ? spacing.QUADRUPLE : spacing.SEXTUPLE;
}, function (props) {
	return props.theme.isCompact ? spacing.QUADRUPLE : spacing.SEXTUPLE;
}, function (props) {
	return props.theme.colours.interaction;
}, function (props) {
	return props.theme.colours.interaction;
}, colours.generalPalette.white, colours.generalPalette.greyLighter, colours.generalPalette.greyLighter);

/**
 * @example ./Design.md
 */
var DayOfMonthPicker = function DayOfMonthPicker(_ref) {
	var _onChange = _ref.onChange,
	    name = _ref.name,
	    selectedDay = _ref.selectedDay,
	    unselectableDays = _ref.unselectableDays;

	var days = [];
	var numOfDays = 31;

	// Check if day is active, selected or unselectable
	var getDay = function getDay(day) {
		var isDisabled = unselectableDays && unselectableDays.includes(day);

		return React.createElement(
			StyledDayLabel,
			{ key: day },
			React.createElement('input', {
				checked: day === selectedDay,
				disabled: isDisabled,
				type: 'radio',
				name: name,
				id: name + '_day' + day,
				value: day,
				onChange: function onChange() {
					return _onChange(day);
				}
			}),
			React.createElement(
				'span',
				{ 'aria-label': 'day ' + day + (isDisabled ? ', unselectable' : '') },
				day
			)
		);
	};

	// Loop through days and build days array
	for (var i = 1; i <= numOfDays; i += 1) {
		var day = getDay(i);
		days.push(day);
	}

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$v, hasCustomMargins: true },
		React.createElement(
			StyledWrapper$e,
			null,
			days
		)
	);
};

DayOfMonthPicker.propTypes = {
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** A _unique_ name for the group (used to group underlying radios).  */
	name: PropTypes.string.isRequired,
	/** Sets the selected day */
	selectedDay: PropTypes.number.isRequired,
	/** Array of days that cannot be selected. */
	unselectableDays: PropTypes.arrayOf(PropTypes.number)
};

DayOfMonthPicker.defaultProps = {};

var main$w = "FileProgressTakeover.js";
var packageJson$w = {
	main: main$w,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$G = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tbottom: 0;\n\tleft: 0;\n\tposition: absolute;\n\topacity: ', ';\n\tright: 0;\n\ttop: 0;\n\tz-index: ', ';\n'], ['\n\tbackground-color: ', ';\n\tbottom: 0;\n\tleft: 0;\n\tposition: absolute;\n\topacity: ', ';\n\tright: 0;\n\ttop: 0;\n\tz-index: ', ';\n']),
    _templateObject2$l = taggedTemplateLiteral(['\n\tdisplay: block;\n\theight: 100%;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\tz-index: ', ';\n\t', ';\n'], ['\n\tdisplay: block;\n\theight: 100%;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\tz-index: ', ';\n\t', ';\n']),
    _templateObject3$d = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\theight: 100%;\n\tpadding-left: ', ';\n\tpadding-right: ', ';\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\theight: 100%;\n\tpadding-left: ', ';\n\tpadding-right: ', ';\n']),
    _templateObject4$9 = taggedTemplateLiteral(['\n\tpadding: ', ';\n\twidth: 100%;\n\tmax-width: 550px;\n\tbackground-color: ', ';\n'], ['\n\tpadding: ', ';\n\twidth: 100%;\n\tmax-width: 550px;\n\tbackground-color: ', ';\n']),
    _templateObject5$6 = taggedTemplateLiteral(['\n\tpadding: ', ' 0;\n'], ['\n\tpadding: ', ' 0;\n']),
    _templateObject6$4 = taggedTemplateLiteral([''], ['']),
    _templateObject7$3 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\n\tsvg {\n\t\twidth: 18px;\n\t\theight: 24px;\n\t\tanimation: ', ' 1.25s linear infinite;\n\t}\n'], ['\n\tdisplay: flex;\n\n\tsvg {\n\t\twidth: 18px;\n\t\theight: 24px;\n\t\tanimation: ', ' 1.25s linear infinite;\n\t}\n']),
    _templateObject8$2 = taggedTemplateLiteral(['\n\tborder: 2px solid ', ';\n\tborder-radius: ', ';\n\theight: 50px;\n'], ['\n\tborder: 2px solid ', ';\n\tborder-radius: ', ';\n\theight: 50px;\n']),
    _templateObject9 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\theight: 100%;\n\twidth: ', '%;\n\ttransition: width 0.2s ease-in-out;\n'], ['\n\tbackground-color: ', ';\n\theight: 100%;\n\twidth: ', '%;\n\ttransition: width 0.2s ease-in-out;\n']),
    _templateObject10 = taggedTemplateLiteral(['\n\ttext-align: center;\n\tpadding-top: ', ';\n'], ['\n\ttext-align: center;\n\tpadding-top: ', ';\n']);

var StyledModalBackdrop = styled('div')(_templateObject$G, function (props) {
	return props.theme.components.localLoader.colours.background;
}, function (props) {
	return props.theme.components.localLoader.root.opacity;
}, layers.sub);

var StyledTakeover = styled('div')(_templateObject2$l, layers.globalTakeover, function (props) {
	return !props.show && '\n\t\tdisplay: none!important\n\t';
});

var StyledContainerWrapper = styled('div')(_templateObject3$d, spacing.DOUBLE, spacing.DOUBLE);

var StyledContainer = styled('div')(_templateObject4$9, spacing.QUADRUPLE, colours.generalPalette.white);

var StyledBody = styled('div')(_templateObject5$6, spacing.DOUBLE);

var StyledProgressSection = styled('div')(_templateObject6$4);

var StyledProgressHeader = styled('div')(_templateObject7$3, animations.rotate);

var StyledProgressBar = styled('div')(_templateObject8$2, colours.generalPalette.greyDarker, function (props) {
	return props.theme.borderRadius;
});

var StyledProgressBarInner = styled('div')(_templateObject9, colours.utility.success, function (props) {
	return props.width;
});

var StyledPercentageSection = styled('div')(_templateObject10, spacing.SINGLE);

var MAX_PERCENTAGE = 100;

var FileProgressTakeover = function FileProgressTakeover(_ref) {
	var title = _ref.title,
	    titleText = _ref.titleText,
	    children = _ref.children,
	    isOpen = _ref.isOpen,
	    percentage = _ref.percentage,
	    activityText = _ref.activityText,
	    dataTestId = _ref['data-test-id'];

	if (title !== undefined) {
		DeprecationWarnings.logProp(packageJson$w, 'title prop deprecated in favour of titleText prop.');
	}

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$w, hasCustomMargins: true },
		React.createElement(
			StyledTakeover,
			{ show: isOpen, 'data-test-id': dataTestId + '-container' },
			React.createElement(
				StyledContainerWrapper,
				null,
				React.createElement(
					StyledContainer,
					null,
					React.createElement(
						SubHeading,
						{ isFlush: true },
						titleText || title
					),
					React.createElement(
						StyledBody,
						null,
						children
					),
					React.createElement(
						StyledProgressSection,
						null,
						React.createElement(
							StyledProgressHeader,
							null,
							React.createElement(
								ProminentLabel,
								null,
								percentage < MAX_PERCENTAGE ? activityText : 'Done'
							),
							percentage < MAX_PERCENTAGE && React.createElement(CycleLarge, null)
						),
						React.createElement(
							StyledProgressBar,
							{ 'data-test-id': dataTestId + '-progressBar' },
							React.createElement(StyledProgressBarInner, { width: percentage })
						),
						React.createElement(
							StyledPercentageSection,
							null,
							React.createElement(
								ProminentLabel,
								null,
								percentage.toString(),
								'%'
							)
						)
					)
				)
			),
			React.createElement(StyledModalBackdrop, null)
		)
	);
};

FileProgressTakeover.propTypes = {
	/** Text shown above the progress bar. */
	activityText: PropTypes.string.isRequired,
	/** Child content. */
	children: PropTypes.node,
	/** Determines if takeover is open */
	isOpen: PropTypes.bool,
	/** Percentage of the progress bar (number) (0-100). */
	percentage: PropTypes.number.isRequired,
	/** DEPRECATED: Use titleText prop. */
	title: PropTypes.string,
	/** Title text. */
	titleText: PropTypes.string.isRequired,
	/** Partial Data attribute for automation test purposes - appended by -container, -progressBar. */
	'data-test-id': PropTypes.string
};

FileProgressTakeover.defaultProps = {
	isOpen: false,
	'data-test-id': 'file-progress-takeover'
};

var padding = '24px';

var getCardHoverStyles = function getCardHoverStyles(theme) {
  return ':hover {\n\t\tborder-color: ' + theme.colours.interaction + ';\n\t}';
};

var getCardStripeStyles = function getCardStripeStyles(theme) {
  return '&:before {\n        background: ' + theme.colours.interaction + ';\n        border-bottom-left-radius: ' + theme.borderRadiusLarger + ';\n        border-top-left-radius: ' + theme.borderRadiusLarger + ';\n        content: \'\';\n        display: block;\n        height: calc(100% + 2px);\n        left: -1px;\n        position: absolute;\n        top: -1px;\n        width: ' + theme.styles.stripeWidth + ';\n    }';
};

var main$x = "IconifiedRadio.js";
var variants$4 = ["GridSet"];
var packageJson$x = {
	main: main$x,
	variants: variants$4,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$H = taggedTemplateLiteral(['\n\tdisplay: grid;\n\tgap: ', ' ', ';\n\n\t@media (min-width: ', ') {\n\t\tgap: ', ';\n\t\t', ';\n\t}\n'], ['\n\tdisplay: grid;\n\tgap: ', ' ', ';\n\n\t@media (min-width: ', ') {\n\t\tgap: ', ';\n\t\t', ';\n\t}\n']),
    _templateObject2$m = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tborder: 2px solid ', ';\n\tbox-sizing: border-box;\n\tcursor: pointer;\n\tdisplay: flex;\n\tpadding: 0 ', ';\n\ttransition: all 0.2s ease-in-out;\n\twidth: 100%;\n\n\t:has(:focus-visible) {\n\t\toutline-style: auto;\n\t\toutline-color: Highlight;\n\t}\n\n\t@media (min-width: ', ') {\n\t\tflex-direction: column;\n\t\tjustify-content: space-between;\n\t\tpadding: ', ' ', ';\n\t\ttext-align: center;\n\t}\n\n\t', ';\n'], ['\n\talign-items: center;\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tborder: 2px solid ', ';\n\tbox-sizing: border-box;\n\tcursor: pointer;\n\tdisplay: flex;\n\tpadding: 0 ', ';\n\ttransition: all 0.2s ease-in-out;\n\twidth: 100%;\n\n\t:has(:focus-visible) {\n\t\toutline-style: auto;\n\t\toutline-color: Highlight;\n\t}\n\n\t@media (min-width: ', ') {\n\t\tflex-direction: column;\n\t\tjustify-content: space-between;\n\t\tpadding: ', ' ', ';\n\t\ttext-align: center;\n\t}\n\n\t', ';\n']),
    _templateObject3$e = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: space-between;\n\torder: 2;\n\twidth: 100%;\n\n\t@media (min-width: ', ') {\n\t\tflex-direction: column;\n\t\tflex: 1;\n\t}\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: space-between;\n\torder: 2;\n\twidth: 100%;\n\n\t@media (min-width: ', ') {\n\t\tflex-direction: column;\n\t\tflex: 1;\n\t}\n']),
    _templateObject4$a = taggedTemplateLiteral(['\n\tclip: rect(0, 0, 0, 0);\n\theight: 0;\n\toverflow: hidden;\n\tposition: absolute;\n\twidth: 0;\n'], ['\n\tclip: rect(0, 0, 0, 0);\n\theight: 0;\n\toverflow: hidden;\n\tposition: absolute;\n\twidth: 0;\n']),
    _templateObject5$7 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tjustify-content: center;\n\n\t> svg {\n\t\tbackground: ', ';\n\t\tborder-radius: 100%;\n\t\tborder: 2px solid ', ';\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\ttransition: all 0.2s ease-in-out;\n\t\twidth: 24px;\n\t}\n\n\t@media (min-width: ', ') {\n\t\torder: 3;\n\t}\n'], ['\n\tdisplay: flex;\n\tjustify-content: center;\n\n\t> svg {\n\t\tbackground: ', ';\n\t\tborder-radius: 100%;\n\t\tborder: 2px solid ', ';\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\ttransition: all 0.2s ease-in-out;\n\t\twidth: 24px;\n\t}\n\n\t@media (min-width: ', ') {\n\t\torder: 3;\n\t}\n']),
    _templateObject6$5 = taggedTemplateLiteral(['\n\t', ';\n\twidth: 100%;\n\n\t@media (max-width: ', ') {\n\t\tmargin: 0 ', ';\n\t\tpadding: ', ' 0;\n\t}\n\n\t@media (min-width: ', ') {\n\t\tmargin: ', ' 0;\n\t\tpadding: 0;\n\t\torder: 2;\n\t}\n'], ['\n\t', ';\n\twidth: 100%;\n\n\t@media (max-width: ', ') {\n\t\tmargin: 0 ', ';\n\t\tpadding: ', ' 0;\n\t}\n\n\t@media (min-width: ', ') {\n\t\tmargin: ', ' 0;\n\t\tpadding: 0;\n\t\torder: 2;\n\t}\n']),
    _templateObject7$4 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tmargin-left: auto;\n\torder: 2;\n\n\tsvg.IconifiedRadioIcon {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\twidth: 24px;\n\n\t\t@media (min-width: ', ') {\n\t\t\theight: 40px;\n\t\t\twidth: 40px;\n\t\t}\n\t}\n\n\t@media (min-width: ', ') {\n\t\tmargin-left: 0;\n\t\torder: 1;\n\t}\n'], ['\n\tdisplay: flex;\n\tmargin-left: auto;\n\torder: 2;\n\n\tsvg.IconifiedRadioIcon {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\twidth: 24px;\n\n\t\t@media (min-width: ', ') {\n\t\t\theight: 40px;\n\t\t\twidth: 40px;\n\t\t}\n\t}\n\n\t@media (min-width: ', ') {\n\t\tmargin-left: 0;\n\t\torder: 1;\n\t}\n']);

function getGridTemplateColumns(numberOfColumns, spacing) {
	if (isNaN(numberOfColumns) || numberOfColumns <= 1) {
		return '';
	}

	var elements = numberOfColumns;
	var gaps = numberOfColumns - 1;

	return 'grid-template-columns:repeat(auto-fit, minmax(calc(100% / ' + elements + ' - (' + gaps + ' * ' + spacing + ')), 1fr))';
}

var StyledWrapper$f = styled('div')(_templateObject$H, spacing.SINGLE, spacing.DOUBLE, breakpoint('sm2'), spacing.TRIPLE, function (props) {
	return getGridTemplateColumns(props.numberOfColumns, spacing.TRIPLE);
});

var StyledLabel$1 = styled('label')(_templateObject2$m, function (props) {
	return props.isChecked ? props.theme.colours.interaction : colours.component.background;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.isChecked ? props.theme.colours.interaction : colours.component.border;
}, spacing.DOUBLE, breakpoint('sm2'), spacing.DOUBLE, spacing.TRIPLE, function (props) {
	return getCardHoverStyles(props.theme);
});

var StyledInitialWrapper = styled('div')(_templateObject3$e, breakpoint('sm2'));

var StyledRadioInput = styled('input')(_templateObject4$a);

var StyledRadioIcon$1 = styled('div')(_templateObject5$7, function (props) {
	return props.isChecked ? props.theme.colours.interaction : colours.generalPalette.white;
}, function (props) {
	return props.isChecked ? colours.generalPalette.white : props.theme.colours.interaction;
}, colours.generalPalette.white, breakpoint('sm2'));

var StyledLabelWrapper = styled('div')(_templateObject6$5, function (props) {
	return props.isChecked && 'color: ' + colours.generalPalette.white + ';';
}, breakpoint('sm2'), spacing.DOUBLE, spacing.ONE_AND_QUARTER, breakpoint('sm2'), spacing.DOUBLE);

var StyledIconWrapper$2 = styled('div')(_templateObject7$4, function (props) {
	return props.isChecked ? colours.generalPalette.white : props.theme.colours.nonInteractive;
}, breakpoint('sm2'), breakpoint('sm2'));

var Base$2 = function (_Component) {
	inherits(Base, _Component);

	function Base(props) {
		classCallCheck(this, Base);
		return possibleConstructorReturn(this, (Base.__proto__ || Object.getPrototypeOf(Base)).call(this, props));
	}

	createClass(Base, [{
		key: 'handleOnChange',
		value: function handleOnChange(id) {
			this.props.onChange(id);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    dataTestId = _props['data-test-id'],
			    groupName = _props.groupName,
			    items = _props.items,
			    selectedId = _props.selectedId,
			    numberOfColumns = _props.numberOfColumns;


			return React.createElement(
				StyledWrapper$f,
				{ 'data-test-id': dataTestId, numberOfColumns: numberOfColumns },
				items.map(function (_ref) {
					var id = _ref.id,
					    labelText = _ref.labelText,
					    iconType = _ref.iconType,
					    onBlur = _ref.onBlur,
					    onFocus = _ref.onFocus;

					return React.createElement(RadioWithIcon, {
						'data-test-id': dataTestId,
						iconType: iconType,
						id: groupName + '-' + id,
						isChecked: id === selectedId,
						key: groupName + '-' + id,
						labelText: labelText,
						name: groupName,
						onBlur: onBlur,
						onChange: function onChange() {
							return _this2.handleOnChange(id);
						},
						onFocus: onFocus
					});
				})
			);
		}
	}]);
	return Base;
}(Component);

var StyledRadioInputReplacement = function StyledRadioInputReplacement(_ref2) {
	var isChecked = _ref2.isChecked;
	return React.createElement(
		StyledRadioIcon$1,
		{ isChecked: isChecked },
		React.createElement(RadioIcon, null)
	);
};

StyledRadioInputReplacement.propTypes = {
	isChecked: PropTypes.bool
};

var RadioWithIcon = function RadioWithIcon(_ref3) {
	var dataTestId = _ref3['data-test-id'],
	    onChange = _ref3.onChange,
	    name = _ref3.name,
	    iconType = _ref3.iconType,
	    labelText = _ref3.labelText,
	    isChecked = _ref3.isChecked,
	    id = _ref3.id,
	    onFocus = _ref3.onFocus,
	    onBlur = _ref3.onBlur;
	return React.createElement(
		StyledLabel$1,
		{ htmlFor: id, 'data-test-id': dataTestId + '-' + id + '-label', isChecked: isChecked },
		React.createElement(
			StyledInitialWrapper,
			null,
			React.createElement(StyledRadioInput, {
				'data-test-id': dataTestId + '-' + id + '-input',
				id: id,
				type: 'radio',
				onChange: onChange,
				onBlur: onBlur,
				onFocus: onFocus,
				name: name,
				isChecked: isChecked,
				value: labelText
			}),
			React.createElement(StyledRadioInputReplacement, { isChecked: isChecked }),
			React.createElement(
				StyledLabelWrapper,
				{ isChecked: isChecked },
				React.createElement(
					StandardLabel,
					{ 'data-test-id': dataTestId + '-' + id + '-inner-label', isFlush: true },
					labelText
				)
			)
		),
		React.createElement(
			StyledIconWrapper$2,
			{ 'data-test-id': dataTestId + '-' + id + '-icon-wrapper', isChecked: isChecked },
			React.createElement(WrappedIcon, { className: 'IconifiedRadioIcon', iconType: iconType })
		)
	);
};

RadioWithIcon.propTypes = {
	/** Icon node. */
	iconType: PropTypes.string.isRequired,
	/** Sets the checked attribute. */
	isChecked: PropTypes.bool.isRequired,
	/** Radio label. */
	labelText: PropTypes.string.isRequired,
	/** String for name attribute. */
	name: PropTypes.string.isRequired,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func
};

var GridSet = function GridSet(_ref4) {
	var dataTestId = _ref4['data-test-id'],
	    groupName = _ref4.groupName,
	    items = _ref4.items,
	    numberOfColumns = _ref4.numberOfColumns,
	    _onChange = _ref4.onChange,
	    selectedId = _ref4.selectedId,
	    xraySuppressed = _ref4.xraySuppressed;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$x, xraySuppressed: xraySuppressed },
		React.createElement(Base$2, {
			'data-test-id': dataTestId,
			groupName: groupName,
			items: items,
			numberOfColumns: numberOfColumns,
			onChange: function onChange(id) {
				return _onChange(id);
			},
			selectedId: selectedId
		})
	);
};

var baseProps$6 = {
	/** Partial Data attribute targeting component for automation test purposes. */
	'data-test-id': PropTypes.string,
	/** String applied to each radio elements html name attribute. */
	groupName: PropTypes.string.isRequired,
	/** Items. */
	items: PropTypes.arrayOf(PropTypes.shape({
		/** Sets the icon to display. */
		iconType: PropTypes.string.isRequired,
		/** ID for radio */
		id: PropTypes.string.isRequired,
		/** Label for radio */
		labelText: PropTypes.string.isRequired,
		/** Callback function triggered on blur. */
		onBlur: PropTypes.func,
		/** Callback function triggered on focus. */
		onFocus: PropTypes.func
	})).isRequired,
	/** Callback function triggered on change of the first radio. */
	onChange: PropTypes.func.isRequired,
	/** Selected radio id. */
	selectedId: PropTypes.string,
	xraySuppressed: PropTypes.bool
};

GridSet.propTypes = _extends({}, baseProps$6, {
	numberOfColumns: PropTypes.number
});

var baseDefaultProps$4 = {
	'data-test-id': 'iconifiedRadio'
};

Base$2.defaultProps = baseDefaultProps$4;
GridSet.defaultProps = _extends({}, baseDefaultProps$4, {
	numberOfColumns: 3
});

var IconifiedRadio = {
	GridSet: GridSet
};

var main$y = "RadioContainer.js";
var variants$5 = ["Standalone", "StackedSet"];
var packageJson$y = {
	main: main$y,
	variants: variants$5,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$I = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tpadding: ', ' ', ' ', ' 0;\n\twidth: 100%;\n\n\t&:nth-child(odd) {\n\t\t', ';\n\t}\n\n\t&:nth-child(even) {\n\t\t', ';\n\t}\n'], ['\n\tdisplay: flex;\n\tpadding: ', ' ', ' ', ' 0;\n\twidth: 100%;\n\n\t&:nth-child(odd) {\n\t\t', ';\n\t}\n\n\t&:nth-child(even) {\n\t\t', ';\n\t}\n']),
    _templateObject2$n = taggedTemplateLiteral(['\n\tdisplay: flex;\n\talign-items: center;\n\n\t> div > label {\n\t\tmin-width: 0;\n\t\tpadding-top: 100%;\n\t\tpadding-bottom: 100%;\n\t\tpadding-left: ', ';\n\t\tpadding-right: ', ';\n\n\t\t@media (min-width: ', ') {\n\t\t\tpadding-left: ', ';\n\t\t\tpadding-right: ', ';\n\t\t}\n\t}\n\n\tlabel span {\n\t\tclip: rect(1px, 1px, 1px, 1px) !important;\n\t\theight: 1px !important;\n\t\twidth: 1px !important;\n\t\toverflow: hidden !important;\n\t\tposition: absolute;\n\t}\n'], ['\n\tdisplay: flex;\n\talign-items: center;\n\n\t> div > label {\n\t\tmin-width: 0;\n\t\tpadding-top: 100%;\n\t\tpadding-bottom: 100%;\n\t\tpadding-left: ', ';\n\t\tpadding-right: ', ';\n\n\t\t@media (min-width: ', ') {\n\t\t\tpadding-left: ', ';\n\t\t\tpadding-right: ', ';\n\t\t}\n\t}\n\n\tlabel span {\n\t\tclip: rect(1px, 1px, 1px, 1px) !important;\n\t\theight: 1px !important;\n\t\twidth: 1px !important;\n\t\toverflow: hidden !important;\n\t\tposition: absolute;\n\t}\n']);

var darkenValue = 8;

var StyledInputWrapper$4 = styled('div')(_templateObject$I, spacing.TRIPLE, spacing.TRIPLE, spacing.TRIPLE, function (props) {
	return props.isSelected ? 'background-color: ' + props.theme.colours.nonInteractive : 'background-color: ' + props.theme.colours.interactionAlternate;
}, function (props) {
	return props.isSelected ? 'background-color: ' + props.theme.colours.nonInteractive : 'background-color: ' + hslAdjust(props.theme.colours.interactionAlternate).darken(darkenValue);
});

var StyledRadioWrapper = styled('div')(_templateObject2$n, spacing.ONE_AND_HALF, spacing.HALF, breakpoint('md1'), spacing.TRIPLE, spacing.DOUBLE);

var Base$3 = function (_Component) {
	inherits(Base, _Component);

	function Base(props) {
		classCallCheck(this, Base);

		var _this = possibleConstructorReturn(this, (Base.__proto__ || Object.getPrototypeOf(Base)).call(this, props));

		_this.radioRef = null;
		return _this;
	}

	createClass(Base, [{
		key: 'handleOnChange',
		value: function handleOnChange(id) {
			this.props.onChange(id);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    groupName = _props.groupName,
			    hasError = _props.hasError,
			    items = _props.items,
			    innerRef = _props.innerRef,
			    isStacked = _props.isStacked,
			    onBlur = _props.onBlur,
			    onFocus = _props.onFocus,
			    selectedId = _props.selectedId;

			return React.createElement(
				'div',
				null,
				items.map(function (_ref, index) {
					var id = _ref.id,
					    visuallyHiddenLabel = _ref.visuallyHiddenLabel,
					    contentNode = _ref.contentNode;

					var blur = index === items.length - 1 ? onBlur : undefined;
					var focus = index === 0 ? onFocus : undefined;
					var ref = index === 0 ? innerRef : undefined;
					var getName = groupName ? groupName : id;
					var getGroupName = groupName ? groupName + id : id;

					return React.createElement(
						StyledInputWrapper$4,
						{ key: getGroupName, isStacked: isStacked, isSelected: id === selectedId },
						React.createElement(
							StyledRadioWrapper,
							null,
							React.createElement(InternalRadio.Default, {
								hasError: hasError,
								id: getGroupName,
								isChecked: id === selectedId,
								innerRef: ref,
								labelText: visuallyHiddenLabel,
								name: getName,
								onBlur: blur,
								onChange: function onChange() {
									return _this2.handleOnChange(id);
								},
								onFocus: focus
							})
						),
						contentNode
					);
				})
			);
		}
	}]);
	return Base;
}(Component);

var Standalone$1 = function Standalone(_ref2) {
	var hasError = _ref2.hasError,
	    innerRef = _ref2.innerRef,
	    items = _ref2.items,
	    onBlur = _ref2.onBlur,
	    _onChange = _ref2.onChange,
	    onFocus = _ref2.onFocus,
	    selectedId = _ref2.selectedId;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Standalone', packageJson: packageJson$y },
		React.createElement(Base$3, {
			hasError: hasError,
			items: items,
			innerRef: innerRef,
			onBlur: onBlur,
			onChange: function onChange(id) {
				return _onChange(id);
			},
			onFocus: onFocus,
			selectedId: selectedId
		})
	);
};

var StackedSet$3 = function StackedSet(_ref3) {
	var groupName = _ref3.groupName,
	    hasError = _ref3.hasError,
	    innerRef = _ref3.innerRef,
	    items = _ref3.items,
	    onBlur = _ref3.onBlur,
	    _onChange2 = _ref3.onChange,
	    onFocus = _ref3.onFocus,
	    selectedId = _ref3.selectedId;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'StackedSet', packageJson: packageJson$y },
		React.createElement(Base$3, {
			hasError: hasError,
			items: items,
			innerRef: innerRef,
			onBlur: onBlur,
			onChange: function onChange(id) {
				return _onChange2(id);
			},
			onFocus: onFocus,
			selectedId: selectedId,
			groupName: groupName,
			isStacked: true
		})
	);
};

var baseProps$7 = {
	/** Changes radio colour when set to true. */
	hasError: PropTypes.bool,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Array of checkbox objects data. */
	items: PropTypes.arrayOf(shape({
		id: PropTypes.string.isRequired,
		visuallyHiddenLabel: PropTypes.string.isRequired
	})),
	/** Callback function triggered on blur of the last checkbox. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus of the first checkbox. */
	onFocus: PropTypes.func,
	/** Array of ids to be highlighted. */
	selectedId: PropTypes.string.isRequired
};

Base$3.propTypes = _extends({}, baseProps$7);
Standalone$1.propTypes = _extends({}, baseProps$7);
StackedSet$3.propTypes = _extends({}, baseProps$7, {
	groupName: PropTypes.string.isRequired,
	isStacked: PropTypes.bool
});

Base$3.defaultProps = {
	hasError: false
};

var RadioContainer = {
	Standalone: Standalone$1,
	StackedSet: StackedSet$3
};

var getChevronUpSolidLarge = getThemeIcon(VMIcon$k, GenericIcon$l);

var _templateObject$J = taggedTemplateLiteral(['\n\tdisplay: inline-flex;\n'], ['\n\tdisplay: inline-flex;\n']),
    _templateObject2$o = taggedTemplateLiteral(['\n\tpadding-right: ', ';\n\twhite-space: nowrap;\n'], ['\n\tpadding-right: ', ';\n\twhite-space: nowrap;\n']);

var StyledDetails = styled('div')(_templateObject$J);

var StyledSortCode = styled('div')(_templateObject2$o, spacing.SINGLE);

var SortCodeAndAccountNumber = function SortCodeAndAccountNumber(_ref) {
	var accountNumber = _ref.accountNumber,
	    sortCode = _ref.sortCode;

	var accountNumberString = typeof accountNumber === 'number' ? BankingUtils.accountNumberFormat(accountNumber) : accountNumber;
	var sortCodeString = typeof sortCode === 'number' ? BankingUtils.sortCodeFormat(sortCode) : sortCode;

	var sortcodeLabel = React.createElement(
		StyledSortCode,
		{ 'aria-label': 'Sortcode: ' + sortCodeString },
		React.createElement(
			'span',
			null,
			sortCodeString
		)
	);

	var accountNumberLabel = React.createElement(
		'div',
		{ 'aria-label': 'Account Number: ' + accountNumberString },
		React.createElement(
			'span',
			null,
			accountNumberString
		)
	);

	return React.createElement(
		StyledDetails,
		null,
		sortcodeLabel,
		accountNumberLabel
	);
};

SortCodeAndAccountNumber.propTypes = {
	/** Account number */
	accountNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	/** Account sort code */
	sortCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

SortCodeAndAccountNumber.defaultProps = {};

var main$z = "AccountCardSelect.js";
var variants$6 = ["BankAccount"];
var packageJson$z = {
	main: main$z,
	variants: variants$6,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$K = taggedTemplateLiteral(['\n\talign-items: center;\n\tposition: relative;\n'], ['\n\talign-items: center;\n\tposition: relative;\n']),
    _templateObject2$p = taggedTemplateLiteral(['\n\tbackground-color: ', ' ', ';\n\tborder: 1px solid ', ' ', ';\n\tborder-radius: ', ';\n\tpadding: ', ' ', ';\n\tposition: relative;\n\ttext-align: left;\n\ttransition: all 0.2s ease-in-out;\n\twidth: 100%;\n\tmin-width: fit-content;\n\tcursor: pointer;\n\n\t', ' ', ';\n\t', '};\n\n\t@media (min-width: ', ') {\n\t\twidth: 540px;\n\t}\n\tsvg {\n\t\tfill: ', '\n\t\t\t', ';\n\t}\n\t:hover {\n\t\tsvg {\n\t\t\tfill: ', ' ', ';\n\t\t}\n\t}\n'], ['\n\tbackground-color: ', ' ', ';\n\tborder: 1px solid ', ' ', ';\n\tborder-radius: ', ';\n\tpadding: ', ' ', ';\n\tposition: relative;\n\ttext-align: left;\n\ttransition: all 0.2s ease-in-out;\n\twidth: 100%;\n\tmin-width: fit-content;\n\tcursor: pointer;\n\n\t', ' ', ';\n\t', '};\n\n\t@media (min-width: ', ') {\n\t\twidth: 540px;\n\t}\n\tsvg {\n\t\tfill: ', '\n\t\t\t', ';\n\t}\n\t:hover {\n\t\tsvg {\n\t\t\tfill: ', ' ', ';\n\t\t}\n\t}\n']),
    _templateObject3$f = taggedTemplateLiteral(['\n\t> div {\n\t\tdiv:last-child {\n\t\t\talign-items: flex-start;\n\t\t\tdisplay: flex;\n\t\t\tmargin: 0 ', ' 0 0;\n\t\t}\n\t}\n'], ['\n\t> div {\n\t\tdiv:last-child {\n\t\t\talign-items: flex-start;\n\t\t\tdisplay: flex;\n\t\t\tmargin: 0 ', ' 0 0;\n\t\t}\n\t}\n']),
    _templateObject4$b = taggedTemplateLiteral(['\n\tmargin: 0 ', ' ', ' 0;\n'], ['\n\tmargin: 0 ', ' ', ' 0;\n']),
    _templateObject5$8 = taggedTemplateLiteral(['\n\tmargin: 0 ', ' ', ' 0;\n\tcolor: ', ' ', ';\n'], ['\n\tmargin: 0 ', ' ', ' 0;\n\tcolor: ', ' ', ';\n']),
    _templateObject6$6 = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\theight: 48px;\n\tjustify-content: center;\n\tpointer-events: none;\n\tposition: absolute;\n\tright: 15px;\n\ttop: ', ';\n\twidth: ', 'px;\n\n\tsvg {\n\t\theight: 24px;\n\t\tpointer-events: none;\n\t\tspeak: none;\n\t\twidth: 24px;\n\t}\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\theight: 48px;\n\tjustify-content: center;\n\tpointer-events: none;\n\tposition: absolute;\n\tright: 15px;\n\ttop: ', ';\n\twidth: ', 'px;\n\n\tsvg {\n\t\theight: 24px;\n\t\tpointer-events: none;\n\t\tspeak: none;\n\t\twidth: 24px;\n\t}\n']),
    _templateObject7$5 = taggedTemplateLiteral(['\n\tbackground-color: ', ' ', ';\n\tborder: 1px solid ', ' ', ';\n\tborder-radius: ', ' ', ';\n\tbox-shadow: ', ' ', ';\n\tmax-height: 380px;\n\toverflow: scroll;\n\tz-index: ', ';\n\tmargin-top: 4px;\n\tposition: absolute;\n\twidth: 100%;\n\tmin-width: fit-content;\n\t@media (min-width: ', ') {\n\t\twidth: 540px;\n\t}\n'], ['\n\tbackground-color: ', ' ', ';\n\tborder: 1px solid ', ' ', ';\n\tborder-radius: ', ' ', ';\n\tbox-shadow: ', ' ', ';\n\tmax-height: 380px;\n\toverflow: scroll;\n\tz-index: ', ';\n\tmargin-top: 4px;\n\tposition: absolute;\n\twidth: 100%;\n\tmin-width: fit-content;\n\t@media (min-width: ', ') {\n\t\twidth: 540px;\n\t}\n']),
    _templateObject8$3 = taggedTemplateLiteral(['\n\tbackground-color: ', '\n\t\t', ';\n\tcolor: ', ';\n\tborder: solid ', ' ', ';\n\tborder-width: 0 0 1px 0 ', ';\n\tpadding: ', ' ', ' ', ';\n\tdisplay: block;\n\ttext-align: left;\n\twidth: 100%;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground-color: ', ' ', ';\n\t}\n\n\t&:last-child {\n\t\tborder-bottom: none;\n\t}\n'], ['\n\tbackground-color: ', '\n\t\t', ';\n\tcolor: ', ';\n\tborder: solid ', ' ', ';\n\tborder-width: 0 0 1px 0 ', ';\n\tpadding: ', ' ', ' ', ';\n\tdisplay: block;\n\ttext-align: left;\n\twidth: 100%;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground-color: ', ' ', ';\n\t}\n\n\t&:last-child {\n\t\tborder-bottom: none;\n\t}\n']);

var StyledWrapper$g = styled('div')(_templateObject$K);

var StyledAccountCard = styled('button')(_templateObject2$p, colours.component.background, INTERNET_BANKING_CSS_OVERRIDE, colours.component.border, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.theme.borderRadiusLarger;
}, padding, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return getCardHoverStyles(props.theme);
}, function (props) {
	return getCardStripeStyles(props.theme);
}, function (props) {
	return props.hasValidationError && 'border: ' + props.theme.borderWidth + ' solid ' + colours.utility.error + ' ' + INTERNET_BANKING_CSS_OVERRIDE;
}, breakpoints.sm1, function (props) {
	return props.dropDownIsOpen ? props.theme.colours.interaction : colours.generalPalette.black;
}, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.theme.colours.interaction;
}, INTERNET_BANKING_CSS_OVERRIDE);

var StyledAccountAvailableAndBalance = styled('div')(_templateObject3$f, spacing.SINGLE);

var StyledDetailsWrapper = styled('div')(_templateObject4$b, spacing.SEPTUPLE, spacing.SINGLE);

var StyledPlaceholderWrapper = styled('div')(_templateObject5$8, spacing.SEPTUPLE, spacing.SINGLE, colours.generalPalette.greyDarker, INTERNET_BANKING_CSS_OVERRIDE);

var ICON_WIDTH = 48;

var StyledIconWrapper$3 = styled('div')(_templateObject6$6, function (props) {
	return props.hasPlaceholderText ? '15px' : '34px';
}, ICON_WIDTH);

var StyledDropDown = styled('div')(_templateObject7$5, colours.component.background, INTERNET_BANKING_CSS_OVERRIDE, colours.component.border, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.theme.borderRadius;
}, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.theme.boxShadow;
}, INTERNET_BANKING_CSS_OVERRIDE, layers.accountLegacyPanelDropdown, breakpoints.sm1);

var StyledDropDownButton = styled('button')(_templateObject8$3, function (props) {
	return props.isSelected ? props.theme.colours.interaction : colours.component.background;
}, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.isSelected && colours.generalPalette.white;
}, colours.component.border, INTERNET_BANKING_CSS_OVERRIDE, INTERNET_BANKING_CSS_OVERRIDE, spacing.SINGLE, spacing.TRIPLE, INTERNET_BANKING_CSS_OVERRIDE, colours.component.hover, INTERNET_BANKING_CSS_OVERRIDE);

var getAccountBalance = function getAccountBalance(accountItem) {
	return typeof accountItem.accountBalanceInPence === 'number' && React.createElement(
		ProminentLabel,
		{ isFlush: true },
		BankingUtils.penceCurrencyFormat(accountItem.accountBalanceInPence)
	);
};

var getAccountAvailable = function getAccountAvailable(accountItem) {
	return typeof accountItem.accountAvailableInPence === 'number' && React.createElement(
		SubLabel,
		{ isFlush: true },
		BankingUtils.penceCurrencyFormat(accountItem.accountAvailableInPence) + ' available'
	);
};

var BankAccountStyledCard = function BankAccountStyledCard(_ref) {
	var account = _ref.account,
	    dataTestId = _ref.dataTestId;
	return React.createElement(
		'div',
		null,
		React.createElement(
			StyledDetailsWrapper,
			{ 'data-test-id': dataTestId + '-accountHolder' },
			React.createElement(
				SubLabel,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					account.accountHolder
				)
			)
		),
		React.createElement(
			StyledDetailsWrapper,
			{ 'data-test-id': dataTestId + '-accountName' },
			React.createElement(
				StandardLabel,
				null,
				React.createElement(
					'span',
					null,
					account.accountName
				)
			)
		),
		React.createElement(
			StyledDetailsWrapper,
			null,
			React.createElement(
				SubLabel,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					React.createElement(SortCodeAndAccountNumber, {
						'data-test-id': dataTestId + '-sortCodeAccountNumber',
						accountNumber: account.accountNumber,
						sortCode: account.sortCode
					})
				)
			)
		),
		React.createElement(
			StyledAccountAvailableAndBalance,
			{ 'data-test-id': dataTestId + '-accountBalance' },
			React.createElement(Inline.Justified, { isNonWrapping: true, nodes: [getAccountBalance(account), getAccountAvailable(account)] })
		)
	);
};

var BaseAccountCardSelect = function (_Component) {
	inherits(BaseAccountCardSelect, _Component);

	function BaseAccountCardSelect(props) {
		classCallCheck(this, BaseAccountCardSelect);

		var _this = possibleConstructorReturn(this, (BaseAccountCardSelect.__proto__ || Object.getPrototypeOf(BaseAccountCardSelect)).call(this, props));

		_this.state = {
			dropDownIsOpen: false
		};
		return _this;
	}

	createClass(BaseAccountCardSelect, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    id = _props.id,
			    items = _props.items,
			    selectedId = _props.selectedId,
			    onChange = _props.onChange,
			    theme = _props.theme,
			    dataTestId = _props['data-test-id'],
			    placeholderText = _props.placeholderText,
			    hasValidationError = _props.hasValidationError;
			var dropDownIsOpen = this.state.dropDownIsOpen;

			var selectedAccount = selectedId && items.find(function (accountItem) {
				return accountItem.id === selectedId;
			});
			var ChevronDownSmallIcon = getChevronDownSolidLarge(theme.name);
			var ChevronUpSmallIcon = getChevronUpSolidLarge(theme.name);
			var hasItems = Array.isArray(items) && items.some(function (item) {
				return (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object';
			});
			var hasDropdown = hasItems && dropDownIsOpen;

			var AccountDropDown = function AccountDropDown() {
				return React.createElement(
					StyledDropDown,
					{ 'data-test-id': dataTestId + '-list' },
					items.map(function (accountItem) {
						var isSelected = accountItem.id === selectedId;
						return React.createElement(
							StyledDropDownButton,
							{
								key: accountItem.id,
								isSelected: isSelected,
								onClick: function onClick() {
									_this2.setState({ dropDownIsOpen: false });
									onChange(accountItem.id);
								}
							},
							React.createElement(BankAccountStyledCard, { account: accountItem, dataTestId: dataTestId })
						);
					})
				);
			};

			return React.createElement(
				StyledWrapper$g,
				null,
				React.createElement(
					StyledAccountCard,
					{
						id: id,
						onClick: function onClick() {
							_this2.setState(function (prevState) {
								return { dropDownIsOpen: !prevState.dropDownIsOpen };
							});
						},
						dropDownIsOpen: dropDownIsOpen,
						hasValidationError: hasValidationError
					},
					!selectedAccount && React.createElement(
						StyledPlaceholderWrapper,
						{ 'data-test-id': dataTestId + '-accountName' },
						React.createElement(
							StandardLabel,
							{ isFlush: true },
							React.createElement(
								'span',
								null,
								placeholderText
							)
						)
					),
					selectedAccount && React.createElement(BankAccountStyledCard, { account: selectedAccount, dataTestId: dataTestId }),
					React.createElement(
						StyledIconWrapper$3,
						{ hasPlaceholderText: !selectedAccount },
						hasDropdown ? React.createElement(ChevronUpSmallIcon, null) : React.createElement(ChevronDownSmallIcon, null)
					)
				),
				hasDropdown && React.createElement(AccountDropDown, null)
			);
		}
	}]);
	return BaseAccountCardSelect;
}(Component);

var baseProps$8 = {
	/** Unique string id. */
	id: PropTypes.string.isRequired,
	/** Sets if validation highlighting is shown. */
	hasValidationError: PropTypes.bool,
	/** ID of the selected account */
	selectedId: PropTypes.string,
	/** Callback function invoked when account selected in the drop down */
	onChange: PropTypes.func.isRequired,
	/** Partial Data attribute targeting accountCardSelect for automation test purposes - appended by internal components. */
	'data-test-id': PropTypes.string,
	/** Change placeholder text. */
	placeholderText: PropTypes.string
};

BaseAccountCardSelect.propTypes = _extends({}, baseProps$8);

BaseAccountCardSelect.defaultProps = {
	'data-test-id': 'account-card-select',
	hasValidationError: false,
	placeholderText: 'Please select'
};

var BaseAccountCardSelectWrapper = withTheme(BaseAccountCardSelect);

var BankAccount = function BankAccount(_ref2) {
	var id = _ref2.id,
	    items = _ref2.items,
	    selectedId = _ref2.selectedId,
	    onChange = _ref2.onChange,
	    dataTestId = _ref2['data-test-id'],
	    placeholderText = _ref2.placeholderText,
	    hasValidationError = _ref2.hasValidationError;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'BankAccount', packageJson: packageJson$z },
		React.createElement(BaseAccountCardSelectWrapper, {
			id: id,
			items: items,
			selectedId: selectedId,
			onChange: onChange,
			'data-test-id': dataTestId,
			placeholderText: placeholderText,
			hasValidationError: hasValidationError
		})
	);
};

BankAccount.propTypes = _extends({
	/** Array of account data to populate the account drop down */
	items: PropTypes.arrayOf(PropTypes.shape({
		/** unique identifier */
		id: PropTypes.string.isRequired,
		/** Account available funds amount in pence. */
		accountAvailableInPence: PropTypes.number,
		/** Account balance in pence. */
		accountBalanceInPence: PropTypes.number,
		/** Displays above the account name in panel and drop down.. Not shown if blank. */
		accountHolder: PropTypes.string,
		/** Displayed account name in panel and drop down. */
		accountName: PropTypes.string.isRequired,
		/** Account number can either be a number or string format */
		accountNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		/** Account sortcode can either be a number or string format */
		sortCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
	})).isRequired
}, baseProps$8);

var AccountCardSelect = {
	BankAccount: BankAccount
};

var main$A = "GenericSelect.js";
var packageJson$A = {
	main: main$A,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$L = taggedTemplateLiteral(['\n\talign-items: center;\n\tborder-left: 2px solid ', ';\n\tdisplay: flex;\n\theight: 48px;\n\tjustify-content: center;\n\tpointer-events: none;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\twidth: ', 'px;\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\tpointer-events: none;\n\t\tspeak: none;\n\t\twidth: 24px;\n\t}\n'], ['\n\talign-items: center;\n\tborder-left: 2px solid ', ';\n\tdisplay: flex;\n\theight: 48px;\n\tjustify-content: center;\n\tpointer-events: none;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\twidth: ', 'px;\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\tpointer-events: none;\n\t\tspeak: none;\n\t\twidth: 24px;\n\t}\n']),
    _templateObject2$q = taggedTemplateLiteral(['\n\tappearance: none;\n\tborder-style: solid;\n\tbackground-color: ', ';\n\tborder: 2px solid ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\tcursor: pointer;\n\theight: 48px;\n\tpadding: ', ' ', ' ', ' ', ';\n\twidth: 100%;\n\n\t', '};\n\n\t@media (min-width: ', ') {\n\t\twidth: ', ';\n\t}\n\n\t::-ms-expand {\n\t\tdisplay: none;\n\t}\n'], ['\n\tappearance: none;\n\tborder-style: solid;\n\tbackground-color: ', ';\n\tborder: 2px solid ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\tcursor: pointer;\n\theight: 48px;\n\tpadding: ', ' ', ' ', ' ', ';\n\twidth: 100%;\n\n\t', '};\n\n\t@media (min-width: ', ') {\n\t\twidth: ', ';\n\t}\n\n\t::-ms-expand {\n\t\tdisplay: none;\n\t}\n']),
    _templateObject3$g = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: block;\n\tposition: relative;\n\twidth: 100%;\n\n\t@media (min-width: ', ') {\n\t\twidth: ', ';\n\t}\n'], ['\n\talign-items: center;\n\tdisplay: block;\n\tposition: relative;\n\twidth: 100%;\n\n\t@media (min-width: ', ') {\n\t\twidth: ', ';\n\t}\n']);

var ICON_WIDTH$1 = 48;

var StyledIconWrapper$4 = styled('div')(_templateObject$L, function (props) {
	return props.theme.colours.borderInteraction;
}, ICON_WIDTH$1, function (props) {
	return props.theme.colours.interaction;
});

var StyledSelect = styled('select')(_templateObject2$q, colours.component.background, function (props) {
	return props.theme.colours.borderInteraction;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.value === '' ? colours.generalPalette.greyDarker : props.theme.colours.bodyText;
}, spacing.SINGLE, spacing.SEPTUPLE, spacing.SINGLE, spacing.DOUBLE, function (props) {
	return props.hasValidationError && 'border: ' + props.theme.borderWidth + ' solid ' + colours.utility.error;
}, breakpoints.sm1, function (props) {
	return getInputWidth(props.characterCount, props.theme.borderWidth, true);
});

var StyledWrapper$h = styled('div')(_templateObject3$g, breakpoints.sm1, function (props) {
	return getInputWidth(props.characterCount, props.theme.borderWidth, true);
});

var GenericSelect = function (_Component) {
	inherits(GenericSelect, _Component);

	function GenericSelect(props) {
		classCallCheck(this, GenericSelect);

		var _this = possibleConstructorReturn(this, (GenericSelect.__proto__ || Object.getPrototypeOf(GenericSelect)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(GenericSelect, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    characterCount = _props.characterCount,
			    id = _props.id,
			    items = _props.items,
			    innerRef = _props.innerRef,
			    hasValidationError = _props.hasValidationError,
			    onBlur = _props.onBlur,
			    _onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    placeholderText = _props.placeholderText,
			    selectedId = _props.selectedId,
			    theme = _props.theme,
			    dataTestId = _props['data-test-id'];

			var ChevronDownSmallIcon = getChevronDownSolidLarge(theme.name);

			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$A },
				React.createElement(
					StyledWrapper$h,
					{ characterCount: characterCount, 'data-test-id': dataTestId + '-wrapper' },
					React.createElement(
						StyledSelect,
						{
							characterCount: characterCount,
							id: id,
							hasValidationError: hasValidationError,
							onBlur: onBlur,
							onChange: function onChange(event) {
								return _onChange(event.target.value);
							},
							onFocus: onFocus,
							innerRef: function innerRef(element) {
								_this2.refInput = element;
							},
							value: selectedId === null ? '' : selectedId,
							'data-test-id': dataTestId + '-select'
						},
						React.createElement(
							'option',
							{ disabled: true, value: '', 'data-test-id': dataTestId + '-placeholder' },
							placeholderText
						),
						items.map(function (item, index) {
							var key = id + '-' + index;
							return React.createElement(
								'option',
								{ key: key, value: item.id, 'data-test-id': dataTestId + '-option-' + key },
								item.labelText
							);
						})
					),
					React.createElement(
						StyledIconWrapper$4,
						null,
						React.createElement(ChevronDownSmallIcon, null)
					)
				)
			);
		}
	}]);
	return GenericSelect;
}(Component);

GenericSelect.propTypes = {
	/** Character count as number, controls the select width. */
	characterCount: PropTypes.number,
	/** Unique string id. */
	id: PropTypes.string.isRequired,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Sets if validation highlighting is shown. */
	hasValidationError: PropTypes.bool,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Array of item objects. */
	items: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.string.isRequired,
		labelText: PropTypes.string.isRequired
	})).isRequired,
	/** Selected item id. */
	selectedId: PropTypes.string,
	/** Change placeholder text. */
	placeholderText: PropTypes.string,
	/** Partial Data attribute targeting panel for automation test purposes - appended by -wrapper, -select and -option. */
	'data-test-id': PropTypes.string
};

GenericSelect.defaultProps = {
	placeholderText: 'Please select',
	hasValidationError: false,
	'data-test-id': 'generic-select'
};

var WrappedGenericSelect = withTheme(GenericSelect);

var main$B = "GenericTextArea.js";
var packageJson$B = {
	main: main$B,
	"component-id": 1001,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$M = taggedTemplateLiteral(['\n\tcolor: ', ';\n\t', ';\n'], ['\n\tcolor: ', ';\n\t', ';\n']),
    _templateObject2$r = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-color: ', ';\n\tborder-radius: ', ';\n\tborder-style: solid;\n\tborder-width: ', ';\n\tcolor: ', ';\n\tmax-width: 100%;\n\tpadding: ', ';\n\twidth: ', ';\n\n\t&[disabled] {\n\t\tcolor: ', ';\n\t\tborder-color: ', ';\n\t\tbackground-color: ', ';\n\n\t\t&:hover {\n\t\t\tcursor: default;\n\t\t}\n\t}\n'], ['\n\tbackground-color: ', ';\n\tborder-color: ', ';\n\tborder-radius: ', ';\n\tborder-style: solid;\n\tborder-width: ', ';\n\tcolor: ', ';\n\tmax-width: 100%;\n\tpadding: ', ';\n\twidth: ', ';\n\n\t&[disabled] {\n\t\tcolor: ', ';\n\t\tborder-color: ', ';\n\t\tbackground-color: ', ';\n\n\t\t&:hover {\n\t\t\tcursor: default;\n\t\t}\n\t}\n']);

var StyledWrapper$i = styled('div')(_templateObject$M, function (props) {
	return props.theme.colours.bodyText;
}, function (props) {
	return !props.isValidInput && 'color: ' + colours.utility.error + ';';
});

var StyledTextarea = styled('textarea')(_templateObject2$r, colours.component.background, function (props) {
	return props.theme.colours.borderInteraction;
}, spacing.QUARTER, spacing.QUARTER, function (props) {
	return props.theme.colours.bodyText;
}, spacing.SINGLE, function (props) {
	return props.isFullWidth ? '100%' : getInputWidth(props.characterWidth, '1px');
}, function (props) {
	return props.theme.colours.bodyText;
}, colours.component.borderDisabled, colours.component.backgroundDisabled);

var getCharacterCount = function getCharacterCount(event, onChange, max) {
	var value = event.target.value;

	var isValid = value.length <= max;
	onChange({ value: value, isValid: isValid });
};

var getOnBlurValue = function getOnBlurValue(event, onBlur) {
	var value = event.target.value;

	if (onBlur) {
		onBlur(value);
	}
};

/**
 * Uses `<textarea>` tag internally.
 * @example ./Design.md
 */

var GenericTextArea = function (_Component) {
	inherits(GenericTextArea, _Component);

	function GenericTextArea(props) {
		classCallCheck(this, GenericTextArea);

		var _this = possibleConstructorReturn(this, (GenericTextArea.__proto__ || Object.getPrototypeOf(GenericTextArea)).call(this, props));

		_this.refInput = null;
		return _this;
	}

	createClass(GenericTextArea, [{
		key: 'focus',
		value: function focus() {
			if (this.refInput) {
				this.refInput.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    characterWidth = _props.characterWidth,
			    hideCharacterCount = _props.hideCharacterCount,
			    id = _props.id,
			    innerRef = _props.innerRef,
			    isDisabled = _props.isDisabled,
			    isFullWidth = _props.isFullWidth,
			    _onBlur = _props.onBlur,
			    _onChange = _props.onChange,
			    onFocus = _props.onFocus,
			    maximumCharacters = _props.maximumCharacters,
			    rowCount = _props.rowCount,
			    value = _props.value,
			    dataTestId = _props['data-test-id'],
			    ariaLabelledBy = _props['aria-labelledby'],
			    ariaLabel = _props['aria-label'];


			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$B },
				React.createElement(
					StyledWrapper$i,
					{
						maxLength: maximumCharacters,
						isValidInput: value.length <= maximumCharacters,
						'data-test-id': dataTestId + '-container'
					},
					React.createElement(StyledTextarea, {
						characterWidth: characterWidth,
						disabled: isDisabled,
						id: id,
						isFullWidth: isFullWidth,
						onBlur: function onBlur(event) {
							return getOnBlurValue(event, _onBlur);
						},
						onFocus: onFocus,
						onChange: function onChange(event) {
							return getCharacterCount(event, _onChange, maximumCharacters);
						},
						rows: rowCount,
						value: value,
						'data-test-id': dataTestId + '-textArea',
						innerRef: function innerRef(element) {
							_this2.refInput = element;
						},
						'aria-labelledby': ariaLabelledBy,
						'aria-label': ariaLabel
					}),
					!hideCharacterCount && React.createElement(
						SubBody,
						null,
						React.createElement(
							'span',
							null,
							'Characters: ',
							value.length,
							' of ',
							maximumCharacters,
							' used'
						)
					),
					value.length > maximumCharacters && React.createElement(
						VisuallyHiddenBody,
						null,
						'Maximum character limit has been exceeded. Current character count is ',
						value.length,
						' of a maximum of',
						' ',
						maximumCharacters,
						'.'
					)
				)
			);
		}
	}]);
	return GenericTextArea;
}(Component);

GenericTextArea.propTypes = {
	/** Overrides the width of the input. */
	characterWidth: PropTypes.number,
	/** If character counter is present. */
	hideCharacterCount: PropTypes.bool,
	/** Unique string id. */
	id: PropTypes.string,
	/** Used to access the internal input inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** If textarea input is disabled or not. */
	isDisabled: PropTypes.bool,
	/** Boolean specifying full width of the textarea within it's container. */
	isFullWidth: PropTypes.bool,
	/** Maximum number of characters allowed. */
	maximumCharacters: PropTypes.number.isRequired,
	/** Callback function triggered on blur. */
	onBlur: PropTypes.func,
	/** Callback function triggered on focus. */
	onFocus: PropTypes.func,
	/** Callback function triggered on change. */
	onChange: PropTypes.func.isRequired,
	/** Specifies te height of the textarea. */
	rowCount: PropTypes.number,
	/** The value. */
	value: PropTypes.string,
	/** Partial Data attribute targeting component for automation test purposes - appended by -container, -textArea. */
	'data-test-id': PropTypes.string,
	/** Aria-labelledby */
	'aria-labelledby': PropTypes.string,
	/** Aria-label */
	'aria-label': PropTypes.string
};

GenericTextArea.defaultProps = {
	hideCharacterCount: false,
	isDisabled: false,
	isFullWidth: false,
	rowCount: 8,
	value: '',
	'data-test-id': 'generic-text-area'
};

export { AccountCardSelect, AccountNumberInput, CheckboxContainer, DateOfBirthInput, DayOfMonthPicker, FileProgressTakeover, FileUploadInput, GenericAlphaNumericInput, GenericCheckbox, GenericIntegerInput, GenericRadio, WrappedGenericSelect as GenericSelect, GenericTextArea, GenericTextInput, IconifiedRadio, LandlineNumberInput, MoneyInput, MonthAndYearDateInput, PasscodeNumberInput, RadioContainer, SliderInputWithTheme as SliderInput, SortcodeInput, StandaloneCheckbox, UKOnlyMobileNumberInput, UKOnlyPostcodeInput, WorldwideMobileNumberInput, YearsAndMonthsCountInput };
